export const WOW_MOMO={
    "statusCode": 0,
    "data": {
      "statusMessage": "done successfully",
      "cards": [
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
              "info": {
                "id": "244004",
                "name": "Wow! Momo",
                "city": "Bangalore",
                "slugs": {
                  "restaurant": "wow-momo-kitchen-hsr-hsr",
                  "city": "bangalore"
                },
                "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
                "cloudinaryImageId": "5a148e63e9c54942e37627da1aa156be",
                "locality": "5th sector",
                "areaName": "HSR Layout",
                "costForTwo": "30000",
                "costForTwoMessage": "₹300 for two",
                "cuisines": [
                  "Tibetan",
                  "Healthy Food"
                ],
                "avgRating": 4.2,
                "feeDetails": {
                  "restaurantId": "244004",
                  "fees": [
                    {
                      "name": "distance",
                      "fee": 3200
                    },
                    {
                      "name": "time"
                    },
                    {
                      "name": "special"
                    }
                  ],
                  "totalFee": 3200,
                  "icon": "v1648635511/Delivery_fee_new_cjxumu",
                  "message": "1.5 kms | ₹32 Delivery fee will apply"
                },
                "parentId": "1776",
                "avgRatingString": "4.2",
                "totalRatingsString": "1K+ ratings",
                "sla": {
                  "restaurantId": "244004",
                  "deliveryTime": 30,
                  "minDeliveryTime": 25,
                  "maxDeliveryTime": 30,
                  "lastMileTravel": 1.5,
                  "serviceability": "SERVICEABLE",
                  "stressFactor": 1,
                  "rainMode": "RAIN_MODE_NONE",
                  "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
                  "zoneId": 3,
                  "slaString": "25-30 MINS",
                  "lastMileTravelString": "1.5 km",
                  "iconType": "ICON_TYPE_EMPTY"
                },
                "availability": {
                  "nextCloseTime": "2024-02-19 03:00:00",
                  "visibility": true,
                  "opened": true,
                  "restaurantClosedMeta": {
                    
                  }
                },
                "aggregatedDiscountInfo": {
                  "header": "Get items under 99",
                  "shortDescriptionList": [
                    {
                      "meta": "Get items under 99",
                      "discountType": "FinalPrice",
                      "operationType": "RESTAURANT"
                    },
                    {
                      "discountType": "Flat",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "descriptionList": [
                    {
                      "meta": "Get items under 99",
                      "discountType": "FinalPrice",
                      "operationType": "RESTAURANT"
                    },
                    {
                      "meta": "Flat ₹100 off | Above ₹550",
                      "discountType": "Flat",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "visible": true
                },
                "badges": {
                  
                },
                "slugString": "wow-momo-kitchen-hsr-hsr",
                "multiOutlet": true,
                "isOpen": true,
                "labels": [
                  {
                    "title": "Timings",
                    "message": "null"
                  },
                  {
                    "title": "Address",
                    "message": "WOW MOMO NO1 120 14th main road 5th sector HSR layout Bangalore BTM layout BBMP south  Karnataka  560102"
                  },
                  {
                    "title": "Cuisines",
                    "message": "Tibetan,Healthy Food"
                  }
                ],
                "logo": "pkpuo3jlgohfyecigzmw",
                "totalRatings": 1000,
                "aggregatedDiscountInfoV2": {
                  "header": "Get items under 99",
                  "shortDescriptionList": [
                    {
                      "meta": "Get items under 99",
                      "discountType": "FinalPrice",
                      "operationType": "RESTAURANT"
                    },
                    {
                      "discountType": "Flat",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "descriptionList": [
                    {
                      "meta": "Get items under 99",
                      "discountType": "FinalPrice",
                      "operationType": "RESTAURANT"
                    },
                    {
                      "meta": "Flat ₹100 off | Above ₹550",
                      "discountType": "Flat",
                      "operationType": "RESTAURANT"
                    }
                  ]
                },
                "type": "F",
                "nudgeBanners": [
                  {
                    "priority": 1,
                    "discountInfo": {
                      "discountType": "FinalPrice",
                      "value": 99
                    },
                    "unlockedMessage": "Deal of the Day unlocked!",
                    "minItemCount": 1,
                    "maxItemCount": 1,
                    "type": "SILD",
                    "nudgeTagInfo": {
                      "title": "Deal of the Day",
                      "fontName": "FONT_NAME_CONDENSED_BOLD"
                    },
                    "logoCtx": {
                      
                    }
                  }
                ],
                "headerBanner": {
                  "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/244004"
                },
                "expectationNotifiers": [
                  {
                    "text": "1.5 kms | ₹32 Delivery fee will apply",
                    "icon": {
                      "imageId": "v1648635511/Delivery_fee_new_cjxumu"
                    },
                    "popup": {
                      "cta": {
                        
                      }
                    },
                    "type": "DISTANCE_FEE_NON_FOOD_LM",
                    "enrichedText": "<b>1.5 kms</b> | ₹32 Delivery fee will apply",
                    "halfCardPopup": {
                      "halfCardPopupHeader": {
                        
                      }
                    }
                  }
                ],
                "generalPurposeInfoListV2": [
                  {
                    "cta": {
                      "info": {
                        "recordings": {
                          
                        }
                      },
                      "linkCta": {
                        
                      }
                    }
                  }
                ],
                "ratingSlab": "RATING_SLAB_5",
                "orderabilityCommunication": {
                  "title": {
                    
                  },
                  "subTitle": {
                    
                  },
                  "message": {
                    
                  },
                  "customIcon": {
                    
                  }
                },
                "hasBestsellerItems": true,
                "cartOrderabilityNudgeBanner": {
                  "parameters": {
                    
                  },
                  "presentation": {
                    
                  }
                },
                "latLong": "12.9161961,77.6377847",
                "hasKidscategoryItems": true,
                "backgroundImageOverlayInfo": {
                  
                }
              },
              "analytics": {
                
              }
            },
            "relevance": {
              "type": "RELEVANCE_TYPE_CHECK_ORDERABILITY_ON_ITEM_ADD",
              "sectionId": "POP_UP_CROUTON_MENU"
            }
          }
        },
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
              "layout": {
                "rows": 1,
                "columns": 5,
                "horizontalScrollEnabled": true,
                "itemSpacing": 12,
                "lineSpacing": 10,
                "widgetPadding": {
                  
                },
                "containerStyle": {
                  "containerPadding": {
                    "left": 10,
                    "right": 10,
                    "bottom": 16
                  }
                },
                "scrollBar": {
                  
                }
              },
              "id": "offerCollectionWidget_UX4",
              "gridElements": {
                "infoWithStyle": {
                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                  "offers": [
                    {
                      "info": {
                        "header": "ITEMS AT ₹99",
                        "offerTag": "DEAL OF DAY",
                        "offerTagColor": "#E46D47",
                        "offerIds": [
                          "8f887b48-c204-43ac-be1a-bea0d90d249a"
                        ],
                        "expiryTime": "1970-01-01T16:13:15Z",
                        "description": "ON SELECT ITEMS |",
                        "offerType": "offers",
                        "restId": "244004",
                        "offerLogo": "offers/deal-of-day",
                        "descriptionTextColor": "#7302060C",
                        "showExpiryTimer": true
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    },
                    {
                      "info": {
                        "header": "FLAT ₹100 OFF",
                        "offerTagColor": "#E46D47",
                        "logoBottom": "MARKETING_BANNERS/IMAGES/OFFERS/2024/2/17/1ed4245d-31e3-4dc6-b949-524a33b9b8c9_ICICI.png",
                        "offerIds": [
                          "299f5c31-dd4a-47a4-8d93-4ccb6be1a8a8"
                        ],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "couponCode": "NO CODE REQUIRED",
                        "description": "ABOVE ₹550",
                        "offerType": "offers",
                        "restId": "244004",
                        "offerLogo": "MARKETING_BANNERS/IMAGES/OFFERS/2024/2/17/1ed4245d-31e3-4dc6-b949-524a33b9b8c9_ICICI.png",
                        "descriptionTextColor": "#7302060C"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    },
                    {
                      "info": {
                        "header": "FLAT ₹50 OFF",
                        "offerTagColor": "#E46D47",
                        "logoBottom": "MARKETING_BANNERS/IMAGES/OFFERS/2024/2/16/d2280c74-96d1-4a1d-afd6-4270a05b5488_ICICI.png",
                        "offerIds": [
                          "72b12a41-597c-4c87-a813-32c46574fde9"
                        ],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "couponCode": "NO CODE REQUIRED",
                        "description": "ABOVE ₹500",
                        "offerType": "offers",
                        "restId": "244004",
                        "offerLogo": "MARKETING_BANNERS/IMAGES/OFFERS/2024/2/16/d2280c74-96d1-4a1d-afd6-4270a05b5488_ICICI.png",
                        "descriptionTextColor": "#7302060C"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    },
                    {
                      "info": {
                        "header": "15% OFF UPTO ₹300",
                        "offerTagColor": "#E46D47",
                        "logoBottom": "rng/md/ads/production/15fb1cfe885005447dc8375e7970600f",
                        "offerIds": [
                          "c313f07b-4a9c-451e-ab52-586759f42642"
                        ],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "couponCode": "USE CITIFOODIE",
                        "description": "ABOVE ₹1200",
                        "offerType": "offers",
                        "restId": "244004",
                        "offerLogo": "rng/md/ads/production/15fb1cfe885005447dc8375e7970600f",
                        "descriptionTextColor": "#7302060C"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    },
                    {
                      "info": {
                        "header": "FLAT ₹30 OFF",
                        "offerTagColor": "#E46D47",
                        "logoBottom": "rng/md/ads/production/7f31c9e47ddd7e6a3c16d21553c0ca60",
                        "offerIds": [
                          "269c382d-796f-45cd-bd15-0b8b891c5e0c"
                        ],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "couponCode": "USE SIMPL30",
                        "description": "ABOVE ₹300",
                        "offerType": "offers",
                        "restId": "244004",
                        "offerLogo": "rng/md/ads/production/7f31c9e47ddd7e6a3c16d21553c0ca60",
                        "descriptionTextColor": "#7302060C"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    }
                  ],
                  "habitMilestoneInfo": {
                    "callout": {
                      
                    }
                  },
                  "loyaltyDiscoverPresentationInfo": {
                    "logoCtx": {
                      
                    }
                  }
                }
              }
            }
          }
        },
        {
          "groupedCard": {
            "cardGroupMap": {
              "REGULAR": {
                "cards": [
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                        "badges": {
                          
                        },
                        "vegOnlyDetails": {
                          "imageId": "AutoVegOnly_qkjowj",
                          "title": "Showing only vegetarian options.",
                          "description": "Tap on the VEG ONLY button to turn off the setting"
                        },
                        "topRatedFilter": {
                          
                        },
                        "kidsCategoryFilter": {
                          "attributes": {
                            "displayText": "Kids Favourites",
                            "tooltip": {
                              "enabled": true,
                              "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                            }
                          }
                        },
                        "vegFilter": {
                          "attributes": {
                            "displayText": "VEG"
                          }
                        },
                        "nonvegFilter": {
                          "attributes": {
                            "displayText": "NONVEG"
                          }
                        }
                      },
                      "relevance": {
                        "type": "RELEVANCE_TYPE_ON_MENU_FILTER_TOGGLED",
                        "sectionId": "MENU_FILTER_TOGGLE"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Recommended",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "70886688",
                                "name": "Chicken Chilli Momo",
                                "category": "Chilli Momo",
                                "description": "Authentic Chicken kothey blended with Chilli seasoning mix. Served with it's Rustic Magic flavors. We don't serve additional Sauce with this plate of Momos [5Pcs].",
                                "imageId": "q4kruzcu8ng4plemgcnl",
                                "inStock": 1,
                                "price": 30500,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "showImage": true,
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.8",
                                    "ratingCount": "9 ratings",
                                    "ratingCountV2": "9"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "118906874",
                                "name": "Chicken Cheese Steam Momo",
                                "category": "Steam Momo",
                                "description": "Indulge in the all-time favorite, mouth-watering Momos filled with a mix of juicy boneless Chicken, Cheese, Coriander, Herbs, and Indian Spices. Served with our tantalizing Spicy Red Sauce [5pcs]. Enhance the experience as Steam Momos taste best when eaten by hand. Please note, we don't serve green coriander Chutney. Delight in 100 gms of savory goodness at 231.72 Kcal.",
                                "imageId": "iwky2okwnrdif0fvf9d7",
                                "inStock": 1,
                                "price": 28900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "showImage": true,
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "105343243",
                                "name": "Chicken Darjeeling Steam Momo",
                                "category": "Steam Momo",
                                "description": "Momo stuffed with mix of Soft Juicy boneless Chicken, Onion & Coriander cooked in blend of herbs and tinch of Spices. Served with Spicy Red Authentic Darjeeling Momo Sauce and We don't serve green sauce [5pcs]. Steam Momos taste best when eaten with hand.100 gms / 261.22 Kcal",
                                "imageId": "jjvddyicewjnw9qhzuqk",
                                "inStock": 1,
                                "price": 21900,
                                "finalPrice": 9900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  "text": "Bestseller",
                                  "textColor": "#ffffff",
                                  "topBackgroundColor": "#d53d4c",
                                  "bottomBackgroundColor": "#b02331"
                                },
                                "showImage": true,
                                "offerTags": [
                                  {
                                    
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "isBestseller": true,
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.2",
                                    "ratingCount": "123 ratings",
                                    "ratingCountV2": "123"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "105343247",
                                "name": "Paneer Steam Momo",
                                "category": "Steam Momo",
                                "description": "Savor the goodness of Delicious Momos, filled with freshly chopped Veggies, Paneer, a hint of spices, and blended with Indian Masala. Accompanied by our tantalizing Spicy Red Sauce [5pcs]. Enjoy the authentic experience as Steam Momos taste best when eaten by hand. Please note, we don't serve green coriander Chutney. Indulge in 100 gms of flavor-packed delight at 310.10 Kcal.",
                                "imageId": "lxpgtvly0fmasrwawup2",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 23900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "showImage": true,
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "2.8",
                                    "ratingCount": "4 ratings",
                                    "ratingCountV2": "4"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "105343250",
                                "name": "Veg Darjeeling Steam Momo",
                                "category": "Steam Momo",
                                "description": "Momo stuffed with freshly chopped Vegetables (Onion, carrot, cabbage, beans & Coriander), herbs and tinch of Spices. Served with Spicy Red Authentic Darjeeling Momo Sauce and We don't serve green sauce [5pcs].Steam Momos taste best when eaten with hand. 100 gms/ 187.98 kcal.",
                                "imageId": "x864peulmohek2c1g63i",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 20900,
                                "finalPrice": 9900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  "text": "Bestseller",
                                  "textColor": "#ffffff",
                                  "topBackgroundColor": "#d53d4c",
                                  "bottomBackgroundColor": "#b02331"
                                },
                                "showImage": true,
                                "offerTags": [
                                  {
                                    
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "isBestseller": true,
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.2",
                                    "ratingCount": "42 ratings",
                                    "ratingCountV2": "42"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "114058631",
                                "name": "Veg Darjeeling Pan Fried Momo in Schezwan Sauce [Spicy]",
                                "category": "Pan Fried",
                                "description": "Crispy fried Veggie Darjeeling Momo, tossed in spicy Schezwan sauce and garnished with chopped coriander. We don't serve additional Sauce [5Pcs].",
                                "imageId": "gwr7gvnwuyyrpjiehy6k",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 27500,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "showImage": true,
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.9",
                                    "ratingCount": "12 ratings",
                                    "ratingCountV2": "12"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "105343241",
                                "name": "Chicken Darjeeling Fried Momo",
                                "category": "Fried Momo",
                                "description": "Filled with softy juicy boneless chicken, onion, coriander and mixed with the flavours of Indian masala. To make it crispy dipped in hot oil and served with Spicy Red Sauce. We don't serve green sauce [5Pcs]. 100 gms / 256.84 Kcal",
                                "imageId": "szzmmvlswvggshmjguqy",
                                "inStock": 1,
                                "price": 26500,
                                "finalPrice": 9900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  "text": "Bestseller",
                                  "textColor": "#ffffff",
                                  "topBackgroundColor": "#d53d4c",
                                  "bottomBackgroundColor": "#b02331"
                                },
                                "showImage": true,
                                "offerTags": [
                                  {
                                    
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "isBestseller": true,
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "35 ratings",
                                    "ratingCountV2": "35"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "105343248",
                                "name": "Veg Darjeeling Fried Momo",
                                "category": "Fried Momo",
                                "description": "Momo stuffed with freshly chopped Vegetables (Onion, carrot, cabbage, beans & Coriander), herbs and Tinch of Spices. To make it crispy Fried in hot oil and Served with Spicy Red Authentic Darjeeling Momo Sauce and We don't serve green sauce[5pcs]. 100 gms / 236.78 Kcal",
                                "imageId": "qjairntkdnqgjynrtvr6",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 25500,
                                "finalPrice": 9900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "showImage": true,
                                "offerTags": [
                                  {
                                    
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.2",
                                    "ratingCount": "6 ratings",
                                    "ratingCountV2": "6"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "111017570",
                                "name": "Chicken Cheese Fried Momo",
                                "category": "Fried Momo",
                                "description": "Indulge in the delightful blend of juicy chicken and shredded cheese, infused with the rich flavors of Indian masala. Crisped to perfection by a dip in hot oil and served with spicy Schezwan sauce [5pcs]. Please note, we don't serve green coriander Chutney. Enjoy 100 gms of this flavorful creation at 279.01 Kcal.",
                                "imageId": "cu78g8lfpq2ri0q6wgg3",
                                "inStock": 1,
                                "price": 33500,
                                "finalPrice": 9900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  "text": "Bestseller",
                                  "textColor": "#ffffff",
                                  "topBackgroundColor": "#d53d4c",
                                  "bottomBackgroundColor": "#b02331"
                                },
                                "showImage": true,
                                "offerTags": [
                                  {
                                    
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "isBestseller": true,
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.7",
                                    "ratingCount": "114 ratings",
                                    "ratingCountV2": "114"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "type": "CATEGORY_TYPE_RECOMMENDED"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Chilli Momo",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132074644",
                                "name": "Veg Himalayan Chilli Momo",
                                "category": "Chilli Momo",
                                "description": "Savor the authentic taste of the hills with our Veg Himalayan Chilli Momos. Each bite bursts with delightful spices, kothey blended with chilli seasoning mix. No extra sauce needed for this delightful plate of Momos! [5Pcs]",
                                "imageId": "e10bef5889b1ac6796d622a33a6452c3",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 17500,
                                "finalPrice": 9900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132074645",
                                "name": "Veg Hot Garlic Chilli Momo",
                                "category": "Chilli Momo",
                                "description": "Indulge in the heat with our Spicy Veg Hot Garlic Momos, featuring succulent bites infused with a sweet chili and garlic kick. Bursting with delightful flavors and kothey blended with chilli seasoning mix, this delightful plate of Momos [5Pcs] requires no extra sauce, it's a complete and flavorful experience on its own!",
                                "imageId": "4baf5e6a4b1a217275a99d833754011d",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 22500,
                                "finalPrice": 9900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132074646",
                                "name": "Paneer Chilli Momo",
                                "category": "Chilli Momo",
                                "description": "Enfused Paneer Chilli Momo Kothey with fusion magic seasoning of chilli flavours. Served with a colorful delight.We don't serve additional Sauce with this plate of Momos [5Pcs].",
                                "imageId": "63a1953791c11c2cc0f05b4e606658b7",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 32500,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132074648",
                                "name": "Chicken Masala Chilli Momo",
                                "category": "Chilli Momo",
                                "description": "Experience the fusion magic of our Enfused Chicken Masala Chilli Momos, packed with Kothey delightful chili flavors and a burst of colors (5Pcs). No extra sauceserved; let the fusion perfection speak for itself!",
                                "imageId": "9ae029be95f3062b40dcf1c09825e0be",
                                "inStock": 1,
                                "price": 32500,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "70886688",
                                "name": "Chicken Chilli Momo",
                                "category": "Chilli Momo",
                                "description": "Authentic Chicken kothey blended with Chilli seasoning mix. Served with it's Rustic Magic flavors. We don't serve additional Sauce with this plate of Momos [5Pcs].",
                                "imageId": "q4kruzcu8ng4plemgcnl",
                                "inStock": 1,
                                "price": 30500,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.8",
                                    "ratingCount": "9 ratings",
                                    "ratingCountV2": "9"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "70886689",
                                "name": "Chicken Cheese Chilli Momo",
                                "category": "Chilli Momo",
                                "description": "Authentic Chicken kothey version with melted Cheese and wrapped with Chilli seasoning served with the dash of Spring onion. We don't serve additional Sauce with this plate of Momos [5 Pcs].",
                                "imageId": "q4kruzcu8ng4plemgcnl",
                                "inStock": 1,
                                "price": 37500,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.9",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "114058619",
                                "name": "Chicken Delight Chilli Momo",
                                "category": "Chilli Momo",
                                "description": "Introducing Yellow Delight Momos: 5 pieces of vegetable-chicken blend, herb and spice-infused Momos with a yellow outer layer, kothey blended with chilli seasoning mix. Enjoy them as is; no extra sauce needed for this delicious plate of momos!",
                                "imageId": "2d19fa8ae24fcc2b66f1daa60ef40e16",
                                "inStock": 1,
                                "price": 22500,
                                "finalPrice": 9900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  "text": "Bestseller",
                                  "textColor": "#ffffff",
                                  "topBackgroundColor": "#d53d4c",
                                  "bottomBackgroundColor": "#b02331"
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "isBestseller": true,
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "21 ratings",
                                    "ratingCountV2": "21"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Molten Cheesy Momo",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "123584500",
                                "name": "Chicken Delight  Momo in Molten Cheesy Sauce",
                                "category": "Molten Cheesy Momo",
                                "description": "Chicken Delight Steam Momo tossed in Molten Cheesy Sauce. We do not serve ant Red & Green Sauce [5Pcs]",
                                "imageId": "5f5b557288c75d41d7fe95e59c104f53",
                                "inStock": 1,
                                "price": 22900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "isKidcategory": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132074641",
                                "name": "Veg Himalayan Momo in Molten Cheese Sauce",
                                "category": "Molten Cheesy Momo",
                                "description": "Indulge in Veggie-loaded Momos for an authentic taste of the hills. Served with the popular Wow Momo Sauce and tossed in Molten Cheesy Sauce, each bite is a flavor sensation. Please note, no Red & Green Sauce is served with this set of 5 Momos. Enjoy the delightful blend of veggies and cheesy goodness!",
                                "imageId": "17026cd18734e29b445b657957a33512",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 16900,
                                "finalPrice": 9900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132074642",
                                "name": "Veg Hot Garlic Momo in Molten Cheese Sauce",
                                "category": "Molten Cheesy Momo",
                                "description": "Delight in the heat of our Spicy Hot Garlic Momos, where succulent momos meet a tantalizing sweet and garlicky kick. Served with the popular Wow Momo Sauce and tossed in Molten Cheesy Sauce, this set of 5 Momos is a flavor-packed experience. Please note, no Red & Green Sauce is served. Enjoy the spicy, garlicky goodness!",
                                "imageId": "991d8bc13913e8feeb722c6a048890c0",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 21900,
                                "finalPrice": 9900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132074643",
                                "name": "Chicken Himalayan Momo in Molten Cheese Sauce",
                                "category": "Molten Cheesy Momo",
                                "description": "Delight in each bite of our flavorful Momos, bursting with delightful spices and wrapped in an authentic taste of the hills. These delectable treats are tossed in Molten Cheesy Sauce for an extra layer of indulgence. Please note, no Red & Green Sauce is served with this set of 5 Momos. Enjoy the pure, cheesy goodness in every bite!",
                                "imageId": "9b04c4e96188dc9f3efab4b844f3e07a",
                                "inStock": 1,
                                "price": 17900,
                                "finalPrice": 9900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "118907027",
                                "name": "Veg Darjeeling Momo in Molten Cheesy Sauce",
                                "category": "Molten Cheesy Momo",
                                "description": "Veg Darjeeling Steam  Momos, tossed in Molten Cheesy Sauce.We do not serve any Red & Green Sauce [5 Pcs] .",
                                "imageId": "hgyvdgr1b8pj6zno2emw",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 28900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "isKidcategory": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "118907030",
                                "name": "Paneer  Momo in Molten Cheesy Sauce",
                                "category": "Molten Cheesy Momo",
                                "description": "Hot & Spongy Paneer Steam Momos, tossed in Molten Cheesy Sauce .  We do not serve any Red & Green Sauce [5 Pcs].",
                                "imageId": "cvltscwbjli4bffq5na6",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 31900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "118907035",
                                "name": "Chicken Darjeeling Momo in Molten Cheesy Sauce",
                                "category": "Molten Cheesy Momo",
                                "description": "Chicken Darejeeling Steam Momos, tossed in Molten Cheesy Sauce.  We do not serve any Red & Green Sauce [5 Pcs].",
                                "imageId": "p0wixq6e1vyows4dmwaq",
                                "inStock": 1,
                                "price": 29900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "isKidcategory": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "118907039",
                                "name": "Chicken Masala Momo in Molten Cheesy Sauce",
                                "category": "Molten Cheesy Momo",
                                "description": "Chicken Masala Steam Momos, tossed in Molten Cheesy Sauce. We do not serve any Red & Green Sauce [5 Pcs].",
                                "imageId": "f92880fd5d3aa5702b6f654da1668c7a",
                                "inStock": 1,
                                "price": 31900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "118907049",
                                "name": "Chicken Cheese Momo in Molten Cheesy Sauce",
                                "category": "Molten Cheesy Momo",
                                "description": "Chicken Cheese Steam Momos, tossed in Molten Cheesy Sauce. We do not serve any Red & Green Sauce [5 Pcs].",
                                "imageId": "uq5xteufjdyphebbrmas",
                                "inStock": 1,
                                "price": 36900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Wow! China on Wow! Momo",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "118906748",
                                "name": "Chilli Fish Large",
                                "category": "Wow! China on Wow! Momo",
                                "description": "Fish, Bell Pepper & Onion Cooked In Soya & Chilli Flavoured Gravy.",
                                "imageId": "t9tonhlweudtph8tpi7d",
                                "inStock": 1,
                                "price": 43450,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "118906742",
                                "name": "Fish in Hot Garlic Sauce Large",
                                "category": "Wow! China on Wow! Momo",
                                "imageId": "npq40eskvqhwwzpmz0nu",
                                "inStock": 1,
                                "price": 41500,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "118906696",
                                "name": "Chicken Wrapped Prawn",
                                "category": "Wow! China on Wow! Momo",
                                "description": "Prawns Marinated & Wrapped In Chicken Breast & Fried, Wok Tossed With Our Chef?S Special Sauce.",
                                "imageId": "apna5889lwcc1wb2bft0",
                                "inStock": 1,
                                "price": 41500,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "118906718",
                                "name": "Chilli Chicken Large",
                                "category": "Wow! China on Wow! Momo",
                                "description": "Chicken, Bell Pepper & Onion Cooked In Soya & Chilli Flavoured Gravy.",
                                "imageId": "cmmyla5gcjk10aehop1j",
                                "inStock": 1,
                                "price": 39500,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "118906728",
                                "name": "Chicken Manchurian Large",
                                "category": "Wow! China on Wow! Momo",
                                "description": "Chicken, Onion, Coriander Cooked In Manchurian Sauce With A Dominant Flavour Of Garlic And Onion To It.",
                                "imageId": "osb7trrmwqgr3qejd8ue",
                                "inStock": 1,
                                "price": 39500,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "118906738",
                                "name": "Chilli Paneer Large",
                                "category": "Wow! China on Wow! Momo",
                                "description": "Fried Paneer, Bell Pepper & Onion Cooked In Soya & Chilli Flavoured Gravy.",
                                "imageId": "zcxqidhkf0fndswpbhip",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 38500,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "62576014",
                                "name": "Indo Chilli Chicken",
                                "category": "Wow! China on Wow! Momo",
                                "description": "Fried Chicken Tossed In Our Special Indo Chilli Sauce.",
                                "imageId": "qjwh2ff47fp5y6rennr6",
                                "inStock": 1,
                                "price": 30500,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "118906694",
                                "name": "Chicken Sweet Corn Soup",
                                "category": "Wow! China on Wow! Momo",
                                "description": "Thick Broth Soup Typically Made By Sweet Corn Paste, Served With Chicken.",
                                "imageId": "gddlo9vo7lcnwotzurid",
                                "inStock": 1,
                                "price": 21450,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "118906695",
                                "name": "Veg Sweet Corn Soup",
                                "category": "Wow! China on Wow! Momo",
                                "description": "Thick Broth Soup Typically Made By Sweet Corn Paste, Served With Veggies.",
                                "imageId": "xwalsly0iqsvh9dblbrj",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 20500,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "118906697",
                                "name": "Chilli Cheese Stuffed Mushroom",
                                "category": "Wow! China on Wow! Momo",
                                "description": "Button Mushroom Stuffed With Cheese And Chilli Dip, Fried And Tossed With Hot Garlic Sauce.",
                                "imageId": "b5fz9dpgeuwjy0ngqu3h",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 35500,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "118906704",
                                "name": "Veg Hakka Noodle Regular",
                                "category": "Wow! China on Wow! Momo",
                                "imageId": "fcx2ziimjzjt3c36vvtb",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 22500,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.5",
                                    "ratingCount": "4 ratings",
                                    "ratingCountV2": "4"
                                  }
                                },
                                "isKidcategory": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "118906706",
                                "name": "Chicken Hakka Noodles Regular",
                                "category": "Wow! China on Wow! Momo",
                                "description": "Boiled Noodles Wok Tossed With Sauteed Chicken & Veggies, Perfectly Seasoned.",
                                "imageId": "epgdzpdsxfpuuejc72bt",
                                "inStock": 1,
                                "price": 27500,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "isKidcategory": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "118906709",
                                "name": "Veggie Fried Rice Regular",
                                "category": "Wow! China on Wow! Momo",
                                "description": "Steamed Rice Wok Tossed With Veggies, Perfectly Seasoned.",
                                "imageId": "caoew9vk7kn7ve1othac",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 24500,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "isKidcategory": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "118906712",
                                "name": "Chicken Fried Rice Regular",
                                "category": "Wow! China on Wow! Momo",
                                "description": "Steamed Rice Wok Tossed With Sauteed Chicken & Veggies, Perfectly Seasoned.",
                                "imageId": "wgew245au41rftg83dls",
                                "inStock": 1,
                                "price": 29500,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "isKidcategory": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "118906714",
                                "name": "Chilli Chicken Regular",
                                "category": "Wow! China on Wow! Momo",
                                "description": "Chicken, Bell Pepper & Onion Cooked In Soya & Chilli Flavoured Gravy.",
                                "imageId": "cmmyla5gcjk10aehop1j",
                                "inStock": 1,
                                "price": 26500,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "118906721",
                                "name": "Chicken Manchurian Regular",
                                "category": "Wow! China on Wow! Momo",
                                "description": "Chicken, Onion, Coriander Cooked In Manchurian Sauce With A Dominant Flavour Of Garlic And Onion To It.",
                                "imageId": "osb7trrmwqgr3qejd8ue",
                                "inStock": 1,
                                "price": 24500,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "118906729",
                                "name": "Veg Manchurian Regular",
                                "category": "Wow! China on Wow! Momo",
                                "description": "Vegetable Coins Made Up Of Chopped Mix Vegetables Served In Manchurian Sauce With A Dominant Flavour Of Garlic And Onion To It.",
                                "imageId": "ueecvjl11eekutbrotdx",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 18500,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "118906732",
                                "name": "Veg Manchurian Large",
                                "category": "Wow! China on Wow! Momo",
                                "description": "Vegetable Coins Made Up Of Chopped Mix Vegetables Served In Manchurian Sauce With A Dominant Flavour Of Garlic And Onion To It.",
                                "imageId": "ueecvjl11eekutbrotdx",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 32450,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "118906734",
                                "name": "Chilli Paneer Regular",
                                "category": "Wow! China on Wow! Momo",
                                "description": "Fried Paneer, Bell Pepper & Onion Cooked In Soya & Chilli Flavoured Gravy.",
                                "imageId": "zcxqidhkf0fndswpbhip",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 24500,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "118906740",
                                "name": "Fish In Hot Garlic Sauce Regular",
                                "category": "Wow! China on Wow! Momo",
                                "imageId": "npq40eskvqhwwzpmz0nu",
                                "inStock": 1,
                                "price": 29500,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "118906746",
                                "name": "Chilli Fish Regular",
                                "category": "Wow! China on Wow! Momo",
                                "description": "Fish, Bell Pepper & Onion Cooked In Soya & Chilli Flavoured Gravy.",
                                "imageId": "t9tonhlweudtph8tpi7d",
                                "inStock": 1,
                                "price": 31500,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Steam Momo",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132074626",
                                "name": "Veg Himalayan Steam Momo",
                                "category": "Steam Momo",
                                "description": "Indulge in the authentic taste of the hills with our Veggie-loaded Steam Momos. Each bite is a burst of flavor, served with the popular Wow Momo Sauce and accompanied by our house-made Spicy Red Sauce [5pcs]. These Steam Momos are a finger-licking delight! Please note, we don't serve green coriander Chutney. Enjoy the delicious experience!",
                                "imageId": "03aa9ae4bc68d09c6927bbac8951d8a3",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 8900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.6",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132074627",
                                "name": "Veg Hot Garlic Steam Momo",
                                "category": "Steam Momo",
                                "description": "Delight in the spicy goodness of our Hot Garlic Momos, where succulent momos meet a tantalizing sweet and garlic-infused kick. Accompanied by our house-made Spicy Red Sauce [5pcs], these Steam Momos are a finger-licking delight! We don't serve green coriander Chutney. Enjoy the flavorful experience!",
                                "imageId": "89f814422331789005f7117a2c1e4e2f",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 13900,
                                "finalPrice": 9900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "118906874",
                                "name": "Chicken Cheese Steam Momo",
                                "category": "Steam Momo",
                                "description": "Indulge in the all-time favorite, mouth-watering Momos filled with a mix of juicy boneless Chicken, Cheese, Coriander, Herbs, and Indian Spices. Served with our tantalizing Spicy Red Sauce [5pcs]. Enhance the experience as Steam Momos taste best when eaten by hand. Please note, we don't serve green coriander Chutney. Delight in 100 gms of savory goodness at 231.72 Kcal.",
                                "imageId": "iwky2okwnrdif0fvf9d7",
                                "inStock": 1,
                                "price": 28900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "105343243",
                                "name": "Chicken Darjeeling Steam Momo",
                                "category": "Steam Momo",
                                "description": "Momo stuffed with mix of Soft Juicy boneless Chicken, Onion & Coriander cooked in blend of herbs and tinch of Spices. Served with Spicy Red Authentic Darjeeling Momo Sauce and We don't serve green sauce [5pcs]. Steam Momos taste best when eaten with hand.100 gms / 261.22 Kcal",
                                "imageId": "jjvddyicewjnw9qhzuqk",
                                "inStock": 1,
                                "price": 21900,
                                "finalPrice": 9900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  "text": "Bestseller",
                                  "textColor": "#ffffff",
                                  "topBackgroundColor": "#d53d4c",
                                  "bottomBackgroundColor": "#b02331"
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "isBestseller": true,
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.2",
                                    "ratingCount": "123 ratings",
                                    "ratingCountV2": "123"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "118907009",
                                "name": "Chicken Masala Steam Momo",
                                "category": "Steam Momo",
                                "description": "Soft juicy boneless chicken, with the flavour of in house Spices. Served with Schezwan spicy red sauce and green coriander Chutney. [5 Pcs]. Steam Momos taste best when eaten with hand.100 gms / 214.54 Kcal",
                                "imageId": "9400a0826a6953c8ec3acece39cf3971",
                                "inStock": 1,
                                "price": 23900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "105343247",
                                "name": "Paneer Steam Momo",
                                "category": "Steam Momo",
                                "description": "Savor the goodness of Delicious Momos, filled with freshly chopped Veggies, Paneer, a hint of spices, and blended with Indian Masala. Accompanied by our tantalizing Spicy Red Sauce [5pcs]. Enjoy the authentic experience as Steam Momos taste best when eaten by hand. Please note, we don't serve green coriander Chutney. Indulge in 100 gms of flavor-packed delight at 310.10 Kcal.",
                                "imageId": "lxpgtvly0fmasrwawup2",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 23900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "2.8",
                                    "ratingCount": "4 ratings",
                                    "ratingCountV2": "4"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "105343250",
                                "name": "Veg Darjeeling Steam Momo",
                                "category": "Steam Momo",
                                "description": "Momo stuffed with freshly chopped Vegetables (Onion, carrot, cabbage, beans & Coriander), herbs and tinch of Spices. Served with Spicy Red Authentic Darjeeling Momo Sauce and We don't serve green sauce [5pcs].Steam Momos taste best when eaten with hand. 100 gms/ 187.98 kcal.",
                                "imageId": "x864peulmohek2c1g63i",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 20900,
                                "finalPrice": 9900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  "text": "Bestseller",
                                  "textColor": "#ffffff",
                                  "topBackgroundColor": "#d53d4c",
                                  "bottomBackgroundColor": "#b02331"
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "isBestseller": true,
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.2",
                                    "ratingCount": "42 ratings",
                                    "ratingCountV2": "42"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "114058624",
                                "name": "Chicken Delight Steam Momo",
                                "category": "Steam Momo",
                                "description": "Introducing Yellow Delight Momos: 5 pieces of veggie-chicken blend, spiced and wrapped in yellow Dough. Steamed Momo served with spicy Schezwan sauce; no green sauce. Best enjoyed by hand!",
                                "imageId": "6005544c724cf9c3163be64b60d5d45b",
                                "inStock": 1,
                                "price": 13900,
                                "finalPrice": 9900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "18 ratings",
                                    "ratingCountV2": "18"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "Pan Fried",
                        "categories": [
                          {
                            "title": "In Schezwan Sauce (Spicy)",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "114058623",
                                    "name": "Chicken Delight Pan Fried Momo in Schezwan Sauce",
                                    "category": "Pan Fried",
                                    "description": "Introducing Yellow Delight Momos: 5 pieces of vegetable-meat blend, herb and spice-infused, wrapped in yellow dough, and hot & cricpy fried chicken delight Momo tossed in spicy Schezwan sauce. No extra sauce needed for this flavor-packed treat!",
                                    "imageId": "eefb1fd170fa1c474fa0eca4d6659b18",
                                    "inStock": 1,
                                    "price": 20500,
                                    "finalPrice": 9900,
                                    "variants": {
                                      
                                    },
                                    "variantsV2": {
                                      
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "ribbon": {
                                      "text": "Bestseller",
                                      "textColor": "#ffffff",
                                      "topBackgroundColor": "#d53d4c",
                                      "bottomBackgroundColor": "#b02331"
                                    },
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        
                                      }
                                    ],
                                    "itemBadge": {
                                      
                                    },
                                    "badgesV2": {
                                      
                                    },
                                    "itemNudgeType": "FinalPrice",
                                    "isBestseller": true,
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "25 ratings",
                                        "ratingCountV2": "25"
                                      }
                                    }
                                  },
                                  "analytics": {
                                    
                                  },
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "114058631",
                                    "name": "Veg Darjeeling Pan Fried Momo in Schezwan Sauce [Spicy]",
                                    "category": "Pan Fried",
                                    "description": "Crispy fried Veggie Darjeeling Momo, tossed in spicy Schezwan sauce and garnished with chopped coriander. We don't serve additional Sauce [5Pcs].",
                                    "imageId": "gwr7gvnwuyyrpjiehy6k",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 27500,
                                    "variants": {
                                      
                                    },
                                    "variantsV2": {
                                      
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {
                                      
                                    },
                                    "type": "ITEM",
                                    "itemBadge": {
                                      
                                    },
                                    "badgesV2": {
                                      
                                    },
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.9",
                                        "ratingCount": "12 ratings",
                                        "ratingCountV2": "12"
                                      }
                                    }
                                  },
                                  "analytics": {
                                    
                                  },
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "118906910",
                                    "name": "Paneer Pan Fried Momo in Schezwan Sauce [Spicy]",
                                    "category": "Pan Fried",
                                    "description": "Hot & spongy paneer fried momo tossed in spicy Schezwan sauce and garnished with coriander.  We don't serve additional Sauce [5Pcs].",
                                    "imageId": "jsqndnspbxt9gko38qmj",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 30500,
                                    "variants": {
                                      
                                    },
                                    "variantsV2": {
                                      
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {
                                      
                                    },
                                    "type": "ITEM",
                                    "itemBadge": {
                                      
                                    },
                                    "badgesV2": {
                                      
                                    },
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "5.0",
                                        "ratingCount": "3 ratings",
                                        "ratingCountV2": "3"
                                      }
                                    }
                                  },
                                  "analytics": {
                                    
                                  },
                                  "hideRestaurantDetails": true
                                }
                              }
                            ]
                          },
                          {
                            "title": "In Tomato Garlic Sauce (Non Spicy)",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "128760814",
                                    "name": "Chicken Masala Pan Fried Momo in Tomato Garlic Sauce",
                                    "category": "Pan Fried",
                                    "description": "Hot and crispy fried chicken masala momo tossed in Tomato Garlic sauce [Non Spicy] and garnished with coriander We don't serve additional Sauce [5 Pcs].",
                                    "imageId": "3feba6dba4f3f4cc742f8fb52e5d4611",
                                    "inStock": 1,
                                    "price": 30500,
                                    "variants": {
                                      
                                    },
                                    "variantsV2": {
                                      
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "ribbon": {
                                      
                                    },
                                    "type": "ITEM",
                                    "itemBadge": {
                                      
                                    },
                                    "badgesV2": {
                                      
                                    },
                                    "ratings": {
                                      "aggregatedRating": {
                                        
                                      }
                                    }
                                  },
                                  "analytics": {
                                    
                                  },
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "128760815",
                                    "name": "Chicken Delight Pan Fried Momo in Tomato Garlic Sauce",
                                    "category": "Pan Fried",
                                    "description": "Introducing Yellow Delight Momos: 5 pieces of vegetable-meat blend, herb and spice-infused, wrapped in yellow dough, and hot & cricpy fried chicken delight Momo tossed in Tomato Garlic sauce [Non- Spicy]. No extra sauce needed for this flavor-packed treat!",
                                    "imageId": "886bb2b8c3acf06504697f96be8b4ab6",
                                    "inStock": 1,
                                    "price": 20500,
                                    "variants": {
                                      
                                    },
                                    "variantsV2": {
                                      
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "ribbon": {
                                      
                                    },
                                    "type": "ITEM",
                                    "itemBadge": {
                                      
                                    },
                                    "badgesV2": {
                                      
                                    },
                                    "ratings": {
                                      "aggregatedRating": {
                                        
                                      }
                                    }
                                  },
                                  "analytics": {
                                    
                                  },
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "128760818",
                                    "name": "Chicken Cheese Pan Fried Momo in Tomato Garlic Sauce",
                                    "category": "Pan Fried",
                                    "description": "Hot & crispy fried Chicken Cheese Momo, tossed in Tomato Garlic sauce [Non-Spicy] and garnished with chopped coriander. We don't serve additional Sauce [5Pcs].",
                                    "imageId": "tmxcp0keg3raatuqjshu",
                                    "inStock": 1,
                                    "price": 35500,
                                    "variants": {
                                      
                                    },
                                    "variantsV2": {
                                      
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "ribbon": {
                                      
                                    },
                                    "type": "ITEM",
                                    "itemBadge": {
                                      
                                    },
                                    "badgesV2": {
                                      
                                    },
                                    "ratings": {
                                      "aggregatedRating": {
                                        
                                      }
                                    }
                                  },
                                  "analytics": {
                                    
                                  },
                                  "hideRestaurantDetails": true
                                }
                              }
                            ]
                          }
                        ]
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Fried Momo",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132074629",
                                "name": "Veg Himalayan Fried Momo",
                                "category": "Fried Momo",
                                "description": "Indulge in the authentic taste of the hills with our Veggie-loaded Momos. Each bite is a burst of flavor, served with the popular house special Sauce. Our delightful creation is made crispy by a dip in hot oil and served with spicy Red sauce [5 Pcs]. We don't serve green coriander Chutney. Enjoy the delicious blend of flavors!",
                                "imageId": "e3666da415cd6f94457b09d2fece8f51",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 13500,
                                "finalPrice": 9900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132074630",
                                "name": "Veg Hot Garlic Fried Momo",
                                "category": "Fried Momo",
                                "description": "Delight in the spicy goodness of our Hot Garlic Momos, where succulent momos meet a tantalizing sweet and garlic-infused kick. Our delightful creation is made crispy by a dip in hot oil and served with spicy red sauce [5 Pcs]. We don't serve green coriander Chutney. Enjoy the flavorful experience!",
                                "imageId": "d18b764ceab12c923d1be3e8c0786faf",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 18500,
                                "finalPrice": 9900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "118907014",
                                "name": "Chicken Masala Fried Momo",
                                "category": "Fried Momo",
                                "description": "Filled with soft juicy bonless Chicken,Onion,Coriander and mixed with the flavour of Indian spices.To make it crispy dipped in hot oil and served with home-made spicy red sauce and green coriander chutney [5pcs]. 100 gms / 279.01 Kcal",
                                "imageId": "794520ab5d9cfc7010186121ef959c23",
                                "inStock": 1,
                                "price": 22900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "105343241",
                                "name": "Chicken Darjeeling Fried Momo",
                                "category": "Fried Momo",
                                "description": "Filled with softy juicy boneless chicken, onion, coriander and mixed with the flavours of Indian masala. To make it crispy dipped in hot oil and served with Spicy Red Sauce. We don't serve green sauce [5Pcs]. 100 gms / 256.84 Kcal",
                                "imageId": "szzmmvlswvggshmjguqy",
                                "inStock": 1,
                                "price": 26500,
                                "finalPrice": 9900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  "text": "Bestseller",
                                  "textColor": "#ffffff",
                                  "topBackgroundColor": "#d53d4c",
                                  "bottomBackgroundColor": "#b02331"
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "isBestseller": true,
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "35 ratings",
                                    "ratingCountV2": "35"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "105343248",
                                "name": "Veg Darjeeling Fried Momo",
                                "category": "Fried Momo",
                                "description": "Momo stuffed with freshly chopped Vegetables (Onion, carrot, cabbage, beans & Coriander), herbs and Tinch of Spices. To make it crispy Fried in hot oil and Served with Spicy Red Authentic Darjeeling Momo Sauce and We don't serve green sauce[5pcs]. 100 gms / 236.78 Kcal",
                                "imageId": "qjairntkdnqgjynrtvr6",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 25500,
                                "finalPrice": 9900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.2",
                                    "ratingCount": "6 ratings",
                                    "ratingCountV2": "6"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "111017570",
                                "name": "Chicken Cheese Fried Momo",
                                "category": "Fried Momo",
                                "description": "Indulge in the delightful blend of juicy chicken and shredded cheese, infused with the rich flavors of Indian masala. Crisped to perfection by a dip in hot oil and served with spicy Schezwan sauce [5pcs]. Please note, we don't serve green coriander Chutney. Enjoy 100 gms of this flavorful creation at 279.01 Kcal.",
                                "imageId": "cu78g8lfpq2ri0q6wgg3",
                                "inStock": 1,
                                "price": 33500,
                                "finalPrice": 9900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  "text": "Bestseller",
                                  "textColor": "#ffffff",
                                  "topBackgroundColor": "#d53d4c",
                                  "bottomBackgroundColor": "#b02331"
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "isBestseller": true,
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.7",
                                    "ratingCount": "114 ratings",
                                    "ratingCountV2": "114"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "111017572",
                                "name": "Paneer Fried Momo",
                                "category": "Fried Momo",
                                "description": "Bringing you the goodness of fresh chopped veggies and tender Paneer, mixed with herbs, fried to a golden brown hue, and served with spicy Schezwan sauce [5Pcs]. Please note, we don't serve green coriander Chutney. Dive into 100 gms of flavorful delight at 391.04 Kcal.",
                                "imageId": "ccxs330yzrnsldbj3xlb",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 28500,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "21 ratings",
                                    "ratingCountV2": "21"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "114058620",
                                "name": "Chicken Delight Fried Momo",
                                "category": "Fried Momo",
                                "description": "Introducing Yellow Delight Momos: 5 pieces of vegetable-chicken blend, spiced and wrapped in yellow dough, crispy fried to perfection. Served with spicy Schezwan sauce; no green sauce. A flavor-packed delight in every bite!",
                                "imageId": "ea3e1c344c630efe97c4f857a4c8400b",
                                "inStock": 1,
                                "price": 18500,
                                "finalPrice": 9900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.3",
                                    "ratingCount": "4 ratings",
                                    "ratingCountV2": "4"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Thukpas",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "118906942",
                                "name": "Chicken Thukpa Soup",
                                "category": "Thukpas",
                                "description": "Tibetan Soup which consists of mixed Fresh Vegetables, Tender Chicken, Home Made Noodles, Indian Spices and Garnished with Coriander.",
                                "imageId": "xgn6fdrr21l6sal2msrl",
                                "inStock": 1,
                                "price": 28900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  "text": "Bestseller",
                                  "textColor": "#ffffff",
                                  "topBackgroundColor": "#d53d4c",
                                  "bottomBackgroundColor": "#b02331"
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "isBestseller": true,
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.6",
                                    "ratingCount": "12 ratings",
                                    "ratingCountV2": "12"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "118906945",
                                "name": "Veg Thukpa Soup",
                                "category": "Thukpas",
                                "description": "Tibetan Soup which consists of mixed Fresh Vegetables, Home Made Noodles, Indian Spices and Garnished with Coriander.",
                                "imageId": "xgn6fdrr21l6sal2msrl",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 27500,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "4 ratings",
                                    "ratingCountV2": "4"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Momo Burger",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97292265",
                                "name": "Chicken Cheese Moburg",
                                "category": "Momo Burger",
                                "description": "Burger filled with crispy Chicken Cheese fried Momos and topped with red and green sauce and mayonnaise. We don?t serve any sauce or mayonnaise or Dips. Dips can be ordered separately.",
                                "imageId": "cfaf1e63df6ef1107d03812867da23b2",
                                "inStock": 1,
                                "price": 14900,
                                "finalPrice": 9900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "17 ratings",
                                    "ratingCountV2": "17"
                                  }
                                },
                                "isKidcategory": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Dessert (Valentine Special)",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "49631666",
                                "name": "Chocolate Momo (1 Pc)",
                                "category": "Dessert (Valentine Special)",
                                "description": "Crunchy Momo filled with Brownie, topped with Chocolate Fudge & Garnished with Chocolate flakes. (01 Pcs)",
                                "imageId": "0eface2360deb667d6b5477f9a6c0197",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 5900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "38 ratings",
                                    "ratingCountV2": "38"
                                  }
                                },
                                "isKidcategory": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "49631669",
                                "name": "Chocolate Momo Platter (4 Pcs)",
                                "category": "Dessert (Valentine Special)",
                                "description": "Crunchy Momo filled with Brownie, topped with Chocolate Fudge & Garnished with Chocolate flakes. (04 Pieces )",
                                "imageId": "a7a26d12a455034158c5f678c6617766",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 19900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Extra",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "118906949",
                                "name": "Cheese Dip",
                                "category": "Extra",
                                "description": "A spicy, tangy flavoured Cheesy Jalapeno Dip is an absolute delight with your favourite Steamed & Fried Momos & Burgers.",
                                "imageId": "071556381231df27f1ff95b5c4086a07",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 2500,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.2",
                                    "ratingCount": "7 ratings",
                                    "ratingCountV2": "7"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "118906951",
                                "name": "Mayo Dip",
                                "category": "Extra",
                                "description": "Wow! Delicisious Eggless Mayonnaise Dip, goes well with Momos & Burgers.",
                                "imageId": "11a0d03b6d6cc00c202dbac6d699c777",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 2500,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "isKidcategory": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Beverage",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "99701462",
                                "name": "Red Bull",
                                "category": "Beverage",
                                "description": "Energy Drink.",
                                "imageId": "q7lsbotpf8ovs3o3h1ai",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 18095,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "isKidcategory": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "118907638",
                                "name": "COCO CHARGE Tender Coconut Water",
                                "category": "Beverage",
                                "description": "COCO CHARGE is made from fresh and young coconuts, and it is 100% natural. It has a refreshing taste and is packed with essential nutrients and electrolytes.",
                                "imageId": "47bf0be29dc2ab7f719d8153319dde02",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 9523,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "119567471",
                                "name": "Pepsi Can 300 ml",
                                "category": "Beverage",
                                "description": "Refreshing Pepsi",
                                "imageId": "xfzcxyvaddk8niuzdisx",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 5714,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.2",
                                    "ratingCount": "10 ratings",
                                    "ratingCountV2": "10"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                        "type": "FSSAI",
                        "imageId": "fssai_final_edss9i",
                        "text": [
                          "License No. 11220334002097"
                        ]
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                        "name": "Wow! Momo",
                        "area": "HSR Layout",
                        "completeAddress": "WOW MOMO NO1 120 14th main road 5th sector HSR layout Bangalore BTM layout BBMP south  Karnataka  560102"
                      }
                    }
                  }
                ]
              }
            }
          }
        }
      ],
      "firstOffsetRequest": true,
      "isQCLink": false
    },
    "tid": "8091b6c9-34ec-4881-8b5e-d2b6a4328fa1",
    "sid": "c8b69dc8-6710-47a7-bc63-18091856e3fa",
    "deviceId": "c73fa13e-69cf-472b-8071-076091f9d98d",
    "csrfToken": "ad5HjDgIvRk5-T9AcPf-cNBeW0OCOhfFkFtxXyLI"
  }

export const CHICAGO_PIZZA=
{
  "statusCode": 0,
  "data": {
    "statusMessage": "done successfully",
    "cards": [
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
            "info": {
              "id": "712380",
              "name": "Chicago Pizza",
              "city": "Bangalore",
              "slugs": {
                "restaurant": "chicago-pizza-koramangala-koramangala",
                "city": "bangalore"
              },
              "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
              "cloudinaryImageId": "80f040545552605e33eba09f8fa30be9",
              "locality": "khb colony",
              "areaName": "Koramangala",
              "costForTwo": "50000",
              "costForTwoMessage": "₹500 for two",
              "cuisines": [
                "Pizzas",
                "Fast Food"
              ],
              "avgRating": 4.1,
              "feeDetails": {
                "restaurantId": "712380",
                "fees": [
                  {
                    "name": "distance",
                    "fee": 5600
                  },
                  {
                    "name": "time"
                  },
                  {
                    "name": "special"
                  }
                ],
                "totalFee": 5600,
                "icon": "v1648208530/surgecreatives/info",
                "message": "Far (5 kms) | Additional delivery fee will apply"
              },
              "parentId": "60277",
              "avgRatingString": "4.1",
              "totalRatingsString": "100+ ratings",
              "sla": {
                "restaurantId": "712380",
                "deliveryTime": 40,
                "minDeliveryTime": 40,
                "maxDeliveryTime": 45,
                "lastMileTravel": 5,
                "serviceability": "SERVICEABLE",
                "stressFactor": 1,
                "rainMode": "RAIN_MODE_NONE",
                "longDistance": "LONG_DISTANCE_IT_IS_LONG_DISTANCE",
                "zoneId": 1,
                "slaString": "40-45 MINS",
                "lastMileTravelString": "5.0 km",
                "iconType": "ICON_TYPE_EMPTY"
              },
              "availability": {
                "nextCloseTime": "2024-02-19 01:15:00",
                "visibility": true,
                "opened": true,
                "restaurantClosedMeta": {
                  
                }
              },
              "aggregatedDiscountInfo": {
                "header": "FLAT125 off",
                "shortDescriptionList": [
                  {
                    "meta": "FLAT125 off | Use FLATDEAL",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "FLAT125 off | Use FLATDEAL",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹100 off | Above ₹550",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "visible": true
              },
              "badges": {
                
              },
              "slugString": "chicago-pizza-koramangala-koramangala",
              "isOpen": true,
              "labels": [
                {
                  "title": "Timings",
                  "message": "null"
                },
                {
                  "title": "Address",
                  "message": "475/1, 5 th Block, KHB colony, Koramangala, Bengaluru"
                },
                {
                  "title": "Cuisines",
                  "message": "Pizzas,Fast Food"
                }
              ],
              "totalRatings": 100,
              "aggregatedDiscountInfoV2": {
                "header": "FLAT125 off",
                "shortDescriptionList": [
                  {
                    "meta": "FLAT125 off | Use FLATDEAL",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "FLAT125 off | Use FLATDEAL",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹100 off | Above ₹550",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "couponDetailsCta": "View coupon details"
              },
              "type": "F",
              "headerBanner": {
                "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/712380"
              },
              "expectationNotifiers": [
                {
                  "text": "Far (5 kms) | Additional delivery fee will apply",
                  "icon": {
                    "imageId": "v1648208530/surgecreatives/info"
                  },
                  "popup": {
                    "cta": {
                      
                    }
                  },
                  "type": "DISTANCE_FEE_NON_FOOD_LM",
                  "enrichedText": "<b>Far (5 kms)</b> | Additional delivery fee will apply",
                  "halfCardPopup": {
                    "halfCardPopupHeader": {
                      
                    }
                  }
                }
              ],
              "ratingSlab": "RATING_SLAB_5",
              "orderabilityCommunication": {
                "title": {
                  
                },
                "subTitle": {
                  
                },
                "message": {
                  
                },
                "customIcon": {
                  
                }
              },
              "hasBestsellerItems": true,
              "brandHeaderText": "Interested in dining out here?\nEnjoy flat 50% off with Swiggy Dineout",
              "cartOrderabilityNudgeBanner": {
                "parameters": {
                  
                },
                "presentation": {
                  
                }
              },
              "latLong": "12.9337983,77.6194491",
              "backgroundImageOverlayInfo": {
                
              }
            },
            "analytics": {
              
            }
          },
          "relevance": {
            "type": "RELEVANCE_TYPE_CHECK_ORDERABILITY_ON_ITEM_ADD",
            "sectionId": "POP_UP_CROUTON_MENU"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "layout": {
              "rows": 1,
              "columns": 5,
              "horizontalScrollEnabled": true,
              "itemSpacing": 12,
              "lineSpacing": 10,
              "widgetPadding": {
                
              },
              "containerStyle": {
                "containerPadding": {
                  "left": 10,
                  "right": 10,
                  "bottom": 16
                }
              },
              "scrollBar": {
                
              }
            },
            "id": "offerCollectionWidget_UX4",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                "offers": [
                  {
                    "info": {
                      "header": "FLAT ₹125 OFF",
                      "offerTag": "FLAT DEAL",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "962ee8e3-8d11-44ad-9b41-dae3160bcb0a"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE FLATDEAL",
                      "description": "ABOVE ₹499",
                      "offerType": "offers",
                      "restId": "712380",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹100 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "MARKETING_BANNERS/IMAGES/OFFERS/2024/2/17/1ed4245d-31e3-4dc6-b949-524a33b9b8c9_ICICI.png",
                      "offerIds": [
                        "299f5c31-dd4a-47a4-8d93-4ccb6be1a8a8"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "NO CODE REQUIRED",
                      "description": "ABOVE ₹550",
                      "offerType": "offers",
                      "restId": "712380",
                      "offerLogo": "MARKETING_BANNERS/IMAGES/OFFERS/2024/2/17/1ed4245d-31e3-4dc6-b949-524a33b9b8c9_ICICI.png",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹50 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "MARKETING_BANNERS/IMAGES/OFFERS/2024/2/16/d2280c74-96d1-4a1d-afd6-4270a05b5488_ICICI.png",
                      "offerIds": [
                        "72b12a41-597c-4c87-a813-32c46574fde9"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "NO CODE REQUIRED",
                      "description": "ABOVE ₹500",
                      "offerType": "offers",
                      "restId": "712380",
                      "offerLogo": "MARKETING_BANNERS/IMAGES/OFFERS/2024/2/16/d2280c74-96d1-4a1d-afd6-4270a05b5488_ICICI.png",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "15% OFF UPTO ₹300",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/15fb1cfe885005447dc8375e7970600f",
                      "offerIds": [
                        "c313f07b-4a9c-451e-ab52-586759f42642"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE CITIFOODIE",
                      "description": "ABOVE ₹1200",
                      "offerType": "offers",
                      "restId": "712380",
                      "offerLogo": "rng/md/ads/production/15fb1cfe885005447dc8375e7970600f",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹30 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/7f31c9e47ddd7e6a3c16d21553c0ca60",
                      "offerIds": [
                        "269c382d-796f-45cd-bd15-0b8b891c5e0c"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE SIMPL30",
                      "description": "ABOVE ₹300",
                      "offerType": "offers",
                      "restId": "712380",
                      "offerLogo": "rng/md/ads/production/7f31c9e47ddd7e6a3c16d21553c0ca60",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  }
                ],
                "habitMilestoneInfo": {
                  "callout": {
                    
                  }
                },
                "loyaltyDiscoverPresentationInfo": {
                  "logoCtx": {
                    
                  }
                }
              }
            }
          }
        }
      },
      {
        "groupedCard": {
          "cardGroupMap": {
            "REGULAR": {
              "cards": [
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                      "badges": {
                        
                      },
                      "vegOnlyDetails": {
                        "imageId": "AutoVegOnly_qkjowj",
                        "title": "Showing only vegetarian options.",
                        "description": "Tap on the VEG ONLY button to turn off the setting"
                      },
                      "topRatedFilter": {
                        
                      },
                      "kidsCategoryFilter": {
                        "attributes": {
                          "displayText": "Kids Favourites",
                          "tooltip": {
                            "enabled": true,
                            "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                          }
                        }
                      },
                      "vegFilter": {
                        "attributes": {
                          "displayText": "VEG"
                        }
                      },
                      "nonvegFilter": {
                        "attributes": {
                          "displayText": "NONVEG"
                        }
                      }
                    },
                    "relevance": {
                      "type": "RELEVANCE_TYPE_ON_MENU_FILTER_TOGGLED",
                      "sectionId": "MENU_FILTER_TOGGLE"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuCarousel",
                      "title": "Top Picks",
                      "carousel": [
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1599286",
                          "creativeId": "TopPicks/116276905A.png",
                          "title": "Margherita Pizza",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "116276905",
                              "name": "Margherita Pizza",
                              "category": "Make Ur Own @rs99",
                              "description": "Customize Your Way",
                              "imageId": "da8850c0e2d01a800cb646d614bfb838",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "28235413",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular (7 Inch)",
                                        "price": 149,
                                        "default": 1,
                                        "id": "89120559",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium (11 Inch)",
                                        "price": 359,
                                        "id": "89120560",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large (14 Inch)",
                                        "price": 549,
                                        "id": "89120561",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium Cheese Blast (11 Inch.)",
                                        "price": 449,
                                        "id": "93750703",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235413",
                                        "variationId": "89120559"
                                      }
                                    ],
                                    "price": 14900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92356996",
                                        "addonId": "99261155"
                                      },
                                      {
                                        "groupId": "92356996",
                                        "addonId": "99261156"
                                      },
                                      {
                                        "groupId": "92356996",
                                        "addonId": "99261157"
                                      },
                                      {
                                        "groupId": "92356996",
                                        "addonId": "99261158"
                                      },
                                      {
                                        "groupId": "92356996",
                                        "addonId": "99261159"
                                      },
                                      {
                                        "groupId": "92356996",
                                        "addonId": "99261160"
                                      },
                                      {
                                        "groupId": "92356996",
                                        "addonId": "99261161"
                                      },
                                      {
                                        "groupId": "92356996",
                                        "addonId": "99261162"
                                      },
                                      {
                                        "groupId": "92356996",
                                        "addonId": "99261163"
                                      },
                                      {
                                        "groupId": "92356996",
                                        "addonId": "99261164"
                                      },
                                      {
                                        "groupId": "92356997",
                                        "addonId": "99261165"
                                      },
                                      {
                                        "groupId": "92356997",
                                        "addonId": "99261166"
                                      },
                                      {
                                        "groupId": "92356997",
                                        "addonId": "99261167"
                                      },
                                      {
                                        "groupId": "92356997",
                                        "addonId": "99261168"
                                      },
                                      {
                                        "groupId": "92356997",
                                        "addonId": "99261169"
                                      },
                                      {
                                        "groupId": "92356997",
                                        "addonId": "99261170"
                                      },
                                      {
                                        "groupId": "92356997",
                                        "addonId": "99261171"
                                      },
                                      {
                                        "groupId": "92356997",
                                        "addonId": "109683408"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235413",
                                        "variationId": "89120560"
                                      }
                                    ],
                                    "price": 35900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92356998",
                                        "addonId": "99261172"
                                      },
                                      {
                                        "groupId": "92356998",
                                        "addonId": "99261173"
                                      },
                                      {
                                        "groupId": "92356998",
                                        "addonId": "99261174"
                                      },
                                      {
                                        "groupId": "92356998",
                                        "addonId": "99261175"
                                      },
                                      {
                                        "groupId": "92356998",
                                        "addonId": "99261176"
                                      },
                                      {
                                        "groupId": "92356998",
                                        "addonId": "99261177"
                                      },
                                      {
                                        "groupId": "92356998",
                                        "addonId": "99261178"
                                      },
                                      {
                                        "groupId": "92356998",
                                        "addonId": "99261179"
                                      },
                                      {
                                        "groupId": "92356998",
                                        "addonId": "99261180"
                                      },
                                      {
                                        "groupId": "92356998",
                                        "addonId": "99261181"
                                      },
                                      {
                                        "groupId": "92356999",
                                        "addonId": "109683407"
                                      },
                                      {
                                        "groupId": "92356999",
                                        "addonId": "99261182"
                                      },
                                      {
                                        "groupId": "92356999",
                                        "addonId": "99261183"
                                      },
                                      {
                                        "groupId": "92356999",
                                        "addonId": "99261184"
                                      },
                                      {
                                        "groupId": "92356999",
                                        "addonId": "99261185"
                                      },
                                      {
                                        "groupId": "92356999",
                                        "addonId": "99261186"
                                      },
                                      {
                                        "groupId": "92356999",
                                        "addonId": "99261187"
                                      },
                                      {
                                        "groupId": "92356999",
                                        "addonId": "99261188"
                                      },
                                      {
                                        "groupId": "92356999",
                                        "addonId": "99261189"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235413",
                                        "variationId": "89120561"
                                      }
                                    ],
                                    "price": 54900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357001",
                                        "addonId": "109683409"
                                      },
                                      {
                                        "groupId": "92357001",
                                        "addonId": "99261200"
                                      },
                                      {
                                        "groupId": "92357001",
                                        "addonId": "99261201"
                                      },
                                      {
                                        "groupId": "92357001",
                                        "addonId": "99261202"
                                      },
                                      {
                                        "groupId": "92357001",
                                        "addonId": "99261203"
                                      },
                                      {
                                        "groupId": "92357001",
                                        "addonId": "99261204"
                                      },
                                      {
                                        "groupId": "92357001",
                                        "addonId": "99261205"
                                      },
                                      {
                                        "groupId": "92357001",
                                        "addonId": "99261206"
                                      },
                                      {
                                        "groupId": "92357001",
                                        "addonId": "99261207"
                                      },
                                      {
                                        "groupId": "92357000",
                                        "addonId": "99261190"
                                      },
                                      {
                                        "groupId": "92357000",
                                        "addonId": "99261191"
                                      },
                                      {
                                        "groupId": "92357000",
                                        "addonId": "99261192"
                                      },
                                      {
                                        "groupId": "92357000",
                                        "addonId": "99261193"
                                      },
                                      {
                                        "groupId": "92357000",
                                        "addonId": "99261194"
                                      },
                                      {
                                        "groupId": "92357000",
                                        "addonId": "99261195"
                                      },
                                      {
                                        "groupId": "92357000",
                                        "addonId": "99261196"
                                      },
                                      {
                                        "groupId": "92357000",
                                        "addonId": "99261197"
                                      },
                                      {
                                        "groupId": "92357000",
                                        "addonId": "99261198"
                                      },
                                      {
                                        "groupId": "92357000",
                                        "addonId": "99261199"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235413",
                                        "variationId": "93750703"
                                      }
                                    ],
                                    "price": 44900
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "92356996",
                                  "groupName": "extra Veg Toppings [regular]",
                                  "choices": [
                                    {
                                      "id": "99261155",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261156",
                                      "name": "Red Paprika",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261157",
                                      "name": "Corn",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261158",
                                      "name": "Mushroom",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261159",
                                      "name": "Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261160",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261161",
                                      "name": "Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261162",
                                      "name": "Pineapple",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261163",
                                      "name": "Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261164",
                                      "name": "Jalapenos",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "92356997",
                                  "groupName": "extra Non Veg Toppings [regular]",
                                  "choices": [
                                    {
                                      "id": "99261165",
                                      "name": "Chicken Ham",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261166",
                                      "name": "Chicken Sausage",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261167",
                                      "name": "Bbq Chicken",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261168",
                                      "name": "Pepperoni",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261169",
                                      "name": "Smoked Chicken Breast",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261170",
                                      "name": "Chicken Tikka",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261171",
                                      "name": "Chicken Meatballs",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683408",
                                      "name": "Chicken Seekh Kebab",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "92356998",
                                  "groupName": "extra Veg Toppings [medium]",
                                  "choices": [
                                    {
                                      "id": "99261172",
                                      "name": "Olive",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261173",
                                      "name": "Paneer",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261174",
                                      "name": "Red Paprika",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261175",
                                      "name": "Corn",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261176",
                                      "name": "Mushroom",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261177",
                                      "name": "Capsicum",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261178",
                                      "name": "Onion",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261179",
                                      "name": "Jalapeno",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261180",
                                      "name": "Cheese",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261181",
                                      "name": "Pineapple",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "92356999",
                                  "groupName": "extra Non Veg Toppings [medium]",
                                  "choices": [
                                    {
                                      "id": "109683407",
                                      "name": "Chicken Seekh Kebab",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261182",
                                      "name": "Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261183",
                                      "name": "Chicken Ham",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261184",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261185",
                                      "name": "Bbq Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261186",
                                      "name": "Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261187",
                                      "name": "Smoked Chicken Breast",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261188",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261189",
                                      "name": "Chicken Meatballs",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "92357000",
                                  "groupName": "extra Veg Toppings [large]",
                                  "choices": [
                                    {
                                      "id": "99261190",
                                      "name": "Paneer",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261191",
                                      "name": "Red Paprika",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261192",
                                      "name": "Corn",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261193",
                                      "name": "Mushroom",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261194",
                                      "name": "Capsicum",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261195",
                                      "name": "Onion",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261196",
                                      "name": "Jalapeno",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261197",
                                      "name": "Pineapple",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261198",
                                      "name": "Cheese",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261199",
                                      "name": "Olive",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "92357001",
                                  "groupName": "extra Non Veg Toppings [large]",
                                  "choices": [
                                    {
                                      "id": "109683409",
                                      "name": "Chicken Seekh Kebab",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261200",
                                      "name": "Cheese",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261201",
                                      "name": "Chicken Ham",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261202",
                                      "name": "Chicken Sausage",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261203",
                                      "name": "Bbq Chicken",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261204",
                                      "name": "Pepperoni",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261205",
                                      "name": "Smoked Chicken Breast",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261206",
                                      "name": "Chicken Tikka",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261207",
                                      "name": "Chicken Meatballs",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 14900,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1599287",
                          "creativeId": "TopPicks/116276938A.png",
                          "title": "Spicy Affair Pizza",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "116276938",
                              "name": "Spicy Affair Pizza",
                              "category": "Special Pizza",
                              "description": "Must Try - imported Mexican Red Paprika & Jalapeno, Spanish Black Olives & Caramalized onion freshly baked Pizza with home made Peri-Peri Sauce sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                              "imageId": "w7cfrm3bofjxxr74zarh",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "28235469",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular (7 Inch)",
                                        "price": 269,
                                        "default": 1,
                                        "id": "89120774",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium (11 Inch)",
                                        "price": 569,
                                        "id": "89120775",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large (14 Inch)",
                                        "price": 819,
                                        "id": "89120776",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium Cheese Blast (11 Inch.)",
                                        "price": 669,
                                        "id": "89120777",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235469",
                                        "variationId": "89120774"
                                      }
                                    ],
                                    "price": 26900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235469",
                                        "variationId": "89120775"
                                      }
                                    ],
                                    "price": 56900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235469",
                                        "variationId": "89120776"
                                      }
                                    ],
                                    "price": 81900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235469",
                                        "variationId": "89120777"
                                      }
                                    ],
                                    "price": 66900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 26900,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1599288",
                          "creativeId": "TopPicks/116276961A.png",
                          "title": "Big Meaty Pizza",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "116276961",
                              "name": "Big Meaty Pizza",
                              "category": "Special Pizza",
                              "description": "BBQ Chicken, Smoked Chicken Breast & caramalized Onion marinated in inhouse  secret korma sauce receipe sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                              "imageId": "cdsfflkkdzubmhvxuuwn",
                              "inStock": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "28235485",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular (7 Inch)",
                                        "price": 329,
                                        "default": 1,
                                        "id": "89120836",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium (11 Inch)",
                                        "price": 639,
                                        "id": "89120837",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large (14 Inch)",
                                        "price": 919,
                                        "id": "89120838",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium Cheese Blast (11 Inch.)",
                                        "price": 739,
                                        "id": "89120839",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235485",
                                        "variationId": "89120836"
                                      }
                                    ],
                                    "price": 32900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235485",
                                        "variationId": "89120837"
                                      }
                                    ],
                                    "price": 63900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357077",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235485",
                                        "variationId": "89120838"
                                      }
                                    ],
                                    "price": 91900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357077",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235485",
                                        "variationId": "89120839"
                                      }
                                    ],
                                    "price": 73900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357077",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "92357077",
                                  "groupName": "Four Cheese",
                                  "choices": [
                                    {
                                      "id": "99261208",
                                      "name": "Four Cheese",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 32900,
                              "ribbon": {
                                
                              },
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1599289",
                          "creativeId": "TopPicks/116276898A.png",
                          "title": "Italian Chicken Pasta",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "116276898",
                              "name": "Italian Chicken Pasta",
                              "category": "Pastas ",
                              "description": "BBQ Chicken, Golden Corn & Tangy Jalapeno Authentic Italian Penne Pasta tossed with extra virgin Spanish Olive oil with 100% mozarella cheese and a dash of garlic & bresh Basil with a choice of 4 secret sauces",
                              "imageId": "wxpnrbru6wcoyu3wadm8",
                              "inStock": 1,
                              "price": 26900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "100684473",
                                  "groupName": "Choice Of Sauce",
                                  "choices": [
                                    {
                                      "id": "99261209",
                                      "name": "Pink Sauce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261210",
                                      "name": "Red Sauce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261211",
                                      "name": "White Sauce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1599290",
                          "creativeId": "TopPicks/116276986A.png",
                          "title": "Potato Wedges",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "116276986",
                              "name": "Potato Wedges",
                              "category": "Sides",
                              "description": "Wedge shaped Potatos baked in Australian style",
                              "imageId": "ziznjn2xqtofyzqtup2w",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1599291",
                          "creativeId": "TopPicks/116276989A.png",
                          "title": "Pizza Roll",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "116276989",
                              "name": "Pizza Roll",
                              "category": "Rolls @ Rs 99",
                              "description": "Secret Pizza recipe handrolled & Baked Desi Style",
                              "imageId": "urhnsqy27wycdiofnygw",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1599292",
                          "creativeId": "TopPicks/116276889A.png",
                          "title": "Bhuna Murg Pizza",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "116276889",
                              "name": "Bhuna Murg Pizza",
                              "category": "Desi Pizza ",
                              "description": "Chicken Tikka marinated in inhouse Desi Butter Gravy, caramalised onion and capsicum sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                              "imageId": "zzv5gr7drxphytlf1rww",
                              "inStock": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "28235430",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular (7 Inch)",
                                        "price": 259,
                                        "default": 1,
                                        "id": "89120620",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium (11 Inch)",
                                        "price": 589,
                                        "id": "89120621",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large (14 Inch)",
                                        "price": 849,
                                        "id": "89120622",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium Cheese Blast (11 Inch.)",
                                        "price": 689,
                                        "id": "89120623",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235430",
                                        "variationId": "89120620"
                                      }
                                    ],
                                    "price": 25900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235430",
                                        "variationId": "89120621"
                                      }
                                    ],
                                    "price": 58900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357055",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235430",
                                        "variationId": "89120622"
                                      }
                                    ],
                                    "price": 84900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357055",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235430",
                                        "variationId": "89120623"
                                      }
                                    ],
                                    "price": 68900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357055",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "92357055",
                                  "groupName": "Four Cheese",
                                  "choices": [
                                    {
                                      "id": "99261208",
                                      "name": "Four Cheese",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 25900,
                              "ribbon": {
                                
                              },
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1599293",
                          "creativeId": "TopPicks/116720589A.png",
                          "title": "Veg Overloaded Pizza",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "116720589",
                              "name": "Veg Overloaded Pizza",
                              "category": "Special Pizza",
                              "description": "BESTSELLER - Loaded with all veg premium toppings including Paneer, Red Paprika, Jalapeno, Black olives. Pineapple, Corn, Mushroom, Capsicum , Sweet Corn & Onion",
                              "imageId": "cqe2rrdjcyj8vzuydafd",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "28235483",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular (7 Inch)",
                                        "price": 299,
                                        "default": 1,
                                        "id": "89120828",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium (11 Inch)",
                                        "price": 609,
                                        "id": "89120829",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large (14 Inch)",
                                        "price": 889,
                                        "id": "89120830",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium Cheese Blast (11 Inch.)",
                                        "price": 709,
                                        "id": "89120831",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235483",
                                        "variationId": "89120828"
                                      }
                                    ],
                                    "price": 29900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357074",
                                        "addonId": "99261220"
                                      },
                                      {
                                        "groupId": "92357074",
                                        "addonId": "99261221"
                                      },
                                      {
                                        "groupId": "92357074",
                                        "addonId": "99261222"
                                      },
                                      {
                                        "groupId": "92357074",
                                        "addonId": "99261223"
                                      },
                                      {
                                        "groupId": "92357074",
                                        "addonId": "99261224"
                                      },
                                      {
                                        "groupId": "92357074",
                                        "addonId": "99261225"
                                      },
                                      {
                                        "groupId": "92357074",
                                        "addonId": "99261226"
                                      },
                                      {
                                        "groupId": "92357074",
                                        "addonId": "99261227"
                                      },
                                      {
                                        "groupId": "92357074",
                                        "addonId": "99261228"
                                      },
                                      {
                                        "groupId": "92357074",
                                        "addonId": "99261229"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235483",
                                        "variationId": "89120829"
                                      }
                                    ],
                                    "price": 60900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357075",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235483",
                                        "variationId": "89120830"
                                      }
                                    ],
                                    "price": 88900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357075",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235483",
                                        "variationId": "89120831"
                                      }
                                    ],
                                    "price": 70900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357075",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "92357074",
                                  "groupName": "Extra Veg Toppings [medium]",
                                  "choices": [
                                    {
                                      "id": "99261220",
                                      "name": "Cheese",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261221",
                                      "name": "Onion",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261222",
                                      "name": "Capsicum",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261223",
                                      "name": "Mushroom",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261224",
                                      "name": "Corn",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261225",
                                      "name": "Red Paprika",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261226",
                                      "name": "Paneer",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261227",
                                      "name": "Olive",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261228",
                                      "name": "Pineapple",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261229",
                                      "name": "Jalapeno",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "92357075",
                                  "groupName": "Four Cheese",
                                  "choices": [
                                    {
                                      "id": "99261208",
                                      "name": "Four Cheese",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 29900,
                              "ribbon": {
                                
                              },
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Recommended",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116276957",
                              "name": "La American Bbq Pizza",
                              "category": "Say ! Meat",
                              "description": "Roasted BBQ Cicken  freshly baked Pizza with secret recipe cheesy, spicy & creamy jalapeno cheese sauce sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                              "imageId": "wogbo7jawtard87tm7he",
                              "inStock": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "28235420",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular (7 Inch)",
                                        "price": 219,
                                        "default": 1,
                                        "id": "89120583",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium (11 Inch)",
                                        "price": 399,
                                        "id": "89120584",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large (14 Inch)",
                                        "price": 749,
                                        "id": "89120585",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium Cheese Blast (11 Inch.)",
                                        "price": 499,
                                        "id": "89120586",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235420",
                                        "variationId": "89120583"
                                      }
                                    ],
                                    "price": 21900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357013",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357013",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357013",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357013",
                                        "addonId": "99261219"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235420",
                                        "variationId": "89120584"
                                      }
                                    ],
                                    "price": 39900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357013",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357013",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357013",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357013",
                                        "addonId": "99261219"
                                      },
                                      {
                                        "groupId": "92357014",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235420",
                                        "variationId": "89120585"
                                      }
                                    ],
                                    "price": 74900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357013",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357013",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357013",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357013",
                                        "addonId": "99261219"
                                      },
                                      {
                                        "groupId": "92357014",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235420",
                                        "variationId": "89120586"
                                      }
                                    ],
                                    "price": 49900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357013",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357013",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357013",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357013",
                                        "addonId": "99261219"
                                      },
                                      {
                                        "groupId": "92357014",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "92357014",
                                  "groupName": "Four Cheese",
                                  "choices": [
                                    {
                                      "id": "99261208",
                                      "name": "Four Cheese",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "92357013",
                                  "groupName": "Add on",
                                  "choices": [
                                    {
                                      "id": "99261216",
                                      "name": "Virgin Mojito Mocktail",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261217",
                                      "name": "Stuffed Garlic Bread (jalapeno & Corn)",
                                      "price": 15800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261218",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261219",
                                      "name": "Blue Lagoon Mocktail",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 21900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "11 ratings",
                                  "ratingCountV2": "11"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116276987",
                              "name": "La Chicken Sausage Pizza",
                              "category": "Say ! Meat",
                              "description": "German recipe Chicken Sausage  freshly baked Pizza with secret recipe cheesy, spicy & creamy jalapeno cheese sauce sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                              "imageId": "ucpyvov4b3jek5oz4kus",
                              "inStock": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "28235423",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular (7 Inch)",
                                        "price": 219,
                                        "default": 1,
                                        "id": "89120595",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium (11 Inch)",
                                        "price": 399,
                                        "id": "89120596",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large (14 Inch)",
                                        "price": 749,
                                        "id": "89120597",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium Cheese Blast (11 Inch.)",
                                        "price": 499,
                                        "id": "89120598",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235423",
                                        "variationId": "89120595"
                                      }
                                    ],
                                    "price": 21900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357019",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357019",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357019",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357019",
                                        "addonId": "99261219"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235423",
                                        "variationId": "89120596"
                                      }
                                    ],
                                    "price": 39900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357019",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357019",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357019",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357019",
                                        "addonId": "99261219"
                                      },
                                      {
                                        "groupId": "92357020",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235423",
                                        "variationId": "89120597"
                                      }
                                    ],
                                    "price": 74900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357019",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357019",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357019",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357019",
                                        "addonId": "99261219"
                                      },
                                      {
                                        "groupId": "92357020",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235423",
                                        "variationId": "89120598"
                                      }
                                    ],
                                    "price": 49900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357019",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357019",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357019",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357019",
                                        "addonId": "99261219"
                                      },
                                      {
                                        "groupId": "92357020",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "92357020",
                                  "groupName": "Four Cheese",
                                  "choices": [
                                    {
                                      "id": "99261208",
                                      "name": "Four Cheese",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "92357019",
                                  "groupName": "Add on",
                                  "choices": [
                                    {
                                      "id": "99261216",
                                      "name": "Virgin Mojito Mocktail",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261217",
                                      "name": "Stuffed Garlic Bread (jalapeno & Corn)",
                                      "price": 15800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261218",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261219",
                                      "name": "Blue Lagoon Mocktail",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 21900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116276999",
                              "name": "La Chicken Meatball Pizza",
                              "category": "Say ! Meat",
                              "description": "Chicken Meatball freshly baked Pizza with secret recipe cheesy, spicy & creamy jalapeno cheese sauce sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                              "imageId": "vj7suncsgomvlkfol4hh",
                              "inStock": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "28235422",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular (7 Inch)",
                                        "price": 219,
                                        "default": 1,
                                        "id": "89120591",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium (11 Inch)",
                                        "price": 399,
                                        "id": "89120592",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large (14 Inch)",
                                        "price": 749,
                                        "id": "89120593",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium Cheese Blast (11 Inch.)",
                                        "price": 499,
                                        "id": "89120594",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235422",
                                        "variationId": "89120591"
                                      }
                                    ],
                                    "price": 21900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357017",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357017",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357017",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357017",
                                        "addonId": "99261219"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235422",
                                        "variationId": "89120592"
                                      }
                                    ],
                                    "price": 39900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357017",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357017",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357017",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357017",
                                        "addonId": "99261219"
                                      },
                                      {
                                        "groupId": "92357018",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235422",
                                        "variationId": "89120593"
                                      }
                                    ],
                                    "price": 74900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357017",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357017",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357017",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357017",
                                        "addonId": "99261219"
                                      },
                                      {
                                        "groupId": "92357018",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235422",
                                        "variationId": "89120594"
                                      }
                                    ],
                                    "price": 49900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357017",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357017",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357017",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357017",
                                        "addonId": "99261219"
                                      },
                                      {
                                        "groupId": "92357018",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "92357018",
                                  "groupName": "Four Cheese",
                                  "choices": [
                                    {
                                      "id": "99261208",
                                      "name": "Four Cheese",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "92357017",
                                  "groupName": "Add on",
                                  "choices": [
                                    {
                                      "id": "99261216",
                                      "name": "Virgin Mojito Mocktail",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261217",
                                      "name": "Stuffed Garlic Bread (jalapeno & Corn)",
                                      "price": 15800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261218",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261219",
                                      "name": "Blue Lagoon Mocktail",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 21900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116277011",
                              "name": "La Chicken Ham Pizza",
                              "category": "Say ! Meat",
                              "description": "Smoked Chicken Ham freshly baked Pizza with secret recipe cheesy, spicy & creamy jalapeno cheese sauce sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                              "imageId": "k3qdnfl4x5lypqqstpdk",
                              "inStock": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "28235421",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular (7 Inch)",
                                        "price": 219,
                                        "default": 1,
                                        "id": "89120587",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium (11 Inch)",
                                        "price": 399,
                                        "id": "89120588",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large (14 Inch)",
                                        "price": 749,
                                        "id": "89120589",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium Cheese Blast (11 Inch.)",
                                        "price": 499,
                                        "id": "89120590",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235421",
                                        "variationId": "89120587"
                                      }
                                    ],
                                    "price": 21900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357015",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357015",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357015",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357015",
                                        "addonId": "99261219"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235421",
                                        "variationId": "89120588"
                                      }
                                    ],
                                    "price": 39900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357015",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357015",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357015",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357015",
                                        "addonId": "99261219"
                                      },
                                      {
                                        "groupId": "92357016",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235421",
                                        "variationId": "89120589"
                                      }
                                    ],
                                    "price": 74900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357015",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357015",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357015",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357015",
                                        "addonId": "99261219"
                                      },
                                      {
                                        "groupId": "92357016",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235421",
                                        "variationId": "89120590"
                                      }
                                    ],
                                    "price": 49900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357015",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357015",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357015",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357015",
                                        "addonId": "99261219"
                                      },
                                      {
                                        "groupId": "92357016",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "92357016",
                                  "groupName": "Four Cheese",
                                  "choices": [
                                    {
                                      "id": "99261208",
                                      "name": "Four Cheese",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "92357015",
                                  "groupName": "Add on",
                                  "choices": [
                                    {
                                      "id": "99261216",
                                      "name": "Virgin Mojito Mocktail",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261217",
                                      "name": "Stuffed Garlic Bread (jalapeno & Corn)",
                                      "price": 15800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261218",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261219",
                                      "name": "Blue Lagoon Mocktail",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 21900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116277010",
                              "name": "7 Types Of Cheese Pizza",
                              "category": "Say Cheese [regular/medium/large]",
                              "description": "7 Types Of Cheese Exotic Combination Baked Freshly To Perfection With Inhouse Italian Pizza Sauce & Served With Chilli Flakes & Oregano Seasoning",
                              "imageId": "c1cf54427a880530a70abeae704c2486",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "28235412",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular (7 Inch)",
                                        "price": 239,
                                        "default": 1,
                                        "id": "89120555",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium (11 Inch)",
                                        "price": 519,
                                        "id": "89120556",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large (14 Inch)",
                                        "price": 799,
                                        "id": "89120557",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium Cheese Blast (11 Inch.)",
                                        "price": 619,
                                        "id": "89120558",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235412",
                                        "variationId": "89120555"
                                      }
                                    ],
                                    "price": 23900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92356990",
                                        "addonId": "99261155"
                                      },
                                      {
                                        "groupId": "92356990",
                                        "addonId": "99261156"
                                      },
                                      {
                                        "groupId": "92356990",
                                        "addonId": "99261157"
                                      },
                                      {
                                        "groupId": "92356990",
                                        "addonId": "99261158"
                                      },
                                      {
                                        "groupId": "92356990",
                                        "addonId": "99261159"
                                      },
                                      {
                                        "groupId": "92356990",
                                        "addonId": "99261160"
                                      },
                                      {
                                        "groupId": "92356990",
                                        "addonId": "99261161"
                                      },
                                      {
                                        "groupId": "92356990",
                                        "addonId": "99261162"
                                      },
                                      {
                                        "groupId": "92356990",
                                        "addonId": "99261163"
                                      },
                                      {
                                        "groupId": "92356990",
                                        "addonId": "99261164"
                                      },
                                      {
                                        "groupId": "92356991",
                                        "addonId": "99261165"
                                      },
                                      {
                                        "groupId": "92356991",
                                        "addonId": "99261166"
                                      },
                                      {
                                        "groupId": "92356991",
                                        "addonId": "99261167"
                                      },
                                      {
                                        "groupId": "92356991",
                                        "addonId": "99261168"
                                      },
                                      {
                                        "groupId": "92356991",
                                        "addonId": "99261169"
                                      },
                                      {
                                        "groupId": "92356991",
                                        "addonId": "99261170"
                                      },
                                      {
                                        "groupId": "92356991",
                                        "addonId": "99261171"
                                      },
                                      {
                                        "groupId": "92356991",
                                        "addonId": "109683408"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235412",
                                        "variationId": "89120556"
                                      }
                                    ],
                                    "price": 51900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92356992",
                                        "addonId": "99261172"
                                      },
                                      {
                                        "groupId": "92356992",
                                        "addonId": "99261173"
                                      },
                                      {
                                        "groupId": "92356992",
                                        "addonId": "99261174"
                                      },
                                      {
                                        "groupId": "92356992",
                                        "addonId": "99261175"
                                      },
                                      {
                                        "groupId": "92356992",
                                        "addonId": "99261176"
                                      },
                                      {
                                        "groupId": "92356992",
                                        "addonId": "99261177"
                                      },
                                      {
                                        "groupId": "92356992",
                                        "addonId": "99261178"
                                      },
                                      {
                                        "groupId": "92356992",
                                        "addonId": "99261179"
                                      },
                                      {
                                        "groupId": "92356992",
                                        "addonId": "99261180"
                                      },
                                      {
                                        "groupId": "92356992",
                                        "addonId": "99261181"
                                      },
                                      {
                                        "groupId": "92356993",
                                        "addonId": "109683407"
                                      },
                                      {
                                        "groupId": "92356993",
                                        "addonId": "99261182"
                                      },
                                      {
                                        "groupId": "92356993",
                                        "addonId": "99261183"
                                      },
                                      {
                                        "groupId": "92356993",
                                        "addonId": "99261184"
                                      },
                                      {
                                        "groupId": "92356993",
                                        "addonId": "99261185"
                                      },
                                      {
                                        "groupId": "92356993",
                                        "addonId": "99261186"
                                      },
                                      {
                                        "groupId": "92356993",
                                        "addonId": "99261187"
                                      },
                                      {
                                        "groupId": "92356993",
                                        "addonId": "99261188"
                                      },
                                      {
                                        "groupId": "92356993",
                                        "addonId": "99261189"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235412",
                                        "variationId": "89120557"
                                      }
                                    ],
                                    "price": 79900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92356995",
                                        "addonId": "109683409"
                                      },
                                      {
                                        "groupId": "92356995",
                                        "addonId": "99261200"
                                      },
                                      {
                                        "groupId": "92356995",
                                        "addonId": "99261201"
                                      },
                                      {
                                        "groupId": "92356995",
                                        "addonId": "99261202"
                                      },
                                      {
                                        "groupId": "92356995",
                                        "addonId": "99261203"
                                      },
                                      {
                                        "groupId": "92356995",
                                        "addonId": "99261204"
                                      },
                                      {
                                        "groupId": "92356995",
                                        "addonId": "99261205"
                                      },
                                      {
                                        "groupId": "92356995",
                                        "addonId": "99261206"
                                      },
                                      {
                                        "groupId": "92356995",
                                        "addonId": "99261207"
                                      },
                                      {
                                        "groupId": "92356994",
                                        "addonId": "99261190"
                                      },
                                      {
                                        "groupId": "92356994",
                                        "addonId": "99261191"
                                      },
                                      {
                                        "groupId": "92356994",
                                        "addonId": "99261192"
                                      },
                                      {
                                        "groupId": "92356994",
                                        "addonId": "99261193"
                                      },
                                      {
                                        "groupId": "92356994",
                                        "addonId": "99261194"
                                      },
                                      {
                                        "groupId": "92356994",
                                        "addonId": "99261195"
                                      },
                                      {
                                        "groupId": "92356994",
                                        "addonId": "99261196"
                                      },
                                      {
                                        "groupId": "92356994",
                                        "addonId": "99261197"
                                      },
                                      {
                                        "groupId": "92356994",
                                        "addonId": "99261198"
                                      },
                                      {
                                        "groupId": "92356994",
                                        "addonId": "99261199"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235412",
                                        "variationId": "89120558"
                                      }
                                    ],
                                    "price": 61900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92356992",
                                        "addonId": "99261172"
                                      },
                                      {
                                        "groupId": "92356992",
                                        "addonId": "99261173"
                                      },
                                      {
                                        "groupId": "92356992",
                                        "addonId": "99261174"
                                      },
                                      {
                                        "groupId": "92356992",
                                        "addonId": "99261175"
                                      },
                                      {
                                        "groupId": "92356992",
                                        "addonId": "99261176"
                                      },
                                      {
                                        "groupId": "92356992",
                                        "addonId": "99261177"
                                      },
                                      {
                                        "groupId": "92356992",
                                        "addonId": "99261178"
                                      },
                                      {
                                        "groupId": "92356992",
                                        "addonId": "99261179"
                                      },
                                      {
                                        "groupId": "92356992",
                                        "addonId": "99261180"
                                      },
                                      {
                                        "groupId": "92356992",
                                        "addonId": "99261181"
                                      },
                                      {
                                        "groupId": "92356993",
                                        "addonId": "109683407"
                                      },
                                      {
                                        "groupId": "92356993",
                                        "addonId": "99261182"
                                      },
                                      {
                                        "groupId": "92356993",
                                        "addonId": "99261183"
                                      },
                                      {
                                        "groupId": "92356993",
                                        "addonId": "99261184"
                                      },
                                      {
                                        "groupId": "92356993",
                                        "addonId": "99261185"
                                      },
                                      {
                                        "groupId": "92356993",
                                        "addonId": "99261186"
                                      },
                                      {
                                        "groupId": "92356993",
                                        "addonId": "99261187"
                                      },
                                      {
                                        "groupId": "92356993",
                                        "addonId": "99261188"
                                      },
                                      {
                                        "groupId": "92356993",
                                        "addonId": "99261189"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "92356990",
                                  "groupName": "extra Veg Toppings [regular]",
                                  "choices": [
                                    {
                                      "id": "99261155",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261156",
                                      "name": "Red Paprika",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261157",
                                      "name": "Corn",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261158",
                                      "name": "Mushroom",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261159",
                                      "name": "Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261160",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261161",
                                      "name": "Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261162",
                                      "name": "Pineapple",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261163",
                                      "name": "Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261164",
                                      "name": "Jalapenos",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "92356991",
                                  "groupName": "extra Non Veg Toppings [regular]",
                                  "choices": [
                                    {
                                      "id": "99261165",
                                      "name": "Chicken Ham",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261166",
                                      "name": "Chicken Sausage",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261167",
                                      "name": "Bbq Chicken",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261168",
                                      "name": "Pepperoni",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261169",
                                      "name": "Smoked Chicken Breast",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261170",
                                      "name": "Chicken Tikka",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261171",
                                      "name": "Chicken Meatballs",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683408",
                                      "name": "Chicken Seekh Kebab",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "92356992",
                                  "groupName": "extra Veg Toppings [medium]",
                                  "choices": [
                                    {
                                      "id": "99261172",
                                      "name": "Olive",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261173",
                                      "name": "Paneer",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261174",
                                      "name": "Red Paprika",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261175",
                                      "name": "Corn",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261176",
                                      "name": "Mushroom",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261177",
                                      "name": "Capsicum",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261178",
                                      "name": "Onion",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261179",
                                      "name": "Jalapeno",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261180",
                                      "name": "Cheese",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261181",
                                      "name": "Pineapple",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "92356993",
                                  "groupName": "extra Non Veg Toppings [medium]",
                                  "choices": [
                                    {
                                      "id": "109683407",
                                      "name": "Chicken Seekh Kebab",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261182",
                                      "name": "Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261183",
                                      "name": "Chicken Ham",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261184",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261185",
                                      "name": "Bbq Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261186",
                                      "name": "Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261187",
                                      "name": "Smoked Chicken Breast",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261188",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261189",
                                      "name": "Chicken Meatballs",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "92356994",
                                  "groupName": "extra Veg Toppings [large]",
                                  "choices": [
                                    {
                                      "id": "99261190",
                                      "name": "Paneer",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261191",
                                      "name": "Red Paprika",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261192",
                                      "name": "Corn",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261193",
                                      "name": "Mushroom",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261194",
                                      "name": "Capsicum",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261195",
                                      "name": "Onion",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261196",
                                      "name": "Jalapeno",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261197",
                                      "name": "Pineapple",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261198",
                                      "name": "Cheese",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261199",
                                      "name": "Olive",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "92356995",
                                  "groupName": "extra Non Veg Toppings [large]",
                                  "choices": [
                                    {
                                      "id": "109683409",
                                      "name": "Chicken Seekh Kebab",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261200",
                                      "name": "Cheese",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261201",
                                      "name": "Chicken Ham",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261202",
                                      "name": "Chicken Sausage",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261203",
                                      "name": "Bbq Chicken",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261204",
                                      "name": "Pepperoni",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261205",
                                      "name": "Smoked Chicken Breast",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261206",
                                      "name": "Chicken Tikka",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261207",
                                      "name": "Chicken Meatballs",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 23900,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "21 ratings",
                                  "ratingCountV2": "21"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116276905",
                              "name": "Margherita Pizza",
                              "category": "Make Ur Own @rs99",
                              "description": "Customize Your Way",
                              "imageId": "da8850c0e2d01a800cb646d614bfb838",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "28235413",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular (7 Inch)",
                                        "price": 149,
                                        "default": 1,
                                        "id": "89120559",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium (11 Inch)",
                                        "price": 359,
                                        "id": "89120560",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large (14 Inch)",
                                        "price": 549,
                                        "id": "89120561",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium Cheese Blast (11 Inch.)",
                                        "price": 449,
                                        "id": "93750703",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235413",
                                        "variationId": "89120559"
                                      }
                                    ],
                                    "price": 14900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92356996",
                                        "addonId": "99261155"
                                      },
                                      {
                                        "groupId": "92356996",
                                        "addonId": "99261156"
                                      },
                                      {
                                        "groupId": "92356996",
                                        "addonId": "99261157"
                                      },
                                      {
                                        "groupId": "92356996",
                                        "addonId": "99261158"
                                      },
                                      {
                                        "groupId": "92356996",
                                        "addonId": "99261159"
                                      },
                                      {
                                        "groupId": "92356996",
                                        "addonId": "99261160"
                                      },
                                      {
                                        "groupId": "92356996",
                                        "addonId": "99261161"
                                      },
                                      {
                                        "groupId": "92356996",
                                        "addonId": "99261162"
                                      },
                                      {
                                        "groupId": "92356996",
                                        "addonId": "99261163"
                                      },
                                      {
                                        "groupId": "92356996",
                                        "addonId": "99261164"
                                      },
                                      {
                                        "groupId": "92356997",
                                        "addonId": "99261165"
                                      },
                                      {
                                        "groupId": "92356997",
                                        "addonId": "99261166"
                                      },
                                      {
                                        "groupId": "92356997",
                                        "addonId": "99261167"
                                      },
                                      {
                                        "groupId": "92356997",
                                        "addonId": "99261168"
                                      },
                                      {
                                        "groupId": "92356997",
                                        "addonId": "99261169"
                                      },
                                      {
                                        "groupId": "92356997",
                                        "addonId": "99261170"
                                      },
                                      {
                                        "groupId": "92356997",
                                        "addonId": "99261171"
                                      },
                                      {
                                        "groupId": "92356997",
                                        "addonId": "109683408"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235413",
                                        "variationId": "89120560"
                                      }
                                    ],
                                    "price": 35900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92356998",
                                        "addonId": "99261172"
                                      },
                                      {
                                        "groupId": "92356998",
                                        "addonId": "99261173"
                                      },
                                      {
                                        "groupId": "92356998",
                                        "addonId": "99261174"
                                      },
                                      {
                                        "groupId": "92356998",
                                        "addonId": "99261175"
                                      },
                                      {
                                        "groupId": "92356998",
                                        "addonId": "99261176"
                                      },
                                      {
                                        "groupId": "92356998",
                                        "addonId": "99261177"
                                      },
                                      {
                                        "groupId": "92356998",
                                        "addonId": "99261178"
                                      },
                                      {
                                        "groupId": "92356998",
                                        "addonId": "99261179"
                                      },
                                      {
                                        "groupId": "92356998",
                                        "addonId": "99261180"
                                      },
                                      {
                                        "groupId": "92356998",
                                        "addonId": "99261181"
                                      },
                                      {
                                        "groupId": "92356999",
                                        "addonId": "109683407"
                                      },
                                      {
                                        "groupId": "92356999",
                                        "addonId": "99261182"
                                      },
                                      {
                                        "groupId": "92356999",
                                        "addonId": "99261183"
                                      },
                                      {
                                        "groupId": "92356999",
                                        "addonId": "99261184"
                                      },
                                      {
                                        "groupId": "92356999",
                                        "addonId": "99261185"
                                      },
                                      {
                                        "groupId": "92356999",
                                        "addonId": "99261186"
                                      },
                                      {
                                        "groupId": "92356999",
                                        "addonId": "99261187"
                                      },
                                      {
                                        "groupId": "92356999",
                                        "addonId": "99261188"
                                      },
                                      {
                                        "groupId": "92356999",
                                        "addonId": "99261189"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235413",
                                        "variationId": "89120561"
                                      }
                                    ],
                                    "price": 54900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357001",
                                        "addonId": "109683409"
                                      },
                                      {
                                        "groupId": "92357001",
                                        "addonId": "99261200"
                                      },
                                      {
                                        "groupId": "92357001",
                                        "addonId": "99261201"
                                      },
                                      {
                                        "groupId": "92357001",
                                        "addonId": "99261202"
                                      },
                                      {
                                        "groupId": "92357001",
                                        "addonId": "99261203"
                                      },
                                      {
                                        "groupId": "92357001",
                                        "addonId": "99261204"
                                      },
                                      {
                                        "groupId": "92357001",
                                        "addonId": "99261205"
                                      },
                                      {
                                        "groupId": "92357001",
                                        "addonId": "99261206"
                                      },
                                      {
                                        "groupId": "92357001",
                                        "addonId": "99261207"
                                      },
                                      {
                                        "groupId": "92357000",
                                        "addonId": "99261190"
                                      },
                                      {
                                        "groupId": "92357000",
                                        "addonId": "99261191"
                                      },
                                      {
                                        "groupId": "92357000",
                                        "addonId": "99261192"
                                      },
                                      {
                                        "groupId": "92357000",
                                        "addonId": "99261193"
                                      },
                                      {
                                        "groupId": "92357000",
                                        "addonId": "99261194"
                                      },
                                      {
                                        "groupId": "92357000",
                                        "addonId": "99261195"
                                      },
                                      {
                                        "groupId": "92357000",
                                        "addonId": "99261196"
                                      },
                                      {
                                        "groupId": "92357000",
                                        "addonId": "99261197"
                                      },
                                      {
                                        "groupId": "92357000",
                                        "addonId": "99261198"
                                      },
                                      {
                                        "groupId": "92357000",
                                        "addonId": "99261199"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235413",
                                        "variationId": "93750703"
                                      }
                                    ],
                                    "price": 44900
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "92356996",
                                  "groupName": "extra Veg Toppings [regular]",
                                  "choices": [
                                    {
                                      "id": "99261155",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261156",
                                      "name": "Red Paprika",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261157",
                                      "name": "Corn",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261158",
                                      "name": "Mushroom",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261159",
                                      "name": "Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261160",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261161",
                                      "name": "Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261162",
                                      "name": "Pineapple",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261163",
                                      "name": "Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261164",
                                      "name": "Jalapenos",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "92356997",
                                  "groupName": "extra Non Veg Toppings [regular]",
                                  "choices": [
                                    {
                                      "id": "99261165",
                                      "name": "Chicken Ham",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261166",
                                      "name": "Chicken Sausage",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261167",
                                      "name": "Bbq Chicken",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261168",
                                      "name": "Pepperoni",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261169",
                                      "name": "Smoked Chicken Breast",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261170",
                                      "name": "Chicken Tikka",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261171",
                                      "name": "Chicken Meatballs",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683408",
                                      "name": "Chicken Seekh Kebab",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "92356998",
                                  "groupName": "extra Veg Toppings [medium]",
                                  "choices": [
                                    {
                                      "id": "99261172",
                                      "name": "Olive",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261173",
                                      "name": "Paneer",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261174",
                                      "name": "Red Paprika",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261175",
                                      "name": "Corn",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261176",
                                      "name": "Mushroom",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261177",
                                      "name": "Capsicum",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261178",
                                      "name": "Onion",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261179",
                                      "name": "Jalapeno",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261180",
                                      "name": "Cheese",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261181",
                                      "name": "Pineapple",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "92356999",
                                  "groupName": "extra Non Veg Toppings [medium]",
                                  "choices": [
                                    {
                                      "id": "109683407",
                                      "name": "Chicken Seekh Kebab",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261182",
                                      "name": "Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261183",
                                      "name": "Chicken Ham",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261184",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261185",
                                      "name": "Bbq Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261186",
                                      "name": "Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261187",
                                      "name": "Smoked Chicken Breast",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261188",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261189",
                                      "name": "Chicken Meatballs",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "92357000",
                                  "groupName": "extra Veg Toppings [large]",
                                  "choices": [
                                    {
                                      "id": "99261190",
                                      "name": "Paneer",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261191",
                                      "name": "Red Paprika",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261192",
                                      "name": "Corn",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261193",
                                      "name": "Mushroom",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261194",
                                      "name": "Capsicum",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261195",
                                      "name": "Onion",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261196",
                                      "name": "Jalapeno",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261197",
                                      "name": "Pineapple",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261198",
                                      "name": "Cheese",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261199",
                                      "name": "Olive",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "92357001",
                                  "groupName": "extra Non Veg Toppings [large]",
                                  "choices": [
                                    {
                                      "id": "109683409",
                                      "name": "Chicken Seekh Kebab",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261200",
                                      "name": "Cheese",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261201",
                                      "name": "Chicken Ham",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261202",
                                      "name": "Chicken Sausage",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261203",
                                      "name": "Bbq Chicken",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261204",
                                      "name": "Pepperoni",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261205",
                                      "name": "Smoked Chicken Breast",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261206",
                                      "name": "Chicken Tikka",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261207",
                                      "name": "Chicken Meatballs",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 14900,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "20 ratings",
                                  "ratingCountV2": "20"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116276989",
                              "name": "Pizza Roll",
                              "category": "Rolls @ Rs 99",
                              "description": "Secret Pizza recipe handrolled & Baked Desi Style",
                              "imageId": "urhnsqy27wycdiofnygw",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.5",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116276994",
                              "name": "Chicken Roll",
                              "category": "Rolls @ Rs 99",
                              "description": "Desi Style Chicken Tikka handrolled & Baked to perfection",
                              "imageId": "ur50bcsg5uazikmbfw3m",
                              "inStock": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "29995307",
                                    "name": "Preparation",
                                    "variations": [
                                      {
                                        "name": "Makhani Roll",
                                        "price": 169,
                                        "default": 1,
                                        "id": "93671434",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Korma Roll",
                                        "price": 169,
                                        "id": "93671435",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "29995307",
                                        "variationId": "93671434"
                                      }
                                    ],
                                    "price": 16900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "29995307",
                                        "variationId": "93671435"
                                      }
                                    ],
                                    "price": 16900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 16900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116276896",
                              "name": "Kadhai Paneer Tikka Pizza",
                              "category": "Desi Pizza ",
                              "description": "Generous chunks of Paneer marinated in Kadai Gravy sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                              "imageId": "ww58ck7qdyhkkrohkvqv",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "28235426",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular (7 Inch)",
                                        "price": 239,
                                        "default": 1,
                                        "id": "89120604",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium (11 Inch)",
                                        "price": 519,
                                        "id": "89120605",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large (14 Inch)",
                                        "price": 799,
                                        "id": "89120606",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium Cheese Blast (11 Inch.)",
                                        "price": 619,
                                        "id": "89120607",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235426",
                                        "variationId": "89120604"
                                      }
                                    ],
                                    "price": 23900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235426",
                                        "variationId": "89120605"
                                      }
                                    ],
                                    "price": 51900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357051",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235426",
                                        "variationId": "89120606"
                                      }
                                    ],
                                    "price": 79900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357051",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235426",
                                        "variationId": "89120607"
                                      }
                                    ],
                                    "price": 61900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357051",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "92357051",
                                  "groupName": "Four Cheese",
                                  "choices": [
                                    {
                                      "id": "99261208",
                                      "name": "Four Cheese",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 23900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116276948",
                              "name": "Reshmi Paneer Pizza",
                              "category": "Desi Pizza ",
                              "description": "Paneer, Roasted capsiucum  & caramalized Onion marinated in inhouse Tandoori Sauce sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                              "imageId": "xjiy3q2aowbpuhweidu2",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "28235429",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular (7 Inch)",
                                        "price": 239,
                                        "default": 1,
                                        "id": "89120616",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium (11 Inch)",
                                        "price": 519,
                                        "id": "89120617",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large (14 Inch)",
                                        "price": 799,
                                        "id": "89120618",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium Cheese Blast (11 Inch.)",
                                        "price": 619,
                                        "id": "89120619",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235429",
                                        "variationId": "89120616"
                                      }
                                    ],
                                    "price": 23900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235429",
                                        "variationId": "89120617"
                                      }
                                    ],
                                    "price": 51900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357054",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235429",
                                        "variationId": "89120618"
                                      }
                                    ],
                                    "price": 79900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357054",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235429",
                                        "variationId": "89120619"
                                      }
                                    ],
                                    "price": 61900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357054",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "92357054",
                                  "groupName": "Four Cheese",
                                  "choices": [
                                    {
                                      "id": "99261208",
                                      "name": "Four Cheese",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 23900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116720562",
                              "name": "Makhni Paneer Pizza",
                              "category": "Desi Pizza ",
                              "description": "Generous chunks of Paneer marinated in Makhni Gravy sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                              "imageId": "vaqjefojguo7vvuvjfs2",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "28235427",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular (7 Inch)",
                                        "price": 239,
                                        "default": 1,
                                        "id": "89120608",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium (11 Inch)",
                                        "price": 519,
                                        "id": "89120609",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large (14 Inch)",
                                        "price": 799,
                                        "id": "89120610",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium Cheese Blast (11 Inch.)",
                                        "price": 619,
                                        "id": "89120611",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235427",
                                        "variationId": "89120608"
                                      }
                                    ],
                                    "price": 23900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235427",
                                        "variationId": "89120609"
                                      }
                                    ],
                                    "price": 51900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357052",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235427",
                                        "variationId": "89120610"
                                      }
                                    ],
                                    "price": 79900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357052",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235427",
                                        "variationId": "89120611"
                                      }
                                    ],
                                    "price": 61900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357052",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "92357052",
                                  "groupName": "Four Cheese",
                                  "choices": [
                                    {
                                      "id": "99261208",
                                      "name": "Four Cheese",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 23900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116720563",
                              "name": "Paneer Lababdar",
                              "category": "Desi Pizza ",
                              "description": "Paneer & caramalized Onion marinated in inhouse Korma sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                              "imageId": "bgi4kqiiuvexhrtbdxif",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "28235428",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular (7 Inch)",
                                        "price": 239,
                                        "default": 1,
                                        "id": "89120612",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium (11 Inch)",
                                        "price": 519,
                                        "id": "89120613",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large (14 Inch)",
                                        "price": 799,
                                        "id": "89120614",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium Cheese Blast (11 Inch.)",
                                        "price": 619,
                                        "id": "89120615",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235428",
                                        "variationId": "89120612"
                                      }
                                    ],
                                    "price": 23900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235428",
                                        "variationId": "89120613"
                                      }
                                    ],
                                    "price": 51900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357053",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235428",
                                        "variationId": "89120614"
                                      }
                                    ],
                                    "price": 79900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357053",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235428",
                                        "variationId": "89120615"
                                      }
                                    ],
                                    "price": 61900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357053",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "92357053",
                                  "groupName": "Four Cheese",
                                  "choices": [
                                    {
                                      "id": "99261208",
                                      "name": "Four Cheese",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 23900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116276887",
                              "name": "Butter Chicken Pizza",
                              "category": "Desi Pizza ",
                              "description": "Chicken tikka  marinated in inhouse creamy, mildly tangy & rich Makhani Gravy sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                              "imageId": "mw6ug9gvo32sgzrthxve",
                              "inStock": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "28235431",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular (7 Inch)",
                                        "price": 259,
                                        "default": 1,
                                        "id": "89120624",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium (11 Inch)",
                                        "price": 589,
                                        "id": "89120625",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large (14 Inch)",
                                        "price": 849,
                                        "id": "89120626",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium Cheese Blast (11 Inch.)",
                                        "price": 689,
                                        "id": "89120627",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235431",
                                        "variationId": "89120624"
                                      }
                                    ],
                                    "price": 25900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235431",
                                        "variationId": "89120625"
                                      }
                                    ],
                                    "price": 58900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357056",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235431",
                                        "variationId": "89120626"
                                      }
                                    ],
                                    "price": 84900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357056",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235431",
                                        "variationId": "89120627"
                                      }
                                    ],
                                    "price": 68900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357056",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "92357056",
                                  "groupName": "Four Cheese",
                                  "choices": [
                                    {
                                      "id": "99261208",
                                      "name": "Four Cheese",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 25900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116276889",
                              "name": "Bhuna Murg Pizza",
                              "category": "Desi Pizza ",
                              "description": "Chicken Tikka marinated in inhouse Desi Butter Gravy, caramalised onion and capsicum sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                              "imageId": "zzv5gr7drxphytlf1rww",
                              "inStock": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "28235430",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular (7 Inch)",
                                        "price": 259,
                                        "default": 1,
                                        "id": "89120620",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium (11 Inch)",
                                        "price": 589,
                                        "id": "89120621",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large (14 Inch)",
                                        "price": 849,
                                        "id": "89120622",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium Cheese Blast (11 Inch.)",
                                        "price": 689,
                                        "id": "89120623",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235430",
                                        "variationId": "89120620"
                                      }
                                    ],
                                    "price": 25900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235430",
                                        "variationId": "89120621"
                                      }
                                    ],
                                    "price": 58900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357055",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235430",
                                        "variationId": "89120622"
                                      }
                                    ],
                                    "price": 84900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357055",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235430",
                                        "variationId": "89120623"
                                      }
                                    ],
                                    "price": 68900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357055",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "92357055",
                                  "groupName": "Four Cheese",
                                  "choices": [
                                    {
                                      "id": "99261208",
                                      "name": "Four Cheese",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 25900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116276959",
                              "name": "Chicken Lahori Pizza",
                              "category": "Desi Pizza ",
                              "description": "Smoked Chicken Breast &caramalized Onion marinated in Korma Gravy sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                              "imageId": "rloqcwcnufazxewop4ce",
                              "inStock": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "28235433",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular (7 Inch)",
                                        "price": 259,
                                        "default": 1,
                                        "id": "89120632",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium (11 Inch)",
                                        "price": 589,
                                        "id": "89120633",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large (14 Inch)",
                                        "price": 849,
                                        "id": "89120634",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium Cheese Blast (11 Inch.)",
                                        "price": 689,
                                        "id": "89120635",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235433",
                                        "variationId": "89120632"
                                      }
                                    ],
                                    "price": 25900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235433",
                                        "variationId": "89120633"
                                      }
                                    ],
                                    "price": 58900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357058",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235433",
                                        "variationId": "89120634"
                                      }
                                    ],
                                    "price": 84900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357058",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235433",
                                        "variationId": "89120635"
                                      }
                                    ],
                                    "price": 68900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357058",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "92357058",
                                  "groupName": "Four Cheese",
                                  "choices": [
                                    {
                                      "id": "99261208",
                                      "name": "Four Cheese",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 25900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116276980",
                              "name": "Chicken Labbabdar Pizza",
                              "category": "Desi Pizza ",
                              "description": "Chicken tikka and caramalised onion marinated in tandoori sauce sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                              "imageId": "axspkxfze0vyufzrvibn",
                              "inStock": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "28235432",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular (7 Inch)",
                                        "price": 259,
                                        "default": 1,
                                        "id": "89120628",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium (11 Inch)",
                                        "price": 589,
                                        "id": "89120629",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large (14 Inch)",
                                        "price": 849,
                                        "id": "89120630",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium Cheese Blast (11 Inch.)",
                                        "price": 689,
                                        "id": "89120631",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235432",
                                        "variationId": "89120628"
                                      }
                                    ],
                                    "price": 25900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235432",
                                        "variationId": "89120629"
                                      }
                                    ],
                                    "price": 58900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357057",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235432",
                                        "variationId": "89120630"
                                      }
                                    ],
                                    "price": 84900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357057",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235432",
                                        "variationId": "89120631"
                                      }
                                    ],
                                    "price": 68900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357057",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "92357057",
                                  "groupName": "Four Cheese",
                                  "choices": [
                                    {
                                      "id": "99261208",
                                      "name": "Four Cheese",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 25900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116276953",
                              "name": "Signature Peri Peri Pizza",
                              "category": "Special Pizza",
                              "description": "Must Try - Mexican Jalapeno, Roasted Capsicum& caramilized Onion marinated in inhouse Per-Peri secret sauce receipe sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                              "imageId": "bww833uqrpzdil7hkchc",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "28235482",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular (7 Inch)",
                                        "price": 299,
                                        "default": 1,
                                        "id": "89120824",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium (11 Inch)",
                                        "price": 609,
                                        "id": "89120825",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large (14 Inch)",
                                        "price": 889,
                                        "id": "89120826",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium Cheese Blast (11 Inch.)",
                                        "price": 709,
                                        "id": "89120827",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235482",
                                        "variationId": "89120824"
                                      }
                                    ],
                                    "price": 29900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235482",
                                        "variationId": "89120825"
                                      }
                                    ],
                                    "price": 60900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357073",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235482",
                                        "variationId": "89120826"
                                      }
                                    ],
                                    "price": 88900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357073",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235482",
                                        "variationId": "89120827"
                                      }
                                    ],
                                    "price": 70900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357073",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "92357073",
                                  "groupName": "Four Cheese",
                                  "choices": [
                                    {
                                      "id": "99261208",
                                      "name": "Four Cheese",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 29900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116276955",
                              "name": "Farm House Pizza",
                              "category": "Special Pizza",
                              "description": "American Golden Corn, Roasted Capsicum, Farm Mushroom & caramilized Onion marinated in inhouse Homemade Italian sauce receipe sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                              "imageId": "gw0essyrpryziioeerxa",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "28235480",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular (7 Inch)",
                                        "price": 299,
                                        "default": 1,
                                        "id": "89120816",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium (11 Inch)",
                                        "price": 609,
                                        "id": "89120817",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large (14 Inch)",
                                        "price": 889,
                                        "id": "89120818",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium Cheese Blast (11 Inch.)",
                                        "price": 709,
                                        "id": "89120819",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235480",
                                        "variationId": "89120816"
                                      }
                                    ],
                                    "price": 29900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235480",
                                        "variationId": "89120817"
                                      }
                                    ],
                                    "price": 60900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357071",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235480",
                                        "variationId": "89120818"
                                      }
                                    ],
                                    "price": 88900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357071",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235480",
                                        "variationId": "89120819"
                                      }
                                    ],
                                    "price": 70900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357071",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "92357071",
                                  "groupName": "Four Cheese",
                                  "choices": [
                                    {
                                      "id": "99261208",
                                      "name": "Four Cheese",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 29900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116720589",
                              "name": "Veg Overloaded Pizza",
                              "category": "Special Pizza",
                              "description": "BESTSELLER - Loaded with all veg premium toppings including Paneer, Red Paprika, Jalapeno, Black olives. Pineapple, Corn, Mushroom, Capsicum , Sweet Corn & Onion",
                              "imageId": "cqe2rrdjcyj8vzuydafd",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "28235483",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular (7 Inch)",
                                        "price": 299,
                                        "default": 1,
                                        "id": "89120828",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium (11 Inch)",
                                        "price": 609,
                                        "id": "89120829",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large (14 Inch)",
                                        "price": 889,
                                        "id": "89120830",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium Cheese Blast (11 Inch.)",
                                        "price": 709,
                                        "id": "89120831",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235483",
                                        "variationId": "89120828"
                                      }
                                    ],
                                    "price": 29900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357074",
                                        "addonId": "99261220"
                                      },
                                      {
                                        "groupId": "92357074",
                                        "addonId": "99261221"
                                      },
                                      {
                                        "groupId": "92357074",
                                        "addonId": "99261222"
                                      },
                                      {
                                        "groupId": "92357074",
                                        "addonId": "99261223"
                                      },
                                      {
                                        "groupId": "92357074",
                                        "addonId": "99261224"
                                      },
                                      {
                                        "groupId": "92357074",
                                        "addonId": "99261225"
                                      },
                                      {
                                        "groupId": "92357074",
                                        "addonId": "99261226"
                                      },
                                      {
                                        "groupId": "92357074",
                                        "addonId": "99261227"
                                      },
                                      {
                                        "groupId": "92357074",
                                        "addonId": "99261228"
                                      },
                                      {
                                        "groupId": "92357074",
                                        "addonId": "99261229"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235483",
                                        "variationId": "89120829"
                                      }
                                    ],
                                    "price": 60900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357075",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235483",
                                        "variationId": "89120830"
                                      }
                                    ],
                                    "price": 88900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357075",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235483",
                                        "variationId": "89120831"
                                      }
                                    ],
                                    "price": 70900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357075",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "92357074",
                                  "groupName": "Extra Veg Toppings [medium]",
                                  "choices": [
                                    {
                                      "id": "99261220",
                                      "name": "Cheese",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261221",
                                      "name": "Onion",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261222",
                                      "name": "Capsicum",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261223",
                                      "name": "Mushroom",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261224",
                                      "name": "Corn",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261225",
                                      "name": "Red Paprika",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261226",
                                      "name": "Paneer",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261227",
                                      "name": "Olive",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261228",
                                      "name": "Pineapple",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261229",
                                      "name": "Jalapeno",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "92357075",
                                  "groupName": "Four Cheese",
                                  "choices": [
                                    {
                                      "id": "99261208",
                                      "name": "Four Cheese",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 29900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116276942",
                              "name": "Smoked Delight Pizza",
                              "category": "Special Pizza",
                              "description": "Must Try - BBQ Chicken, Smoked Chicken Breast & Chicken Ham marinated in inhouse italian pizza sauce receipe sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                              "imageId": "mvd9dopbxleuu6lixnhm",
                              "inStock": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "28235489",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular (7 Inch)",
                                        "price": 329,
                                        "default": 1,
                                        "id": "89120852",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium (11 Inch)",
                                        "price": 639,
                                        "id": "89120853",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large (14 Inch)",
                                        "price": 919,
                                        "id": "89120854",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium Cheese Blast (11 Inch.)",
                                        "price": 739,
                                        "id": "89120855",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235489",
                                        "variationId": "89120852"
                                      }
                                    ],
                                    "price": 32900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235489",
                                        "variationId": "89120853"
                                      }
                                    ],
                                    "price": 63900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357081",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235489",
                                        "variationId": "89120854"
                                      }
                                    ],
                                    "price": 91900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357081",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235489",
                                        "variationId": "89120855"
                                      }
                                    ],
                                    "price": 73900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357081",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "92357081",
                                  "groupName": "Four Cheese",
                                  "choices": [
                                    {
                                      "id": "99261208",
                                      "name": "Four Cheese",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 32900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "type": "CATEGORY_TYPE_RECOMMENDED"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Eco Veg Pizza [regular/medium/large]",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116276916",
                              "name": "La Mushroom Pizza",
                              "category": "Eco Veg Pizza [regular/medium/large]",
                              "description": "Farm Mushroom  freshly baked Pizza with secret recipe cheesy, spicy & creamy jalapeno cheese sauce sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                              "imageId": "pxpt61trmyelbdtnwfhi",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "28235417",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular (7 Inch)",
                                        "price": 209,
                                        "default": 1,
                                        "id": "89120574",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium (11 Inch)",
                                        "price": 389,
                                        "id": "89120575",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large (14 Inch)",
                                        "price": 559,
                                        "id": "89120576",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium Cheese Blast (11 Inch.)",
                                        "price": 489,
                                        "id": "89120577",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235417",
                                        "variationId": "89120574"
                                      }
                                    ],
                                    "price": 20900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357008",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357008",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357008",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357008",
                                        "addonId": "99261219"
                                      },
                                      {
                                        "groupId": "92357009",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235417",
                                        "variationId": "89120575"
                                      }
                                    ],
                                    "price": 38900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357008",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357008",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357008",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357008",
                                        "addonId": "99261219"
                                      },
                                      {
                                        "groupId": "92357009",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235417",
                                        "variationId": "89120576"
                                      }
                                    ],
                                    "price": 55900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357008",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357008",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357008",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357008",
                                        "addonId": "99261219"
                                      },
                                      {
                                        "groupId": "92357009",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235417",
                                        "variationId": "89120577"
                                      }
                                    ],
                                    "price": 48900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357008",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357008",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357008",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357008",
                                        "addonId": "99261219"
                                      },
                                      {
                                        "groupId": "92357009",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "92357009",
                                  "groupName": "Four Cheese",
                                  "choices": [
                                    {
                                      "id": "99261208",
                                      "name": "Four Cheese",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "92357008",
                                  "groupName": "Add on",
                                  "choices": [
                                    {
                                      "id": "99261216",
                                      "name": "Virgin Mojito Mocktail",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261217",
                                      "name": "Stuffed Garlic Bread (jalapeno & Corn)",
                                      "price": 15800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261218",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261219",
                                      "name": "Blue Lagoon Mocktail",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 20900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116276928",
                              "name": "La Capsicum Pizza",
                              "category": "Eco Veg Pizza [regular/medium/large]",
                              "description": "Roasted capsicum freshly baked Pizza with secret recipe cheesy, spicy & creamy jalapeno cheese sauce sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                              "imageId": "f9jnsfm9hlpuepk3vwwb",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "28235414",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular (7 Inch)",
                                        "price": 209,
                                        "default": 1,
                                        "id": "89120562",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium (11 Inch)",
                                        "price": 389,
                                        "id": "89120563",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large (14 Inch)",
                                        "price": 559,
                                        "id": "89120564",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium Cheese Blast (11 Inch.)",
                                        "price": 489,
                                        "id": "89120565",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235414",
                                        "variationId": "89120562"
                                      }
                                    ],
                                    "price": 20900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357002",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357002",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357002",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357002",
                                        "addonId": "99261219"
                                      },
                                      {
                                        "groupId": "92357003",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235414",
                                        "variationId": "89120563"
                                      }
                                    ],
                                    "price": 38900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357002",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357002",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357002",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357002",
                                        "addonId": "99261219"
                                      },
                                      {
                                        "groupId": "92357003",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235414",
                                        "variationId": "89120564"
                                      }
                                    ],
                                    "price": 55900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357002",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357002",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357002",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357002",
                                        "addonId": "99261219"
                                      },
                                      {
                                        "groupId": "92357003",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235414",
                                        "variationId": "89120565"
                                      }
                                    ],
                                    "price": 48900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357002",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357002",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357002",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357002",
                                        "addonId": "99261219"
                                      },
                                      {
                                        "groupId": "92357003",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "92357003",
                                  "groupName": "Four Cheese",
                                  "choices": [
                                    {
                                      "id": "99261208",
                                      "name": "Four Cheese",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "92357002",
                                  "groupName": "Add on",
                                  "choices": [
                                    {
                                      "id": "99261216",
                                      "name": "Virgin Mojito Mocktail",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261217",
                                      "name": "Stuffed Garlic Bread (jalapeno & Corn)",
                                      "price": 15800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261218",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261219",
                                      "name": "Blue Lagoon Mocktail",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 20900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116276967",
                              "name": "La Onion Pizza",
                              "category": "Eco Veg Pizza [regular/medium/large]",
                              "description": "Caramalized onion freshly baked Pizza with secret recipe cheesy, spicy & creamy jalapeno cheese sauce sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                              "imageId": "wivta0yxoknuluwfldef",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "28235418",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular (7 Inch)",
                                        "price": 209,
                                        "default": 1,
                                        "id": "89120578",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium (11 Inch)",
                                        "price": 389,
                                        "id": "89120579",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large (14 Inch)",
                                        "price": 559,
                                        "id": "89120580",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium Cheese Blast (11 Inch.)",
                                        "price": 489,
                                        "id": "89120581",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235418",
                                        "variationId": "89120578"
                                      }
                                    ],
                                    "price": 20900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357010",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357010",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357010",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357010",
                                        "addonId": "99261219"
                                      },
                                      {
                                        "groupId": "92357011",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235418",
                                        "variationId": "89120579"
                                      }
                                    ],
                                    "price": 38900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357010",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357010",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357010",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357010",
                                        "addonId": "99261219"
                                      },
                                      {
                                        "groupId": "92357011",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235418",
                                        "variationId": "89120580"
                                      }
                                    ],
                                    "price": 55900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357010",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357010",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357010",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357010",
                                        "addonId": "99261219"
                                      },
                                      {
                                        "groupId": "92357011",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235418",
                                        "variationId": "89120581"
                                      }
                                    ],
                                    "price": 48900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357010",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357010",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357010",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357010",
                                        "addonId": "99261219"
                                      },
                                      {
                                        "groupId": "92357011",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "92357011",
                                  "groupName": "Four Cheese",
                                  "choices": [
                                    {
                                      "id": "99261208",
                                      "name": "Four Cheese",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "92357010",
                                  "groupName": "Add on",
                                  "choices": [
                                    {
                                      "id": "99261216",
                                      "name": "Virgin Mojito Mocktail",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261217",
                                      "name": "Stuffed Garlic Bread (jalapeno & Corn)",
                                      "price": 15800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261218",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261219",
                                      "name": "Blue Lagoon Mocktail",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 20900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116276974",
                              "name": "La Pineapple Pizza",
                              "category": "Eco Veg Pizza [regular/medium/large]",
                              "description": "Pineapple  freshly baked Pizza with secret recipe cheesy, spicy & creamy jalapeno cheese sauce sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                              "imageId": "db9b5df6469fe41bef11a7bf9b21a04d",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "28235416",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular (7 Inch)",
                                        "price": 209,
                                        "default": 1,
                                        "id": "89120570",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium (11 Inch)",
                                        "price": 389,
                                        "id": "89120571",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large (14 Inch)",
                                        "price": 559,
                                        "id": "89120572",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium Cheese Blast (11 Inch.)",
                                        "price": 489,
                                        "id": "89120573",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235416",
                                        "variationId": "89120570"
                                      }
                                    ],
                                    "price": 20900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357006",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357006",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357006",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357006",
                                        "addonId": "99261219"
                                      },
                                      {
                                        "groupId": "92357007",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235416",
                                        "variationId": "89120571"
                                      }
                                    ],
                                    "price": 38900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357006",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357006",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357006",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357006",
                                        "addonId": "99261219"
                                      },
                                      {
                                        "groupId": "92357007",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235416",
                                        "variationId": "89120572"
                                      }
                                    ],
                                    "price": 55900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357006",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357006",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357006",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357006",
                                        "addonId": "99261219"
                                      },
                                      {
                                        "groupId": "92357007",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235416",
                                        "variationId": "89120573"
                                      }
                                    ],
                                    "price": 48900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357006",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357006",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357006",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357006",
                                        "addonId": "99261219"
                                      },
                                      {
                                        "groupId": "92357007",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "92357007",
                                  "groupName": "Four Cheese",
                                  "choices": [
                                    {
                                      "id": "99261208",
                                      "name": "Four Cheese",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "92357006",
                                  "groupName": "Add on",
                                  "choices": [
                                    {
                                      "id": "99261216",
                                      "name": "Virgin Mojito Mocktail",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261217",
                                      "name": "Stuffed Garlic Bread (jalapeno & Corn)",
                                      "price": 15800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261218",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261219",
                                      "name": "Blue Lagoon Mocktail",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 20900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.2",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116276998",
                              "name": "La Golden Corn Pizza",
                              "category": "Eco Veg Pizza [regular/medium/large]",
                              "description": "Sweet & juicy golden corn  freshly baked Pizza with secret recipe cheesy, spicy & creamy jalapeno cheese sauce sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                              "imageId": "vu5oydmrjc00rhoep0nb",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "28235415",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular (7 Inch)",
                                        "price": 209,
                                        "default": 1,
                                        "id": "89120566",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium (11 Inch)",
                                        "price": 389,
                                        "id": "89120567",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large (14 Inch)",
                                        "price": 559,
                                        "id": "89120568",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium Cheese Blast (11 Inch.)",
                                        "price": 489,
                                        "id": "89120569",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235415",
                                        "variationId": "89120566"
                                      }
                                    ],
                                    "price": 20900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357004",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357004",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357004",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357004",
                                        "addonId": "99261219"
                                      },
                                      {
                                        "groupId": "92357005",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235415",
                                        "variationId": "89120567"
                                      }
                                    ],
                                    "price": 38900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357004",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357004",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357004",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357004",
                                        "addonId": "99261219"
                                      },
                                      {
                                        "groupId": "92357005",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235415",
                                        "variationId": "89120568"
                                      }
                                    ],
                                    "price": 55900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357004",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357004",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357004",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357004",
                                        "addonId": "99261219"
                                      },
                                      {
                                        "groupId": "92357005",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235415",
                                        "variationId": "89120569"
                                      }
                                    ],
                                    "price": 48900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357004",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357004",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357004",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357004",
                                        "addonId": "99261219"
                                      },
                                      {
                                        "groupId": "92357005",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "92357005",
                                  "groupName": "Four Cheese",
                                  "choices": [
                                    {
                                      "id": "99261208",
                                      "name": "Four Cheese",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "92357004",
                                  "groupName": "Add on",
                                  "choices": [
                                    {
                                      "id": "99261216",
                                      "name": "Virgin Mojito Mocktail",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261217",
                                      "name": "Stuffed Garlic Bread (jalapeno & Corn)",
                                      "price": 15800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261218",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261219",
                                      "name": "Blue Lagoon Mocktail",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 20900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.5",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Say ! Meat",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116276957",
                              "name": "La American Bbq Pizza",
                              "category": "Say ! Meat",
                              "description": "Roasted BBQ Cicken  freshly baked Pizza with secret recipe cheesy, spicy & creamy jalapeno cheese sauce sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                              "imageId": "wogbo7jawtard87tm7he",
                              "inStock": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "28235420",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular (7 Inch)",
                                        "price": 219,
                                        "default": 1,
                                        "id": "89120583",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium (11 Inch)",
                                        "price": 399,
                                        "id": "89120584",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large (14 Inch)",
                                        "price": 749,
                                        "id": "89120585",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium Cheese Blast (11 Inch.)",
                                        "price": 499,
                                        "id": "89120586",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235420",
                                        "variationId": "89120583"
                                      }
                                    ],
                                    "price": 21900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357013",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357013",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357013",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357013",
                                        "addonId": "99261219"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235420",
                                        "variationId": "89120584"
                                      }
                                    ],
                                    "price": 39900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357013",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357013",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357013",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357013",
                                        "addonId": "99261219"
                                      },
                                      {
                                        "groupId": "92357014",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235420",
                                        "variationId": "89120585"
                                      }
                                    ],
                                    "price": 74900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357013",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357013",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357013",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357013",
                                        "addonId": "99261219"
                                      },
                                      {
                                        "groupId": "92357014",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235420",
                                        "variationId": "89120586"
                                      }
                                    ],
                                    "price": 49900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357013",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357013",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357013",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357013",
                                        "addonId": "99261219"
                                      },
                                      {
                                        "groupId": "92357014",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "92357014",
                                  "groupName": "Four Cheese",
                                  "choices": [
                                    {
                                      "id": "99261208",
                                      "name": "Four Cheese",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "92357013",
                                  "groupName": "Add on",
                                  "choices": [
                                    {
                                      "id": "99261216",
                                      "name": "Virgin Mojito Mocktail",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261217",
                                      "name": "Stuffed Garlic Bread (jalapeno & Corn)",
                                      "price": 15800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261218",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261219",
                                      "name": "Blue Lagoon Mocktail",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 21900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "11 ratings",
                                  "ratingCountV2": "11"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116276987",
                              "name": "La Chicken Sausage Pizza",
                              "category": "Say ! Meat",
                              "description": "German recipe Chicken Sausage  freshly baked Pizza with secret recipe cheesy, spicy & creamy jalapeno cheese sauce sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                              "imageId": "ucpyvov4b3jek5oz4kus",
                              "inStock": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "28235423",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular (7 Inch)",
                                        "price": 219,
                                        "default": 1,
                                        "id": "89120595",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium (11 Inch)",
                                        "price": 399,
                                        "id": "89120596",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large (14 Inch)",
                                        "price": 749,
                                        "id": "89120597",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium Cheese Blast (11 Inch.)",
                                        "price": 499,
                                        "id": "89120598",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235423",
                                        "variationId": "89120595"
                                      }
                                    ],
                                    "price": 21900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357019",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357019",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357019",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357019",
                                        "addonId": "99261219"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235423",
                                        "variationId": "89120596"
                                      }
                                    ],
                                    "price": 39900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357019",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357019",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357019",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357019",
                                        "addonId": "99261219"
                                      },
                                      {
                                        "groupId": "92357020",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235423",
                                        "variationId": "89120597"
                                      }
                                    ],
                                    "price": 74900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357019",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357019",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357019",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357019",
                                        "addonId": "99261219"
                                      },
                                      {
                                        "groupId": "92357020",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235423",
                                        "variationId": "89120598"
                                      }
                                    ],
                                    "price": 49900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357019",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357019",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357019",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357019",
                                        "addonId": "99261219"
                                      },
                                      {
                                        "groupId": "92357020",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "92357020",
                                  "groupName": "Four Cheese",
                                  "choices": [
                                    {
                                      "id": "99261208",
                                      "name": "Four Cheese",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "92357019",
                                  "groupName": "Add on",
                                  "choices": [
                                    {
                                      "id": "99261216",
                                      "name": "Virgin Mojito Mocktail",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261217",
                                      "name": "Stuffed Garlic Bread (jalapeno & Corn)",
                                      "price": 15800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261218",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261219",
                                      "name": "Blue Lagoon Mocktail",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 21900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116276999",
                              "name": "La Chicken Meatball Pizza",
                              "category": "Say ! Meat",
                              "description": "Chicken Meatball freshly baked Pizza with secret recipe cheesy, spicy & creamy jalapeno cheese sauce sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                              "imageId": "vj7suncsgomvlkfol4hh",
                              "inStock": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "28235422",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular (7 Inch)",
                                        "price": 219,
                                        "default": 1,
                                        "id": "89120591",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium (11 Inch)",
                                        "price": 399,
                                        "id": "89120592",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large (14 Inch)",
                                        "price": 749,
                                        "id": "89120593",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium Cheese Blast (11 Inch.)",
                                        "price": 499,
                                        "id": "89120594",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235422",
                                        "variationId": "89120591"
                                      }
                                    ],
                                    "price": 21900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357017",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357017",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357017",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357017",
                                        "addonId": "99261219"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235422",
                                        "variationId": "89120592"
                                      }
                                    ],
                                    "price": 39900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357017",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357017",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357017",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357017",
                                        "addonId": "99261219"
                                      },
                                      {
                                        "groupId": "92357018",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235422",
                                        "variationId": "89120593"
                                      }
                                    ],
                                    "price": 74900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357017",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357017",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357017",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357017",
                                        "addonId": "99261219"
                                      },
                                      {
                                        "groupId": "92357018",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235422",
                                        "variationId": "89120594"
                                      }
                                    ],
                                    "price": 49900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357017",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357017",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357017",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357017",
                                        "addonId": "99261219"
                                      },
                                      {
                                        "groupId": "92357018",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "92357018",
                                  "groupName": "Four Cheese",
                                  "choices": [
                                    {
                                      "id": "99261208",
                                      "name": "Four Cheese",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "92357017",
                                  "groupName": "Add on",
                                  "choices": [
                                    {
                                      "id": "99261216",
                                      "name": "Virgin Mojito Mocktail",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261217",
                                      "name": "Stuffed Garlic Bread (jalapeno & Corn)",
                                      "price": 15800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261218",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261219",
                                      "name": "Blue Lagoon Mocktail",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 21900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116277011",
                              "name": "La Chicken Ham Pizza",
                              "category": "Say ! Meat",
                              "description": "Smoked Chicken Ham freshly baked Pizza with secret recipe cheesy, spicy & creamy jalapeno cheese sauce sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                              "imageId": "k3qdnfl4x5lypqqstpdk",
                              "inStock": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "28235421",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular (7 Inch)",
                                        "price": 219,
                                        "default": 1,
                                        "id": "89120587",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium (11 Inch)",
                                        "price": 399,
                                        "id": "89120588",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large (14 Inch)",
                                        "price": 749,
                                        "id": "89120589",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium Cheese Blast (11 Inch.)",
                                        "price": 499,
                                        "id": "89120590",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235421",
                                        "variationId": "89120587"
                                      }
                                    ],
                                    "price": 21900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357015",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357015",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357015",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357015",
                                        "addonId": "99261219"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235421",
                                        "variationId": "89120588"
                                      }
                                    ],
                                    "price": 39900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357015",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357015",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357015",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357015",
                                        "addonId": "99261219"
                                      },
                                      {
                                        "groupId": "92357016",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235421",
                                        "variationId": "89120589"
                                      }
                                    ],
                                    "price": 74900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357015",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357015",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357015",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357015",
                                        "addonId": "99261219"
                                      },
                                      {
                                        "groupId": "92357016",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235421",
                                        "variationId": "89120590"
                                      }
                                    ],
                                    "price": 49900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357015",
                                        "addonId": "99261216"
                                      },
                                      {
                                        "groupId": "92357015",
                                        "addonId": "99261217"
                                      },
                                      {
                                        "groupId": "92357015",
                                        "addonId": "99261218"
                                      },
                                      {
                                        "groupId": "92357015",
                                        "addonId": "99261219"
                                      },
                                      {
                                        "groupId": "92357016",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "92357016",
                                  "groupName": "Four Cheese",
                                  "choices": [
                                    {
                                      "id": "99261208",
                                      "name": "Four Cheese",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "92357015",
                                  "groupName": "Add on",
                                  "choices": [
                                    {
                                      "id": "99261216",
                                      "name": "Virgin Mojito Mocktail",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261217",
                                      "name": "Stuffed Garlic Bread (jalapeno & Corn)",
                                      "price": 15800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261218",
                                      "name": "Choco Lava Cake",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261219",
                                      "name": "Blue Lagoon Mocktail",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 21900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117642666",
                              "name": "La Chicken Seekh Pizza",
                              "category": "Say ! Meat",
                              "inStock": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "28672570",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular (7 Inch)",
                                        "price": 219,
                                        "default": 1,
                                        "id": "90307047",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium (11 Inch)",
                                        "price": 399,
                                        "id": "90307048",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium Cheese Blast (11 Inch)",
                                        "price": 499,
                                        "id": "90307049",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large (14 Inch)",
                                        "price": 749,
                                        "id": "90307050",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28672570",
                                        "variationId": "90307047"
                                      }
                                    ],
                                    "price": 21900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28672570",
                                        "variationId": "90307048"
                                      }
                                    ],
                                    "price": 39900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "94436354",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28672570",
                                        "variationId": "90307049"
                                      }
                                    ],
                                    "price": 49900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "94436354",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28672570",
                                        "variationId": "90307050"
                                      }
                                    ],
                                    "price": 74900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "94436354",
                                        "addonId": "99261208"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "94436354",
                                  "groupName": "Four Cheese",
                                  "choices": [
                                    {
                                      "id": "99261208",
                                      "name": "Four Cheese",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 21900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "127737018",
                              "name": "La Chicken Seekh Kebab Pizza",
                              "category": "Say ! Meat",
                              "description": "Chicken Seekh Freshly Baked Pizza With Secret Recipe Cheesy, Spicy & Creamy Jalapeno Cheese Sauce Sprinkled With 100% Mozarella Cheese And Served With Inhouse Chilli Flakes & Oregano Seasoning",
                              "inStock": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "34062726",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "price": 219,
                                        "default": 1,
                                        "id": "105261274",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 399,
                                        "id": "105261275",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium Cheese Blast",
                                        "price": 499,
                                        "id": "105261276",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "price": 749,
                                        "id": "105261277",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "34062726",
                                        "variationId": "105261274"
                                      }
                                    ],
                                    "price": 21900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "34062726",
                                        "variationId": "105261275"
                                      }
                                    ],
                                    "price": 39900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "34062726",
                                        "variationId": "105261276"
                                      }
                                    ],
                                    "price": 49900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "34062726",
                                        "variationId": "105261277"
                                      }
                                    ],
                                    "price": 74900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 21900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Say Cheese [regular/medium/large]",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116277010",
                              "name": "7 Types Of Cheese Pizza",
                              "category": "Say Cheese [regular/medium/large]",
                              "description": "7 Types Of Cheese Exotic Combination Baked Freshly To Perfection With Inhouse Italian Pizza Sauce & Served With Chilli Flakes & Oregano Seasoning",
                              "imageId": "c1cf54427a880530a70abeae704c2486",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "28235412",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular (7 Inch)",
                                        "price": 239,
                                        "default": 1,
                                        "id": "89120555",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium (11 Inch)",
                                        "price": 519,
                                        "id": "89120556",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large (14 Inch)",
                                        "price": 799,
                                        "id": "89120557",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium Cheese Blast (11 Inch.)",
                                        "price": 619,
                                        "id": "89120558",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235412",
                                        "variationId": "89120555"
                                      }
                                    ],
                                    "price": 23900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92356990",
                                        "addonId": "99261155"
                                      },
                                      {
                                        "groupId": "92356990",
                                        "addonId": "99261156"
                                      },
                                      {
                                        "groupId": "92356990",
                                        "addonId": "99261157"
                                      },
                                      {
                                        "groupId": "92356990",
                                        "addonId": "99261158"
                                      },
                                      {
                                        "groupId": "92356990",
                                        "addonId": "99261159"
                                      },
                                      {
                                        "groupId": "92356990",
                                        "addonId": "99261160"
                                      },
                                      {
                                        "groupId": "92356990",
                                        "addonId": "99261161"
                                      },
                                      {
                                        "groupId": "92356990",
                                        "addonId": "99261162"
                                      },
                                      {
                                        "groupId": "92356990",
                                        "addonId": "99261163"
                                      },
                                      {
                                        "groupId": "92356990",
                                        "addonId": "99261164"
                                      },
                                      {
                                        "groupId": "92356991",
                                        "addonId": "99261165"
                                      },
                                      {
                                        "groupId": "92356991",
                                        "addonId": "99261166"
                                      },
                                      {
                                        "groupId": "92356991",
                                        "addonId": "99261167"
                                      },
                                      {
                                        "groupId": "92356991",
                                        "addonId": "99261168"
                                      },
                                      {
                                        "groupId": "92356991",
                                        "addonId": "99261169"
                                      },
                                      {
                                        "groupId": "92356991",
                                        "addonId": "99261170"
                                      },
                                      {
                                        "groupId": "92356991",
                                        "addonId": "99261171"
                                      },
                                      {
                                        "groupId": "92356991",
                                        "addonId": "109683408"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235412",
                                        "variationId": "89120556"
                                      }
                                    ],
                                    "price": 51900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92356992",
                                        "addonId": "99261172"
                                      },
                                      {
                                        "groupId": "92356992",
                                        "addonId": "99261173"
                                      },
                                      {
                                        "groupId": "92356992",
                                        "addonId": "99261174"
                                      },
                                      {
                                        "groupId": "92356992",
                                        "addonId": "99261175"
                                      },
                                      {
                                        "groupId": "92356992",
                                        "addonId": "99261176"
                                      },
                                      {
                                        "groupId": "92356992",
                                        "addonId": "99261177"
                                      },
                                      {
                                        "groupId": "92356992",
                                        "addonId": "99261178"
                                      },
                                      {
                                        "groupId": "92356992",
                                        "addonId": "99261179"
                                      },
                                      {
                                        "groupId": "92356992",
                                        "addonId": "99261180"
                                      },
                                      {
                                        "groupId": "92356992",
                                        "addonId": "99261181"
                                      },
                                      {
                                        "groupId": "92356993",
                                        "addonId": "109683407"
                                      },
                                      {
                                        "groupId": "92356993",
                                        "addonId": "99261182"
                                      },
                                      {
                                        "groupId": "92356993",
                                        "addonId": "99261183"
                                      },
                                      {
                                        "groupId": "92356993",
                                        "addonId": "99261184"
                                      },
                                      {
                                        "groupId": "92356993",
                                        "addonId": "99261185"
                                      },
                                      {
                                        "groupId": "92356993",
                                        "addonId": "99261186"
                                      },
                                      {
                                        "groupId": "92356993",
                                        "addonId": "99261187"
                                      },
                                      {
                                        "groupId": "92356993",
                                        "addonId": "99261188"
                                      },
                                      {
                                        "groupId": "92356993",
                                        "addonId": "99261189"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235412",
                                        "variationId": "89120557"
                                      }
                                    ],
                                    "price": 79900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92356995",
                                        "addonId": "109683409"
                                      },
                                      {
                                        "groupId": "92356995",
                                        "addonId": "99261200"
                                      },
                                      {
                                        "groupId": "92356995",
                                        "addonId": "99261201"
                                      },
                                      {
                                        "groupId": "92356995",
                                        "addonId": "99261202"
                                      },
                                      {
                                        "groupId": "92356995",
                                        "addonId": "99261203"
                                      },
                                      {
                                        "groupId": "92356995",
                                        "addonId": "99261204"
                                      },
                                      {
                                        "groupId": "92356995",
                                        "addonId": "99261205"
                                      },
                                      {
                                        "groupId": "92356995",
                                        "addonId": "99261206"
                                      },
                                      {
                                        "groupId": "92356995",
                                        "addonId": "99261207"
                                      },
                                      {
                                        "groupId": "92356994",
                                        "addonId": "99261190"
                                      },
                                      {
                                        "groupId": "92356994",
                                        "addonId": "99261191"
                                      },
                                      {
                                        "groupId": "92356994",
                                        "addonId": "99261192"
                                      },
                                      {
                                        "groupId": "92356994",
                                        "addonId": "99261193"
                                      },
                                      {
                                        "groupId": "92356994",
                                        "addonId": "99261194"
                                      },
                                      {
                                        "groupId": "92356994",
                                        "addonId": "99261195"
                                      },
                                      {
                                        "groupId": "92356994",
                                        "addonId": "99261196"
                                      },
                                      {
                                        "groupId": "92356994",
                                        "addonId": "99261197"
                                      },
                                      {
                                        "groupId": "92356994",
                                        "addonId": "99261198"
                                      },
                                      {
                                        "groupId": "92356994",
                                        "addonId": "99261199"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235412",
                                        "variationId": "89120558"
                                      }
                                    ],
                                    "price": 61900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92356992",
                                        "addonId": "99261172"
                                      },
                                      {
                                        "groupId": "92356992",
                                        "addonId": "99261173"
                                      },
                                      {
                                        "groupId": "92356992",
                                        "addonId": "99261174"
                                      },
                                      {
                                        "groupId": "92356992",
                                        "addonId": "99261175"
                                      },
                                      {
                                        "groupId": "92356992",
                                        "addonId": "99261176"
                                      },
                                      {
                                        "groupId": "92356992",
                                        "addonId": "99261177"
                                      },
                                      {
                                        "groupId": "92356992",
                                        "addonId": "99261178"
                                      },
                                      {
                                        "groupId": "92356992",
                                        "addonId": "99261179"
                                      },
                                      {
                                        "groupId": "92356992",
                                        "addonId": "99261180"
                                      },
                                      {
                                        "groupId": "92356992",
                                        "addonId": "99261181"
                                      },
                                      {
                                        "groupId": "92356993",
                                        "addonId": "109683407"
                                      },
                                      {
                                        "groupId": "92356993",
                                        "addonId": "99261182"
                                      },
                                      {
                                        "groupId": "92356993",
                                        "addonId": "99261183"
                                      },
                                      {
                                        "groupId": "92356993",
                                        "addonId": "99261184"
                                      },
                                      {
                                        "groupId": "92356993",
                                        "addonId": "99261185"
                                      },
                                      {
                                        "groupId": "92356993",
                                        "addonId": "99261186"
                                      },
                                      {
                                        "groupId": "92356993",
                                        "addonId": "99261187"
                                      },
                                      {
                                        "groupId": "92356993",
                                        "addonId": "99261188"
                                      },
                                      {
                                        "groupId": "92356993",
                                        "addonId": "99261189"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "92356990",
                                  "groupName": "extra Veg Toppings [regular]",
                                  "choices": [
                                    {
                                      "id": "99261155",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261156",
                                      "name": "Red Paprika",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261157",
                                      "name": "Corn",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261158",
                                      "name": "Mushroom",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261159",
                                      "name": "Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261160",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261161",
                                      "name": "Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261162",
                                      "name": "Pineapple",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261163",
                                      "name": "Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261164",
                                      "name": "Jalapenos",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "92356991",
                                  "groupName": "extra Non Veg Toppings [regular]",
                                  "choices": [
                                    {
                                      "id": "99261165",
                                      "name": "Chicken Ham",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261166",
                                      "name": "Chicken Sausage",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261167",
                                      "name": "Bbq Chicken",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261168",
                                      "name": "Pepperoni",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261169",
                                      "name": "Smoked Chicken Breast",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261170",
                                      "name": "Chicken Tikka",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261171",
                                      "name": "Chicken Meatballs",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683408",
                                      "name": "Chicken Seekh Kebab",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "92356992",
                                  "groupName": "extra Veg Toppings [medium]",
                                  "choices": [
                                    {
                                      "id": "99261172",
                                      "name": "Olive",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261173",
                                      "name": "Paneer",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261174",
                                      "name": "Red Paprika",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261175",
                                      "name": "Corn",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261176",
                                      "name": "Mushroom",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261177",
                                      "name": "Capsicum",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261178",
                                      "name": "Onion",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261179",
                                      "name": "Jalapeno",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261180",
                                      "name": "Cheese",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261181",
                                      "name": "Pineapple",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "92356993",
                                  "groupName": "extra Non Veg Toppings [medium]",
                                  "choices": [
                                    {
                                      "id": "109683407",
                                      "name": "Chicken Seekh Kebab",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261182",
                                      "name": "Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261183",
                                      "name": "Chicken Ham",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261184",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261185",
                                      "name": "Bbq Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261186",
                                      "name": "Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261187",
                                      "name": "Smoked Chicken Breast",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261188",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261189",
                                      "name": "Chicken Meatballs",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "92356994",
                                  "groupName": "extra Veg Toppings [large]",
                                  "choices": [
                                    {
                                      "id": "99261190",
                                      "name": "Paneer",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261191",
                                      "name": "Red Paprika",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261192",
                                      "name": "Corn",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261193",
                                      "name": "Mushroom",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261194",
                                      "name": "Capsicum",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261195",
                                      "name": "Onion",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261196",
                                      "name": "Jalapeno",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261197",
                                      "name": "Pineapple",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261198",
                                      "name": "Cheese",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261199",
                                      "name": "Olive",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "92356995",
                                  "groupName": "extra Non Veg Toppings [large]",
                                  "choices": [
                                    {
                                      "id": "109683409",
                                      "name": "Chicken Seekh Kebab",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261200",
                                      "name": "Cheese",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261201",
                                      "name": "Chicken Ham",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261202",
                                      "name": "Chicken Sausage",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261203",
                                      "name": "Bbq Chicken",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261204",
                                      "name": "Pepperoni",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261205",
                                      "name": "Smoked Chicken Breast",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261206",
                                      "name": "Chicken Tikka",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261207",
                                      "name": "Chicken Meatballs",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 23900,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "21 ratings",
                                  "ratingCountV2": "21"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Make Ur Own @rs99",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116276905",
                              "name": "Margherita Pizza",
                              "category": "Make Ur Own @rs99",
                              "description": "Customize Your Way",
                              "imageId": "da8850c0e2d01a800cb646d614bfb838",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "28235413",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular (7 Inch)",
                                        "price": 149,
                                        "default": 1,
                                        "id": "89120559",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium (11 Inch)",
                                        "price": 359,
                                        "id": "89120560",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large (14 Inch)",
                                        "price": 549,
                                        "id": "89120561",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium Cheese Blast (11 Inch.)",
                                        "price": 449,
                                        "id": "93750703",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235413",
                                        "variationId": "89120559"
                                      }
                                    ],
                                    "price": 14900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92356996",
                                        "addonId": "99261155"
                                      },
                                      {
                                        "groupId": "92356996",
                                        "addonId": "99261156"
                                      },
                                      {
                                        "groupId": "92356996",
                                        "addonId": "99261157"
                                      },
                                      {
                                        "groupId": "92356996",
                                        "addonId": "99261158"
                                      },
                                      {
                                        "groupId": "92356996",
                                        "addonId": "99261159"
                                      },
                                      {
                                        "groupId": "92356996",
                                        "addonId": "99261160"
                                      },
                                      {
                                        "groupId": "92356996",
                                        "addonId": "99261161"
                                      },
                                      {
                                        "groupId": "92356996",
                                        "addonId": "99261162"
                                      },
                                      {
                                        "groupId": "92356996",
                                        "addonId": "99261163"
                                      },
                                      {
                                        "groupId": "92356996",
                                        "addonId": "99261164"
                                      },
                                      {
                                        "groupId": "92356997",
                                        "addonId": "99261165"
                                      },
                                      {
                                        "groupId": "92356997",
                                        "addonId": "99261166"
                                      },
                                      {
                                        "groupId": "92356997",
                                        "addonId": "99261167"
                                      },
                                      {
                                        "groupId": "92356997",
                                        "addonId": "99261168"
                                      },
                                      {
                                        "groupId": "92356997",
                                        "addonId": "99261169"
                                      },
                                      {
                                        "groupId": "92356997",
                                        "addonId": "99261170"
                                      },
                                      {
                                        "groupId": "92356997",
                                        "addonId": "99261171"
                                      },
                                      {
                                        "groupId": "92356997",
                                        "addonId": "109683408"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235413",
                                        "variationId": "89120560"
                                      }
                                    ],
                                    "price": 35900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92356998",
                                        "addonId": "99261172"
                                      },
                                      {
                                        "groupId": "92356998",
                                        "addonId": "99261173"
                                      },
                                      {
                                        "groupId": "92356998",
                                        "addonId": "99261174"
                                      },
                                      {
                                        "groupId": "92356998",
                                        "addonId": "99261175"
                                      },
                                      {
                                        "groupId": "92356998",
                                        "addonId": "99261176"
                                      },
                                      {
                                        "groupId": "92356998",
                                        "addonId": "99261177"
                                      },
                                      {
                                        "groupId": "92356998",
                                        "addonId": "99261178"
                                      },
                                      {
                                        "groupId": "92356998",
                                        "addonId": "99261179"
                                      },
                                      {
                                        "groupId": "92356998",
                                        "addonId": "99261180"
                                      },
                                      {
                                        "groupId": "92356998",
                                        "addonId": "99261181"
                                      },
                                      {
                                        "groupId": "92356999",
                                        "addonId": "109683407"
                                      },
                                      {
                                        "groupId": "92356999",
                                        "addonId": "99261182"
                                      },
                                      {
                                        "groupId": "92356999",
                                        "addonId": "99261183"
                                      },
                                      {
                                        "groupId": "92356999",
                                        "addonId": "99261184"
                                      },
                                      {
                                        "groupId": "92356999",
                                        "addonId": "99261185"
                                      },
                                      {
                                        "groupId": "92356999",
                                        "addonId": "99261186"
                                      },
                                      {
                                        "groupId": "92356999",
                                        "addonId": "99261187"
                                      },
                                      {
                                        "groupId": "92356999",
                                        "addonId": "99261188"
                                      },
                                      {
                                        "groupId": "92356999",
                                        "addonId": "99261189"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235413",
                                        "variationId": "89120561"
                                      }
                                    ],
                                    "price": 54900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "92357001",
                                        "addonId": "109683409"
                                      },
                                      {
                                        "groupId": "92357001",
                                        "addonId": "99261200"
                                      },
                                      {
                                        "groupId": "92357001",
                                        "addonId": "99261201"
                                      },
                                      {
                                        "groupId": "92357001",
                                        "addonId": "99261202"
                                      },
                                      {
                                        "groupId": "92357001",
                                        "addonId": "99261203"
                                      },
                                      {
                                        "groupId": "92357001",
                                        "addonId": "99261204"
                                      },
                                      {
                                        "groupId": "92357001",
                                        "addonId": "99261205"
                                      },
                                      {
                                        "groupId": "92357001",
                                        "addonId": "99261206"
                                      },
                                      {
                                        "groupId": "92357001",
                                        "addonId": "99261207"
                                      },
                                      {
                                        "groupId": "92357000",
                                        "addonId": "99261190"
                                      },
                                      {
                                        "groupId": "92357000",
                                        "addonId": "99261191"
                                      },
                                      {
                                        "groupId": "92357000",
                                        "addonId": "99261192"
                                      },
                                      {
                                        "groupId": "92357000",
                                        "addonId": "99261193"
                                      },
                                      {
                                        "groupId": "92357000",
                                        "addonId": "99261194"
                                      },
                                      {
                                        "groupId": "92357000",
                                        "addonId": "99261195"
                                      },
                                      {
                                        "groupId": "92357000",
                                        "addonId": "99261196"
                                      },
                                      {
                                        "groupId": "92357000",
                                        "addonId": "99261197"
                                      },
                                      {
                                        "groupId": "92357000",
                                        "addonId": "99261198"
                                      },
                                      {
                                        "groupId": "92357000",
                                        "addonId": "99261199"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28235413",
                                        "variationId": "93750703"
                                      }
                                    ],
                                    "price": 44900
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "92356996",
                                  "groupName": "extra Veg Toppings [regular]",
                                  "choices": [
                                    {
                                      "id": "99261155",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261156",
                                      "name": "Red Paprika",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261157",
                                      "name": "Corn",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261158",
                                      "name": "Mushroom",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261159",
                                      "name": "Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261160",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261161",
                                      "name": "Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261162",
                                      "name": "Pineapple",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261163",
                                      "name": "Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261164",
                                      "name": "Jalapenos",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "92356997",
                                  "groupName": "extra Non Veg Toppings [regular]",
                                  "choices": [
                                    {
                                      "id": "99261165",
                                      "name": "Chicken Ham",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261166",
                                      "name": "Chicken Sausage",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261167",
                                      "name": "Bbq Chicken",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261168",
                                      "name": "Pepperoni",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261169",
                                      "name": "Smoked Chicken Breast",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261170",
                                      "name": "Chicken Tikka",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261171",
                                      "name": "Chicken Meatballs",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683408",
                                      "name": "Chicken Seekh Kebab",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "92356998",
                                  "groupName": "extra Veg Toppings [medium]",
                                  "choices": [
                                    {
                                      "id": "99261172",
                                      "name": "Olive",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261173",
                                      "name": "Paneer",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261174",
                                      "name": "Red Paprika",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261175",
                                      "name": "Corn",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261176",
                                      "name": "Mushroom",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261177",
                                      "name": "Capsicum",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261178",
                                      "name": "Onion",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261179",
                                      "name": "Jalapeno",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261180",
                                      "name": "Cheese",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261181",
                                      "name": "Pineapple",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "92356999",
                                  "groupName": "extra Non Veg Toppings [medium]",
                                  "choices": [
                                    {
                                      "id": "109683407",
                                      "name": "Chicken Seekh Kebab",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261182",
                                      "name": "Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261183",
                                      "name": "Chicken Ham",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261184",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261185",
                                      "name": "Bbq Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261186",
                                      "name": "Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261187",
                                      "name": "Smoked Chicken Breast",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261188",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261189",
                                      "name": "Chicken Meatballs",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "92357000",
                                  "groupName": "extra Veg Toppings [large]",
                                  "choices": [
                                    {
                                      "id": "99261190",
                                      "name": "Paneer",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261191",
                                      "name": "Red Paprika",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261192",
                                      "name": "Corn",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261193",
                                      "name": "Mushroom",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261194",
                                      "name": "Capsicum",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261195",
                                      "name": "Onion",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261196",
                                      "name": "Jalapeno",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261197",
                                      "name": "Pineapple",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261198",
                                      "name": "Cheese",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261199",
                                      "name": "Olive",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "92357001",
                                  "groupName": "extra Non Veg Toppings [large]",
                                  "choices": [
                                    {
                                      "id": "109683409",
                                      "name": "Chicken Seekh Kebab",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261200",
                                      "name": "Cheese",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261201",
                                      "name": "Chicken Ham",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261202",
                                      "name": "Chicken Sausage",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261203",
                                      "name": "Bbq Chicken",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261204",
                                      "name": "Pepperoni",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261205",
                                      "name": "Smoked Chicken Breast",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261206",
                                      "name": "Chicken Tikka",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261207",
                                      "name": "Chicken Meatballs",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 14900,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "20 ratings",
                                  "ratingCountV2": "20"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "124389646",
                              "name": "Four Cheese Pizza",
                              "category": "Make Ur Own @rs99",
                              "description": "Super cheesy pizza offering best blend of Mozzarella, Cheddar, Monterey Jack and Colby cheese",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35945740",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "price": 149,
                                        "default": 1,
                                        "id": "111651079",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 449,
                                        "id": "111651080",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium Cheese Blast",
                                        "price": 559,
                                        "id": "111651081",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "price": 699,
                                        "id": "111651082",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35945740",
                                        "variationId": "111651079"
                                      }
                                    ],
                                    "price": 14900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "128740125",
                                        "addonId": "99261155"
                                      },
                                      {
                                        "groupId": "128740125",
                                        "addonId": "99261156"
                                      },
                                      {
                                        "groupId": "128740125",
                                        "addonId": "99261157"
                                      },
                                      {
                                        "groupId": "128740125",
                                        "addonId": "99261158"
                                      },
                                      {
                                        "groupId": "128740125",
                                        "addonId": "99261159"
                                      },
                                      {
                                        "groupId": "128740125",
                                        "addonId": "99261160"
                                      },
                                      {
                                        "groupId": "128740125",
                                        "addonId": "99261161"
                                      },
                                      {
                                        "groupId": "128740125",
                                        "addonId": "99261162"
                                      },
                                      {
                                        "groupId": "128740125",
                                        "addonId": "99261163"
                                      },
                                      {
                                        "groupId": "128740125",
                                        "addonId": "99261164"
                                      },
                                      {
                                        "groupId": "128740126",
                                        "addonId": "99261165"
                                      },
                                      {
                                        "groupId": "128740126",
                                        "addonId": "99261166"
                                      },
                                      {
                                        "groupId": "128740126",
                                        "addonId": "99261167"
                                      },
                                      {
                                        "groupId": "128740126",
                                        "addonId": "99261168"
                                      },
                                      {
                                        "groupId": "128740126",
                                        "addonId": "99261169"
                                      },
                                      {
                                        "groupId": "128740126",
                                        "addonId": "99261170"
                                      },
                                      {
                                        "groupId": "128740126",
                                        "addonId": "99261171"
                                      },
                                      {
                                        "groupId": "128740126",
                                        "addonId": "109683408"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35945740",
                                        "variationId": "111651080"
                                      }
                                    ],
                                    "price": 44900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "128740127",
                                        "addonId": "99261172"
                                      },
                                      {
                                        "groupId": "128740127",
                                        "addonId": "99261173"
                                      },
                                      {
                                        "groupId": "128740127",
                                        "addonId": "99261174"
                                      },
                                      {
                                        "groupId": "128740127",
                                        "addonId": "99261175"
                                      },
                                      {
                                        "groupId": "128740127",
                                        "addonId": "99261176"
                                      },
                                      {
                                        "groupId": "128740127",
                                        "addonId": "99261177"
                                      },
                                      {
                                        "groupId": "128740127",
                                        "addonId": "99261178"
                                      },
                                      {
                                        "groupId": "128740127",
                                        "addonId": "99261179"
                                      },
                                      {
                                        "groupId": "128740127",
                                        "addonId": "99261180"
                                      },
                                      {
                                        "groupId": "128740127",
                                        "addonId": "99261181"
                                      },
                                      {
                                        "groupId": "128740128",
                                        "addonId": "109683407"
                                      },
                                      {
                                        "groupId": "128740128",
                                        "addonId": "99261182"
                                      },
                                      {
                                        "groupId": "128740128",
                                        "addonId": "99261183"
                                      },
                                      {
                                        "groupId": "128740128",
                                        "addonId": "99261184"
                                      },
                                      {
                                        "groupId": "128740128",
                                        "addonId": "99261185"
                                      },
                                      {
                                        "groupId": "128740128",
                                        "addonId": "99261186"
                                      },
                                      {
                                        "groupId": "128740128",
                                        "addonId": "99261187"
                                      },
                                      {
                                        "groupId": "128740128",
                                        "addonId": "99261188"
                                      },
                                      {
                                        "groupId": "128740128",
                                        "addonId": "99261189"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35945740",
                                        "variationId": "111651081"
                                      }
                                    ],
                                    "price": 55900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "128740127",
                                        "addonId": "99261172"
                                      },
                                      {
                                        "groupId": "128740127",
                                        "addonId": "99261173"
                                      },
                                      {
                                        "groupId": "128740127",
                                        "addonId": "99261174"
                                      },
                                      {
                                        "groupId": "128740127",
                                        "addonId": "99261175"
                                      },
                                      {
                                        "groupId": "128740127",
                                        "addonId": "99261176"
                                      },
                                      {
                                        "groupId": "128740127",
                                        "addonId": "99261177"
                                      },
                                      {
                                        "groupId": "128740127",
                                        "addonId": "99261178"
                                      },
                                      {
                                        "groupId": "128740127",
                                        "addonId": "99261179"
                                      },
                                      {
                                        "groupId": "128740127",
                                        "addonId": "99261180"
                                      },
                                      {
                                        "groupId": "128740127",
                                        "addonId": "99261181"
                                      },
                                      {
                                        "groupId": "128740128",
                                        "addonId": "109683407"
                                      },
                                      {
                                        "groupId": "128740128",
                                        "addonId": "99261182"
                                      },
                                      {
                                        "groupId": "128740128",
                                        "addonId": "99261183"
                                      },
                                      {
                                        "groupId": "128740128",
                                        "addonId": "99261184"
                                      },
                                      {
                                        "groupId": "128740128",
                                        "addonId": "99261185"
                                      },
                                      {
                                        "groupId": "128740128",
                                        "addonId": "99261186"
                                      },
                                      {
                                        "groupId": "128740128",
                                        "addonId": "99261187"
                                      },
                                      {
                                        "groupId": "128740128",
                                        "addonId": "99261188"
                                      },
                                      {
                                        "groupId": "128740128",
                                        "addonId": "99261189"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35945740",
                                        "variationId": "111651082"
                                      }
                                    ],
                                    "price": 69900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "128740130",
                                        "addonId": "109683409"
                                      },
                                      {
                                        "groupId": "128740130",
                                        "addonId": "99261200"
                                      },
                                      {
                                        "groupId": "128740130",
                                        "addonId": "99261201"
                                      },
                                      {
                                        "groupId": "128740130",
                                        "addonId": "99261202"
                                      },
                                      {
                                        "groupId": "128740130",
                                        "addonId": "99261203"
                                      },
                                      {
                                        "groupId": "128740130",
                                        "addonId": "99261204"
                                      },
                                      {
                                        "groupId": "128740130",
                                        "addonId": "99261205"
                                      },
                                      {
                                        "groupId": "128740130",
                                        "addonId": "99261206"
                                      },
                                      {
                                        "groupId": "128740130",
                                        "addonId": "99261207"
                                      },
                                      {
                                        "groupId": "128740129",
                                        "addonId": "99261190"
                                      },
                                      {
                                        "groupId": "128740129",
                                        "addonId": "99261191"
                                      },
                                      {
                                        "groupId": "128740129",
                                        "addonId": "99261192"
                                      },
                                      {
                                        "groupId": "128740129",
                                        "addonId": "99261193"
                                      },
                                      {
                                        "groupId": "128740129",
                                        "addonId": "99261194"
                                      },
                                      {
                                        "groupId": "128740129",
                                        "addonId": "99261195"
                                      },
                                      {
                                        "groupId": "128740129",
                                        "addonId": "99261196"
                                      },
                                      {
                                        "groupId": "128740129",
                                        "addonId": "99261197"
                                      },
                                      {
                                        "groupId": "128740129",
                                        "addonId": "99261198"
                                      },
                                      {
                                        "groupId": "128740129",
                                        "addonId": "99261199"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "128740125",
                                  "groupName": "extra Veg Toppings [regular]",
                                  "choices": [
                                    {
                                      "id": "99261155",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261156",
                                      "name": "Red Paprika",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261157",
                                      "name": "Corn",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261158",
                                      "name": "Mushroom",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261159",
                                      "name": "Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261160",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261161",
                                      "name": "Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261162",
                                      "name": "Pineapple",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261163",
                                      "name": "Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261164",
                                      "name": "Jalapenos",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128740126",
                                  "groupName": "extra Non Veg Toppings [regular]",
                                  "choices": [
                                    {
                                      "id": "99261165",
                                      "name": "Chicken Ham",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261166",
                                      "name": "Chicken Sausage",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261167",
                                      "name": "Bbq Chicken",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261168",
                                      "name": "Pepperoni",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261169",
                                      "name": "Smoked Chicken Breast",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261170",
                                      "name": "Chicken Tikka",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261171",
                                      "name": "Chicken Meatballs",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683408",
                                      "name": "Chicken Seekh Kebab",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128740127",
                                  "groupName": "extra Veg Toppings [medium]",
                                  "choices": [
                                    {
                                      "id": "99261172",
                                      "name": "Olive",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261173",
                                      "name": "Paneer",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261174",
                                      "name": "Red Paprika",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261175",
                                      "name": "Corn",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261176",
                                      "name": "Mushroom",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261177",
                                      "name": "Capsicum",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261178",
                                      "name": "Onion",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261179",
                                      "name": "Jalapeno",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261180",
                                      "name": "Cheese",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261181",
                                      "name": "Pineapple",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128740128",
                                  "groupName": "extra Non Veg Toppings [medium]",
                                  "choices": [
                                    {
                                      "id": "109683407",
                                      "name": "Chicken Seekh Kebab",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261182",
                                      "name": "Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261183",
                                      "name": "Chicken Ham",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261184",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261185",
                                      "name": "Bbq Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261186",
                                      "name": "Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261187",
                                      "name": "Smoked Chicken Breast",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261188",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261189",
                                      "name": "Chicken Meatballs",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128740129",
                                  "groupName": "extra Veg Toppings [large]",
                                  "choices": [
                                    {
                                      "id": "99261190",
                                      "name": "Paneer",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261191",
                                      "name": "Red Paprika",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261192",
                                      "name": "Corn",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261193",
                                      "name": "Mushroom",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261194",
                                      "name": "Capsicum",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261195",
                                      "name": "Onion",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261196",
                                      "name": "Jalapeno",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261197",
                                      "name": "Pineapple",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261198",
                                      "name": "Cheese",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261199",
                                      "name": "Olive",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128740130",
                                  "groupName": "extra Non Veg Toppings [large]",
                                  "choices": [
                                    {
                                      "id": "109683409",
                                      "name": "Chicken Seekh Kebab",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261200",
                                      "name": "Cheese",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261201",
                                      "name": "Chicken Ham",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261202",
                                      "name": "Chicken Sausage",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261203",
                                      "name": "Bbq Chicken",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261204",
                                      "name": "Pepperoni",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261205",
                                      "name": "Smoked Chicken Breast",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261206",
                                      "name": "Chicken Tikka",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99261207",
                                      "name": "Chicken Meatballs",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 14900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Rolls @ Rs 99",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116276954",
                              "name": "Paneer Roll",
                              "category": "Rolls @ Rs 99",
                              "description": "Desi Style Paneer Tikka handrolled & Baked to perfection",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "29995097",
                                    "name": "Preparation",
                                    "variations": [
                                      {
                                        "name": "Makhani Roll",
                                        "price": 149,
                                        "default": 1,
                                        "id": "93670922",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Korma Roll",
                                        "price": 149,
                                        "id": "93670923",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "29995097",
                                        "variationId": "93670922"
                                      }
                                    ],
                                    "price": 14900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "29995097",
                                        "variationId": "93670923"
                                      }
                                    ],
                                    "price": 14900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 14900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116276989",
                              "name": "Pizza Roll",
                              "category": "Rolls @ Rs 99",
                              "description": "Secret Pizza recipe handrolled & Baked Desi Style",
                              "imageId": "urhnsqy27wycdiofnygw",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.5",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116276994",
                              "name": "Chicken Roll",
                              "category": "Rolls @ Rs 99",
                              "description": "Desi Style Chicken Tikka handrolled & Baked to perfection",
                              "imageId": "ur50bcsg5uazikmbfw3m",
                              "inStock": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "29995307",
                                    "name": "Preparation",
                                    "variations": [
                                      {
                                        "name": "Makhani Roll",
                                        "price": 169,
                                        "default": 1,
                                        "id": "93671434",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Korma Roll",
                                        "price": 169,
                                        "id": "93671435",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "29995307",
                                        "variationId": "93671434"
                                      }
                                    ],
                                    "price": 16900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "29995307",
                                        "variationId": "93671435"
                                      }
                                    ],
                                    "price": 16900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 16900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Sandwich",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "127736991",
                              "name": "Paneer Makhani Sandwich",
                              "category": "Sandwich",
                              "imageId": "e263f8ad1734779d36325c8be98a55d4",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "127736993",
                              "name": "Chicken Korma Sandwich",
                              "category": "Sandwich",
                              "imageId": "1ae942cabe98cb2ec30d0cb195c41a4c",
                              "inStock": 1,
                              "price": 15900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "127736994",
                              "name": "Chicken Makhani Sandwich",
                              "category": "Sandwich",
                              "imageId": "9e296814818c5dac0482177e384a2551",
                              "inStock": 1,
                              "price": 15900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "127736995",
                              "name": "Paneer Korma Sandwich",
                              "category": "Sandwich",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "127737015",
                              "name": "Pizza Sandwich",
                              "category": "Sandwich",
                              "imageId": "03212542d54bbe543f917f68d25e9220",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Desi Pizza ",
                      "categories": [
                        {
                          "title": "Desi Veg Pizza [regular/medium/large]",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116276896",
                                  "name": "Kadhai Paneer Tikka Pizza",
                                  "category": "Desi Pizza ",
                                  "description": "Generous chunks of Paneer marinated in Kadai Gravy sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                                  "imageId": "ww58ck7qdyhkkrohkvqv",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28235426",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Regular (7 Inch)",
                                            "price": 239,
                                            "default": 1,
                                            "id": "89120604",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium (11 Inch)",
                                            "price": 519,
                                            "id": "89120605",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large (14 Inch)",
                                            "price": 799,
                                            "id": "89120606",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium Cheese Blast (11 Inch.)",
                                            "price": 619,
                                            "id": "89120607",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235426",
                                            "variationId": "89120604"
                                          }
                                        ],
                                        "price": 23900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235426",
                                            "variationId": "89120605"
                                          }
                                        ],
                                        "price": 51900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357051",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235426",
                                            "variationId": "89120606"
                                          }
                                        ],
                                        "price": 79900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357051",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235426",
                                            "variationId": "89120607"
                                          }
                                        ],
                                        "price": 61900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357051",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "92357051",
                                      "groupName": "Four Cheese",
                                      "choices": [
                                        {
                                          "id": "99261208",
                                          "name": "Four Cheese",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 23900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116276948",
                                  "name": "Reshmi Paneer Pizza",
                                  "category": "Desi Pizza ",
                                  "description": "Paneer, Roasted capsiucum  & caramalized Onion marinated in inhouse Tandoori Sauce sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                                  "imageId": "xjiy3q2aowbpuhweidu2",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28235429",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Regular (7 Inch)",
                                            "price": 239,
                                            "default": 1,
                                            "id": "89120616",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium (11 Inch)",
                                            "price": 519,
                                            "id": "89120617",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large (14 Inch)",
                                            "price": 799,
                                            "id": "89120618",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium Cheese Blast (11 Inch.)",
                                            "price": 619,
                                            "id": "89120619",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235429",
                                            "variationId": "89120616"
                                          }
                                        ],
                                        "price": 23900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235429",
                                            "variationId": "89120617"
                                          }
                                        ],
                                        "price": 51900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357054",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235429",
                                            "variationId": "89120618"
                                          }
                                        ],
                                        "price": 79900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357054",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235429",
                                            "variationId": "89120619"
                                          }
                                        ],
                                        "price": 61900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357054",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "92357054",
                                      "groupName": "Four Cheese",
                                      "choices": [
                                        {
                                          "id": "99261208",
                                          "name": "Four Cheese",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 23900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116720562",
                                  "name": "Makhni Paneer Pizza",
                                  "category": "Desi Pizza ",
                                  "description": "Generous chunks of Paneer marinated in Makhni Gravy sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                                  "imageId": "vaqjefojguo7vvuvjfs2",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28235427",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Regular (7 Inch)",
                                            "price": 239,
                                            "default": 1,
                                            "id": "89120608",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium (11 Inch)",
                                            "price": 519,
                                            "id": "89120609",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large (14 Inch)",
                                            "price": 799,
                                            "id": "89120610",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium Cheese Blast (11 Inch.)",
                                            "price": 619,
                                            "id": "89120611",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235427",
                                            "variationId": "89120608"
                                          }
                                        ],
                                        "price": 23900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235427",
                                            "variationId": "89120609"
                                          }
                                        ],
                                        "price": 51900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357052",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235427",
                                            "variationId": "89120610"
                                          }
                                        ],
                                        "price": 79900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357052",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235427",
                                            "variationId": "89120611"
                                          }
                                        ],
                                        "price": 61900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357052",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "92357052",
                                      "groupName": "Four Cheese",
                                      "choices": [
                                        {
                                          "id": "99261208",
                                          "name": "Four Cheese",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 23900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116720563",
                                  "name": "Paneer Lababdar",
                                  "category": "Desi Pizza ",
                                  "description": "Paneer & caramalized Onion marinated in inhouse Korma sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                                  "imageId": "bgi4kqiiuvexhrtbdxif",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28235428",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Regular (7 Inch)",
                                            "price": 239,
                                            "default": 1,
                                            "id": "89120612",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium (11 Inch)",
                                            "price": 519,
                                            "id": "89120613",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large (14 Inch)",
                                            "price": 799,
                                            "id": "89120614",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium Cheese Blast (11 Inch.)",
                                            "price": 619,
                                            "id": "89120615",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235428",
                                            "variationId": "89120612"
                                          }
                                        ],
                                        "price": 23900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235428",
                                            "variationId": "89120613"
                                          }
                                        ],
                                        "price": 51900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357053",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235428",
                                            "variationId": "89120614"
                                          }
                                        ],
                                        "price": 79900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357053",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235428",
                                            "variationId": "89120615"
                                          }
                                        ],
                                        "price": 61900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357053",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "92357053",
                                      "groupName": "Four Cheese",
                                      "choices": [
                                        {
                                          "id": "99261208",
                                          "name": "Four Cheese",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 23900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Desi Non Veg Pizza",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116276887",
                                  "name": "Butter Chicken Pizza",
                                  "category": "Desi Pizza ",
                                  "description": "Chicken tikka  marinated in inhouse creamy, mildly tangy & rich Makhani Gravy sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                                  "imageId": "mw6ug9gvo32sgzrthxve",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28235431",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Regular (7 Inch)",
                                            "price": 259,
                                            "default": 1,
                                            "id": "89120624",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium (11 Inch)",
                                            "price": 589,
                                            "id": "89120625",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large (14 Inch)",
                                            "price": 849,
                                            "id": "89120626",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium Cheese Blast (11 Inch.)",
                                            "price": 689,
                                            "id": "89120627",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235431",
                                            "variationId": "89120624"
                                          }
                                        ],
                                        "price": 25900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235431",
                                            "variationId": "89120625"
                                          }
                                        ],
                                        "price": 58900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357056",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235431",
                                            "variationId": "89120626"
                                          }
                                        ],
                                        "price": 84900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357056",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235431",
                                            "variationId": "89120627"
                                          }
                                        ],
                                        "price": 68900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357056",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "92357056",
                                      "groupName": "Four Cheese",
                                      "choices": [
                                        {
                                          "id": "99261208",
                                          "name": "Four Cheese",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 25900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116276889",
                                  "name": "Bhuna Murg Pizza",
                                  "category": "Desi Pizza ",
                                  "description": "Chicken Tikka marinated in inhouse Desi Butter Gravy, caramalised onion and capsicum sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                                  "imageId": "zzv5gr7drxphytlf1rww",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28235430",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Regular (7 Inch)",
                                            "price": 259,
                                            "default": 1,
                                            "id": "89120620",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium (11 Inch)",
                                            "price": 589,
                                            "id": "89120621",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large (14 Inch)",
                                            "price": 849,
                                            "id": "89120622",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium Cheese Blast (11 Inch.)",
                                            "price": 689,
                                            "id": "89120623",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235430",
                                            "variationId": "89120620"
                                          }
                                        ],
                                        "price": 25900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235430",
                                            "variationId": "89120621"
                                          }
                                        ],
                                        "price": 58900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357055",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235430",
                                            "variationId": "89120622"
                                          }
                                        ],
                                        "price": 84900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357055",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235430",
                                            "variationId": "89120623"
                                          }
                                        ],
                                        "price": 68900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357055",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "92357055",
                                      "groupName": "Four Cheese",
                                      "choices": [
                                        {
                                          "id": "99261208",
                                          "name": "Four Cheese",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 25900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116276959",
                                  "name": "Chicken Lahori Pizza",
                                  "category": "Desi Pizza ",
                                  "description": "Smoked Chicken Breast &caramalized Onion marinated in Korma Gravy sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                                  "imageId": "rloqcwcnufazxewop4ce",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28235433",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Regular (7 Inch)",
                                            "price": 259,
                                            "default": 1,
                                            "id": "89120632",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium (11 Inch)",
                                            "price": 589,
                                            "id": "89120633",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large (14 Inch)",
                                            "price": 849,
                                            "id": "89120634",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium Cheese Blast (11 Inch.)",
                                            "price": 689,
                                            "id": "89120635",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235433",
                                            "variationId": "89120632"
                                          }
                                        ],
                                        "price": 25900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235433",
                                            "variationId": "89120633"
                                          }
                                        ],
                                        "price": 58900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357058",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235433",
                                            "variationId": "89120634"
                                          }
                                        ],
                                        "price": 84900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357058",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235433",
                                            "variationId": "89120635"
                                          }
                                        ],
                                        "price": 68900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357058",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "92357058",
                                      "groupName": "Four Cheese",
                                      "choices": [
                                        {
                                          "id": "99261208",
                                          "name": "Four Cheese",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 25900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116276980",
                                  "name": "Chicken Labbabdar Pizza",
                                  "category": "Desi Pizza ",
                                  "description": "Chicken tikka and caramalised onion marinated in tandoori sauce sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                                  "imageId": "axspkxfze0vyufzrvibn",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28235432",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Regular (7 Inch)",
                                            "price": 259,
                                            "default": 1,
                                            "id": "89120628",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium (11 Inch)",
                                            "price": 589,
                                            "id": "89120629",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large (14 Inch)",
                                            "price": 849,
                                            "id": "89120630",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium Cheese Blast (11 Inch.)",
                                            "price": 689,
                                            "id": "89120631",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235432",
                                            "variationId": "89120628"
                                          }
                                        ],
                                        "price": 25900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235432",
                                            "variationId": "89120629"
                                          }
                                        ],
                                        "price": 58900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357057",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235432",
                                            "variationId": "89120630"
                                          }
                                        ],
                                        "price": 84900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357057",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235432",
                                            "variationId": "89120631"
                                          }
                                        ],
                                        "price": 68900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357057",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "92357057",
                                      "groupName": "Four Cheese",
                                      "choices": [
                                        {
                                          "id": "99261208",
                                          "name": "Four Cheese",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 25900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "117642675",
                                  "name": "Kashmiri Kebab Pizza",
                                  "category": "Desi Pizza ",
                                  "description": "Chicken Kebab, Spicy Red Paprika & caramalized onion marinated in inhouse Kadhai Gravy sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                                  "imageId": "2d9b98846b8a063df4a94fd6724f4e63",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28672579",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Regular (7 Inch)",
                                            "price": 259,
                                            "default": 1,
                                            "id": "90307069",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium (11 Inch)",
                                            "price": 589,
                                            "id": "90307070",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium Cheese Blast (11 Inch)",
                                            "price": 689,
                                            "id": "90307071",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large (14 Inch)",
                                            "price": 849,
                                            "id": "90307072",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28672579",
                                            "variationId": "90307069"
                                          }
                                        ],
                                        "price": 25900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28672579",
                                            "variationId": "90307070"
                                          }
                                        ],
                                        "price": 58900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "94436368",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28672579",
                                            "variationId": "90307071"
                                          }
                                        ],
                                        "price": 68900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "94436368",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28672579",
                                            "variationId": "90307072"
                                          }
                                        ],
                                        "price": 84900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "94436368",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "94436368",
                                      "groupName": "Four Cheese",
                                      "choices": [
                                        {
                                          "id": "99261208",
                                          "name": "Four Cheese",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 25900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "117642679",
                                  "name": "Kadhai Chicken Pizza",
                                  "category": "Desi Pizza ",
                                  "description": "Chicken tikka, Redpaprika and caramalised onion marinated in kadhai saue sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28672586",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Regular (7 Inch)",
                                            "price": 259,
                                            "default": 1,
                                            "id": "90307087",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium (11 Inch)",
                                            "price": 589,
                                            "id": "90307088",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium Cheese Blast (11 Inch)",
                                            "price": 689,
                                            "id": "90307089",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large (14 Inch)",
                                            "price": 849,
                                            "id": "90307090",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28672586",
                                            "variationId": "90307087"
                                          }
                                        ],
                                        "price": 25900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28672586",
                                            "variationId": "90307088"
                                          }
                                        ],
                                        "price": 58900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "94436378",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28672586",
                                            "variationId": "90307089"
                                          }
                                        ],
                                        "price": 68900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "94436378",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28672586",
                                            "variationId": "90307090"
                                          }
                                        ],
                                        "price": 84900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "94436378",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "94436378",
                                      "groupName": "Four Cheese",
                                      "choices": [
                                        {
                                          "id": "99261208",
                                          "name": "Four Cheese",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 25900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Special Pizza",
                      "categories": [
                        {
                          "title": "Premium Veg Pizza [regular/medium/large]",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116276953",
                                  "name": "Signature Peri Peri Pizza",
                                  "category": "Special Pizza",
                                  "description": "Must Try - Mexican Jalapeno, Roasted Capsicum& caramilized Onion marinated in inhouse Per-Peri secret sauce receipe sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                                  "imageId": "bww833uqrpzdil7hkchc",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28235482",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Regular (7 Inch)",
                                            "price": 299,
                                            "default": 1,
                                            "id": "89120824",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium (11 Inch)",
                                            "price": 609,
                                            "id": "89120825",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large (14 Inch)",
                                            "price": 889,
                                            "id": "89120826",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium Cheese Blast (11 Inch.)",
                                            "price": 709,
                                            "id": "89120827",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235482",
                                            "variationId": "89120824"
                                          }
                                        ],
                                        "price": 29900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235482",
                                            "variationId": "89120825"
                                          }
                                        ],
                                        "price": 60900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357073",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235482",
                                            "variationId": "89120826"
                                          }
                                        ],
                                        "price": 88900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357073",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235482",
                                            "variationId": "89120827"
                                          }
                                        ],
                                        "price": 70900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357073",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "92357073",
                                      "groupName": "Four Cheese",
                                      "choices": [
                                        {
                                          "id": "99261208",
                                          "name": "Four Cheese",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 29900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116276955",
                                  "name": "Farm House Pizza",
                                  "category": "Special Pizza",
                                  "description": "American Golden Corn, Roasted Capsicum, Farm Mushroom & caramilized Onion marinated in inhouse Homemade Italian sauce receipe sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                                  "imageId": "gw0essyrpryziioeerxa",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28235480",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Regular (7 Inch)",
                                            "price": 299,
                                            "default": 1,
                                            "id": "89120816",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium (11 Inch)",
                                            "price": 609,
                                            "id": "89120817",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large (14 Inch)",
                                            "price": 889,
                                            "id": "89120818",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium Cheese Blast (11 Inch.)",
                                            "price": 709,
                                            "id": "89120819",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235480",
                                            "variationId": "89120816"
                                          }
                                        ],
                                        "price": 29900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235480",
                                            "variationId": "89120817"
                                          }
                                        ],
                                        "price": 60900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357071",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235480",
                                            "variationId": "89120818"
                                          }
                                        ],
                                        "price": 88900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357071",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235480",
                                            "variationId": "89120819"
                                          }
                                        ],
                                        "price": 70900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357071",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "92357071",
                                      "groupName": "Four Cheese",
                                      "choices": [
                                        {
                                          "id": "99261208",
                                          "name": "Four Cheese",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 29900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116276969",
                                  "name": "Mexican Veg Pizza",
                                  "category": "Special Pizza",
                                  "description": "Imported Mexican Jalapeno with caramilized Onion & Pineapple marinated in Peri-Peri spicy secret sauce receipe sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                                  "imageId": "ltnsfp151ntiotfwpuap",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28235481",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Regular (7 Inch)",
                                            "price": 299,
                                            "default": 1,
                                            "id": "89120820",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium (11 Inch)",
                                            "price": 609,
                                            "id": "89120821",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large (14 Inch)",
                                            "price": 889,
                                            "id": "89120822",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium Cheese Blast (11 Inch.)",
                                            "price": 709,
                                            "id": "89120823",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235481",
                                            "variationId": "89120820"
                                          }
                                        ],
                                        "price": 29900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235481",
                                            "variationId": "89120821"
                                          }
                                        ],
                                        "price": 60900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357072",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235481",
                                            "variationId": "89120822"
                                          }
                                        ],
                                        "price": 88900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357072",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235481",
                                            "variationId": "89120823"
                                          }
                                        ],
                                        "price": 70900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357072",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "92357072",
                                      "groupName": "Four Cheese",
                                      "choices": [
                                        {
                                          "id": "99261208",
                                          "name": "Four Cheese",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 29900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116276971",
                                  "name": "Veggie Delight Pizza",
                                  "category": "Special Pizza",
                                  "description": "Recomended - Paneer, Roasted Capsicum, Farm Mushroom & caramilized Onion marinated in Homkemade italian sauce sauce receipe sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                                  "imageId": "n2x4wuhlqhmal7abp19a",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28235484",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Regular (7 Inch)",
                                            "price": 299,
                                            "default": 1,
                                            "id": "89120832",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium (11 Inch)",
                                            "price": 609,
                                            "id": "89120833",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large (14 Inch)",
                                            "price": 889,
                                            "id": "89120834",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium Cheese Blast (11 Inch.)",
                                            "price": 709,
                                            "id": "89120835",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235484",
                                            "variationId": "89120832"
                                          }
                                        ],
                                        "price": 29900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235484",
                                            "variationId": "89120833"
                                          }
                                        ],
                                        "price": 60900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357076",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235484",
                                            "variationId": "89120834"
                                          }
                                        ],
                                        "price": 88900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357076",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235484",
                                            "variationId": "89120835"
                                          }
                                        ],
                                        "price": 70900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357076",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "92357076",
                                      "groupName": "Four Cheese",
                                      "choices": [
                                        {
                                          "id": "99261208",
                                          "name": "Four Cheese",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 29900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116720589",
                                  "name": "Veg Overloaded Pizza",
                                  "category": "Special Pizza",
                                  "description": "BESTSELLER - Loaded with all veg premium toppings including Paneer, Red Paprika, Jalapeno, Black olives. Pineapple, Corn, Mushroom, Capsicum , Sweet Corn & Onion",
                                  "imageId": "cqe2rrdjcyj8vzuydafd",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28235483",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Regular (7 Inch)",
                                            "price": 299,
                                            "default": 1,
                                            "id": "89120828",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium (11 Inch)",
                                            "price": 609,
                                            "id": "89120829",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large (14 Inch)",
                                            "price": 889,
                                            "id": "89120830",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium Cheese Blast (11 Inch.)",
                                            "price": 709,
                                            "id": "89120831",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235483",
                                            "variationId": "89120828"
                                          }
                                        ],
                                        "price": 29900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357074",
                                            "addonId": "99261220"
                                          },
                                          {
                                            "groupId": "92357074",
                                            "addonId": "99261221"
                                          },
                                          {
                                            "groupId": "92357074",
                                            "addonId": "99261222"
                                          },
                                          {
                                            "groupId": "92357074",
                                            "addonId": "99261223"
                                          },
                                          {
                                            "groupId": "92357074",
                                            "addonId": "99261224"
                                          },
                                          {
                                            "groupId": "92357074",
                                            "addonId": "99261225"
                                          },
                                          {
                                            "groupId": "92357074",
                                            "addonId": "99261226"
                                          },
                                          {
                                            "groupId": "92357074",
                                            "addonId": "99261227"
                                          },
                                          {
                                            "groupId": "92357074",
                                            "addonId": "99261228"
                                          },
                                          {
                                            "groupId": "92357074",
                                            "addonId": "99261229"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235483",
                                            "variationId": "89120829"
                                          }
                                        ],
                                        "price": 60900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357075",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235483",
                                            "variationId": "89120830"
                                          }
                                        ],
                                        "price": 88900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357075",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235483",
                                            "variationId": "89120831"
                                          }
                                        ],
                                        "price": 70900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357075",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "92357074",
                                      "groupName": "Extra Veg Toppings [medium]",
                                      "choices": [
                                        {
                                          "id": "99261220",
                                          "name": "Cheese",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99261221",
                                          "name": "Onion",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99261222",
                                          "name": "Capsicum",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99261223",
                                          "name": "Mushroom",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99261224",
                                          "name": "Corn",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99261225",
                                          "name": "Red Paprika",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99261226",
                                          "name": "Paneer",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99261227",
                                          "name": "Olive",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99261228",
                                          "name": "Pineapple",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99261229",
                                          "name": "Jalapeno",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "92357075",
                                      "groupName": "Four Cheese",
                                      "choices": [
                                        {
                                          "id": "99261208",
                                          "name": "Four Cheese",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 29900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.7",
                                      "ratingCount": "7 ratings",
                                      "ratingCountV2": "7"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Premium Non Veg Pizza [d]",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116276942",
                                  "name": "Smoked Delight Pizza",
                                  "category": "Special Pizza",
                                  "description": "Must Try - BBQ Chicken, Smoked Chicken Breast & Chicken Ham marinated in inhouse italian pizza sauce receipe sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                                  "imageId": "mvd9dopbxleuu6lixnhm",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28235489",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Regular (7 Inch)",
                                            "price": 329,
                                            "default": 1,
                                            "id": "89120852",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium (11 Inch)",
                                            "price": 639,
                                            "id": "89120853",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large (14 Inch)",
                                            "price": 919,
                                            "id": "89120854",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium Cheese Blast (11 Inch.)",
                                            "price": 739,
                                            "id": "89120855",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235489",
                                            "variationId": "89120852"
                                          }
                                        ],
                                        "price": 32900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235489",
                                            "variationId": "89120853"
                                          }
                                        ],
                                        "price": 63900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357081",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235489",
                                            "variationId": "89120854"
                                          }
                                        ],
                                        "price": 91900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357081",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235489",
                                            "variationId": "89120855"
                                          }
                                        ],
                                        "price": 73900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357081",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "92357081",
                                      "groupName": "Four Cheese",
                                      "choices": [
                                        {
                                          "id": "99261208",
                                          "name": "Four Cheese",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 32900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116276961",
                                  "name": "Big Meaty Pizza",
                                  "category": "Special Pizza",
                                  "description": "BBQ Chicken, Smoked Chicken Breast & caramalized Onion marinated in inhouse  secret korma sauce receipe sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                                  "imageId": "cdsfflkkdzubmhvxuuwn",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28235485",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Regular (7 Inch)",
                                            "price": 329,
                                            "default": 1,
                                            "id": "89120836",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium (11 Inch)",
                                            "price": 639,
                                            "id": "89120837",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large (14 Inch)",
                                            "price": 919,
                                            "id": "89120838",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium Cheese Blast (11 Inch.)",
                                            "price": 739,
                                            "id": "89120839",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235485",
                                            "variationId": "89120836"
                                          }
                                        ],
                                        "price": 32900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235485",
                                            "variationId": "89120837"
                                          }
                                        ],
                                        "price": 63900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357077",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235485",
                                            "variationId": "89120838"
                                          }
                                        ],
                                        "price": 91900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357077",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235485",
                                            "variationId": "89120839"
                                          }
                                        ],
                                        "price": 73900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357077",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "92357077",
                                      "groupName": "Four Cheese",
                                      "choices": [
                                        {
                                          "id": "99261208",
                                          "name": "Four Cheese",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 32900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116720590",
                                  "name": "Mexican Nonveg Pizza",
                                  "category": "Special Pizza",
                                  "description": "Smoked Chicken Breast, Mexican Jalapeno & Redpaprika & Golden Corn marinated in spicy Peri-peri secret sauce receipe sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                                  "imageId": "ivqbxgdoz9mrady0veog",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28235487",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Regular (7 Inch)",
                                            "price": 329,
                                            "default": 1,
                                            "id": "89120844",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium (11 Inch)",
                                            "price": 639,
                                            "id": "89120845",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large (14 Inch)",
                                            "price": 919,
                                            "id": "89120846",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium Cheese Blast (11 Inch.)",
                                            "price": 739,
                                            "id": "89120847",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235487",
                                            "variationId": "89120844"
                                          }
                                        ],
                                        "price": 32900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235487",
                                            "variationId": "89120845"
                                          }
                                        ],
                                        "price": 63900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357079",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235487",
                                            "variationId": "89120846"
                                          }
                                        ],
                                        "price": 91900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357079",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235487",
                                            "variationId": "89120847"
                                          }
                                        ],
                                        "price": 73900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357079",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "92357079",
                                      "groupName": "Four Cheese",
                                      "choices": [
                                        {
                                          "id": "99261208",
                                          "name": "Four Cheese",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 32900,
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116720591",
                                  "name": "Non Veg Overloaded Pizza",
                                  "category": "Special Pizza",
                                  "description": "BESTSELLER - Loaded with all chicken premium toppings including BBQ Chicken, Smoked Chicken Breast, Chicken Ham, Chicken Meat Balls & Chicken Tikka",
                                  "imageId": "nedfettmp7ditqdca4vd",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28235488",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Regular (7 Inch)",
                                            "price": 329,
                                            "default": 1,
                                            "id": "89120848",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium (11 Inch)",
                                            "price": 639,
                                            "id": "89120849",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large (14 Inch)",
                                            "price": 919,
                                            "id": "89120850",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium Cheese Blast (11 Inch.)",
                                            "price": 739,
                                            "id": "89120851",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235488",
                                            "variationId": "89120848"
                                          }
                                        ],
                                        "price": 32900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235488",
                                            "variationId": "89120849"
                                          }
                                        ],
                                        "price": 63900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357080",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235488",
                                            "variationId": "89120850"
                                          }
                                        ],
                                        "price": 91900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357080",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235488",
                                            "variationId": "89120851"
                                          }
                                        ],
                                        "price": 73900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357080",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "92357080",
                                      "groupName": "Four Cheese",
                                      "choices": [
                                        {
                                          "id": "99261208",
                                          "name": "Four Cheese",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 32900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.5",
                                      "ratingCount": "6 ratings",
                                      "ratingCountV2": "6"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "117642668",
                                  "name": "Exotic Chicken Pizza",
                                  "category": "Special Pizza",
                                  "description": "Recomended - Chicken seekh kebab, BBQ Chicken, Red paprika, Jalapeno & onion marinated in Italian Sauce sauce receipe sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                                  "imageId": "5b0da76046d2a2002dfbdce38b1f861b",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28672573",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Regular (7 Inch)",
                                            "price": 329,
                                            "default": 1,
                                            "id": "90307055",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium (11 Inch)",
                                            "price": 639,
                                            "id": "90307056",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium Cheese Blast (11 Inch)",
                                            "price": 739,
                                            "id": "90307057",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large (14 Inch)",
                                            "price": 919,
                                            "id": "90307058",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28672573",
                                            "variationId": "90307055"
                                          }
                                        ],
                                        "price": 32900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28672573",
                                            "variationId": "90307056"
                                          }
                                        ],
                                        "price": 63900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "94436357",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28672573",
                                            "variationId": "90307057"
                                          }
                                        ],
                                        "price": 73900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "94436357",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28672573",
                                            "variationId": "90307058"
                                          }
                                        ],
                                        "price": 91900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "94436357",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "94436357",
                                      "groupName": "Four Cheese",
                                      "choices": [
                                        {
                                          "id": "99261208",
                                          "name": "Four Cheese",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 32900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Exotic Veg Pizza",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116276904",
                                  "name": "Paneer Delight Pizza",
                                  "category": "Special Pizza",
                                  "description": "Best Seller - Chunks of Paneer, Caramalized Onion & Crispy Capsicim freshly baked Pizza with home made Italian Pizza Sauce sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                                  "imageId": "rctaav5wnamxw1totkac",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28235468",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Regular (7 Inch)",
                                            "price": 269,
                                            "default": 1,
                                            "id": "89120770",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium (11 Inch)",
                                            "price": 569,
                                            "id": "89120771",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large (14 Inch)",
                                            "price": 819,
                                            "id": "89120772",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium Cheese Blast (11 Inch.)",
                                            "price": 669,
                                            "id": "89120773",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235468",
                                            "variationId": "89120770"
                                          }
                                        ],
                                        "price": 26900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235468",
                                            "variationId": "89120771"
                                          }
                                        ],
                                        "price": 56900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235468",
                                            "variationId": "89120772"
                                          }
                                        ],
                                        "price": 81900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235468",
                                            "variationId": "89120773"
                                          }
                                        ],
                                        "price": 66900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 26900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116276927",
                                  "name": "Garden Fresh Pizza",
                                  "category": "Special Pizza",
                                  "description": "Caramalized Onion & Crispy Capsicim freshly baked Pizza with home made Italian Pizza Sauce sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                                  "imageId": "sprjb08act9lbkx9ojhy",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28235465",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Regular (7 Inch)",
                                            "price": 269,
                                            "default": 1,
                                            "id": "89120758",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium (11 Inch)",
                                            "price": 569,
                                            "id": "89120759",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large (14 Inch)",
                                            "price": 819,
                                            "id": "89120760",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium Cheese Blast (11 Inch.)",
                                            "price": 669,
                                            "id": "89120761",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235465",
                                            "variationId": "89120758"
                                          }
                                        ],
                                        "price": 26900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235465",
                                            "variationId": "89120759"
                                          }
                                        ],
                                        "price": 56900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235465",
                                            "variationId": "89120760"
                                          }
                                        ],
                                        "price": 81900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235465",
                                            "variationId": "89120761"
                                          }
                                        ],
                                        "price": 66900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 26900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116276936",
                                  "name": "Country Special Pizza",
                                  "category": "Special Pizza",
                                  "description": "Spanish olives, Caramalized Onion & Crispy Capsicim,Pineapple  freshly baked Pizza with home made Italian Pizza Sauce sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                                  "imageId": "705b8425e3434e041c9fd029f0d6db79",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28235464",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Regular (7 Inch)",
                                            "price": 269,
                                            "default": 1,
                                            "id": "89120754",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium (11 Inch)",
                                            "price": 569,
                                            "id": "89120755",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large (14 Inch)",
                                            "price": 819,
                                            "id": "89120756",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium Cheese Blast (11 Inch.)",
                                            "price": 669,
                                            "id": "89120757",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235464",
                                            "variationId": "89120754"
                                          }
                                        ],
                                        "price": 26900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235464",
                                            "variationId": "89120755"
                                          }
                                        ],
                                        "price": 56900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235464",
                                            "variationId": "89120756"
                                          }
                                        ],
                                        "price": 81900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235464",
                                            "variationId": "89120757"
                                          }
                                        ],
                                        "price": 66900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 26900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116276938",
                                  "name": "Spicy Affair Pizza",
                                  "category": "Special Pizza",
                                  "description": "Must Try - imported Mexican Red Paprika & Jalapeno, Spanish Black Olives & Caramalized onion freshly baked Pizza with home made Peri-Peri Sauce sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                                  "imageId": "w7cfrm3bofjxxr74zarh",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28235469",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Regular (7 Inch)",
                                            "price": 269,
                                            "default": 1,
                                            "id": "89120774",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium (11 Inch)",
                                            "price": 569,
                                            "id": "89120775",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large (14 Inch)",
                                            "price": 819,
                                            "id": "89120776",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium Cheese Blast (11 Inch.)",
                                            "price": 669,
                                            "id": "89120777",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235469",
                                            "variationId": "89120774"
                                          }
                                        ],
                                        "price": 26900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235469",
                                            "variationId": "89120775"
                                          }
                                        ],
                                        "price": 56900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235469",
                                            "variationId": "89120776"
                                          }
                                        ],
                                        "price": 81900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235469",
                                            "variationId": "89120777"
                                          }
                                        ],
                                        "price": 66900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 26900,
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116276950",
                                  "name": "Caribbean Pizza",
                                  "category": "Special Pizza",
                                  "description": "Mexican Red Paprika, Spanish Black Olives & Chunks of Paneer freshly baked Pizza with home made Peri-Peri Sauce sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                                  "imageId": "tqalnvtkfcj40lb1qvpv",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28235463",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Regular (7 Inch)",
                                            "price": 269,
                                            "default": 1,
                                            "id": "89120750",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium (11 Inch)",
                                            "price": 569,
                                            "id": "89120751",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large (14 Inch)",
                                            "price": 819,
                                            "id": "89120752",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium Cheese Blast (11 Inch.)",
                                            "price": 669,
                                            "id": "89120753",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235463",
                                            "variationId": "89120750"
                                          }
                                        ],
                                        "price": 26900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235463",
                                            "variationId": "89120751"
                                          }
                                        ],
                                        "price": 56900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235463",
                                            "variationId": "89120752"
                                          }
                                        ],
                                        "price": 81900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235463",
                                            "variationId": "89120753"
                                          }
                                        ],
                                        "price": 66900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 26900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116276951",
                                  "name": "Veggie Treat Pizza",
                                  "category": "Special Pizza",
                                  "description": "Mexican Red Paprika, Caramalized Onion & Roasted Capsicim freshly baked Pizza with home made peri-peri Sauce sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                                  "imageId": "bcf077a5d2d67c7ad58beb3cc346ff26",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28235470",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Regular (7 Inch)",
                                            "price": 269,
                                            "default": 1,
                                            "id": "89120778",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium (11 Inch)",
                                            "price": 569,
                                            "id": "89120779",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large (14 Inch)",
                                            "price": 819,
                                            "id": "89120780",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium Cheese Blast (11 Inch.)",
                                            "price": 669,
                                            "id": "89120781",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235470",
                                            "variationId": "89120778"
                                          }
                                        ],
                                        "price": 26900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235470",
                                            "variationId": "89120779"
                                          }
                                        ],
                                        "price": 56900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235470",
                                            "variationId": "89120780"
                                          }
                                        ],
                                        "price": 81900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235470",
                                            "variationId": "89120781"
                                          }
                                        ],
                                        "price": 66900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 26900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "8 ratings",
                                      "ratingCountV2": "8"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116276972",
                                  "name": "Golden Veg Pizza",
                                  "category": "Special Pizza",
                                  "description": "Sweet & juicy Golden Corn, Caramalized Onion & Roasted Capsicim freshly baked Pizza with home made Italian Pizza Sauce sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                                  "imageId": "qhtytf5dqcojbnccumcm",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28235466",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Regular (7 Inch)",
                                            "price": 269,
                                            "default": 1,
                                            "id": "89120762",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium (11 Inch)",
                                            "price": 569,
                                            "id": "89120763",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large (14 Inch)",
                                            "price": 819,
                                            "id": "89120764",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium Cheese Blast (11 Inch.)",
                                            "price": 669,
                                            "id": "89120765",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235466",
                                            "variationId": "89120762"
                                          }
                                        ],
                                        "price": 26900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235466",
                                            "variationId": "89120763"
                                          }
                                        ],
                                        "price": 56900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235466",
                                            "variationId": "89120764"
                                          }
                                        ],
                                        "price": 81900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235466",
                                            "variationId": "89120765"
                                          }
                                        ],
                                        "price": 66900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 26900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116720586",
                                  "name": "Hawaiian Pizza",
                                  "category": "Special Pizza",
                                  "description": "Tropical Pineappple, Paneer & Golden Corn freshly baked Pizza with home made Italian Pizza Sauce sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                                  "imageId": "hnnge15wvbiutkxkzj2b",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28235467",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Regular (7 Inch)",
                                            "price": 269,
                                            "default": 1,
                                            "id": "89120766",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium (11 Inch)",
                                            "price": 569,
                                            "id": "89120767",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large (14 Inch)",
                                            "price": 819,
                                            "id": "89120768",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium Cheese Blast (11 Inch.)",
                                            "price": 669,
                                            "id": "89120769",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235467",
                                            "variationId": "89120766"
                                          }
                                        ],
                                        "price": 26900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235467",
                                            "variationId": "89120767"
                                          }
                                        ],
                                        "price": 56900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235467",
                                            "variationId": "89120768"
                                          }
                                        ],
                                        "price": 81900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235467",
                                            "variationId": "89120769"
                                          }
                                        ],
                                        "price": 66900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 26900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Exotic Non Veg Pizza",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116276943",
                                  "name": "Zesty Chicken Pizza",
                                  "category": "Special Pizza",
                                  "description": "Smoked Chicken Breast, Chicken  Ham,  Chicken Sausage & Red Parika freshly baked Pizza with home made peri-peri  Sauce sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                                  "imageId": "cwrabozju62xelhraedr",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28235479",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Regular (7 Inch)",
                                            "price": 289,
                                            "default": 1,
                                            "id": "89120812",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium (11 Inch)",
                                            "price": 589,
                                            "id": "89120813",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large (14 Inch)",
                                            "price": 849,
                                            "id": "89120814",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium Cheese Blast (11 Inch.)",
                                            "price": 689,
                                            "id": "89120815",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235479",
                                            "variationId": "89120812"
                                          }
                                        ],
                                        "price": 28900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235479",
                                            "variationId": "89120813"
                                          }
                                        ],
                                        "price": 58900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357070",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235479",
                                            "variationId": "89120814"
                                          }
                                        ],
                                        "price": 84900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357070",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235479",
                                            "variationId": "89120815"
                                          }
                                        ],
                                        "price": 68900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357070",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "92357070",
                                      "groupName": "Four Cheese",
                                      "choices": [
                                        {
                                          "id": "99261208",
                                          "name": "Four Cheese",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 28900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116276945",
                                  "name": "Tandoori Tikka Pizza",
                                  "category": "Special Pizza",
                                  "description": "Best Seller - Roasted Chicken tikka, Caramalized Onion & Crispy Capsicim freshly baked Pizza with home made Italian Pizza Sauce sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                                  "imageId": "pciahntdhu6ifa1pkiqq",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28235478",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Regular (7 Inch)",
                                            "price": 289,
                                            "default": 1,
                                            "id": "89120808",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium (11 Inch)",
                                            "price": 589,
                                            "id": "89120809",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large (14 Inch)",
                                            "price": 849,
                                            "id": "89120810",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium Cheese Blast (11 Inch.)",
                                            "price": 689,
                                            "id": "89120811",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235478",
                                            "variationId": "89120808"
                                          }
                                        ],
                                        "price": 28900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235478",
                                            "variationId": "89120809"
                                          }
                                        ],
                                        "price": 58900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357069",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235478",
                                            "variationId": "89120810"
                                          }
                                        ],
                                        "price": 84900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357069",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235478",
                                            "variationId": "89120811"
                                          }
                                        ],
                                        "price": 68900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357069",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "92357069",
                                      "groupName": "Four Cheese",
                                      "choices": [
                                        {
                                          "id": "99261208",
                                          "name": "Four Cheese",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 28900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116276952",
                                  "name": "Hot Queen Pizza",
                                  "category": "Special Pizza",
                                  "description": "Must Try - Chicken Tikka, BBQ Chicken  & Mexican Red Paprika freshly baked Pizza with home made peri-peri Sauce sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                                  "imageId": "ytzqxxg00sz8veuusuaz",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28235474",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Regular (7 Inch)",
                                            "price": 289,
                                            "default": 1,
                                            "id": "89120794",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium (11 Inch)",
                                            "price": 589,
                                            "id": "89120795",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large (14 Inch)",
                                            "price": 849,
                                            "id": "89120796",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium Cheese Blast (11 Inch.)",
                                            "price": 689,
                                            "id": "89120797",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235474",
                                            "variationId": "89120794"
                                          }
                                        ],
                                        "price": 28900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235474",
                                            "variationId": "89120795"
                                          }
                                        ],
                                        "price": 58900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357065",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235474",
                                            "variationId": "89120796"
                                          }
                                        ],
                                        "price": 84900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357065",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235474",
                                            "variationId": "89120797"
                                          }
                                        ],
                                        "price": 68900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357065",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "92357065",
                                      "groupName": "Four Cheese",
                                      "choices": [
                                        {
                                          "id": "99261208",
                                          "name": "Four Cheese",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 28900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.0",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116720587",
                                  "name": "Chicken Has Landed",
                                  "category": "Special Pizza",
                                  "description": "Tandoori Chicken Tikka and caramalised onion freshly baked Pizza with home made Italian Pizza Sauce sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                                  "imageId": "foxjybmx1o3xtky1yjgw",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28235471",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Regular (7 Inch)",
                                            "price": 289,
                                            "default": 1,
                                            "id": "89120782",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium (11 Inch)",
                                            "price": 589,
                                            "id": "89120783",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large (14 Inch)",
                                            "price": 849,
                                            "id": "89120784",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium Cheese Blast (11 Inch.)",
                                            "price": 689,
                                            "id": "89120785",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235471",
                                            "variationId": "89120782"
                                          }
                                        ],
                                        "price": 28900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235471",
                                            "variationId": "89120783"
                                          }
                                        ],
                                        "price": 58900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357062",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235471",
                                            "variationId": "89120784"
                                          }
                                        ],
                                        "price": 84900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357062",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235471",
                                            "variationId": "89120785"
                                          }
                                        ],
                                        "price": 68900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357062",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "92357062",
                                      "groupName": "Four Cheese",
                                      "choices": [
                                        {
                                          "id": "99261208",
                                          "name": "Four Cheese",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 28900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.8",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116720588",
                                  "name": "Deadpool Pizza",
                                  "category": "Special Pizza",
                                  "description": "Chicken Ham, Spanish Olives & tropical Pineapple  freshly baked Pizza with home made Italian Pizza Sauce sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                                  "imageId": "ys04zprg8wwqjfmxi4es",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28235472",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Regular (7 Inch)",
                                            "price": 289,
                                            "default": 1,
                                            "id": "89120786",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium (11 Inch)",
                                            "price": 589,
                                            "id": "89120787",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large (14 Inch)",
                                            "price": 849,
                                            "id": "89120788",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium Cheese Blast (11 Inch.)",
                                            "price": 689,
                                            "id": "89120789",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235472",
                                            "variationId": "89120786"
                                          }
                                        ],
                                        "price": 28900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235472",
                                            "variationId": "89120787"
                                          }
                                        ],
                                        "price": 58900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357063",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235472",
                                            "variationId": "89120788"
                                          }
                                        ],
                                        "price": 84900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357063",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28235472",
                                            "variationId": "89120789"
                                          }
                                        ],
                                        "price": 68900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "92357063",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "92357063",
                                      "groupName": "Four Cheese",
                                      "choices": [
                                        {
                                          "id": "99261208",
                                          "name": "Four Cheese",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 28900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "117642678",
                                  "name": "Italian Pepperoni Pizza,",
                                  "category": "Special Pizza",
                                  "description": "Imported Italian Pepperoni with Mexican Jalapeno freshly baked Pizza with home made Italian Pizza Sauce sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28672584",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Regular (7 Inch)",
                                            "price": 289,
                                            "default": 1,
                                            "id": "90307081",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium (11 Inch)",
                                            "price": 589,
                                            "id": "90307082",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium Cheese Blast (11 Inch)",
                                            "price": 689,
                                            "id": "90307083",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large (14 Inch)",
                                            "price": 849,
                                            "id": "90307084",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28672584",
                                            "variationId": "90307081"
                                          }
                                        ],
                                        "price": 28900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28672584",
                                            "variationId": "90307082"
                                          }
                                        ],
                                        "price": 58900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "94436375",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28672584",
                                            "variationId": "90307083"
                                          }
                                        ],
                                        "price": 68900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "94436375",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28672584",
                                            "variationId": "90307084"
                                          }
                                        ],
                                        "price": 84900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "94436375",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "94436375",
                                      "groupName": "Four Cheese",
                                      "choices": [
                                        {
                                          "id": "99261208",
                                          "name": "Four Cheese",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 28900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "2.9",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "117642681",
                                  "name": "Chicago Delight Pizza",
                                  "category": "Special Pizza",
                                  "description": "Recomended - Loaded with seekh kebab & Caramalised onion freshly baked Pizza with home made peri-peri Sauce sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                                  "imageId": "72b61bdf52fcf6e534f8948c4c121f2e",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28672588",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Regular (7 Inch)",
                                            "price": 289,
                                            "default": 1,
                                            "id": "90307093",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium (11 Inch)",
                                            "price": 589,
                                            "id": "90307094",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium Cheese Blast (11 Inch)",
                                            "price": 689,
                                            "id": "90307095",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large (14 Inch)",
                                            "price": 849,
                                            "id": "90307096",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28672588",
                                            "variationId": "90307093"
                                          }
                                        ],
                                        "price": 28900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28672588",
                                            "variationId": "90307094"
                                          }
                                        ],
                                        "price": 58900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28672588",
                                            "variationId": "90307095"
                                          }
                                        ],
                                        "price": 68900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28672588",
                                            "variationId": "90307096"
                                          }
                                        ],
                                        "price": 84900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 28900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "117642682",
                                  "name": "Spicy Kebab Pizza",
                                  "category": "Special Pizza",
                                  "description": "Seekh Kebab, Chicken Meatballs & Onion freshly baked Pizza with home made peri-peri Sauce sprinkled with 100% mozarella cheese and served with inhouse Chilli flakes & Oregano seasoning",
                                  "imageId": "adfc55117190977df930174fc7777f2d",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28672589",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Regular (7 Inch)",
                                            "price": 289,
                                            "default": 1,
                                            "id": "90307097",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium (11 Inch)",
                                            "price": 589,
                                            "id": "90307098",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium Cheese Blast (11 Inch)",
                                            "price": 689,
                                            "id": "90307099",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large (14 Inch)",
                                            "price": 849,
                                            "id": "90307100",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28672589",
                                            "variationId": "90307097"
                                          }
                                        ],
                                        "price": 28900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28672589",
                                            "variationId": "90307098"
                                          }
                                        ],
                                        "price": 58900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "94436379",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28672589",
                                            "variationId": "90307099"
                                          }
                                        ],
                                        "price": 68900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "94436379",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28672589",
                                            "variationId": "90307100"
                                          }
                                        ],
                                        "price": 84900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "94436379",
                                            "addonId": "99261208"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "94436379",
                                      "groupName": "Four Cheese",
                                      "choices": [
                                        {
                                          "id": "99261208",
                                          "name": "Four Cheese",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 28900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Stuffed Garlic Bread",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116277001",
                              "name": "Jalapeno & Corn Stuffed Garlic Bread",
                              "category": "Stuffed Garlic Bread",
                              "description": "MUST TRY - Artisan inhouse Baked Bread with signature Garlic Butter. Inhouse Cream cheese, Flavoured herbs & 100% Mozarella cheese that will pull your excitement",
                              "imageId": "1d45387af3d2a6a9a5b2d20aeb48137c",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "10 ratings",
                                  "ratingCountV2": "10"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116277002",
                              "name": "7 Type Cheese Cheese Stuffed Garlic Bread",
                              "category": "Stuffed Garlic Bread",
                              "description": "MUST RTY - Artisan inhouse Baked Bread with signature Garlic Butter. Inhouse Cream cheese, Flavoured herbs & 100% Mozarella cheese that will pull your excitement",
                              "imageId": "xcbbpvy7bymls04waml0",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 21900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "11 ratings",
                                  "ratingCountV2": "11"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116277003",
                              "name": "Jalapeno & Bbq Chicken Stuffed Garlic Bread",
                              "category": "Stuffed Garlic Bread",
                              "description": "Best Seller - Artisan inhouse Baked Bread with signature Garlic Butter. Inhouse Cream cheese, Flavoured herbs & 100% Mozarella cheese that will pull your excitement",
                              "imageId": "2c82ff53a1713ad5dbcf971760bd4f31",
                              "inStock": 1,
                              "price": 20900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116277004",
                              "name": "Red Paprika & Chicken Tikka Stuffed Garlic Bread",
                              "category": "Stuffed Garlic Bread",
                              "description": "Artisan inhouse Baked Bread with signature Garlic Butter. Inhouse Cream cheese, Flavoured herbs & 100% Mozarella cheese that will pull your excitement",
                              "imageId": "pidjhrtcoito2vhvg0xi",
                              "inStock": 1,
                              "price": 20900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116720552",
                              "name": "Red Paprika & Paneer Stuffed Garlic Bread",
                              "category": "Stuffed Garlic Bread",
                              "description": "Recomended - Artisan inhouse Baked Bread with signature Garlic Butter. Inhouse Cream cheese, Flavoured herbs & 100% Mozarella cheese that will pull your excitement",
                              "imageId": "tllj2zinn7ts84mveulm",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Pastas ",
                      "categories": [
                        {
                          "title": "Veg Pasta [serves - 1]",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116276893",
                                  "name": "Veggie Blast Pasta",
                                  "category": "Pastas ",
                                  "description": "Sweet Corn, Capsicum & Onion Authentic Italian Penne Pasta tossed with extra virgin Spanish Olive oil with 100% mozarella cheese and a dash of garlic & bresh Basil with a choice of 4 secret sauces",
                                  "imageId": "ynb5zuokin4kopocan6t",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 24900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "100684475",
                                      "groupName": "Choice Of Sauce",
                                      "choices": [
                                        {
                                          "id": "99261209",
                                          "name": "Pink Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99261210",
                                          "name": "Red Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99261211",
                                          "name": "White Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "2.7",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116276900",
                                  "name": "Spicy Twist Pasta",
                                  "category": "Pastas ",
                                  "description": "Spicy Red Paprika & Mexican Jalapenon Authentic Italian Penne Pasta tossed with extra virgin Spanish Olive oil with 100% mozarella cheese and a dash of garlic & bresh Basil with a choice of 4 secret sauces",
                                  "imageId": "gn6xsklpdlpj2tzujfnd",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 22900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "100684474",
                                      "groupName": "Choice Of Sauce",
                                      "choices": [
                                        {
                                          "id": "99261209",
                                          "name": "Pink Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99261210",
                                          "name": "Red Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99261211",
                                          "name": "White Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116276902",
                                  "name": "Farm House Pasta",
                                  "category": "Pastas ",
                                  "description": "Farm Mushroom, Spanish Black Olives & Juicy Corn Authentic Italian Penne Pasta tossed with extra virgin Spanish Olive oil with 100% mozarella cheese and a dash of garlic & bresh Basil with a choice of 4 secret sauces",
                                  "imageId": "wsorhawhfiy570unf8l4",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 24900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "100684476",
                                      "groupName": "Choice Of Sauce",
                                      "choices": [
                                        {
                                          "id": "99261209",
                                          "name": "Pink Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99261210",
                                          "name": "Red Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99261211",
                                          "name": "White Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116276924",
                                  "name": "Paneer Pasta",
                                  "category": "Pastas ",
                                  "description": "Generous Chunks of Paneer, capsicum & Red paprika Authentic Italian Penne Pasta tossed with extra virgin Spanish Olive oil with 100% mozarella cheese and a dash of garlic & bresh Basil with a choice of 4 secret sauces",
                                  "imageId": "fp7lup9f87xjpkciutsv",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 26900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "100684478",
                                      "groupName": "Choice Of Sauce",
                                      "choices": [
                                        {
                                          "id": "99261209",
                                          "name": "Pink Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99261210",
                                          "name": "Red Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99261211",
                                          "name": "White Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116276926",
                                  "name": "Classic Cheese Pasta",
                                  "category": "Pastas ",
                                  "description": "Authentic Italian Penne Pasta tossed with extra virgin Spanish Olive oil with 100% mozarella cheese and a dash of garlic & bresh Basil with a choice of 4 secret sauces",
                                  "imageId": "jdhnlhiozmepgpesz38z",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 19900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "100684471",
                                      "groupName": "Choice Of Sauce",
                                      "choices": [
                                        {
                                          "id": "99261209",
                                          "name": "Pink Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99261210",
                                          "name": "Red Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99261211",
                                          "name": "White Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "8 ratings",
                                      "ratingCountV2": "8"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116277012",
                                  "name": "Chicago Special Pasta",
                                  "category": "Pastas ",
                                  "description": "Mexican Red Paprika & jalapeno with caramalized Onion Authentic Italian Penne Pasta tossed with extra virgin Spanish Olive oil with 100% mozarella cheese and a dash of garlic & bresh Basil with a choice of 4 secret sauces",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 24900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "100684477",
                                      "groupName": "Choice Of Sauce",
                                      "choices": [
                                        {
                                          "id": "99261209",
                                          "name": "Pink Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99261210",
                                          "name": "Red Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99261211",
                                          "name": "White Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116277013",
                                  "name": "Veggie Lover Pasta",
                                  "category": "Pastas ",
                                  "description": "Spanish Olives, Mexican jalapeno, Roasted Capsicum & Caramalized Onion Authentic Italian Penne Pasta tossed with extra virgin Spanish Olive oil with 100% mozarella cheese and a dash of garlic & bresh Basil with a choice of 4 secret sauces",
                                  "imageId": "ojvijworro0ip4pbnvvo",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 28900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "100684469",
                                      "groupName": "Choice Of Sauce",
                                      "choices": [
                                        {
                                          "id": "99261209",
                                          "name": "Pink Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99261210",
                                          "name": "Red Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99261211",
                                          "name": "White Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116277014",
                                  "name": "Simply Veg Pasta",
                                  "category": "Pastas ",
                                  "description": "Roasted Capsicum & Caramalized Onion Authentic Italian Penne Pasta tossed with extra virgin Spanish Olive oil with 100% mozarella cheese and a dash of garlic & bresh Basil with a choice of 4 secret sauces",
                                  "imageId": "exe52qnhzysflpo6jdsf",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 22900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "100684470",
                                      "groupName": "Choice Of Sauce",
                                      "choices": [
                                        {
                                          "id": "99261209",
                                          "name": "Pink Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99261210",
                                          "name": "Red Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99261211",
                                          "name": "White Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Non Veg Pasta [serves - 1]",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116276898",
                                  "name": "Italian Chicken Pasta",
                                  "category": "Pastas ",
                                  "description": "BBQ Chicken, Golden Corn & Tangy Jalapeno Authentic Italian Penne Pasta tossed with extra virgin Spanish Olive oil with 100% mozarella cheese and a dash of garlic & bresh Basil with a choice of 4 secret sauces",
                                  "imageId": "wxpnrbru6wcoyu3wadm8",
                                  "inStock": 1,
                                  "price": 26900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "100684473",
                                      "groupName": "Choice Of Sauce",
                                      "choices": [
                                        {
                                          "id": "99261209",
                                          "name": "Pink Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99261210",
                                          "name": "Red Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99261211",
                                          "name": "White Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116276910",
                                  "name": "Chicken Ham Pasta",
                                  "category": "Pastas ",
                                  "description": "Smoked Chicken Ham Authentic Italian Penne Pasta tossed with extra virgin Spanish Olive oil with 100% mozarella cheese and a dash of garlic & bresh Basil with a choice of 4 secret sauces",
                                  "imageId": "vofwoij04zbe6dyibm8r",
                                  "inStock": 1,
                                  "price": 19900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "100684468",
                                      "groupName": "Choice Of Sauce",
                                      "choices": [
                                        {
                                          "id": "99261209",
                                          "name": "Pink Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99261210",
                                          "name": "Red Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99261211",
                                          "name": "White Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116276918",
                                  "name": "Mutton Twist Pasta",
                                  "category": "Pastas ",
                                  "description": "Lamb Keema, Spanish Olives & Capsicum Authentic Italian Penne Pasta tossed with extra virgin Spanish Olive oil with 100% mozarella cheese and a dash of garlic & bresh Basil with a choice of 4 secret sauces",
                                  "imageId": "ijiqc3mdkscwf9kvjotw",
                                  "inStock": 1,
                                  "price": 32900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "100684467",
                                      "groupName": "Choice Of Sauce",
                                      "choices": [
                                        {
                                          "id": "99261209",
                                          "name": "Pink Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99261210",
                                          "name": "Red Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99261211",
                                          "name": "White Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116276921",
                                  "name": "Chicken Tikka Pasta",
                                  "category": "Pastas ",
                                  "description": "Smoked Chicken Tikka, Capsicum & Onion Authentic Italian Penne Pasta tossed with extra virgin Spanish Olive oil with 100% mozarella cheese and a dash of garlic & bresh Basil with a choice of 4 secret sauces",
                                  "imageId": "ckv2v0vfempt7yits72c",
                                  "inStock": 1,
                                  "price": 24900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "100684472",
                                      "groupName": "Choice Of Sauce",
                                      "choices": [
                                        {
                                          "id": "99261209",
                                          "name": "Pink Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99261210",
                                          "name": "Red Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99261211",
                                          "name": "White Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116276932",
                                  "name": "Chicken Supreme Pasta",
                                  "category": "Pastas ",
                                  "description": "Smoked Chicken breast, BBQ Chicken & Caramalized Onion Authentic Italian Penne Pasta tossed with extra virgin Spanish Olive oil with 100% mozarella cheese and a dash of garlic & bresh Basil with a choice of 4 secret sauces",
                                  "imageId": "okifclcpijuhu0fx4pac",
                                  "inStock": 1,
                                  "price": 26900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "100684466",
                                      "groupName": "Choice Of Sauce",
                                      "choices": [
                                        {
                                          "id": "99261209",
                                          "name": "Pink Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99261210",
                                          "name": "Red Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99261211",
                                          "name": "White Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116276935",
                                  "name": "Chicken Delight Pasta",
                                  "category": "Pastas ",
                                  "description": "Chicken Tikka, BBQ Chicken, Smoked Chicken Ham & Onion Authentic Italian Penne Pasta tossed with extra virgin Spanish Olive oil with 100% mozarella cheese and a dash of garlic & bresh Basil with a choice of 4 secret sauces",
                                  "imageId": "fu7iyx3kfthtgrbn1w0n",
                                  "inStock": 1,
                                  "price": 29900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "100684465",
                                      "groupName": "Choice Of Sauce",
                                      "choices": [
                                        {
                                          "id": "99261209",
                                          "name": "Pink Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99261210",
                                          "name": "Red Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99261211",
                                          "name": "White Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "117642669",
                                  "name": "Chicken Twist",
                                  "category": "Pastas ",
                                  "description": "Seekh kebab, Spanish Olives & Capsicum Authentic Italian Penne Pasta tossed with extra virgin Spanish Olive oil with 100% mozarella cheese and a dash of garlic & bresh Basil with a choice of 4 secret sauces",
                                  "inStock": 1,
                                  "price": 24900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "94436360",
                                      "groupName": "Choice Of Sauce",
                                      "choices": [
                                        {
                                          "id": "99261209",
                                          "name": "Pink Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99261210",
                                          "name": "Red Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99261211",
                                          "name": "White Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "117642674",
                                  "name": "Pepperoni Pasta.",
                                  "category": "Pastas ",
                                  "description": "Imported Italian Pepperoni & Mexican Jalapeno Authentic Italian Penne Pasta tossed with extra virgin Spanish Olive oil with 100% mozarella cheese and a dash of garlic & bresh Basil with a choice of 4 secret sauces",
                                  "inStock": 1,
                                  "price": 29900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "100684464",
                                      "groupName": "Choice Of Sauce",
                                      "choices": [
                                        {
                                          "id": "99261209",
                                          "name": "Pink Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99261210",
                                          "name": "Red Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99261211",
                                          "name": "White Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Sides",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116276947",
                              "name": "Baked Chicken Wings",
                              "category": "Sides",
                              "description": "BBQ flavoured tender chicken wings",
                              "imageId": "ov0b84ah19piyypyyfoe",
                              "inStock": 1,
                              "price": 29900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116276986",
                              "name": "Potato Wedges",
                              "category": "Sides",
                              "description": "Wedge shaped Potatos baked in Australian style",
                              "imageId": "ziznjn2xqtofyzqtup2w",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116276988",
                              "name": "Choco Lava Cake",
                              "category": "Sides",
                              "description": "Filled with magma chocolate sauce, this cake is to Die for !",
                              "imageId": "emlnfovsg1aoooh8z0eh",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "10 ratings",
                                  "ratingCountV2": "10"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117642667",
                              "name": "Classic Garlic Bread",
                              "category": "Sides",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "28672572",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "2 Pcs",
                                        "price": 99,
                                        "default": 1,
                                        "id": "90307053",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "4 Pcs",
                                        "price": 179,
                                        "id": "90307054",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28672572",
                                        "variationId": "90307053"
                                      }
                                    ],
                                    "price": 9900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "28672572",
                                        "variationId": "90307054"
                                      }
                                    ],
                                    "price": 17900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 9900,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "8 ratings",
                                  "ratingCountV2": "8"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Mocktail",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116276963",
                              "name": "Monster Ginger",
                              "category": "Mocktail",
                              "description": "A Health Tonic that rejuvenates your senses",
                              "imageId": "swgck3rzrvdai2fm5ivp",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "98478824",
                                  "groupName": "Boba (Mocktails)",
                                  "choices": [
                                    {
                                      "id": "99261154",
                                      "name": "Boba",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121357766",
                                  "groupName": "Add Ons [Mocktails]",
                                  "choices": [
                                    {
                                      "id": "104756050",
                                      "name": "Blueberry Boba",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104756051",
                                      "name": "Lichi Boba",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116720556",
                              "name": "Blue Lagoon",
                              "category": "Mocktail",
                              "description": "Electrifying Blue mocktail from Iceland",
                              "imageId": "ipjr0uqxtjnkwu0vfcvc",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "98478804",
                                  "groupName": "Boba (Mocktails)",
                                  "choices": [
                                    {
                                      "id": "99261154",
                                      "name": "Boba",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121357762",
                                  "groupName": "Add Ons [Mocktails]",
                                  "choices": [
                                    {
                                      "id": "104756050",
                                      "name": "Blueberry Boba",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104756051",
                                      "name": "Lichi Boba",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116720557",
                              "name": "Green Apple Cooler",
                              "category": "Mocktail",
                              "description": "A cool and calming drink that soothes you within",
                              "imageId": "zms2yc3lswbuwaqxvuma",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "98478809",
                                  "groupName": "Boba (Mocktails)",
                                  "choices": [
                                    {
                                      "id": "99261154",
                                      "name": "Boba",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121357763",
                                  "groupName": "Add Ons [Mocktails]",
                                  "choices": [
                                    {
                                      "id": "104756050",
                                      "name": "Blueberry Boba",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104756051",
                                      "name": "Lichi Boba",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116720558",
                              "name": "Indian Spice Soda",
                              "category": "Mocktail",
                              "description": "Swing yourself to an exciting mood",
                              "imageId": "mtocsbldav8qrwf5vzvf",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "98478819",
                                  "groupName": "Boba (Mocktails)",
                                  "choices": [
                                    {
                                      "id": "99261154",
                                      "name": "Boba",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121357765",
                                  "groupName": "Add Ons [Mocktails]",
                                  "choices": [
                                    {
                                      "id": "104756050",
                                      "name": "Blueberry Boba",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104756051",
                                      "name": "Lichi Boba",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116720559",
                              "name": "Monster Lemon",
                              "category": "Mocktail",
                              "description": "Hydrate your Body with this",
                              "imageId": "pzmc964yv5hm4u4dw0jj",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "98478799",
                                  "groupName": "Boba (Mocktails)",
                                  "choices": [
                                    {
                                      "id": "99261154",
                                      "name": "Boba",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121357761",
                                  "groupName": "Add Ons [Mocktails]",
                                  "choices": [
                                    {
                                      "id": "104756050",
                                      "name": "Blueberry Boba",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104756051",
                                      "name": "Lichi Boba",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116720560",
                              "name": "Strawberry Cooler",
                              "category": "Mocktail",
                              "description": "Bring out the Passsion in you !",
                              "imageId": "rdbymqkcemzotjmpnrx8",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "98471949",
                                  "groupName": "Boba (Mocktails)",
                                  "choices": [
                                    {
                                      "id": "99261154",
                                      "name": "Boba",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121357767",
                                  "groupName": "Add Ons [Mocktails]",
                                  "choices": [
                                    {
                                      "id": "104756050",
                                      "name": "Blueberry Boba",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104756051",
                                      "name": "Lichi Boba",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116720561",
                              "name": "Virgin Mojito",
                              "category": "Mocktail",
                              "description": "All time favorite - A drink from Cuba",
                              "imageId": "z0byqpmole2dcdvplbfg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "98478814",
                                  "groupName": "Boba (Mocktails)",
                                  "choices": [
                                    {
                                      "id": "99261154",
                                      "name": "Boba",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121357764",
                                  "groupName": "Add Ons [Mocktails]",
                                  "choices": [
                                    {
                                      "id": "104756050",
                                      "name": "Blueberry Boba",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104756051",
                                      "name": "Lichi Boba",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Milk Shake",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116276956",
                              "name": "Cold Coffee",
                              "category": "Milk Shake",
                              "description": "MUST TRY - Speciality Coffee Beans",
                              "imageId": "gdqcfdywc7i8tftjjc33",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "98471948",
                                  "groupName": "Boba (Mocktails)",
                                  "choices": [
                                    {
                                      "id": "99261154",
                                      "name": "Boba",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "120849877",
                              "name": "Chocolate Shake [o]",
                              "category": "Milk Shake",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "101363325",
                                  "groupName": "Boba (Mocktails)",
                                  "choices": [
                                    {
                                      "id": "99261154",
                                      "name": "Boba",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "120849878",
                              "name": "Oreo Shake [o]",
                              "category": "Milk Shake",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "101363326",
                                  "groupName": "Boba (Mocktails)",
                                  "choices": [
                                    {
                                      "id": "99261154",
                                      "name": "Boba",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "120849879",
                              "name": "Strawberry Shake [o]",
                              "category": "Milk Shake",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "101363327",
                                  "groupName": "Boba (Mocktails)",
                                  "choices": [
                                    {
                                      "id": "99261154",
                                      "name": "Boba",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "127736992",
                              "name": "Chocolate Milkshake",
                              "category": "Milk Shake",
                              "imageId": "2db4a6bc0dd43737ef779579a13d1df0",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "127736996",
                              "name": "Oreo Milkshake",
                              "category": "Milk Shake",
                              "imageId": "b642b4842775dbc494f7c1c38fc87ff1",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "127737014",
                              "name": "Strawberry Milkshake",
                              "category": "Milk Shake",
                              "imageId": "2c0f44eca1f8b7a969e6ad570d7b5718",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Combos For Everyone",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121887913",
                              "name": "Meal For Two (veg)",
                              "category": "Combos For Everyone",
                              "description": "1 Medium Veg Pizza (11\") + 1 Stuffed Garlic Bread + 2 Mocktails + 1 ChocoLava",
                              "imageId": "9939a7f0ba9a55412d2bb7a0d4211428",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 99900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "109974515",
                                  "groupName": "Stuffed Garlic Bread (Veg)",
                                  "choices": [
                                    {
                                      "id": "99278059",
                                      "name": "Red Paprika & Paneer",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278060",
                                      "name": "Jalapeno & Corn",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109974516",
                                  "groupName": "Mocktails",
                                  "choices": [
                                    {
                                      "id": "99278061",
                                      "name": "Strawberry Cooler",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278062",
                                      "name": "Monster Lemon",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278063",
                                      "name": "Blue Lagoon",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278064",
                                      "name": "Green Apple Cooler",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278065",
                                      "name": "Virgin Mojito",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278066",
                                      "name": "Indian Spice Soda",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278067",
                                      "name": "Monster Ginger",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109974517",
                                  "groupName": "Medium Pizza Toppings(1)",
                                  "choices": [
                                    {
                                      "id": "99278068",
                                      "name": "Jalapeno",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278069",
                                      "name": "Pineapple",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278070",
                                      "name": "Olive",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278071",
                                      "name": "Paneer",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278072",
                                      "name": "Red Paprika",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278073",
                                      "name": "Corn",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278074",
                                      "name": "Mushroom",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278075",
                                      "name": "Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278076",
                                      "name": "Onion",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "109974518",
                                  "groupName": "Chocolava",
                                  "choices": [
                                    {
                                      "id": "99278077",
                                      "name": "Chocolava",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121887914",
                              "name": "Meal For Two (non-veg)",
                              "category": "Combos For Everyone",
                              "description": "1 Medium Non-Veg Pizza (11\") + 1 Stuffed Garlic Bread + 2 Mocktails + 1 ChocoLava",
                              "imageId": "f3e833d221ac2eaba90c50b9224b736a",
                              "inStock": 1,
                              "price": 109900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "109974519",
                                  "groupName": "Stuffed Garlic Bread (Non-Veg)",
                                  "choices": [
                                    {
                                      "id": "99278016",
                                      "name": "Red Paprika & Chicken Tikka",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278017",
                                      "name": "Jalapeno & BBQ Chicken",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109974520",
                                  "groupName": "Mocktails",
                                  "choices": [
                                    {
                                      "id": "99278061",
                                      "name": "Strawberry Cooler",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278062",
                                      "name": "Monster Lemon",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278063",
                                      "name": "Blue Lagoon",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278064",
                                      "name": "Green Apple Cooler",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278065",
                                      "name": "Virgin Mojito",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278066",
                                      "name": "Indian Spice Soda",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278067",
                                      "name": "Monster Ginger",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109974521",
                                  "groupName": "Medium Pizza Toppings(1)",
                                  "choices": [
                                    {
                                      "id": "99278041",
                                      "name": "Mutton Keema",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278042",
                                      "name": "Chicken Meatballs",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278043",
                                      "name": "Chicken Tikka",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278044",
                                      "name": "Smoked Chicken Breast",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278045",
                                      "name": "BBQ Chicken",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278046",
                                      "name": "Chicken Sausage",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278047",
                                      "name": "Chicken Ham",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278048",
                                      "name": "Jalapeno",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278049",
                                      "name": "Pineapple",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278050",
                                      "name": "Olive",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278051",
                                      "name": "Paneer",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278052",
                                      "name": "Red Paprika",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278053",
                                      "name": "Corn",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278054",
                                      "name": "Mushroom",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278055",
                                      "name": "Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278056",
                                      "name": "Onion",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "109974522",
                                  "groupName": "Chocolava",
                                  "choices": [
                                    {
                                      "id": "99278077",
                                      "name": "Chocolava",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121887921",
                              "name": "Meal For Four (non-veg)",
                              "category": "Combos For Everyone",
                              "description": "2 Medium Non-Veg Pizza (11\") + Chicken Wings (6Pcs) + 1 Stuffed Garlic Bread + 4 Mocktails + 2 ChocoLava",
                              "imageId": "b6dba83dd7add478f4627c4f33a6e3f7",
                              "inStock": 1,
                              "price": 184900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "109974509",
                                  "groupName": "Stuffed Garlic Bread (Non-Veg)",
                                  "choices": [
                                    {
                                      "id": "99278016",
                                      "name": "Red Paprika & Chicken Tikka",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278017",
                                      "name": "Jalapeno & BBQ Chicken",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109974510",
                                  "groupName": "Mocktails",
                                  "choices": [
                                    {
                                      "id": "99278018",
                                      "name": "Strawberry Cooler",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278019",
                                      "name": "Monster Lemon",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278020",
                                      "name": "Blue Lagoon",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278021",
                                      "name": "Green Apple Cooler",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278022",
                                      "name": "Virgin Mojito",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278023",
                                      "name": "Indian Spice Soda",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278024",
                                      "name": "Monster Ginger",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109974511",
                                  "groupName": "Medium Pizza Toppings(2)",
                                  "choices": [
                                    {
                                      "id": "99278025",
                                      "name": "Mutton Keema",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278026",
                                      "name": "Chicken Meatballs",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278027",
                                      "name": "Chicken Tikka",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278028",
                                      "name": "Smoked Chicken Breast",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278029",
                                      "name": "BBQ Chicken",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278030",
                                      "name": "Chicken Sausage",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278031",
                                      "name": "Chicken Ham",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278032",
                                      "name": "Jalapeno",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278033",
                                      "name": "Pineapple",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278034",
                                      "name": "Olive",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278035",
                                      "name": "Paneer",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278036",
                                      "name": "Red Paprika",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278037",
                                      "name": "Corn",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278038",
                                      "name": "Mushroom",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278039",
                                      "name": "Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278040",
                                      "name": "Onion",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "109974512",
                                  "groupName": "Medium Pizza Toppings(1)",
                                  "choices": [
                                    {
                                      "id": "99278041",
                                      "name": "Mutton Keema",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278042",
                                      "name": "Chicken Meatballs",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278043",
                                      "name": "Chicken Tikka",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278044",
                                      "name": "Smoked Chicken Breast",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278045",
                                      "name": "BBQ Chicken",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278046",
                                      "name": "Chicken Sausage",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278047",
                                      "name": "Chicken Ham",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278048",
                                      "name": "Jalapeno",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278049",
                                      "name": "Pineapple",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278050",
                                      "name": "Olive",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278051",
                                      "name": "Paneer",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278052",
                                      "name": "Red Paprika",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278053",
                                      "name": "Corn",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278054",
                                      "name": "Mushroom",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278055",
                                      "name": "Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278056",
                                      "name": "Onion",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "109974513",
                                  "groupName": "Chocolava",
                                  "choices": [
                                    {
                                      "id": "99278057",
                                      "name": "Chocolava - 2",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "109974514",
                                  "groupName": "Sides",
                                  "choices": [
                                    {
                                      "id": "99278058",
                                      "name": "Chicken Wings (6pcs)",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121887922",
                              "name": "Meal For Four (veg)",
                              "category": "Combos For Everyone",
                              "description": "2 Medium Veg Pizza (11\") +1 Potato Wedges + 1 Stuffed Garlic Bread + 4 Mocktails + 2 ChocoLava",
                              "imageId": "3165c6126bb89f0d575659e987290e83",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 174900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "109974523",
                                  "groupName": "Stuffed Garlic Bread (Veg)",
                                  "choices": [
                                    {
                                      "id": "99278059",
                                      "name": "Red Paprika & Paneer",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278060",
                                      "name": "Jalapeno & Corn",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109974524",
                                  "groupName": "Mocktails",
                                  "choices": [
                                    {
                                      "id": "99278018",
                                      "name": "Strawberry Cooler",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278019",
                                      "name": "Monster Lemon",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278020",
                                      "name": "Blue Lagoon",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278021",
                                      "name": "Green Apple Cooler",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278022",
                                      "name": "Virgin Mojito",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278023",
                                      "name": "Indian Spice Soda",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278024",
                                      "name": "Monster Ginger",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109974525",
                                  "groupName": "Medium Pizza Toppings(1)",
                                  "choices": [
                                    {
                                      "id": "99278068",
                                      "name": "Jalapeno",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278069",
                                      "name": "Pineapple",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278070",
                                      "name": "Olive",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278071",
                                      "name": "Paneer",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278072",
                                      "name": "Red Paprika",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278073",
                                      "name": "Corn",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278074",
                                      "name": "Mushroom",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278075",
                                      "name": "Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278076",
                                      "name": "Onion",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "109974526",
                                  "groupName": "Medium Pizza Toppings(2)",
                                  "choices": [
                                    {
                                      "id": "99278078",
                                      "name": "Jalapeno",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278079",
                                      "name": "Pineapple",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278080",
                                      "name": "Olive",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278081",
                                      "name": "Paneer",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278082",
                                      "name": "Red Paprika",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278083",
                                      "name": "Corn",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278084",
                                      "name": "Mushroom",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278085",
                                      "name": "Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278086",
                                      "name": "Onion",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "109974527",
                                  "groupName": "Chocolava",
                                  "choices": [
                                    {
                                      "id": "99278057",
                                      "name": "Chocolava - 2",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "109974528",
                                  "groupName": "Side (mf4) (veg)",
                                  "choices": [
                                    {
                                      "id": "99278087",
                                      "name": "Potato Wedges",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121887925",
                              "name": "Meal For One (non-veg)",
                              "category": "Combos For Everyone",
                              "description": "1 Regular Non-Veg Pizza (7\") + Chicken Wings (2Pcs) + 1 Mocktail + 1 Chocolava",
                              "imageId": "c6775cf61ba9369afc681c8874da1a92",
                              "inStock": 1,
                              "price": 57900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "109974529",
                                  "groupName": "Boba (Mocktails)",
                                  "choices": [
                                    {
                                      "id": "99261154",
                                      "name": "Boba",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109974530",
                                  "groupName": "Mocktails",
                                  "choices": [
                                    {
                                      "id": "99278088",
                                      "name": "Strawberry Cooler",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278089",
                                      "name": "Monster Lemon",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278090",
                                      "name": "Blue Lagoon",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278091",
                                      "name": "Green Apple Cooler",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278092",
                                      "name": "Virgin Mojito",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278093",
                                      "name": "Indian Spice Soda",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278094",
                                      "name": "Monster Ginger",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109974531",
                                  "groupName": "Reg Pizza Toppings",
                                  "choices": [
                                    {
                                      "id": "99278095",
                                      "name": "Mutton Keema",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278096",
                                      "name": "Chicken Meatballs",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278097",
                                      "name": "Chicken Tikka",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278098",
                                      "name": "Smoked Chicken Breast",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278099",
                                      "name": "BBQ Chicken",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278100",
                                      "name": "Chicken Sausage",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278101",
                                      "name": "Chicken Ham",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278102",
                                      "name": "Jalapeno",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278103",
                                      "name": "Pineapple",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278104",
                                      "name": "Olive",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278105",
                                      "name": "Paneer",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278106",
                                      "name": "Red Paprika",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278107",
                                      "name": "Corn",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278108",
                                      "name": "Mushroom",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278109",
                                      "name": "Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278110",
                                      "name": "Onion",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "109974532",
                                  "groupName": "Chocolava",
                                  "choices": [
                                    {
                                      "id": "99278077",
                                      "name": "Chocolava",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "109974533",
                                  "groupName": "Sides",
                                  "choices": [
                                    {
                                      "id": "99278111",
                                      "name": "Chicken Wings (2pcs)",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121887926",
                              "name": "Meal For One (veg)",
                              "category": "Combos For Everyone",
                              "description": "1 Regular Veg Pizza (7\") + Potato Wedges (small) + 1 Mocktail + 1 Chocolava",
                              "imageId": "cea0b185d7394ba1238119da8ace7922",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 51900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "109974534",
                                  "groupName": "Boba (Mocktails)",
                                  "choices": [
                                    {
                                      "id": "99261154",
                                      "name": "Boba",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109974535",
                                  "groupName": "Mocktails",
                                  "choices": [
                                    {
                                      "id": "99278088",
                                      "name": "Strawberry Cooler",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278089",
                                      "name": "Monster Lemon",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278090",
                                      "name": "Blue Lagoon",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278091",
                                      "name": "Green Apple Cooler",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278092",
                                      "name": "Virgin Mojito",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278093",
                                      "name": "Indian Spice Soda",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278094",
                                      "name": "Monster Ginger",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109974536",
                                  "groupName": "Reg Pizza Toppings",
                                  "choices": [
                                    {
                                      "id": "99278112",
                                      "name": "Jalapeno",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278113",
                                      "name": "Pineapple",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278114",
                                      "name": "Olive",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278115",
                                      "name": "Paneer",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278116",
                                      "name": "Red Paprika",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278117",
                                      "name": "Corn",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278118",
                                      "name": "Mushroom",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278119",
                                      "name": "Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99278120",
                                      "name": "Onion",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "109974537",
                                  "groupName": "Chocolava",
                                  "choices": [
                                    {
                                      "id": "99278077",
                                      "name": "Chocolava",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "109974538",
                                  "groupName": "Sides",
                                  "choices": [
                                    {
                                      "id": "99278121",
                                      "name": "Potato Wedges (small)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Deep Dish Pizza",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "123872257",
                              "name": "Deep Dish (non- Veg Overload)",
                              "category": "Deep Dish Pizza",
                              "description": "7\" Deep Dish Pizza loaded with all meaty toppings including BBQ, smoked chicken, Sausage, Chicken Ham, Mutton Keema.",
                              "imageId": "582d948487f0d66e0efa00fc0d79422e",
                              "inStock": 1,
                              "price": 89900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "123872258",
                              "name": "Deep Dish (veg Overload)",
                              "category": "Deep Dish Pizza",
                              "description": "7\" Deep Dish Pizza loaded with all veggie including Olives, corn, onion, mushroom, Redpaprika, Jalpeno.",
                              "imageId": "54577d408a669ce43fadb972013ed87b",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 79900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                      "type": "FSSAI",
                      "imageId": "fssai_final_edss9i",
                      "text": [
                        "License No. 11223334000597"
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                      "name": "Chicago Pizza",
                      "area": "Koramangala",
                      "completeAddress": "475/1, 5 th Block, KHB colony, Koramangala, Bengaluru"
                    }
                  }
                }
              ]
            }
          }
        }
      }
    ],
    "firstOffsetRequest": true,
    "isQCLink": false
  },
  "tid": "8091b6c9-34ec-4881-8b5e-d2b6a4328fa1",
  "sid": "c8b69dc8-6710-47a7-bc63-18091856e3fa",
  "deviceId": "c73fa13e-69cf-472b-8071-076091f9d98d",
  "csrfToken": "1DF7Co0yHro4-U4VJ0iZcCAaxwf-V0I2IQu5LRf8"
}

export const MEGHANA_FOODS=
{
  "statusCode": 0,
  "data": {
    "statusMessage": "done successfully",
    "cards": [
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
            "info": {
              "id": "654809",
              "name": "Meghana Foods",
              "city": "Bangalore",
              "slugs": {
                "restaurant": "meghana-foods-bellandur-sarjapur-bellandur-sarjapur",
                "city": "bangalore"
              },
              "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
              "cloudinaryImageId": "c627e55c996978a070c10079ae57f706",
              "locality": "G R S TOWERS",
              "areaName": "Sarjapur Road",
              "costForTwo": "50000",
              "costForTwoMessage": "₹500 for two",
              "cuisines": [
                "Biryani",
                "Andhra"
              ],
              "avgRating": 4.5,
              "feeDetails": {
                "restaurantId": "654809",
                "fees": [
                  {
                    "name": "distance",
                    "fee": 6000
                  },
                  {
                    "name": "time"
                  },
                  {
                    "name": "special"
                  }
                ],
                "totalFee": 6000,
                "icon": "v1648208530/surgecreatives/info",
                "message": "Far (5 kms) | Additional delivery fee will apply"
              },
              "parentId": "635",
              "avgRatingString": "4.5",
              "totalRatingsString": "10K+ ratings",
              "sla": {
                "restaurantId": "654809",
                "deliveryTime": 31,
                "minDeliveryTime": 30,
                "maxDeliveryTime": 35,
                "lastMileTravel": 5,
                "serviceability": "SERVICEABLE",
                "stressFactor": 1,
                "rainMode": "RAIN_MODE_NONE",
                "longDistance": "LONG_DISTANCE_IT_IS_LONG_DISTANCE",
                "zoneId": 8,
                "slaString": "30-35 MINS",
                "lastMileTravelString": "5.0 km",
                "iconType": "ICON_TYPE_EMPTY"
              },
              "availability": {
                "nextCloseTime": "2024-02-19 01:30:00",
                "visibility": true,
                "opened": true,
                "restaurantClosedMeta": {
                  
                }
              },
              "aggregatedDiscountInfo": {
                "shortDescriptionList": [
                  {
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "Flat ₹100 off | Above ₹550",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "15% off upto ₹300 | Use CITIFOODIE Above ₹1200",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "visible": true
              },
              "badges": {
                
              },
              "slugString": "meghana-foods-bellandur-sarjapur-bellandur-sarjapur",
              "multiOutlet": true,
              "isOpen": true,
              "labels": [
                {
                  "title": "Timings",
                  "message": "null"
                },
                {
                  "title": "Address",
                  "message": "SY No.18/2A, 1ST FLOOR G R S TOWERS SARJAPURA ROAD,BELLANDUR BANGALORE ,Mahadevapura , B.B.M.P East,Karnataka, 560102"
                },
                {
                  "title": "Cuisines",
                  "message": "Biryani,Andhra"
                }
              ],
              "logo": "v1685078885/Brand logo/Meghana_Foods",
              "totalRatings": 10000,
              "aggregatedDiscountInfoV2": {
                "shortDescriptionList": [
                  {
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "Flat ₹100 off | Above ₹550",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "15% off upto ₹300 | Use CITIFOODIE Above ₹1200",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "couponDetailsCta": "View coupon details"
              },
              "type": "F",
              "headerBanner": {
                "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/654809"
              },
              "expectationNotifiers": [
                {
                  "text": "Far (5 kms) | Additional delivery fee will apply",
                  "icon": {
                    "imageId": "v1648208530/surgecreatives/info"
                  },
                  "popup": {
                    "cta": {
                      
                    }
                  },
                  "type": "DISTANCE_FEE_NON_FOOD_LM",
                  "enrichedText": "<b>Far (5 kms)</b> | Additional delivery fee will apply",
                  "halfCardPopup": {
                    "halfCardPopupHeader": {
                      
                    }
                  }
                }
              ],
              "ratingSlab": "RATING_SLAB_5",
              "orderabilityCommunication": {
                "title": {
                  
                },
                "subTitle": {
                  
                },
                "message": {
                  
                },
                "customIcon": {
                  
                }
              },
              "hasBestsellerItems": true,
              "cartOrderabilityNudgeBanner": {
                "parameters": {
                  
                },
                "presentation": {
                  
                }
              },
              "latLong": "12.91874448,77.6703644",
              "backgroundImageOverlayInfo": {
                
              }
            },
            "analytics": {
              
            }
          },
          "relevance": {
            "type": "RELEVANCE_TYPE_CHECK_ORDERABILITY_ON_ITEM_ADD",
            "sectionId": "POP_UP_CROUTON_MENU"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "layout": {
              "rows": 1,
              "columns": 5,
              "horizontalScrollEnabled": true,
              "itemSpacing": 12,
              "lineSpacing": 10,
              "widgetPadding": {
                
              },
              "containerStyle": {
                "containerPadding": {
                  "left": 10,
                  "right": 10,
                  "bottom": 16
                }
              },
              "scrollBar": {
                
              }
            },
            "id": "offerCollectionWidget_UX4",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                "offers": [
                  {
                    "info": {
                      "header": "FLAT ₹100 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "MARKETING_BANNERS/IMAGES/OFFERS/2024/2/17/1ed4245d-31e3-4dc6-b949-524a33b9b8c9_ICICI.png",
                      "offerIds": [
                        "299f5c31-dd4a-47a4-8d93-4ccb6be1a8a8"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "NO CODE REQUIRED",
                      "description": "ABOVE ₹550",
                      "offerType": "offers",
                      "restId": "654809",
                      "offerLogo": "MARKETING_BANNERS/IMAGES/OFFERS/2024/2/17/1ed4245d-31e3-4dc6-b949-524a33b9b8c9_ICICI.png",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹50 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "MARKETING_BANNERS/IMAGES/OFFERS/2024/2/16/d2280c74-96d1-4a1d-afd6-4270a05b5488_ICICI.png",
                      "offerIds": [
                        "72b12a41-597c-4c87-a813-32c46574fde9"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "NO CODE REQUIRED",
                      "description": "ABOVE ₹500",
                      "offerType": "offers",
                      "restId": "654809",
                      "offerLogo": "MARKETING_BANNERS/IMAGES/OFFERS/2024/2/16/d2280c74-96d1-4a1d-afd6-4270a05b5488_ICICI.png",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "15% OFF UPTO ₹300",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/15fb1cfe885005447dc8375e7970600f",
                      "offerIds": [
                        "c313f07b-4a9c-451e-ab52-586759f42642"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE CITIFOODIE",
                      "description": "ABOVE ₹1200",
                      "offerType": "offers",
                      "restId": "654809",
                      "offerLogo": "rng/md/ads/production/15fb1cfe885005447dc8375e7970600f",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹30 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/7f31c9e47ddd7e6a3c16d21553c0ca60",
                      "offerIds": [
                        "269c382d-796f-45cd-bd15-0b8b891c5e0c"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE SIMPL30",
                      "description": "ABOVE ₹300",
                      "offerType": "offers",
                      "restId": "654809",
                      "offerLogo": "rng/md/ads/production/7f31c9e47ddd7e6a3c16d21553c0ca60",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹150 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/59ef5e58052532ad85a185bf516eccce",
                      "offerIds": [
                        "6265534b-c8b7-4494-a469-116273548dd2"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE AMEX150",
                      "description": "ABOVE ₹600",
                      "offerType": "offers",
                      "restId": "654809",
                      "offerLogo": "rng/md/ads/production/59ef5e58052532ad85a185bf516eccce",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  }
                ],
                "habitMilestoneInfo": {
                  "callout": {
                    
                  }
                },
                "loyaltyDiscoverPresentationInfo": {
                  "logoCtx": {
                    
                  }
                }
              }
            }
          }
        }
      },
      {
        "groupedCard": {
          "cardGroupMap": {
            "REGULAR": {
              "cards": [
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                      "badges": {
                        
                      },
                      "vegOnlyDetails": {
                        "imageId": "AutoVegOnly_qkjowj",
                        "title": "Showing only vegetarian options.",
                        "description": "Tap on the VEG ONLY button to turn off the setting"
                      },
                      "topRatedFilter": {
                        
                      },
                      "kidsCategoryFilter": {
                        "attributes": {
                          "displayText": "Kids Favourites",
                          "tooltip": {
                            "enabled": true,
                            "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                          }
                        }
                      },
                      "vegFilter": {
                        "attributes": {
                          "displayText": "VEG"
                        }
                      },
                      "nonvegFilter": {
                        "attributes": {
                          "displayText": "NONVEG"
                        }
                      }
                    },
                    "relevance": {
                      "type": "RELEVANCE_TYPE_ON_MENU_FILTER_TOGGLED",
                      "sectionId": "MENU_FILTER_TOGGLE"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Recommended",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924443",
                              "name": "Golden Baby Corn",
                              "category": "Veg Starter",
                              "description": "300 gram |  [Energy: 325.18 kcal, Protein: 9.84g, Carbohydrates: 40.6g, Fat: 13.76g]",
                              "imageId": "ocgjpnijydsughgjnkk0",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 30000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "300 gram"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "99 ratings",
                                  "ratingCountV2": "99"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924450",
                              "name": "Paneer 65",
                              "category": "Veg Starter",
                              "description": "300 gram |  [Energy: 723.82 kcal, Protein: 32.95g, Carbohydrates: 30.89g, Fat: 51.82g]",
                              "imageId": "druwjzmfmz7qvepq3bkr",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 32000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "300 gram"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "107 ratings",
                                  "ratingCountV2": "107"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924432",
                              "name": "Aloo Dum Biryani",
                              "category": "Veg Biriyani",
                              "description": "1050 gram |  [Energy: 1415.98 kcal, Protein: 25.46g, Carbohydrates: 226.97g, Fat: 42.15g]",
                              "imageId": "mtuzvgdmipuikj6pxllr",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 28500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "94820390",
                                  "groupName": "Extra",
                                  "choices": [
                                    {
                                      "id": "92412350",
                                      "name": "Extra Masala Pack",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412348",
                                      "name": "Extra Aloo 4 Pcs",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412351",
                                      "name": "Paneer Pcs",
                                      "price": 21000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412349",
                                      "name": "Extra Gravy",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412352",
                                      "name": "Extra Raita",
                                      "price": 1200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "1050 gram"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "554 ratings",
                                  "ratingCountV2": "554"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924440",
                              "name": "Spl Veg Biryani",
                              "category": "Veg Biriyani",
                              "description": "1050 gram |  [Energy: 1327.35 kcal, Protein: 26.99g, Carbohydrates: 213.24g, Fat: 38.46g]",
                              "imageId": "fsitbray4gq1kxcndqqx",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 30000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "94817720",
                                  "groupName": "Extra",
                                  "choices": [
                                    {
                                      "id": "92412350",
                                      "name": "Extra Masala Pack",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412348",
                                      "name": "Extra Aloo 4 Pcs",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412351",
                                      "name": "Paneer Pcs",
                                      "price": 21000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412349",
                                      "name": "Extra Gravy",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412352",
                                      "name": "Extra Raita",
                                      "price": 1200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "1050 gram"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "720 ratings",
                                  "ratingCountV2": "720"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924469",
                              "name": "Paneer Biryani",
                              "category": "Veg Biriyani",
                              "description": "1050 gram |  [Energy: 1800.51 kcal, Protein: 61.42g, Carbohydrates: 198.62g, Fat: 82g]",
                              "imageId": "gehax5kizfwncsgkris2",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 33000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "94820406",
                                  "groupName": "Extra",
                                  "choices": [
                                    {
                                      "id": "92412350",
                                      "name": "Extra Masala Pack",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412348",
                                      "name": "Extra Aloo 4 Pcs",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412351",
                                      "name": "Paneer Pcs",
                                      "price": 21000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412349",
                                      "name": "Extra Gravy",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412352",
                                      "name": "Extra Raita",
                                      "price": 1200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "1050 gram"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "1779 ratings",
                                  "ratingCountV2": "1779"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924459",
                              "name": "Chilly Chicken (Boneless)",
                              "category": "Non-veg Starter",
                              "description": "370 gram |  [Energy: 604.42 kcal, Protein: 50.63g, Carbohydrates: 29.67g, Fat: 30.94g]",
                              "imageId": "ry3c3f518z10t4olu4l7",
                              "inStock": 1,
                              "price": 32000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "370 gram"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "210 ratings",
                                  "ratingCountV2": "210"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924463",
                              "name": "Chicken Lollypop",
                              "category": "Non-veg Starter",
                              "description": "250 gram |  [Energy: 389.14 kcal, Protein: 36.13g, Carbohydrates: 7.31g, Fat: 23.92g]",
                              "imageId": "ldqyxnhlfylhymnsopzc",
                              "inStock": 1,
                              "price": 32500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "250 gram"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "210 ratings",
                                  "ratingCountV2": "210"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924476",
                              "name": "Chilly Chicken (Andhra Style)",
                              "category": "Non-veg Starter",
                              "description": "450 gram |  [Energy: 912.22 kcal, Protein: 68.75g, Carbohydrates: 5.35g, Fat: 67.98g]",
                              "imageId": "gitnmufvwguqai831dlc",
                              "inStock": 1,
                              "price": 32500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "450 gram"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "56 ratings",
                                  "ratingCountV2": "56"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924466",
                              "name": "Lemon Chicken",
                              "category": "Non-veg Starter",
                              "description": "370 gram |  [Energy: 582.12 kcal, Protein: 44.58g, Carbohydrates: 31.16g, Fat: 30.79g]",
                              "imageId": "vnotaq2k5i2nqdigafon",
                              "inStock": 1,
                              "price": 32000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "370 gram"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "159 ratings",
                                  "ratingCountV2": "159"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924478",
                              "name": "Meghana Chicken 555",
                              "category": "Non-veg Starter",
                              "description": "300 gram |  [Energy: 585.13 kcal, Protein: 32.48g, Carbohydrates: 26.88g, Fat: 39.36g]",
                              "imageId": "irnwr59vlrmciau11or0",
                              "inStock": 1,
                              "price": 32500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "128852391",
                                  "groupName": "Extra",
                                  "choices": [
                                    {
                                      "id": "92412705",
                                      "name": "Gravy",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412706",
                                      "name": "Masala Pack",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412707",
                                      "name": "Meghana Chicken Spl Pcs",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412708",
                                      "name": "Raita",
                                      "price": 1200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412703",
                                      "name": "Chicken Boneless Pcs",
                                      "price": 22000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412704",
                                      "name": "Extra Aloo 4 Pcs",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "300 gram"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "205 ratings",
                                  "ratingCountV2": "205"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924453",
                              "name": "Chicken Biryani",
                              "category": "Non-veg Biriyani",
                              "description": "1050 gram |  [Energy: 1615.27 kcal, Protein: 61.82g, Carbohydrates: 190.89g, Fat: 64.63g]",
                              "imageId": "zbrpxvywfsrrb7os11jf",
                              "inStock": 1,
                              "price": 31500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "94819888",
                                  "groupName": "Extra",
                                  "choices": [
                                    {
                                      "id": "92412705",
                                      "name": "Gravy",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412706",
                                      "name": "Masala Pack",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412707",
                                      "name": "Meghana Chicken Spl Pcs",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412708",
                                      "name": "Raita",
                                      "price": 1200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412703",
                                      "name": "Chicken Boneless Pcs",
                                      "price": 22000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412704",
                                      "name": "Extra Aloo 4 Pcs",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "1050 gram"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "1223 ratings",
                                  "ratingCountV2": "1223"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924472",
                              "name": "Chicken Boneless Biryani",
                              "category": "Non-veg Biriyani",
                              "description": "1050 gram |  [Energy: 1446.5 kcal, Protein: 64.22g, Carbohydrates: 189.62g, Fat: 44.2g]",
                              "imageId": "iivuhjc2mswi9lublktf",
                              "inStock": 1,
                              "price": 32500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "94819902",
                                  "groupName": "Extra",
                                  "choices": [
                                    {
                                      "id": "92412705",
                                      "name": "Gravy",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412706",
                                      "name": "Masala Pack",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412707",
                                      "name": "Meghana Chicken Spl Pcs",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412708",
                                      "name": "Raita",
                                      "price": 1200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412703",
                                      "name": "Chicken Boneless Pcs",
                                      "price": 22000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412704",
                                      "name": "Extra Aloo 4 Pcs",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "1050 gram"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "4277 ratings",
                                  "ratingCountV2": "4277"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924467",
                              "name": "Lollipop Biryani",
                              "category": "Non-veg Biriyani",
                              "description": "1050 gram |  [Energy: 1673.09 kcal, Protein: 45.42g, Carbohydrates: 217.95g, Fat: 65.98g]",
                              "imageId": "tscwxqko4pabme8gj2ty",
                              "inStock": 1,
                              "price": 32500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "94819920",
                                  "groupName": "Extra",
                                  "choices": [
                                    {
                                      "id": "92412705",
                                      "name": "Gravy",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412706",
                                      "name": "Masala Pack",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412707",
                                      "name": "Meghana Chicken Spl Pcs",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412708",
                                      "name": "Raita",
                                      "price": 1200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412703",
                                      "name": "Chicken Boneless Pcs",
                                      "price": 22000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412704",
                                      "name": "Extra Aloo 4 Pcs",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "1050 gram"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "81 ratings",
                                  "ratingCountV2": "81"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924480",
                              "name": "Meghana Special Biryani",
                              "category": "Non-veg Biriyani",
                              "description": "1050 gram |  [Energy: 1456.21 kcal, Protein: 64.65g, Carbohydrates: 190.89g, Fat: 44.5g]",
                              "imageId": "zuthvcwjjvdjmo6n1pbl",
                              "inStock": 1,
                              "price": 33000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "94819911",
                                  "groupName": "Extra",
                                  "choices": [
                                    {
                                      "id": "92412705",
                                      "name": "Gravy",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412706",
                                      "name": "Masala Pack",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412707",
                                      "name": "Meghana Chicken Spl Pcs",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412708",
                                      "name": "Raita",
                                      "price": 1200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412703",
                                      "name": "Chicken Boneless Pcs",
                                      "price": 22000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412704",
                                      "name": "Extra Aloo 4 Pcs",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "1050 gram"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "3222 ratings",
                                  "ratingCountV2": "3222"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924505",
                              "name": "Mutton Keema Biryani",
                              "category": "Non-veg Biriyani",
                              "description": "1050 gram |  [Energy: 1551.26 kcal, Protein: 42.47g, Carbohydrates: 200.46g, Fat: 61.1g]",
                              "imageId": "bsswvqauvfo1qg4lqblz",
                              "inStock": 1,
                              "price": 42500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "94819955",
                                  "groupName": "Extra",
                                  "choices": [
                                    {
                                      "id": "92412705",
                                      "name": "Gravy",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412706",
                                      "name": "Masala Pack",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412707",
                                      "name": "Meghana Chicken Spl Pcs",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412708",
                                      "name": "Raita",
                                      "price": 1200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412703",
                                      "name": "Chicken Boneless Pcs",
                                      "price": 22000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412704",
                                      "name": "Extra Aloo 4 Pcs",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "1050 gram"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "82 ratings",
                                  "ratingCountV2": "82"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924500",
                              "name": "Prawns Biryani",
                              "category": "Non-veg Biriyani",
                              "description": "1050 gram |  [Energy: 1431.95 kcal, Protein: 37.34g, Carbohydrates: 213.4g, Fat: 43.56g]",
                              "imageId": "pxqhnjvdhm3nyqkhxute",
                              "inStock": 1,
                              "price": 41500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "94820089",
                                  "groupName": "Extra",
                                  "choices": [
                                    {
                                      "id": "92412705",
                                      "name": "Gravy",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412706",
                                      "name": "Masala Pack",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412707",
                                      "name": "Meghana Chicken Spl Pcs",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412708",
                                      "name": "Raita",
                                      "price": 1200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412703",
                                      "name": "Chicken Boneless Pcs",
                                      "price": 22000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412704",
                                      "name": "Extra Aloo 4 Pcs",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "1050 gram"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "188 ratings",
                                  "ratingCountV2": "188"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924471",
                              "name": "Butter Chicken Curry",
                              "category": "Non-veg Curries",
                              "description": "600 gram |  [Energy: 910.32 kcal, Protein: 50.28g, Carbohydrates: 32.44g, Fat: 63.47g]",
                              "imageId": "mqfjzwea48recubya6or",
                              "inStock": 1,
                              "price": 33000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "600 gram"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "179 ratings",
                                  "ratingCountV2": "179"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924457",
                              "name": "Paneer Butter Masala",
                              "category": "Veg Curries",
                              "description": "550 gram |  [Energy: 1156.81 kcal, Protein: 43.54g, Carbohydrates: 37.93g, Fat: 92.6g]",
                              "imageId": "ksjxi61s8xqlj8cqp4zs",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 32000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "550 gram"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "162 ratings",
                                  "ratingCountV2": "162"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "type": "CATEGORY_TYPE_RECOMMENDED"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Veg Starter",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924433",
                              "name": "Chilly Gobi",
                              "category": "Veg Starter",
                              "description": "350 gram | Serves 1 |  [Energy: 192.99 kcal, Protein: 8.11g, Carbohydrates: 15.54g, Fat: 10.39g]",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 27000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "350 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "12 ratings",
                                  "ratingCountV2": "12"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924434",
                              "name": "Gobi 65",
                              "category": "Veg Starter",
                              "description": "320 gram | Serves 1 |  [Energy: 187.49 kcal, Protein: 7.79g, Carbohydrates: 16.9g, Fat: 9.06g]",
                              "imageId": "q8kk1xz0w0l8oxmcyxdc",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 27000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "320 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "63 ratings",
                                  "ratingCountV2": "63"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924435",
                              "name": "Gobi Manchurian",
                              "category": "Veg Starter",
                              "description": "320 gram | Serves 1 |  [Energy: 194.6 kcal, Protein: 7.96g, Carbohydrates: 15.56g, Fat: 10.89g]",
                              "imageId": "rzh4qydjkaurrpecaxc2",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 27000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "320 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "149 ratings",
                                  "ratingCountV2": "149"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924442",
                              "name": "Baby Corn Manchurian",
                              "category": "Veg Starter",
                              "description": "250 gram | Serves 1 |  [Energy: 258.72 kcal, Protein: 7.42g, Carbohydrates: 32.28g, Fat: 11.45g]",
                              "imageId": "qkg8efaxbjjgx5cpkuax",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 29500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "250 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "60 ratings",
                                  "ratingCountV2": "60"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924438",
                              "name": "Chilly Babycorn",
                              "category": "Veg Starter",
                              "description": "320 gram | Serves 1 |  [Energy: 308.05 kcal, Protein: 8.85g, Carbohydrates: 39.35g, Fat: 12.97g]",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 29500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "320 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "16 ratings",
                                  "ratingCountV2": "16"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924443",
                              "name": "Golden Baby Corn",
                              "category": "Veg Starter",
                              "description": "300 gram | Serves 1 |  [Energy: 325.18 kcal, Protein: 9.84g, Carbohydrates: 40.6g, Fat: 13.76g]",
                              "imageId": "ocgjpnijydsughgjnkk0",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 30000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "300 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "99 ratings",
                                  "ratingCountV2": "99"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924445",
                              "name": "Chilly Mushroom",
                              "category": "Veg Starter",
                              "description": "320 gram | Serves 1 |  [Energy: 203.43 kcal, Protein: 11.25g, Carbohydrates: 15.55g, Fat: 10.64g]",
                              "imageId": "bof3doctupomf223xpzz",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 31500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "320 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "57 ratings",
                                  "ratingCountV2": "57"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924446",
                              "name": "Chilly Paneer",
                              "category": "Veg Starter",
                              "description": "320 gram | Serves 1 |  [Energy: 871.69 kcal, Protein: 51.9g, Carbohydrates: 21.54g, Fat: 64.36g]",
                              "imageId": "byonwwb8mzxyqluxlqpq",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 32000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "320 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "118 ratings",
                                  "ratingCountV2": "118"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924451",
                              "name": "Paneer Manchurian",
                              "category": "Veg Starter",
                              "description": "250 gram | Serves 1 |  [Energy: 706.01 kcal, Protein: 41.58g, Carbohydrates: 18.14g, Fat: 52.24g]",
                              "imageId": "xafpkamsf7oz2ae8lgil",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 32000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "250 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "33 ratings",
                                  "ratingCountV2": "33"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924448",
                              "name": "Mushroom Manchurian",
                              "category": "Veg Starter",
                              "imageId": "soz7jm21okoxcltrobge",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 30500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "15 ratings",
                                  "ratingCountV2": "15"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924452",
                              "name": "Veg Manchurian",
                              "category": "Veg Starter",
                              "description": "230 gram | Serves 1 |  [Energy: 240.61 kcal, Protein: 12.72g, Carbohydrates: 18.83g, Fat: 12.39g]",
                              "imageId": "etnsehnoylzjgipeapde",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 30500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "230 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "49 ratings",
                                  "ratingCountV2": "49"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924447",
                              "name": "Mushroom 65",
                              "category": "Veg Starter",
                              "description": "300 gram | Serves 1 |  [Energy: 196.76 kcal, Protein: 10.27g, Carbohydrates: 16.97g, Fat: 9.35g]",
                              "imageId": "buclixrr4jwtcemyrz68",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 31500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "300 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "69 ratings",
                                  "ratingCountV2": "69"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924450",
                              "name": "Paneer 65",
                              "category": "Veg Starter",
                              "description": "300 gram | Serves 1 |  [Energy: 723.82 kcal, Protein: 32.95g, Carbohydrates: 30.89g, Fat: 51.82g]",
                              "imageId": "druwjzmfmz7qvepq3bkr",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 32000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "300 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "107 ratings",
                                  "ratingCountV2": "107"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "134280589",
                              "name": "Paneer Kabab",
                              "category": "Veg Starter",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 35000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Veg Biriyani",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924432",
                              "name": "Aloo Dum Biryani",
                              "category": "Veg Biriyani",
                              "description": "1050 gram | Serves 1 |  [Energy: 1415.98 kcal, Protein: 25.46g, Carbohydrates: 226.97g, Fat: 42.15g]",
                              "imageId": "mtuzvgdmipuikj6pxllr",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 28500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "94820390",
                                  "groupName": "Extra",
                                  "choices": [
                                    {
                                      "id": "92412350",
                                      "name": "Extra Masala Pack",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412348",
                                      "name": "Extra Aloo 4 Pcs",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412351",
                                      "name": "Paneer Pcs",
                                      "price": 21000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412349",
                                      "name": "Extra Gravy",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412352",
                                      "name": "Extra Raita",
                                      "price": 1200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "1050 gram"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "554 ratings",
                                  "ratingCountV2": "554"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924423",
                              "name": "Veg Biryani Rice",
                              "category": "Veg Biriyani",
                              "imageId": "yiiln3ntc7cwm51l9lhi",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 23000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "94820420",
                                  "groupName": "Extra",
                                  "choices": [
                                    {
                                      "id": "92412350",
                                      "name": "Extra Masala Pack",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412348",
                                      "name": "Extra Aloo 4 Pcs",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412351",
                                      "name": "Paneer Pcs",
                                      "price": 21000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412349",
                                      "name": "Extra Gravy",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412352",
                                      "name": "Extra Raita",
                                      "price": 1200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "301 ratings",
                                  "ratingCountV2": "301"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924440",
                              "name": "Spl Veg Biryani",
                              "category": "Veg Biriyani",
                              "description": "1050 gram | Serves 1 |  [Energy: 1327.35 kcal, Protein: 26.99g, Carbohydrates: 213.24g, Fat: 38.46g]",
                              "imageId": "fsitbray4gq1kxcndqqx",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 30000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "94817720",
                                  "groupName": "Extra",
                                  "choices": [
                                    {
                                      "id": "92412350",
                                      "name": "Extra Masala Pack",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412348",
                                      "name": "Extra Aloo 4 Pcs",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412351",
                                      "name": "Paneer Pcs",
                                      "price": 21000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412349",
                                      "name": "Extra Gravy",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412352",
                                      "name": "Extra Raita",
                                      "price": 1200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "1050 gram"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "720 ratings",
                                  "ratingCountV2": "720"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924470",
                              "name": "Veg Manchurian Biryani",
                              "category": "Veg Biriyani",
                              "description": "1050 gram | Serves 1 |  [Energy: 1218.09 kcal, Protein: 42.53g, Carbohydrates: 176.93g, Fat: 35.32g]",
                              "imageId": "x6hqabmwan7pfwhshqhj",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 32000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "1050 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "185 ratings",
                                  "ratingCountV2": "185"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924468",
                              "name": "Mushroom Biryani",
                              "category": "Veg Biriyani",
                              "description": "1050 gram | Serves 1 |  [Energy: 1225.8 kcal, Protein: 29.42g, Carbohydrates: 186.92g, Fat: 37.51g]",
                              "imageId": "ujngpmxwklmqpruqhx9h",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 33000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "94817780",
                                  "groupName": "Extra",
                                  "choices": [
                                    {
                                      "id": "92412350",
                                      "name": "Extra Masala Pack",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412348",
                                      "name": "Extra Aloo 4 Pcs",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412351",
                                      "name": "Paneer Pcs",
                                      "price": 21000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412349",
                                      "name": "Extra Gravy",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412352",
                                      "name": "Extra Raita",
                                      "price": 1200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "1050 gram"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "396 ratings",
                                  "ratingCountV2": "396"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924469",
                              "name": "Paneer Biryani",
                              "category": "Veg Biriyani",
                              "description": "1050 gram | Serves 1 |  [Energy: 1800.51 kcal, Protein: 61.42g, Carbohydrates: 198.62g, Fat: 82g]",
                              "imageId": "gehax5kizfwncsgkris2",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 33000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "94820406",
                                  "groupName": "Extra",
                                  "choices": [
                                    {
                                      "id": "92412350",
                                      "name": "Extra Masala Pack",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412348",
                                      "name": "Extra Aloo 4 Pcs",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412351",
                                      "name": "Paneer Pcs",
                                      "price": 21000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412349",
                                      "name": "Extra Gravy",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412352",
                                      "name": "Extra Raita",
                                      "price": 1200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "1050 gram"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "1779 ratings",
                                  "ratingCountV2": "1779"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Sea Food Starter",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924485",
                              "name": "Chilly Fish",
                              "category": "Sea Food Starter",
                              "description": "300 gram | Serves 1 |  [Energy: 348.16 kcal, Protein: 43.21g, Carbohydrates: 12.57g, Fat: 14.27g]",
                              "inStock": 1,
                              "price": 34500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "300 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "33 ratings",
                                  "ratingCountV2": "33"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924482",
                              "name": "Apollo Fish",
                              "category": "Sea Food Starter",
                              "description": "270 gram | Serves 1 |  [Energy: 293.75 kcal, Protein: 24.8g, Carbohydrates: 15.07g, Fat: 15.38g]",
                              "imageId": "ywwqavlqhhhwrpzu3nle",
                              "inStock": 1,
                              "price": 35000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "270 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "81 ratings",
                                  "ratingCountV2": "81"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924496",
                              "name": "Chilli Prawns",
                              "category": "Sea Food Starter",
                              "description": "280 gram | Serves 1 |  [Energy: 289.89 kcal, Protein: 28.51g, Carbohydrates: 12.99g, Fat: 13.85g]",
                              "imageId": "gbowveie1vh3zrxegqqb",
                              "inStock": 1,
                              "price": 39500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "280 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "107 ratings",
                                  "ratingCountV2": "107"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924439",
                              "name": "Single Fish Fry",
                              "category": "Sea Food Starter",
                              "description": "250 gram | Serves 1 |  [Energy: 229.01 kcal, Protein: 30.84g, Carbohydrates: 4.83g, Fat: 9.67g]",
                              "imageId": "pakkeubb0v5dngxvyper",
                              "inStock": 1,
                              "price": 30000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "250 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.6",
                                  "ratingCount": "10 ratings",
                                  "ratingCountV2": "10"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924499",
                              "name": "Prawns Fry",
                              "category": "Sea Food Starter",
                              "inStock": 1,
                              "price": 39500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "24 ratings",
                                  "ratingCountV2": "24"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Non-veg Starter",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924455",
                              "name": "Chicken Fry",
                              "category": "Non-veg Starter",
                              "description": "250 gram | Serves 1 |  [Energy: 585.85 kcal, Protein: 29.63g, Carbohydrates: 17.29g, Fat: 44.88g]",
                              "imageId": "fxzktf2iv07u8iqufivx",
                              "inStock": 1,
                              "price": 31000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "250 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "14 ratings",
                                  "ratingCountV2": "14"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924444",
                              "name": "Chicken Kabab",
                              "category": "Non-veg Starter",
                              "imageId": "lxj1uvdkng7zu0npvnsu",
                              "inStock": 1,
                              "price": 31000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "125 ratings",
                                  "ratingCountV2": "125"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924462",
                              "name": "Chicken 65",
                              "category": "Non-veg Starter",
                              "description": "350 gram | Serves 1 |  [Energy: 544.39 kcal, Protein: 45.15g, Carbohydrates: 25.11g, Fat: 27.91g]",
                              "imageId": "x0jegvlf4h7wrgaaqdqi",
                              "inStock": 1,
                              "price": 32000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "350 gram"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "421 ratings",
                                  "ratingCountV2": "421"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924459",
                              "name": "Chilly Chicken (Boneless)",
                              "category": "Non-veg Starter",
                              "description": "370 gram | Serves 1 |  [Energy: 604.42 kcal, Protein: 50.63g, Carbohydrates: 29.67g, Fat: 30.94g]",
                              "imageId": "ry3c3f518z10t4olu4l7",
                              "inStock": 1,
                              "price": 32000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "370 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "210 ratings",
                                  "ratingCountV2": "210"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924463",
                              "name": "Chicken Lollypop",
                              "category": "Non-veg Starter",
                              "description": "250 gram | Serves 1 |  [Energy: 389.14 kcal, Protein: 36.13g, Carbohydrates: 7.31g, Fat: 23.92g]",
                              "imageId": "ldqyxnhlfylhymnsopzc",
                              "inStock": 1,
                              "price": 32500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "250 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "210 ratings",
                                  "ratingCountV2": "210"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924481",
                              "name": "Chicken Pakoda",
                              "category": "Non-veg Starter",
                              "description": "250 gram | Serves 1 |  [Energy: 269.97 kcal, Protein: 38.25g, Carbohydrates: 7.54g, Fat: 8.7g]",
                              "imageId": "txnhcbhyu0kkltnqxyyu",
                              "inStock": 1,
                              "price": 32500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "250 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "115 ratings",
                                  "ratingCountV2": "115"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924476",
                              "name": "Chilly Chicken (Andhra Style)",
                              "category": "Non-veg Starter",
                              "description": "450 gram | Serves 1 |  [Energy: 912.22 kcal, Protein: 68.75g, Carbohydrates: 5.35g, Fat: 67.98g]",
                              "imageId": "gitnmufvwguqai831dlc",
                              "inStock": 1,
                              "price": 32500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "450 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "56 ratings",
                                  "ratingCountV2": "56"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924483",
                              "name": "Chicken Maharaja",
                              "category": "Non-veg Starter",
                              "description": "350 gram | Serves 1 |  [Energy: 601.09 kcal, Protein: 49.21g, Carbohydrates: 31.6g, Fat: 30.39g]",
                              "imageId": "qbvnd4eezzybx9dj38xv",
                              "inStock": 1,
                              "price": 34500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "350 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "127 ratings",
                                  "ratingCountV2": "127"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924484",
                              "name": "Chicken Rayalaseema",
                              "category": "Non-veg Starter",
                              "description": "275 gram | Serves 1 |  [Energy: 555.52 kcal, Protein: 48.05g, Carbohydrates: 9.71g, Fat: 36.1g]",
                              "imageId": "amlh8ivjrwgcx4lxrki8",
                              "inStock": 1,
                              "price": 35000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "275 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "35 ratings",
                                  "ratingCountV2": "35"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924488",
                              "name": "Chicken Leg Roast",
                              "category": "Non-veg Starter",
                              "description": "400 gram | Serves 1 |  [Energy: 1537.16 kcal, Protein: 31.38g, Carbohydrates: 16.89g, Fat: 149.28g]",
                              "imageId": "cpyzm071pqrnuoktg4t4",
                              "inStock": 1,
                              "price": 35500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "400 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "21 ratings",
                                  "ratingCountV2": "21"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924461",
                              "name": "Pepper Chicken",
                              "category": "Non-veg Starter",
                              "description": "350 gram | Serves 1 |  [Energy: 609.63 kcal, Protein: 47.42g, Carbohydrates: 25.62g, Fat: 33.7g]",
                              "imageId": "rlcjzwkysumyh28nxuaq",
                              "inStock": 1,
                              "price": 32000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "350 gram"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "495 ratings",
                                  "ratingCountV2": "495"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924466",
                              "name": "Lemon Chicken",
                              "category": "Non-veg Starter",
                              "description": "370 gram | Serves 1 |  [Energy: 582.12 kcal, Protein: 44.58g, Carbohydrates: 31.16g, Fat: 30.79g]",
                              "imageId": "vnotaq2k5i2nqdigafon",
                              "inStock": 1,
                              "price": 32000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "370 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "159 ratings",
                                  "ratingCountV2": "159"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924478",
                              "name": "Meghana Chicken 555",
                              "category": "Non-veg Starter",
                              "description": "300 gram | Serves 1 |  [Energy: 585.13 kcal, Protein: 32.48g, Carbohydrates: 26.88g, Fat: 39.36g]",
                              "imageId": "irnwr59vlrmciau11or0",
                              "inStock": 1,
                              "price": 32500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "128852391",
                                  "groupName": "Extra",
                                  "choices": [
                                    {
                                      "id": "92412705",
                                      "name": "Gravy",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412706",
                                      "name": "Masala Pack",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412707",
                                      "name": "Meghana Chicken Spl Pcs",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412708",
                                      "name": "Raita",
                                      "price": 1200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412703",
                                      "name": "Chicken Boneless Pcs",
                                      "price": 22000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412704",
                                      "name": "Extra Aloo 4 Pcs",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "300 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "205 ratings",
                                  "ratingCountV2": "205"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924492",
                              "name": "Nati Chicken Fry",
                              "category": "Non-veg Starter",
                              "description": "250 gram | Serves 1 |  [Energy: 585.85 kcal, Protein: 29.63g, Carbohydrates: 17.29g, Fat: 44.88g]",
                              "imageId": "kh3sscrltnyzlbd995sw",
                              "inStock": 1,
                              "price": 36500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "250 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "18 ratings",
                                  "ratingCountV2": "18"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924503",
                              "name": "Mutton Fry",
                              "category": "Non-veg Starter",
                              "imageId": "ezj9gf9w0fcf1ipklggw",
                              "inStock": 1,
                              "price": 41500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "11 ratings",
                                  "ratingCountV2": "11"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924506",
                              "name": "Mutton Pepper Fry",
                              "category": "Non-veg Starter",
                              "description": "200 gram | Serves 1 |  [Energy: 452.55 kcal, Protein: 34.31g, Carbohydrates: 23.89g, Fat: 24.17g]",
                              "imageId": "o2gtnh4ixf24wbvkhgtp",
                              "inStock": 1,
                              "price": 42500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "200 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "40 ratings",
                                  "ratingCountV2": "40"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924504",
                              "name": "Mutton Kheema Fry",
                              "category": "Non-veg Starter",
                              "imageId": "duelwcrkh4piecqicjxk",
                              "inStock": 1,
                              "price": 43500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "16 ratings",
                                  "ratingCountV2": "16"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924489",
                              "name": "Today's Andhra Spl",
                              "category": "Non-veg Starter",
                              "inStock": 1,
                              "price": 35500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924490",
                              "name": "Today's Chinese Spl",
                              "category": "Non-veg Starter",
                              "inStock": 1,
                              "price": 35500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Non-veg Biriyani",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924436",
                              "name": "Egg Biryani",
                              "category": "Non-veg Biriyani",
                              "description": "1000 gram | Serves 1 |  [Energy: 1421.92 kcal, Protein: 38.82g, Carbohydrates: 196.91g, Fat: 50.86g]",
                              "imageId": "wcvun7u8l0jzkzcf8zap",
                              "inStock": 1,
                              "price": 29000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "94820369",
                                  "groupName": "Extra",
                                  "choices": [
                                    {
                                      "id": "92412705",
                                      "name": "Gravy",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412706",
                                      "name": "Masala Pack",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412707",
                                      "name": "Meghana Chicken Spl Pcs",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412708",
                                      "name": "Raita",
                                      "price": 1200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412703",
                                      "name": "Chicken Boneless Pcs",
                                      "price": 22000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412704",
                                      "name": "Extra Aloo 4 Pcs",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "1000 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "308 ratings",
                                  "ratingCountV2": "308"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924453",
                              "name": "Chicken Biryani",
                              "category": "Non-veg Biriyani",
                              "description": "1050 gram | Serves 1 |  [Energy: 1615.27 kcal, Protein: 61.82g, Carbohydrates: 190.89g, Fat: 64.63g]",
                              "imageId": "zbrpxvywfsrrb7os11jf",
                              "inStock": 1,
                              "price": 31500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "94819888",
                                  "groupName": "Extra",
                                  "choices": [
                                    {
                                      "id": "92412705",
                                      "name": "Gravy",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412706",
                                      "name": "Masala Pack",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412707",
                                      "name": "Meghana Chicken Spl Pcs",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412708",
                                      "name": "Raita",
                                      "price": 1200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412703",
                                      "name": "Chicken Boneless Pcs",
                                      "price": 22000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412704",
                                      "name": "Extra Aloo 4 Pcs",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "1050 gram"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "1223 ratings",
                                  "ratingCountV2": "1223"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924472",
                              "name": "Chicken Boneless Biryani",
                              "category": "Non-veg Biriyani",
                              "description": "1050 gram | Serves 1 |  [Energy: 1446.5 kcal, Protein: 64.22g, Carbohydrates: 189.62g, Fat: 44.2g]",
                              "imageId": "iivuhjc2mswi9lublktf",
                              "inStock": 1,
                              "price": 32500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "94819902",
                                  "groupName": "Extra",
                                  "choices": [
                                    {
                                      "id": "92412705",
                                      "name": "Gravy",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412706",
                                      "name": "Masala Pack",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412707",
                                      "name": "Meghana Chicken Spl Pcs",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412708",
                                      "name": "Raita",
                                      "price": 1200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412703",
                                      "name": "Chicken Boneless Pcs",
                                      "price": 22000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412704",
                                      "name": "Extra Aloo 4 Pcs",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "1050 gram"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "4277 ratings",
                                  "ratingCountV2": "4277"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924479",
                              "name": "Chicken Fry Pc Biriyani",
                              "category": "Non-veg Biriyani",
                              "description": "1050 gram | Serves 1 |  [Energy: 1576.65 kcal, Protein: 55.24g, Carbohydrates: 197.77g, Fat: 59.33g]",
                              "imageId": "o6eblssnt4tjn9zzufs0",
                              "inStock": 1,
                              "price": 34000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "94818171",
                                  "groupName": "Extra",
                                  "choices": [
                                    {
                                      "id": "92412705",
                                      "name": "Gravy",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412706",
                                      "name": "Masala Pack",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412707",
                                      "name": "Meghana Chicken Spl Pcs",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412708",
                                      "name": "Raita",
                                      "price": 1200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412703",
                                      "name": "Chicken Boneless Pcs",
                                      "price": 22000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412704",
                                      "name": "Extra Aloo 4 Pcs",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "1050 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "122 ratings",
                                  "ratingCountV2": "122"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924497",
                              "name": "Fish Biriyani",
                              "category": "Non-veg Biriyani",
                              "description": "1050 gram | Serves 1 |  [Energy: 1429.3 kcal, Protein: 55.02g, Carbohydrates: 189.62g, Fat: 47.6g]",
                              "imageId": "cfrtq4lrtjrollvuwyb3",
                              "inStock": 1,
                              "price": 40500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "94820075",
                                  "groupName": "Extra",
                                  "choices": [
                                    {
                                      "id": "92412705",
                                      "name": "Gravy",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412706",
                                      "name": "Masala Pack",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412707",
                                      "name": "Meghana Chicken Spl Pcs",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412708",
                                      "name": "Raita",
                                      "price": 1200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412703",
                                      "name": "Chicken Boneless Pcs",
                                      "price": 22000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412704",
                                      "name": "Extra Aloo 4 Pcs",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "1050 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "63 ratings",
                                  "ratingCountV2": "63"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924422",
                              "name": "Non Veg Biryani Rice",
                              "category": "Non-veg Biriyani",
                              "imageId": "yiiln3ntc7cwm51l9lhi",
                              "inStock": 1,
                              "price": 24000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "94821410",
                                  "groupName": "Extra",
                                  "choices": [
                                    {
                                      "id": "92412705",
                                      "name": "Gravy",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412706",
                                      "name": "Masala Pack",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412707",
                                      "name": "Meghana Chicken Spl Pcs",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412708",
                                      "name": "Raita",
                                      "price": 1200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412703",
                                      "name": "Chicken Boneless Pcs",
                                      "price": 22000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412704",
                                      "name": "Extra Aloo 4 Pcs",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "217 ratings",
                                  "ratingCountV2": "217"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924467",
                              "name": "Lollipop Biryani",
                              "category": "Non-veg Biriyani",
                              "description": "1050 gram | Serves 1 |  [Energy: 1673.09 kcal, Protein: 45.42g, Carbohydrates: 217.95g, Fat: 65.98g]",
                              "imageId": "tscwxqko4pabme8gj2ty",
                              "inStock": 1,
                              "price": 32500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "94819920",
                                  "groupName": "Extra",
                                  "choices": [
                                    {
                                      "id": "92412705",
                                      "name": "Gravy",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412706",
                                      "name": "Masala Pack",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412707",
                                      "name": "Meghana Chicken Spl Pcs",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412708",
                                      "name": "Raita",
                                      "price": 1200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412703",
                                      "name": "Chicken Boneless Pcs",
                                      "price": 22000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412704",
                                      "name": "Extra Aloo 4 Pcs",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "1050 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "81 ratings",
                                  "ratingCountV2": "81"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924480",
                              "name": "Meghana Special Biryani",
                              "category": "Non-veg Biriyani",
                              "description": "1050 gram | Serves 1 |  [Energy: 1456.21 kcal, Protein: 64.65g, Carbohydrates: 190.89g, Fat: 44.5g]",
                              "imageId": "zuthvcwjjvdjmo6n1pbl",
                              "inStock": 1,
                              "price": 33000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "94819911",
                                  "groupName": "Extra",
                                  "choices": [
                                    {
                                      "id": "92412705",
                                      "name": "Gravy",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412706",
                                      "name": "Masala Pack",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412707",
                                      "name": "Meghana Chicken Spl Pcs",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412708",
                                      "name": "Raita",
                                      "price": 1200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412703",
                                      "name": "Chicken Boneless Pcs",
                                      "price": 22000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412704",
                                      "name": "Extra Aloo 4 Pcs",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "1050 gram"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "3222 ratings",
                                  "ratingCountV2": "3222"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924495",
                              "name": "Nati Chicken Biryani",
                              "category": "Non-veg Biriyani",
                              "description": "1050 gram | Serves 1 |  [Energy: 1606.2 kcal, Protein: 58.94g, Carbohydrates: 194.62g, Fat: 63.21g]",
                              "imageId": "rmx0qwkhbmld4x1tety2",
                              "inStock": 1,
                              "price": 39000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "94819927",
                                  "groupName": "Extra",
                                  "choices": [
                                    {
                                      "id": "92412705",
                                      "name": "Gravy",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412706",
                                      "name": "Masala Pack",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412707",
                                      "name": "Meghana Chicken Spl Pcs",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412708",
                                      "name": "Raita",
                                      "price": 1200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412703",
                                      "name": "Chicken Boneless Pcs",
                                      "price": 22000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412704",
                                      "name": "Extra Aloo 4 Pcs",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "1050 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "18 ratings",
                                  "ratingCountV2": "18"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924505",
                              "name": "Mutton Keema Biryani",
                              "category": "Non-veg Biriyani",
                              "description": "1050 gram | Serves 1 |  [Energy: 1551.26 kcal, Protein: 42.47g, Carbohydrates: 200.46g, Fat: 61.1g]",
                              "imageId": "bsswvqauvfo1qg4lqblz",
                              "inStock": 1,
                              "price": 42500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "94819955",
                                  "groupName": "Extra",
                                  "choices": [
                                    {
                                      "id": "92412705",
                                      "name": "Gravy",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412706",
                                      "name": "Masala Pack",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412707",
                                      "name": "Meghana Chicken Spl Pcs",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412708",
                                      "name": "Raita",
                                      "price": 1200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412703",
                                      "name": "Chicken Boneless Pcs",
                                      "price": 22000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412704",
                                      "name": "Extra Aloo 4 Pcs",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "1050 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "82 ratings",
                                  "ratingCountV2": "82"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924507",
                              "name": "Mutton Biryani",
                              "category": "Non-veg Biriyani",
                              "description": "1000 gram | Serves 1 |  [Energy: 1586.02 kcal, Protein: 66.69g, Carbohydrates: 185.36g, Fat: 61.78g]",
                              "imageId": "wqvc9jnr4vhjmkkjiir0",
                              "inStock": 1,
                              "price": 43500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "94819937",
                                  "groupName": "Extra",
                                  "choices": [
                                    {
                                      "id": "92412705",
                                      "name": "Gravy",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412706",
                                      "name": "Masala Pack",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412707",
                                      "name": "Meghana Chicken Spl Pcs",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412708",
                                      "name": "Raita",
                                      "price": 1200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412703",
                                      "name": "Chicken Boneless Pcs",
                                      "price": 22000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412704",
                                      "name": "Extra Aloo 4 Pcs",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "1000 gram"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "361 ratings",
                                  "ratingCountV2": "361"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924500",
                              "name": "Prawns Biryani",
                              "category": "Non-veg Biriyani",
                              "description": "1050 gram | Serves 1 |  [Energy: 1431.95 kcal, Protein: 37.34g, Carbohydrates: 213.4g, Fat: 43.56g]",
                              "imageId": "pxqhnjvdhm3nyqkhxute",
                              "inStock": 1,
                              "price": 41500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "94820089",
                                  "groupName": "Extra",
                                  "choices": [
                                    {
                                      "id": "92412705",
                                      "name": "Gravy",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412706",
                                      "name": "Masala Pack",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412707",
                                      "name": "Meghana Chicken Spl Pcs",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412708",
                                      "name": "Raita",
                                      "price": 1200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412703",
                                      "name": "Chicken Boneless Pcs",
                                      "price": 22000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412704",
                                      "name": "Extra Aloo 4 Pcs",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "1050 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "188 ratings",
                                  "ratingCountV2": "188"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Non-veg Curries",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924420",
                              "name": "Egg Masala Curry",
                              "category": "Non-veg Curries",
                              "description": "450 gram | Serves 1 |  [Energy: 721.81 kcal, Protein: 24.15g, Carbohydrates: 34.03g, Fat: 54.89g]",
                              "imageId": "xqpvlqbixniguvhqvdzb",
                              "inStock": 1,
                              "price": 22500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "450 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "70 ratings",
                                  "ratingCountV2": "70"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924458",
                              "name": "Chicken Boneless Curry",
                              "category": "Non-veg Curries",
                              "description": "500 gram | Serves 1 |  [Energy: 651.37 kcal, Protein: 44.85g, Carbohydrates: 26.52g, Fat: 39.17g]",
                              "imageId": "ybxkminvzggpmjfbecu8",
                              "inStock": 1,
                              "price": 32500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "500 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "322 ratings",
                                  "ratingCountV2": "322"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924454",
                              "name": "Chicken Curry",
                              "category": "Non-veg Curries",
                              "description": "460 gram | Serves 1 |  [Energy: 661.19 kcal, Protein: 35g, Carbohydrates: 33.26g, Fat: 42.53g]",
                              "inStock": 1,
                              "price": 32500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "460 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "31 ratings",
                                  "ratingCountV2": "31"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924474",
                              "name": "Chicken Hyd Curry With Bone",
                              "category": "Non-veg Curries",
                              "inStock": 1,
                              "price": 32500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "20 ratings",
                                  "ratingCountV2": "20"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924471",
                              "name": "Butter Chicken Curry",
                              "category": "Non-veg Curries",
                              "description": "600 gram | Serves 1 |  [Energy: 910.32 kcal, Protein: 50.28g, Carbohydrates: 32.44g, Fat: 63.47g]",
                              "imageId": "mqfjzwea48recubya6or",
                              "inStock": 1,
                              "price": 33000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "600 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "179 ratings",
                                  "ratingCountV2": "179"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924494",
                              "name": "Fish Curry",
                              "category": "Non-veg Curries",
                              "description": "440 gram | Serves 1 |  [Energy: 489.84 kcal, Protein: 26.83g, Carbohydrates: 26.33g, Fat: 30.55g]",
                              "inStock": 1,
                              "price": 38500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "440 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "10 ratings",
                                  "ratingCountV2": "10"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924421",
                              "name": "Tomato Egg Curry",
                              "category": "Non-veg Curries",
                              "description": "450 gram | Serves 1 |  [Energy: 545.12 kcal, Protein: 16.69g, Carbohydrates: 25.14g, Fat: 41.96g]",
                              "inStock": 1,
                              "price": 23500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "450 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "11 ratings",
                                  "ratingCountV2": "11"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924487",
                              "name": "Nati Chicken Curry",
                              "category": "Non-veg Curries",
                              "description": "460 gram | Serves 1 |  [Energy: 757.15 kcal, Protein: 33.3g, Carbohydrates: 33.26g, Fat: 54.67g]",
                              "imageId": "gxwjneetuercelgtio4x",
                              "inStock": 1,
                              "price": 35500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "460 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "31 ratings",
                                  "ratingCountV2": "31"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924502",
                              "name": "Mutton Curry",
                              "category": "Non-veg Curries",
                              "description": "460 gram | Serves 1 |  [Energy: 687.42 kcal, Protein: 97.57g, Carbohydrates: 8.12g, Fat: 26.64g]",
                              "imageId": "f7ckmzlbdykejeqlmjbh",
                              "inStock": 1,
                              "price": 41500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "460 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "68 ratings",
                                  "ratingCountV2": "68"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924498",
                              "name": "Prawns Curry",
                              "category": "Non-veg Curries",
                              "description": "440 gram | Serves 1 |  [Energy: 468.91 kcal, Protein: 19.92g, Carbohydrates: 26.95g, Fat: 30.84g]",
                              "imageId": "x28cgy0rmpxluhsv0lzr",
                              "inStock": 1,
                              "price": 41000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "440 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "23 ratings",
                                  "ratingCountV2": "23"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Veg Tandoor",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924431",
                              "name": "Aloo Tikka",
                              "category": "Veg Tandoor",
                              "description": "350 gram | Serves 1 |  [Energy: 718.86 kcal, Protein: 22.44g, Carbohydrates: 126.17g, Fat: 19.89g]",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 28800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "350 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924460",
                              "name": "Paneer Tikka",
                              "category": "Veg Tandoor",
                              "description": "410 gram | Serves 1 |  [Energy: 1389.63 kcal, Protein: 65.29g, Carbohydrates: 147.69g, Fat: 69.03g]",
                              "imageId": "khgxfbaaeviitfhdqlg7",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 32800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "410 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "64 ratings",
                                  "ratingCountV2": "64"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Non-veg Tandoor",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "107164555",
                              "name": "Chicken Tandoori",
                              "category": "Non-veg Tandoor",
                              "imageId": "z5zp6cisie3mlpswfl0w",
                              "inStock": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "23252796",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "75763249",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "id": "75763250",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "23252796",
                                        "variationId": "75763249"
                                      }
                                    ],
                                    "price": 33300,
                                    "addonCombinations": [
                                      {
                                        "groupId": "94820103",
                                        "addonId": "92412353"
                                      },
                                      {
                                        "groupId": "94820103",
                                        "addonId": "92412354"
                                      },
                                      {
                                        "groupId": "94820103",
                                        "addonId": "92412355"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "23252796",
                                        "variationId": "75763250"
                                      }
                                    ],
                                    "price": 61100,
                                    "addonCombinations": [
                                      {
                                        "groupId": "94820103",
                                        "addonId": "92412353"
                                      },
                                      {
                                        "groupId": "94820103",
                                        "addonId": "92412354"
                                      },
                                      {
                                        "groupId": "94820103",
                                        "addonId": "92412355"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 33300,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "317 ratings",
                                  "ratingCountV2": "317"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924464",
                              "name": "Chicken Tikka",
                              "category": "Non-veg Tandoor",
                              "description": "300 gram | Serves 1 |  [Energy: 741 kcal, Protein: 50.85g, Carbohydrates: 93.75g, Fat: 23.4g]",
                              "imageId": "ii9y7l6jozcqk6msrbpw",
                              "inStock": 1,
                              "price": 33300,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "300 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "100 ratings",
                                  "ratingCountV2": "100"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "107164556",
                              "name": "Kalmi Kabab (4 Pieces)",
                              "category": "Non-veg Tandoor",
                              "description": "350 gram | Serves 1 |  [Energy: 816.9 kcal, Protein: 64.75g, Carbohydrates: 43.75g, Fat: 45.43g]",
                              "imageId": "vfoyuqphpexme2xzkabf",
                              "inStock": 1,
                              "price": 34300,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "350 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "114 ratings",
                                  "ratingCountV2": "114"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115620486",
                              "name": "Non Veg Tandoori Today Spl",
                              "category": "Non-veg Tandoor",
                              "inStock": 1,
                              "price": 37800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "107255862",
                              "name": "Tandoori Chicken Platter",
                              "category": "Non-veg Tandoor",
                              "imageId": "modyzt1k7m56zxunfhf5",
                              "inStock": 1,
                              "price": 67600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "17 ratings",
                                  "ratingCountV2": "17"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Indian Breads",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924391",
                              "name": "Tandoori Roti",
                              "category": "Indian Breads",
                              "description": "100 gram | Serves 1 |  [Energy: 341 kcal, Protein: 12.1g, Carbohydrates: 69.4g, Fat: 1.7g]",
                              "imageId": "yzlluiabjyc9b5xm0u7v",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 4000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "100 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "140 ratings",
                                  "ratingCountV2": "140"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924394",
                              "name": "Butter Tandoori Roti",
                              "category": "Indian Breads",
                              "description": "100 gram | Serves 1 |  [Energy: 354.77 kcal, Protein: 11.18g, Carbohydrates: 63.82g, Fat: 6.23g]",
                              "imageId": "km888m8jtexrr54ukvsf",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 4500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "100 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "121 ratings",
                                  "ratingCountV2": "121"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924399",
                              "name": "Naan",
                              "category": "Indian Breads",
                              "description": "100 gram | Serves 1 |  [Energy: 249.96 kcal, Protein: 8.22g, Carbohydrates: 47.99g, Fat: 2.43g]",
                              "imageId": "zhehanswdbtjel9vjn5t",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 4500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "100 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "67 ratings",
                                  "ratingCountV2": "67"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924400",
                              "name": "Butter Naan",
                              "category": "Indian Breads",
                              "description": "110 gram | Serves 1 |  [Energy: 304.82 kcal, Protein: 8.57g, Carbohydrates: 49.72g, Fat: 7.7g]",
                              "imageId": "vsboj7w5fg5likd24jca",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "110 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "221 ratings",
                                  "ratingCountV2": "221"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924401",
                              "name": "Garlic Naan",
                              "category": "Indian Breads",
                              "description": "125 gram | Serves 1 |  [Energy: 303.22 kcal, Protein: 10.18g, Carbohydrates: 58.09g, Fat: 2.87g]",
                              "imageId": "ef7dhf6vv8ncnvlbrkux",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "125 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "141 ratings",
                                  "ratingCountV2": "141"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924402",
                              "name": "Kulcha",
                              "category": "Indian Breads",
                              "description": "100 gram | Serves 1 |  [Energy: 222.05 kcal, Protein: 7.74g, Carbohydrates: 38g, Fat: 4g]",
                              "imageId": "dfn6dm1daa224wym6jgv",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "100 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "51 ratings",
                                  "ratingCountV2": "51"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924404",
                              "name": "Butter Kulcha",
                              "category": "Indian Breads",
                              "description": "100 gram | Serves 1 |  [Energy: 244.35 kcal, Protein: 7.06g, Carbohydrates: 34.47g, Fat: 7.1g]",
                              "imageId": "gajieufhbxtgyukag2c8",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "100 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "74 ratings",
                                  "ratingCountV2": "74"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Egg",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924392",
                              "name": "Boiled Egg (2nos)",
                              "category": "Egg",
                              "description": "120 gram | Serves 1 |  [Energy: 161.75 kcal, Protein: 15.94g, Carbohydrates: 0g, Fat: 10.98g]",
                              "imageId": "cu8lzfhxtzgzcd0c0wga",
                              "inStock": 1,
                              "price": 4000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "120 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "83 ratings",
                                  "ratingCountV2": "83"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924411",
                              "name": "Chilly Egg",
                              "category": "Egg",
                              "description": "270 gram | Serves 1 |  [Energy: 753.36 kcal, Protein: 17.51g, Carbohydrates: 36.97g, Fat: 60.84g]",
                              "imageId": "txicrqgqrl1nmgj4iay6",
                              "inStock": 1,
                              "price": 19500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "270 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "59 ratings",
                                  "ratingCountV2": "59"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Veg Curries",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924412",
                              "name": "Dal Fry",
                              "category": "Veg Curries",
                              "description": "450 gram | Serves 1 |  [Energy: 471.22 kcal, Protein: 18g, Carbohydrates: 52.05g, Fat: 20.93g]",
                              "imageId": "czmhxhzvc8lqklawenrv",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "450 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "96 ratings",
                                  "ratingCountV2": "96"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924425",
                              "name": "Aloo Matar Curry",
                              "category": "Veg Curries",
                              "description": "550 gram | Serves 1 |  [Energy: 658.32 kcal, Protein: 18.86g, Carbohydrates: 57.86g, Fat: 38.08g]",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 26000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "550 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "10 ratings",
                                  "ratingCountV2": "10"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924426",
                              "name": "Green Peas Curry",
                              "category": "Veg Curries",
                              "description": "530 gram | Serves 1 |  [Energy: 675.07 kcal, Protein: 22.48g, Carbohydrates: 52.47g, Fat: 40.67g]",
                              "imageId": "izr6y2zxm2o7j8bgj9s2",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 26000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "530 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "17 ratings",
                                  "ratingCountV2": "17"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924417",
                              "name": "Tomato Curry",
                              "category": "Veg Curries",
                              "description": "450 gram | Serves 1 |  [Energy: 509.47 kcal, Protein: 6.93g, Carbohydrates: 25.05g, Fat: 42.21g]",
                              "imageId": "thpbu9owje2ut4r7gk0d",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 21000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "450 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "20 ratings",
                                  "ratingCountV2": "20"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924428",
                              "name": "Veg Kadai",
                              "category": "Veg Curries",
                              "description": "550 gram | Serves 1 |  [Energy: 729.09 kcal, Protein: 20.61g, Carbohydrates: 37.87g, Fat: 54.45g]",
                              "imageId": "iffbbbz435xq2c0uzxxt",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 26000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "550 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "78 ratings",
                                  "ratingCountV2": "78"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924427",
                              "name": "Mix Vegetable Curry",
                              "category": "Veg Curries",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 27500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "12 ratings",
                                  "ratingCountV2": "12"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924430",
                              "name": "Veg Hyderabadi Curry",
                              "category": "Veg Curries",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 27500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "18 ratings",
                                  "ratingCountV2": "18"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924449",
                              "name": "Palak Paneer Curry",
                              "category": "Veg Curries",
                              "description": "550 gram | Serves 1 |  [Energy: 833.69 kcal, Protein: 30.72g, Carbohydrates: 33.75g, Fat: 64.01g]",
                              "imageId": "slaicd3fv71xcsxblb2w",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 31000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "550 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "24 ratings",
                                  "ratingCountV2": "24"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924456",
                              "name": "Mushroom Masala",
                              "category": "Veg Curries",
                              "description": "450 gram | Serves 1 |  [Energy: 537.7 kcal, Protein: 13.09g, Carbohydrates: 34.48g, Fat: 38.75g]",
                              "imageId": "gqjbuq7xoyuxolxsprjp",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 32000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "450 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "55 ratings",
                                  "ratingCountV2": "55"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924457",
                              "name": "Paneer Butter Masala",
                              "category": "Veg Curries",
                              "description": "550 gram | Serves 1 |  [Energy: 1156.81 kcal, Protein: 43.54g, Carbohydrates: 37.93g, Fat: 92.6g]",
                              "imageId": "ksjxi61s8xqlj8cqp4zs",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 32000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "550 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "162 ratings",
                                  "ratingCountV2": "162"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924477",
                              "name": "Kaju Masala",
                              "category": "Veg Curries",
                              "description": "370 gram | Serves 1 |  [Energy: 780.95 kcal, Protein: 15.53g, Carbohydrates: 39.3g, Fat: 62.27g]",
                              "imageId": "jwcsply1spuntwiy6ory",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 32500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "370 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "35 ratings",
                                  "ratingCountV2": "35"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Rice",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924410",
                              "name": "Curd Rice",
                              "category": "Rice",
                              "description": "600 gram | Serves 1 |  [Energy: 569.98 kcal, Protein: 24.32g, Carbohydrates: 58.63g, Fat: 25.64g]",
                              "imageId": "ojyjwksfduvct4jrqglo",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "600 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "174 ratings",
                                  "ratingCountV2": "174"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924418",
                              "name": "Ghee Rice",
                              "category": "Rice",
                              "description": "1050 gram | Serves 1 |  [Energy: 1824.4 kcal, Protein: 25.93g, Carbohydrates: 246.6g, Fat: 78.23g]",
                              "imageId": "wm9rg7kwm8ujpcal9u2z",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 20500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "1050 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "69 ratings",
                                  "ratingCountV2": "69"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924419",
                              "name": "Jeera Rice",
                              "category": "Rice",
                              "description": "1050 gram | Serves 1 |  [Energy: 1832.3 kcal, Protein: 27.51g, Carbohydrates: 246.73g, Fat: 78.15g]",
                              "imageId": "xukq8swrwct8usmg4cjv",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 21000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "1050 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "45 ratings",
                                  "ratingCountV2": "45"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924429",
                              "name": "Egg Fried Rice",
                              "category": "Rice",
                              "description": "1050 gram | Serves 1 |  [Energy: 1729.51 kcal, Protein: 44.03g, Carbohydrates: 204.54g, Fat: 79.02g]",
                              "imageId": "lv6jl9qdscekjmwkxm9l",
                              "inStock": 1,
                              "price": 26000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "1050 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "82 ratings",
                                  "ratingCountV2": "82"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924437",
                              "name": "Chicken Fried Rice",
                              "category": "Rice",
                              "description": "700 gram | Serves 1 |  [Energy: 1142.26 kcal, Protein: 40.11g, Carbohydrates: 125.05g, Fat: 51.37g]",
                              "imageId": "akmx533z73jjbq8avy6v",
                              "inStock": 1,
                              "price": 29000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "700 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "136 ratings",
                                  "ratingCountV2": "136"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924424",
                              "name": "Veg Fried Rice",
                              "category": "Rice",
                              "description": "1050 gram | Serves 1 |  [Energy: 1477 kcal, Protein: 22.9g, Carbohydrates: 204.14g, Fat: 59.95g]",
                              "imageId": "pycpbzawueci1dvhmkr3",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 24500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "1050 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "132 ratings",
                                  "ratingCountV2": "132"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Beverages",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115662687",
                              "name": "500 Ml Water Bottle",
                              "category": "Beverages",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 955,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115662690",
                              "name": "Buttermilk",
                              "category": "Beverages",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6400,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924405",
                              "name": "Coke Tin 330 Ml",
                              "category": "Beverages",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6666,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "12 ratings",
                                  "ratingCountV2": "12"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924406",
                              "name": "Sprite Tin 330 Ml",
                              "category": "Beverages",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6666,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924407",
                              "name": "Thums Up Tin 330 Ml",
                              "category": "Beverages",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6666,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "10 ratings",
                                  "ratingCountV2": "10"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "120085511",
                              "name": "Diet Coke 330 Ml Tin",
                              "category": "Beverages",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6667,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "9 ratings",
                                  "ratingCountV2": "9"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "120085510",
                              "name": "Fanta 330 Ml Tin",
                              "category": "Beverages",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6667,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131145331",
                              "name": "Blue Lime Juice",
                              "category": "Beverages",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8400,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131144821",
                              "name": "Arabian Grape",
                              "category": "Beverages",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12400,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131145338",
                              "name": "Mint Lime Juice",
                              "category": "Beverages",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8400,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117075900",
                              "name": "Lassi",
                              "category": "Beverages",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "36060645",
                                    "name": "Type",
                                    "variations": [
                                      {
                                        "name": "Sweet",
                                        "id": "112084140",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Salt",
                                        "default": 1,
                                        "id": "112084139",
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36060645",
                                        "variationId": "112084139"
                                      }
                                    ],
                                    "price": 9900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36060645",
                                        "variationId": "112084140"
                                      }
                                    ],
                                    "price": 9900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 9900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.6",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131145337",
                              "name": "Meghana Sarbath",
                              "category": "Beverages",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131145336",
                              "name": "Mango Lassi",
                              "category": "Beverages",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131144822",
                              "name": "Meghana Special Lassi",
                              "category": "Beverages",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131145341",
                              "name": "Strawberry Lassi",
                              "category": "Beverages",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Extra",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115907344",
                              "name": "Paper Plate",
                              "category": "Extra",
                              "inStock": 1,
                              "price": 1000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "21 ratings",
                                  "ratingCountV2": "21"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115662688",
                              "name": "Raita",
                              "category": "Extra",
                              "imageId": "juyijxp6bswclaw3uuaq",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 1200,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "95 ratings",
                                  "ratingCountV2": "95"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115662689",
                              "name": "Gravy",
                              "category": "Extra",
                              "imageId": "x8nlpx0doxhanlnplqx9",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "58 ratings",
                                  "ratingCountV2": "58"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116393941",
                              "name": "Extra Aloo 4 Pcs",
                              "category": "Extra",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 4000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "18 ratings",
                                  "ratingCountV2": "18"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924415",
                              "name": "Chicken Boneless Pcs",
                              "category": "Extra",
                              "imageId": "apypbgt1qvkqjvjkkmkg",
                              "inStock": 1,
                              "price": 22000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "94821467",
                                  "groupName": "Extra",
                                  "choices": [
                                    {
                                      "id": "92412350",
                                      "name": "Extra Masala Pack",
                                      "price": 10500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412348",
                                      "name": "Extra Aloo 4 Pcs",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412351",
                                      "name": "Paneer Pcs",
                                      "price": 21000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412349",
                                      "name": "Extra Gravy",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92412352",
                                      "name": "Extra Raita",
                                      "price": 1200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "59 ratings",
                                  "ratingCountV2": "59"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117075901",
                              "name": "Masala Pack",
                              "category": "Extra",
                              "imageId": "pderw7h3flvbytkaoe01",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924414",
                              "name": "Paneer Pcs",
                              "category": "Extra",
                              "imageId": "y2umnx7fqzcl6vtf3mad",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 21000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "38 ratings",
                                  "ratingCountV2": "38"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106924416",
                              "name": "Meghana Chicken Spl Pcs",
                              "category": "Extra",
                              "imageId": "z0nhfbn5wz2ckwqzoedm",
                              "inStock": 1,
                              "price": 22500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "73 ratings",
                                  "ratingCountV2": "73"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Day Special",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "111061264",
                              "name": "Chicken Roast",
                              "category": "Day Special",
                              "description": "450 gram | Serves 1 |  [Energy: 1183.19 kcal, Protein: 56.88g, Carbohydrates: 24.24g, Fat: 95.8g]",
                              "imageId": "fep49gjof7cfmbtzg2xx",
                              "inStock": 1,
                              "price": 35500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "450 gram"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "10 ratings",
                                  "ratingCountV2": "10"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "111061266",
                              "name": "Guntur Chicken Dry",
                              "category": "Day Special",
                              "imageId": "lqztcufd3ousnznlrh6o",
                              "inStock": 1,
                              "price": 35500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                      "name": "Meghana Foods",
                      "area": "Sarjapur Road",
                      "completeAddress": "SY No.18/2A, 1ST FLOOR G R S TOWERS SARJAPURA ROAD,BELLANDUR BANGALORE ,Mahadevapura , B.B.M.P East,Karnataka, 560102"
                    }
                  }
                }
              ]
            }
          }
        }
      }
    ],
    "firstOffsetRequest": true,
    "isQCLink": false
  },
  "tid": "8091b6c9-34ec-4881-8b5e-d2b6a4328fa1",
  "sid": "c8b69dc8-6710-47a7-bc63-18091856e3fa",
  "deviceId": "c73fa13e-69cf-472b-8071-076091f9d98d",
  "csrfToken": "NnffFNJ4rfrD-K1pGMQzxA42ICia-uWv34qPAXwI"
}

export const BAKINGO=
{
  "statusCode": 0,
  "data": {
    "statusMessage": "done successfully",
    "cards": [
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
            "info": {
              "id": "50467",
              "name": "Bakingo",
              "city": "Bangalore",
              "slugs": {
                "restaurant": "bakingo-koramangala-koramangala",
                "city": "bangalore"
              },
              "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
              "cloudinaryImageId": "fa68ac0434f668bba1322abda36570b3",
              "locality": "1st Block",
              "areaName": "Koramangala",
              "costForTwo": "30000",
              "costForTwoMessage": "₹300 for two",
              "cuisines": [
                "Bakery",
                "Desserts"
              ],
              "avgRating": 4.3,
              "feeDetails": {
                "restaurantId": "50467",
                "fees": [
                  {
                    "name": "distance",
                    "fee": 4100
                  },
                  {
                    "name": "time"
                  },
                  {
                    "name": "special"
                  }
                ],
                "totalFee": 4100,
                "icon": "v1648635511/Delivery_fee_new_cjxumu",
                "message": "3 kms | ₹41 Delivery fee will apply"
              },
              "parentId": "3818",
              "avgRatingString": "4.3",
              "totalRatingsString": "5K+ ratings",
              "sla": {
                "restaurantId": "50467",
                "deliveryTime": 31,
                "minDeliveryTime": 30,
                "maxDeliveryTime": 35,
                "lastMileTravel": 3,
                "serviceability": "SERVICEABLE",
                "stressFactor": 1,
                "rainMode": "RAIN_MODE_NONE",
                "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
                "zoneId": 1,
                "slaString": "30-35 MINS",
                "lastMileTravelString": "3.0 km",
                "iconType": "ICON_TYPE_EMPTY"
              },
              "availability": {
                "nextCloseTime": "2024-02-19 01:00:00",
                "visibility": true,
                "opened": true,
                "restaurantClosedMeta": {
                  
                }
              },
              "aggregatedDiscountInfo": {
                "header": "Flat ₹125 off",
                "shortDescriptionList": [
                  {
                    "meta": "Flat ₹125 off on orders above ₹399",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "Flat ₹125 off on orders above ₹399 | Use code SWIGGYWEEKENDS",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹100 off | Above ₹550",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "visible": true
              },
              "badges": {
                
              },
              "slugString": "bakingo-koramangala-koramangala",
              "multiOutlet": true,
              "isOpen": true,
              "labels": [
                {
                  "title": "Timings",
                  "message": "null"
                },
                {
                  "title": "Address",
                  "message": "No. 2, 1st Floor, 4th Cross Kormangala 1st Block, Jakkasandra Extension Sarjapur Road Bangalore 560034 Karnataka"
                },
                {
                  "title": "Cuisines",
                  "message": "Bakery,Desserts"
                }
              ],
              "logo": "rng/md/carousel/production/sy7qlk0rswg7hi1xlvls",
              "totalRatings": 5000,
              "aggregatedDiscountInfoV2": {
                "header": "Flat ₹125 off",
                "shortDescriptionList": [
                  {
                    "meta": "Flat ₹125 off on orders above ₹399",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "Flat ₹125 off on orders above ₹399 | Use code SWIGGYWEEKENDS",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹100 off | Above ₹550",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "couponDetailsCta": "View coupon details"
              },
              "type": "F",
              "nudgeBanners": [
                {
                  "minValue": 279,
                  "maxValue": 399,
                  "priority": 1,
                  "couponCode": "SWIGGYWEEKENDS",
                  "discountInfo": {
                    "discountType": "Flat",
                    "value": 125
                  },
                  "lockedMessage": "Add items worth ₹<amount> to save ₹125 | Code SWIGGYWEEKENDS",
                  "unlockedMessage": "SWIGGYWEEKENDS Coupon Unlocked! Use it to save ₹125",
                  "logoCtx": {
                    
                  }
                }
              ],
              "headerBanner": {
                "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/50467"
              },
              "expectationNotifiers": [
                {
                  "text": "3 kms | ₹41 Delivery fee will apply",
                  "icon": {
                    "imageId": "v1648635511/Delivery_fee_new_cjxumu"
                  },
                  "popup": {
                    "cta": {
                      
                    }
                  },
                  "type": "DISTANCE_FEE_NON_FOOD_LM",
                  "enrichedText": "<b>3 kms</b> | ₹41 Delivery fee will apply",
                  "halfCardPopup": {
                    "halfCardPopupHeader": {
                      
                    }
                  }
                }
              ],
              "generalPurposeInfoListV2": [
                {
                  "cta": {
                    "info": {
                      "recordings": {
                        
                      }
                    },
                    "linkCta": {
                      
                    }
                  }
                }
              ],
              "ratingSlab": "RATING_SLAB_5",
              "orderabilityCommunication": {
                "title": {
                  
                },
                "subTitle": {
                  
                },
                "message": {
                  
                },
                "customIcon": {
                  
                }
              },
              "hasBestsellerItems": true,
              "cartOrderabilityNudgeBanner": {
                "parameters": {
                  
                },
                "presentation": {
                  
                }
              },
              "latLong": "12.92485570012125,77.63859918783567",
              "hasKidscategoryItems": true,
              "backgroundImageOverlayInfo": {
                
              }
            },
            "analytics": {
              
            }
          },
          "relevance": {
            "type": "RELEVANCE_TYPE_CHECK_ORDERABILITY_ON_ITEM_ADD",
            "sectionId": "POP_UP_CROUTON_MENU"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "layout": {
              "rows": 1,
              "columns": 5,
              "horizontalScrollEnabled": true,
              "itemSpacing": 12,
              "lineSpacing": 10,
              "widgetPadding": {
                
              },
              "containerStyle": {
                "containerPadding": {
                  "left": 10,
                  "right": 10,
                  "bottom": 16
                }
              },
              "scrollBar": {
                
              }
            },
            "id": "offerCollectionWidget_UX4",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                "offers": [
                  {
                    "info": {
                      "header": "FLAT ₹125 OFF",
                      "offerTag": "FLAT DEAL",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "0b0f38cd-02ad-47d5-b12e-2ceca24ef440"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE SWIGGYWEEKENDS",
                      "description": "ABOVE ₹399",
                      "offerType": "offers",
                      "restId": "50467",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹100 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "MARKETING_BANNERS/IMAGES/OFFERS/2024/2/17/1ed4245d-31e3-4dc6-b949-524a33b9b8c9_ICICI.png",
                      "offerIds": [
                        "299f5c31-dd4a-47a4-8d93-4ccb6be1a8a8"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "NO CODE REQUIRED",
                      "description": "ABOVE ₹550",
                      "offerType": "offers",
                      "restId": "50467",
                      "offerLogo": "MARKETING_BANNERS/IMAGES/OFFERS/2024/2/17/1ed4245d-31e3-4dc6-b949-524a33b9b8c9_ICICI.png",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹50 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "MARKETING_BANNERS/IMAGES/OFFERS/2024/2/16/d2280c74-96d1-4a1d-afd6-4270a05b5488_ICICI.png",
                      "offerIds": [
                        "72b12a41-597c-4c87-a813-32c46574fde9"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "NO CODE REQUIRED",
                      "description": "ABOVE ₹500",
                      "offerType": "offers",
                      "restId": "50467",
                      "offerLogo": "MARKETING_BANNERS/IMAGES/OFFERS/2024/2/16/d2280c74-96d1-4a1d-afd6-4270a05b5488_ICICI.png",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "15% OFF UPTO ₹300",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/15fb1cfe885005447dc8375e7970600f",
                      "offerIds": [
                        "c313f07b-4a9c-451e-ab52-586759f42642"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE CITIFOODIE",
                      "description": "ABOVE ₹1200",
                      "offerType": "offers",
                      "restId": "50467",
                      "offerLogo": "rng/md/ads/production/15fb1cfe885005447dc8375e7970600f",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹30 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/7f31c9e47ddd7e6a3c16d21553c0ca60",
                      "offerIds": [
                        "269c382d-796f-45cd-bd15-0b8b891c5e0c"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE SIMPL30",
                      "description": "ABOVE ₹300",
                      "offerType": "offers",
                      "restId": "50467",
                      "offerLogo": "rng/md/ads/production/7f31c9e47ddd7e6a3c16d21553c0ca60",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  }
                ],
                "habitMilestoneInfo": {
                  "callout": {
                    
                  }
                },
                "loyaltyDiscoverPresentationInfo": {
                  "logoCtx": {
                    
                  }
                }
              }
            }
          }
        }
      },
      {
        "groupedCard": {
          "cardGroupMap": {
            "REGULAR": {
              "cards": [
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                      "badges": {
                        
                      },
                      "vegOnlyDetails": {
                        "imageId": "AutoVegOnly_qkjowj",
                        "title": "Showing only vegetarian options.",
                        "description": "Tap on the VEG ONLY button to turn off the setting"
                      },
                      "topRatedFilter": {
                        
                      },
                      "kidsCategoryFilter": {
                        "attributes": {
                          "displayText": "Kids Favourites",
                          "tooltip": {
                            "enabled": true,
                            "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                          }
                        }
                      },
                      "vegFilter": {
                        "attributes": {
                          "displayText": "VEG"
                        }
                      },
                      "nonvegFilter": {
                        "attributes": {
                          "displayText": "NONVEG"
                        }
                      }
                    },
                    "relevance": {
                      "type": "RELEVANCE_TYPE_ON_MENU_FILTER_TOGGLED",
                      "sectionId": "MENU_FILTER_TOGGLE"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuCarousel",
                      "title": "Top Picks",
                      "carousel": [
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1601929",
                          "creativeId": "TopPicks/BBChcake",
                          "title": "Biscoff Baked Cheesecake (600 gm)",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "112797569",
                              "name": "Biscoff Baked Cheesecake (600 gm)",
                              "category": "Baked Cheesecakes",
                              "description": "Serves 1 | A delectable cheesecake prepared with fresh cream, infused with cream cheese and topped with a Lotus Biscoff Biscuit",
                              "imageId": "ee62781b41b4adaf15aef6ec38e1d27e",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 89900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "82998556",
                                  "groupName": "Add On - Birthday Caps",
                                  "choices": [
                                    {
                                      "id": "35198445",
                                      "name": "Birthday Caps For Girls",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198444",
                                      "name": "Birthday Cap for Boys",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "82998557",
                                  "groupName": "Add On -  Candles",
                                  "choices": [
                                    {
                                      "id": "35198447",
                                      "name": "Flower Candle",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198448",
                                      "name": "One Pack Magic Candle",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198446",
                                      "name": "'BIRTHDAY' Letter Candles",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "82998558",
                                  "groupName": "Add On - Roses",
                                  "choices": [
                                    {
                                      "id": "35198449",
                                      "name": "Single Red Rose",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198451",
                                      "name": "6 Red rose Bunch",
                                      "price": 39900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198450",
                                      "name": "10 Red rose Bunch",
                                      "price": 54900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "82998559",
                                  "groupName": "Add On - Extras",
                                  "choices": [
                                    {
                                      "id": "35198457",
                                      "name": "Set of 50 balloons (deflated)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198453",
                                      "name": "6 Inch Teddy Bear",
                                      "price": 29900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198452",
                                      "name": "Set of 2 Party Poppers",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198455",
                                      "name": "Happy Birthday Banner",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113484081",
                                      "name": "Set of 2 Party Poppers",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1601977",
                          "creativeId": "TopPicks/BBCSlice",
                          "title": "Blueberry Bake Cheesecake Slice",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "92637741",
                              "name": "Blueberry Bake Cheesecake Slice",
                              "category": "Baked Cheesecakes",
                              "description": "Serves 1 | A light & creamy cheese cake with blueberry pulp baked with cream cheese",
                              "imageId": "f532ecd6ffae5ca5b75cf0f18c1123ac",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1602056",
                          "creativeId": "TopPicks/BCMJCake",
                          "title": "Belgian Chocolate Mousse Jar Cake",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "112797567",
                              "name": "Belgian Chocolate Mousse Jar Cake",
                              "category": "Jar Cake",
                              "description": "Serves 1 | A mousse based chocolate jar cake prepared with milk chocolate, fresh cream, chocolate sponge and nutella.",
                              "imageId": "14456111aaf9b8147aa1553fcd5d6950",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "82998555",
                                  "groupName": "Add On",
                                  "choices": [
                                    {
                                      "id": "35198447",
                                      "name": "Flower Candle",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198448",
                                      "name": "One Pack Magic Candle",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198449",
                                      "name": "Single Red Rose",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102193391",
                                      "name": "Premium Bakingo Opener",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1602176",
                          "creativeId": "TopPicks/NHJCake",
                          "title": "Nutella Hazelnut Jar Cake",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "112797566",
                              "name": "Nutella Hazelnut Jar Cake",
                              "category": "Jar Cake",
                              "description": "Serves 1 | Milk chocolate based jar with chocolate sponge topped with hazelnuts and nutella glaze.",
                              "imageId": "ea22765173608e8273e442a110b81d93",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1602254",
                          "creativeId": "TopPicks/CTCake",
                          "title": "Choco Truffle Cake",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "11860034",
                              "name": "Choco Truffle Cake",
                              "category": "Cakes",
                              "description": "Serves 1 | A decadent and exotic combination of melted chocolate and truffles augmented with a streak of white chocolate to top it off",
                              "imageId": "zwv6dwhw82s4u38byk8o",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "14031523",
                                    "name": "Choose your Cake Size",
                                    "variations": [
                                      {
                                        "name": "500 gm",
                                        "price": 499,
                                        "default": 1,
                                        "id": "45439077",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "1 Kg",
                                        "price": 899,
                                        "id": "45439078",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "14031523",
                                        "variationId": "45439077"
                                      }
                                    ],
                                    "price": 49900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "73139725",
                                        "addonId": "35198444"
                                      },
                                      {
                                        "groupId": "73139725",
                                        "addonId": "35198445"
                                      },
                                      {
                                        "groupId": "73139726",
                                        "addonId": "35198446"
                                      },
                                      {
                                        "groupId": "73139726",
                                        "addonId": "35198447"
                                      },
                                      {
                                        "groupId": "73139726",
                                        "addonId": "35198448"
                                      },
                                      {
                                        "groupId": "73139727",
                                        "addonId": "35198449"
                                      },
                                      {
                                        "groupId": "73139727",
                                        "addonId": "35198451"
                                      },
                                      {
                                        "groupId": "73139727",
                                        "addonId": "35198450"
                                      },
                                      {
                                        "groupId": "73139729",
                                        "addonId": "35198455"
                                      },
                                      {
                                        "groupId": "73139729",
                                        "addonId": "35198452"
                                      },
                                      {
                                        "groupId": "73139729",
                                        "addonId": "35198457"
                                      },
                                      {
                                        "groupId": "73139729",
                                        "addonId": "35198453"
                                      },
                                      {
                                        "groupId": "73139729",
                                        "addonId": "113484081"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "14031523",
                                        "variationId": "45439078"
                                      }
                                    ],
                                    "price": 89900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "73139725",
                                        "addonId": "35198444"
                                      },
                                      {
                                        "groupId": "73139725",
                                        "addonId": "35198445"
                                      },
                                      {
                                        "groupId": "73139726",
                                        "addonId": "35198446"
                                      },
                                      {
                                        "groupId": "73139726",
                                        "addonId": "35198447"
                                      },
                                      {
                                        "groupId": "73139726",
                                        "addonId": "35198448"
                                      },
                                      {
                                        "groupId": "73139727",
                                        "addonId": "35198449"
                                      },
                                      {
                                        "groupId": "73139727",
                                        "addonId": "35198451"
                                      },
                                      {
                                        "groupId": "73139727",
                                        "addonId": "35198450"
                                      },
                                      {
                                        "groupId": "73139729",
                                        "addonId": "35198455"
                                      },
                                      {
                                        "groupId": "73139729",
                                        "addonId": "35198452"
                                      },
                                      {
                                        "groupId": "73139729",
                                        "addonId": "35198457"
                                      },
                                      {
                                        "groupId": "73139729",
                                        "addonId": "35198453"
                                      },
                                      {
                                        "groupId": "73139729",
                                        "addonId": "113484081"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "73139725",
                                  "groupName": "Add On - Birthday Caps",
                                  "choices": [
                                    {
                                      "id": "35198445",
                                      "name": "Birthday Caps For Girls",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198444",
                                      "name": "Birthday Cap for Boys",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "73139726",
                                  "groupName": "Add On -  Candles",
                                  "choices": [
                                    {
                                      "id": "35198447",
                                      "name": "Flower Candle",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198448",
                                      "name": "One Pack Magic Candle",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198446",
                                      "name": "'BIRTHDAY' Letter Candles",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "73139727",
                                  "groupName": "Add On - Roses",
                                  "choices": [
                                    {
                                      "id": "35198449",
                                      "name": "Single Red Rose",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198451",
                                      "name": "6 Red rose Bunch",
                                      "price": 39900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198450",
                                      "name": "10 Red rose Bunch",
                                      "price": 54900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "73139729",
                                  "groupName": "Add On - Extras",
                                  "choices": [
                                    {
                                      "id": "35198457",
                                      "name": "Set of 50 balloons (deflated)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198453",
                                      "name": "6 Inch Teddy Bear",
                                      "price": 29900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198452",
                                      "name": "Set of 2 Party Poppers",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198455",
                                      "name": "Happy Birthday Banner",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113484081",
                                      "name": "Set of 2 Party Poppers",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 49900,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Recommended",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "11860110",
                              "name": "Strawberry Pastry",
                              "category": "Season Special",
                              "description": "Serves 1 | A strawberry pastry is a delightful and indulgent baked treat that features the sweet and vibrant flavor of fresh strawberries",
                              "imageId": "58a06f01bc972de404a7b50588f6bd6d",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "9 ratings",
                                  "ratingCountV2": "9"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "11860101",
                              "name": "Butterscotch Pastry",
                              "category": "Pastries",
                              "description": "Serves 1 | A childhood favourite combines butterscotch chips with choco sticks, white marbles & whipped cream",
                              "imageId": "v5je8qzy4w8s0conzzxo",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "63645722",
                                  "groupName": "Add On",
                                  "choices": [
                                    {
                                      "id": "35198447",
                                      "name": "Flower Candle",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198448",
                                      "name": "One Pack Magic Candle",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198449",
                                      "name": "Single Red Rose",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102193391",
                                      "name": "Premium Bakingo Opener",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "489 ratings",
                                  "ratingCountV2": "489"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "11860100",
                              "name": "Black Forest Pastry",
                              "category": "Pastries",
                              "description": "Serves 1 | A crowd favourite and for good reason. Multiple layers of moist chocolate topped with whipped cream and garnished with chocolate flakes.",
                              "imageId": "ebrjhlgnsshuinjxbuof",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "63645645",
                                  "groupName": "Add On",
                                  "choices": [
                                    {
                                      "id": "35198447",
                                      "name": "Flower Candle",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198448",
                                      "name": "One Pack Magic Candle",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198449",
                                      "name": "Single Red Rose",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102193391",
                                      "name": "Premium Bakingo Opener",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "468 ratings",
                                  "ratingCountV2": "468"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "11860069",
                              "name": "Chocolate Jar Cake",
                              "category": "Jar Cake",
                              "description": "Serves 1 | A thick layered velvety chocolate classic in a jar",
                              "imageId": "laozbxohmfnvce2l4f6z",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "14031637",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Mini (200ml)",
                                        "price": 109,
                                        "default": 1,
                                        "id": "45439308",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large (375ml)",
                                        "price": 199,
                                        "id": "45439309",
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "14031637",
                                        "variationId": "45439308"
                                      }
                                    ],
                                    "price": 10900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "63645895",
                                        "addonId": "35198447"
                                      },
                                      {
                                        "groupId": "63645895",
                                        "addonId": "35198448"
                                      },
                                      {
                                        "groupId": "63645895",
                                        "addonId": "35198449"
                                      },
                                      {
                                        "groupId": "63645895",
                                        "addonId": "102193391"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "14031637",
                                        "variationId": "45439309"
                                      }
                                    ],
                                    "price": 19900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "63645895",
                                        "addonId": "35198447"
                                      },
                                      {
                                        "groupId": "63645895",
                                        "addonId": "35198448"
                                      },
                                      {
                                        "groupId": "63645895",
                                        "addonId": "35198449"
                                      },
                                      {
                                        "groupId": "63645895",
                                        "addonId": "102193391"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "63645895",
                                  "groupName": "Add On",
                                  "choices": [
                                    {
                                      "id": "35198447",
                                      "name": "Flower Candle",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198448",
                                      "name": "One Pack Magic Candle",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198449",
                                      "name": "Single Red Rose",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102193391",
                                      "name": "Premium Bakingo Opener",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 10900,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "325 ratings",
                                  "ratingCountV2": "325"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "33576352",
                              "name": "Red Velvet Jar Cake",
                              "category": "Jar Cake",
                              "description": "Serves 1 | A perfct construction of red velvet goodness, carfully layered with vanilla cream and infused with vanilla essence makes for the perfect red velvet cake in a jar",
                              "imageId": "eba8fb9aa7a92797a97af17520bcd749",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "14032227",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Mini (200ml)",
                                        "price": 129,
                                        "default": 1,
                                        "id": "45440595",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large (375ml)",
                                        "price": 199,
                                        "id": "45440597",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "14032227",
                                        "variationId": "45440595"
                                      }
                                    ],
                                    "price": 12900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "63646103",
                                        "addonId": "35198447"
                                      },
                                      {
                                        "groupId": "63646103",
                                        "addonId": "35198448"
                                      },
                                      {
                                        "groupId": "63646103",
                                        "addonId": "35198449"
                                      },
                                      {
                                        "groupId": "63646103",
                                        "addonId": "102193391"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "14032227",
                                        "variationId": "45440597"
                                      }
                                    ],
                                    "price": 19900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "63646103",
                                        "addonId": "35198447"
                                      },
                                      {
                                        "groupId": "63646103",
                                        "addonId": "35198448"
                                      },
                                      {
                                        "groupId": "63646103",
                                        "addonId": "35198449"
                                      },
                                      {
                                        "groupId": "63646103",
                                        "addonId": "102193391"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "63646103",
                                  "groupName": "Add On",
                                  "choices": [
                                    {
                                      "id": "35198447",
                                      "name": "Flower Candle",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198448",
                                      "name": "One Pack Magic Candle",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198449",
                                      "name": "Single Red Rose",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102193391",
                                      "name": "Premium Bakingo Opener",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 12900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "175 ratings",
                                  "ratingCountV2": "175"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "11860067",
                              "name": "Blueberry Jar Cake",
                              "category": "Jar Cake",
                              "description": "Serves 1 | An exotic mix of fresh blueberry pulp and freshly baked cake in a jar is a seasoal treat",
                              "imageId": "rxbbzo6bj4tkbzbkypmr",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "14031440",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Mini (200ml)",
                                        "price": 129,
                                        "default": 1,
                                        "id": "45438903",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large (375ml)",
                                        "price": 229,
                                        "id": "45438904",
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "14031440",
                                        "variationId": "45438903"
                                      }
                                    ],
                                    "price": 12900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "63645681",
                                        "addonId": "35198447"
                                      },
                                      {
                                        "groupId": "63645681",
                                        "addonId": "35198448"
                                      },
                                      {
                                        "groupId": "63645681",
                                        "addonId": "35198449"
                                      },
                                      {
                                        "groupId": "63645681",
                                        "addonId": "102193391"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "14031440",
                                        "variationId": "45438904"
                                      }
                                    ],
                                    "price": 22900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "63645681",
                                        "addonId": "35198447"
                                      },
                                      {
                                        "groupId": "63645681",
                                        "addonId": "35198448"
                                      },
                                      {
                                        "groupId": "63645681",
                                        "addonId": "35198449"
                                      },
                                      {
                                        "groupId": "63645681",
                                        "addonId": "102193391"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "63645681",
                                  "groupName": "Add On",
                                  "choices": [
                                    {
                                      "id": "35198447",
                                      "name": "Flower Candle",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198448",
                                      "name": "One Pack Magic Candle",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198449",
                                      "name": "Single Red Rose",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102193391",
                                      "name": "Premium Bakingo Opener",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 12900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "111 ratings",
                                  "ratingCountV2": "111"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47790339",
                              "name": "Chocolate Snicker Cake",
                              "category": "Cakes",
                              "description": "Serves 1 | A dark, rich & chocolaty bind of mocha, snickers & melted chocolate is pure indulgence",
                              "imageId": "b92a91d0db96679e466319687383d5d3",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "14032267",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "500 gm",
                                        "price": 599,
                                        "default": 1,
                                        "id": "45440678",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "1 Kg",
                                        "price": 1149,
                                        "id": "45440679",
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "14032267",
                                        "variationId": "45440678"
                                      }
                                    ],
                                    "price": 59900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "48694925",
                                        "addonId": "35198444"
                                      },
                                      {
                                        "groupId": "48694925",
                                        "addonId": "35198445"
                                      },
                                      {
                                        "groupId": "48694951",
                                        "addonId": "35198446"
                                      },
                                      {
                                        "groupId": "48694951",
                                        "addonId": "35198447"
                                      },
                                      {
                                        "groupId": "48694951",
                                        "addonId": "35198448"
                                      },
                                      {
                                        "groupId": "48694975",
                                        "addonId": "35198449"
                                      },
                                      {
                                        "groupId": "48694975",
                                        "addonId": "35198451"
                                      },
                                      {
                                        "groupId": "48694975",
                                        "addonId": "35198450"
                                      },
                                      {
                                        "groupId": "48694996",
                                        "addonId": "35198455"
                                      },
                                      {
                                        "groupId": "48694996",
                                        "addonId": "35198452"
                                      },
                                      {
                                        "groupId": "48694996",
                                        "addonId": "35198457"
                                      },
                                      {
                                        "groupId": "48694996",
                                        "addonId": "35198453"
                                      },
                                      {
                                        "groupId": "48694996",
                                        "addonId": "113484081"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "14032267",
                                        "variationId": "45440679"
                                      }
                                    ],
                                    "price": 114900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "48694925",
                                        "addonId": "35198444"
                                      },
                                      {
                                        "groupId": "48694925",
                                        "addonId": "35198445"
                                      },
                                      {
                                        "groupId": "48694951",
                                        "addonId": "35198446"
                                      },
                                      {
                                        "groupId": "48694951",
                                        "addonId": "35198447"
                                      },
                                      {
                                        "groupId": "48694951",
                                        "addonId": "35198448"
                                      },
                                      {
                                        "groupId": "48694975",
                                        "addonId": "35198449"
                                      },
                                      {
                                        "groupId": "48694975",
                                        "addonId": "35198451"
                                      },
                                      {
                                        "groupId": "48694975",
                                        "addonId": "35198450"
                                      },
                                      {
                                        "groupId": "48694996",
                                        "addonId": "35198455"
                                      },
                                      {
                                        "groupId": "48694996",
                                        "addonId": "35198452"
                                      },
                                      {
                                        "groupId": "48694996",
                                        "addonId": "35198457"
                                      },
                                      {
                                        "groupId": "48694996",
                                        "addonId": "35198453"
                                      },
                                      {
                                        "groupId": "48694996",
                                        "addonId": "113484081"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "48694925",
                                  "groupName": "Add On - Birthday Caps",
                                  "choices": [
                                    {
                                      "id": "35198445",
                                      "name": "Birthday Caps For Girls",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198444",
                                      "name": "Birthday Cap for Boys",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "48694951",
                                  "groupName": "Add On -  Candles",
                                  "choices": [
                                    {
                                      "id": "35198447",
                                      "name": "Flower Candle",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198448",
                                      "name": "One Pack Magic Candle",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198446",
                                      "name": "'BIRTHDAY' Letter Candles",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "48694975",
                                  "groupName": "Add On - Roses",
                                  "choices": [
                                    {
                                      "id": "35198449",
                                      "name": "Single Red Rose",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198451",
                                      "name": "6 Red rose Bunch",
                                      "price": 39900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198450",
                                      "name": "10 Red rose Bunch",
                                      "price": 54900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "48694996",
                                  "groupName": "Add On - Extras",
                                  "choices": [
                                    {
                                      "id": "35198457",
                                      "name": "Set of 50 balloons (deflated)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198453",
                                      "name": "6 Inch Teddy Bear",
                                      "price": 29900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198452",
                                      "name": "Set of 2 Party Poppers",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198455",
                                      "name": "Happy Birthday Banner",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113484081",
                                      "name": "Set of 2 Party Poppers",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 59900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "148 ratings",
                                  "ratingCountV2": "148"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "11860025",
                              "name": "Black Forest Cake",
                              "category": "Cakes",
                              "description": "Serves 1 | A crowd favourite and for good reason. Multiple layers of moist chocolate topped with whipped cream and garnished with chocolate flakes & a cherry on top",
                              "imageId": "xnznp2fkndvgpndt2dyl",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "14031402",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "500 gm",
                                        "price": 449,
                                        "default": 1,
                                        "id": "45438823",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "1 Kg",
                                        "price": 750,
                                        "id": "45438824",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "14031402",
                                        "variationId": "45438823"
                                      }
                                    ],
                                    "price": 44900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "48687893",
                                        "addonId": "35198444"
                                      },
                                      {
                                        "groupId": "48687893",
                                        "addonId": "35198445"
                                      },
                                      {
                                        "groupId": "48687898",
                                        "addonId": "35198446"
                                      },
                                      {
                                        "groupId": "48687898",
                                        "addonId": "35198447"
                                      },
                                      {
                                        "groupId": "48687898",
                                        "addonId": "35198448"
                                      },
                                      {
                                        "groupId": "48687903",
                                        "addonId": "35198449"
                                      },
                                      {
                                        "groupId": "48687903",
                                        "addonId": "35198451"
                                      },
                                      {
                                        "groupId": "48687903",
                                        "addonId": "35198450"
                                      },
                                      {
                                        "groupId": "48687910",
                                        "addonId": "35198455"
                                      },
                                      {
                                        "groupId": "48687910",
                                        "addonId": "35198452"
                                      },
                                      {
                                        "groupId": "48687910",
                                        "addonId": "35198457"
                                      },
                                      {
                                        "groupId": "48687910",
                                        "addonId": "35198453"
                                      },
                                      {
                                        "groupId": "48687910",
                                        "addonId": "113484081"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "14031402",
                                        "variationId": "45438824"
                                      }
                                    ],
                                    "price": 75000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "48687893",
                                        "addonId": "35198444"
                                      },
                                      {
                                        "groupId": "48687893",
                                        "addonId": "35198445"
                                      },
                                      {
                                        "groupId": "48687898",
                                        "addonId": "35198446"
                                      },
                                      {
                                        "groupId": "48687898",
                                        "addonId": "35198447"
                                      },
                                      {
                                        "groupId": "48687898",
                                        "addonId": "35198448"
                                      },
                                      {
                                        "groupId": "48687903",
                                        "addonId": "35198449"
                                      },
                                      {
                                        "groupId": "48687903",
                                        "addonId": "35198451"
                                      },
                                      {
                                        "groupId": "48687903",
                                        "addonId": "35198450"
                                      },
                                      {
                                        "groupId": "48687910",
                                        "addonId": "35198455"
                                      },
                                      {
                                        "groupId": "48687910",
                                        "addonId": "35198452"
                                      },
                                      {
                                        "groupId": "48687910",
                                        "addonId": "35198457"
                                      },
                                      {
                                        "groupId": "48687910",
                                        "addonId": "35198453"
                                      },
                                      {
                                        "groupId": "48687910",
                                        "addonId": "113484081"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "48687893",
                                  "groupName": "Add On - Birthday Caps",
                                  "choices": [
                                    {
                                      "id": "35198445",
                                      "name": "Birthday Caps For Girls",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198444",
                                      "name": "Birthday Cap for Boys",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "48687898",
                                  "groupName": "Add On -  Candles",
                                  "choices": [
                                    {
                                      "id": "35198447",
                                      "name": "Flower Candle",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198448",
                                      "name": "One Pack Magic Candle",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198446",
                                      "name": "'BIRTHDAY' Letter Candles",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "48687903",
                                  "groupName": "Add On - Roses",
                                  "choices": [
                                    {
                                      "id": "35198449",
                                      "name": "Single Red Rose",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198451",
                                      "name": "6 Red rose Bunch",
                                      "price": 39900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198450",
                                      "name": "10 Red rose Bunch",
                                      "price": 54900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "48687910",
                                  "groupName": "Add On - Extras",
                                  "choices": [
                                    {
                                      "id": "35198457",
                                      "name": "Set of 50 balloons (deflated)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198453",
                                      "name": "6 Inch Teddy Bear",
                                      "price": 29900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198452",
                                      "name": "Set of 2 Party Poppers",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198455",
                                      "name": "Happy Birthday Banner",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113484081",
                                      "name": "Set of 2 Party Poppers",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 44900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "259 ratings",
                                  "ratingCountV2": "259"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "11860044",
                              "name": "German Black Forest Cake",
                              "category": "Cakes",
                              "description": "Serves 1 | A crowd favourite and for good reason. Multiple layers of moist German chocolate topped with whipped cream and garnished with chocolate flakes & a cherry on top",
                              "imageId": "b93222c67463070fc45ced51a432faac",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "14031886",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "500 gm",
                                        "price": 479,
                                        "default": 1,
                                        "id": "45439845",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "1 Kg",
                                        "price": 850,
                                        "id": "45439847",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "14031886",
                                        "variationId": "45439845"
                                      }
                                    ],
                                    "price": 47900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "48691631",
                                        "addonId": "35198444"
                                      },
                                      {
                                        "groupId": "48691631",
                                        "addonId": "35198445"
                                      },
                                      {
                                        "groupId": "48691643",
                                        "addonId": "35198446"
                                      },
                                      {
                                        "groupId": "48691643",
                                        "addonId": "35198447"
                                      },
                                      {
                                        "groupId": "48691643",
                                        "addonId": "35198448"
                                      },
                                      {
                                        "groupId": "48691668",
                                        "addonId": "35198449"
                                      },
                                      {
                                        "groupId": "48691668",
                                        "addonId": "35198451"
                                      },
                                      {
                                        "groupId": "48691668",
                                        "addonId": "35198450"
                                      },
                                      {
                                        "groupId": "48691688",
                                        "addonId": "35198455"
                                      },
                                      {
                                        "groupId": "48691688",
                                        "addonId": "35198452"
                                      },
                                      {
                                        "groupId": "48691688",
                                        "addonId": "35198457"
                                      },
                                      {
                                        "groupId": "48691688",
                                        "addonId": "35198453"
                                      },
                                      {
                                        "groupId": "48691688",
                                        "addonId": "113484081"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "14031886",
                                        "variationId": "45439847"
                                      }
                                    ],
                                    "price": 85000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "48691631",
                                        "addonId": "35198444"
                                      },
                                      {
                                        "groupId": "48691631",
                                        "addonId": "35198445"
                                      },
                                      {
                                        "groupId": "48691643",
                                        "addonId": "35198446"
                                      },
                                      {
                                        "groupId": "48691643",
                                        "addonId": "35198447"
                                      },
                                      {
                                        "groupId": "48691643",
                                        "addonId": "35198448"
                                      },
                                      {
                                        "groupId": "48691668",
                                        "addonId": "35198449"
                                      },
                                      {
                                        "groupId": "48691668",
                                        "addonId": "35198451"
                                      },
                                      {
                                        "groupId": "48691668",
                                        "addonId": "35198450"
                                      },
                                      {
                                        "groupId": "48691688",
                                        "addonId": "35198455"
                                      },
                                      {
                                        "groupId": "48691688",
                                        "addonId": "35198452"
                                      },
                                      {
                                        "groupId": "48691688",
                                        "addonId": "35198457"
                                      },
                                      {
                                        "groupId": "48691688",
                                        "addonId": "35198453"
                                      },
                                      {
                                        "groupId": "48691688",
                                        "addonId": "113484081"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "48691631",
                                  "groupName": "Add On - Birthday Caps",
                                  "choices": [
                                    {
                                      "id": "35198445",
                                      "name": "Birthday Caps For Girls",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198444",
                                      "name": "Birthday Cap for Boys",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "48691643",
                                  "groupName": "Add On -  Candles",
                                  "choices": [
                                    {
                                      "id": "35198447",
                                      "name": "Flower Candle",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198448",
                                      "name": "One Pack Magic Candle",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198446",
                                      "name": "'BIRTHDAY' Letter Candles",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "48691668",
                                  "groupName": "Add On - Roses",
                                  "choices": [
                                    {
                                      "id": "35198449",
                                      "name": "Single Red Rose",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198451",
                                      "name": "6 Red rose Bunch",
                                      "price": 39900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198450",
                                      "name": "10 Red rose Bunch",
                                      "price": 54900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "48691688",
                                  "groupName": "Add On - Extras",
                                  "choices": [
                                    {
                                      "id": "35198457",
                                      "name": "Set of 50 balloons (deflated)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198453",
                                      "name": "6 Inch Teddy Bear",
                                      "price": 29900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198452",
                                      "name": "Set of 2 Party Poppers",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198455",
                                      "name": "Happy Birthday Banner",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113484081",
                                      "name": "Set of 2 Party Poppers",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 47900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "176 ratings",
                                  "ratingCountV2": "176"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "52138349",
                              "name": "Red Velvet Cake",
                              "category": "Cakes",
                              "description": "Serves 1 | A vanilla based red velvet cake dressed in red velvet crumbs with dollops of whipped cream",
                              "imageId": "xcj4thrsskl8knl6xxgf",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "14032491",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "500 gm",
                                        "price": 599,
                                        "default": 1,
                                        "id": "45441138",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "1 Kg",
                                        "price": 1049,
                                        "id": "45441137",
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "14032491",
                                        "variationId": "45441138"
                                      }
                                    ],
                                    "price": 59900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "48697628",
                                        "addonId": "35198444"
                                      },
                                      {
                                        "groupId": "48697628",
                                        "addonId": "35198445"
                                      },
                                      {
                                        "groupId": "48697645",
                                        "addonId": "35198446"
                                      },
                                      {
                                        "groupId": "48697645",
                                        "addonId": "35198447"
                                      },
                                      {
                                        "groupId": "48697645",
                                        "addonId": "35198448"
                                      },
                                      {
                                        "groupId": "48697662",
                                        "addonId": "35198449"
                                      },
                                      {
                                        "groupId": "48697662",
                                        "addonId": "35198451"
                                      },
                                      {
                                        "groupId": "48697662",
                                        "addonId": "35198450"
                                      },
                                      {
                                        "groupId": "48697679",
                                        "addonId": "35198455"
                                      },
                                      {
                                        "groupId": "48697679",
                                        "addonId": "35198452"
                                      },
                                      {
                                        "groupId": "48697679",
                                        "addonId": "35198457"
                                      },
                                      {
                                        "groupId": "48697679",
                                        "addonId": "35198453"
                                      },
                                      {
                                        "groupId": "48697679",
                                        "addonId": "113484081"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "14032491",
                                        "variationId": "45441137"
                                      }
                                    ],
                                    "price": 104900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "48697628",
                                        "addonId": "35198444"
                                      },
                                      {
                                        "groupId": "48697628",
                                        "addonId": "35198445"
                                      },
                                      {
                                        "groupId": "48697645",
                                        "addonId": "35198446"
                                      },
                                      {
                                        "groupId": "48697645",
                                        "addonId": "35198447"
                                      },
                                      {
                                        "groupId": "48697645",
                                        "addonId": "35198448"
                                      },
                                      {
                                        "groupId": "48697662",
                                        "addonId": "35198449"
                                      },
                                      {
                                        "groupId": "48697662",
                                        "addonId": "35198451"
                                      },
                                      {
                                        "groupId": "48697662",
                                        "addonId": "35198450"
                                      },
                                      {
                                        "groupId": "48697679",
                                        "addonId": "35198455"
                                      },
                                      {
                                        "groupId": "48697679",
                                        "addonId": "35198452"
                                      },
                                      {
                                        "groupId": "48697679",
                                        "addonId": "35198457"
                                      },
                                      {
                                        "groupId": "48697679",
                                        "addonId": "35198453"
                                      },
                                      {
                                        "groupId": "48697679",
                                        "addonId": "113484081"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "48697628",
                                  "groupName": "Add On - Birthday Caps",
                                  "choices": [
                                    {
                                      "id": "35198445",
                                      "name": "Birthday Caps For Girls",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198444",
                                      "name": "Birthday Cap for Boys",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "48697645",
                                  "groupName": "Add On -  Candles",
                                  "choices": [
                                    {
                                      "id": "35198447",
                                      "name": "Flower Candle",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198448",
                                      "name": "One Pack Magic Candle",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198446",
                                      "name": "'BIRTHDAY' Letter Candles",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "48697662",
                                  "groupName": "Add On - Roses",
                                  "choices": [
                                    {
                                      "id": "35198449",
                                      "name": "Single Red Rose",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198451",
                                      "name": "6 Red rose Bunch",
                                      "price": 39900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198450",
                                      "name": "10 Red rose Bunch",
                                      "price": 54900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "48697679",
                                  "groupName": "Add On - Extras",
                                  "choices": [
                                    {
                                      "id": "35198457",
                                      "name": "Set of 50 balloons (deflated)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198453",
                                      "name": "6 Inch Teddy Bear",
                                      "price": 29900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198452",
                                      "name": "Set of 2 Party Poppers",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198455",
                                      "name": "Happy Birthday Banner",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113484081",
                                      "name": "Set of 2 Party Poppers",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 59900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "107 ratings",
                                  "ratingCountV2": "107"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "92637741",
                              "name": "Blueberry Bake Cheesecake Slice",
                              "category": "Baked Cheesecakes",
                              "description": "Serves 1 | A light & creamy cheese cake with blueberry pulp baked with cream cheese",
                              "imageId": "f532ecd6ffae5ca5b75cf0f18c1123ac",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "257 ratings",
                                  "ratingCountV2": "257"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "25967100",
                              "name": "Classic Walnut Brownie",
                              "category": "Brownie & Tarts",
                              "description": "Serves 1 | A classic brownie Bakingo style. Infused with milkmaid, fresh cream and Vanleer dark chocolate, inundated with walnuts.",
                              "imageId": "1f27dba287121fbb4df192b7c67ede64",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "14031659",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Single",
                                        "price": 89,
                                        "default": 1,
                                        "id": "45439353",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Pack of 6",
                                        "price": 499,
                                        "id": "45439354",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "14031659",
                                        "variationId": "45439353"
                                      }
                                    ],
                                    "price": 8900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "14031659",
                                        "variationId": "45439354"
                                      }
                                    ],
                                    "price": 49900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 8900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "161 ratings",
                                  "ratingCountV2": "161"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "25967101",
                              "name": "Nutella Brownie",
                              "category": "Brownie & Tarts",
                              "description": "Serves 1 | The quintessential indulgent brownie prepared with milk maid, fresh cream & CHD 45 Chocolate, infused with Nutella and hazelnuts.",
                              "imageId": "2fca02ee8233a9b0f93455565458a8ae",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "31693292",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Single",
                                        "price": 109,
                                        "default": 1,
                                        "id": "98052121",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Pack of 6",
                                        "price": 649,
                                        "id": "98052122",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "31693292",
                                        "variationId": "98052121"
                                      }
                                    ],
                                    "price": 10900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "31693292",
                                        "variationId": "98052122"
                                      }
                                    ],
                                    "price": 64900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 10900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "213 ratings",
                                  "ratingCountV2": "213"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "25968052",
                              "name": "Blueberry Cup Cake",
                              "category": "Cup Cakes",
                              "description": "Serves 1 | Fresh blueberry pulp topped with whipped cream & sprinkles in a cup cake",
                              "imageId": "bqct0qlenq6npiooqtjo",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "14031428",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Single",
                                        "price": 79,
                                        "default": 1,
                                        "id": "45438878",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Double",
                                        "price": 109,
                                        "id": "45438879",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Pack Of 6",
                                        "price": 299,
                                        "id": "45438880",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "14031428",
                                        "variationId": "45438878"
                                      }
                                    ],
                                    "price": 7900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "63645666",
                                        "addonId": "35198447"
                                      },
                                      {
                                        "groupId": "63645666",
                                        "addonId": "35198448"
                                      },
                                      {
                                        "groupId": "63645666",
                                        "addonId": "35198449"
                                      },
                                      {
                                        "groupId": "63645666",
                                        "addonId": "102193391"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "14031428",
                                        "variationId": "45438879"
                                      }
                                    ],
                                    "price": 10900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "63645666",
                                        "addonId": "35198447"
                                      },
                                      {
                                        "groupId": "63645666",
                                        "addonId": "35198448"
                                      },
                                      {
                                        "groupId": "63645666",
                                        "addonId": "35198449"
                                      },
                                      {
                                        "groupId": "63645666",
                                        "addonId": "102193391"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "14031428",
                                        "variationId": "45438880"
                                      }
                                    ],
                                    "price": 29900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "63645666",
                                        "addonId": "35198447"
                                      },
                                      {
                                        "groupId": "63645666",
                                        "addonId": "35198448"
                                      },
                                      {
                                        "groupId": "63645666",
                                        "addonId": "35198449"
                                      },
                                      {
                                        "groupId": "63645666",
                                        "addonId": "102193391"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "63645666",
                                  "groupName": "Add On",
                                  "choices": [
                                    {
                                      "id": "35198447",
                                      "name": "Flower Candle",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198448",
                                      "name": "One Pack Magic Candle",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198449",
                                      "name": "Single Red Rose",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102193391",
                                      "name": "Premium Bakingo Opener",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 7900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "125 ratings",
                                  "ratingCountV2": "125"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "25968050",
                              "name": "Vanilla Cup Cake",
                              "category": "Cup Cakes",
                              "description": "Serves 1 | A classic cupcake with vanilla whippd cream adn edible sugar sprinkles",
                              "imageId": "fu3slis50dgunqh2vr2m",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "14032279",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Double",
                                        "price": 129,
                                        "id": "45440704",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Pack Of 6",
                                        "price": 299,
                                        "id": "45440705",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Single",
                                        "price": 69,
                                        "default": 1,
                                        "id": "45440703",
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "14032279",
                                        "variationId": "45440703"
                                      }
                                    ],
                                    "price": 6900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "63646141",
                                        "addonId": "35198447"
                                      },
                                      {
                                        "groupId": "63646141",
                                        "addonId": "35198448"
                                      },
                                      {
                                        "groupId": "63646141",
                                        "addonId": "35198449"
                                      },
                                      {
                                        "groupId": "63646141",
                                        "addonId": "102193391"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "14032279",
                                        "variationId": "45440704"
                                      }
                                    ],
                                    "price": 12900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "63646141",
                                        "addonId": "35198447"
                                      },
                                      {
                                        "groupId": "63646141",
                                        "addonId": "35198448"
                                      },
                                      {
                                        "groupId": "63646141",
                                        "addonId": "35198449"
                                      },
                                      {
                                        "groupId": "63646141",
                                        "addonId": "102193391"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "14032279",
                                        "variationId": "45440705"
                                      }
                                    ],
                                    "price": 29900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "63646141",
                                        "addonId": "35198447"
                                      },
                                      {
                                        "groupId": "63646141",
                                        "addonId": "35198448"
                                      },
                                      {
                                        "groupId": "63646141",
                                        "addonId": "35198449"
                                      },
                                      {
                                        "groupId": "63646141",
                                        "addonId": "102193391"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "63646141",
                                  "groupName": "Add On",
                                  "choices": [
                                    {
                                      "id": "35198447",
                                      "name": "Flower Candle",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198448",
                                      "name": "One Pack Magic Candle",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198449",
                                      "name": "Single Red Rose",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102193391",
                                      "name": "Premium Bakingo Opener",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 6900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "186 ratings",
                                  "ratingCountV2": "186"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "66609567",
                              "name": "Set of 2 each of Red Velvet ,Pineapple and Vanilla Cup Cake",
                              "category": "Cup Cakes",
                              "description": "Serves 1 | 6 assorted cup cakes  in 3 mouth watering flavours",
                              "imageId": "vrp9yfhgcseh8vnekjqf",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 37900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "63646169",
                                  "groupName": "Add On",
                                  "choices": [
                                    {
                                      "id": "35198447",
                                      "name": "Flower Candle",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198448",
                                      "name": "One Pack Magic Candle",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198449",
                                      "name": "Single Red Rose",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102193391",
                                      "name": "Premium Bakingo Opener",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "29 ratings",
                                  "ratingCountV2": "29"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "68987474",
                              "name": "Set of 2 Birthday Poster Chocolate Jar Cakes",
                              "category": "Birthday & Anniversay Specials",
                              "description": "Serves 1 | 2 chocolate jar cakes topped with sugar sheets with special birthday graphics",
                              "imageId": "fsoqjikztz7mhljhtpbo",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "14032521",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Mini (200ml)",
                                        "price": 329,
                                        "default": 1,
                                        "id": "45441201",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large (375ml)",
                                        "price": 479,
                                        "id": "45441202",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "14032521",
                                        "variationId": "45441201"
                                      }
                                    ],
                                    "price": 32900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "52000412",
                                        "addonId": "35198447"
                                      },
                                      {
                                        "groupId": "52000412",
                                        "addonId": "35198448"
                                      },
                                      {
                                        "groupId": "52000412",
                                        "addonId": "35198449"
                                      },
                                      {
                                        "groupId": "52000412",
                                        "addonId": "102193391"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "14032521",
                                        "variationId": "45441202"
                                      }
                                    ],
                                    "price": 47900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "52000412",
                                        "addonId": "35198447"
                                      },
                                      {
                                        "groupId": "52000412",
                                        "addonId": "35198448"
                                      },
                                      {
                                        "groupId": "52000412",
                                        "addonId": "35198449"
                                      },
                                      {
                                        "groupId": "52000412",
                                        "addonId": "102193391"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "52000412",
                                  "groupName": "Add On",
                                  "choices": [
                                    {
                                      "id": "35198447",
                                      "name": "Flower Candle",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198448",
                                      "name": "One Pack Magic Candle",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198449",
                                      "name": "Single Red Rose",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102193391",
                                      "name": "Premium Bakingo Opener",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 32900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "46 ratings",
                                  "ratingCountV2": "46"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "68987478",
                              "name": "Set of 2 Anniversary Poster Chocolate Jar Cakes",
                              "category": "Birthday & Anniversay Specials",
                              "description": "Serves 1 | A set of 2 chocolate jar cakes topped with anniversary wishes",
                              "imageId": "calc3omdyyick4zzh6wr",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "14032524",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Mini (200ml)",
                                        "price": 329,
                                        "default": 1,
                                        "id": "45441207",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large (375ml)",
                                        "price": 479,
                                        "id": "45441208",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "14032524",
                                        "variationId": "45441207"
                                      }
                                    ],
                                    "price": 32900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "52000425",
                                        "addonId": "35198447"
                                      },
                                      {
                                        "groupId": "52000425",
                                        "addonId": "35198448"
                                      },
                                      {
                                        "groupId": "52000425",
                                        "addonId": "35198449"
                                      },
                                      {
                                        "groupId": "52000425",
                                        "addonId": "102193391"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "14032524",
                                        "variationId": "45441208"
                                      }
                                    ],
                                    "price": 47900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "52000425",
                                        "addonId": "35198447"
                                      },
                                      {
                                        "groupId": "52000425",
                                        "addonId": "35198448"
                                      },
                                      {
                                        "groupId": "52000425",
                                        "addonId": "35198449"
                                      },
                                      {
                                        "groupId": "52000425",
                                        "addonId": "102193391"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "52000425",
                                  "groupName": "Add On",
                                  "choices": [
                                    {
                                      "id": "35198447",
                                      "name": "Flower Candle",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198448",
                                      "name": "One Pack Magic Candle",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198449",
                                      "name": "Single Red Rose",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102193391",
                                      "name": "Premium Bakingo Opener",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 32900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.1",
                                  "ratingCount": "17 ratings",
                                  "ratingCountV2": "17"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "type": "CATEGORY_TYPE_RECOMMENDED"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Season Special",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "11860074",
                              "name": "Strawberry Jar Cake",
                              "category": "Season Special",
                              "description": "Serves 1 | A vanilla sponge based cake with a fresh strawberry filling topped with fresh white cream.",
                              "imageId": "81dbc8f1fac6f8b9f1a3e12821782838",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130869028",
                                  "groupName": "Add On -  Candles",
                                  "choices": [
                                    {
                                      "id": "35198447",
                                      "name": "Flower Candle",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198448",
                                      "name": "One Pack Magic Candle",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198446",
                                      "name": "'BIRTHDAY' Letter Candles",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130869029",
                                  "groupName": "Add On - Roses",
                                  "choices": [
                                    {
                                      "id": "35198449",
                                      "name": "Single Red Rose",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198451",
                                      "name": "6 Red rose Bunch",
                                      "price": 39900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198450",
                                      "name": "10 Red rose Bunch",
                                      "price": 54900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130869030",
                                  "groupName": "Add On",
                                  "choices": [
                                    {
                                      "id": "35198447",
                                      "name": "Flower Candle",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198449",
                                      "name": "Single Red Rose",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102193391",
                                      "name": "Premium Bakingo Opener",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198448",
                                      "name": "One Pack Magic Candle",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 12900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.0",
                                  "ratingCount": "8 ratings",
                                  "ratingCountV2": "8"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "109672986",
                              "name": "Strawberry Bake Cheesecake Slice",
                              "category": "Season Special",
                              "description": "Serves 1 | A baked crust layer topped with fresh strawberries and melting cream cheese",
                              "imageId": "99e7cf29751e72362b8c92662956805f",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130869031",
                                  "groupName": "Add On",
                                  "choices": [
                                    {
                                      "id": "35198447",
                                      "name": "Flower Candle",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198448",
                                      "name": "One Pack Magic Candle",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198449",
                                      "name": "Single Red Rose",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102193391",
                                      "name": "Premium Bakingo Opener",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "9 ratings",
                                  "ratingCountV2": "9"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "11860110",
                              "name": "Strawberry Pastry",
                              "category": "Season Special",
                              "description": "Serves 1 | A strawberry pastry is a delightful and indulgent baked treat that features the sweet and vibrant flavor of fresh strawberries",
                              "imageId": "58a06f01bc972de404a7b50588f6bd6d",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "9 ratings",
                                  "ratingCountV2": "9"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "11860052",
                              "name": "Very Berry Strawberry Cake",
                              "category": "Season Special",
                              "description": "Serves 1 | Flattering strawberry cream-filled flavored cake with hints of chocolate toppings",
                              "imageId": "f3f68056c1940c12a7c74dfd4a5cf321",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 49900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130869032",
                                  "groupName": "Add On - Birthday Caps",
                                  "choices": [
                                    {
                                      "id": "35198445",
                                      "name": "Birthday Caps For Girls",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198444",
                                      "name": "Birthday Cap for Boys",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130869033",
                                  "groupName": "Add On -  Candles",
                                  "choices": [
                                    {
                                      "id": "35198447",
                                      "name": "Flower Candle",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198448",
                                      "name": "One Pack Magic Candle",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198446",
                                      "name": "'BIRTHDAY' Letter Candles",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130869034",
                                  "groupName": "Add On - Roses",
                                  "choices": [
                                    {
                                      "id": "35198449",
                                      "name": "Single Red Rose",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198451",
                                      "name": "6 Red rose Bunch",
                                      "price": 39900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198450",
                                      "name": "10 Red rose Bunch",
                                      "price": 54900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130869035",
                                  "groupName": "Add On - Extras",
                                  "choices": [
                                    {
                                      "id": "35198457",
                                      "name": "Set of 50 balloons (deflated)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198453",
                                      "name": "6 Inch Teddy Bear",
                                      "price": 29900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198452",
                                      "name": "Set of 2 Party Poppers",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198455",
                                      "name": "Happy Birthday Banner",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113484081",
                                      "name": "Set of 2 Party Poppers",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Pastries",
                      "categories": [
                        {
                          "title": "Classic",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "11860102",
                                  "name": "Choco Truffle Pastry",
                                  "category": "Pastries",
                                  "description": "Serves 1 | A decadent and exotic combination of melted chocolate and truffles augmented with a streak of white chocolate to top it off",
                                  "imageId": "nxhhtm8ek1isepnlluyw",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 9900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "63645849",
                                      "groupName": "Add On",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102193391",
                                          "name": "Premium Bakingo Opener",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "871 ratings",
                                      "ratingCountV2": "871"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "11860108",
                                  "name": "Pineapple Pastry",
                                  "category": "Pastries",
                                  "description": "Serves 1 | An eggless classic pineapple pastry topped with a cherry. Freshly baked bread and scented vanilla essence seals the deal.",
                                  "imageId": "fmymcdjsjiubmcf7eki3",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 8900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "63646086",
                                      "groupName": "Add On",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102193391",
                                          "name": "Premium Bakingo Opener",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "676 ratings",
                                      "ratingCountV2": "676"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "11860101",
                                  "name": "Butterscotch Pastry",
                                  "category": "Pastries",
                                  "description": "Serves 1 | A childhood favourite combines butterscotch chips with choco sticks, white marbles & whipped cream",
                                  "imageId": "v5je8qzy4w8s0conzzxo",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 8900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "63645722",
                                      "groupName": "Add On",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102193391",
                                          "name": "Premium Bakingo Opener",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "489 ratings",
                                      "ratingCountV2": "489"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "33456036",
                                  "name": "Kit Kat Pastry",
                                  "category": "Pastries",
                                  "description": "Serves 1 | A perfect match of chocolatty goodness and kit kat crumbs binds together with whipped cream, A bakingo special",
                                  "imageId": "k6gu0yeqooe2jzh5lmib",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 9900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "63645992",
                                      "groupName": "Add On",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102193391",
                                          "name": "Premium Bakingo Opener",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.7",
                                      "ratingCount": "305 ratings",
                                      "ratingCountV2": "305"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "11860113",
                                  "name": "Red Velvet Pastry",
                                  "category": "Pastries",
                                  "description": "Serves 1 | An eggless construction of layers of red velvet goodness, carfully layered with vanilla cream and infused with vanilla essence makes for the perfect red velvet pastry",
                                  "imageId": "wskwzmkdg0jlrroueoc1",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 9900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "63646121",
                                      "groupName": "Add On",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102193391",
                                          "name": "Premium Bakingo Opener",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "392 ratings",
                                      "ratingCountV2": "392"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "11860100",
                                  "name": "Black Forest Pastry",
                                  "category": "Pastries",
                                  "description": "Serves 1 | A crowd favourite and for good reason. Multiple layers of moist chocolate topped with whipped cream and garnished with chocolate flakes.",
                                  "imageId": "ebrjhlgnsshuinjxbuof",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 8900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "63645645",
                                      "groupName": "Add On",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102193391",
                                          "name": "Premium Bakingo Opener",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "468 ratings",
                                      "ratingCountV2": "468"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "11860103",
                                  "name": "Chocolate Chip Pastry",
                                  "category": "Pastries",
                                  "description": "Serves 1 | The softness of freshly baked bread and chocolate with the crispyness of chocolate chips & white chocolates defines this classic",
                                  "imageId": "xauvrdljflukdvr3wssa",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 8900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "63645871",
                                      "groupName": "Add On",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102193391",
                                          "name": "Premium Bakingo Opener",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.5",
                                      "ratingCount": "372 ratings",
                                      "ratingCountV2": "372"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Gourmet",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "90185476",
                                  "name": "Opera Pastry",
                                  "category": "Pastries",
                                  "description": "Serves 1 | Jocan sponge, coffee, fresh cream, chd 45 chocolate, egg & butter complete this delicacy",
                                  "imageId": "jhlcqlll26l5vsw1qwc9",
                                  "inStock": 1,
                                  "price": 10900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "63646199",
                                      "groupName": "Add On",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102193391",
                                          "name": "Premium Bakingo Opener",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.7",
                                      "ratingCount": "54 ratings",
                                      "ratingCountV2": "54"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "90185477",
                                  "name": "Tiramisu Pastry Tub",
                                  "category": "Pastries",
                                  "description": "Serves 1 | A crowd favourite, Bakingo style, replete with Jocan spunge, rum, egg, topping cream, butter & cream cheese",
                                  "imageId": "d0827cfd2d6c3146bf00b3277f81e0aa",
                                  "inStock": 1,
                                  "price": 19900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "63646202",
                                      "groupName": "Add On",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102193391",
                                          "name": "Premium Bakingo Opener",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.6",
                                      "ratingCount": "16 ratings",
                                      "ratingCountV2": "16"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Jar Cake",
                      "categories": [
                        {
                          "title": "Classic Jar Cakes",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "11860069",
                                  "name": "Chocolate Jar Cake",
                                  "category": "Jar Cake",
                                  "description": "Serves 1 | A thick layered velvety chocolate classic in a jar",
                                  "imageId": "laozbxohmfnvce2l4f6z",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "14031637",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Mini (200ml)",
                                            "price": 109,
                                            "default": 1,
                                            "id": "45439308",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large (375ml)",
                                            "price": 199,
                                            "id": "45439309",
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14031637",
                                            "variationId": "45439308"
                                          }
                                        ],
                                        "price": 10900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "63645895",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "63645895",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "63645895",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "63645895",
                                            "addonId": "102193391"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14031637",
                                            "variationId": "45439309"
                                          }
                                        ],
                                        "price": 19900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "63645895",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "63645895",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "63645895",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "63645895",
                                            "addonId": "102193391"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "63645895",
                                      "groupName": "Add On",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102193391",
                                          "name": "Premium Bakingo Opener",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 10900,
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "325 ratings",
                                      "ratingCountV2": "325"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "11860072",
                                  "name": "Choco Mud Jar Cake",
                                  "category": "Jar Cake",
                                  "description": "Serves 1 | A layered chococalte classic with vanilla cream and the texture of chocolate mud",
                                  "imageId": "dyukktyibpcrg1ylf5uo",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "14031507",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Mini (200ml)",
                                            "price": 109,
                                            "default": 1,
                                            "id": "45439044",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large (375ml)",
                                            "price": 199,
                                            "id": "45439045",
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14031507",
                                            "variationId": "45439044"
                                          }
                                        ],
                                        "price": 10900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "63645817",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "63645817",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "63645817",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "63645817",
                                            "addonId": "102193391"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14031507",
                                            "variationId": "45439045"
                                          }
                                        ],
                                        "price": 19900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "63645817",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "63645817",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "63645817",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "63645817",
                                            "addonId": "102193391"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "63645817",
                                      "groupName": "Add On",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102193391",
                                          "name": "Premium Bakingo Opener",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 10900,
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "276 ratings",
                                      "ratingCountV2": "276"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "33576352",
                                  "name": "Red Velvet Jar Cake",
                                  "category": "Jar Cake",
                                  "description": "Serves 1 | A perfct construction of red velvet goodness, carfully layered with vanilla cream and infused with vanilla essence makes for the perfect red velvet cake in a jar",
                                  "imageId": "eba8fb9aa7a92797a97af17520bcd749",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "14032227",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Mini (200ml)",
                                            "price": 129,
                                            "default": 1,
                                            "id": "45440595",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large (375ml)",
                                            "price": 199,
                                            "id": "45440597",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14032227",
                                            "variationId": "45440595"
                                          }
                                        ],
                                        "price": 12900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "63646103",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "63646103",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "63646103",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "63646103",
                                            "addonId": "102193391"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14032227",
                                            "variationId": "45440597"
                                          }
                                        ],
                                        "price": 19900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "63646103",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "63646103",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "63646103",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "63646103",
                                            "addonId": "102193391"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "63646103",
                                      "groupName": "Add On",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102193391",
                                          "name": "Premium Bakingo Opener",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 12900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "175 ratings",
                                      "ratingCountV2": "175"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "11860067",
                                  "name": "Blueberry Jar Cake",
                                  "category": "Jar Cake",
                                  "description": "Serves 1 | An exotic mix of fresh blueberry pulp and freshly baked cake in a jar is a seasoal treat",
                                  "imageId": "rxbbzo6bj4tkbzbkypmr",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "14031440",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Mini (200ml)",
                                            "price": 129,
                                            "default": 1,
                                            "id": "45438903",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large (375ml)",
                                            "price": 229,
                                            "id": "45438904",
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14031440",
                                            "variationId": "45438903"
                                          }
                                        ],
                                        "price": 12900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "63645681",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "63645681",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "63645681",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "63645681",
                                            "addonId": "102193391"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14031440",
                                            "variationId": "45438904"
                                          }
                                        ],
                                        "price": 22900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "63645681",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "63645681",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "63645681",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "63645681",
                                            "addonId": "102193391"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "63645681",
                                      "groupName": "Add On",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102193391",
                                          "name": "Premium Bakingo Opener",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 12900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.8",
                                      "ratingCount": "111 ratings",
                                      "ratingCountV2": "111"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "11860071",
                                  "name": "Choco Crunch Jar Cake",
                                  "category": "Jar Cake",
                                  "description": "Serves 1 | A crunchy rendition of the original blends soft and crispy in perfect proportions",
                                  "imageId": "ihklj52benyfu8qi9g07",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "14031501",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Large (375ml)",
                                            "price": 199,
                                            "id": "45439032",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Mini (200ml)",
                                            "price": 109,
                                            "default": 1,
                                            "id": "45439031",
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14031501",
                                            "variationId": "45439031"
                                          }
                                        ],
                                        "price": 10900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "63645769",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "63645769",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "63645769",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "63645769",
                                            "addonId": "102193391"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14031501",
                                            "variationId": "45439032"
                                          }
                                        ],
                                        "price": 19900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "63645769",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "63645769",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "63645769",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "63645769",
                                            "addonId": "102193391"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "63645769",
                                      "groupName": "Add On",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102193391",
                                          "name": "Premium Bakingo Opener",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 10900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "80 ratings",
                                      "ratingCountV2": "80"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "11860068",
                                  "name": "Butterscotch Jar Cake",
                                  "category": "Jar Cake",
                                  "description": "Serves 1 | This childhood favourite combines crunchy butterscotch bits & creamy butterscotch bread in a jar cake",
                                  "imageId": "vatp3njevgajwz3of2rn",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "14031468",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Mini (200ml)",
                                            "price": 129,
                                            "default": 1,
                                            "id": "45438963",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large (375ml)",
                                            "price": 199,
                                            "id": "45438964",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14031468",
                                            "variationId": "45438963"
                                          }
                                        ],
                                        "price": 12900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "63645702",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "63645702",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "63645702",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "63645702",
                                            "addonId": "102193391"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14031468",
                                            "variationId": "45438964"
                                          }
                                        ],
                                        "price": 19900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "63645702",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "63645702",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "63645702",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "63645702",
                                            "addonId": "102193391"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "63645702",
                                      "groupName": "Add On",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102193391",
                                          "name": "Premium Bakingo Opener",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 12900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.5",
                                      "ratingCount": "45 ratings",
                                      "ratingCountV2": "45"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Gourmet Jar Cakes",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "112797566",
                                  "name": "Nutella Hazelnut Jar Cake",
                                  "category": "Jar Cake",
                                  "description": "Serves 1 | Milk chocolate based jar with chocolate sponge topped with hazelnuts and nutella glaze.",
                                  "imageId": "ea22765173608e8273e442a110b81d93",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 17900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "2.7",
                                      "ratingCount": "8 ratings",
                                      "ratingCountV2": "8"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "112797567",
                                  "name": "Belgian Chocolate Mousse Jar Cake",
                                  "category": "Jar Cake",
                                  "description": "Serves 1 | A mousse based chocolate jar cake prepared with milk chocolate, fresh cream, chocolate sponge and nutella.",
                                  "imageId": "14456111aaf9b8147aa1553fcd5d6950",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 17900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "82998555",
                                      "groupName": "Add On",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102193391",
                                          "name": "Premium Bakingo Opener",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "18 ratings",
                                      "ratingCountV2": "18"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "112797568",
                                  "name": "Biscoff Cheesecake Jar",
                                  "category": "Jar Cake",
                                  "description": "Serves 1 | A delectable cheesecake jar prepared with fresh cream, infused with cream cheese and topped with a Lotus Biscoff Biscuit",
                                  "imageId": "f7d7776ef296f2ad8abd10150d8ebb5f",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 19900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "61 ratings",
                                      "ratingCountV2": "61"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "73829384",
                                  "name": "Chocolate Hazelnut Caramel Jar Cake",
                                  "category": "Jar Cake",
                                  "description": "Serves 1 | A chocolate cake base topped with chocolate sauce, a sticky toffee caramel syrup and a blend of hazelnuts completes this decadent concoction",
                                  "imageId": "hypy5cbzqxf9bciwviav",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 14900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "63646194",
                                      "groupName": "Add On",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102193391",
                                          "name": "Premium Bakingo Opener",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "64 ratings",
                                      "ratingCountV2": "64"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "73829366",
                                  "name": "Banoffee Jar Cake",
                                  "category": "Jar Cake",
                                  "description": "Serves 1 | Banana, cream and thick caramel sauce layered with sponge cake completes this classic, Bakingo style.",
                                  "imageId": "wdwmtt41w64imixpqyg9",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 14900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "63646187",
                                      "groupName": "Add On",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102193391",
                                          "name": "Premium Bakingo Opener",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.6",
                                      "ratingCount": "35 ratings",
                                      "ratingCountV2": "35"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Verrine Cups",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "96812028",
                                  "name": "Trio Mousse",
                                  "category": "Jar Cake",
                                  "description": "Serves 1 | A decadent trio of white chocolate, milk chocolate, CHD 45 chocolate & egg topped off with a rich creamy mousse.",
                                  "imageId": "cbpd40juwalzvgydndol",
                                  "inStock": 1,
                                  "price": 10900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "56132631",
                                      "groupName": "Add On",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102193391",
                                          "name": "Premium Bakingo Opener",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.7",
                                      "ratingCount": "11 ratings",
                                      "ratingCountV2": "11"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "132020080",
                                  "name": "Strawberry Cheese",
                                  "category": "Jar Cake",
                                  "description": "Serves 1 | A delightful and visually appealing dessert served in a small cup, often with layers of Cream Cheese, Whipped Cream & Fresh Strawberries",
                                  "imageId": "21778f27f7c37e6d3cc33e1d8e5685c3",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 14900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "131138094",
                                      "groupName": "Add On",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102193391",
                                          "name": "Premium Bakingo Opener",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Cakes",
                      "categories": [
                        {
                          "title": "Chocolate All star",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "11860034",
                                  "name": "Choco Truffle Cake",
                                  "category": "Cakes",
                                  "description": "Serves 1 | A decadent and exotic combination of melted chocolate and truffles augmented with a streak of white chocolate to top it off",
                                  "imageId": "zwv6dwhw82s4u38byk8o",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "14031523",
                                        "name": "Choose your Cake Size",
                                        "variations": [
                                          {
                                            "name": "500 gm",
                                            "price": 499,
                                            "default": 1,
                                            "id": "45439077",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg",
                                            "price": 899,
                                            "id": "45439078",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14031523",
                                            "variationId": "45439077"
                                          }
                                        ],
                                        "price": 49900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "73139725",
                                            "addonId": "35198444"
                                          },
                                          {
                                            "groupId": "73139725",
                                            "addonId": "35198445"
                                          },
                                          {
                                            "groupId": "73139726",
                                            "addonId": "35198446"
                                          },
                                          {
                                            "groupId": "73139726",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "73139726",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "73139727",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "73139727",
                                            "addonId": "35198451"
                                          },
                                          {
                                            "groupId": "73139727",
                                            "addonId": "35198450"
                                          },
                                          {
                                            "groupId": "73139729",
                                            "addonId": "35198455"
                                          },
                                          {
                                            "groupId": "73139729",
                                            "addonId": "35198452"
                                          },
                                          {
                                            "groupId": "73139729",
                                            "addonId": "35198457"
                                          },
                                          {
                                            "groupId": "73139729",
                                            "addonId": "35198453"
                                          },
                                          {
                                            "groupId": "73139729",
                                            "addonId": "113484081"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14031523",
                                            "variationId": "45439078"
                                          }
                                        ],
                                        "price": 89900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "73139725",
                                            "addonId": "35198444"
                                          },
                                          {
                                            "groupId": "73139725",
                                            "addonId": "35198445"
                                          },
                                          {
                                            "groupId": "73139726",
                                            "addonId": "35198446"
                                          },
                                          {
                                            "groupId": "73139726",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "73139726",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "73139727",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "73139727",
                                            "addonId": "35198451"
                                          },
                                          {
                                            "groupId": "73139727",
                                            "addonId": "35198450"
                                          },
                                          {
                                            "groupId": "73139729",
                                            "addonId": "35198455"
                                          },
                                          {
                                            "groupId": "73139729",
                                            "addonId": "35198452"
                                          },
                                          {
                                            "groupId": "73139729",
                                            "addonId": "35198457"
                                          },
                                          {
                                            "groupId": "73139729",
                                            "addonId": "35198453"
                                          },
                                          {
                                            "groupId": "73139729",
                                            "addonId": "113484081"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "73139725",
                                      "groupName": "Add On - Birthday Caps",
                                      "choices": [
                                        {
                                          "id": "35198445",
                                          "name": "Birthday Caps For Girls",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198444",
                                          "name": "Birthday Cap for Boys",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73139726",
                                      "groupName": "Add On -  Candles",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198446",
                                          "name": "'BIRTHDAY' Letter Candles",
                                          "price": 12900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73139727",
                                      "groupName": "Add On - Roses",
                                      "choices": [
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198451",
                                          "name": "6 Red rose Bunch",
                                          "price": 39900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198450",
                                          "name": "10 Red rose Bunch",
                                          "price": 54900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73139729",
                                      "groupName": "Add On - Extras",
                                      "choices": [
                                        {
                                          "id": "35198457",
                                          "name": "Set of 50 balloons (deflated)",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198453",
                                          "name": "6 Inch Teddy Bear",
                                          "price": 29900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198452",
                                          "name": "Set of 2 Party Poppers",
                                          "price": 13900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198455",
                                          "name": "Happy Birthday Banner",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113484081",
                                          "name": "Set of 2 Party Poppers",
                                          "price": 13900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 49900,
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.5",
                                      "ratingCount": "751 ratings",
                                      "ratingCountV2": "751"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "11860035",
                                  "name": "Choco Vanilla Cake",
                                  "category": "Cakes",
                                  "description": "Serves 1 | The perfect duality of chocolate and vanilla combines two classics in one cake",
                                  "imageId": "ckvijubonn2yovh4jdom",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "14031567",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "500 gm",
                                            "price": 499,
                                            "default": 1,
                                            "id": "45439167",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg",
                                            "price": 850,
                                            "id": "45439168",
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14031567",
                                            "variationId": "45439167"
                                          }
                                        ],
                                        "price": 49900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "48689214",
                                            "addonId": "35198444"
                                          },
                                          {
                                            "groupId": "48689214",
                                            "addonId": "35198445"
                                          },
                                          {
                                            "groupId": "48689231",
                                            "addonId": "35198446"
                                          },
                                          {
                                            "groupId": "48689231",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "48689231",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "48689254",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "48689254",
                                            "addonId": "35198451"
                                          },
                                          {
                                            "groupId": "48689254",
                                            "addonId": "35198450"
                                          },
                                          {
                                            "groupId": "48689275",
                                            "addonId": "35198455"
                                          },
                                          {
                                            "groupId": "48689275",
                                            "addonId": "35198452"
                                          },
                                          {
                                            "groupId": "48689275",
                                            "addonId": "35198457"
                                          },
                                          {
                                            "groupId": "48689275",
                                            "addonId": "35198453"
                                          },
                                          {
                                            "groupId": "48689275",
                                            "addonId": "113484081"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14031567",
                                            "variationId": "45439168"
                                          }
                                        ],
                                        "price": 85000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "48689214",
                                            "addonId": "35198444"
                                          },
                                          {
                                            "groupId": "48689214",
                                            "addonId": "35198445"
                                          },
                                          {
                                            "groupId": "48689231",
                                            "addonId": "35198446"
                                          },
                                          {
                                            "groupId": "48689231",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "48689231",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "48689254",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "48689254",
                                            "addonId": "35198451"
                                          },
                                          {
                                            "groupId": "48689254",
                                            "addonId": "35198450"
                                          },
                                          {
                                            "groupId": "48689275",
                                            "addonId": "35198455"
                                          },
                                          {
                                            "groupId": "48689275",
                                            "addonId": "35198452"
                                          },
                                          {
                                            "groupId": "48689275",
                                            "addonId": "35198457"
                                          },
                                          {
                                            "groupId": "48689275",
                                            "addonId": "35198453"
                                          },
                                          {
                                            "groupId": "48689275",
                                            "addonId": "113484081"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "48689214",
                                      "groupName": "Add On - Birthday Caps",
                                      "choices": [
                                        {
                                          "id": "35198445",
                                          "name": "Birthday Caps For Girls",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198444",
                                          "name": "Birthday Cap for Boys",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "48689231",
                                      "groupName": "Add On -  Candles",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198446",
                                          "name": "'BIRTHDAY' Letter Candles",
                                          "price": 12900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "48689254",
                                      "groupName": "Add On - Roses",
                                      "choices": [
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198451",
                                          "name": "6 Red rose Bunch",
                                          "price": 39900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198450",
                                          "name": "10 Red rose Bunch",
                                          "price": 54900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "48689275",
                                      "groupName": "Add On - Extras",
                                      "choices": [
                                        {
                                          "id": "35198457",
                                          "name": "Set of 50 balloons (deflated)",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198453",
                                          "name": "6 Inch Teddy Bear",
                                          "price": 29900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198452",
                                          "name": "Set of 2 Party Poppers",
                                          "price": 13900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198455",
                                          "name": "Happy Birthday Banner",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113484081",
                                          "name": "Set of 2 Party Poppers",
                                          "price": 13900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 49900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "444 ratings",
                                      "ratingCountV2": "444"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "94442084",
                                  "name": "Marble Cake",
                                  "category": "Cakes",
                                  "description": "Serves 1 | A glossy marble cake combines morde twin compound chips, white compound, chocolate sponge & truffle finished with chocolate glaze",
                                  "imageId": "fj84rv8uwcctefw3nmjx",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "16317891",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "1 Kg",
                                            "price": 999,
                                            "id": "54337723",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 gm",
                                            "price": 499,
                                            "default": 1,
                                            "id": "54337724",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16317891",
                                            "variationId": "54337723"
                                          }
                                        ],
                                        "price": 99900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "53438912",
                                            "addonId": "35198444"
                                          },
                                          {
                                            "groupId": "53438912",
                                            "addonId": "35198445"
                                          },
                                          {
                                            "groupId": "53438913",
                                            "addonId": "35198446"
                                          },
                                          {
                                            "groupId": "53438913",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "53438913",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "53438915",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "53438915",
                                            "addonId": "35198451"
                                          },
                                          {
                                            "groupId": "53438915",
                                            "addonId": "35198450"
                                          },
                                          {
                                            "groupId": "53438916",
                                            "addonId": "35198455"
                                          },
                                          {
                                            "groupId": "53438916",
                                            "addonId": "35198452"
                                          },
                                          {
                                            "groupId": "53438916",
                                            "addonId": "35198457"
                                          },
                                          {
                                            "groupId": "53438916",
                                            "addonId": "35198453"
                                          },
                                          {
                                            "groupId": "53438916",
                                            "addonId": "113484081"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16317891",
                                            "variationId": "54337724"
                                          }
                                        ],
                                        "price": 49900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "53438912",
                                            "addonId": "35198444"
                                          },
                                          {
                                            "groupId": "53438912",
                                            "addonId": "35198445"
                                          },
                                          {
                                            "groupId": "53438913",
                                            "addonId": "35198446"
                                          },
                                          {
                                            "groupId": "53438913",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "53438913",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "53438915",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "53438915",
                                            "addonId": "35198451"
                                          },
                                          {
                                            "groupId": "53438915",
                                            "addonId": "35198450"
                                          },
                                          {
                                            "groupId": "53438916",
                                            "addonId": "35198455"
                                          },
                                          {
                                            "groupId": "53438916",
                                            "addonId": "35198452"
                                          },
                                          {
                                            "groupId": "53438916",
                                            "addonId": "35198457"
                                          },
                                          {
                                            "groupId": "53438916",
                                            "addonId": "35198453"
                                          },
                                          {
                                            "groupId": "53438916",
                                            "addonId": "113484081"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "53438912",
                                      "groupName": "Add On - Birthday Caps",
                                      "choices": [
                                        {
                                          "id": "35198445",
                                          "name": "Birthday Caps For Girls",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198444",
                                          "name": "Birthday Cap for Boys",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "53438913",
                                      "groupName": "Add On -  Candles",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198446",
                                          "name": "'BIRTHDAY' Letter Candles",
                                          "price": 12900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "53438915",
                                      "groupName": "Add On - Roses",
                                      "choices": [
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198451",
                                          "name": "6 Red rose Bunch",
                                          "price": 39900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198450",
                                          "name": "10 Red rose Bunch",
                                          "price": 54900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "53438916",
                                      "groupName": "Add On - Extras",
                                      "choices": [
                                        {
                                          "id": "35198457",
                                          "name": "Set of 50 balloons (deflated)",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198453",
                                          "name": "6 Inch Teddy Bear",
                                          "price": 29900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198452",
                                          "name": "Set of 2 Party Poppers",
                                          "price": 13900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198455",
                                          "name": "Happy Birthday Banner",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113484081",
                                          "name": "Set of 2 Party Poppers",
                                          "price": 13900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 49900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.8",
                                      "ratingCount": "10 ratings",
                                      "ratingCountV2": "10"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "47790339",
                                  "name": "Chocolate Snicker Cake",
                                  "category": "Cakes",
                                  "description": "Serves 1 | A dark, rich & chocolaty bind of mocha, snickers & melted chocolate is pure indulgence",
                                  "imageId": "b92a91d0db96679e466319687383d5d3",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "14032267",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "500 gm",
                                            "price": 599,
                                            "default": 1,
                                            "id": "45440678",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg",
                                            "price": 1149,
                                            "id": "45440679",
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14032267",
                                            "variationId": "45440678"
                                          }
                                        ],
                                        "price": 59900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "48694925",
                                            "addonId": "35198444"
                                          },
                                          {
                                            "groupId": "48694925",
                                            "addonId": "35198445"
                                          },
                                          {
                                            "groupId": "48694951",
                                            "addonId": "35198446"
                                          },
                                          {
                                            "groupId": "48694951",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "48694951",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "48694975",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "48694975",
                                            "addonId": "35198451"
                                          },
                                          {
                                            "groupId": "48694975",
                                            "addonId": "35198450"
                                          },
                                          {
                                            "groupId": "48694996",
                                            "addonId": "35198455"
                                          },
                                          {
                                            "groupId": "48694996",
                                            "addonId": "35198452"
                                          },
                                          {
                                            "groupId": "48694996",
                                            "addonId": "35198457"
                                          },
                                          {
                                            "groupId": "48694996",
                                            "addonId": "35198453"
                                          },
                                          {
                                            "groupId": "48694996",
                                            "addonId": "113484081"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14032267",
                                            "variationId": "45440679"
                                          }
                                        ],
                                        "price": 114900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "48694925",
                                            "addonId": "35198444"
                                          },
                                          {
                                            "groupId": "48694925",
                                            "addonId": "35198445"
                                          },
                                          {
                                            "groupId": "48694951",
                                            "addonId": "35198446"
                                          },
                                          {
                                            "groupId": "48694951",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "48694951",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "48694975",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "48694975",
                                            "addonId": "35198451"
                                          },
                                          {
                                            "groupId": "48694975",
                                            "addonId": "35198450"
                                          },
                                          {
                                            "groupId": "48694996",
                                            "addonId": "35198455"
                                          },
                                          {
                                            "groupId": "48694996",
                                            "addonId": "35198452"
                                          },
                                          {
                                            "groupId": "48694996",
                                            "addonId": "35198457"
                                          },
                                          {
                                            "groupId": "48694996",
                                            "addonId": "35198453"
                                          },
                                          {
                                            "groupId": "48694996",
                                            "addonId": "113484081"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "48694925",
                                      "groupName": "Add On - Birthday Caps",
                                      "choices": [
                                        {
                                          "id": "35198445",
                                          "name": "Birthday Caps For Girls",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198444",
                                          "name": "Birthday Cap for Boys",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "48694951",
                                      "groupName": "Add On -  Candles",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198446",
                                          "name": "'BIRTHDAY' Letter Candles",
                                          "price": 12900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "48694975",
                                      "groupName": "Add On - Roses",
                                      "choices": [
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198451",
                                          "name": "6 Red rose Bunch",
                                          "price": 39900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198450",
                                          "name": "10 Red rose Bunch",
                                          "price": 54900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "48694996",
                                      "groupName": "Add On - Extras",
                                      "choices": [
                                        {
                                          "id": "35198457",
                                          "name": "Set of 50 balloons (deflated)",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198453",
                                          "name": "6 Inch Teddy Bear",
                                          "price": 29900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198452",
                                          "name": "Set of 2 Party Poppers",
                                          "price": 13900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198455",
                                          "name": "Happy Birthday Banner",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113484081",
                                          "name": "Set of 2 Party Poppers",
                                          "price": 13900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 59900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "148 ratings",
                                      "ratingCountV2": "148"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "61476022",
                                  "name": "Choco Crunch KitKat Cake",
                                  "category": "Cakes",
                                  "description": "Serves 1 | A perfect match of chocolatty goodness and kit kat crumbs binds together with whipped cream & white chocolate marbles. A bakingo special",
                                  "imageId": "eo2shjthazrwgbnkxf1k",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "14032436",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "500 gm",
                                            "price": 579,
                                            "default": 1,
                                            "id": "45441026",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg",
                                            "price": 1150,
                                            "id": "45441027",
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14032436",
                                            "variationId": "45441026"
                                          }
                                        ],
                                        "price": 57900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "48696848",
                                            "addonId": "35198444"
                                          },
                                          {
                                            "groupId": "48696848",
                                            "addonId": "35198445"
                                          },
                                          {
                                            "groupId": "48696859",
                                            "addonId": "35198446"
                                          },
                                          {
                                            "groupId": "48696859",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "48696859",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "48696879",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "48696879",
                                            "addonId": "35198451"
                                          },
                                          {
                                            "groupId": "48696879",
                                            "addonId": "35198450"
                                          },
                                          {
                                            "groupId": "48696899",
                                            "addonId": "35198455"
                                          },
                                          {
                                            "groupId": "48696899",
                                            "addonId": "35198452"
                                          },
                                          {
                                            "groupId": "48696899",
                                            "addonId": "35198457"
                                          },
                                          {
                                            "groupId": "48696899",
                                            "addonId": "35198453"
                                          },
                                          {
                                            "groupId": "48696899",
                                            "addonId": "113484081"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14032436",
                                            "variationId": "45441027"
                                          }
                                        ],
                                        "price": 115000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "48696848",
                                            "addonId": "35198444"
                                          },
                                          {
                                            "groupId": "48696848",
                                            "addonId": "35198445"
                                          },
                                          {
                                            "groupId": "48696859",
                                            "addonId": "35198446"
                                          },
                                          {
                                            "groupId": "48696859",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "48696859",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "48696879",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "48696879",
                                            "addonId": "35198451"
                                          },
                                          {
                                            "groupId": "48696879",
                                            "addonId": "35198450"
                                          },
                                          {
                                            "groupId": "48696899",
                                            "addonId": "35198455"
                                          },
                                          {
                                            "groupId": "48696899",
                                            "addonId": "35198452"
                                          },
                                          {
                                            "groupId": "48696899",
                                            "addonId": "35198457"
                                          },
                                          {
                                            "groupId": "48696899",
                                            "addonId": "35198453"
                                          },
                                          {
                                            "groupId": "48696899",
                                            "addonId": "113484081"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "48696848",
                                      "groupName": "Add On - Birthday Caps",
                                      "choices": [
                                        {
                                          "id": "35198445",
                                          "name": "Birthday Caps For Girls",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198444",
                                          "name": "Birthday Cap for Boys",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "48696859",
                                      "groupName": "Add On -  Candles",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198446",
                                          "name": "'BIRTHDAY' Letter Candles",
                                          "price": 12900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "48696879",
                                      "groupName": "Add On - Roses",
                                      "choices": [
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198451",
                                          "name": "6 Red rose Bunch",
                                          "price": 39900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198450",
                                          "name": "10 Red rose Bunch",
                                          "price": 54900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "48696899",
                                      "groupName": "Add On - Extras",
                                      "choices": [
                                        {
                                          "id": "35198457",
                                          "name": "Set of 50 balloons (deflated)",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198453",
                                          "name": "6 Inch Teddy Bear",
                                          "price": 29900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198452",
                                          "name": "Set of 2 Party Poppers",
                                          "price": 13900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198455",
                                          "name": "Happy Birthday Banner",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113484081",
                                          "name": "Set of 2 Party Poppers",
                                          "price": 13900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 57900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "83 ratings",
                                      "ratingCountV2": "83"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "11860036",
                                  "name": "Choco Butterscotch Cake",
                                  "category": "Cakes",
                                  "description": "Serves 1 | A perfect combo of chocolate cake, whipped cream and butterscotch chips",
                                  "imageId": "qvbz2ig3maair1jgwmgs",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "14031586",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "500 gm",
                                            "price": 499,
                                            "default": 1,
                                            "id": "45439205",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg",
                                            "price": 950,
                                            "id": "45439206",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14031586",
                                            "variationId": "45439205"
                                          }
                                        ],
                                        "price": 49900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "48689366",
                                            "addonId": "35198444"
                                          },
                                          {
                                            "groupId": "48689366",
                                            "addonId": "35198445"
                                          },
                                          {
                                            "groupId": "48689379",
                                            "addonId": "35198446"
                                          },
                                          {
                                            "groupId": "48689379",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "48689379",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "48689408",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "48689408",
                                            "addonId": "35198451"
                                          },
                                          {
                                            "groupId": "48689408",
                                            "addonId": "35198450"
                                          },
                                          {
                                            "groupId": "48689424",
                                            "addonId": "35198455"
                                          },
                                          {
                                            "groupId": "48689424",
                                            "addonId": "35198452"
                                          },
                                          {
                                            "groupId": "48689424",
                                            "addonId": "35198457"
                                          },
                                          {
                                            "groupId": "48689424",
                                            "addonId": "35198453"
                                          },
                                          {
                                            "groupId": "48689424",
                                            "addonId": "113484081"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14031586",
                                            "variationId": "45439206"
                                          }
                                        ],
                                        "price": 95000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "48689366",
                                            "addonId": "35198444"
                                          },
                                          {
                                            "groupId": "48689366",
                                            "addonId": "35198445"
                                          },
                                          {
                                            "groupId": "48689379",
                                            "addonId": "35198446"
                                          },
                                          {
                                            "groupId": "48689379",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "48689379",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "48689408",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "48689408",
                                            "addonId": "35198451"
                                          },
                                          {
                                            "groupId": "48689408",
                                            "addonId": "35198450"
                                          },
                                          {
                                            "groupId": "48689424",
                                            "addonId": "35198455"
                                          },
                                          {
                                            "groupId": "48689424",
                                            "addonId": "35198452"
                                          },
                                          {
                                            "groupId": "48689424",
                                            "addonId": "35198457"
                                          },
                                          {
                                            "groupId": "48689424",
                                            "addonId": "35198453"
                                          },
                                          {
                                            "groupId": "48689424",
                                            "addonId": "113484081"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "48689366",
                                      "groupName": "Add On - Birthday Caps",
                                      "choices": [
                                        {
                                          "id": "35198445",
                                          "name": "Birthday Caps For Girls",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198444",
                                          "name": "Birthday Cap for Boys",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "48689379",
                                      "groupName": "Add On -  Candles",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198446",
                                          "name": "'BIRTHDAY' Letter Candles",
                                          "price": 12900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "48689408",
                                      "groupName": "Add On - Roses",
                                      "choices": [
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198451",
                                          "name": "6 Red rose Bunch",
                                          "price": 39900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198450",
                                          "name": "10 Red rose Bunch",
                                          "price": 54900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "48689424",
                                      "groupName": "Add On - Extras",
                                      "choices": [
                                        {
                                          "id": "35198457",
                                          "name": "Set of 50 balloons (deflated)",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198453",
                                          "name": "6 Inch Teddy Bear",
                                          "price": 29900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198452",
                                          "name": "Set of 2 Party Poppers",
                                          "price": 13900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198455",
                                          "name": "Happy Birthday Banner",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113484081",
                                          "name": "Set of 2 Party Poppers",
                                          "price": 13900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 49900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "112 ratings",
                                      "ratingCountV2": "112"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "11860037",
                                  "name": "Choco Chip Cake",
                                  "category": "Cakes",
                                  "description": "Serves 1 | The softness of freshly baked bread and chocolate with the crispyness of chocolate chips & white chocolates defines this classic",
                                  "imageId": "rwv5loeyxqzcshxi5hpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "14031603",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "500 gm",
                                            "price": 499,
                                            "default": 1,
                                            "id": "45439239",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg",
                                            "price": 950,
                                            "id": "45439240",
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14031603",
                                            "variationId": "45439239"
                                          }
                                        ],
                                        "price": 49900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "48689514",
                                            "addonId": "35198444"
                                          },
                                          {
                                            "groupId": "48689514",
                                            "addonId": "35198445"
                                          },
                                          {
                                            "groupId": "48689527",
                                            "addonId": "35198446"
                                          },
                                          {
                                            "groupId": "48689527",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "48689527",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "48689548",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "48689548",
                                            "addonId": "35198451"
                                          },
                                          {
                                            "groupId": "48689548",
                                            "addonId": "35198450"
                                          },
                                          {
                                            "groupId": "48689566",
                                            "addonId": "35198455"
                                          },
                                          {
                                            "groupId": "48689566",
                                            "addonId": "35198452"
                                          },
                                          {
                                            "groupId": "48689566",
                                            "addonId": "35198457"
                                          },
                                          {
                                            "groupId": "48689566",
                                            "addonId": "35198453"
                                          },
                                          {
                                            "groupId": "48689566",
                                            "addonId": "113484081"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14031603",
                                            "variationId": "45439240"
                                          }
                                        ],
                                        "price": 95000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "48689514",
                                            "addonId": "35198444"
                                          },
                                          {
                                            "groupId": "48689514",
                                            "addonId": "35198445"
                                          },
                                          {
                                            "groupId": "48689527",
                                            "addonId": "35198446"
                                          },
                                          {
                                            "groupId": "48689527",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "48689527",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "48689548",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "48689548",
                                            "addonId": "35198451"
                                          },
                                          {
                                            "groupId": "48689548",
                                            "addonId": "35198450"
                                          },
                                          {
                                            "groupId": "48689566",
                                            "addonId": "35198455"
                                          },
                                          {
                                            "groupId": "48689566",
                                            "addonId": "35198452"
                                          },
                                          {
                                            "groupId": "48689566",
                                            "addonId": "35198457"
                                          },
                                          {
                                            "groupId": "48689566",
                                            "addonId": "35198453"
                                          },
                                          {
                                            "groupId": "48689566",
                                            "addonId": "113484081"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "48689514",
                                      "groupName": "Add On - Birthday Caps",
                                      "choices": [
                                        {
                                          "id": "35198445",
                                          "name": "Birthday Caps For Girls",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198444",
                                          "name": "Birthday Cap for Boys",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "48689527",
                                      "groupName": "Add On -  Candles",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198446",
                                          "name": "'BIRTHDAY' Letter Candles",
                                          "price": 12900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "48689548",
                                      "groupName": "Add On - Roses",
                                      "choices": [
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198451",
                                          "name": "6 Red rose Bunch",
                                          "price": 39900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198450",
                                          "name": "10 Red rose Bunch",
                                          "price": 54900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "48689566",
                                      "groupName": "Add On - Extras",
                                      "choices": [
                                        {
                                          "id": "35198457",
                                          "name": "Set of 50 balloons (deflated)",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198453",
                                          "name": "6 Inch Teddy Bear",
                                          "price": 29900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198452",
                                          "name": "Set of 2 Party Poppers",
                                          "price": 13900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198455",
                                          "name": "Happy Birthday Banner",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113484081",
                                          "name": "Set of 2 Party Poppers",
                                          "price": 13900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 49900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "64 ratings",
                                      "ratingCountV2": "64"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "11860049",
                                  "name": "Choco Oreo Cake",
                                  "category": "Cakes",
                                  "description": "Serves 1 | A delectable chocolate cake blended and topped with crunchy Oreos, augmented with white cream and truffle essence.",
                                  "imageId": "miq28o4bdn74je9iiyau",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "14032071",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "500 gm",
                                            "price": 549,
                                            "default": 1,
                                            "id": "45440252",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg",
                                            "price": 950,
                                            "id": "45440253",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14032071",
                                            "variationId": "45440252"
                                          }
                                        ],
                                        "price": 54900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "50670432",
                                            "addonId": "35198444"
                                          },
                                          {
                                            "groupId": "50670432",
                                            "addonId": "35198445"
                                          },
                                          {
                                            "groupId": "50670439",
                                            "addonId": "35198446"
                                          },
                                          {
                                            "groupId": "50670439",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "50670439",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "50670450",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "50670450",
                                            "addonId": "35198451"
                                          },
                                          {
                                            "groupId": "50670450",
                                            "addonId": "35198450"
                                          },
                                          {
                                            "groupId": "50670464",
                                            "addonId": "35198455"
                                          },
                                          {
                                            "groupId": "50670464",
                                            "addonId": "35198452"
                                          },
                                          {
                                            "groupId": "50670464",
                                            "addonId": "35198457"
                                          },
                                          {
                                            "groupId": "50670464",
                                            "addonId": "35198453"
                                          },
                                          {
                                            "groupId": "50670464",
                                            "addonId": "113484081"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14032071",
                                            "variationId": "45440253"
                                          }
                                        ],
                                        "price": 95000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "50670432",
                                            "addonId": "35198444"
                                          },
                                          {
                                            "groupId": "50670432",
                                            "addonId": "35198445"
                                          },
                                          {
                                            "groupId": "50670439",
                                            "addonId": "35198446"
                                          },
                                          {
                                            "groupId": "50670439",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "50670439",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "50670450",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "50670450",
                                            "addonId": "35198451"
                                          },
                                          {
                                            "groupId": "50670450",
                                            "addonId": "35198450"
                                          },
                                          {
                                            "groupId": "50670464",
                                            "addonId": "35198455"
                                          },
                                          {
                                            "groupId": "50670464",
                                            "addonId": "35198452"
                                          },
                                          {
                                            "groupId": "50670464",
                                            "addonId": "35198457"
                                          },
                                          {
                                            "groupId": "50670464",
                                            "addonId": "35198453"
                                          },
                                          {
                                            "groupId": "50670464",
                                            "addonId": "113484081"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "50670432",
                                      "groupName": "Add On - Birthday Caps",
                                      "choices": [
                                        {
                                          "id": "35198445",
                                          "name": "Birthday Caps For Girls",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198444",
                                          "name": "Birthday Cap for Boys",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "50670439",
                                      "groupName": "Add On -  Candles",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198446",
                                          "name": "'BIRTHDAY' Letter Candles",
                                          "price": 12900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "50670450",
                                      "groupName": "Add On - Roses",
                                      "choices": [
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198451",
                                          "name": "6 Red rose Bunch",
                                          "price": 39900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198450",
                                          "name": "10 Red rose Bunch",
                                          "price": 54900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "50670464",
                                      "groupName": "Add On - Extras",
                                      "choices": [
                                        {
                                          "id": "35198457",
                                          "name": "Set of 50 balloons (deflated)",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198453",
                                          "name": "6 Inch Teddy Bear",
                                          "price": 29900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198452",
                                          "name": "Set of 2 Party Poppers",
                                          "price": 13900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198455",
                                          "name": "Happy Birthday Banner",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113484081",
                                          "name": "Set of 2 Party Poppers",
                                          "price": 13900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 54900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "2.5",
                                      "ratingCount": "15 ratings",
                                      "ratingCountV2": "15"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Fruit Cakes",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "11860050",
                                  "name": "Pineapple Cake",
                                  "category": "Cakes",
                                  "description": "Serves 1 | Freshly whipped vanilla cake topped with pineapples, chocolate marbles and cherries",
                                  "imageId": "wbpb3vtcxeokyxf0ofsc",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "14032140",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "500 gm",
                                            "price": 449,
                                            "default": 1,
                                            "id": "45440402",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg",
                                            "price": 750,
                                            "id": "45440403",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14032140",
                                            "variationId": "45440402"
                                          }
                                        ],
                                        "price": 44900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "48693588",
                                            "addonId": "35198444"
                                          },
                                          {
                                            "groupId": "48693588",
                                            "addonId": "35198445"
                                          },
                                          {
                                            "groupId": "48693598",
                                            "addonId": "35198446"
                                          },
                                          {
                                            "groupId": "48693598",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "48693598",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "48693615",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "48693615",
                                            "addonId": "35198451"
                                          },
                                          {
                                            "groupId": "48693615",
                                            "addonId": "35198450"
                                          },
                                          {
                                            "groupId": "48693636",
                                            "addonId": "35198455"
                                          },
                                          {
                                            "groupId": "48693636",
                                            "addonId": "35198452"
                                          },
                                          {
                                            "groupId": "48693636",
                                            "addonId": "35198457"
                                          },
                                          {
                                            "groupId": "48693636",
                                            "addonId": "35198453"
                                          },
                                          {
                                            "groupId": "48693636",
                                            "addonId": "113484081"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14032140",
                                            "variationId": "45440403"
                                          }
                                        ],
                                        "price": 75000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "48693588",
                                            "addonId": "35198444"
                                          },
                                          {
                                            "groupId": "48693588",
                                            "addonId": "35198445"
                                          },
                                          {
                                            "groupId": "48693598",
                                            "addonId": "35198446"
                                          },
                                          {
                                            "groupId": "48693598",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "48693598",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "48693615",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "48693615",
                                            "addonId": "35198451"
                                          },
                                          {
                                            "groupId": "48693615",
                                            "addonId": "35198450"
                                          },
                                          {
                                            "groupId": "48693636",
                                            "addonId": "35198455"
                                          },
                                          {
                                            "groupId": "48693636",
                                            "addonId": "35198452"
                                          },
                                          {
                                            "groupId": "48693636",
                                            "addonId": "35198457"
                                          },
                                          {
                                            "groupId": "48693636",
                                            "addonId": "35198453"
                                          },
                                          {
                                            "groupId": "48693636",
                                            "addonId": "113484081"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "48693588",
                                      "groupName": "Add On - Birthday Caps",
                                      "choices": [
                                        {
                                          "id": "35198445",
                                          "name": "Birthday Caps For Girls",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198444",
                                          "name": "Birthday Cap for Boys",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "48693598",
                                      "groupName": "Add On -  Candles",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198446",
                                          "name": "'BIRTHDAY' Letter Candles",
                                          "price": 12900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "48693615",
                                      "groupName": "Add On - Roses",
                                      "choices": [
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198451",
                                          "name": "6 Red rose Bunch",
                                          "price": 39900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198450",
                                          "name": "10 Red rose Bunch",
                                          "price": 54900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "48693636",
                                      "groupName": "Add On - Extras",
                                      "choices": [
                                        {
                                          "id": "35198457",
                                          "name": "Set of 50 balloons (deflated)",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198453",
                                          "name": "6 Inch Teddy Bear",
                                          "price": 29900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198452",
                                          "name": "Set of 2 Party Poppers",
                                          "price": 13900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198455",
                                          "name": "Happy Birthday Banner",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113484081",
                                          "name": "Set of 2 Party Poppers",
                                          "price": 13900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 44900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.5",
                                      "ratingCount": "354 ratings",
                                      "ratingCountV2": "354"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "48482620",
                                  "name": "Fresh Fruit Cake",
                                  "category": "Cakes",
                                  "description": "Serves 1 | A rainbow of flavors, fresh fruit & an almondy vanilla tango",
                                  "imageId": "yvamlqg4ywgnmtcmffrs",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "14031866",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "500 gm",
                                            "price": 599,
                                            "default": 1,
                                            "id": "45439802",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg",
                                            "price": 1150,
                                            "id": "45439803",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14031866",
                                            "variationId": "45439802"
                                          }
                                        ],
                                        "price": 59900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "48691492",
                                            "addonId": "35198444"
                                          },
                                          {
                                            "groupId": "48691492",
                                            "addonId": "35198445"
                                          },
                                          {
                                            "groupId": "48691506",
                                            "addonId": "35198446"
                                          },
                                          {
                                            "groupId": "48691506",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "48691506",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "48691528",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "48691528",
                                            "addonId": "35198451"
                                          },
                                          {
                                            "groupId": "48691528",
                                            "addonId": "35198450"
                                          },
                                          {
                                            "groupId": "48691554",
                                            "addonId": "35198455"
                                          },
                                          {
                                            "groupId": "48691554",
                                            "addonId": "35198452"
                                          },
                                          {
                                            "groupId": "48691554",
                                            "addonId": "35198457"
                                          },
                                          {
                                            "groupId": "48691554",
                                            "addonId": "35198453"
                                          },
                                          {
                                            "groupId": "48691554",
                                            "addonId": "113484081"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14031866",
                                            "variationId": "45439803"
                                          }
                                        ],
                                        "price": 115000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "48691492",
                                            "addonId": "35198444"
                                          },
                                          {
                                            "groupId": "48691492",
                                            "addonId": "35198445"
                                          },
                                          {
                                            "groupId": "48691506",
                                            "addonId": "35198446"
                                          },
                                          {
                                            "groupId": "48691506",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "48691506",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "48691528",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "48691528",
                                            "addonId": "35198451"
                                          },
                                          {
                                            "groupId": "48691528",
                                            "addonId": "35198450"
                                          },
                                          {
                                            "groupId": "48691554",
                                            "addonId": "35198455"
                                          },
                                          {
                                            "groupId": "48691554",
                                            "addonId": "35198452"
                                          },
                                          {
                                            "groupId": "48691554",
                                            "addonId": "35198457"
                                          },
                                          {
                                            "groupId": "48691554",
                                            "addonId": "35198453"
                                          },
                                          {
                                            "groupId": "48691554",
                                            "addonId": "113484081"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "48691492",
                                      "groupName": "Add On - Birthday Caps",
                                      "choices": [
                                        {
                                          "id": "35198445",
                                          "name": "Birthday Caps For Girls",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198444",
                                          "name": "Birthday Cap for Boys",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "48691506",
                                      "groupName": "Add On -  Candles",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198446",
                                          "name": "'BIRTHDAY' Letter Candles",
                                          "price": 12900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "48691528",
                                      "groupName": "Add On - Roses",
                                      "choices": [
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198451",
                                          "name": "6 Red rose Bunch",
                                          "price": 39900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198450",
                                          "name": "10 Red rose Bunch",
                                          "price": 54900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "48691554",
                                      "groupName": "Add On - Extras",
                                      "choices": [
                                        {
                                          "id": "35198457",
                                          "name": "Set of 50 balloons (deflated)",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198453",
                                          "name": "6 Inch Teddy Bear",
                                          "price": 29900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198452",
                                          "name": "Set of 2 Party Poppers",
                                          "price": 13900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198455",
                                          "name": "Happy Birthday Banner",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113484081",
                                          "name": "Set of 2 Party Poppers",
                                          "price": 13900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 59900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "260 ratings",
                                      "ratingCountV2": "260"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "61475961",
                                  "name": "Lucious Blueberry Cake",
                                  "category": "Cakes",
                                  "description": "Serves 1 | An exotic mix of fresh blueberry puree and freshly baked cake decorated with chocolate flowers & sticks",
                                  "imageId": "ptfb5tjl6kkcb48hlurf",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "14032000",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "500 gm",
                                            "price": 529,
                                            "default": 1,
                                            "id": "45440096",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg",
                                            "price": 1129,
                                            "id": "45440097",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14032000",
                                            "variationId": "45440096"
                                          }
                                        ],
                                        "price": 52900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "48692447",
                                            "addonId": "35198444"
                                          },
                                          {
                                            "groupId": "48692447",
                                            "addonId": "35198445"
                                          },
                                          {
                                            "groupId": "48692455",
                                            "addonId": "35198446"
                                          },
                                          {
                                            "groupId": "48692455",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "48692455",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "48692474",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "48692474",
                                            "addonId": "35198451"
                                          },
                                          {
                                            "groupId": "48692474",
                                            "addonId": "35198450"
                                          },
                                          {
                                            "groupId": "48692487",
                                            "addonId": "35198455"
                                          },
                                          {
                                            "groupId": "48692487",
                                            "addonId": "35198452"
                                          },
                                          {
                                            "groupId": "48692487",
                                            "addonId": "35198457"
                                          },
                                          {
                                            "groupId": "48692487",
                                            "addonId": "35198453"
                                          },
                                          {
                                            "groupId": "48692487",
                                            "addonId": "113484081"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14032000",
                                            "variationId": "45440097"
                                          }
                                        ],
                                        "price": 112900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "48692447",
                                            "addonId": "35198444"
                                          },
                                          {
                                            "groupId": "48692447",
                                            "addonId": "35198445"
                                          },
                                          {
                                            "groupId": "48692455",
                                            "addonId": "35198446"
                                          },
                                          {
                                            "groupId": "48692455",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "48692455",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "48692474",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "48692474",
                                            "addonId": "35198451"
                                          },
                                          {
                                            "groupId": "48692474",
                                            "addonId": "35198450"
                                          },
                                          {
                                            "groupId": "48692487",
                                            "addonId": "35198455"
                                          },
                                          {
                                            "groupId": "48692487",
                                            "addonId": "35198452"
                                          },
                                          {
                                            "groupId": "48692487",
                                            "addonId": "35198457"
                                          },
                                          {
                                            "groupId": "48692487",
                                            "addonId": "35198453"
                                          },
                                          {
                                            "groupId": "48692487",
                                            "addonId": "113484081"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "48692447",
                                      "groupName": "Add On - Birthday Caps",
                                      "choices": [
                                        {
                                          "id": "35198445",
                                          "name": "Birthday Caps For Girls",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198444",
                                          "name": "Birthday Cap for Boys",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "48692455",
                                      "groupName": "Add On -  Candles",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198446",
                                          "name": "'BIRTHDAY' Letter Candles",
                                          "price": 12900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "48692474",
                                      "groupName": "Add On - Roses",
                                      "choices": [
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198451",
                                          "name": "6 Red rose Bunch",
                                          "price": 39900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198450",
                                          "name": "10 Red rose Bunch",
                                          "price": 54900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "48692487",
                                      "groupName": "Add On - Extras",
                                      "choices": [
                                        {
                                          "id": "35198457",
                                          "name": "Set of 50 balloons (deflated)",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198453",
                                          "name": "6 Inch Teddy Bear",
                                          "price": 29900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198452",
                                          "name": "Set of 2 Party Poppers",
                                          "price": 13900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198455",
                                          "name": "Happy Birthday Banner",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113484081",
                                          "name": "Set of 2 Party Poppers",
                                          "price": 13900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 52900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "90 ratings",
                                      "ratingCountV2": "90"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Black forest & Butterscotch",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "11860062",
                                  "name": "Butterscotch Cake",
                                  "category": "Cakes",
                                  "description": "Serves 1 | A childhood favourite combines butterscotch chips with choco sticks, white marbles & a cherry on top",
                                  "imageId": "12468edcc3f9e8973cc50ab3a87bbbca",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "14031451",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "500 gm",
                                            "price": 469,
                                            "default": 1,
                                            "id": "45438926",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg",
                                            "price": 750,
                                            "id": "45438927",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14031451",
                                            "variationId": "45438926"
                                          }
                                        ],
                                        "price": 46900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "48688320",
                                            "addonId": "35198444"
                                          },
                                          {
                                            "groupId": "48688320",
                                            "addonId": "35198445"
                                          },
                                          {
                                            "groupId": "48688326",
                                            "addonId": "35198446"
                                          },
                                          {
                                            "groupId": "48688326",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "48688326",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "48688337",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "48688337",
                                            "addonId": "35198451"
                                          },
                                          {
                                            "groupId": "48688337",
                                            "addonId": "35198450"
                                          },
                                          {
                                            "groupId": "48688355",
                                            "addonId": "35198455"
                                          },
                                          {
                                            "groupId": "48688355",
                                            "addonId": "35198452"
                                          },
                                          {
                                            "groupId": "48688355",
                                            "addonId": "35198457"
                                          },
                                          {
                                            "groupId": "48688355",
                                            "addonId": "35198453"
                                          },
                                          {
                                            "groupId": "48688355",
                                            "addonId": "113484081"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14031451",
                                            "variationId": "45438927"
                                          }
                                        ],
                                        "price": 75000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "48688320",
                                            "addonId": "35198444"
                                          },
                                          {
                                            "groupId": "48688320",
                                            "addonId": "35198445"
                                          },
                                          {
                                            "groupId": "48688326",
                                            "addonId": "35198446"
                                          },
                                          {
                                            "groupId": "48688326",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "48688326",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "48688337",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "48688337",
                                            "addonId": "35198451"
                                          },
                                          {
                                            "groupId": "48688337",
                                            "addonId": "35198450"
                                          },
                                          {
                                            "groupId": "48688355",
                                            "addonId": "35198455"
                                          },
                                          {
                                            "groupId": "48688355",
                                            "addonId": "35198452"
                                          },
                                          {
                                            "groupId": "48688355",
                                            "addonId": "35198457"
                                          },
                                          {
                                            "groupId": "48688355",
                                            "addonId": "35198453"
                                          },
                                          {
                                            "groupId": "48688355",
                                            "addonId": "113484081"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "48688320",
                                      "groupName": "Add On - Birthday Caps",
                                      "choices": [
                                        {
                                          "id": "35198445",
                                          "name": "Birthday Caps For Girls",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198444",
                                          "name": "Birthday Cap for Boys",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "48688326",
                                      "groupName": "Add On -  Candles",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198446",
                                          "name": "'BIRTHDAY' Letter Candles",
                                          "price": 12900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "48688337",
                                      "groupName": "Add On - Roses",
                                      "choices": [
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198451",
                                          "name": "6 Red rose Bunch",
                                          "price": 39900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198450",
                                          "name": "10 Red rose Bunch",
                                          "price": 54900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "48688355",
                                      "groupName": "Add On - Extras",
                                      "choices": [
                                        {
                                          "id": "35198457",
                                          "name": "Set of 50 balloons (deflated)",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198453",
                                          "name": "6 Inch Teddy Bear",
                                          "price": 29900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198452",
                                          "name": "Set of 2 Party Poppers",
                                          "price": 13900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198455",
                                          "name": "Happy Birthday Banner",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113484081",
                                          "name": "Set of 2 Party Poppers",
                                          "price": 13900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 46900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "534 ratings",
                                      "ratingCountV2": "534"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "11860025",
                                  "name": "Black Forest Cake",
                                  "category": "Cakes",
                                  "description": "Serves 1 | A crowd favourite and for good reason. Multiple layers of moist chocolate topped with whipped cream and garnished with chocolate flakes & a cherry on top",
                                  "imageId": "xnznp2fkndvgpndt2dyl",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "14031402",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "500 gm",
                                            "price": 449,
                                            "default": 1,
                                            "id": "45438823",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg",
                                            "price": 750,
                                            "id": "45438824",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14031402",
                                            "variationId": "45438823"
                                          }
                                        ],
                                        "price": 44900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "48687893",
                                            "addonId": "35198444"
                                          },
                                          {
                                            "groupId": "48687893",
                                            "addonId": "35198445"
                                          },
                                          {
                                            "groupId": "48687898",
                                            "addonId": "35198446"
                                          },
                                          {
                                            "groupId": "48687898",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "48687898",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "48687903",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "48687903",
                                            "addonId": "35198451"
                                          },
                                          {
                                            "groupId": "48687903",
                                            "addonId": "35198450"
                                          },
                                          {
                                            "groupId": "48687910",
                                            "addonId": "35198455"
                                          },
                                          {
                                            "groupId": "48687910",
                                            "addonId": "35198452"
                                          },
                                          {
                                            "groupId": "48687910",
                                            "addonId": "35198457"
                                          },
                                          {
                                            "groupId": "48687910",
                                            "addonId": "35198453"
                                          },
                                          {
                                            "groupId": "48687910",
                                            "addonId": "113484081"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14031402",
                                            "variationId": "45438824"
                                          }
                                        ],
                                        "price": 75000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "48687893",
                                            "addonId": "35198444"
                                          },
                                          {
                                            "groupId": "48687893",
                                            "addonId": "35198445"
                                          },
                                          {
                                            "groupId": "48687898",
                                            "addonId": "35198446"
                                          },
                                          {
                                            "groupId": "48687898",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "48687898",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "48687903",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "48687903",
                                            "addonId": "35198451"
                                          },
                                          {
                                            "groupId": "48687903",
                                            "addonId": "35198450"
                                          },
                                          {
                                            "groupId": "48687910",
                                            "addonId": "35198455"
                                          },
                                          {
                                            "groupId": "48687910",
                                            "addonId": "35198452"
                                          },
                                          {
                                            "groupId": "48687910",
                                            "addonId": "35198457"
                                          },
                                          {
                                            "groupId": "48687910",
                                            "addonId": "35198453"
                                          },
                                          {
                                            "groupId": "48687910",
                                            "addonId": "113484081"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "48687893",
                                      "groupName": "Add On - Birthday Caps",
                                      "choices": [
                                        {
                                          "id": "35198445",
                                          "name": "Birthday Caps For Girls",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198444",
                                          "name": "Birthday Cap for Boys",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "48687898",
                                      "groupName": "Add On -  Candles",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198446",
                                          "name": "'BIRTHDAY' Letter Candles",
                                          "price": 12900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "48687903",
                                      "groupName": "Add On - Roses",
                                      "choices": [
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198451",
                                          "name": "6 Red rose Bunch",
                                          "price": 39900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198450",
                                          "name": "10 Red rose Bunch",
                                          "price": 54900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "48687910",
                                      "groupName": "Add On - Extras",
                                      "choices": [
                                        {
                                          "id": "35198457",
                                          "name": "Set of 50 balloons (deflated)",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198453",
                                          "name": "6 Inch Teddy Bear",
                                          "price": 29900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198452",
                                          "name": "Set of 2 Party Poppers",
                                          "price": 13900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198455",
                                          "name": "Happy Birthday Banner",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113484081",
                                          "name": "Set of 2 Party Poppers",
                                          "price": 13900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 44900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "259 ratings",
                                      "ratingCountV2": "259"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "11860044",
                                  "name": "German Black Forest Cake",
                                  "category": "Cakes",
                                  "description": "Serves 1 | A crowd favourite and for good reason. Multiple layers of moist German chocolate topped with whipped cream and garnished with chocolate flakes & a cherry on top",
                                  "imageId": "b93222c67463070fc45ced51a432faac",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "14031886",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "500 gm",
                                            "price": 479,
                                            "default": 1,
                                            "id": "45439845",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg",
                                            "price": 850,
                                            "id": "45439847",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14031886",
                                            "variationId": "45439845"
                                          }
                                        ],
                                        "price": 47900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "48691631",
                                            "addonId": "35198444"
                                          },
                                          {
                                            "groupId": "48691631",
                                            "addonId": "35198445"
                                          },
                                          {
                                            "groupId": "48691643",
                                            "addonId": "35198446"
                                          },
                                          {
                                            "groupId": "48691643",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "48691643",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "48691668",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "48691668",
                                            "addonId": "35198451"
                                          },
                                          {
                                            "groupId": "48691668",
                                            "addonId": "35198450"
                                          },
                                          {
                                            "groupId": "48691688",
                                            "addonId": "35198455"
                                          },
                                          {
                                            "groupId": "48691688",
                                            "addonId": "35198452"
                                          },
                                          {
                                            "groupId": "48691688",
                                            "addonId": "35198457"
                                          },
                                          {
                                            "groupId": "48691688",
                                            "addonId": "35198453"
                                          },
                                          {
                                            "groupId": "48691688",
                                            "addonId": "113484081"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14031886",
                                            "variationId": "45439847"
                                          }
                                        ],
                                        "price": 85000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "48691631",
                                            "addonId": "35198444"
                                          },
                                          {
                                            "groupId": "48691631",
                                            "addonId": "35198445"
                                          },
                                          {
                                            "groupId": "48691643",
                                            "addonId": "35198446"
                                          },
                                          {
                                            "groupId": "48691643",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "48691643",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "48691668",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "48691668",
                                            "addonId": "35198451"
                                          },
                                          {
                                            "groupId": "48691668",
                                            "addonId": "35198450"
                                          },
                                          {
                                            "groupId": "48691688",
                                            "addonId": "35198455"
                                          },
                                          {
                                            "groupId": "48691688",
                                            "addonId": "35198452"
                                          },
                                          {
                                            "groupId": "48691688",
                                            "addonId": "35198457"
                                          },
                                          {
                                            "groupId": "48691688",
                                            "addonId": "35198453"
                                          },
                                          {
                                            "groupId": "48691688",
                                            "addonId": "113484081"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "48691631",
                                      "groupName": "Add On - Birthday Caps",
                                      "choices": [
                                        {
                                          "id": "35198445",
                                          "name": "Birthday Caps For Girls",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198444",
                                          "name": "Birthday Cap for Boys",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "48691643",
                                      "groupName": "Add On -  Candles",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198446",
                                          "name": "'BIRTHDAY' Letter Candles",
                                          "price": 12900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "48691668",
                                      "groupName": "Add On - Roses",
                                      "choices": [
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198451",
                                          "name": "6 Red rose Bunch",
                                          "price": 39900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198450",
                                          "name": "10 Red rose Bunch",
                                          "price": 54900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "48691688",
                                      "groupName": "Add On - Extras",
                                      "choices": [
                                        {
                                          "id": "35198457",
                                          "name": "Set of 50 balloons (deflated)",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198453",
                                          "name": "6 Inch Teddy Bear",
                                          "price": 29900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198452",
                                          "name": "Set of 2 Party Poppers",
                                          "price": 13900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198455",
                                          "name": "Happy Birthday Banner",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113484081",
                                          "name": "Set of 2 Party Poppers",
                                          "price": 13900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 47900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "176 ratings",
                                      "ratingCountV2": "176"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Red Velvet & Coffee Kick",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "52138349",
                                  "name": "Red Velvet Cake",
                                  "category": "Cakes",
                                  "description": "Serves 1 | A vanilla based red velvet cake dressed in red velvet crumbs with dollops of whipped cream",
                                  "imageId": "xcj4thrsskl8knl6xxgf",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "14032491",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "500 gm",
                                            "price": 599,
                                            "default": 1,
                                            "id": "45441138",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg",
                                            "price": 1049,
                                            "id": "45441137",
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14032491",
                                            "variationId": "45441138"
                                          }
                                        ],
                                        "price": 59900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "48697628",
                                            "addonId": "35198444"
                                          },
                                          {
                                            "groupId": "48697628",
                                            "addonId": "35198445"
                                          },
                                          {
                                            "groupId": "48697645",
                                            "addonId": "35198446"
                                          },
                                          {
                                            "groupId": "48697645",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "48697645",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "48697662",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "48697662",
                                            "addonId": "35198451"
                                          },
                                          {
                                            "groupId": "48697662",
                                            "addonId": "35198450"
                                          },
                                          {
                                            "groupId": "48697679",
                                            "addonId": "35198455"
                                          },
                                          {
                                            "groupId": "48697679",
                                            "addonId": "35198452"
                                          },
                                          {
                                            "groupId": "48697679",
                                            "addonId": "35198457"
                                          },
                                          {
                                            "groupId": "48697679",
                                            "addonId": "35198453"
                                          },
                                          {
                                            "groupId": "48697679",
                                            "addonId": "113484081"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14032491",
                                            "variationId": "45441137"
                                          }
                                        ],
                                        "price": 104900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "48697628",
                                            "addonId": "35198444"
                                          },
                                          {
                                            "groupId": "48697628",
                                            "addonId": "35198445"
                                          },
                                          {
                                            "groupId": "48697645",
                                            "addonId": "35198446"
                                          },
                                          {
                                            "groupId": "48697645",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "48697645",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "48697662",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "48697662",
                                            "addonId": "35198451"
                                          },
                                          {
                                            "groupId": "48697662",
                                            "addonId": "35198450"
                                          },
                                          {
                                            "groupId": "48697679",
                                            "addonId": "35198455"
                                          },
                                          {
                                            "groupId": "48697679",
                                            "addonId": "35198452"
                                          },
                                          {
                                            "groupId": "48697679",
                                            "addonId": "35198457"
                                          },
                                          {
                                            "groupId": "48697679",
                                            "addonId": "35198453"
                                          },
                                          {
                                            "groupId": "48697679",
                                            "addonId": "113484081"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "48697628",
                                      "groupName": "Add On - Birthday Caps",
                                      "choices": [
                                        {
                                          "id": "35198445",
                                          "name": "Birthday Caps For Girls",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198444",
                                          "name": "Birthday Cap for Boys",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "48697645",
                                      "groupName": "Add On -  Candles",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198446",
                                          "name": "'BIRTHDAY' Letter Candles",
                                          "price": 12900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "48697662",
                                      "groupName": "Add On - Roses",
                                      "choices": [
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198451",
                                          "name": "6 Red rose Bunch",
                                          "price": 39900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198450",
                                          "name": "10 Red rose Bunch",
                                          "price": 54900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "48697679",
                                      "groupName": "Add On - Extras",
                                      "choices": [
                                        {
                                          "id": "35198457",
                                          "name": "Set of 50 balloons (deflated)",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198453",
                                          "name": "6 Inch Teddy Bear",
                                          "price": 29900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198452",
                                          "name": "Set of 2 Party Poppers",
                                          "price": 13900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198455",
                                          "name": "Happy Birthday Banner",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113484081",
                                          "name": "Set of 2 Party Poppers",
                                          "price": 13900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 59900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.8",
                                      "ratingCount": "107 ratings",
                                      "ratingCountV2": "107"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "11860039",
                                  "name": "Coffee Cake",
                                  "category": "Cakes",
                                  "description": "Serves 1 | A chocolate based coffee kick topped with sprinkled coffee and topped with fresh white cream.",
                                  "imageId": "cvak6ophvjxypxbtyztq",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "14031681",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "500 gm",
                                            "price": 529,
                                            "default": 1,
                                            "id": "45439400",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg",
                                            "price": 950,
                                            "id": "45439401",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14031681",
                                            "variationId": "45439400"
                                          }
                                        ],
                                        "price": 52900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "50670137",
                                            "addonId": "35198444"
                                          },
                                          {
                                            "groupId": "50670137",
                                            "addonId": "35198445"
                                          },
                                          {
                                            "groupId": "50670146",
                                            "addonId": "35198446"
                                          },
                                          {
                                            "groupId": "50670146",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "50670146",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "50670153",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "50670153",
                                            "addonId": "35198451"
                                          },
                                          {
                                            "groupId": "50670153",
                                            "addonId": "35198450"
                                          },
                                          {
                                            "groupId": "50670162",
                                            "addonId": "35198455"
                                          },
                                          {
                                            "groupId": "50670162",
                                            "addonId": "35198452"
                                          },
                                          {
                                            "groupId": "50670162",
                                            "addonId": "35198457"
                                          },
                                          {
                                            "groupId": "50670162",
                                            "addonId": "35198453"
                                          },
                                          {
                                            "groupId": "50670162",
                                            "addonId": "113484081"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14031681",
                                            "variationId": "45439401"
                                          }
                                        ],
                                        "price": 95000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "50670137",
                                            "addonId": "35198444"
                                          },
                                          {
                                            "groupId": "50670137",
                                            "addonId": "35198445"
                                          },
                                          {
                                            "groupId": "50670146",
                                            "addonId": "35198446"
                                          },
                                          {
                                            "groupId": "50670146",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "50670146",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "50670153",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "50670153",
                                            "addonId": "35198451"
                                          },
                                          {
                                            "groupId": "50670153",
                                            "addonId": "35198450"
                                          },
                                          {
                                            "groupId": "50670162",
                                            "addonId": "35198455"
                                          },
                                          {
                                            "groupId": "50670162",
                                            "addonId": "35198452"
                                          },
                                          {
                                            "groupId": "50670162",
                                            "addonId": "35198457"
                                          },
                                          {
                                            "groupId": "50670162",
                                            "addonId": "35198453"
                                          },
                                          {
                                            "groupId": "50670162",
                                            "addonId": "113484081"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "50670137",
                                      "groupName": "Add On - Birthday Caps",
                                      "choices": [
                                        {
                                          "id": "35198445",
                                          "name": "Birthday Caps For Girls",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198444",
                                          "name": "Birthday Cap for Boys",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "50670146",
                                      "groupName": "Add On -  Candles",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198446",
                                          "name": "'BIRTHDAY' Letter Candles",
                                          "price": 12900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "50670153",
                                      "groupName": "Add On - Roses",
                                      "choices": [
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198451",
                                          "name": "6 Red rose Bunch",
                                          "price": 39900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198450",
                                          "name": "10 Red rose Bunch",
                                          "price": 54900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "50670162",
                                      "groupName": "Add On - Extras",
                                      "choices": [
                                        {
                                          "id": "35198457",
                                          "name": "Set of 50 balloons (deflated)",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198453",
                                          "name": "6 Inch Teddy Bear",
                                          "price": 29900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198452",
                                          "name": "Set of 2 Party Poppers",
                                          "price": 13900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198455",
                                          "name": "Happy Birthday Banner",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113484081",
                                          "name": "Set of 2 Party Poppers",
                                          "price": 13900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 52900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.0",
                                      "ratingCount": "36 ratings",
                                      "ratingCountV2": "36"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "11860041",
                                  "name": "Coffee Walnut Cake",
                                  "category": "Cakes",
                                  "description": "Serves 1 | A rich molten vanilla cake augmented with a coffee cake and inundated with the crunch of walnuts. A perfect blend of textures and flavors.",
                                  "imageId": "usj8p1gcpyikqcektjnx",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "14031790",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "500 gm",
                                            "price": 599,
                                            "default": 1,
                                            "id": "45439633",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg",
                                            "price": 1150,
                                            "id": "45439634",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14031790",
                                            "variationId": "45439633"
                                          }
                                        ],
                                        "price": 59900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "50670280",
                                            "addonId": "35198444"
                                          },
                                          {
                                            "groupId": "50670280",
                                            "addonId": "35198445"
                                          },
                                          {
                                            "groupId": "50670290",
                                            "addonId": "35198446"
                                          },
                                          {
                                            "groupId": "50670290",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "50670290",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "50670303",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "50670303",
                                            "addonId": "35198451"
                                          },
                                          {
                                            "groupId": "50670303",
                                            "addonId": "35198450"
                                          },
                                          {
                                            "groupId": "50670314",
                                            "addonId": "35198455"
                                          },
                                          {
                                            "groupId": "50670314",
                                            "addonId": "35198452"
                                          },
                                          {
                                            "groupId": "50670314",
                                            "addonId": "35198457"
                                          },
                                          {
                                            "groupId": "50670314",
                                            "addonId": "35198453"
                                          },
                                          {
                                            "groupId": "50670314",
                                            "addonId": "113484081"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14031790",
                                            "variationId": "45439634"
                                          }
                                        ],
                                        "price": 115000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "50670280",
                                            "addonId": "35198444"
                                          },
                                          {
                                            "groupId": "50670280",
                                            "addonId": "35198445"
                                          },
                                          {
                                            "groupId": "50670290",
                                            "addonId": "35198446"
                                          },
                                          {
                                            "groupId": "50670290",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "50670290",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "50670303",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "50670303",
                                            "addonId": "35198451"
                                          },
                                          {
                                            "groupId": "50670303",
                                            "addonId": "35198450"
                                          },
                                          {
                                            "groupId": "50670314",
                                            "addonId": "35198455"
                                          },
                                          {
                                            "groupId": "50670314",
                                            "addonId": "35198452"
                                          },
                                          {
                                            "groupId": "50670314",
                                            "addonId": "35198457"
                                          },
                                          {
                                            "groupId": "50670314",
                                            "addonId": "35198453"
                                          },
                                          {
                                            "groupId": "50670314",
                                            "addonId": "113484081"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "50670280",
                                      "groupName": "Add On - Birthday Caps",
                                      "choices": [
                                        {
                                          "id": "35198445",
                                          "name": "Birthday Caps For Girls",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198444",
                                          "name": "Birthday Cap for Boys",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "50670290",
                                      "groupName": "Add On -  Candles",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198446",
                                          "name": "'BIRTHDAY' Letter Candles",
                                          "price": 12900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "50670303",
                                      "groupName": "Add On - Roses",
                                      "choices": [
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198451",
                                          "name": "6 Red rose Bunch",
                                          "price": 39900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198450",
                                          "name": "10 Red rose Bunch",
                                          "price": 54900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "50670314",
                                      "groupName": "Add On - Extras",
                                      "choices": [
                                        {
                                          "id": "35198457",
                                          "name": "Set of 50 balloons (deflated)",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198453",
                                          "name": "6 Inch Teddy Bear",
                                          "price": 29900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198452",
                                          "name": "Set of 2 Party Poppers",
                                          "price": 13900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198455",
                                          "name": "Happy Birthday Banner",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113484081",
                                          "name": "Set of 2 Party Poppers",
                                          "price": 13900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 59900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.0",
                                      "ratingCount": "21 ratings",
                                      "ratingCountV2": "21"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Heart Shaped Cakes",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "28387962",
                                  "name": "Choco Truffle Heart Cake",
                                  "category": "Cakes",
                                  "description": "Serves 1 | A heart shaped decadent and exotic combination of melted chocolate and truffles augmented with a streak of white chocolate to top it off",
                                  "imageId": "dli11m6mombxmrgz4bce",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "14031920",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "500 gm",
                                            "price": 599,
                                            "default": 1,
                                            "id": "45439920",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg",
                                            "price": 1199,
                                            "id": "45439921",
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14031920",
                                            "variationId": "45439920"
                                          }
                                        ],
                                        "price": 59900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "48691918",
                                            "addonId": "35198444"
                                          },
                                          {
                                            "groupId": "48691918",
                                            "addonId": "35198445"
                                          },
                                          {
                                            "groupId": "48691937",
                                            "addonId": "35198446"
                                          },
                                          {
                                            "groupId": "48691937",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "48691937",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "48691954",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "48691954",
                                            "addonId": "35198451"
                                          },
                                          {
                                            "groupId": "48691954",
                                            "addonId": "35198450"
                                          },
                                          {
                                            "groupId": "48691977",
                                            "addonId": "35198455"
                                          },
                                          {
                                            "groupId": "48691977",
                                            "addonId": "35198452"
                                          },
                                          {
                                            "groupId": "48691977",
                                            "addonId": "35198457"
                                          },
                                          {
                                            "groupId": "48691977",
                                            "addonId": "35198453"
                                          },
                                          {
                                            "groupId": "48691977",
                                            "addonId": "113484081"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14031920",
                                            "variationId": "45439921"
                                          }
                                        ],
                                        "price": 119900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "48691918",
                                            "addonId": "35198444"
                                          },
                                          {
                                            "groupId": "48691918",
                                            "addonId": "35198445"
                                          },
                                          {
                                            "groupId": "48691937",
                                            "addonId": "35198446"
                                          },
                                          {
                                            "groupId": "48691937",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "48691937",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "48691954",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "48691954",
                                            "addonId": "35198451"
                                          },
                                          {
                                            "groupId": "48691954",
                                            "addonId": "35198450"
                                          },
                                          {
                                            "groupId": "48691977",
                                            "addonId": "35198455"
                                          },
                                          {
                                            "groupId": "48691977",
                                            "addonId": "35198452"
                                          },
                                          {
                                            "groupId": "48691977",
                                            "addonId": "35198457"
                                          },
                                          {
                                            "groupId": "48691977",
                                            "addonId": "35198453"
                                          },
                                          {
                                            "groupId": "48691977",
                                            "addonId": "113484081"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "48691918",
                                      "groupName": "Add On - Birthday Caps",
                                      "choices": [
                                        {
                                          "id": "35198445",
                                          "name": "Birthday Caps For Girls",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198444",
                                          "name": "Birthday Cap for Boys",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "48691937",
                                      "groupName": "Add On -  Candles",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198446",
                                          "name": "'BIRTHDAY' Letter Candles",
                                          "price": 12900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "48691954",
                                      "groupName": "Add On - Roses",
                                      "choices": [
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198451",
                                          "name": "6 Red rose Bunch",
                                          "price": 39900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198450",
                                          "name": "10 Red rose Bunch",
                                          "price": 54900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "48691977",
                                      "groupName": "Add On - Extras",
                                      "choices": [
                                        {
                                          "id": "35198457",
                                          "name": "Set of 50 balloons (deflated)",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198453",
                                          "name": "6 Inch Teddy Bear",
                                          "price": 29900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198452",
                                          "name": "Set of 2 Party Poppers",
                                          "price": 13900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198455",
                                          "name": "Happy Birthday Banner",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113484081",
                                          "name": "Set of 2 Party Poppers",
                                          "price": 13900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 59900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "42 ratings",
                                      "ratingCountV2": "42"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Gourmet Cakes",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "96812030",
                              "name": "Trio Mousse Cake",
                              "category": "Gourmet Cakes",
                              "description": "Serves 1 | A decadent trio of white chocolate, milk chocolate, CHD 45 chocolate & egg topped off with a rich cream.",
                              "imageId": "cpftekp5oywo54hygynw",
                              "inStock": 1,
                              "price": 59900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "56132634",
                                  "groupName": "Add On - Birthday Caps",
                                  "choices": [
                                    {
                                      "id": "35198445",
                                      "name": "Birthday Caps For Girls",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198444",
                                      "name": "Birthday Cap for Boys",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "56132637",
                                  "groupName": "Add On -  Candles",
                                  "choices": [
                                    {
                                      "id": "35198447",
                                      "name": "Flower Candle",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198448",
                                      "name": "One Pack Magic Candle",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198446",
                                      "name": "'BIRTHDAY' Letter Candles",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "56132640",
                                  "groupName": "Add On - Roses",
                                  "choices": [
                                    {
                                      "id": "35198449",
                                      "name": "Single Red Rose",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198451",
                                      "name": "6 Red rose Bunch",
                                      "price": 39900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198450",
                                      "name": "10 Red rose Bunch",
                                      "price": 54900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "56132642",
                                  "groupName": "Add On - Extras",
                                  "choices": [
                                    {
                                      "id": "35198457",
                                      "name": "Set of 50 balloons (deflated)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198453",
                                      "name": "6 Inch Teddy Bear",
                                      "price": 29900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198452",
                                      "name": "Set of 2 Party Poppers",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198455",
                                      "name": "Happy Birthday Banner",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113484081",
                                      "name": "Set of 2 Party Poppers",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "11 ratings",
                                  "ratingCountV2": "11"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110237127",
                              "name": "Nutella Hazelnut Cake",
                              "category": "Gourmet Cakes",
                              "description": "Serves 1 | A perfect blend of molten Nutella chocolate augmented with truffle, hazelnuts and topped with fresh cream.",
                              "imageId": "e0cfa0be4f49840e476b09fccb415ca8",
                              "inStock": 1,
                              "price": 59900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "77847836",
                                  "groupName": "Add On - Birthday Caps",
                                  "choices": [
                                    {
                                      "id": "35198445",
                                      "name": "Birthday Caps For Girls",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198444",
                                      "name": "Birthday Cap for Boys",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "77847837",
                                  "groupName": "Add On -  Candles",
                                  "choices": [
                                    {
                                      "id": "35198447",
                                      "name": "Flower Candle",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198448",
                                      "name": "One Pack Magic Candle",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198446",
                                      "name": "'BIRTHDAY' Letter Candles",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "77847839",
                                  "groupName": "Add On - Roses",
                                  "choices": [
                                    {
                                      "id": "35198449",
                                      "name": "Single Red Rose",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198451",
                                      "name": "6 Red rose Bunch",
                                      "price": 39900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198450",
                                      "name": "10 Red rose Bunch",
                                      "price": 54900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "77847842",
                                  "groupName": "Add On - Extras",
                                  "choices": [
                                    {
                                      "id": "35198457",
                                      "name": "Set of 50 balloons (deflated)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198453",
                                      "name": "6 Inch Teddy Bear",
                                      "price": 29900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198452",
                                      "name": "Set of 2 Party Poppers",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198455",
                                      "name": "Happy Birthday Banner",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113484081",
                                      "name": "Set of 2 Party Poppers",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 59900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.9",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110237130",
                              "name": "Belgian Chocolate Cake",
                              "category": "Gourmet Cakes",
                              "description": "Serves 1 | Inspired by the famous chocolate, blended with truffle, milk chocolate, cocoa butter and inundated with french biscuits for the perfect texture.",
                              "imageId": "27dc632f5c67d9626a161f6f44809d0f",
                              "inStock": 1,
                              "price": 59900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "77847844",
                                  "groupName": "Add On - Birthday Caps",
                                  "choices": [
                                    {
                                      "id": "35198445",
                                      "name": "Birthday Caps For Girls",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198444",
                                      "name": "Birthday Cap for Boys",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "77847845",
                                  "groupName": "Add On -  Candles",
                                  "choices": [
                                    {
                                      "id": "35198447",
                                      "name": "Flower Candle",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198448",
                                      "name": "One Pack Magic Candle",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198446",
                                      "name": "'BIRTHDAY' Letter Candles",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "77847846",
                                  "groupName": "Add On - Roses",
                                  "choices": [
                                    {
                                      "id": "35198449",
                                      "name": "Single Red Rose",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198451",
                                      "name": "6 Red rose Bunch",
                                      "price": 39900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198450",
                                      "name": "10 Red rose Bunch",
                                      "price": 54900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "77847849",
                                  "groupName": "Add On - Extras",
                                  "choices": [
                                    {
                                      "id": "35198457",
                                      "name": "Set of 50 balloons (deflated)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198453",
                                      "name": "6 Inch Teddy Bear",
                                      "price": 29900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198452",
                                      "name": "Set of 2 Party Poppers",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198455",
                                      "name": "Happy Birthday Banner",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113484081",
                                      "name": "Set of 2 Party Poppers",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 59900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.5",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "11860042",
                              "name": "Almond Ferrero Rocher Cake",
                              "category": "Gourmet Cakes",
                              "description": "Serves 1 | A rich & moist chocolate cake topped with Ferrero Rocher balls & coated with almond shavings",
                              "imageId": "tkaw85ytzbsdspaammgs",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "14031847",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "500 gm",
                                        "price": 699,
                                        "default": 1,
                                        "id": "45439760",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "1 Kg",
                                        "price": 1350,
                                        "id": "45439761",
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "14031847",
                                        "variationId": "45439760"
                                      }
                                    ],
                                    "price": 69900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "48691354",
                                        "addonId": "35198444"
                                      },
                                      {
                                        "groupId": "48691354",
                                        "addonId": "35198445"
                                      },
                                      {
                                        "groupId": "48691367",
                                        "addonId": "35198446"
                                      },
                                      {
                                        "groupId": "48691367",
                                        "addonId": "35198447"
                                      },
                                      {
                                        "groupId": "48691367",
                                        "addonId": "35198448"
                                      },
                                      {
                                        "groupId": "48691386",
                                        "addonId": "35198449"
                                      },
                                      {
                                        "groupId": "48691386",
                                        "addonId": "35198451"
                                      },
                                      {
                                        "groupId": "48691386",
                                        "addonId": "35198450"
                                      },
                                      {
                                        "groupId": "48691405",
                                        "addonId": "35198455"
                                      },
                                      {
                                        "groupId": "48691405",
                                        "addonId": "35198452"
                                      },
                                      {
                                        "groupId": "48691405",
                                        "addonId": "35198457"
                                      },
                                      {
                                        "groupId": "48691405",
                                        "addonId": "35198453"
                                      },
                                      {
                                        "groupId": "48691405",
                                        "addonId": "113484081"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "14031847",
                                        "variationId": "45439761"
                                      }
                                    ],
                                    "price": 135000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "48691354",
                                        "addonId": "35198444"
                                      },
                                      {
                                        "groupId": "48691354",
                                        "addonId": "35198445"
                                      },
                                      {
                                        "groupId": "48691367",
                                        "addonId": "35198446"
                                      },
                                      {
                                        "groupId": "48691367",
                                        "addonId": "35198447"
                                      },
                                      {
                                        "groupId": "48691367",
                                        "addonId": "35198448"
                                      },
                                      {
                                        "groupId": "48691386",
                                        "addonId": "35198449"
                                      },
                                      {
                                        "groupId": "48691386",
                                        "addonId": "35198451"
                                      },
                                      {
                                        "groupId": "48691386",
                                        "addonId": "35198450"
                                      },
                                      {
                                        "groupId": "48691405",
                                        "addonId": "35198455"
                                      },
                                      {
                                        "groupId": "48691405",
                                        "addonId": "35198452"
                                      },
                                      {
                                        "groupId": "48691405",
                                        "addonId": "35198457"
                                      },
                                      {
                                        "groupId": "48691405",
                                        "addonId": "35198453"
                                      },
                                      {
                                        "groupId": "48691405",
                                        "addonId": "113484081"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "48691354",
                                  "groupName": "Add On - Birthday Caps",
                                  "choices": [
                                    {
                                      "id": "35198445",
                                      "name": "Birthday Caps For Girls",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198444",
                                      "name": "Birthday Cap for Boys",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "48691367",
                                  "groupName": "Add On -  Candles",
                                  "choices": [
                                    {
                                      "id": "35198447",
                                      "name": "Flower Candle",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198448",
                                      "name": "One Pack Magic Candle",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198446",
                                      "name": "'BIRTHDAY' Letter Candles",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "48691386",
                                  "groupName": "Add On - Roses",
                                  "choices": [
                                    {
                                      "id": "35198449",
                                      "name": "Single Red Rose",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198451",
                                      "name": "6 Red rose Bunch",
                                      "price": 39900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198450",
                                      "name": "10 Red rose Bunch",
                                      "price": 54900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "48691405",
                                  "groupName": "Add On - Extras",
                                  "choices": [
                                    {
                                      "id": "35198457",
                                      "name": "Set of 50 balloons (deflated)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198453",
                                      "name": "6 Inch Teddy Bear",
                                      "price": 29900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198452",
                                      "name": "Set of 2 Party Poppers",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198455",
                                      "name": "Happy Birthday Banner",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113484081",
                                      "name": "Set of 2 Party Poppers",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 69900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "71 ratings",
                                  "ratingCountV2": "71"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "90185417",
                              "name": "Coffee Opera Cake",
                              "category": "Gourmet Cakes",
                              "description": "Serves 1 | Jocan sponge, coffee, fresh cream, egg and rich chocolate is topped off with our signature Opera glaze.",
                              "imageId": "veunwhek56tgfetrqjmk",
                              "inStock": 1,
                              "price": 59900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "49999495",
                                  "groupName": "Add On - Birthday Caps",
                                  "choices": [
                                    {
                                      "id": "35198445",
                                      "name": "Birthday Caps For Girls",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198444",
                                      "name": "Birthday Cap for Boys",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "49999506",
                                  "groupName": "Add On -  Candles",
                                  "choices": [
                                    {
                                      "id": "35198447",
                                      "name": "Flower Candle",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198448",
                                      "name": "One Pack Magic Candle",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198446",
                                      "name": "'BIRTHDAY' Letter Candles",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "49999523",
                                  "groupName": "Add On - Roses",
                                  "choices": [
                                    {
                                      "id": "35198449",
                                      "name": "Single Red Rose",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198451",
                                      "name": "6 Red rose Bunch",
                                      "price": 39900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198450",
                                      "name": "10 Red rose Bunch",
                                      "price": 54900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "49999538",
                                  "groupName": "Add On - Extras",
                                  "choices": [
                                    {
                                      "id": "35198457",
                                      "name": "Set of 50 balloons (deflated)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198453",
                                      "name": "6 Inch Teddy Bear",
                                      "price": 29900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198452",
                                      "name": "Set of 2 Party Poppers",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198455",
                                      "name": "Happy Birthday Banner",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113484081",
                                      "name": "Set of 2 Party Poppers",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 59900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "90185455",
                              "name": "Tiramisu Cake",
                              "category": "Gourmet Cakes",
                              "description": "Serves 1 | A crowd favourite, Bakingo style, replete with Jocan spunge, rum, egg, topping cream, butter & cream cheese",
                              "imageId": "5467aa073049b97d8d5416cb2fa825d9",
                              "inStock": 1,
                              "price": 64900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "49999571",
                                  "groupName": "Add On - Birthday Caps",
                                  "choices": [
                                    {
                                      "id": "35198445",
                                      "name": "Birthday Caps For Girls",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198444",
                                      "name": "Birthday Cap for Boys",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "49999578",
                                  "groupName": "Add On -  Candles",
                                  "choices": [
                                    {
                                      "id": "35198447",
                                      "name": "Flower Candle",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198448",
                                      "name": "One Pack Magic Candle",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198446",
                                      "name": "'BIRTHDAY' Letter Candles",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "49999587",
                                  "groupName": "Add On - Roses",
                                  "choices": [
                                    {
                                      "id": "35198449",
                                      "name": "Single Red Rose",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198451",
                                      "name": "6 Red rose Bunch",
                                      "price": 39900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198450",
                                      "name": "10 Red rose Bunch",
                                      "price": 54900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "49999595",
                                  "groupName": "Add On - Extras",
                                  "choices": [
                                    {
                                      "id": "35198457",
                                      "name": "Set of 50 balloons (deflated)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198453",
                                      "name": "6 Inch Teddy Bear",
                                      "price": 29900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198452",
                                      "name": "Set of 2 Party Poppers",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198455",
                                      "name": "Happy Birthday Banner",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113484081",
                                      "name": "Set of 2 Party Poppers",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 64900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Baked Cheesecakes",
                      "categories": [
                        {
                          "title": "Cheesecakes",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "99530072",
                                  "name": "Blueberry Baked Cheese Cake",
                                  "category": "Baked Cheesecakes",
                                  "description": "Serves 1 | Delectable cream cheese, fresh cream, and fresh blueberry pulp completes a classic cheese cake",
                                  "imageId": "ljvavslj6h5c93cnmppw",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 74900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.7",
                                      "ratingCount": "23 ratings",
                                      "ratingCountV2": "23"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "112797569",
                                  "name": "Biscoff Baked Cheesecake (600 gm)",
                                  "category": "Baked Cheesecakes",
                                  "description": "Serves 1 | A delectable cheesecake prepared with fresh cream, infused with cream cheese and topped with a Lotus Biscoff Biscuit",
                                  "imageId": "ee62781b41b4adaf15aef6ec38e1d27e",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 89900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "82998556",
                                      "groupName": "Add On - Birthday Caps",
                                      "choices": [
                                        {
                                          "id": "35198445",
                                          "name": "Birthday Caps For Girls",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198444",
                                          "name": "Birthday Cap for Boys",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "82998557",
                                      "groupName": "Add On -  Candles",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198446",
                                          "name": "'BIRTHDAY' Letter Candles",
                                          "price": 12900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "82998558",
                                      "groupName": "Add On - Roses",
                                      "choices": [
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198451",
                                          "name": "6 Red rose Bunch",
                                          "price": 39900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198450",
                                          "name": "10 Red rose Bunch",
                                          "price": 54900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "82998559",
                                      "groupName": "Add On - Extras",
                                      "choices": [
                                        {
                                          "id": "35198457",
                                          "name": "Set of 50 balloons (deflated)",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198453",
                                          "name": "6 Inch Teddy Bear",
                                          "price": 29900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198452",
                                          "name": "Set of 2 Party Poppers",
                                          "price": 13900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198455",
                                          "name": "Happy Birthday Banner",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113484081",
                                          "name": "Set of 2 Party Poppers",
                                          "price": 13900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.5",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Slices",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "86187318",
                                  "name": "New York Bake Cheesecake Slice",
                                  "category": "Baked Cheesecakes",
                                  "description": "Serves 1 | Fresh & velvety cream cheese makes for a classic New York Baked Cheese Cake",
                                  "imageId": "bdfe8157c3371bc8b03d362290d834dc",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 14900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "194 ratings",
                                      "ratingCountV2": "194"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "92637741",
                                  "name": "Blueberry Bake Cheesecake Slice",
                                  "category": "Baked Cheesecakes",
                                  "description": "Serves 1 | A light & creamy cheese cake with blueberry pulp baked with cream cheese",
                                  "imageId": "f532ecd6ffae5ca5b75cf0f18c1123ac",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 14900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "257 ratings",
                                      "ratingCountV2": "257"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101470245",
                                  "name": "Nutella Cheesecake Slice",
                                  "category": "Baked Cheesecakes",
                                  "description": "Serves 1 | A scrumptious and decadent cheesecake layered with fresh cream, cream cheese & nutella and inundated with butter and cookies",
                                  "imageId": "rgqlm27asr8qhgwxioln",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 19900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "97 ratings",
                                      "ratingCountV2": "97"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "99530071",
                                  "name": "Oreo Bake Cheesecake slice",
                                  "category": "Baked Cheesecakes",
                                  "description": "Serves 1 | Delectable cream cheese, fresh cream, oreos and chocolate make for a classic oreo baked cheesecake, Bakingo style.",
                                  "imageId": "s44gxrymdttx1cfjxc4x",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 19900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "68 ratings",
                                      "ratingCountV2": "68"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Brownie & Tarts",
                      "categories": [
                        {
                          "title": "Brownie",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "132020079",
                                  "name": "Biscoff Brownie",
                                  "category": "Brownie & Tarts",
                                  "description": "Serves 1 | A delightful and indulgent treat that combines the rich and fudgy texture of traditional brownies with the unique flavor of Biscoff spread",
                                  "imageId": "82db2d44fb1c826be2703da13ab56064",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 12900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "131138093",
                                      "groupName": "Add On",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102193391",
                                          "name": "Premium Bakingo Opener",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "25967100",
                                  "name": "Classic Walnut Brownie",
                                  "category": "Brownie & Tarts",
                                  "description": "Serves 1 | A classic brownie Bakingo style. Infused with milkmaid, fresh cream and Vanleer dark chocolate, inundated with walnuts.",
                                  "imageId": "1f27dba287121fbb4df192b7c67ede64",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "14031659",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Single",
                                            "price": 89,
                                            "default": 1,
                                            "id": "45439353",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Pack of 6",
                                            "price": 499,
                                            "id": "45439354",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14031659",
                                            "variationId": "45439353"
                                          }
                                        ],
                                        "price": 8900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14031659",
                                            "variationId": "45439354"
                                          }
                                        ],
                                        "price": 49900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 8900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "161 ratings",
                                      "ratingCountV2": "161"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "25967101",
                                  "name": "Nutella Brownie",
                                  "category": "Brownie & Tarts",
                                  "description": "Serves 1 | The quintessential indulgent brownie prepared with milk maid, fresh cream & CHD 45 Chocolate, infused with Nutella and hazelnuts.",
                                  "imageId": "2fca02ee8233a9b0f93455565458a8ae",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "31693292",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Single",
                                            "price": 109,
                                            "default": 1,
                                            "id": "98052121",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Pack of 6",
                                            "price": 649,
                                            "id": "98052122",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "31693292",
                                            "variationId": "98052121"
                                          }
                                        ],
                                        "price": 10900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "31693292",
                                            "variationId": "98052122"
                                          }
                                        ],
                                        "price": 64900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 10900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "213 ratings",
                                      "ratingCountV2": "213"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "102672407",
                                  "name": "Millionaire Brownie",
                                  "category": "Brownie & Tarts",
                                  "description": "Serves 1 | A Dark Compound chocolate brownie prepared with the classic molten gooeyness of a millionaire caramel spread, vanilla essence & Morde CHD 45 Truffle",
                                  "imageId": "qnqczdww7ydtjybfwk2a",
                                  "inStock": 1,
                                  "price": 10900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "13 ratings",
                                      "ratingCountV2": "13"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "132020078",
                                  "name": "Coffee Mocha Brownie",
                                  "category": "Brownie & Tarts",
                                  "description": "Serves 1 | Prepared with milkmaid, fresh cream & Vanleer dark chocolate, topped with Morde CHD 45 Truffle and infused with aromatic filter coffee.",
                                  "imageId": "786a8ef1865d646aaa030e38cd885886",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 11900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "102672410",
                                  "name": "Double Choco Brownie",
                                  "category": "Brownie & Tarts",
                                  "description": "Serves 1 | A delicious chocolate overload brownie prepared with Morde CHD 45 chocolate and egg, infused with vanilla essense and inundated with choco chips.",
                                  "imageId": "ox7dn8jonqeoe5vvtvfb",
                                  "inStock": 1,
                                  "price": 10900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "28 ratings",
                                      "ratingCountV2": "28"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Tart & Pie",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93757843",
                                  "name": "Choco Tart",
                                  "category": "Brownie & Tarts",
                                  "description": "Serves 1 | A perfctly crunchy biscuity shell, dark compound & fresh cream completes this classic",
                                  "imageId": "zqwl5zpqf1wg2pq56sjf",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 10900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "11 ratings",
                                      "ratingCountV2": "11"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93757844",
                                  "name": "Apple Pie Tart",
                                  "category": "Brownie & Tarts",
                                  "description": "Serves 1 | A classic tart with fresh apples, almonds, raisin, pista & milk maid",
                                  "imageId": "mafier6hpsaiuxvyhbuq",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 10900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.5",
                                      "ratingCount": "29 ratings",
                                      "ratingCountV2": "29"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Cup Cakes",
                      "categories": [
                        {
                          "title": "Classic Cup Cakes",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "90185478",
                                  "name": "Choco Lava",
                                  "category": "Cup Cakes",
                                  "description": "Serves 1 | The classic Choco lava cake Bakingo style. Gooey molten CHD 45 chocolaty goodness.",
                                  "imageId": "ozzljnba6jjdfaljpa8h",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 7900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "63646204",
                                      "groupName": "Add On",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102193391",
                                          "name": "Premium Bakingo Opener",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.8",
                                      "ratingCount": "46 ratings",
                                      "ratingCountV2": "46"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "25968052",
                                  "name": "Blueberry Cup Cake",
                                  "category": "Cup Cakes",
                                  "description": "Serves 1 | Fresh blueberry pulp topped with whipped cream & sprinkles in a cup cake",
                                  "imageId": "bqct0qlenq6npiooqtjo",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "14031428",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Single",
                                            "price": 79,
                                            "default": 1,
                                            "id": "45438878",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Double",
                                            "price": 109,
                                            "id": "45438879",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Pack Of 6",
                                            "price": 299,
                                            "id": "45438880",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14031428",
                                            "variationId": "45438878"
                                          }
                                        ],
                                        "price": 7900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "63645666",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "63645666",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "63645666",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "63645666",
                                            "addonId": "102193391"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14031428",
                                            "variationId": "45438879"
                                          }
                                        ],
                                        "price": 10900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "63645666",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "63645666",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "63645666",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "63645666",
                                            "addonId": "102193391"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14031428",
                                            "variationId": "45438880"
                                          }
                                        ],
                                        "price": 29900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "63645666",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "63645666",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "63645666",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "63645666",
                                            "addonId": "102193391"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "63645666",
                                      "groupName": "Add On",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102193391",
                                          "name": "Premium Bakingo Opener",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 7900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "125 ratings",
                                      "ratingCountV2": "125"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "25968056",
                                  "name": "Pineapple Cup Cake",
                                  "category": "Cup Cakes",
                                  "description": "Serves 1 | A frosted creamy classic topped with a juicy pineapple",
                                  "imageId": "uz18zr2fjzlnnoswi90x",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "14032154",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Double",
                                            "price": 109,
                                            "id": "45440433",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Pack Of 6",
                                            "price": 299,
                                            "id": "45440434",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Single",
                                            "price": 69,
                                            "default": 1,
                                            "id": "45440431",
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14032154",
                                            "variationId": "45440431"
                                          }
                                        ],
                                        "price": 6900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "63646075",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "63646075",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "63646075",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "63646075",
                                            "addonId": "102193391"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14032154",
                                            "variationId": "45440433"
                                          }
                                        ],
                                        "price": 10900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "63646075",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "63646075",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "63646075",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "63646075",
                                            "addonId": "102193391"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14032154",
                                            "variationId": "45440434"
                                          }
                                        ],
                                        "price": 29900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "63646075",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "63646075",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "63646075",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "63646075",
                                            "addonId": "102193391"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "63646075",
                                      "groupName": "Add On",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102193391",
                                          "name": "Premium Bakingo Opener",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 6900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.5",
                                      "ratingCount": "69 ratings",
                                      "ratingCountV2": "69"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "25968050",
                                  "name": "Vanilla Cup Cake",
                                  "category": "Cup Cakes",
                                  "description": "Serves 1 | A classic cupcake with vanilla whippd cream adn edible sugar sprinkles",
                                  "imageId": "fu3slis50dgunqh2vr2m",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "14032279",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Double",
                                            "price": 129,
                                            "id": "45440704",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Pack Of 6",
                                            "price": 299,
                                            "id": "45440705",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Single",
                                            "price": 69,
                                            "default": 1,
                                            "id": "45440703",
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14032279",
                                            "variationId": "45440703"
                                          }
                                        ],
                                        "price": 6900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "63646141",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "63646141",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "63646141",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "63646141",
                                            "addonId": "102193391"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14032279",
                                            "variationId": "45440704"
                                          }
                                        ],
                                        "price": 12900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "63646141",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "63646141",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "63646141",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "63646141",
                                            "addonId": "102193391"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14032279",
                                            "variationId": "45440705"
                                          }
                                        ],
                                        "price": 29900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "63646141",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "63646141",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "63646141",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "63646141",
                                            "addonId": "102193391"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "63646141",
                                      "groupName": "Add On",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102193391",
                                          "name": "Premium Bakingo Opener",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 6900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.9",
                                      "ratingCount": "186 ratings",
                                      "ratingCountV2": "186"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "61475983",
                                  "name": "Red Velvet Cup Cake",
                                  "category": "Cup Cakes",
                                  "description": "Serves 1 | A red velvet extravaganza topped with whippe cream and red velvet sprinkles",
                                  "imageId": "hdltmvqjlou5hsqely7t",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "14032251",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Single",
                                            "price": 79,
                                            "default": 1,
                                            "id": "45440645",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Double",
                                            "price": 109,
                                            "id": "45440646",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Pack Of 6",
                                            "price": 299,
                                            "id": "45440648",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14032251",
                                            "variationId": "45440645"
                                          }
                                        ],
                                        "price": 7900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "63646128",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "63646128",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "63646128",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "63646128",
                                            "addonId": "102193391"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14032251",
                                            "variationId": "45440646"
                                          }
                                        ],
                                        "price": 10900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "63646128",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "63646128",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "63646128",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "63646128",
                                            "addonId": "102193391"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14032251",
                                            "variationId": "45440648"
                                          }
                                        ],
                                        "price": 29900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "63646128",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "63646128",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "63646128",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "63646128",
                                            "addonId": "102193391"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "63646128",
                                      "groupName": "Add On",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102193391",
                                          "name": "Premium Bakingo Opener",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 7900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "110 ratings",
                                      "ratingCountV2": "110"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "48025491",
                                  "name": "Choco Chip Cream Cup Cake",
                                  "category": "Cup Cakes",
                                  "description": "Serves 1 | A classic chocolate cream cup cake overloaded with choco chips",
                                  "imageId": "edhfkkyf58bxoliyi6uy",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "14032101",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Single",
                                            "price": 79,
                                            "default": 1,
                                            "id": "45440314",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Double",
                                            "price": 109,
                                            "id": "45440318",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Pack Of 6",
                                            "price": 299,
                                            "id": "45440319",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14032101",
                                            "variationId": "45440314"
                                          }
                                        ],
                                        "price": 7900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "63646041",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "63646041",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "63646041",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "63646041",
                                            "addonId": "102193391"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14032101",
                                            "variationId": "45440318"
                                          }
                                        ],
                                        "price": 10900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "63646041",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "63646041",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "63646041",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "63646041",
                                            "addonId": "102193391"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14032101",
                                            "variationId": "45440319"
                                          }
                                        ],
                                        "price": 29900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "63646041",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "63646041",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "63646041",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "63646041",
                                            "addonId": "102193391"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "63646041",
                                      "groupName": "Add On",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102193391",
                                          "name": "Premium Bakingo Opener",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 7900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "121 ratings",
                                      "ratingCountV2": "121"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "61475967",
                                  "name": "Oreo Cup Cake",
                                  "category": "Cup Cakes",
                                  "description": "Serves 1 | A chocolate sponge frosted cup cake with whipped cream and an oreo cookie",
                                  "imageId": "lgnjonfitzmazjai6p0y",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "14032116",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Single",
                                            "price": 79,
                                            "default": 1,
                                            "id": "45440349",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Double",
                                            "price": 129,
                                            "id": "45440350",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Pack Of 6",
                                            "price": 349,
                                            "id": "45440351",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14032116",
                                            "variationId": "45440349"
                                          }
                                        ],
                                        "price": 7900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "63646059",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "63646059",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "63646059",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "63646059",
                                            "addonId": "102193391"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14032116",
                                            "variationId": "45440350"
                                          }
                                        ],
                                        "price": 12900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "63646059",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "63646059",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "63646059",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "63646059",
                                            "addonId": "102193391"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14032116",
                                            "variationId": "45440351"
                                          }
                                        ],
                                        "price": 34900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "63646059",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "63646059",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "63646059",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "63646059",
                                            "addonId": "102193391"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "63646059",
                                      "groupName": "Add On",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102193391",
                                          "name": "Premium Bakingo Opener",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 7900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.1",
                                      "ratingCount": "16 ratings",
                                      "ratingCountV2": "16"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "61475956",
                                  "name": "Choco Devil Cup Cakes",
                                  "category": "Cup Cakes",
                                  "description": "Serves 1 | An intense chocolate overload replete with chocolate frosting & topped with white chocolate swirl",
                                  "imageId": "f94vpxgqoylfsbzahxgi",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "14031824",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Single",
                                            "price": 79,
                                            "default": 1,
                                            "id": "45439706",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Double",
                                            "price": 109,
                                            "id": "45439707",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Pack Of 6",
                                            "price": 299,
                                            "id": "45439709",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14031824",
                                            "variationId": "45439706"
                                          }
                                        ],
                                        "price": 7900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "63645955",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "63645955",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "63645955",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "63645955",
                                            "addonId": "102193391"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14031824",
                                            "variationId": "45439707"
                                          }
                                        ],
                                        "price": 10900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "63645955",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "63645955",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "63645955",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "63645955",
                                            "addonId": "102193391"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14031824",
                                            "variationId": "45439709"
                                          }
                                        ],
                                        "price": 29900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "63645955",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "63645955",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "63645955",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "63645955",
                                            "addonId": "102193391"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "63645955",
                                      "groupName": "Add On",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102193391",
                                          "name": "Premium Bakingo Opener",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 7900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.9",
                                      "ratingCount": "84 ratings",
                                      "ratingCountV2": "84"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Assorted Cup Cakes",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "121455016",
                                  "name": "Pack of 6 Assorted Cup Cakes",
                                  "category": "Cup Cakes",
                                  "description": "Serves 1",
                                  "imageId": "4907a6750a69416b6bb52767c6d8cf1f",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 37900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "102456071",
                                      "groupName": "Select 1st, 2nd & 3rd",
                                      "choices": [
                                        {
                                          "id": "96005122",
                                          "name": "Choco Chip Cream Cup Cake",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "96005123",
                                          "name": "Blueberry Cup Cake",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "96005124",
                                          "name": "Red Velvet Cup Cake",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "96005125",
                                          "name": "Coffee Cup Cake",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "96005121",
                                          "name": "Vanilla Cup Cake",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 3
                                    },
                                    {
                                      "groupId": "102456072",
                                      "groupName": "Select 4th,5th & 6th",
                                      "choices": [
                                        {
                                          "id": "96005122",
                                          "name": "Choco Chip Cream Cup Cake",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "96005123",
                                          "name": "Blueberry Cup Cake",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "96005124",
                                          "name": "Red Velvet Cup Cake",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "96005125",
                                          "name": "Coffee Cup Cake",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "96005121",
                                          "name": "Vanilla Cup Cake",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 3
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.7",
                                      "ratingCount": "5 ratings",
                                      "ratingCountV2": "5"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "66609567",
                                  "name": "Set of 2 each of Red Velvet ,Pineapple and Vanilla Cup Cake",
                                  "category": "Cup Cakes",
                                  "description": "Serves 1 | 6 assorted cup cakes  in 3 mouth watering flavours",
                                  "imageId": "vrp9yfhgcseh8vnekjqf",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 37900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "63646169",
                                      "groupName": "Add On",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102193391",
                                          "name": "Premium Bakingo Opener",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.7",
                                      "ratingCount": "29 ratings",
                                      "ratingCountV2": "29"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "66609558",
                                  "name": "Set of 2 each of Choco Chip Cream, Oreo and Choco Devil Cup Cake",
                                  "category": "Cup Cakes",
                                  "description": "Serves 1 | 6 assorted cup cakes  in 3 mouth watering flavours",
                                  "imageId": "ktw67sab27yscv5h8bop",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 37900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "63646160",
                                      "groupName": "Add On",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102193391",
                                          "name": "Premium Bakingo Opener",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.8",
                                      "ratingCount": "13 ratings",
                                      "ratingCountV2": "13"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "66609546",
                                  "name": "Set of 2 each of Red Velvet, Blueberry and Dalgona Coffee Cup Cake",
                                  "category": "Cup Cakes",
                                  "description": "Serves 1 | 6 assorted cup cakes  in 3 mouth watering flavours",
                                  "imageId": "biyyunyjysqauvhbe67u",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 37900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "63646151",
                                      "groupName": "Add On",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102193391",
                                          "name": "Premium Bakingo Opener",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.6",
                                      "ratingCount": "17 ratings",
                                      "ratingCountV2": "17"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "67656881",
                                  "name": "Set of 2 each of Blueberry, Pineapple and Vanilla Cup Cake",
                                  "category": "Cup Cakes",
                                  "description": "Serves 1 | 6 assorted cup cakes  in 3 mouth watering flavours",
                                  "imageId": "t2oxlqtgzkgw5rcqpo7a",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 37900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "63646181",
                                      "groupName": "Add On",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102193391",
                                          "name": "Premium Bakingo Opener",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "10 ratings",
                                      "ratingCountV2": "10"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Cookies & Tea Cake",
                      "categories": [
                        {
                          "title": "Tea Cakes",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93238977",
                                  "name": "Marble Tea Cake",
                                  "category": "Cookies & Tea Cake",
                                  "description": "Serves 1 | A Bakingo special marble cake is formed with the perfect blend of icing sugar, milk powder, flour, butter, cocao powder, dar compound and fresh cream.",
                                  "imageId": "gsipttsypai9b3eous03",
                                  "inStock": 1,
                                  "price": 25340,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.9",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93238978",
                                  "name": "Fruit Nut & Cranberry Tea Cake (Wheat)",
                                  "category": "Cookies & Tea Cake",
                                  "description": "Serves 1 | The quintessential tea time Wheat cake molds together cranberries, almonds, raisins, cashew and tooty fruity.",
                                  "imageId": "j8msrjykmu4gp8nlzuzk",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 27900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93238979",
                                  "name": "Dense Loaf Tea Cake",
                                  "category": "Cookies & Tea Cake",
                                  "description": "Serves 1 | A dense dry loaf cake gives you the smell of breakfast with the taste of milk, cocao powder and CHD 45 chocolate",
                                  "imageId": "o28xuz9ydafdllz1nm70",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 21100,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "2.3",
                                      "ratingCount": "6 ratings",
                                      "ratingCountV2": "6"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93238980",
                                  "name": "Banana & Walnut Tea Cake",
                                  "category": "Cookies & Tea Cake",
                                  "description": "Serves 1 | This classic dry cake is baked with walnuts, banana, flour, sugar and milk",
                                  "imageId": "casgeokvjayp871wzq6t",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 19400,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "25 ratings",
                                      "ratingCountV2": "25"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "97998839",
                                  "name": "Multigrain Tea Cake",
                                  "category": "Cookies & Tea Cake",
                                  "description": "Serves 1 | A classic staple for dry cake lovers.",
                                  "imageId": "isa49jatxbnzs3ogs6vb",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 22800,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Cookies",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "133444655",
                                  "name": "Almond Rocks (100 gm)",
                                  "category": "Cookies & Tea Cake",
                                  "description": "Serves 1 | Almond rocks are a delightful confectionery that typically combines the rich and nutty flavor of almonds with the sweetness of chocolate",
                                  "imageId": "d4b7f092377407989c7c0822eb91da0b",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 16900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "133444657",
                                  "name": "Hazelnut Rocks (100 gm)",
                                  "category": "Cookies & Tea Cake",
                                  "description": "Serves 1 | Hazelnut rocks are a delicious confectionery treat that combines the rich, nutty flavor of hazelnuts with the sweetness of chocolate",
                                  "imageId": "508aff53b3a034e049faf4602363ec07",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 21900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "134164752",
                                  "name": "Almond & Hazelnut Rocks Combo (100 gm)",
                                  "category": "Cookies & Tea Cake",
                                  "description": "Serves 1",
                                  "imageId": "5a43625933477d9e71719e4743bb61d0",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 37900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "98687612",
                                  "name": "Almond Cookies",
                                  "category": "Cookies & Tea Cake",
                                  "description": "Serves 1 | Baked with butter, flour, milk, custard powder & fresh almonds",
                                  "imageId": "y6p1cqxcf2pdccot5exa",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 25900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "98687613",
                                  "name": "Coconut Cookies",
                                  "category": "Cookies & Tea Cake",
                                  "description": "Serves 1 | A tinge of cocunut and the crispyness of Bakingo cookies",
                                  "imageId": "gcfo9uqavbtrs1xyvzqi",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 19900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "98687611",
                                  "name": "Choco Chip cookies",
                                  "category": "Cookies & Tea Cake",
                                  "description": "Serves 1 | Cocoa powder, chd 45 chocolate & dark choco chips for the win",
                                  "imageId": "kp0epn538qgcbxtzvnu9",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 15900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.9",
                                      "ratingCount": "7 ratings",
                                      "ratingCountV2": "7"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Gift Hampers",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "123278801",
                              "name": "Coconut Corn Choco Almond Cookies",
                              "category": "Gift Hampers",
                              "description": "Serves 1 | A hamper of set of 4 flavored cookies consisting  Roasted Almond, Choco chip, Coconut & Corn Flakes cookies for Valentine's Day",
                              "imageId": "c0a8b0138101e5f8591623f2c32c0f03",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 88900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "106475901",
                                  "groupName": "Add On - Birthday Caps",
                                  "choices": [
                                    {
                                      "id": "35198445",
                                      "name": "Birthday Caps For Girls",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198444",
                                      "name": "Birthday Cap for Boys",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "106475903",
                                  "groupName": "Add On -  Candles",
                                  "choices": [
                                    {
                                      "id": "35198447",
                                      "name": "Flower Candle",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198448",
                                      "name": "One Pack Magic Candle",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198446",
                                      "name": "'BIRTHDAY' Letter Candles",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "106475905",
                                  "groupName": "Add On - Roses",
                                  "choices": [
                                    {
                                      "id": "35198449",
                                      "name": "Single Red Rose",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198451",
                                      "name": "6 Red rose Bunch",
                                      "price": 39900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198450",
                                      "name": "10 Red rose Bunch",
                                      "price": 54900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "106475907",
                                  "groupName": "Add On - Extras",
                                  "choices": [
                                    {
                                      "id": "35198457",
                                      "name": "Set of 50 balloons (deflated)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198453",
                                      "name": "6 Inch Teddy Bear",
                                      "price": 29900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198452",
                                      "name": "Set of 2 Party Poppers",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198455",
                                      "name": "Happy Birthday Banner",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113484081",
                                      "name": "Set of 2 Party Poppers",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "106475909",
                                  "groupName": "Add On",
                                  "choices": [
                                    {
                                      "id": "35198447",
                                      "name": "Flower Candle",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198449",
                                      "name": "Single Red Rose",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102193391",
                                      "name": "Premium Bakingo Opener",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198448",
                                      "name": "One Pack Magic Candle",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "98687610",
                              "name": "The Cookies & Cake Hamper",
                              "category": "Gift Hampers",
                              "description": "Serves 1 | A combo of Banana & Walnut Tea cake, corn flakes cookies, chocochip cookie, almond rock cookies, & coconut cookie",
                              "imageId": "cajantv4yrbeiyh1r3bn",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 105900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "123278797",
                              "name": "Delicious Tea Cake With Choco Chip N Corn Cookies",
                              "category": "Gift Hampers",
                              "description": "Serves 1 | An exclusive hamper of Corn & Choco chip cookies with a Banana walnut Tea Cake.",
                              "imageId": "d36150897fa53f12652f12d5426f9f6c",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 59900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "106475877",
                                  "groupName": "Add On - Birthday Caps",
                                  "choices": [
                                    {
                                      "id": "35198445",
                                      "name": "Birthday Caps For Girls",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198444",
                                      "name": "Birthday Cap for Boys",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "106475879",
                                  "groupName": "Add On -  Candles",
                                  "choices": [
                                    {
                                      "id": "35198447",
                                      "name": "Flower Candle",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198448",
                                      "name": "One Pack Magic Candle",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198446",
                                      "name": "'BIRTHDAY' Letter Candles",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "106475881",
                                  "groupName": "Add On - Roses",
                                  "choices": [
                                    {
                                      "id": "35198449",
                                      "name": "Single Red Rose",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198451",
                                      "name": "6 Red rose Bunch",
                                      "price": 39900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198450",
                                      "name": "10 Red rose Bunch",
                                      "price": 54900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "106475883",
                                  "groupName": "Add On - Extras",
                                  "choices": [
                                    {
                                      "id": "35198457",
                                      "name": "Set of 50 balloons (deflated)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198453",
                                      "name": "6 Inch Teddy Bear",
                                      "price": 29900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198452",
                                      "name": "Set of 2 Party Poppers",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198455",
                                      "name": "Happy Birthday Banner",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113484081",
                                      "name": "Set of 2 Party Poppers",
                                      "price": 13900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "106475885",
                                  "groupName": "Add On",
                                  "choices": [
                                    {
                                      "id": "35198447",
                                      "name": "Flower Candle",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198449",
                                      "name": "Single Red Rose",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102193391",
                                      "name": "Premium Bakingo Opener",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198448",
                                      "name": "One Pack Magic Candle",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Birthday & Anniversay Specials",
                      "categories": [
                        {
                          "title": "Birthday Special",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "61476000",
                                  "name": "Birthday Chocolate Poster Cup Cake ( 2 Pcs)",
                                  "category": "Birthday & Anniversay Specials",
                                  "description": "Serves 1 | 2 personalised Minnie Mouse birthday cupcakes printed in edible ink",
                                  "imageId": "tqknfmtukoc5uz8jnokt",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 14900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52000260",
                                      "groupName": "Add On",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102193391",
                                          "name": "Premium Bakingo Opener",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "154 ratings",
                                      "ratingCountV2": "154"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "68987474",
                                  "name": "Set of 2 Birthday Poster Chocolate Jar Cakes",
                                  "category": "Birthday & Anniversay Specials",
                                  "description": "Serves 1 | 2 chocolate jar cakes topped with sugar sheets with special birthday graphics",
                                  "imageId": "fsoqjikztz7mhljhtpbo",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "14032521",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Mini (200ml)",
                                            "price": 329,
                                            "default": 1,
                                            "id": "45441201",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large (375ml)",
                                            "price": 479,
                                            "id": "45441202",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14032521",
                                            "variationId": "45441201"
                                          }
                                        ],
                                        "price": 32900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "52000412",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "52000412",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "52000412",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "52000412",
                                            "addonId": "102193391"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14032521",
                                            "variationId": "45441202"
                                          }
                                        ],
                                        "price": 47900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "52000412",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "52000412",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "52000412",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "52000412",
                                            "addonId": "102193391"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52000412",
                                      "groupName": "Add On",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102193391",
                                          "name": "Premium Bakingo Opener",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 32900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.5",
                                      "ratingCount": "46 ratings",
                                      "ratingCountV2": "46"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "61475992",
                                  "name": "Birthday Vanilla Poster Cake",
                                  "category": "Birthday & Anniversay Specials",
                                  "description": "Serves 1 | A square-shaped cake topped with a birthday special edible poster fondant sheet with flavoured with vanilla",
                                  "imageId": "jlpqugouyvdzhmpyshmm",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "14032344",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "500 Gms",
                                            "price": 649,
                                            "default": 1,
                                            "id": "45440842",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg",
                                            "price": 1099,
                                            "id": "45440840",
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14032344",
                                            "variationId": "45440840"
                                          }
                                        ],
                                        "price": 109900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "48695771",
                                            "addonId": "35198444"
                                          },
                                          {
                                            "groupId": "48695771",
                                            "addonId": "35198445"
                                          },
                                          {
                                            "groupId": "48695787",
                                            "addonId": "35198446"
                                          },
                                          {
                                            "groupId": "48695787",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "48695787",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "48695813",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "48695813",
                                            "addonId": "35198451"
                                          },
                                          {
                                            "groupId": "48695813",
                                            "addonId": "35198450"
                                          },
                                          {
                                            "groupId": "48695835",
                                            "addonId": "35198455"
                                          },
                                          {
                                            "groupId": "48695835",
                                            "addonId": "35198452"
                                          },
                                          {
                                            "groupId": "48695835",
                                            "addonId": "35198457"
                                          },
                                          {
                                            "groupId": "48695835",
                                            "addonId": "35198453"
                                          },
                                          {
                                            "groupId": "48695835",
                                            "addonId": "113484081"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14032344",
                                            "variationId": "45440842"
                                          }
                                        ],
                                        "price": 64900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "48695771",
                                            "addonId": "35198444"
                                          },
                                          {
                                            "groupId": "48695771",
                                            "addonId": "35198445"
                                          },
                                          {
                                            "groupId": "48695787",
                                            "addonId": "35198446"
                                          },
                                          {
                                            "groupId": "48695787",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "48695787",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "48695813",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "48695813",
                                            "addonId": "35198451"
                                          },
                                          {
                                            "groupId": "48695813",
                                            "addonId": "35198450"
                                          },
                                          {
                                            "groupId": "48695835",
                                            "addonId": "35198455"
                                          },
                                          {
                                            "groupId": "48695835",
                                            "addonId": "35198452"
                                          },
                                          {
                                            "groupId": "48695835",
                                            "addonId": "35198457"
                                          },
                                          {
                                            "groupId": "48695835",
                                            "addonId": "35198453"
                                          },
                                          {
                                            "groupId": "48695835",
                                            "addonId": "113484081"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "48695771",
                                      "groupName": "Add On - Birthday Caps",
                                      "choices": [
                                        {
                                          "id": "35198445",
                                          "name": "Birthday Caps For Girls",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198444",
                                          "name": "Birthday Cap for Boys",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "48695787",
                                      "groupName": "Add On -  Candles",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198446",
                                          "name": "'BIRTHDAY' Letter Candles",
                                          "price": 12900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "48695813",
                                      "groupName": "Add On - Roses",
                                      "choices": [
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198451",
                                          "name": "6 Red rose Bunch",
                                          "price": 39900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198450",
                                          "name": "10 Red rose Bunch",
                                          "price": 54900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "48695835",
                                      "groupName": "Add On - Extras",
                                      "choices": [
                                        {
                                          "id": "35198457",
                                          "name": "Set of 50 balloons (deflated)",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198453",
                                          "name": "6 Inch Teddy Bear",
                                          "price": 29900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198452",
                                          "name": "Set of 2 Party Poppers",
                                          "price": 13900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198455",
                                          "name": "Happy Birthday Banner",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113484081",
                                          "name": "Set of 2 Party Poppers",
                                          "price": 13900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 64900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.9",
                                      "ratingCount": "26 ratings",
                                      "ratingCountV2": "26"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Anniversary Special",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "61476001",
                                  "name": "I Love You Chocolate Poster Cup Cake ( 2 Pcs)",
                                  "category": "Birthday & Anniversay Specials",
                                  "description": "Serves 1 | 2 romantic chocolate poster cupcakes printed with premium edible ink & customisable to the flavour of your choice",
                                  "imageId": "bzhlfu2obx9xu6g1hyth",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 14900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52000266",
                                      "groupName": "Add On",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102193391",
                                          "name": "Premium Bakingo Opener",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "120 ratings",
                                      "ratingCountV2": "120"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "61475998",
                                  "name": "Anniversary Chocolate Poster Cup Cake ( 2 Pcs)",
                                  "category": "Birthday & Anniversay Specials",
                                  "description": "Serves 1 | A rich creamy set of 2 poster cup cakes with premium edible ink",
                                  "imageId": "v0bq8n7fmqbtyqmqceqt",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 14900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52000251",
                                      "groupName": "Add On",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102193391",
                                          "name": "Premium Bakingo Opener",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "2.8",
                                      "ratingCount": "63 ratings",
                                      "ratingCountV2": "63"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "61475995",
                                  "name": "Anniversary Vanilla Poster Cake",
                                  "category": "Birthday & Anniversay Specials",
                                  "description": "Serves 1 | Anround-shaped cake topped with an anniversary special edible poster sugar sheet with vanilla flavour.",
                                  "imageId": "qngkb35kg9jx7lxpji9g",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "14032365",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "1 Kg",
                                            "price": 1099,
                                            "id": "45440883",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Gms",
                                            "price": 649,
                                            "default": 1,
                                            "id": "45440884",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14032365",
                                            "variationId": "45440883"
                                          }
                                        ],
                                        "price": 109900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "48695927",
                                            "addonId": "35198444"
                                          },
                                          {
                                            "groupId": "48695927",
                                            "addonId": "35198445"
                                          },
                                          {
                                            "groupId": "48695949",
                                            "addonId": "35198446"
                                          },
                                          {
                                            "groupId": "48695949",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "48695949",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "48695975",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "48695975",
                                            "addonId": "35198451"
                                          },
                                          {
                                            "groupId": "48695975",
                                            "addonId": "35198450"
                                          },
                                          {
                                            "groupId": "48696004",
                                            "addonId": "35198455"
                                          },
                                          {
                                            "groupId": "48696004",
                                            "addonId": "35198452"
                                          },
                                          {
                                            "groupId": "48696004",
                                            "addonId": "35198457"
                                          },
                                          {
                                            "groupId": "48696004",
                                            "addonId": "35198453"
                                          },
                                          {
                                            "groupId": "48696004",
                                            "addonId": "113484081"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14032365",
                                            "variationId": "45440884"
                                          }
                                        ],
                                        "price": 64900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "48695927",
                                            "addonId": "35198444"
                                          },
                                          {
                                            "groupId": "48695927",
                                            "addonId": "35198445"
                                          },
                                          {
                                            "groupId": "48695949",
                                            "addonId": "35198446"
                                          },
                                          {
                                            "groupId": "48695949",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "48695949",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "48695975",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "48695975",
                                            "addonId": "35198451"
                                          },
                                          {
                                            "groupId": "48695975",
                                            "addonId": "35198450"
                                          },
                                          {
                                            "groupId": "48696004",
                                            "addonId": "35198455"
                                          },
                                          {
                                            "groupId": "48696004",
                                            "addonId": "35198452"
                                          },
                                          {
                                            "groupId": "48696004",
                                            "addonId": "35198457"
                                          },
                                          {
                                            "groupId": "48696004",
                                            "addonId": "35198453"
                                          },
                                          {
                                            "groupId": "48696004",
                                            "addonId": "113484081"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "48695927",
                                      "groupName": "Add On - Birthday Caps",
                                      "choices": [
                                        {
                                          "id": "35198445",
                                          "name": "Birthday Caps For Girls",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198444",
                                          "name": "Birthday Cap for Boys",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "48695949",
                                      "groupName": "Add On -  Candles",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198446",
                                          "name": "'BIRTHDAY' Letter Candles",
                                          "price": 12900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "48695975",
                                      "groupName": "Add On - Roses",
                                      "choices": [
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198451",
                                          "name": "6 Red rose Bunch",
                                          "price": 39900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198450",
                                          "name": "10 Red rose Bunch",
                                          "price": 54900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "48696004",
                                      "groupName": "Add On - Extras",
                                      "choices": [
                                        {
                                          "id": "35198457",
                                          "name": "Set of 50 balloons (deflated)",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198453",
                                          "name": "6 Inch Teddy Bear",
                                          "price": 29900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198452",
                                          "name": "Set of 2 Party Poppers",
                                          "price": 13900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198455",
                                          "name": "Happy Birthday Banner",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113484081",
                                          "name": "Set of 2 Party Poppers",
                                          "price": 13900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 64900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.3",
                                      "ratingCount": "21 ratings",
                                      "ratingCountV2": "21"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "68987478",
                                  "name": "Set of 2 Anniversary Poster Chocolate Jar Cakes",
                                  "category": "Birthday & Anniversay Specials",
                                  "description": "Serves 1 | A set of 2 chocolate jar cakes topped with anniversary wishes",
                                  "imageId": "calc3omdyyick4zzh6wr",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "14032524",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Mini (200ml)",
                                            "price": 329,
                                            "default": 1,
                                            "id": "45441207",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large (375ml)",
                                            "price": 479,
                                            "id": "45441208",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14032524",
                                            "variationId": "45441207"
                                          }
                                        ],
                                        "price": 32900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "52000425",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "52000425",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "52000425",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "52000425",
                                            "addonId": "102193391"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14032524",
                                            "variationId": "45441208"
                                          }
                                        ],
                                        "price": 47900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "52000425",
                                            "addonId": "35198447"
                                          },
                                          {
                                            "groupId": "52000425",
                                            "addonId": "35198448"
                                          },
                                          {
                                            "groupId": "52000425",
                                            "addonId": "35198449"
                                          },
                                          {
                                            "groupId": "52000425",
                                            "addonId": "102193391"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52000425",
                                      "groupName": "Add On",
                                      "choices": [
                                        {
                                          "id": "35198447",
                                          "name": "Flower Candle",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198448",
                                          "name": "One Pack Magic Candle",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "35198449",
                                          "name": "Single Red Rose",
                                          "price": 14900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102193391",
                                          "name": "Premium Bakingo Opener",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 32900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.1",
                                      "ratingCount": "17 ratings",
                                      "ratingCountV2": "17"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Exclusive combo",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "33461780",
                              "name": "Choco Chip & Butterscotch Pastry Combo",
                              "category": "Exclusive combo",
                              "description": "Serves 1 | A combo of 2 pastries. Choco chip & Butterscotch",
                              "imageId": "ayqfh3gdn5ptojwkotac",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "62 ratings",
                                  "ratingCountV2": "62"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "33461776",
                              "name": "Red Velvet & Choco Chip Cup Cake Combo",
                              "category": "Exclusive combo",
                              "description": "Serves 1 | A combo of 2 cup cakes. Red Velvet & Choco Chip",
                              "imageId": "95d1ab2c250f4355884351aa5c88a793",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "48694196",
                                  "groupName": "Add On -  Candles",
                                  "choices": [
                                    {
                                      "id": "35198447",
                                      "name": "Flower Candle",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198448",
                                      "name": "One Pack Magic Candle",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198446",
                                      "name": "'BIRTHDAY' Letter Candles",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "48694220",
                                  "groupName": "Add On - Roses",
                                  "choices": [
                                    {
                                      "id": "35198449",
                                      "name": "Single Red Rose",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198451",
                                      "name": "6 Red rose Bunch",
                                      "price": 39900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "35198450",
                                      "name": "10 Red rose Bunch",
                                      "price": 54900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "25 ratings",
                                  "ratingCountV2": "25"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "33461774",
                              "name": "Blueberry & Vanilla Cup Cake Combo",
                              "category": "Exclusive combo",
                              "description": "Serves 1 | A combo of 2 cup cakes. Blueberry & Vanilla",
                              "imageId": "hkbyjl0ljqc3qpktc4za",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.6",
                                  "ratingCount": "28 ratings",
                                  "ratingCountV2": "28"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Party Props",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121455010",
                              "name": "Set of 2 Party Poppers",
                              "category": "Party Props",
                              "description": "Serves 1",
                              "imageId": "8dcf305a42b3f25fa7c196a68f94e239",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121455011",
                              "name": "Birthday Cap Boy",
                              "category": "Party Props",
                              "description": "Serves 1",
                              "imageId": "388b01ed2ccf727799e52059525215d6",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121455012",
                              "name": "Birthday Cap Girl",
                              "category": "Party Props",
                              "description": "Serves 1",
                              "imageId": "d48f750594eef7c25aebe1e5a839e50c",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121455013",
                              "name": "HAPPY BIRTHDAY' Letter Candle",
                              "category": "Party Props",
                              "description": "Serves 1",
                              "imageId": "6e71409e700e72bb5406348ee965bc34",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121455014",
                              "name": "Flower Candle",
                              "category": "Party Props",
                              "description": "Serves 1",
                              "imageId": "acbcb29d75a892fd49908cd9ea7ee804",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121455015",
                              "name": "Pack of Magic Candle",
                              "category": "Party Props",
                              "description": "Serves 1",
                              "imageId": "f49e888a9a6319f14959929dc4168262",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125026795",
                              "name": "\"Happy Birthday\" Foil Balloon",
                              "category": "Party Props",
                              "description": "Serves 1",
                              "imageId": "6c6994a5da3dadfa88d483215e2f14de",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 27900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125026796",
                              "name": "\"Happy Anniversary\" Foil Balloon",
                              "category": "Party Props",
                              "description": "Serves 1",
                              "imageId": "e786cc771be0720a7b2cec7ce3632396",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 27900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125026797",
                              "name": "\"I Love You\" Foil Balloon",
                              "category": "Party Props",
                              "description": "Serves 1",
                              "imageId": "06dc14ea9ce527a700272798cbda64f4",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 27900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                      "type": "FSSAI",
                      "imageId": "fssai_final_edss9i",
                      "text": [
                        "License No. 11221334001210"
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                      "name": "Bakingo",
                      "area": "Koramangala",
                      "completeAddress": "No. 2, 1st Floor, 4th Cross Kormangala 1st Block, Jakkasandra Extension Sarjapur Road Bangalore 560034 Karnataka"
                    }
                  }
                }
              ]
            }
          }
        }
      }
    ],
    "firstOffsetRequest": true,
    "isQCLink": false
  },
  "tid": "8091b6c9-34ec-4881-8b5e-d2b6a4328fa1",
  "sid": "c8b69dc8-6710-47a7-bc63-18091856e3fa",
  "deviceId": "c73fa13e-69cf-472b-8071-076091f9d98d",
  "csrfToken": "i0WHmyENimG0-4CnAPsJ3PM8lLwAZRxnh3nmuKvI"
}

export const ANDHRA_GUNPOWDER=
{
  "statusCode": 0,
  "data": {
    "statusMessage": "done successfully",
    "cards": [
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
            "info": {
              "id": "279024",
              "name": "Andhra Gunpowder",
              "city": "Bangalore",
              "slugs": {
                "restaurant": "andhra-gunpowder-hsr-hsr-2",
                "city": "bangalore"
              },
              "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
              "cloudinaryImageId": "od1vem08qw94dfzt5ms3",
              "locality": "7th Sector",
              "areaName": "Hsr Layout",
              "costForTwo": "35000",
              "costForTwoMessage": "₹350 for two",
              "cuisines": [
                "Andhra",
                "Biryani"
              ],
              "avgRating": 4.3,
              "feeDetails": {
                "restaurantId": "279024",
                "fees": [
                  {
                    "name": "distance",
                    "fee": 3200
                  },
                  {
                    "name": "time"
                  },
                  {
                    "name": "special"
                  }
                ],
                "totalFee": 3200,
                "icon": "v1648635511/Delivery_fee_new_cjxumu",
                "message": "1.7 kms | ₹32 Delivery fee will apply"
              },
              "parentId": "10496",
              "avgRatingString": "4.3",
              "totalRatingsString": "5K+ ratings",
              "sla": {
                "restaurantId": "279024",
                "deliveryTime": 20,
                "minDeliveryTime": 15,
                "maxDeliveryTime": 20,
                "lastMileTravel": 1.7,
                "serviceability": "SERVICEABLE",
                "stressFactor": 1,
                "rainMode": "RAIN_MODE_NONE",
                "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
                "zoneId": 3,
                "slaString": "15-20 MINS",
                "lastMileTravelString": "1.7 km",
                "iconType": "ICON_TYPE_EMPTY"
              },
              "availability": {
                "nextCloseTime": "2024-02-18 23:00:00",
                "visibility": true,
                "opened": true,
                "restaurantClosedMeta": {
                  
                }
              },
              "aggregatedDiscountInfo": {
                "header": "FLAT100 off",
                "shortDescriptionList": [
                  {
                    "meta": "FLAT100 off | Use FLATDEAL",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "20% off | Use PARTY",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "FLAT100 off | Use FLATDEAL",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "20% off | Use code PARTY",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "visible": true
              },
              "badges": {
                
              },
              "slugString": "andhra-gunpowder-hsr-hsr-2",
              "multiOutlet": true,
              "isOpen": true,
              "labels": [
                {
                  "title": "Timings",
                  "message": "null"
                },
                {
                  "title": "Address",
                  "message": "No 392, 3rd Floor , 9th Main , 7th Sector ,HSR Layout, Bangalore 560102"
                },
                {
                  "title": "Cuisines",
                  "message": "Andhra,Biryani"
                }
              ],
              "totalRatings": 5000,
              "aggregatedDiscountInfoV2": {
                "header": "FLAT100 off",
                "shortDescriptionList": [
                  {
                    "meta": "FLAT100 off | Use FLATDEAL",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "20% off | Use PARTY",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "FLAT100 off | Use FLATDEAL",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "20% off | Use code PARTY",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "couponDetailsCta": "View coupon details"
              },
              "type": "F",
              "nudgeBanners": [
                {
                  "minValue": 630,
                  "maxValue": 900,
                  "priority": 2,
                  "couponCode": "PARTY",
                  "discountInfo": {
                    "discountType": "Percentage",
                    "value": 20
                  },
                  "lockedMessage": "Add items worth ₹<amount> to unlock flat 20% off | Code PARTY",
                  "unlockedMessage": "PARTY Coupon Unlocked! Use it to save flat 20% off",
                  "logoCtx": {
                    
                  }
                },
                {
                  "minValue": 349,
                  "maxValue": 499,
                  "priority": 3,
                  "couponCode": "SWIGGYWEEKENDS",
                  "discountInfo": {
                    "discountType": "Flat",
                    "value": 125
                  },
                  "lockedMessage": "Add items worth ₹<amount> to save ₹125 | Code SWIGGYWEEKENDS",
                  "unlockedMessage": "SWIGGYWEEKENDS Coupon Unlocked! Use it to save ₹125",
                  "logoCtx": {
                    
                  }
                }
              ],
              "headerBanner": {
                "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/279024"
              },
              "expectationNotifiers": [
                {
                  "text": "1.7 kms | ₹32 Delivery fee will apply",
                  "icon": {
                    "imageId": "v1648635511/Delivery_fee_new_cjxumu"
                  },
                  "popup": {
                    "cta": {
                      
                    }
                  },
                  "type": "DISTANCE_FEE_NON_FOOD_LM",
                  "enrichedText": "<b>1.7 kms</b> | ₹32 Delivery fee will apply",
                  "halfCardPopup": {
                    "halfCardPopupHeader": {
                      
                    }
                  }
                }
              ],
              "generalPurposeInfoListV2": [
                {
                  "cta": {
                    "info": {
                      "recordings": {
                        
                      }
                    },
                    "linkCta": {
                      
                    }
                  }
                }
              ],
              "ratingSlab": "RATING_SLAB_5",
              "orderabilityCommunication": {
                "title": {
                  
                },
                "subTitle": {
                  
                },
                "message": {
                  
                },
                "customIcon": {
                  
                }
              },
              "hasBestsellerItems": true,
              "hasGuiltfreeItems": true,
              "cartOrderabilityNudgeBanner": {
                "parameters": {
                  
                },
                "presentation": {
                  
                }
              },
              "latLong": "12.907519,77.635168",
              "hasKidscategoryItems": true,
              "backgroundImageOverlayInfo": {
                
              }
            },
            "analytics": {
              
            }
          },
          "relevance": {
            "type": "RELEVANCE_TYPE_CHECK_ORDERABILITY_ON_ITEM_ADD",
            "sectionId": "POP_UP_CROUTON_MENU"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "layout": {
              "rows": 1,
              "columns": 5,
              "horizontalScrollEnabled": true,
              "itemSpacing": 12,
              "lineSpacing": 10,
              "widgetPadding": {
                
              },
              "containerStyle": {
                "containerPadding": {
                  "left": 10,
                  "right": 10,
                  "bottom": 16
                }
              },
              "scrollBar": {
                
              }
            },
            "id": "offerCollectionWidget_UX4",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                "offers": [
                  {
                    "info": {
                      "header": "FLAT ₹100 OFF",
                      "offerTag": "FLAT DEAL",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "fe77295c-8d42-4c46-9c9d-53cb7fb1d6a8"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE FLATDEAL",
                      "description": "ABOVE ₹399",
                      "offerType": "offers",
                      "restId": "279024",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT 20% OFF",
                      "offerTag": "FLAT DEAL",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "1aa6eac3-8a9b-4c38-9ea9-8f1efe945df3"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE PARTY",
                      "description": "ABOVE ₹900",
                      "offerType": "offers",
                      "restId": "279024",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹125 OFF",
                      "offerTag": "FLAT DEAL",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "42107c7c-4149-49ac-97e0-60bd47e5f647"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE SWIGGYWEEKENDS",
                      "description": "ABOVE ₹499",
                      "offerType": "offers",
                      "restId": "279024",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹100 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "MARKETING_BANNERS/IMAGES/OFFERS/2024/2/17/1ed4245d-31e3-4dc6-b949-524a33b9b8c9_ICICI.png",
                      "offerIds": [
                        "299f5c31-dd4a-47a4-8d93-4ccb6be1a8a8"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "NO CODE REQUIRED",
                      "description": "ABOVE ₹550",
                      "offerType": "offers",
                      "restId": "279024",
                      "offerLogo": "MARKETING_BANNERS/IMAGES/OFFERS/2024/2/17/1ed4245d-31e3-4dc6-b949-524a33b9b8c9_ICICI.png",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹50 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "MARKETING_BANNERS/IMAGES/OFFERS/2024/2/16/d2280c74-96d1-4a1d-afd6-4270a05b5488_ICICI.png",
                      "offerIds": [
                        "72b12a41-597c-4c87-a813-32c46574fde9"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "NO CODE REQUIRED",
                      "description": "ABOVE ₹500",
                      "offerType": "offers",
                      "restId": "279024",
                      "offerLogo": "MARKETING_BANNERS/IMAGES/OFFERS/2024/2/16/d2280c74-96d1-4a1d-afd6-4270a05b5488_ICICI.png",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  }
                ],
                "habitMilestoneInfo": {
                  "callout": {
                    
                  }
                },
                "loyaltyDiscoverPresentationInfo": {
                  "logoCtx": {
                    
                  }
                }
              }
            }
          }
        }
      },
      {
        "groupedCard": {
          "cardGroupMap": {
            "REGULAR": {
              "cards": [
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                      "badges": {
                        
                      },
                      "vegOnlyDetails": {
                        "imageId": "AutoVegOnly_qkjowj",
                        "title": "Showing only vegetarian options.",
                        "description": "Tap on the VEG ONLY button to turn off the setting"
                      },
                      "topRatedFilter": {
                        
                      },
                      "kidsCategoryFilter": {
                        "attributes": {
                          "displayText": "Kids Favourites",
                          "tooltip": {
                            "enabled": true,
                            "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                          }
                        }
                      },
                      "vegFilter": {
                        "attributes": {
                          "displayText": "VEG"
                        }
                      },
                      "nonvegFilter": {
                        "attributes": {
                          "displayText": "NONVEG"
                        }
                      }
                    },
                    "relevance": {
                      "type": "RELEVANCE_TYPE_ON_MENU_FILTER_TOGGLED",
                      "sectionId": "MENU_FILTER_TOGGLE"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Recommended",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "78315558",
                              "name": "Butter Paneer Biryani Family Pack (serves 3-4)",
                              "category": "Biryani Family Pack (Save upto Rs 150/-)",
                              "description": "Serves 4 | Paneer Tikka cooked in a silky makhani gravy layered on Dum biryani rice. Served with raita and salan.",
                              "imageId": "xdn3ovilifxvzoyexlaw",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 89900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "131859673",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "111372917",
                                      "name": "Paneer pakoda (Full)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096573",
                                      "name": "Chicken Kebab (Full)",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372921",
                                      "name": "Chicken wings Kebab (Full)",
                                      "price": 18000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372916",
                                      "name": "Andhra Pepper Chicken (Full)",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299033",
                                      "name": "Andhra Chicken Curry (Full)",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372909",
                                      "name": "Andhra Chilli Chicken",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372923",
                                      "name": "Extra Boiled Egg - 2 nos",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372918",
                                      "name": "Ghee Gulab Jamun - 4 Pcs",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111405535",
                                      "name": "Masala More (Buttermilk)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372911",
                                      "name": "Pepsi (475 ml)",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 10,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 4"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "78315554",
                              "name": "Hyderabadi Chicken Dum Biryani Family Pack (serves 3-4)",
                              "category": "Biryani Family Pack (Save upto Rs 150/-)",
                              "description": "Serves 4 | Slow-cooked long grained rice layered in chicken masala, caramelised onions is finished in charcoal dum. Served with Mirchi ka salan and creamy raita.\n\n\"Allergens : Dairy\nNutritional information ( For serve 1) : Kcal(g):1713, Protein(g): 88, Carbohydrate(g): 113, Fat (g):101\"",
                              "imageId": "jkfyqgzhvmddguwgsaee",
                              "inStock": 1,
                              "price": 98900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "131859634",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "111372917",
                                      "name": "Paneer pakoda (Full)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096573",
                                      "name": "Chicken Kebab (Full)",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372921",
                                      "name": "Chicken wings Kebab (Full)",
                                      "price": 18000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372916",
                                      "name": "Andhra Pepper Chicken (Full)",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299033",
                                      "name": "Andhra Chicken Curry (Full)",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372909",
                                      "name": "Andhra Chilli Chicken",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372923",
                                      "name": "Extra Boiled Egg - 2 nos",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372918",
                                      "name": "Ghee Gulab Jamun - 4 Pcs",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111405535",
                                      "name": "Masala More (Buttermilk)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372911",
                                      "name": "Pepsi (475 ml)",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 10,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 4"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "32 ratings",
                                  "ratingCountV2": "32"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "78315555",
                              "name": "Special Chicken Boneless Dum Biryani Family Pack (serves 3-4)",
                              "category": "Biryani Family Pack (Save upto Rs 150/-)",
                              "description": "Serves 4 | Cashew based masala chicken (boneless) tops dum biryani rice.",
                              "imageId": "zt2ewncgdzupt9apv7jt",
                              "inStock": 1,
                              "price": 98000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "131859681",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "111372917",
                                      "name": "Paneer pakoda (Full)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096573",
                                      "name": "Chicken Kebab (Full)",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372921",
                                      "name": "Chicken wings Kebab (Full)",
                                      "price": 18000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372916",
                                      "name": "Andhra Pepper Chicken (Full)",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299033",
                                      "name": "Andhra Chicken Curry (Full)",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372909",
                                      "name": "Andhra Chilli Chicken",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372923",
                                      "name": "Extra Boiled Egg - 2 nos",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372918",
                                      "name": "Ghee Gulab Jamun - 4 Pcs",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111405535",
                                      "name": "Masala More (Buttermilk)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372911",
                                      "name": "Pepsi (475 ml)",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 10,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 4"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "22 ratings",
                                  "ratingCountV2": "22"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112360602",
                              "name": "Special Boneless Chicken Dum Biryani Family Pack [Serves 3-4]",
                              "category": "Biryani Family Pack (Save upto Rs 150/-)",
                              "description": "Serves 4 | Our biryani is slow-cooked on a charcoal dum, in layers of aromatic rice, boneless meat, and caramelized onions. Served with Mirchi ka salan and creamy raita.",
                              "imageId": "1557524a4d89abf84cb3a1b947e109c7",
                              "inStock": 1,
                              "price": 99900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "131859672",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "111372917",
                                      "name": "Paneer pakoda (Full)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096573",
                                      "name": "Chicken Kebab (Full)",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372921",
                                      "name": "Chicken wings Kebab (Full)",
                                      "price": 18000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372916",
                                      "name": "Andhra Pepper Chicken (Full)",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299033",
                                      "name": "Andhra Chicken Curry (Full)",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372909",
                                      "name": "Andhra Chilli Chicken",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372923",
                                      "name": "Extra Boiled Egg - 2 nos",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372918",
                                      "name": "Ghee Gulab Jamun - 4 Pcs",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111405535",
                                      "name": "Masala More (Buttermilk)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372911",
                                      "name": "Pepsi (475 ml)",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 10,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 4"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "57913847",
                              "name": "Paneer Makhni Biryani",
                              "category": "Hyderabadi Biryanis",
                              "description": "Serves 1 | Paneer Tikka cooked in silky makhani gravy tops a Veg Dum biryani rice. Served with Salan and Raita.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1054, Protein(g): 27, Carbohydrate(g): 114, Fat (g):54\"",
                              "imageId": "kbox9yaeq8gwcabncefl",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 29900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "52732026",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "111372907",
                                      "name": "Paneer Pakoda (Half)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096574",
                                      "name": "Chicken Kebab (Half)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372921",
                                      "name": "Chicken wings Kebab (Full)",
                                      "price": 18000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372916",
                                      "name": "Andhra Pepper Chicken (Full)",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372909",
                                      "name": "Andhra Chilli Chicken",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372906",
                                      "name": "Andhra Chicken Curry (200 ml)",
                                      "price": 9900,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "53809298",
                                  "groupName": "Sides",
                                  "choices": [
                                    {
                                      "id": "111771460",
                                      "name": "Ghee Gulab Jamun (2 Pcs)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372923",
                                      "name": "Extra Boiled Egg - 2 nos",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299024",
                                      "name": "Extra Raita",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111771461",
                                      "name": "Masala More (Buttermilk) (10% Off)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299037",
                                      "name": "Fresh Curd (200 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299027",
                                      "name": "Extra Papad (With 1 Fried chilli)",
                                      "price": 900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372911",
                                      "name": "Pepsi (475 ml)",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "58 ratings",
                                  "ratingCountV2": "58"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "85019235",
                              "name": "Hyderabadi Paneer Biryani",
                              "category": "Hyderabadi Biryanis",
                              "description": "Serves 1 | Paneer cooked in a rich masala and added to a veg Dum Biryani rice.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1054, Protein(g): 27, Carbohydrate(g): 114, Fat (g):54\"",
                              "imageId": "tpw4aky5jxzxj7qfklg5",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 29900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "52732036",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "111372907",
                                      "name": "Paneer Pakoda (Half)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096574",
                                      "name": "Chicken Kebab (Half)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372921",
                                      "name": "Chicken wings Kebab (Full)",
                                      "price": 18000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372916",
                                      "name": "Andhra Pepper Chicken (Full)",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372909",
                                      "name": "Andhra Chilli Chicken",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372906",
                                      "name": "Andhra Chicken Curry (200 ml)",
                                      "price": 9900,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "53809320",
                                  "groupName": "Sides",
                                  "choices": [
                                    {
                                      "id": "111771460",
                                      "name": "Ghee Gulab Jamun (2 Pcs)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372923",
                                      "name": "Extra Boiled Egg - 2 nos",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299024",
                                      "name": "Extra Raita",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111771461",
                                      "name": "Masala More (Buttermilk) (10% Off)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299037",
                                      "name": "Fresh Curd (200 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299027",
                                      "name": "Extra Papad (With 1 Fried chilli)",
                                      "price": 900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372911",
                                      "name": "Pepsi (475 ml)",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "11 ratings",
                                  "ratingCountV2": "11"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "57913849",
                              "name": "Egg Biryani",
                              "category": "Hyderabadi Biryanis",
                              "description": "Serves 1 | Masala eggs top a bowl of dum rice. Served with Mirchi ka Salan and mixed raita.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1185, Protein(g): 33, Carbohydrate(g): 115, Fat (g):66\"",
                              "imageId": "dnuw70nclzxujjcjfunl",
                              "inStock": 1,
                              "price": 24900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "52732038",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "111372907",
                                      "name": "Paneer Pakoda (Half)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096574",
                                      "name": "Chicken Kebab (Half)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372921",
                                      "name": "Chicken wings Kebab (Full)",
                                      "price": 18000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372916",
                                      "name": "Andhra Pepper Chicken (Full)",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372909",
                                      "name": "Andhra Chilli Chicken",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372906",
                                      "name": "Andhra Chicken Curry (200 ml)",
                                      "price": 9900,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "53809329",
                                  "groupName": "Sides",
                                  "choices": [
                                    {
                                      "id": "111771460",
                                      "name": "Ghee Gulab Jamun (2 Pcs)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372923",
                                      "name": "Extra Boiled Egg - 2 nos",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299024",
                                      "name": "Extra Raita",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111771461",
                                      "name": "Masala More (Buttermilk) (10% Off)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299037",
                                      "name": "Fresh Curd (200 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299027",
                                      "name": "Extra Papad (With 1 Fried chilli)",
                                      "price": 900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372911",
                                      "name": "Pepsi (475 ml)",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "98 ratings",
                                  "ratingCountV2": "98"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "55027849",
                              "name": "Hyderabadi Chicken Dum Biryani",
                              "category": "Hyderabadi Biryanis",
                              "description": "Serves 1 | Slow-cooked long grained rice layered in chicken masala, caramelized onions is finished in charcoal dum. Served with Mirchi ka salan and creamy raita.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1713, Protein(g): 88, Carbohydrate(g): 113, Fat (g):101\"",
                              "imageId": "janhgjevj4xnyyg5htnv",
                              "inStock": 1,
                              "price": 35900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "52732032",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "111372907",
                                      "name": "Paneer Pakoda (Half)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096574",
                                      "name": "Chicken Kebab (Half)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372921",
                                      "name": "Chicken wings Kebab (Full)",
                                      "price": 18000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372916",
                                      "name": "Andhra Pepper Chicken (Full)",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372909",
                                      "name": "Andhra Chilli Chicken",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372906",
                                      "name": "Andhra Chicken Curry (200 ml)",
                                      "price": 9900,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "53809314",
                                  "groupName": "Sides",
                                  "choices": [
                                    {
                                      "id": "111771460",
                                      "name": "Ghee Gulab Jamun (2 Pcs)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372923",
                                      "name": "Extra Boiled Egg - 2 nos",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299024",
                                      "name": "Extra Raita",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111771461",
                                      "name": "Masala More (Buttermilk) (10% Off)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299037",
                                      "name": "Fresh Curd (200 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299027",
                                      "name": "Extra Papad (With 1 Fried chilli)",
                                      "price": 900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372911",
                                      "name": "Pepsi (475 ml)",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "isGuiltfree": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "387 ratings",
                                  "ratingCountV2": "387"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112360601",
                              "name": "Special Boneless Chicken Dum Biryani",
                              "category": "Hyderabadi Biryanis",
                              "description": "Serves 1 | Our biryani is slow-cooked on a charcoal dum, in layers of aromatic rice, boneless meat, and caramelized onions. Served with Mirchi ka salan and creamy raitha.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1238, Protein(g): 69, Carbohydrate(g): 119, Fat (g):54\"",
                              "imageId": "1557524a4d89abf84cb3a1b947e109c7",
                              "inStock": 1,
                              "price": 35900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "82205876",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "111372907",
                                      "name": "Paneer Pakoda (Half)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096574",
                                      "name": "Chicken Kebab (Half)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372921",
                                      "name": "Chicken wings Kebab (Full)",
                                      "price": 18000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372916",
                                      "name": "Andhra Pepper Chicken (Full)",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372909",
                                      "name": "Andhra Chilli Chicken",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372906",
                                      "name": "Andhra Chicken Curry (200 ml)",
                                      "price": 9900,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "82205877",
                                  "groupName": "Sides",
                                  "choices": [
                                    {
                                      "id": "111771460",
                                      "name": "Ghee Gulab Jamun (2 Pcs)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372923",
                                      "name": "Extra Boiled Egg - 2 nos",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299024",
                                      "name": "Extra Raita",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111771461",
                                      "name": "Masala More (Buttermilk) (10% Off)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299037",
                                      "name": "Fresh Curd (200 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299027",
                                      "name": "Extra Papad (With 1 Fried chilli)",
                                      "price": 900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372911",
                                      "name": "Pepsi (475 ml)",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "isGuiltfree": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "37 ratings",
                                  "ratingCountV2": "37"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101213280",
                              "name": "Boneless Kebab Biryani",
                              "category": "Hyderabadi Biryanis",
                              "description": "Serves 1 | Deep fried spicy chicken kebab tops a bowl of Dum Hyderabadi biryani rice. Served with Salan and Raita.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1106, Protein(g): 35, Carbohydrate(g): 113, Fat (g):57\"",
                              "imageId": "70ab23fb7177ba9abe0fe8fe2feaa5c6",
                              "inStock": 1,
                              "price": 34900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "37 ratings",
                                  "ratingCountV2": "37"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "57913850",
                              "name": "Chicken Tikka Masala Biryani",
                              "category": "Hyderabadi Biryanis",
                              "description": "Serves 1 | Smoky boneless chicken tikka finished in a tomato masala and topped on dum biryani rice.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1115, Protein(g): 44, Carbohydrate(g): 113, Fat (g):54\"",
                              "imageId": "unbgenhukd68zfybeial",
                              "inStock": 1,
                              "price": 34900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "52732028",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "111372907",
                                      "name": "Paneer Pakoda (Half)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096574",
                                      "name": "Chicken Kebab (Half)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372921",
                                      "name": "Chicken wings Kebab (Full)",
                                      "price": 18000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372916",
                                      "name": "Andhra Pepper Chicken (Full)",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372909",
                                      "name": "Andhra Chilli Chicken",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372906",
                                      "name": "Andhra Chicken Curry (200 ml)",
                                      "price": 9900,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "53809299",
                                  "groupName": "Sides",
                                  "choices": [
                                    {
                                      "id": "111771460",
                                      "name": "Ghee Gulab Jamun (2 Pcs)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372923",
                                      "name": "Extra Boiled Egg - 2 nos",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299024",
                                      "name": "Extra Raita",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111771461",
                                      "name": "Masala More (Buttermilk) (10% Off)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299037",
                                      "name": "Fresh Curd (200 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299027",
                                      "name": "Extra Papad (With 1 Fried chilli)",
                                      "price": 900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372911",
                                      "name": "Pepsi (475 ml)",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isGuiltfree": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.8",
                                  "ratingCount": "61 ratings",
                                  "ratingCountV2": "61"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "54769110",
                              "name": "Andhra Veg Meals For 2",
                              "category": "Authentic Andhra Meals",
                              "description": "Serves 2 | Steamed Rice, Pappu, Veggie Sambar, Tomato Pepper Rasam, Gutti Vankaya (Brinjal Curry), Crispy Aloo Vepudu, Fresh Curd, Kandi Podi (gunpowder), Ghee, Papad, Fresh Chutney, Deep-fried sun-dried chilli, and Sweet.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):3594, Protein(g): 119, Carbohydrate(g): 442, Fat (g):150\"",
                              "imageId": "09dde73cd0bc184307be9f619e93d869",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 55900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "52732149",
                                  "groupName": "Meal Add Ons",
                                  "choices": [
                                    {
                                      "id": "43299029",
                                      "name": "Plain Rice (Gunpowder, Ghee, Papad)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299028",
                                      "name": "Pappu of the day (350 ml)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299032",
                                      "name": "Vegetable Sambar (350 ml)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299030",
                                      "name": "Rasam (350 ml)",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299031",
                                      "name": "Gunpowder (Kandi Podi) (200 Gms)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096595",
                                      "name": "Chicken Kebab (Full)",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096594",
                                      "name": "Chicken Kebab (Half) (100gms)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299033",
                                      "name": "Andhra Chicken Curry (Full)",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299034",
                                      "name": "Guntur Chicken Dry (380 Gms)",
                                      "price": 31400,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299037",
                                      "name": "Fresh Curd (200 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111405535",
                                      "name": "Masala More (Buttermilk)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299027",
                                      "name": "Extra Papad (With 1 Fried chilli)",
                                      "price": 900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096597",
                                      "name": "Ghee Gulab Jamun (2pcs)",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096596",
                                      "name": "Rabdi",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 14,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 2"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "527 ratings",
                                  "ratingCountV2": "527"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "54769124",
                              "name": "Andhra Veg Carrier Meals- (for 3-4)",
                              "category": "Authentic Andhra Meals",
                              "description": "Serves 4 | Steamed Rice, Pappu, Veggie Sambar, Tomato Pepper Rasam, Gutti Vankaya (Brinjal Curry), Crispy Aloo Vepudu, Fresh Curd, Kandi Podi (gunpowder), Ghee, Papad, Fresh Chutney, Deep-fried sun-dried chilli, and Sweet.\n\n\"Allergens : Dairy\nNutritional information ( For serve 1) : Kcal(g):1400, Protein(g): 37, Carbohydrate(g): 199, Fat (g):51\"",
                              "imageId": "935244a6ade3870c338e2377bcb5639e",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 73900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "52732171",
                                  "groupName": "Meal Add Ons",
                                  "choices": [
                                    {
                                      "id": "43299029",
                                      "name": "Plain Rice (Gunpowder, Ghee, Papad)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299028",
                                      "name": "Pappu of the day (350 ml)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299032",
                                      "name": "Vegetable Sambar (350 ml)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299030",
                                      "name": "Rasam (350 ml)",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299031",
                                      "name": "Gunpowder (Kandi Podi) (200 Gms)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096595",
                                      "name": "Chicken Kebab (Full)",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096594",
                                      "name": "Chicken Kebab (Half) (100gms)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299033",
                                      "name": "Andhra Chicken Curry (Full)",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299034",
                                      "name": "Guntur Chicken Dry (380 Gms)",
                                      "price": 31400,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299037",
                                      "name": "Fresh Curd (200 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111405535",
                                      "name": "Masala More (Buttermilk)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299027",
                                      "name": "Extra Papad (With 1 Fried chilli)",
                                      "price": 900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096597",
                                      "name": "Ghee Gulab Jamun (2pcs)",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096596",
                                      "name": "Rabdi",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 14,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 4"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "212 ratings",
                                  "ratingCountV2": "212"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "54769142",
                              "name": "Andhra Non-Veg Meals For 1",
                              "category": "Authentic Andhra Meals",
                              "description": "Serves 1 | Steamed Rice, Pappu, Andhra Chicken Curry, Guntur Chicken Fry, Veggie Sambar, Tomato Pepper Rasam, Fresh Curd, Kandi Podi (gunpowder), Ghee, Papad, Fresh chutney, Deep-fried sun-dried chilli and Sweet.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1681, Protein(g): 59, Carbohydrate(g): 194, Fat (g):74\"",
                              "imageId": "c11716be6de65d3c53b58e7cae6fb467",
                              "inStock": 1,
                              "price": 34900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "52732165",
                                  "groupName": "Meal Add Ons",
                                  "choices": [
                                    {
                                      "id": "43299029",
                                      "name": "Plain Rice (Gunpowder, Ghee, Papad)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299028",
                                      "name": "Pappu of the day (350 ml)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299032",
                                      "name": "Vegetable Sambar (350 ml)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299030",
                                      "name": "Rasam (350 ml)",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299031",
                                      "name": "Gunpowder (Kandi Podi) (200 Gms)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096595",
                                      "name": "Chicken Kebab (Full)",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096594",
                                      "name": "Chicken Kebab (Half) (100gms)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299033",
                                      "name": "Andhra Chicken Curry (Full)",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299034",
                                      "name": "Guntur Chicken Dry (380 Gms)",
                                      "price": 31400,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299037",
                                      "name": "Fresh Curd (200 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111405535",
                                      "name": "Masala More (Buttermilk)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299027",
                                      "name": "Extra Papad (With 1 Fried chilli)",
                                      "price": 900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096597",
                                      "name": "Ghee Gulab Jamun (2pcs)",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096596",
                                      "name": "Rabdi",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 14,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "655 ratings",
                                  "ratingCountV2": "655"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "54769151",
                              "name": "Andhra Non-Veg Carrier Meals (for 3-4)",
                              "category": "Authentic Andhra Meals",
                              "description": "Serves 4 | Steamed Rice, Pappu, Andhra Chicken Curry, Guntur Chicken Fry, Veggie Sambar, Tomato Pepper Rasam, Fresh Curd, Kandi Podi (gunpowder), Ghee, Papad, Fresh chutney, Deep-fried sun-dried chilli and Sweet.\n\n\"Allergens : Dairy\nNutritional information ( For One serve) : Kcal(g):1681, Protein(g): 59, Carbohydrate(g): 194, Fat (g):74\"",
                              "imageId": "e3f665b123b199b80e07f3b7b2b113e5",
                              "inStock": 1,
                              "price": 93900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "52732030",
                                  "groupName": "Meal Add Ons",
                                  "choices": [
                                    {
                                      "id": "43299029",
                                      "name": "Plain Rice (Gunpowder, Ghee, Papad)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299028",
                                      "name": "Pappu of the day (350 ml)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299032",
                                      "name": "Vegetable Sambar (350 ml)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299030",
                                      "name": "Rasam (350 ml)",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299031",
                                      "name": "Gunpowder (Kandi Podi) (200 Gms)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096595",
                                      "name": "Chicken Kebab (Full)",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096594",
                                      "name": "Chicken Kebab (Half) (100gms)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299033",
                                      "name": "Andhra Chicken Curry (Full)",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299034",
                                      "name": "Guntur Chicken Dry (380 Gms)",
                                      "price": 31400,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299037",
                                      "name": "Fresh Curd (200 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111405535",
                                      "name": "Masala More (Buttermilk)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299027",
                                      "name": "Extra Papad (With 1 Fried chilli)",
                                      "price": 900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096597",
                                      "name": "Ghee Gulab Jamun (2pcs)",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096596",
                                      "name": "Rabdi",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 14,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 4"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "51 ratings",
                                  "ratingCountV2": "51"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58539423",
                              "name": "Andhra Style Chicken Biryani",
                              "category": "Andhra Biryani",
                              "description": "Serves 1 | Marinated chicken cooked with onion, chilli, and garlic added to a Dum with rice. Served with raita and salan.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1640, Protein(g): 87, Carbohydrate(g): 128, Fat (g):86\"",
                              "imageId": "wt4yfrfw2ugwv0pmf6ar",
                              "inStock": 1,
                              "price": 34900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "52732027",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "111372907",
                                      "name": "Paneer Pakoda (Half)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096574",
                                      "name": "Chicken Kebab (Half)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372921",
                                      "name": "Chicken wings Kebab (Full)",
                                      "price": 18000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372916",
                                      "name": "Andhra Pepper Chicken (Full)",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372909",
                                      "name": "Andhra Chilli Chicken",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372906",
                                      "name": "Andhra Chicken Curry (200 ml)",
                                      "price": 9900,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "53918543",
                                  "groupName": "Sides",
                                  "choices": [
                                    {
                                      "id": "111771460",
                                      "name": "Ghee Gulab Jamun (2 Pcs)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372923",
                                      "name": "Extra Boiled Egg - 2 nos",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299024",
                                      "name": "Extra Raita",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111771461",
                                      "name": "Masala More (Buttermilk) (10% Off)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299037",
                                      "name": "Fresh Curd (200 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299027",
                                      "name": "Extra Papad (With 1 Fried chilli)",
                                      "price": 900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372911",
                                      "name": "Pepsi (475 ml)",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "182 ratings",
                                  "ratingCountV2": "182"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "133359640",
                              "name": "Ghee Podi Khichdi",
                              "category": "Southern Spiced Khichdis",
                              "description": "Serves 1 | Experience comfort food at its best with our Ghee Podi Khichdi. A warm and tasty rice dish.\n\n\"Allergens : -\nNutritional information : Kcal(g):492, Protein(g): 16, Carbohydrate(g): 47, Fat (g):27\"",
                              "imageId": "26ce0c5cb94e9ed6b1849f9138213e62",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "135351067",
                                  "groupName": "Addons",
                                  "choices": [
                                    {
                                      "id": "111372907",
                                      "name": "Paneer Pakoda (Half)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372920",
                                      "name": "Masala Papad",
                                      "price": 900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372908",
                                      "name": "Extra Fresh Curd (200 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372913",
                                      "name": "Mango Lassi",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372915",
                                      "name": "Ghee Gulab Jamun - 2 pcs",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372914",
                                      "name": "Sweet Lassi",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372912",
                                      "name": "Dry Fruit Lassi",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299024",
                                      "name": "Extra Raita",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372910",
                                      "name": "Payasam 200 ml",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111405535",
                                      "name": "Masala More (Buttermilk)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372911",
                                      "name": "Pepsi (475 ml)",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "133359642",
                              "name": "Deccan Dal Khichdi",
                              "category": "Southern Spiced Khichdis",
                              "description": "Serves 1 | Savor the warm spices of the Deccan in our comforting Khichdi. A flavorful lentil and rice dish that feels like home.",
                              "imageId": "010c324eca53207bb44d4307233b3d9d",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "135351068",
                                  "groupName": "Addons",
                                  "choices": [
                                    {
                                      "id": "111372907",
                                      "name": "Paneer Pakoda (Half)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372920",
                                      "name": "Masala Papad",
                                      "price": 900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372908",
                                      "name": "Extra Fresh Curd (200 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372913",
                                      "name": "Mango Lassi",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372915",
                                      "name": "Ghee Gulab Jamun - 2 pcs",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372914",
                                      "name": "Sweet Lassi",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372912",
                                      "name": "Dry Fruit Lassi",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299024",
                                      "name": "Extra Raita",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372910",
                                      "name": "Payasam 200 ml",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111405535",
                                      "name": "Masala More (Buttermilk)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372911",
                                      "name": "Pepsi (475 ml)",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "133359643",
                              "name": "Sambar Khichdi",
                              "category": "Southern Spiced Khichdis",
                              "description": "Serves 1 | Try our tangy and spicy Sambar Khichdi, a South classic. A comforting and savoury meal.",
                              "imageId": "7efe49f2ba2c8c2d7406acda0632c7e2",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "135351069",
                                  "groupName": "Addons",
                                  "choices": [
                                    {
                                      "id": "111372907",
                                      "name": "Paneer Pakoda (Half)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372920",
                                      "name": "Masala Papad",
                                      "price": 900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372908",
                                      "name": "Extra Fresh Curd (200 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372913",
                                      "name": "Mango Lassi",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372915",
                                      "name": "Ghee Gulab Jamun - 2 pcs",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372914",
                                      "name": "Sweet Lassi",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372912",
                                      "name": "Dry Fruit Lassi",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299024",
                                      "name": "Extra Raita",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372910",
                                      "name": "Payasam 200 ml",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111405535",
                                      "name": "Masala More (Buttermilk)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372911",
                                      "name": "Pepsi (475 ml)",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "133359645",
                              "name": "Andhra Style Bagara Baigan Khichdi",
                              "category": "Southern Spiced Khichdis",
                              "description": "Serves 1 | Our Andhra-style Khichdi features the unique taste of Brinjal. A flavorful South vegetarian dish.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):799, Protein(g): 17, Carbohydrate(g): 43, Fat (g):62\"",
                              "imageId": "7f996fb05e441c0182de4e85e453f12f",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "135351070",
                                  "groupName": "Addons",
                                  "choices": [
                                    {
                                      "id": "111372907",
                                      "name": "Paneer Pakoda (Half)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372920",
                                      "name": "Masala Papad",
                                      "price": 900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372908",
                                      "name": "Extra Fresh Curd (200 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372913",
                                      "name": "Mango Lassi",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372915",
                                      "name": "Ghee Gulab Jamun - 2 pcs",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372914",
                                      "name": "Sweet Lassi",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372912",
                                      "name": "Dry Fruit Lassi",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299024",
                                      "name": "Extra Raita",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372910",
                                      "name": "Payasam 200 ml",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111405535",
                                      "name": "Masala More (Buttermilk)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372911",
                                      "name": "Pepsi (475 ml)",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "type": "CATEGORY_TYPE_RECOMMENDED"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Biryani Family Pack (Save upto Rs 150/-)",
                      "categories": [
                        {
                          "title": "Hyderabadi Biryani Family Pack",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "134217034",
                                  "name": "Hyderabadi Paneer Biryani Family Pack (serves 3-4)",
                                  "category": "Biryani Family Pack (Save upto Rs 150/-)",
                                  "description": "Serves 3 | Succulent paneer is cooked in a flavorful Hyderabadi masala and then layered on to aromatic vegetable Dum Biryani rice. Served with mirchi ka Salan and Raita.",
                                  "imageId": "tpw4aky5jxzxj7qfklg5",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 89900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "137548447",
                                      "groupName": "Add Ons",
                                      "choices": [
                                        {
                                          "id": "111372907",
                                          "name": "Paneer Pakoda (Half)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096574",
                                          "name": "Chicken Kebab (Half)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372921",
                                          "name": "Chicken wings Kebab (Full)",
                                          "price": 18000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372916",
                                          "name": "Andhra Pepper Chicken (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372909",
                                          "name": "Andhra Chilli Chicken",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372906",
                                          "name": "Andhra Chicken Curry (200 ml)",
                                          "price": 9900,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "137548448",
                                      "groupName": "Sides",
                                      "choices": [
                                        {
                                          "id": "111771460",
                                          "name": "Ghee Gulab Jamun (2 Pcs)",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372923",
                                          "name": "Extra Boiled Egg - 2 nos",
                                          "price": 2400,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299024",
                                          "name": "Extra Raita",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111771461",
                                          "name": "Masala More (Buttermilk) (10% Off)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299037",
                                          "name": "Fresh Curd (200 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299027",
                                          "name": "Extra Papad (With 1 Fried chilli)",
                                          "price": 900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372911",
                                          "name": "Pepsi (475 ml)",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 3"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "78315558",
                                  "name": "Butter Paneer Biryani Family Pack (serves 3-4)",
                                  "category": "Biryani Family Pack (Save upto Rs 150/-)",
                                  "description": "Serves 4 | Paneer Tikka cooked in a silky makhani gravy layered on Dum biryani rice. Served with raita and salan.",
                                  "imageId": "xdn3ovilifxvzoyexlaw",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 89900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "131859673",
                                      "groupName": "Add Ons",
                                      "choices": [
                                        {
                                          "id": "111372917",
                                          "name": "Paneer pakoda (Full)",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096573",
                                          "name": "Chicken Kebab (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372921",
                                          "name": "Chicken wings Kebab (Full)",
                                          "price": 18000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372916",
                                          "name": "Andhra Pepper Chicken (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299033",
                                          "name": "Andhra Chicken Curry (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372909",
                                          "name": "Andhra Chilli Chicken",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372923",
                                          "name": "Extra Boiled Egg - 2 nos",
                                          "price": 2400,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372918",
                                          "name": "Ghee Gulab Jamun - 4 Pcs",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111405535",
                                          "name": "Masala More (Buttermilk)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372911",
                                          "name": "Pepsi (475 ml)",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 4"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "78315554",
                                  "name": "Hyderabadi Chicken Dum Biryani Family Pack (serves 3-4)",
                                  "category": "Biryani Family Pack (Save upto Rs 150/-)",
                                  "description": "Serves 4 | Slow-cooked long grained rice layered in chicken masala, caramelised onions is finished in charcoal dum. Served with Mirchi ka salan and creamy raita.\n\n\"Allergens : Dairy\nNutritional information ( For serve 1) : Kcal(g):1713, Protein(g): 88, Carbohydrate(g): 113, Fat (g):101\"",
                                  "imageId": "jkfyqgzhvmddguwgsaee",
                                  "inStock": 1,
                                  "price": 98900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "131859634",
                                      "groupName": "Add Ons",
                                      "choices": [
                                        {
                                          "id": "111372917",
                                          "name": "Paneer pakoda (Full)",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096573",
                                          "name": "Chicken Kebab (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372921",
                                          "name": "Chicken wings Kebab (Full)",
                                          "price": 18000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372916",
                                          "name": "Andhra Pepper Chicken (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299033",
                                          "name": "Andhra Chicken Curry (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372909",
                                          "name": "Andhra Chilli Chicken",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372923",
                                          "name": "Extra Boiled Egg - 2 nos",
                                          "price": 2400,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372918",
                                          "name": "Ghee Gulab Jamun - 4 Pcs",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111405535",
                                          "name": "Masala More (Buttermilk)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372911",
                                          "name": "Pepsi (475 ml)",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 4"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "32 ratings",
                                      "ratingCountV2": "32"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "78315555",
                                  "name": "Special Chicken Boneless Dum Biryani Family Pack (serves 3-4)",
                                  "category": "Biryani Family Pack (Save upto Rs 150/-)",
                                  "description": "Serves 4 | Cashew based masala chicken (boneless) tops dum biryani rice.",
                                  "imageId": "zt2ewncgdzupt9apv7jt",
                                  "inStock": 1,
                                  "price": 98000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "131859681",
                                      "groupName": "Add Ons",
                                      "choices": [
                                        {
                                          "id": "111372917",
                                          "name": "Paneer pakoda (Full)",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096573",
                                          "name": "Chicken Kebab (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372921",
                                          "name": "Chicken wings Kebab (Full)",
                                          "price": 18000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372916",
                                          "name": "Andhra Pepper Chicken (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299033",
                                          "name": "Andhra Chicken Curry (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372909",
                                          "name": "Andhra Chilli Chicken",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372923",
                                          "name": "Extra Boiled Egg - 2 nos",
                                          "price": 2400,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372918",
                                          "name": "Ghee Gulab Jamun - 4 Pcs",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111405535",
                                          "name": "Masala More (Buttermilk)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372911",
                                          "name": "Pepsi (475 ml)",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 4"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.9",
                                      "ratingCount": "22 ratings",
                                      "ratingCountV2": "22"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "112360602",
                                  "name": "Special Boneless Chicken Dum Biryani Family Pack [Serves 3-4]",
                                  "category": "Biryani Family Pack (Save upto Rs 150/-)",
                                  "description": "Serves 4 | Our biryani is slow-cooked on a charcoal dum, in layers of aromatic rice, boneless meat, and caramelized onions. Served with Mirchi ka salan and creamy raita.",
                                  "imageId": "1557524a4d89abf84cb3a1b947e109c7",
                                  "inStock": 1,
                                  "price": 99900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "131859672",
                                      "groupName": "Add Ons",
                                      "choices": [
                                        {
                                          "id": "111372917",
                                          "name": "Paneer pakoda (Full)",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096573",
                                          "name": "Chicken Kebab (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372921",
                                          "name": "Chicken wings Kebab (Full)",
                                          "price": 18000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372916",
                                          "name": "Andhra Pepper Chicken (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299033",
                                          "name": "Andhra Chicken Curry (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372909",
                                          "name": "Andhra Chilli Chicken",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372923",
                                          "name": "Extra Boiled Egg - 2 nos",
                                          "price": 2400,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372918",
                                          "name": "Ghee Gulab Jamun - 4 Pcs",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111405535",
                                          "name": "Masala More (Buttermilk)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372911",
                                          "name": "Pepsi (475 ml)",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 4"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "78315556",
                                  "name": "Chicken Tikka Masala Biryani Family Pack (serves 3-4)",
                                  "category": "Biryani Family Pack (Save upto Rs 150/-)",
                                  "description": "Serves 4 | Smoky boneless chicken tikka finished in a tomato masala and topped on dum biryani rice.\n\n\"Allergens : Dairy\nNutritional information ( For serve 1) : Kcal(g):1115, Protein(g): 44, Carbohydrate(g): 113, Fat (g):54\"",
                                  "imageId": "foos9ap0iuljzjtbxku4",
                                  "inStock": 1,
                                  "price": 98900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "131859610",
                                      "groupName": "Add Ons",
                                      "choices": [
                                        {
                                          "id": "111372917",
                                          "name": "Paneer pakoda (Full)",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096573",
                                          "name": "Chicken Kebab (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372921",
                                          "name": "Chicken wings Kebab (Full)",
                                          "price": 18000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372916",
                                          "name": "Andhra Pepper Chicken (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299033",
                                          "name": "Andhra Chicken Curry (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372909",
                                          "name": "Andhra Chilli Chicken",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372923",
                                          "name": "Extra Boiled Egg - 2 nos",
                                          "price": 2400,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372918",
                                          "name": "Ghee Gulab Jamun - 4 Pcs",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111405535",
                                          "name": "Masala More (Buttermilk)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372911",
                                          "name": "Pepsi (475 ml)",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 4"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.8",
                                      "ratingCount": "7 ratings",
                                      "ratingCountV2": "7"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93230458",
                                  "name": "Guntur Chicken Biryani Family Pack (Serves 3-4)",
                                  "category": "Biryani Family Pack (Save upto Rs 150/-)",
                                  "description": "Serves 1 | Sizzling hot Guntur Chicken tops a bowl of Dum Hyderabadi biryani rice. Served with Raita and Salan.\n\n\"Allergens : Dairy\nNutritional information ( For serve 1) : Kcal(g):1000, Protein(g): 29, Carbohydrate(g): 108, Fat (g):50\"",
                                  "imageId": "gwrm4csbtdc9p3ttbay6",
                                  "inStock": 1,
                                  "price": 98900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "131859590",
                                      "groupName": "Add Ons",
                                      "choices": [
                                        {
                                          "id": "111372917",
                                          "name": "Paneer pakoda (Full)",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096573",
                                          "name": "Chicken Kebab (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372921",
                                          "name": "Chicken wings Kebab (Full)",
                                          "price": 18000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372916",
                                          "name": "Andhra Pepper Chicken (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299033",
                                          "name": "Andhra Chicken Curry (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372909",
                                          "name": "Andhra Chilli Chicken",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372923",
                                          "name": "Extra Boiled Egg - 2 nos",
                                          "price": 2400,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372918",
                                          "name": "Ghee Gulab Jamun - 4 Pcs",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111405535",
                                          "name": "Masala More (Buttermilk)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372911",
                                          "name": "Pepsi (475 ml)",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "95857464",
                                  "name": "Andhra Style Chicken Biryani Family Pack (serves 3-4)",
                                  "category": "Biryani Family Pack (Save upto Rs 150/-)",
                                  "description": "Serves 1 | Marinated chicken cooked with onion, chilli, and garlic added to a Dum with rice. Served with raita and salan.\n\n\"Allergens : Dairy\nNutritional information ( For serve 1) : Kcal(g):1640, Protein(g): 87, Carbohydrate(g): 128, Fat (g):86\"",
                                  "imageId": "wt4yfrfw2ugwv0pmf6ar",
                                  "inStock": 1,
                                  "price": 89900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "131859614",
                                      "groupName": "Add Ons",
                                      "choices": [
                                        {
                                          "id": "111372917",
                                          "name": "Paneer pakoda (Full)",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096573",
                                          "name": "Chicken Kebab (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372921",
                                          "name": "Chicken wings Kebab (Full)",
                                          "price": 18000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372916",
                                          "name": "Andhra Pepper Chicken (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299033",
                                          "name": "Andhra Chicken Curry (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372909",
                                          "name": "Andhra Chilli Chicken",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372923",
                                          "name": "Extra Boiled Egg - 2 nos",
                                          "price": 2400,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372918",
                                          "name": "Ghee Gulab Jamun - 4 Pcs",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111405535",
                                          "name": "Masala More (Buttermilk)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372911",
                                          "name": "Pepsi (475 ml)",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Bagara Biryani Family Pack",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "78315562",
                                  "name": "Butter Paneer Bagara Biryani Family Pack (serves 3-4)",
                                  "category": "Biryani Family Pack (Save upto Rs 150/-)",
                                  "description": "Serves 4 | Mildly spiced fine grained Basmati Rice cooked in Ghee paired with well marinated Paneer cooked in homestyle makhni gravy.\n\n\"Allergens : Dairy\nNutritional information ( For serve 1) : Kcal(g):1077, Protein(g): 28, Carbohydrate(g): 112, Fat (g):58\"",
                                  "imageId": "3aacfdcb5053e8123b98be866ac2d534",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 89900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "131859611",
                                      "groupName": "Add Ons",
                                      "choices": [
                                        {
                                          "id": "111372917",
                                          "name": "Paneer pakoda (Full)",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096573",
                                          "name": "Chicken Kebab (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372921",
                                          "name": "Chicken wings Kebab (Full)",
                                          "price": 18000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372916",
                                          "name": "Andhra Pepper Chicken (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299033",
                                          "name": "Andhra Chicken Curry (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372909",
                                          "name": "Andhra Chilli Chicken",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372923",
                                          "name": "Extra Boiled Egg - 2 nos",
                                          "price": 2400,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372918",
                                          "name": "Ghee Gulab Jamun - 4 Pcs",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111405535",
                                          "name": "Masala More (Buttermilk)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372911",
                                          "name": "Pepsi (475 ml)",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 4"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "78315559",
                                  "name": "Chicken Boneless Bagara Biryani Family Pack (serves 3-4)",
                                  "category": "Biryani Family Pack (Save upto Rs 150/-)",
                                  "description": "Serves 4 | Aromatic Basmati Rice cooked in Ghee, caramelized onion and mild spices - paired with juicy boneless chicken chunks cooked in the right blend of Indian masalas.\n\n\"Allergens : Dairy\nNutritional information ( For serve 1) : Kcal(g):1037, Protein(g): 45, Carbohydrate(g): 110, Fat (g):47\"",
                                  "imageId": "wrdzdkvthzjjnyz6i2ov",
                                  "inStock": 1,
                                  "price": 98900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "131859685",
                                      "groupName": "Add Ons",
                                      "choices": [
                                        {
                                          "id": "111372917",
                                          "name": "Paneer pakoda (Full)",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096573",
                                          "name": "Chicken Kebab (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372921",
                                          "name": "Chicken wings Kebab (Full)",
                                          "price": 18000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372916",
                                          "name": "Andhra Pepper Chicken (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299033",
                                          "name": "Andhra Chicken Curry (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372909",
                                          "name": "Andhra Chilli Chicken",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372923",
                                          "name": "Extra Boiled Egg - 2 nos",
                                          "price": 2400,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372918",
                                          "name": "Ghee Gulab Jamun - 4 Pcs",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111405535",
                                          "name": "Masala More (Buttermilk)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372911",
                                          "name": "Pepsi (475 ml)",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 4"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Super Saver Meals",
                      "categories": [
                        {
                          "title": "Super Saver Meals for 2",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "97228858",
                                  "name": "Executive Andhra Veg Meal (For 2)",
                                  "category": "Super Saver Meals",
                                  "description": "Serves 1 | A perfect combo for 2 people includes plain Rice (2) + Palak Pappu (380g) + Sambar (380g) + Curd (180g) served with Ghee, Gunpowder, Papad, and Deep-fried sun-dried chilli.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):2062, Protein(g): 61, Carbohydrate(g): 318, Fat (g):61\"",
                                  "imageId": "uhputyqo0faogxfakv9i",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 29900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "131859628",
                                      "groupName": "Add Ons",
                                      "choices": [
                                        {
                                          "id": "111372907",
                                          "name": "Paneer Pakoda (Half)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096594",
                                          "name": "Chicken Kebab (Half) (100gms)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372923",
                                          "name": "Extra Boiled Egg - 2 nos",
                                          "price": 2400,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372910",
                                          "name": "Payasam 200 ml",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096576",
                                          "name": "Ghee Gulab Jamun (2pcs)",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299037",
                                          "name": "Fresh Curd (200 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111405535",
                                          "name": "Masala More (Buttermilk)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299027",
                                          "name": "Extra Papad (With 1 Fried chilli)",
                                          "price": 900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372911",
                                          "name": "Pepsi (475 ml)",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372906",
                                          "name": "Andhra Chicken Curry (200 ml)",
                                          "price": 9900,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.8",
                                      "ratingCount": "111 ratings",
                                      "ratingCountV2": "111"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "97228859",
                                  "name": "Andhra Chicken Sambar Meal (For 2)",
                                  "category": "Super Saver Meals",
                                  "description": "Serves 1 | A perfect combo for 2 people includes plain Rice (2) + Andhra Chicken Curry (380g) + Sambar (380g) + Curd (180g) served with Ghee, Gunpowder, Papad, and Deep-fried sun-dried chilli.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):3126, Protein(g): 111, Carbohydrate(g): 365, Fat (g):135\"",
                                  "imageId": "gu0hkottesgizfzwthxl",
                                  "inStock": 1,
                                  "price": 52900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "131859624",
                                      "groupName": "Add Ons",
                                      "choices": [
                                        {
                                          "id": "111372907",
                                          "name": "Paneer Pakoda (Half)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096594",
                                          "name": "Chicken Kebab (Half) (100gms)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372923",
                                          "name": "Extra Boiled Egg - 2 nos",
                                          "price": 2400,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372910",
                                          "name": "Payasam 200 ml",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096576",
                                          "name": "Ghee Gulab Jamun (2pcs)",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299037",
                                          "name": "Fresh Curd (200 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111405535",
                                          "name": "Masala More (Buttermilk)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299027",
                                          "name": "Extra Papad (With 1 Fried chilli)",
                                          "price": 900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372911",
                                          "name": "Pepsi (475 ml)",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372906",
                                          "name": "Andhra Chicken Curry (200 ml)",
                                          "price": 9900,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.6",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "97228860",
                                  "name": "Andhra Chicken Pappu Meal (For 2)",
                                  "category": "Super Saver Meals",
                                  "description": "Serves 1 | A perfect combo for 2 people includes plain Rice (2) + Andhra Chicken Curry (380g) + Palak Pappu (380g) + Curd (180g) served with Ghee, Gunpowder, Papad, and Deep-fried sun-dried chilli.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):2989, Protein(g): 111, Carbohydrate(g): 362, Fat (g):122\"",
                                  "imageId": "p4c0zfcznypomecnin8x",
                                  "inStock": 1,
                                  "price": 54900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "131859654",
                                      "groupName": "Add Ons",
                                      "choices": [
                                        {
                                          "id": "111372907",
                                          "name": "Paneer Pakoda (Half)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096594",
                                          "name": "Chicken Kebab (Half) (100gms)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372923",
                                          "name": "Extra Boiled Egg - 2 nos",
                                          "price": 2400,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372910",
                                          "name": "Payasam 200 ml",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096576",
                                          "name": "Ghee Gulab Jamun (2pcs)",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299037",
                                          "name": "Fresh Curd (200 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111405535",
                                          "name": "Masala More (Buttermilk)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299027",
                                          "name": "Extra Papad (With 1 Fried chilli)",
                                          "price": 900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372911",
                                          "name": "Pepsi (475 ml)",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372906",
                                          "name": "Andhra Chicken Curry (200 ml)",
                                          "price": 9900,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.8",
                                      "ratingCount": "8 ratings",
                                      "ratingCountV2": "8"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "97228861",
                                  "name": "Guntur Chicken Meal (For 2)",
                                  "category": "Super Saver Meals",
                                  "description": "Serves 1 | A perfect combo for 2 people includes plain Rice (2) + Guntur Chicken (180g) + Vegetable Sambar (380g) + Rasam (180g) + Curd (180g) served with Ghee, Gunpowder, Papad, and Deep-fried sun-dried chilli.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):2133, Protein(g): 54, Carbohydrate(g): 354, Fat (g):56\"",
                                  "imageId": "ew0qb3xztppzuuuarhs8",
                                  "inStock": 1,
                                  "price": 54900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "131859658",
                                      "groupName": "Add Ons",
                                      "choices": [
                                        {
                                          "id": "111372907",
                                          "name": "Paneer Pakoda (Half)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096594",
                                          "name": "Chicken Kebab (Half) (100gms)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372923",
                                          "name": "Extra Boiled Egg - 2 nos",
                                          "price": 2400,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372910",
                                          "name": "Payasam 200 ml",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096576",
                                          "name": "Ghee Gulab Jamun (2pcs)",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299037",
                                          "name": "Fresh Curd (200 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111405535",
                                          "name": "Masala More (Buttermilk)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299027",
                                          "name": "Extra Papad (With 1 Fried chilli)",
                                          "price": 900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372911",
                                          "name": "Pepsi (475 ml)",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372906",
                                          "name": "Andhra Chicken Curry (200 ml)",
                                          "price": 9900,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Super Saver Meals for 3-4",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "97228863",
                                  "name": "Guntur Chicken Family Meal (For 3-4)",
                                  "category": "Super Saver Meals",
                                  "description": "Serves 1 | A perfect combo for 3-4 people includes plain Rice (1650g) + Palak Pappu (450g) + Guntur Chicken (350g) + Rasam (380 g) + Curd (380g) served with Ghee, Gunpowder, Papad, and Deep-fried sun-dried chilli.",
                                  "imageId": "onrsarfm9vazzsk3usft",
                                  "inStock": 1,
                                  "price": 78900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "131859668",
                                      "groupName": "Add Ons",
                                      "choices": [
                                        {
                                          "id": "111372917",
                                          "name": "Paneer pakoda (Full)",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096595",
                                          "name": "Chicken Kebab (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372921",
                                          "name": "Chicken wings Kebab (Full)",
                                          "price": 18000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372916",
                                          "name": "Andhra Pepper Chicken (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299033",
                                          "name": "Andhra Chicken Curry (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372909",
                                          "name": "Andhra Chilli Chicken",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372923",
                                          "name": "Extra Boiled Egg - 2 nos",
                                          "price": 2400,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372918",
                                          "name": "Ghee Gulab Jamun - 4 Pcs",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372910",
                                          "name": "Payasam 200 ml",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299037",
                                          "name": "Fresh Curd (200 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111405535",
                                          "name": "Masala More (Buttermilk)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299027",
                                          "name": "Extra Papad (With 1 Fried chilli)",
                                          "price": 900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372911",
                                          "name": "Pepsi (475 ml)",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 12,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "97228866",
                                  "name": "Andhra Chicken Family Meal (For 3-4)",
                                  "category": "Super Saver Meals",
                                  "description": "Serves 1 | A perfect combo for 3-4 people includes plain Rice (1650g) + Andhra Chicken Curry (450g) + Palak Pappu (350g) + Rasam (380g) + Curd (380g) served with Ghee, Gunpowder, Papad, and Deep-fried sun-dried chilli.\n\n\"Allergens : Dairy\nNutritional information ( For serve 1) : Kcal(g):1681, Protein(g): 59, Carbohydrate(g): 194, Fat (g):74\"",
                                  "imageId": "cs6l6v0or0lmcxkhtcbw",
                                  "inStock": 1,
                                  "price": 79900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "131859635",
                                      "groupName": "Add Ons",
                                      "choices": [
                                        {
                                          "id": "111372917",
                                          "name": "Paneer pakoda (Full)",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096595",
                                          "name": "Chicken Kebab (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372921",
                                          "name": "Chicken wings Kebab (Full)",
                                          "price": 18000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372916",
                                          "name": "Andhra Pepper Chicken (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299033",
                                          "name": "Andhra Chicken Curry (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372909",
                                          "name": "Andhra Chilli Chicken",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372923",
                                          "name": "Extra Boiled Egg - 2 nos",
                                          "price": 2400,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372918",
                                          "name": "Ghee Gulab Jamun - 4 Pcs",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372910",
                                          "name": "Payasam 200 ml",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299037",
                                          "name": "Fresh Curd (200 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111405535",
                                          "name": "Masala More (Buttermilk)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299027",
                                          "name": "Extra Papad (With 1 Fried chilli)",
                                          "price": 900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372911",
                                          "name": "Pepsi (475 ml)",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 12,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.9",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Hyderabadi Biryanis",
                      "categories": [
                        {
                          "title": "Veg Hyderabadi Biryani",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "54769091",
                                  "name": "Veg Biryani",
                                  "category": "Hyderabadi Biryanis",
                                  "description": "Serves 1 | Layers of aromatic Rice and Vegetables cooked with our biryani masala in a dum. Served with Mirchi ka Salan and creamy raita.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1087, Protein(g): 29, Carbohydrate(g): 133, Fat (g):49\"",
                                  "imageId": "3f4a79ca260ae1572fec5891b1397e3d",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 27900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "127223422",
                                      "groupName": "Add Ons",
                                      "choices": [
                                        {
                                          "id": "111372907",
                                          "name": "Paneer Pakoda (Half)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096574",
                                          "name": "Chicken Kebab (Half)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372921",
                                          "name": "Chicken wings Kebab (Full)",
                                          "price": 18000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372916",
                                          "name": "Andhra Pepper Chicken (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372909",
                                          "name": "Andhra Chilli Chicken",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372906",
                                          "name": "Andhra Chicken Curry (200 ml)",
                                          "price": 9900,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.9",
                                      "ratingCount": "129 ratings",
                                      "ratingCountV2": "129"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "57913847",
                                  "name": "Paneer Makhni Biryani",
                                  "category": "Hyderabadi Biryanis",
                                  "description": "Serves 1 | Paneer Tikka cooked in silky makhani gravy tops a Veg Dum biryani rice. Served with Salan and Raita.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1054, Protein(g): 27, Carbohydrate(g): 114, Fat (g):54\"",
                                  "imageId": "kbox9yaeq8gwcabncefl",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 29900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52732026",
                                      "groupName": "Add Ons",
                                      "choices": [
                                        {
                                          "id": "111372907",
                                          "name": "Paneer Pakoda (Half)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096574",
                                          "name": "Chicken Kebab (Half)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372921",
                                          "name": "Chicken wings Kebab (Full)",
                                          "price": 18000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372916",
                                          "name": "Andhra Pepper Chicken (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372909",
                                          "name": "Andhra Chilli Chicken",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372906",
                                          "name": "Andhra Chicken Curry (200 ml)",
                                          "price": 9900,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "53809298",
                                      "groupName": "Sides",
                                      "choices": [
                                        {
                                          "id": "111771460",
                                          "name": "Ghee Gulab Jamun (2 Pcs)",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372923",
                                          "name": "Extra Boiled Egg - 2 nos",
                                          "price": 2400,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299024",
                                          "name": "Extra Raita",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111771461",
                                          "name": "Masala More (Buttermilk) (10% Off)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299037",
                                          "name": "Fresh Curd (200 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299027",
                                          "name": "Extra Papad (With 1 Fried chilli)",
                                          "price": 900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372911",
                                          "name": "Pepsi (475 ml)",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "58 ratings",
                                      "ratingCountV2": "58"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "85019235",
                                  "name": "Hyderabadi Paneer Biryani",
                                  "category": "Hyderabadi Biryanis",
                                  "description": "Serves 1 | Paneer cooked in a rich masala and added to a veg Dum Biryani rice.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1054, Protein(g): 27, Carbohydrate(g): 114, Fat (g):54\"",
                                  "imageId": "tpw4aky5jxzxj7qfklg5",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 29900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52732036",
                                      "groupName": "Add Ons",
                                      "choices": [
                                        {
                                          "id": "111372907",
                                          "name": "Paneer Pakoda (Half)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096574",
                                          "name": "Chicken Kebab (Half)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372921",
                                          "name": "Chicken wings Kebab (Full)",
                                          "price": 18000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372916",
                                          "name": "Andhra Pepper Chicken (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372909",
                                          "name": "Andhra Chilli Chicken",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372906",
                                          "name": "Andhra Chicken Curry (200 ml)",
                                          "price": 9900,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "53809320",
                                      "groupName": "Sides",
                                      "choices": [
                                        {
                                          "id": "111771460",
                                          "name": "Ghee Gulab Jamun (2 Pcs)",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372923",
                                          "name": "Extra Boiled Egg - 2 nos",
                                          "price": 2400,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299024",
                                          "name": "Extra Raita",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111771461",
                                          "name": "Masala More (Buttermilk) (10% Off)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299037",
                                          "name": "Fresh Curd (200 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299027",
                                          "name": "Extra Papad (With 1 Fried chilli)",
                                          "price": 900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372911",
                                          "name": "Pepsi (475 ml)",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.7",
                                      "ratingCount": "11 ratings",
                                      "ratingCountV2": "11"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Non-Veg Hyderabadi Biryani",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "57913849",
                                  "name": "Egg Biryani",
                                  "category": "Hyderabadi Biryanis",
                                  "description": "Serves 1 | Masala eggs top a bowl of dum rice. Served with Mirchi ka Salan and mixed raita.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1185, Protein(g): 33, Carbohydrate(g): 115, Fat (g):66\"",
                                  "imageId": "dnuw70nclzxujjcjfunl",
                                  "inStock": 1,
                                  "price": 24900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52732038",
                                      "groupName": "Add Ons",
                                      "choices": [
                                        {
                                          "id": "111372907",
                                          "name": "Paneer Pakoda (Half)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096574",
                                          "name": "Chicken Kebab (Half)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372921",
                                          "name": "Chicken wings Kebab (Full)",
                                          "price": 18000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372916",
                                          "name": "Andhra Pepper Chicken (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372909",
                                          "name": "Andhra Chilli Chicken",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372906",
                                          "name": "Andhra Chicken Curry (200 ml)",
                                          "price": 9900,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "53809329",
                                      "groupName": "Sides",
                                      "choices": [
                                        {
                                          "id": "111771460",
                                          "name": "Ghee Gulab Jamun (2 Pcs)",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372923",
                                          "name": "Extra Boiled Egg - 2 nos",
                                          "price": 2400,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299024",
                                          "name": "Extra Raita",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111771461",
                                          "name": "Masala More (Buttermilk) (10% Off)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299037",
                                          "name": "Fresh Curd (200 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299027",
                                          "name": "Extra Papad (With 1 Fried chilli)",
                                          "price": 900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372911",
                                          "name": "Pepsi (475 ml)",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "98 ratings",
                                      "ratingCountV2": "98"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "55027849",
                                  "name": "Hyderabadi Chicken Dum Biryani",
                                  "category": "Hyderabadi Biryanis",
                                  "description": "Serves 1 | Slow-cooked long grained rice layered in chicken masala, caramelized onions is finished in charcoal dum. Served with Mirchi ka salan and creamy raita.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1713, Protein(g): 88, Carbohydrate(g): 113, Fat (g):101\"",
                                  "imageId": "janhgjevj4xnyyg5htnv",
                                  "inStock": 1,
                                  "price": 35900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52732032",
                                      "groupName": "Add Ons",
                                      "choices": [
                                        {
                                          "id": "111372907",
                                          "name": "Paneer Pakoda (Half)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096574",
                                          "name": "Chicken Kebab (Half)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372921",
                                          "name": "Chicken wings Kebab (Full)",
                                          "price": 18000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372916",
                                          "name": "Andhra Pepper Chicken (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372909",
                                          "name": "Andhra Chilli Chicken",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372906",
                                          "name": "Andhra Chicken Curry (200 ml)",
                                          "price": 9900,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "53809314",
                                      "groupName": "Sides",
                                      "choices": [
                                        {
                                          "id": "111771460",
                                          "name": "Ghee Gulab Jamun (2 Pcs)",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372923",
                                          "name": "Extra Boiled Egg - 2 nos",
                                          "price": 2400,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299024",
                                          "name": "Extra Raita",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111771461",
                                          "name": "Masala More (Buttermilk) (10% Off)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299037",
                                          "name": "Fresh Curd (200 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299027",
                                          "name": "Extra Papad (With 1 Fried chilli)",
                                          "price": 900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372911",
                                          "name": "Pepsi (475 ml)",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "isGuiltfree": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "387 ratings",
                                      "ratingCountV2": "387"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "112360601",
                                  "name": "Special Boneless Chicken Dum Biryani",
                                  "category": "Hyderabadi Biryanis",
                                  "description": "Serves 1 | Our biryani is slow-cooked on a charcoal dum, in layers of aromatic rice, boneless meat, and caramelized onions. Served with Mirchi ka salan and creamy raitha.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1238, Protein(g): 69, Carbohydrate(g): 119, Fat (g):54\"",
                                  "imageId": "1557524a4d89abf84cb3a1b947e109c7",
                                  "inStock": 1,
                                  "price": 35900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "82205876",
                                      "groupName": "Add Ons",
                                      "choices": [
                                        {
                                          "id": "111372907",
                                          "name": "Paneer Pakoda (Half)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096574",
                                          "name": "Chicken Kebab (Half)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372921",
                                          "name": "Chicken wings Kebab (Full)",
                                          "price": 18000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372916",
                                          "name": "Andhra Pepper Chicken (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372909",
                                          "name": "Andhra Chilli Chicken",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372906",
                                          "name": "Andhra Chicken Curry (200 ml)",
                                          "price": 9900,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "82205877",
                                      "groupName": "Sides",
                                      "choices": [
                                        {
                                          "id": "111771460",
                                          "name": "Ghee Gulab Jamun (2 Pcs)",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372923",
                                          "name": "Extra Boiled Egg - 2 nos",
                                          "price": 2400,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299024",
                                          "name": "Extra Raita",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111771461",
                                          "name": "Masala More (Buttermilk) (10% Off)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299037",
                                          "name": "Fresh Curd (200 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299027",
                                          "name": "Extra Papad (With 1 Fried chilli)",
                                          "price": 900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372911",
                                          "name": "Pepsi (475 ml)",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "isGuiltfree": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "37 ratings",
                                      "ratingCountV2": "37"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101213280",
                                  "name": "Boneless Kebab Biryani",
                                  "category": "Hyderabadi Biryanis",
                                  "description": "Serves 1 | Deep fried spicy chicken kebab tops a bowl of Dum Hyderabadi biryani rice. Served with Salan and Raita.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1106, Protein(g): 35, Carbohydrate(g): 113, Fat (g):57\"",
                                  "imageId": "70ab23fb7177ba9abe0fe8fe2feaa5c6",
                                  "inStock": 1,
                                  "price": 34900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "37 ratings",
                                      "ratingCountV2": "37"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "81703268",
                                  "name": "Guntur Chicken Biryani",
                                  "category": "Hyderabadi Biryanis",
                                  "description": "Serves 1 | Sizzling hot Guntur Chicken tops a bowl of Dum Hyderabadi biryani rice. Served with Raita and Salan.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1000, Protein(g): 29, Carbohydrate(g): 108, Fat (g):50\"",
                                  "imageId": "gwtusq0zmzwzbqzfwfhc",
                                  "inStock": 1,
                                  "price": 35900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52732029",
                                      "groupName": "Add Ons",
                                      "choices": [
                                        {
                                          "id": "111372907",
                                          "name": "Paneer Pakoda (Half)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096574",
                                          "name": "Chicken Kebab (Half)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372921",
                                          "name": "Chicken wings Kebab (Full)",
                                          "price": 18000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372916",
                                          "name": "Andhra Pepper Chicken (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372909",
                                          "name": "Andhra Chilli Chicken",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372906",
                                          "name": "Andhra Chicken Curry (200 ml)",
                                          "price": 9900,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "53809308",
                                      "groupName": "Sides",
                                      "choices": [
                                        {
                                          "id": "111771460",
                                          "name": "Ghee Gulab Jamun (2 Pcs)",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372923",
                                          "name": "Extra Boiled Egg - 2 nos",
                                          "price": 2400,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299024",
                                          "name": "Extra Raita",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111771461",
                                          "name": "Masala More (Buttermilk) (10% Off)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299037",
                                          "name": "Fresh Curd (200 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299027",
                                          "name": "Extra Papad (With 1 Fried chilli)",
                                          "price": 900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372911",
                                          "name": "Pepsi (475 ml)",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isGuiltfree": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "66 ratings",
                                      "ratingCountV2": "66"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "57913850",
                                  "name": "Chicken Tikka Masala Biryani",
                                  "category": "Hyderabadi Biryanis",
                                  "description": "Serves 1 | Smoky boneless chicken tikka finished in a tomato masala and topped on dum biryani rice.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1115, Protein(g): 44, Carbohydrate(g): 113, Fat (g):54\"",
                                  "imageId": "unbgenhukd68zfybeial",
                                  "inStock": 1,
                                  "price": 34900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52732028",
                                      "groupName": "Add Ons",
                                      "choices": [
                                        {
                                          "id": "111372907",
                                          "name": "Paneer Pakoda (Half)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096574",
                                          "name": "Chicken Kebab (Half)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372921",
                                          "name": "Chicken wings Kebab (Full)",
                                          "price": 18000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372916",
                                          "name": "Andhra Pepper Chicken (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372909",
                                          "name": "Andhra Chilli Chicken",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372906",
                                          "name": "Andhra Chicken Curry (200 ml)",
                                          "price": 9900,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "53809299",
                                      "groupName": "Sides",
                                      "choices": [
                                        {
                                          "id": "111771460",
                                          "name": "Ghee Gulab Jamun (2 Pcs)",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372923",
                                          "name": "Extra Boiled Egg - 2 nos",
                                          "price": 2400,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299024",
                                          "name": "Extra Raita",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111771461",
                                          "name": "Masala More (Buttermilk) (10% Off)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299037",
                                          "name": "Fresh Curd (200 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299027",
                                          "name": "Extra Papad (With 1 Fried chilli)",
                                          "price": 900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372911",
                                          "name": "Pepsi (475 ml)",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isGuiltfree": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "2.8",
                                      "ratingCount": "61 ratings",
                                      "ratingCountV2": "61"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "57913851",
                                  "name": "Butter Chicken Biryani",
                                  "category": "Hyderabadi Biryanis",
                                  "description": "Serves 1 | Smoky Chicken Tikka, cooked in a silky makhani gravy, added to dum biryani rice. Served with raita, salan and salad.",
                                  "imageId": "ivysnthcsu2limy4ycxd",
                                  "inStock": 1,
                                  "price": 34900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "128249038",
                                      "groupName": "Add Ons",
                                      "choices": [
                                        {
                                          "id": "111372907",
                                          "name": "Paneer Pakoda (Half)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096574",
                                          "name": "Chicken Kebab (Half)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372921",
                                          "name": "Chicken wings Kebab (Full)",
                                          "price": 18000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372916",
                                          "name": "Andhra Pepper Chicken (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372909",
                                          "name": "Andhra Chilli Chicken",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372906",
                                          "name": "Andhra Chicken Curry (200 ml)",
                                          "price": 9900,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "128249039",
                                      "groupName": "Sides",
                                      "choices": [
                                        {
                                          "id": "111771460",
                                          "name": "Ghee Gulab Jamun (2 Pcs)",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372923",
                                          "name": "Extra Boiled Egg - 2 nos",
                                          "price": 2400,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299024",
                                          "name": "Extra Raita",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111771461",
                                          "name": "Masala More (Buttermilk) (10% Off)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299037",
                                          "name": "Fresh Curd (200 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299027",
                                          "name": "Extra Papad (With 1 Fried chilli)",
                                          "price": 900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372911",
                                          "name": "Pepsi (475 ml)",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "77 ratings",
                                      "ratingCountV2": "77"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "55027850",
                                  "name": "Chicken Keema Biryani",
                                  "category": "Hyderabadi Biryanis",
                                  "description": "Serves 1 | Chicken keema in a creamy Hyderabadi masala layered on Dum biryani rice. Served with Mirchi ka Salan and creamy raita.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1154, Protein(g): 41, Carbohydrate(g): 114, Fat (g):59\"",
                                  "imageId": "lcrdgsbrsfbzslqd3i9i",
                                  "inStock": 1,
                                  "price": 35900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52732169",
                                      "groupName": "Add Ons",
                                      "choices": [
                                        {
                                          "id": "111372907",
                                          "name": "Paneer Pakoda (Half)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096574",
                                          "name": "Chicken Kebab (Half)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372921",
                                          "name": "Chicken wings Kebab (Full)",
                                          "price": 18000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372916",
                                          "name": "Andhra Pepper Chicken (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372909",
                                          "name": "Andhra Chilli Chicken",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372906",
                                          "name": "Andhra Chicken Curry (200 ml)",
                                          "price": 9900,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "53809373",
                                      "groupName": "Sides",
                                      "choices": [
                                        {
                                          "id": "111771460",
                                          "name": "Ghee Gulab Jamun (2 Pcs)",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372923",
                                          "name": "Extra Boiled Egg - 2 nos",
                                          "price": 2400,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299024",
                                          "name": "Extra Raita",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111771461",
                                          "name": "Masala More (Buttermilk) (10% Off)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299037",
                                          "name": "Fresh Curd (200 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299027",
                                          "name": "Extra Papad (With 1 Fried chilli)",
                                          "price": 900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372911",
                                          "name": "Pepsi (475 ml)",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.3",
                                      "ratingCount": "34 ratings",
                                      "ratingCountV2": "34"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Authentic Andhra Meals",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "54769115",
                              "name": "Andhra Veg Meals For 1",
                              "category": "Authentic Andhra Meals",
                              "description": "Serves 1 | Steamed Rice, Pappu, Veggie Sambar, Tomato Pepper Rasam, Gutti Vankaya (Brinjal Curry), Crispy Aloo Vepudu, Fresh Curd, Kandi Podi (gunpowder), Ghee, Papad, Fresh Chutney, Deep-fried sun-dried chilli, and Sweet.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1400, Protein(g): 37, Carbohydrate(g): 199, Fat (g):51\"",
                              "imageId": "3552f46d42b1f00e1972b719bfeba648",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 28900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "52732147",
                                  "groupName": "Meal Add Ons",
                                  "choices": [
                                    {
                                      "id": "43299029",
                                      "name": "Plain Rice (Gunpowder, Ghee, Papad)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299028",
                                      "name": "Pappu of the day (350 ml)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299032",
                                      "name": "Vegetable Sambar (350 ml)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299030",
                                      "name": "Rasam (350 ml)",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299031",
                                      "name": "Gunpowder (Kandi Podi) (200 Gms)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096595",
                                      "name": "Chicken Kebab (Full)",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096594",
                                      "name": "Chicken Kebab (Half) (100gms)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299033",
                                      "name": "Andhra Chicken Curry (Full)",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299034",
                                      "name": "Guntur Chicken Dry (380 Gms)",
                                      "price": 31400,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299037",
                                      "name": "Fresh Curd (200 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111405535",
                                      "name": "Masala More (Buttermilk)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299027",
                                      "name": "Extra Papad (With 1 Fried chilli)",
                                      "price": 900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096597",
                                      "name": "Ghee Gulab Jamun (2pcs)",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096596",
                                      "name": "Rabdi",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 14,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "1107 ratings",
                                  "ratingCountV2": "1107"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "54769110",
                              "name": "Andhra Veg Meals For 2",
                              "category": "Authentic Andhra Meals",
                              "description": "Serves 2 | Steamed Rice, Pappu, Veggie Sambar, Tomato Pepper Rasam, Gutti Vankaya (Brinjal Curry), Crispy Aloo Vepudu, Fresh Curd, Kandi Podi (gunpowder), Ghee, Papad, Fresh Chutney, Deep-fried sun-dried chilli, and Sweet.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):3594, Protein(g): 119, Carbohydrate(g): 442, Fat (g):150\"",
                              "imageId": "09dde73cd0bc184307be9f619e93d869",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 55900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "52732149",
                                  "groupName": "Meal Add Ons",
                                  "choices": [
                                    {
                                      "id": "43299029",
                                      "name": "Plain Rice (Gunpowder, Ghee, Papad)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299028",
                                      "name": "Pappu of the day (350 ml)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299032",
                                      "name": "Vegetable Sambar (350 ml)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299030",
                                      "name": "Rasam (350 ml)",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299031",
                                      "name": "Gunpowder (Kandi Podi) (200 Gms)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096595",
                                      "name": "Chicken Kebab (Full)",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096594",
                                      "name": "Chicken Kebab (Half) (100gms)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299033",
                                      "name": "Andhra Chicken Curry (Full)",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299034",
                                      "name": "Guntur Chicken Dry (380 Gms)",
                                      "price": 31400,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299037",
                                      "name": "Fresh Curd (200 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111405535",
                                      "name": "Masala More (Buttermilk)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299027",
                                      "name": "Extra Papad (With 1 Fried chilli)",
                                      "price": 900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096597",
                                      "name": "Ghee Gulab Jamun (2pcs)",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096596",
                                      "name": "Rabdi",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 14,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 2"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "527 ratings",
                                  "ratingCountV2": "527"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "54769124",
                              "name": "Andhra Veg Carrier Meals- (for 3-4)",
                              "category": "Authentic Andhra Meals",
                              "description": "Serves 4 | Steamed Rice, Pappu, Veggie Sambar, Tomato Pepper Rasam, Gutti Vankaya (Brinjal Curry), Crispy Aloo Vepudu, Fresh Curd, Kandi Podi (gunpowder), Ghee, Papad, Fresh Chutney, Deep-fried sun-dried chilli, and Sweet.\n\n\"Allergens : Dairy\nNutritional information ( For serve 1) : Kcal(g):1400, Protein(g): 37, Carbohydrate(g): 199, Fat (g):51\"",
                              "imageId": "935244a6ade3870c338e2377bcb5639e",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 73900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "52732171",
                                  "groupName": "Meal Add Ons",
                                  "choices": [
                                    {
                                      "id": "43299029",
                                      "name": "Plain Rice (Gunpowder, Ghee, Papad)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299028",
                                      "name": "Pappu of the day (350 ml)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299032",
                                      "name": "Vegetable Sambar (350 ml)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299030",
                                      "name": "Rasam (350 ml)",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299031",
                                      "name": "Gunpowder (Kandi Podi) (200 Gms)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096595",
                                      "name": "Chicken Kebab (Full)",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096594",
                                      "name": "Chicken Kebab (Half) (100gms)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299033",
                                      "name": "Andhra Chicken Curry (Full)",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299034",
                                      "name": "Guntur Chicken Dry (380 Gms)",
                                      "price": 31400,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299037",
                                      "name": "Fresh Curd (200 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111405535",
                                      "name": "Masala More (Buttermilk)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299027",
                                      "name": "Extra Papad (With 1 Fried chilli)",
                                      "price": 900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096597",
                                      "name": "Ghee Gulab Jamun (2pcs)",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096596",
                                      "name": "Rabdi",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 14,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 4"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "212 ratings",
                                  "ratingCountV2": "212"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "54769142",
                              "name": "Andhra Non-Veg Meals For 1",
                              "category": "Authentic Andhra Meals",
                              "description": "Serves 1 | Steamed Rice, Pappu, Andhra Chicken Curry, Guntur Chicken Fry, Veggie Sambar, Tomato Pepper Rasam, Fresh Curd, Kandi Podi (gunpowder), Ghee, Papad, Fresh chutney, Deep-fried sun-dried chilli and Sweet.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1681, Protein(g): 59, Carbohydrate(g): 194, Fat (g):74\"",
                              "imageId": "c11716be6de65d3c53b58e7cae6fb467",
                              "inStock": 1,
                              "price": 34900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "52732165",
                                  "groupName": "Meal Add Ons",
                                  "choices": [
                                    {
                                      "id": "43299029",
                                      "name": "Plain Rice (Gunpowder, Ghee, Papad)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299028",
                                      "name": "Pappu of the day (350 ml)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299032",
                                      "name": "Vegetable Sambar (350 ml)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299030",
                                      "name": "Rasam (350 ml)",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299031",
                                      "name": "Gunpowder (Kandi Podi) (200 Gms)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096595",
                                      "name": "Chicken Kebab (Full)",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096594",
                                      "name": "Chicken Kebab (Half) (100gms)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299033",
                                      "name": "Andhra Chicken Curry (Full)",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299034",
                                      "name": "Guntur Chicken Dry (380 Gms)",
                                      "price": 31400,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299037",
                                      "name": "Fresh Curd (200 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111405535",
                                      "name": "Masala More (Buttermilk)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299027",
                                      "name": "Extra Papad (With 1 Fried chilli)",
                                      "price": 900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096597",
                                      "name": "Ghee Gulab Jamun (2pcs)",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096596",
                                      "name": "Rabdi",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 14,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "655 ratings",
                                  "ratingCountV2": "655"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "54769133",
                              "name": "Andhra Non-veg Meals For 2",
                              "category": "Authentic Andhra Meals",
                              "description": "Serves 2 | Steamed Rice, Pappu, Andhra Chicken Curry, Guntur Chicken Fry, Veggie Sambar, Tomato Pepper Rasam, Fresh Curd, Kandi Podi (gunpowder), Ghee, Papad, Fresh chutney, Deep-fried sun-dried chilli and Sweet.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):3594, Protein(g): 119, Carbohydrate(g): 442, Fat (g):150\"",
                              "imageId": "ac37c0ad29c191627fd55e98b3f2b92b",
                              "inStock": 1,
                              "price": 63900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "52732167",
                                  "groupName": "Meal Add Ons",
                                  "choices": [
                                    {
                                      "id": "43299029",
                                      "name": "Plain Rice (Gunpowder, Ghee, Papad)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299028",
                                      "name": "Pappu of the day (350 ml)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299032",
                                      "name": "Vegetable Sambar (350 ml)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299030",
                                      "name": "Rasam (350 ml)",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299031",
                                      "name": "Gunpowder (Kandi Podi) (200 Gms)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096595",
                                      "name": "Chicken Kebab (Full)",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096594",
                                      "name": "Chicken Kebab (Half) (100gms)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299033",
                                      "name": "Andhra Chicken Curry (Full)",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299034",
                                      "name": "Guntur Chicken Dry (380 Gms)",
                                      "price": 31400,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299037",
                                      "name": "Fresh Curd (200 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111405535",
                                      "name": "Masala More (Buttermilk)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299027",
                                      "name": "Extra Papad (With 1 Fried chilli)",
                                      "price": 900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096597",
                                      "name": "Ghee Gulab Jamun (2pcs)",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096596",
                                      "name": "Rabdi",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 14,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 2"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "171 ratings",
                                  "ratingCountV2": "171"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "54769151",
                              "name": "Andhra Non-Veg Carrier Meals (for 3-4)",
                              "category": "Authentic Andhra Meals",
                              "description": "Serves 4 | Steamed Rice, Pappu, Andhra Chicken Curry, Guntur Chicken Fry, Veggie Sambar, Tomato Pepper Rasam, Fresh Curd, Kandi Podi (gunpowder), Ghee, Papad, Fresh chutney, Deep-fried sun-dried chilli and Sweet.\n\n\"Allergens : Dairy\nNutritional information ( For One serve) : Kcal(g):1681, Protein(g): 59, Carbohydrate(g): 194, Fat (g):74\"",
                              "imageId": "e3f665b123b199b80e07f3b7b2b113e5",
                              "inStock": 1,
                              "price": 93900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "52732030",
                                  "groupName": "Meal Add Ons",
                                  "choices": [
                                    {
                                      "id": "43299029",
                                      "name": "Plain Rice (Gunpowder, Ghee, Papad)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299028",
                                      "name": "Pappu of the day (350 ml)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299032",
                                      "name": "Vegetable Sambar (350 ml)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299030",
                                      "name": "Rasam (350 ml)",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299031",
                                      "name": "Gunpowder (Kandi Podi) (200 Gms)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096595",
                                      "name": "Chicken Kebab (Full)",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096594",
                                      "name": "Chicken Kebab (Half) (100gms)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299033",
                                      "name": "Andhra Chicken Curry (Full)",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299034",
                                      "name": "Guntur Chicken Dry (380 Gms)",
                                      "price": 31400,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299037",
                                      "name": "Fresh Curd (200 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111405535",
                                      "name": "Masala More (Buttermilk)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299027",
                                      "name": "Extra Papad (With 1 Fried chilli)",
                                      "price": 900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096597",
                                      "name": "Ghee Gulab Jamun (2pcs)",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096596",
                                      "name": "Rabdi",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 14,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 4"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "51 ratings",
                                  "ratingCountV2": "51"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Andhra Biryani",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58539423",
                              "name": "Andhra Style Chicken Biryani",
                              "category": "Andhra Biryani",
                              "description": "Serves 1 | Marinated chicken cooked with onion, chilli, and garlic added to a Dum with rice. Served with raita and salan.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1640, Protein(g): 87, Carbohydrate(g): 128, Fat (g):86\"",
                              "imageId": "wt4yfrfw2ugwv0pmf6ar",
                              "inStock": 1,
                              "price": 34900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "52732027",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "111372907",
                                      "name": "Paneer Pakoda (Half)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096574",
                                      "name": "Chicken Kebab (Half)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372921",
                                      "name": "Chicken wings Kebab (Full)",
                                      "price": 18000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372916",
                                      "name": "Andhra Pepper Chicken (Full)",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372909",
                                      "name": "Andhra Chilli Chicken",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372906",
                                      "name": "Andhra Chicken Curry (200 ml)",
                                      "price": 9900,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "53918543",
                                  "groupName": "Sides",
                                  "choices": [
                                    {
                                      "id": "111771460",
                                      "name": "Ghee Gulab Jamun (2 Pcs)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372923",
                                      "name": "Extra Boiled Egg - 2 nos",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299024",
                                      "name": "Extra Raita",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111771461",
                                      "name": "Masala More (Buttermilk) (10% Off)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299037",
                                      "name": "Fresh Curd (200 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299027",
                                      "name": "Extra Papad (With 1 Fried chilli)",
                                      "price": 900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372911",
                                      "name": "Pepsi (475 ml)",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "182 ratings",
                                  "ratingCountV2": "182"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Tamil Rice Bowls",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "132992910",
                              "name": "Chicken Varutha Curry Rice Bowl",
                              "category": "Tamil Rice Bowls",
                              "description": "Serves 1 | Taste our Chicken Varutha Curry Rice Bowl, tender chicken in roasted spice gravy with steamed rice. A Tamil all inclusive comfort food favorite served with papad, curd, mor milagai and a boiled egg.",
                              "imageId": "158672427ca314a74c5644438b6941b6",
                              "inStock": 1,
                              "price": 24900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Southern Spiced Khichdis",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "133359640",
                              "name": "Ghee Podi Khichdi",
                              "category": "Southern Spiced Khichdis",
                              "description": "Serves 1 | Experience comfort food at its best with our Ghee Podi Khichdi. A warm and tasty rice dish.\n\n\"Allergens : -\nNutritional information : Kcal(g):492, Protein(g): 16, Carbohydrate(g): 47, Fat (g):27\"",
                              "imageId": "26ce0c5cb94e9ed6b1849f9138213e62",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "135351067",
                                  "groupName": "Addons",
                                  "choices": [
                                    {
                                      "id": "111372907",
                                      "name": "Paneer Pakoda (Half)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372920",
                                      "name": "Masala Papad",
                                      "price": 900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372908",
                                      "name": "Extra Fresh Curd (200 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372913",
                                      "name": "Mango Lassi",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372915",
                                      "name": "Ghee Gulab Jamun - 2 pcs",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372914",
                                      "name": "Sweet Lassi",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372912",
                                      "name": "Dry Fruit Lassi",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299024",
                                      "name": "Extra Raita",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372910",
                                      "name": "Payasam 200 ml",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111405535",
                                      "name": "Masala More (Buttermilk)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372911",
                                      "name": "Pepsi (475 ml)",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "133359642",
                              "name": "Deccan Dal Khichdi",
                              "category": "Southern Spiced Khichdis",
                              "description": "Serves 1 | Savor the warm spices of the Deccan in our comforting Khichdi. A flavorful lentil and rice dish that feels like home.",
                              "imageId": "010c324eca53207bb44d4307233b3d9d",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "135351068",
                                  "groupName": "Addons",
                                  "choices": [
                                    {
                                      "id": "111372907",
                                      "name": "Paneer Pakoda (Half)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372920",
                                      "name": "Masala Papad",
                                      "price": 900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372908",
                                      "name": "Extra Fresh Curd (200 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372913",
                                      "name": "Mango Lassi",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372915",
                                      "name": "Ghee Gulab Jamun - 2 pcs",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372914",
                                      "name": "Sweet Lassi",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372912",
                                      "name": "Dry Fruit Lassi",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299024",
                                      "name": "Extra Raita",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372910",
                                      "name": "Payasam 200 ml",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111405535",
                                      "name": "Masala More (Buttermilk)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372911",
                                      "name": "Pepsi (475 ml)",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "133359643",
                              "name": "Sambar Khichdi",
                              "category": "Southern Spiced Khichdis",
                              "description": "Serves 1 | Try our tangy and spicy Sambar Khichdi, a South classic. A comforting and savoury meal.",
                              "imageId": "7efe49f2ba2c8c2d7406acda0632c7e2",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "135351069",
                                  "groupName": "Addons",
                                  "choices": [
                                    {
                                      "id": "111372907",
                                      "name": "Paneer Pakoda (Half)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372920",
                                      "name": "Masala Papad",
                                      "price": 900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372908",
                                      "name": "Extra Fresh Curd (200 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372913",
                                      "name": "Mango Lassi",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372915",
                                      "name": "Ghee Gulab Jamun - 2 pcs",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372914",
                                      "name": "Sweet Lassi",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372912",
                                      "name": "Dry Fruit Lassi",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299024",
                                      "name": "Extra Raita",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372910",
                                      "name": "Payasam 200 ml",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111405535",
                                      "name": "Masala More (Buttermilk)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372911",
                                      "name": "Pepsi (475 ml)",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "133359645",
                              "name": "Andhra Style Bagara Baigan Khichdi",
                              "category": "Southern Spiced Khichdis",
                              "description": "Serves 1 | Our Andhra-style Khichdi features the unique taste of Brinjal. A flavorful South vegetarian dish.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):799, Protein(g): 17, Carbohydrate(g): 43, Fat (g):62\"",
                              "imageId": "7f996fb05e441c0182de4e85e453f12f",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "135351070",
                                  "groupName": "Addons",
                                  "choices": [
                                    {
                                      "id": "111372907",
                                      "name": "Paneer Pakoda (Half)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372920",
                                      "name": "Masala Papad",
                                      "price": 900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372908",
                                      "name": "Extra Fresh Curd (200 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372913",
                                      "name": "Mango Lassi",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372915",
                                      "name": "Ghee Gulab Jamun - 2 pcs",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372914",
                                      "name": "Sweet Lassi",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372912",
                                      "name": "Dry Fruit Lassi",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299024",
                                      "name": "Extra Raita",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372910",
                                      "name": "Payasam 200 ml",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111405535",
                                      "name": "Masala More (Buttermilk)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372911",
                                      "name": "Pepsi (475 ml)",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "133359647",
                              "name": "Coconut Salana khichdi",
                              "category": "Southern Spiced Khichdis",
                              "description": "Serves 1 | Enjoy our Khichdi with the creamy taste of coconut. A comforting South rice dish that's like a mini-vacation in a bowl.",
                              "imageId": "1852f2c5f4570b8e7fb288f215f5522b",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "135351071",
                                  "groupName": "Addons",
                                  "choices": [
                                    {
                                      "id": "111372907",
                                      "name": "Paneer Pakoda (Half)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372920",
                                      "name": "Masala Papad",
                                      "price": 900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372908",
                                      "name": "Extra Fresh Curd (200 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372913",
                                      "name": "Mango Lassi",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372915",
                                      "name": "Ghee Gulab Jamun - 2 pcs",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372914",
                                      "name": "Sweet Lassi",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372912",
                                      "name": "Dry Fruit Lassi",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299024",
                                      "name": "Extra Raita",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372910",
                                      "name": "Payasam 200 ml",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111405535",
                                      "name": "Masala More (Buttermilk)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372911",
                                      "name": "Pepsi (475 ml)",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Year of the Millet - Khichdi Dishes",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "133359648",
                              "name": "Andhra Gun Powder Millet Khichdi",
                              "category": "Year of the Millet - Khichdi Dishes",
                              "description": "Serves 1 | Try our Khichdi with the spicy taste of Andhra-style gunpowder and the goodness of millets. A healthy and exciting South dish.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):859, Protein(g): 22, Carbohydrate(g): 51, Fat (g):63\"",
                              "imageId": "ec898185feff19670a42b71c471ef0c6",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "135351072",
                                  "groupName": "Addons",
                                  "choices": [
                                    {
                                      "id": "111372907",
                                      "name": "Paneer Pakoda (Half)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372920",
                                      "name": "Masala Papad",
                                      "price": 900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372908",
                                      "name": "Extra Fresh Curd (200 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372913",
                                      "name": "Mango Lassi",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372915",
                                      "name": "Ghee Gulab Jamun - 2 pcs",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372914",
                                      "name": "Sweet Lassi",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372912",
                                      "name": "Dry Fruit Lassi",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299024",
                                      "name": "Extra Raita",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372910",
                                      "name": "Payasam 200 ml",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111405535",
                                      "name": "Masala More (Buttermilk)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372911",
                                      "name": "Pepsi (475 ml)",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Bagara Biryani",
                      "categories": [
                        {
                          "title": "Veg Bagara Biryani",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "54769095",
                                  "name": "Paneer Makhni Bagara Biryani",
                                  "category": "Bagara Biryani",
                                  "description": "Serves 1 | Paneer tikka cooked in a silky makhani gravy, tops a bowl of Bagara rice. Served with raita and  salan.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1077, Protein(g): 28, Carbohydrate(g): 112, Fat (g):58\"",
                                  "imageId": "tp48oduaveu90hfwyvyk",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 29900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52732166",
                                      "groupName": "Add Ons",
                                      "choices": [
                                        {
                                          "id": "111372907",
                                          "name": "Paneer Pakoda (Half)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096574",
                                          "name": "Chicken Kebab (Half)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372921",
                                          "name": "Chicken wings Kebab (Full)",
                                          "price": 18000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372916",
                                          "name": "Andhra Pepper Chicken (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372909",
                                          "name": "Andhra Chilli Chicken",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372906",
                                          "name": "Andhra Chicken Curry (200 ml)",
                                          "price": 9900,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "53809370",
                                      "groupName": "Sides",
                                      "choices": [
                                        {
                                          "id": "111771460",
                                          "name": "Ghee Gulab Jamun (2 Pcs)",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372923",
                                          "name": "Extra Boiled Egg - 2 nos",
                                          "price": 2400,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299024",
                                          "name": "Extra Raita",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111771461",
                                          "name": "Masala More (Buttermilk) (10% Off)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299037",
                                          "name": "Fresh Curd (200 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299027",
                                          "name": "Extra Papad (With 1 Fried chilli)",
                                          "price": 900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372911",
                                          "name": "Pepsi (475 ml)",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.7",
                                      "ratingCount": "20 ratings",
                                      "ratingCountV2": "20"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Non-Veg Bagara Biryani",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "57913844",
                                  "name": "Egg Bagara Biryani",
                                  "category": "Bagara Biryani",
                                  "description": "Serves 1 | Masala eggs tops a  bowl of special Bagara rice. Served with Mirchi ka Salan and mixed raita.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1075, Protein(g): 34, Carbohydrate(g): 112, Fat (g):55\"",
                                  "imageId": "kuzhvpwr5okwqx99venb",
                                  "inStock": 1,
                                  "price": 24900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52732098",
                                      "groupName": "Add Ons",
                                      "choices": [
                                        {
                                          "id": "111372907",
                                          "name": "Paneer Pakoda (Half)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096574",
                                          "name": "Chicken Kebab (Half)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372921",
                                          "name": "Chicken wings Kebab (Full)",
                                          "price": 18000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372916",
                                          "name": "Andhra Pepper Chicken (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372909",
                                          "name": "Andhra Chilli Chicken",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372906",
                                          "name": "Andhra Chicken Curry (200 ml)",
                                          "price": 9900,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "53809342",
                                      "groupName": "Sides",
                                      "choices": [
                                        {
                                          "id": "111771460",
                                          "name": "Ghee Gulab Jamun (2 Pcs)",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372923",
                                          "name": "Extra Boiled Egg - 2 nos",
                                          "price": 2400,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299024",
                                          "name": "Extra Raita",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111771461",
                                          "name": "Masala More (Buttermilk) (10% Off)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299037",
                                          "name": "Fresh Curd (200 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299027",
                                          "name": "Extra Papad (With 1 Fried chilli)",
                                          "price": 900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372911",
                                          "name": "Pepsi (475 ml)",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.6",
                                      "ratingCount": "25 ratings",
                                      "ratingCountV2": "25"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "54769107",
                                  "name": "Boneless Chicken Bagara Biryani",
                                  "category": "Bagara Biryani",
                                  "description": "Serves 1 | Cashew based masala chicken (boneless) tops bagara rice.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1037, Protein(g): 45, Carbohydrate(g): 110, Fat (g):47\"",
                                  "imageId": "f2c1f4f77b4c9ecdc12c26664753effb",
                                  "inStock": 1,
                                  "price": 34900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52732150",
                                      "groupName": "Add Ons",
                                      "choices": [
                                        {
                                          "id": "111372907",
                                          "name": "Paneer Pakoda (Half)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096574",
                                          "name": "Chicken Kebab (Half)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372921",
                                          "name": "Chicken wings Kebab (Full)",
                                          "price": 18000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372916",
                                          "name": "Andhra Pepper Chicken (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372909",
                                          "name": "Andhra Chilli Chicken",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372906",
                                          "name": "Andhra Chicken Curry (200 ml)",
                                          "price": 9900,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "53809359",
                                      "groupName": "Sides",
                                      "choices": [
                                        {
                                          "id": "111771460",
                                          "name": "Ghee Gulab Jamun (2 Pcs)",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372923",
                                          "name": "Extra Boiled Egg - 2 nos",
                                          "price": 2400,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299024",
                                          "name": "Extra Raita",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111771461",
                                          "name": "Masala More (Buttermilk) (10% Off)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299037",
                                          "name": "Fresh Curd (200 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299027",
                                          "name": "Extra Papad (With 1 Fried chilli)",
                                          "price": 900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372911",
                                          "name": "Pepsi (475 ml)",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isGuiltfree": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "134 ratings",
                                      "ratingCountV2": "134"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "57913845",
                                  "name": "Chicken Tikka Masala Bagara Biryani",
                                  "category": "Bagara Biryani",
                                  "description": "Serves 1 | Smoky Chicken Tikka cooked in a tomato masala tops a bowl of Bagara rice. Served with Mirchi ka Salan and mixed raita.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1005, Protein(g): 45, Carbohydrate(g): 110, Fat (g):43\"",
                                  "imageId": "jmumtongbbuhw4uwvb7d",
                                  "inStock": 1,
                                  "price": 34900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52732172",
                                      "groupName": "Add Ons",
                                      "choices": [
                                        {
                                          "id": "111372907",
                                          "name": "Paneer Pakoda (Half)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096574",
                                          "name": "Chicken Kebab (Half)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372921",
                                          "name": "Chicken wings Kebab (Full)",
                                          "price": 18000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372916",
                                          "name": "Andhra Pepper Chicken (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372909",
                                          "name": "Andhra Chilli Chicken",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372906",
                                          "name": "Andhra Chicken Curry (200 ml)",
                                          "price": 9900,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "53809374",
                                      "groupName": "Sides",
                                      "choices": [
                                        {
                                          "id": "111771460",
                                          "name": "Ghee Gulab Jamun (2 Pcs)",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372923",
                                          "name": "Extra Boiled Egg - 2 nos",
                                          "price": 2400,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299024",
                                          "name": "Extra Raita",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111771461",
                                          "name": "Masala More (Buttermilk) (10% Off)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299037",
                                          "name": "Fresh Curd (200 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299027",
                                          "name": "Extra Papad (With 1 Fried chilli)",
                                          "price": 900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372911",
                                          "name": "Pepsi (475 ml)",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.7",
                                      "ratingCount": "23 ratings",
                                      "ratingCountV2": "23"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "91307542",
                                  "name": "Guntur Chicken Bagara Biryani",
                                  "category": "Bagara Biryani",
                                  "description": "Serves 1 | Sizzling hot Guntur Chicken tops a bowl of Bagara Rice. Served with Raita and Salan.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):890, Protein(g): 30, Carbohydrate(g): 106, Fat (g):39\"",
                                  "imageId": "eofffmwpytxf1kjlqwgu",
                                  "inStock": 1,
                                  "price": 35900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52732148",
                                      "groupName": "Add Ons",
                                      "choices": [
                                        {
                                          "id": "111372907",
                                          "name": "Paneer Pakoda (Half)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096574",
                                          "name": "Chicken Kebab (Half)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372921",
                                          "name": "Chicken wings Kebab (Full)",
                                          "price": 18000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372916",
                                          "name": "Andhra Pepper Chicken (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372909",
                                          "name": "Andhra Chilli Chicken",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372906",
                                          "name": "Andhra Chicken Curry (200 ml)",
                                          "price": 9900,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "53809352",
                                      "groupName": "Sides",
                                      "choices": [
                                        {
                                          "id": "111771460",
                                          "name": "Ghee Gulab Jamun (2 Pcs)",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372923",
                                          "name": "Extra Boiled Egg - 2 nos",
                                          "price": 2400,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299024",
                                          "name": "Extra Raita",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111771461",
                                          "name": "Masala More (Buttermilk) (10% Off)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299037",
                                          "name": "Fresh Curd (200 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43299027",
                                          "name": "Extra Papad (With 1 Fried chilli)",
                                          "price": 900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372911",
                                          "name": "Pepsi (475 ml)",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.9",
                                      "ratingCount": "24 ratings",
                                      "ratingCountV2": "24"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "127261508",
                                  "name": "Pepper Chicken Bagara Biryani",
                                  "category": "Bagara Biryani",
                                  "description": "Serves 1 | Experience marinated chicken cooked in aromatic dark pepper masala served on a bowl of aromatic bagara rice.",
                                  "inStock": 1,
                                  "price": 35900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "127223426",
                                      "groupName": "Add Ons",
                                      "choices": [
                                        {
                                          "id": "111372907",
                                          "name": "Paneer Pakoda (Half)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096574",
                                          "name": "Chicken Kebab (Half)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372921",
                                          "name": "Chicken wings Kebab (Full)",
                                          "price": 18000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372916",
                                          "name": "Andhra Pepper Chicken (Full)",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372909",
                                          "name": "Andhra Chilli Chicken",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "111372906",
                                          "name": "Andhra Chicken Curry (200 ml)",
                                          "price": 9900,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Andhra Bowls",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58771992",
                              "name": "Pappu Rice Bowl",
                              "category": "Andhra Bowls",
                              "description": "Serves 1 | Steamed Rice, Palak Pappu, Potato Fry, Papad and Deep-fried sun-dried chilli.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):745, Protein(g): 18, Carbohydrate(g): 123, Fat (g):20\"",
                              "imageId": "zbvjppwbrdwtg4f4wcjl",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "131859660",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "111372907",
                                      "name": "Paneer Pakoda (Half)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096574",
                                      "name": "Chicken Kebab (Half)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372923",
                                      "name": "Extra Boiled Egg - 2 nos",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299037",
                                      "name": "Fresh Curd (200 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111405535",
                                      "name": "Masala More (Buttermilk)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299027",
                                      "name": "Extra Papad (With 1 Fried chilli)",
                                      "price": 900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096597",
                                      "name": "Ghee Gulab Jamun (2pcs)",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372906",
                                      "name": "Andhra Chicken Curry (200 ml)",
                                      "price": 9900,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372922",
                                      "name": "Payasam (100 ml)",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "416 ratings",
                                  "ratingCountV2": "416"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58771993",
                              "name": "Brinjal Curry Rice Bowl",
                              "category": "Andhra Bowls",
                              "description": "Serves 1 | Andhra Style Brinjal Curry, Steamed Rice, Potato Fry, Papad and Deep-fried sun-dried chilli.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):882, Protein(g): 15, Carbohydrate(g): 118, Fat (g):39\"",
                              "imageId": "vswzgkrxqi8rrunhfkpq",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 22900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "131859588",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "111372907",
                                      "name": "Paneer Pakoda (Half)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096574",
                                      "name": "Chicken Kebab (Half)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372923",
                                      "name": "Extra Boiled Egg - 2 nos",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299037",
                                      "name": "Fresh Curd (200 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111405535",
                                      "name": "Masala More (Buttermilk)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299027",
                                      "name": "Extra Papad (With 1 Fried chilli)",
                                      "price": 900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096597",
                                      "name": "Ghee Gulab Jamun (2pcs)",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372906",
                                      "name": "Andhra Chicken Curry (200 ml)",
                                      "price": 9900,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372922",
                                      "name": "Payasam (100 ml)",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "162 ratings",
                                  "ratingCountV2": "162"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "99745341",
                              "name": "Sambar Rice Bowl",
                              "category": "Andhra Bowls",
                              "description": "Serves 1 | Sambar, Steamed Rice, Potato Fry, Papad and Deep-fried sun-dried chilli.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):844, Protein(g): 18, Carbohydrate(g): 127, Fat (g):29\"",
                              "imageId": "h5prmmrimublerlo8g6z",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "131859625",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "111372907",
                                      "name": "Paneer Pakoda (Half)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096574",
                                      "name": "Chicken Kebab (Half)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372923",
                                      "name": "Extra Boiled Egg - 2 nos",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299037",
                                      "name": "Fresh Curd (200 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111405535",
                                      "name": "Masala More (Buttermilk)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299027",
                                      "name": "Extra Papad (With 1 Fried chilli)",
                                      "price": 900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096597",
                                      "name": "Ghee Gulab Jamun (2pcs)",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372906",
                                      "name": "Andhra Chicken Curry (200 ml)",
                                      "price": 9900,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372922",
                                      "name": "Payasam (100 ml)",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "52 ratings",
                                  "ratingCountV2": "52"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115989212",
                              "name": "Curd And Poriyal Rice Bowl",
                              "category": "Andhra Bowls",
                              "description": "Serves 1 | Try our in creamy Curd and Rice paired with vegetable poriyal stir-fry. A light and refreshing all-inclusive Tamil-style meal served with avakai pickle, papad, fried crispy chilli, deep-fried crispy aloo and poriyal of the day.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):867, Protein(g): 47, Carbohydrate(g): 127, Fat (g):19\"",
                              "imageId": "71015f621fcd581b4bcc6ebd7777d419",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "131859608",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "111372907",
                                      "name": "Paneer Pakoda (Half)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096574",
                                      "name": "Chicken Kebab (Half)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372923",
                                      "name": "Extra Boiled Egg - 2 nos",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299037",
                                      "name": "Fresh Curd (200 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111405535",
                                      "name": "Masala More (Buttermilk)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299027",
                                      "name": "Extra Papad (With 1 Fried chilli)",
                                      "price": 900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096597",
                                      "name": "Ghee Gulab Jamun (2pcs)",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372906",
                                      "name": "Andhra Chicken Curry (200 ml)",
                                      "price": 9900,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372922",
                                      "name": "Payasam (100 ml)",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129820373",
                              "name": "Rasam and Poriyal Rice Bowl",
                              "category": "Andhra Bowls",
                              "description": "Serves 1 | Savour our tangy, peppery rasam mixed with white rice in a satisfying bowl served with a side of poriyal. A South Indian comfort food classic, now conveniently served together and accompanied by papad and fried chilli. Our Rasam and Poriyal Rice Bowl brings together two greats for a delightful, nostalgic meal.",
                              "imageId": "38a80cfaf0a2dbd21f44fe24bdfa2f15",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "131859612",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "111372907",
                                      "name": "Paneer Pakoda (Half)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096574",
                                      "name": "Chicken Kebab (Half)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372923",
                                      "name": "Extra Boiled Egg - 2 nos",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299037",
                                      "name": "Fresh Curd (200 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111405535",
                                      "name": "Masala More (Buttermilk)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299027",
                                      "name": "Extra Papad (With 1 Fried chilli)",
                                      "price": 900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096597",
                                      "name": "Ghee Gulab Jamun (2pcs)",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372906",
                                      "name": "Andhra Chicken Curry (200 ml)",
                                      "price": 9900,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372922",
                                      "name": "Payasam (100 ml)",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "90500098",
                              "name": "Andhra Gun Powder Khichdi",
                              "category": "Andhra Bowls",
                              "description": "Serves 1 | Freshly Ground Kandi Podi (Gunpowder) is added to our khichdi Mix. This is a fun Andhra take. Served with Ghee, Aloo Chokha, Pickle, Papad and Curd.\n\n\"Allergens : -\nNutritional information : Kcal(g):492, Protein(g): 16, Carbohydrate(g): 47, Fat (g):27\"",
                              "imageId": "26ce0c5cb94e9ed6b1849f9138213e62",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "131859596",
                                  "groupName": "Addons",
                                  "choices": [
                                    {
                                      "id": "111372907",
                                      "name": "Paneer Pakoda (Half)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372920",
                                      "name": "Masala Papad",
                                      "price": 900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372908",
                                      "name": "Extra Fresh Curd (200 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372913",
                                      "name": "Mango Lassi",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372915",
                                      "name": "Ghee Gulab Jamun - 2 pcs",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372914",
                                      "name": "Sweet Lassi",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372912",
                                      "name": "Dry Fruit Lassi",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299024",
                                      "name": "Extra Raita",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372910",
                                      "name": "Payasam 200 ml",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111405535",
                                      "name": "Masala More (Buttermilk)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372911",
                                      "name": "Pepsi (475 ml)",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "131859597",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "111372907",
                                      "name": "Paneer Pakoda (Half)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096574",
                                      "name": "Chicken Kebab (Half)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372923",
                                      "name": "Extra Boiled Egg - 2 nos",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299037",
                                      "name": "Fresh Curd (200 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111405535",
                                      "name": "Masala More (Buttermilk)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299027",
                                      "name": "Extra Papad (With 1 Fried chilli)",
                                      "price": 900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096597",
                                      "name": "Ghee Gulab Jamun (2pcs)",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372906",
                                      "name": "Andhra Chicken Curry (200 ml)",
                                      "price": 9900,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372922",
                                      "name": "Payasam (100 ml)",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "50 ratings",
                                  "ratingCountV2": "50"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "104608897",
                              "name": "Egg Curry Rice Bowl (Andhra Style)",
                              "category": "Andhra Bowls",
                              "description": "Serves 1 | Boiled Eggs stewed in an Andhra-style onion tomato mix served with rice in an all-inclusive bowl.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1036, Protein(g): 26, Carbohydrate(g): 118, Fat (g):51\"",
                              "imageId": "rslioqyxekef1ypqo0ky",
                              "inStock": 1,
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "131859683",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "111372907",
                                      "name": "Paneer Pakoda (Half)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096574",
                                      "name": "Chicken Kebab (Half)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372923",
                                      "name": "Extra Boiled Egg - 2 nos",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299037",
                                      "name": "Fresh Curd (200 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111405535",
                                      "name": "Masala More (Buttermilk)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299027",
                                      "name": "Extra Papad (With 1 Fried chilli)",
                                      "price": 900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096597",
                                      "name": "Ghee Gulab Jamun (2pcs)",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372906",
                                      "name": "Andhra Chicken Curry (200 ml)",
                                      "price": 9900,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372922",
                                      "name": "Payasam (100 ml)",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "41 ratings",
                                  "ratingCountV2": "41"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58771988",
                              "name": "Andhra Chicken Curry Rice Bowl",
                              "category": "Andhra Bowls",
                              "description": "Serves 1 | Andhra Style Chicken Curry, Steamed Rice, Boiled Egg, Papad and Deep-fried sun-dried chilli.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1236, Protein(g): 51, Carbohydrate(g): 112, Fat (g):65\"",
                              "imageId": "ylefe7hr3c2ku4hingbg",
                              "inStock": 1,
                              "price": 29800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "131859620",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "111372907",
                                      "name": "Paneer Pakoda (Half)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096574",
                                      "name": "Chicken Kebab (Half)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372923",
                                      "name": "Extra Boiled Egg - 2 nos",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299037",
                                      "name": "Fresh Curd (200 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111405535",
                                      "name": "Masala More (Buttermilk)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299027",
                                      "name": "Extra Papad (With 1 Fried chilli)",
                                      "price": 900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096597",
                                      "name": "Ghee Gulab Jamun (2pcs)",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372906",
                                      "name": "Andhra Chicken Curry (200 ml)",
                                      "price": 9900,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372922",
                                      "name": "Payasam (100 ml)",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "71 ratings",
                                  "ratingCountV2": "71"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131194587",
                              "name": "Rasam Rice and Chicken Masala Fry Rice Bowl",
                              "category": "Andhra Bowls",
                              "description": "Serves 1 | Fragrant rice, drenched in tangy rasam. Accompanied by succulent, fiery Andhra-style chicken fry, papad, curd, Deep-fried sun-dried chilli and crispy potato vepudu.",
                              "imageId": "8d9236ea6011237a3a65e2ae0898a475",
                              "inStock": 1,
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "131859629",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "111372907",
                                      "name": "Paneer Pakoda (Half)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096574",
                                      "name": "Chicken Kebab (Half)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372923",
                                      "name": "Extra Boiled Egg - 2 nos",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299037",
                                      "name": "Fresh Curd (200 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111405535",
                                      "name": "Masala More (Buttermilk)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299027",
                                      "name": "Extra Papad (With 1 Fried chilli)",
                                      "price": 900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096597",
                                      "name": "Ghee Gulab Jamun (2pcs)",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372906",
                                      "name": "Andhra Chicken Curry (200 ml)",
                                      "price": 9900,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372922",
                                      "name": "Payasam (100 ml)",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "134217033",
                              "name": "Curd Rice Dal Khichdi",
                              "category": "Andhra Bowls",
                              "description": "Serves 1 | Fresh curd rice is mixed into our khichdi for a protein-rich, probiotic one-bowl meal. It is served with ghee, aloo chokha, pickle, papad, and raita.",
                              "imageId": "9881845218f899a2d55ee723fe4e98c5",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131194588",
                              "name": "Sambar Rice and Chicken Masala Fry Rice Bowl",
                              "category": "Andhra Bowls",
                              "description": "Serves 1 | A comforting bowl of rice bathed in a hearty, vegetable-rich sambar, paired with a generous portion of spicy Chicken fry, curd, papad, potato vepudu and Deep-fried sun-dried chilli.",
                              "imageId": "a228790e5493f2b81f9c8abb432d3391",
                              "inStock": 1,
                              "price": 21900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "131859632",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "111372907",
                                      "name": "Paneer Pakoda (Half)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096574",
                                      "name": "Chicken Kebab (Half)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372923",
                                      "name": "Extra Boiled Egg - 2 nos",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299037",
                                      "name": "Fresh Curd (200 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111405535",
                                      "name": "Masala More (Buttermilk)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299027",
                                      "name": "Extra Papad (With 1 Fried chilli)",
                                      "price": 900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096597",
                                      "name": "Ghee Gulab Jamun (2pcs)",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372906",
                                      "name": "Andhra Chicken Curry (200 ml)",
                                      "price": 9900,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372922",
                                      "name": "Payasam (100 ml)",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131194589",
                              "name": "Rasam Rice and Bangalore Kebab Rice Bowl",
                              "category": "Andhra Bowls",
                              "description": "Serves 1 | Experience rasam poured over rice, paired with succulent Bangalore Chicken Kebab. The meal is balanced with cool Curd and served alongside crispy papad, potato vepudu and Deep-fried sun-dried chilli.",
                              "imageId": "b17458ddc4b4278e72ee169327606fce",
                              "inStock": 1,
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "131859593",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "111372907",
                                      "name": "Paneer Pakoda (Half)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096574",
                                      "name": "Chicken Kebab (Half)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372923",
                                      "name": "Extra Boiled Egg - 2 nos",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299037",
                                      "name": "Fresh Curd (200 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111405535",
                                      "name": "Masala More (Buttermilk)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299027",
                                      "name": "Extra Papad (With 1 Fried chilli)",
                                      "price": 900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096597",
                                      "name": "Ghee Gulab Jamun (2pcs)",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372906",
                                      "name": "Andhra Chicken Curry (200 ml)",
                                      "price": 9900,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372922",
                                      "name": "Payasam (100 ml)",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131194590",
                              "name": "Sambar Rice and Bangalore Kebab Fry Rice Bowl",
                              "category": "Andhra Bowls",
                              "description": "Serves 1 | Indulge in the wholesome goodness of sambar rice, paired with Bangalore Chicken Kebab, curd, served with crunchy papad, potato vepudu and Deep-fried sun-dried chilli.",
                              "imageId": "aac6c59f6f88073021fafcd1a3f38beb",
                              "inStock": 1,
                              "price": 21900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "131859609",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "111372907",
                                      "name": "Paneer Pakoda (Half)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096574",
                                      "name": "Chicken Kebab (Half)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372923",
                                      "name": "Extra Boiled Egg - 2 nos",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299037",
                                      "name": "Fresh Curd (200 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111405535",
                                      "name": "Masala More (Buttermilk)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299027",
                                      "name": "Extra Papad (With 1 Fried chilli)",
                                      "price": 900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096597",
                                      "name": "Ghee Gulab Jamun (2pcs)",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372906",
                                      "name": "Andhra Chicken Curry (200 ml)",
                                      "price": 9900,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372922",
                                      "name": "Payasam (100 ml)",
                                      "price": 1900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Basmati Bhai Biryani - Tamil Edition",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101029742",
                              "name": "Bhai Biryani - Khushka with Egg",
                              "category": "Basmati Bhai Biryani - Tamil Edition",
                              "description": "Serves 1 | Tamil Muslim Style Kushka (Non-Veg) cooked in Dum style with Long Grain Basmati rice and served with Raita.",
                              "imageId": "a7nrsjbl9dcexqfqxztz",
                              "inStock": 1,
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127223423",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "111372907",
                                      "name": "Paneer Pakoda (Half)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096574",
                                      "name": "Chicken Kebab (Half)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372921",
                                      "name": "Chicken wings Kebab (Full)",
                                      "price": 18000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372916",
                                      "name": "Andhra Pepper Chicken (Full)",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372909",
                                      "name": "Andhra Chilli Chicken",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372906",
                                      "name": "Andhra Chicken Curry (200 ml)",
                                      "price": 9900,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "21 ratings",
                                  "ratingCountV2": "21"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101029744",
                              "name": "Bhai Biryani Khushka with Egg - Family Pack (Serves 3-4)",
                              "category": "Basmati Bhai Biryani - Tamil Edition",
                              "description": "Serves 1 | Tamil Muslim Style Kushka (Non-Veg) cooked in Dum style with Long Grain Basmati rice and served with Raita.",
                              "imageId": "a7nrsjbl9dcexqfqxztz",
                              "inStock": 1,
                              "price": 48900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "131859647",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "111372917",
                                      "name": "Paneer pakoda (Full)",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096573",
                                      "name": "Chicken Kebab (Full)",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372921",
                                      "name": "Chicken wings Kebab (Full)",
                                      "price": 18000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372916",
                                      "name": "Andhra Pepper Chicken (Full)",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43299033",
                                      "name": "Andhra Chicken Curry (Full)",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372909",
                                      "name": "Andhra Chilli Chicken",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372923",
                                      "name": "Extra Boiled Egg - 2 nos",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372918",
                                      "name": "Ghee Gulab Jamun - 4 Pcs",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111405535",
                                      "name": "Masala More (Buttermilk)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372911",
                                      "name": "Pepsi (475 ml)",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 10,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101029746",
                              "name": "Bhai Biryani - Khushka with Egg and Chicken Kebab Combo",
                              "category": "Basmati Bhai Biryani - Tamil Edition",
                              "description": "Serves 1 | Bhai Biryani - Khushka (Non-Veg) (Serves 1) + Fried Chicken Kebab.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1294, Protein(g): 41, Carbohydrate(g): 135, Fat (g):66\"",
                              "imageId": "81e581c53ad3d7c76cc97af114e116e3",
                              "inStock": 1,
                              "price": 35900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127223420",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "111372907",
                                      "name": "Paneer Pakoda (Half)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096574",
                                      "name": "Chicken Kebab (Half)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372921",
                                      "name": "Chicken wings Kebab (Full)",
                                      "price": 18000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372916",
                                      "name": "Andhra Pepper Chicken (Full)",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372909",
                                      "name": "Andhra Chilli Chicken",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372906",
                                      "name": "Andhra Chicken Curry (200 ml)",
                                      "price": 9900,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Eat@Desk",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "132721291",
                              "name": "Hyderabadi Paneer Bagara Pulao Meal",
                              "category": "Eat@Desk",
                              "description": "Serves 1 | Spiced paneer cooked in a Hyderabadi-style gravy atop Bagara rice. Served with raita, Mirchi ka salan and payasam.",
                              "imageId": "4866baaba1c6984a307e9762e545e377",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 27900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "132721292",
                              "name": "Hyderabadi Paneer Biryani Rice Meal",
                              "category": "Eat@Desk",
                              "description": "Serves 1 | Spiced paneer cooked in a Hyderabadi-style gravy layered over Hyderabadi biryani rice. Served with raita, Mirchi ka salan and payasam.",
                              "imageId": "d0b51389479223b324d336132a408a64",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 27900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "132721293",
                              "name": "Paneer Makhani Bagara Pulao Meal",
                              "category": "Eat@Desk",
                              "description": "Serves 1 | Paneer tikka cooked in a silky makhani gravy atop Bagara rice. Served with raita, mirchi ka salan and sweet payasam.",
                              "imageId": "ec706bf54b65d9f8b9406b1763a9594a",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 27900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "132721294",
                              "name": "Paneer Makhani Biryani Rice Meal",
                              "category": "Eat@Desk",
                              "description": "Serves 1 | Paneer tikka cooked in a silky makhani gravy layered over biryani rice. Served with raita, mirchi ka salan and sweet payasam.",
                              "imageId": "c07fbdf99cc254723488779dec549b28",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 27900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "132721295",
                              "name": "Butter Chicken Bagara Pulao Meal",
                              "category": "Eat@Desk",
                              "description": "Serves 1 | Chicken tikka cooked in a rich makhani gravy atop Bagara rice. Served with raita, Mirchi ka salan and sweet payasam.",
                              "imageId": "4f6fa53c58f99fc6e9c43a7225920363",
                              "inStock": 1,
                              "price": 29900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "132721296",
                              "name": "Butter Chicken Biryani Rice Meal",
                              "category": "Eat@Desk",
                              "description": "Serves 1 | Chicken tikka cooked in a rich makhani gravy layered over biryani rice. Served with raitas, Mirchi ka salan and sweet payasam.",
                              "imageId": "0f92e3e91d714327a7a958c78de678ce",
                              "inStock": 1,
                              "price": 28900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "132721297",
                              "name": "Andhra Chicken Curry Biryani Rice Meal",
                              "category": "Eat@Desk",
                              "description": "Serves 1 | Andhra chicken curry served over biryani rice. Served with raita, mirchi ka salan and sweet payasam.",
                              "imageId": "8352b2ea7ec9c255d5aeb9aea6a2c23b",
                              "inStock": 1,
                              "price": 27900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "132721298",
                              "name": "Bhai Khushka Meals With Chicken Varutha Curry",
                              "category": "Eat@Desk",
                              "description": "Serves 1 | Tamil style chicken  curry served over Bhai biryani kushka rice. Accompanied by raita, mirchi ka salan and payasam.",
                              "imageId": "63f0acb3e164d67f9628574e62943067",
                              "inStock": 1,
                              "price": 27900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "132721290",
                              "name": "Chicken Tikka Masala Bagara Pulao Meal",
                              "category": "Eat@Desk",
                              "description": "Serves 1 | Chicken tikka masala atop Bagara rice. Served with raita, mirchi ka salan and sweet payasam.",
                              "imageId": "b9a22e7e3e57f4b03bc63bf052b0f82e",
                              "inStock": 1,
                              "price": 29900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "132721299",
                              "name": "Chicken Tikka Masala Biryani Rice Meal",
                              "category": "Eat@Desk",
                              "description": "Serves 1 | Chicken tikka masala layered over biryani rice. Served with raita, mirchi ka salan and sweet payasam.",
                              "imageId": "2c1eff7b492e40d5b1450fbc743f3e4b",
                              "inStock": 1,
                              "price": 27900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "132721300",
                              "name": "Guntur Chicken Biryani Rice Meal",
                              "category": "Eat@Desk",
                              "description": "Serves 1 | Spicy Guntur chicken curry layered over Hyderabadi biryani rice. Served with raita, mirchi ka salan and payasam.",
                              "imageId": "4efd4de8a85d12b382c88ebd8283d5a8",
                              "inStock": 1,
                              "price": 27900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "132721301",
                              "name": "Pepper Chicken Masala Bagara Pulao Meal",
                              "category": "Eat@Desk",
                              "description": "Serves 1 | Pepper chicken marinated in aromatic spices atop creamy Bagara rice. Served with raita, mirchi ka salan and sweet payasam.",
                              "imageId": "111583b380ee18628749181c2b514040",
                              "inStock": 1,
                              "price": 29900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "132721302",
                              "name": "Pepper Chicken Masala Biryani Meal",
                              "category": "Eat@Desk",
                              "description": "Serves 1 | Slow cooked chicken marinated in aromatic pepper masala tops steamed basmati rice. Served with raita, mirchi ka salan and sweet payasam.",
                              "imageId": "e19f0f63097f1b17dfcbfc90878cad5d",
                              "inStock": 1,
                              "price": 29900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "133394190",
                              "name": "Andhra Chicken Curry Bagara Meal",
                              "category": "Eat@Desk",
                              "description": "Serves 1 | Andhra style chicken curry with regional spices atop Bagara rice. Served with raita, mirchi ka salan and sweet payasam.",
                              "imageId": "98e52659f882dbc427cf9cf15c046d3c",
                              "inStock": 1,
                              "price": 27900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "133394191",
                              "name": "Guntur Chicken Curry Bagara Meal",
                              "category": "Eat@Desk",
                              "description": "Serves 1 | Spicy Guntur style chicken curry with regional spices atop Bagara rice. Served with raita, mirchi ka salan and sweet payasam.",
                              "imageId": "c5a1c9f6f8fc7cefb1c6afdb2d3c84ab",
                              "inStock": 1,
                              "price": 27900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Meals Add Ons",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "70984181",
                              "name": "Pappu of the Day (350 ml)",
                              "category": "Meals Add Ons",
                              "description": "Serves 1 | Andhra style lentil slow cooked with green leafy spinach (Serves 2).\n\n\"Allergens : -\nNutritional information : Kcal(g):223, Protein(g): 8, Carbohydrate(g): 22, Fat (g):12\"",
                              "imageId": "fwdqpxk6k3bcvtoircjm",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "329 ratings",
                                  "ratingCountV2": "329"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "70984184",
                              "name": "Vegetable Sambar (350 ml)",
                              "category": "Meals Add Ons",
                              "description": "Serves 1 | Lentil-based vegetables, cooked with in-house masala and tamarind(Serves 2).\n\n\"Allergens : -\nNutritional information : Kcal(g):349, Protein(g): 8, Carbohydrate(g): 26, Fat (g):24\"",
                              "imageId": "k05pdjuqjh4azbyy8ddk",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "171 ratings",
                                  "ratingCountV2": "171"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "132992909",
                              "name": "Kozhi Varutha Curry",
                              "category": "Meals Add Ons",
                              "description": "Serves 1 | Delicious chicken curry made with a freshly ground masala that lends great flavour to the dish (Serves 2).",
                              "imageId": "c996d7e3bb0828291b18633213584c4b",
                              "inStock": 1,
                              "price": 23900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "70984182",
                              "name": "Rasam (350 ml)",
                              "category": "Meals Add Ons",
                              "description": "Serves 1 | Functional Food using tamarind juice as a base, with the addition of turmeric, tomato, chilli pepper, pepper, garlic, cumin, curry leaves, mustard, coriander, asafoetida, sea salt, and water.\n\n\"Allergens : -\nNutritional information : Kcal(g):128, Protein(g): 4, Carbohydrate(g): 15, Fat (g):6\"",
                              "imageId": "oabyrcankntimjumfksh",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "263 ratings",
                                  "ratingCountV2": "263"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "84738274",
                              "name": "Andhra Chilli Chicken",
                              "category": "Meals Add Ons",
                              "description": "Chicken is slow cooked with minimal spices and heaps of fiery Green Chilli.\n\n\"Allergens : -\nNutritional information : Kcal(g):1664, Protein(g): 116, Carbohydrate(g): 20, Fat (g):124\"",
                              "imageId": "toxsxykhxta1xl0utndb",
                              "inStock": 1,
                              "price": 29800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.2",
                                  "ratingCount": "24 ratings",
                                  "ratingCountV2": "24"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "104608899",
                              "name": "Andhra Egg Curry (350 ml)",
                              "category": "Meals Add Ons",
                              "description": "Serves 1 | Boiled eggs stewed in an Andhra-style tomato onion gravy (350 ml).\n\n\"Allergens : Egg\nNutritional information : Kcal(g):575, Protein(g): 21, Carbohydrate(g): 16, Fat (g):47\"",
                              "imageId": "cqgf6b0kr0ht5zptspgh",
                              "inStock": 1,
                              "price": 16500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "20 ratings",
                                  "ratingCountV2": "20"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "70984180",
                              "name": "Guntur Chicken Dry (400 gms)",
                              "category": "Meals Add Ons",
                              "description": "Serves 1 | Juicy chicken cooked in spicy masala (Serves 2).\n\n\"Allergens : -\nNutritional information : Kcal(g):143, Protein(g): 7, Carbohydrate(g): 4, Fat (g):11\"",
                              "imageId": "sgbkjpwknnnuxkcupywy",
                              "inStock": 1,
                              "price": 29900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "91 ratings",
                                  "ratingCountV2": "91"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "70984178",
                              "name": "Andhra Chicken Curry (400 ml)",
                              "category": "Meals Add Ons",
                              "description": "Serves 1 | Marinated chicken is made with a freshly ground tamarind masala (Serves 2).\n\n\"Allergens : -\nNutritional information : Kcal(g):1128, Protein(g): 58, Carbohydrate(g): 19, Fat (g):91\"",
                              "imageId": "kmp3tquxjhq1ivyv7bss",
                              "inStock": 1,
                              "price": 29900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "161 ratings",
                                  "ratingCountV2": "161"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93770709",
                              "name": "Plain Rice (Gunpowder, Ghee, Papad & Crispy Fried Curd Chilli )",
                              "category": "Meals Add Ons",
                              "description": "Serves 1 | Served with Ghee, Gunpowder, Papad & Deep-fried sun-dried chilli (Serves 1).\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):780, Protein(g): 14, Carbohydrate(g): 133, Fat (g):21\"",
                              "imageId": "vd1qcbt7dwyettvwyymj",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "233 ratings",
                                  "ratingCountV2": "233"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "70984186",
                              "name": "Fresh Curd (200 ml)",
                              "category": "Meals Add Ons",
                              "description": "Serves 1 | Creamy fresh curd (200 Ml).\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):145, Protein(g): 20, Carbohydrate(g): 8, Fat (g):4\"",
                              "imageId": "zkaygnxsap6b9dbg01zz",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 4900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "103 ratings",
                                  "ratingCountV2": "103"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "75155793",
                              "name": "Extra Papad",
                              "category": "Meals Add Ons",
                              "description": "Serves 1 | \"Allergens : -\nNutritional information : Kcal(g):68, Protein(g): 2, Carbohydrate(g): 6, Fat (g):4\"",
                              "imageId": "diglkpki32lznvw1vi1z",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "265 ratings",
                                  "ratingCountV2": "265"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58300545",
                              "name": "Gunpowder (Kandi Podi) (200 gms)",
                              "category": "Meals Add Ons",
                              "description": "Serves 1 | \"Allergens : -\nNutritional information : Kcal(g):492, Protein(g): 16, Carbohydrate(g): 47, Fat (g):27\"",
                              "imageId": "7e6b4346b5067bbd186723ffebab42d9",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "66 ratings",
                                  "ratingCountV2": "66"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Aromatic Bagara Pulav",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "132992911",
                              "name": "Chicken Varutha Bagara Pulav",
                              "category": "Aromatic Bagara Pulav",
                              "description": "Serves 1 | Savour the combination of Bagara Rice and Chicken Varutha Curry. This flavorful dish is served with Raita, making it a perfect choice for those seeking a delicious alternative to traditional biryani.",
                              "imageId": "57695699cd89c3cd3f00b78516ea5624",
                              "inStock": 1,
                              "price": 33900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133910532",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "111372907",
                                      "name": "Paneer Pakoda (Half)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096574",
                                      "name": "Chicken Kebab (Half)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372921",
                                      "name": "Chicken wings Kebab (Full)",
                                      "price": 18000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372916",
                                      "name": "Andhra Pepper Chicken (Full)",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372909",
                                      "name": "Andhra Chilli Chicken",
                                      "price": 25000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "111372906",
                                      "name": "Andhra Chicken Curry (200 ml)",
                                      "price": 9900,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Starters",
                      "categories": [
                        {
                          "title": "Veg Starters",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "54668408",
                                  "name": "Paneer Pakoda",
                                  "category": "Starters",
                                  "description": "Serves 1 | Soft Dairy fresh Paneer coated in a special batter and deep fried to golden brown.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):663, Protein(g): 17, Carbohydrate(g): 22, Fat (g):57\"",
                                  "imageId": "jdpkkbqkdzzthiuuckqz",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 16900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "89 ratings",
                                      "ratingCountV2": "89"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Non Veg Starters",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "121156721",
                                  "name": "Chicken Vepudu",
                                  "category": "Starters",
                                  "description": "Serves 1 | Experience an Andhra's culinary joy! Succulent chicken bite size pieces, stir-fried to golden perfection in dry fiery spice and fresh herbs mix.\n\n\"Allergens : -\nNutritional information : Kcal(g):307, Protein(g): 42, Carbohydrate(g): 10, Fat (g):11\"",
                                  "imageId": "d39c0e53bf864dc3a5846829c91e1b50",
                                  "inStock": 1,
                                  "price": 34900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "2.9",
                                      "ratingCount": "5 ratings",
                                      "ratingCountV2": "5"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "54668410",
                                  "name": "Fried Chicken Kebab(Boneless)",
                                  "category": "Starters",
                                  "description": "Serves 1 | Marinated chicken is coated in spicy masala and fried to perfection.\n\n\"Allergens : -\nNutritional information : Kcal(g):647, Protein(g): 25, Carbohydrate(g): 17, Fat (g):53\"",
                                  "imageId": "ytcezodswsdrejtgicwj",
                                  "inStock": 1,
                                  "price": 27900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.5",
                                      "ratingCount": "485 ratings",
                                      "ratingCountV2": "485"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "111440412",
                                  "name": "Chicken Wings Kebab",
                                  "category": "Starters",
                                  "description": "Serves 1 | Try our delicious bone-in chicken wings marinated in a kabab-style spice blend. Fried to perfection for a crispy outside and moist inside. 7 pieces per serving.\n\n\"Allergens : -\nNutritional information : Kcal(g):972, Protein(g): 33, Carbohydrate(g): 22, Fat (g):84\"",
                                  "imageId": "aabb1e1ae49da7048c9c2c829a174aac",
                                  "inStock": 1,
                                  "price": 19900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "56 ratings",
                                      "ratingCountV2": "56"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "125755804",
                                  "name": "Andhra Pepper Chicken",
                                  "category": "Starters",
                                  "description": "Serves 1 | Tender marinated chicken cooked in aromatic dark pepper masala, served with a coriander garnish.\n\n\"Allergens : -\nNutritional information : Kcal(g):307, Protein(g): 42, Carbohydrate(g): 10, Fat (g):11\"",
                                  "imageId": "maw5aalu74mqjkrdc51x",
                                  "inStock": 1,
                                  "price": 29900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.9",
                                      "ratingCount": "11 ratings",
                                      "ratingCountV2": "11"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Desserts.",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117417581",
                              "name": "Payasam (200gm)",
                              "category": "Desserts.",
                              "description": "Serves 1 | Payasam Of The Day.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):406, Protein(g): 9, Carbohydrate(g): 72, Fat (g):9\"",
                              "imageId": "d3af1638b216b7dd27020a1d64a5adee",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 4900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "28 ratings",
                                  "ratingCountV2": "28"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "54668420",
                              "name": "Ghee Gulab Jamun (2 Pcs)",
                              "category": "Desserts.",
                              "description": "Serves 1 | Khoya rich dumplings are deep fried and then given a soaking in sugar syrup.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):426, Protein(g): 4, Carbohydrate(g): 41, Fat (g):27\"",
                              "imageId": "i6wqvnqigzfkkbgxkvxp",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "150 ratings",
                                  "ratingCountV2": "150"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "76250620",
                              "name": "Ghee Gulab Jamun - 4 Pcs",
                              "category": "Desserts.",
                              "description": "Serves 1 | Khoya rich dumplings are deep fried and then given a soaking in sugar syrup.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):853, Protein(g): 8, Carbohydrate(g): 81, Fat (g):55\"",
                              "imageId": "nwr4e3l5gdqh1lkffoyw",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "26 ratings",
                                  "ratingCountV2": "26"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "54668419",
                              "name": "Rabdi",
                              "category": "Desserts.",
                              "description": "Serves 1 | Slow reduced sweetened milk.\n\n\"Allergens : -\nNutritional information : Kcal(g):1210, Protein(g): 26, Carbohydrate(g): 217, Fat (g):26\"",
                              "imageId": "zews9mmyenswmczpraan",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 4900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "135 ratings",
                                  "ratingCountV2": "135"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Healthy Beverages.",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129665449",
                              "name": "Masala Shikanji",
                              "category": "Healthy Beverages.",
                              "description": "Serves 1 | The perfect thirst quencher, get our tangy nimbu pani mixed with cooling spices (250ml)",
                              "imageId": "95b0b1343e6fd975912b78a40c895c12",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "54668413",
                              "name": "Sweet Lassi",
                              "category": "Healthy Beverages.",
                              "description": "Serves 1 | Classic Lassi - Chilled.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):223, Protein(g): 24, Carbohydrate(g): 22, Fat (g):5\"",
                              "imageId": "gplhj8dthmmsvb4pybe9",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "72 ratings",
                                  "ratingCountV2": "72"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "54668416",
                              "name": "Dry Fruit Lassi",
                              "category": "Healthy Beverages.",
                              "description": "Serves 1 | Classic Lassi, blended with Dry Fruit.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):287, Protein(g): 25, Carbohydrate(g): 29, Fat (g):8\"",
                              "imageId": "bhs9ipdh7qebylefiuyj",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "42 ratings",
                                  "ratingCountV2": "42"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "54668414",
                              "name": "Mango Lassi",
                              "category": "Healthy Beverages.",
                              "description": "Serves 1 | Classic lassi churned with mango pulp.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):195, Protein(g): 14, Carbohydrate(g): 29, Fat (g):3\"",
                              "imageId": "kp2fejjkf13mbmzxqqyr",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "35 ratings",
                                  "ratingCountV2": "35"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Beverages",
                      "categories": [
                        {
                          "title": "Soft Drinks",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "127923658",
                                  "name": "Pepsi Pet Bottle-475 mL",
                                  "category": "Beverages",
                                  "description": "Serves 1",
                                  "imageId": "973bab2d743001a35f4f231bbd167e72",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 6000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.8",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                      "type": "FSSAI",
                      "imageId": "fssai_final_edss9i",
                      "text": [
                        "License No. 11220334000161"
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                      "name": "Andhra Gunpowder",
                      "area": "Hsr Layout",
                      "completeAddress": "No 392, 3rd Floor , 9th Main , 7th Sector ,HSR Layout, Bangalore 560102"
                    }
                  }
                }
              ]
            }
          }
        }
      }
    ],
    "firstOffsetRequest": true,
    "isQCLink": false
  },
  "tid": "8091b6c9-34ec-4881-8b5e-d2b6a4328fa1",
  "sid": "c8b69dc8-6710-47a7-bc63-18091856e3fa",
  "deviceId": "c73fa13e-69cf-472b-8071-076091f9d98d",
  "csrfToken": "bhBZfSTycvrA-IJtt-UZcTz5oskKDbGo6h_JFD78"
}

export const ASHA_TIFFINS=
{
  "statusCode": 0,
  "data": {
    "statusMessage": "done successfully",
    "cards": [
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
            "info": {
              "id": "201224",
              "name": "Asha tiffins",
              "city": "Bangalore",
              "slugs": {
                "restaurant": "asha-tiffins-hsr-hsr-2",
                "city": "bangalore"
              },
              "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
              "cloudinaryImageId": "n15vckntsiboiod3gpco",
              "locality": "HSR Layout",
              "areaName": "Hsr Layout",
              "costForTwo": "20000",
              "costForTwoMessage": "₹200 for two",
              "cuisines": [
                "South Indian",
                "North Indian"
              ],
              "avgRating": 4.5,
              "feeDetails": {
                "restaurantId": "201224",
                "fees": [
                  {
                    "name": "distance",
                    "fee": 3200
                  },
                  {
                    "name": "time"
                  },
                  {
                    "name": "special"
                  }
                ],
                "totalFee": 3200,
                "icon": "v1648635511/Delivery_fee_new_cjxumu",
                "message": "1.3 kms | ₹32 Delivery fee will apply"
              },
              "parentId": "236243",
              "avgRatingString": "4.5",
              "totalRatingsString": "10K+ ratings",
              "sla": {
                "restaurantId": "201224",
                "deliveryTime": 18,
                "minDeliveryTime": 15,
                "maxDeliveryTime": 20,
                "lastMileTravel": 1.4,
                "serviceability": "SERVICEABLE",
                "stressFactor": 1,
                "rainMode": "RAIN_MODE_NONE",
                "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
                "zoneId": 3,
                "slaString": "15-20 MINS",
                "lastMileTravelString": "1.3 km",
                "iconType": "ICON_TYPE_EMPTY"
              },
              "availability": {
                "nextCloseTime": "2024-02-18 15:30:00",
                "visibility": true,
                "opened": true,
                "restaurantClosedMeta": {
                  
                }
              },
              "aggregatedDiscountInfo": {
                "header": "50% off",
                "shortDescriptionList": [
                  {
                    "meta": "50% off | Use TRYNEW",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹125 off on orders above ₹299",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "50% off up to ₹100 | Use code TRYNEW",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹125 off on orders above ₹299 | Use code SWIGGYWEEKENDS",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "visible": true
              },
              "badges": {
                
              },
              "slugString": "asha-tiffins-hsr-hsr-2",
              "multiOutlet": true,
              "isOpen": true,
              "labels": [
                {
                  "title": "Timings",
                  "message": "null"
                },
                {
                  "title": "Address",
                  "message": "Asha Tiffins, 5th Main Road, Sector 7, HSR Layout, Bengaluru, Karnataka, India"
                },
                {
                  "title": "Cuisines",
                  "message": "South Indian,North Indian"
                }
              ],
              "totalRatings": 10000,
              "aggregatedDiscountInfoV2": {
                "header": "50% off",
                "shortDescriptionList": [
                  {
                    "meta": "50% off | Use TRYNEW",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹125 off on orders above ₹299",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "50% off up to ₹100 | Use code TRYNEW",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹125 off on orders above ₹299 | Use code SWIGGYWEEKENDS",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "couponDetailsCta": "View coupon details"
              },
              "type": "F",
              "nudgeBanners": [
                {
                  "minValue": 209,
                  "maxValue": 299,
                  "priority": 2,
                  "couponCode": "SWIGGYWEEKENDS",
                  "discountInfo": {
                    "discountType": "Flat",
                    "value": 125
                  },
                  "lockedMessage": "Add items worth ₹<amount> to save ₹125 | Code SWIGGYWEEKENDS",
                  "unlockedMessage": "SWIGGYWEEKENDS Coupon Unlocked! Use it to save ₹125",
                  "logoCtx": {
                    
                  }
                },
                {
                  "minValue": 630,
                  "maxValue": 900,
                  "priority": 3,
                  "couponCode": "PARTY",
                  "discountInfo": {
                    "discountType": "Percentage",
                    "value": 15
                  },
                  "lockedMessage": "Add items worth ₹<amount> to unlock flat 15% off | Code PARTY",
                  "unlockedMessage": "PARTY Coupon Unlocked! Use it to save flat 15% off",
                  "logoCtx": {
                    
                  }
                }
              ],
              "headerBanner": {
                "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/201224"
              },
              "expectationNotifiers": [
                {
                  "text": "1.3 kms | ₹32 Delivery fee will apply",
                  "icon": {
                    "imageId": "v1648635511/Delivery_fee_new_cjxumu"
                  },
                  "popup": {
                    "cta": {
                      
                    }
                  },
                  "type": "DISTANCE_FEE_NON_FOOD_LM",
                  "enrichedText": "<b>1.3 kms</b> | ₹32 Delivery fee will apply",
                  "halfCardPopup": {
                    "halfCardPopupHeader": {
                      
                    }
                  }
                }
              ],
              "generalPurposeInfoListV2": [
                {
                  "cta": {
                    "info": {
                      "recordings": {
                        
                      }
                    },
                    "linkCta": {
                      
                    }
                  }
                }
              ],
              "ratingSlab": "RATING_SLAB_5",
              "orderabilityCommunication": {
                "title": {
                  
                },
                "subTitle": {
                  
                },
                "message": {
                  
                },
                "customIcon": {
                  
                }
              },
              "hasBestsellerItems": true,
              "cartOrderabilityNudgeBanner": {
                "parameters": {
                  
                },
                "presentation": {
                  
                }
              },
              "latLong": "12.91187709,77.63248288",
              "backgroundImageOverlayInfo": {
                
              }
            },
            "analytics": {
              
            }
          },
          "relevance": {
            "type": "RELEVANCE_TYPE_CHECK_ORDERABILITY_ON_ITEM_ADD",
            "sectionId": "POP_UP_CROUTON_MENU"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "layout": {
              "rows": 1,
              "columns": 5,
              "horizontalScrollEnabled": true,
              "itemSpacing": 12,
              "lineSpacing": 10,
              "widgetPadding": {
                
              },
              "containerStyle": {
                "containerPadding": {
                  "left": 10,
                  "right": 10,
                  "bottom": 16
                }
              },
              "scrollBar": {
                
              }
            },
            "id": "offerCollectionWidget_UX4",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                "offers": [
                  {
                    "info": {
                      "header": "50% OFF UPTO ₹100",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "8ed8f86b-6e92-4bb0-b7e5-9b97b1097a99"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE TRYNEW",
                      "description": "ABOVE ₹179",
                      "offerType": "offers",
                      "restId": "201224",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹125 OFF",
                      "offerTag": "FLAT DEAL",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "d8d75127-12f0-4878-8df9-169d0cb7b907"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE SWIGGYWEEKENDS",
                      "description": "ABOVE ₹299",
                      "offerType": "offers",
                      "restId": "201224",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT 15% OFF",
                      "offerTag": "FLAT DEAL",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "96aee372-0221-48d7-ae49-916602c0dca7"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE PARTY",
                      "description": "ABOVE ₹900",
                      "offerType": "offers",
                      "restId": "201224",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹100 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "MARKETING_BANNERS/IMAGES/OFFERS/2024/2/17/1ed4245d-31e3-4dc6-b949-524a33b9b8c9_ICICI.png",
                      "offerIds": [
                        "299f5c31-dd4a-47a4-8d93-4ccb6be1a8a8"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "NO CODE REQUIRED",
                      "description": "ABOVE ₹550",
                      "offerType": "offers",
                      "restId": "201224",
                      "offerLogo": "MARKETING_BANNERS/IMAGES/OFFERS/2024/2/17/1ed4245d-31e3-4dc6-b949-524a33b9b8c9_ICICI.png",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹50 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "MARKETING_BANNERS/IMAGES/OFFERS/2024/2/16/d2280c74-96d1-4a1d-afd6-4270a05b5488_ICICI.png",
                      "offerIds": [
                        "72b12a41-597c-4c87-a813-32c46574fde9"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "NO CODE REQUIRED",
                      "description": "ABOVE ₹500",
                      "offerType": "offers",
                      "restId": "201224",
                      "offerLogo": "MARKETING_BANNERS/IMAGES/OFFERS/2024/2/16/d2280c74-96d1-4a1d-afd6-4270a05b5488_ICICI.png",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  }
                ],
                "habitMilestoneInfo": {
                  "callout": {
                    
                  }
                },
                "loyaltyDiscoverPresentationInfo": {
                  "logoCtx": {
                    
                  }
                }
              }
            }
          }
        }
      },
      {
        "groupedCard": {
          "cardGroupMap": {
            "REGULAR": {
              "cards": [
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                      "badges": {
                        
                      },
                      "vegOnlyDetails": {
                        "imageId": "AutoVegOnly_qkjowj",
                        "title": "Showing only vegetarian options.",
                        "description": "Tap on the VEG ONLY button to turn off the setting"
                      },
                      "topRatedFilter": {
                        
                      },
                      "kidsCategoryFilter": {
                        "attributes": {
                          "displayText": "Kids Favourites",
                          "tooltip": {
                            "enabled": true,
                            "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                          }
                        }
                      },
                      "vegFilter": {
                        "attributes": {
                          "displayText": "VEG"
                        }
                      },
                      "nonvegFilter": {
                        "attributes": {
                          "displayText": "NONVEG"
                        }
                      }
                    },
                    "relevance": {
                      "type": "RELEVANCE_TYPE_ON_MENU_FILTER_TOGGLED",
                      "sectionId": "MENU_FILTER_TOGGLE"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Recommended",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "43305466",
                              "name": "Plain Dosa.",
                              "category": "Breakfast  ",
                              "description": "Served with chutney & sambar.",
                              "imageId": "bjfm55y7bhcglmye97m9",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "49878150",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318799",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318803",
                                  "groupName": "Extras",
                                  "choices": [
                                    {
                                      "id": "28626625",
                                      "name": "Extra Sambar (250 Ml)",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "28626626",
                                      "name": "Extra Sambar (450 Ml)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "28626627",
                                      "name": "Extra Coconut Chutney (250 Ml)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "28626628",
                                      "name": "Extra Coconut Chutney (450 Ml)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "5030 ratings",
                                  "ratingCountV2": "5030"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "43305467",
                              "name": "Masala Dosa",
                              "category": "Breakfast  ",
                              "description": "Served with chutney & sambar.",
                              "imageId": "apfjvcq6ccr01svoezji",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "49878151",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318805",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318808",
                                  "groupName": "Extras",
                                  "choices": [
                                    {
                                      "id": "28626625",
                                      "name": "Extra Sambar (250 Ml)",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "28626626",
                                      "name": "Extra Sambar (450 Ml)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "28626627",
                                      "name": "Extra Coconut Chutney (250 Ml)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "28626628",
                                      "name": "Extra Coconut Chutney (450 Ml)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "17717 ratings",
                                  "ratingCountV2": "17717"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "42978078",
                              "name": "Roti Curry",
                              "category": "Combos ",
                              "description": "Roti (2 pcs) + dal + curry + salad.",
                              "imageId": "jb2zc3lab0ziv9hb6svd",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "41318829",
                                  "groupName": "Extra Butter",
                                  "choices": [
                                    {
                                      "id": "28626629",
                                      "name": "Butter",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318830",
                                  "groupName": "Extra Roti",
                                  "choices": [
                                    {
                                      "id": "28626630",
                                      "name": "Extra Butter Roti",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "28626631",
                                      "name": "Extra Roti",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318832",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "2306 ratings",
                                  "ratingCountV2": "2306"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "42978080",
                              "name": "Kulcha Curry",
                              "category": "Combos ",
                              "description": "Kulcha + dal + curry + salad.",
                              "imageId": "qm9fprc0hyloqb8yzqk9",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "41318822",
                                  "groupName": "Extra Butter",
                                  "choices": [
                                    {
                                      "id": "28626629",
                                      "name": "Butter",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318823",
                                  "groupName": "Extra Roti",
                                  "choices": [
                                    {
                                      "id": "28626630",
                                      "name": "Extra Butter Roti",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "28626631",
                                      "name": "Extra Roti",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318825",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "1407 ratings",
                                  "ratingCountV2": "1407"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "42978079",
                              "name": "Naan Curry",
                              "category": "Combos ",
                              "description": "Naan + dal + curry + salad.",
                              "imageId": "iqjczuvbs9mxsbxdelws",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "41318837",
                                  "groupName": "Extra Butter",
                                  "choices": [
                                    {
                                      "id": "28626629",
                                      "name": "Butter",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318838",
                                  "groupName": "Extra Roti",
                                  "choices": [
                                    {
                                      "id": "28626630",
                                      "name": "Extra Butter Roti",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "28626631",
                                      "name": "Extra Roti",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318840",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "640 ratings",
                                  "ratingCountV2": "640"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "42978076",
                              "name": "South Indian Meal",
                              "category": "Meals ",
                              "description": "Steam rice+ Chapati(1pc)+ kurma+ palya+ rasam+ sambar or dal+ curd rice+ sweet+ papad",
                              "imageId": "uhommbdcbehesmzvghkg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "49878155",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318844",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "1584 ratings",
                                  "ratingCountV2": "1584"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "42978075",
                              "name": "North Indian Kulcha Meal",
                              "category": "Meals ",
                              "description": "Tomato soup + Kulcha + Dal + Curry + pulao + Curd rice + Sweet + Papad",
                              "imageId": "lsyl2rzxniq4emh6h2yk",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "41318846",
                                  "groupName": "Extra Butter",
                                  "choices": [
                                    {
                                      "id": "28626629",
                                      "name": "Butter",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "49881510",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318848",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "928 ratings",
                                  "ratingCountV2": "928"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "42978074",
                              "name": "North Indian Naan Meal",
                              "category": "Meals ",
                              "description": "Tomato soup + Naan + Dal + Curry + pulao + Curd rice + Sweet + Papad",
                              "imageId": "gtncz2l5at5svw2wvmu8",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "41318850",
                                  "groupName": "Extra Butter",
                                  "choices": [
                                    {
                                      "id": "28626629",
                                      "name": "Butter",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "49881512",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318851",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "372 ratings",
                                  "ratingCountV2": "372"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "42978073",
                              "name": "North Indian Roti Meal",
                              "category": "Meals ",
                              "description": "Tomato soup + Naan + Dal + Curry + pulao + Curd rice + Sweet + Papad",
                              "imageId": "nrcppaggbbdx4itsvxvj",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "41318853",
                                  "groupName": "Extra Butter",
                                  "choices": [
                                    {
                                      "id": "28626629",
                                      "name": "Butter",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "49881515",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318855",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "790 ratings",
                                  "ratingCountV2": "790"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "79020093",
                              "name": "Gobi Manchurian (dry)",
                              "category": "Starters ",
                              "description": "Served with tomato sauce(no artificial colours/ajinomoto/msg and its chemical free).",
                              "imageId": "cepid7iiux5mmvqa5lgm",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "41318876",
                                  "groupName": "Add On",
                                  "choices": [
                                    {
                                      "id": "28626634",
                                      "name": "Extra Tomato Ketchup",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "49878161",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318879",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "4565 ratings",
                                  "ratingCountV2": "4565"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "79020098",
                              "name": "Baby Corn Manchurian (dry)",
                              "category": "Starters ",
                              "description": "Served with tomato sauce(no artificial colours/ajinomoto/msg and its chemical free).",
                              "imageId": "nrvlfysm2ysnaxmwqrwt",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "41318881",
                                  "groupName": "Add On",
                                  "choices": [
                                    {
                                      "id": "28626634",
                                      "name": "Extra Tomato Ketchup",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "49878162",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318884",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "2048 ratings",
                                  "ratingCountV2": "2048"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "79020100",
                              "name": "Mushroom Manchurian (dry)",
                              "category": "Starters ",
                              "description": "Served with tomato sauce(no artificial colours/ajinomoto/msg and its chemical free).",
                              "imageId": "dfzkaxlydbd2zx3zwxa5",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "41318886",
                                  "groupName": "Add On",
                                  "choices": [
                                    {
                                      "id": "28626634",
                                      "name": "Extra Tomato Ketchup",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "49878163",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318888",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "1713 ratings",
                                  "ratingCountV2": "1713"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "79020104",
                              "name": "Paneer Manchurian (dry)",
                              "category": "Starters ",
                              "description": "Served with tomato sauce(no artificial colours/ajinomoto/msg and its chemical free).",
                              "imageId": "dyz1toyq79yjed3gxktr",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "41318891",
                                  "groupName": "Add On",
                                  "choices": [
                                    {
                                      "id": "28626634",
                                      "name": "Extra Tomato Ketchup",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "49878164",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318894",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "2536 ratings",
                                  "ratingCountV2": "2536"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "42978083",
                              "name": "Kulcha",
                              "category": "Breads ",
                              "imageId": "bqdrm3dt32fvqnp9o1a1",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "41318896",
                                  "groupName": "Extra Butter",
                                  "choices": [
                                    {
                                      "id": "28626629",
                                      "name": "Butter",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318897",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "345 ratings",
                                  "ratingCountV2": "345"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "50676854",
                              "name": "Roti (2 Pcs)",
                              "category": "Breads ",
                              "imageId": "glt9d62bq0qaplpwebaq",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "41318905",
                                  "groupName": "Extra Butter",
                                  "choices": [
                                    {
                                      "id": "28626629",
                                      "name": "Butter",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318906",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "464 ratings",
                                  "ratingCountV2": "464"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "42978082",
                              "name": "Naan",
                              "category": "Breads ",
                              "imageId": "njnsugcvjecwrthowqdl",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "41318901",
                                  "groupName": "Extra Butter",
                                  "choices": [
                                    {
                                      "id": "28626629",
                                      "name": "Butter",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318902",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "167 ratings",
                                  "ratingCountV2": "167"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "42978077",
                              "name": "Curd Rice",
                              "category": "Rice ",
                              "description": "Served with pickle only.",
                              "imageId": "seadeat5cs7wapexlydy",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "803 ratings",
                                  "ratingCountV2": "803"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "84883717",
                              "name": "Asha Special Biryani",
                              "category": "Veg Biryani",
                              "imageId": "xvkxcvhma8y31kn8iir2",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "13350566",
                                    "name": "Portion",
                                    "variations": [
                                      {
                                        "name": "Mini",
                                        "price": 109,
                                        "default": 1,
                                        "id": "43384853",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 149,
                                        "id": "43384854",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "13350566",
                                        "variationId": "43384853"
                                      }
                                    ],
                                    "price": 10900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "13350566",
                                        "variationId": "43384854"
                                      }
                                    ],
                                    "price": 14900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 10900,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "1007 ratings",
                                  "ratingCountV2": "1007"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "42978068",
                              "name": "Veg Fried Rice",
                              "category": "Fried Rice",
                              "description": "Served with tomato sauce(no artificial colours/ajinomoto/msg and its chemical free).",
                              "imageId": "csmshhiajkyysvkyj9zd",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "41318910",
                                  "groupName": "Add On",
                                  "choices": [
                                    {
                                      "id": "28626634",
                                      "name": "Extra Tomato Ketchup",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "49878166",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318915",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "2873 ratings",
                                  "ratingCountV2": "2873"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "42978069",
                              "name": "Schezwan Fried Rice",
                              "category": "Fried Rice",
                              "description": "Served with tomato sauce(no artificial colours/ajinomoto/msg and its chemical free).",
                              "imageId": "ocbivocwjzbhzdcjvqst",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "41318920",
                                  "groupName": "Add On",
                                  "choices": [
                                    {
                                      "id": "28626634",
                                      "name": "Extra Tomato Ketchup",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "49878167",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318924",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "1583 ratings",
                                  "ratingCountV2": "1583"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "type": "CATEGORY_TYPE_RECOMMENDED"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Breakfast  ",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "43305466",
                              "name": "Plain Dosa.",
                              "category": "Breakfast  ",
                              "description": "Served with chutney & sambar.",
                              "imageId": "bjfm55y7bhcglmye97m9",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "49878150",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318799",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318803",
                                  "groupName": "Extras",
                                  "choices": [
                                    {
                                      "id": "28626625",
                                      "name": "Extra Sambar (250 Ml)",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "28626626",
                                      "name": "Extra Sambar (450 Ml)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "28626627",
                                      "name": "Extra Coconut Chutney (250 Ml)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "28626628",
                                      "name": "Extra Coconut Chutney (450 Ml)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "5030 ratings",
                                  "ratingCountV2": "5030"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "43305467",
                              "name": "Masala Dosa",
                              "category": "Breakfast  ",
                              "description": "Served with chutney & sambar.",
                              "imageId": "apfjvcq6ccr01svoezji",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "49878151",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318805",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318808",
                                  "groupName": "Extras",
                                  "choices": [
                                    {
                                      "id": "28626625",
                                      "name": "Extra Sambar (250 Ml)",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "28626626",
                                      "name": "Extra Sambar (450 Ml)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "28626627",
                                      "name": "Extra Coconut Chutney (250 Ml)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "28626628",
                                      "name": "Extra Coconut Chutney (450 Ml)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "17717 ratings",
                                  "ratingCountV2": "17717"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "43305470",
                              "name": "Kesari Bath.",
                              "category": "Breakfast  ",
                              "imageId": "mgpuoj62zphcmsgwqztk",
                              "isVeg": 1,
                              "price": 3500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "49878145",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318767",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 7 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "2833 ratings",
                                  "ratingCountV2": "2833"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "64566318",
                              "name": "Special Mini Tiffin",
                              "category": "Breakfast  ",
                              "description": "Vada (2 pcs), pongal (250 grm), masala dosa.",
                              "imageId": "aoytbo4lo4ftcemuvvzr",
                              "isVeg": 1,
                              "price": 15900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "41318755",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "36926124",
                                      "name": "Extra Tiffin Sambar[250ml]",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110360334",
                                      "name": "Extra Coconut Chutney [250ml]",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "49878142",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318759",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 7 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "787 ratings",
                                  "ratingCountV2": "787"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "92151913",
                              "name": "Bisi Bele Bath",
                              "category": "Breakfast  ",
                              "description": "Served with boondi only.",
                              "imageId": "oisdlnma2wlb5xbw8mcj",
                              "isVeg": 1,
                              "price": 6900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "nextAvailableAtMessage": "Next available at 7 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "1099 ratings",
                                  "ratingCountV2": "1099"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "43305469",
                              "name": "Khara Bath",
                              "category": "Breakfast  ",
                              "description": "Served with chutney only.",
                              "imageId": "oqcixhqvihf7nbx0gvjx",
                              "isVeg": 1,
                              "price": 3500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "41318772",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "36926124",
                                      "name": "Extra Tiffin Sambar[250ml]",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110360334",
                                      "name": "Extra Coconut Chutney [250ml]",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "49878146",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318774",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 7 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "2225 ratings",
                                  "ratingCountV2": "2225"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "79020079",
                              "name": "Idli (2 Pcs)",
                              "category": "Breakfast  ",
                              "description": "Served with chutney & sambar.",
                              "imageId": "iyhixkvgcssweqmvesfk",
                              "isVeg": 1,
                              "price": 5500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "49878147",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318780",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318782",
                                  "groupName": "Extras",
                                  "choices": [
                                    {
                                      "id": "28626625",
                                      "name": "Extra Sambar (250 Ml)",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "28626626",
                                      "name": "Extra Sambar (450 Ml)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "28626627",
                                      "name": "Extra Coconut Chutney (250 Ml)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "28626628",
                                      "name": "Extra Coconut Chutney (450 Ml)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 7 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "6341 ratings",
                                  "ratingCountV2": "6341"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "79020080",
                              "name": "Vada (2 Pc)",
                              "category": "Breakfast  ",
                              "description": "Served with chutney & sambar.",
                              "imageId": "pznj9dxgd5fgyzwplwga",
                              "isVeg": 1,
                              "price": 5900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "49878148",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318787",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318788",
                                  "groupName": "Extras",
                                  "choices": [
                                    {
                                      "id": "28626625",
                                      "name": "Extra Sambar (250 Ml)",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "28626626",
                                      "name": "Extra Sambar (450 Ml)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "28626627",
                                      "name": "Extra Coconut Chutney (250 Ml)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "28626628",
                                      "name": "Extra Coconut Chutney (450 Ml)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 7 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "5205 ratings",
                                  "ratingCountV2": "5205"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "79020081",
                              "name": "Idli (2 Pcs) + Vada (1 Pc).",
                              "category": "Breakfast  ",
                              "description": "Served with chutney & sambar.",
                              "imageId": "bkjiru5omutvizz2jkhh",
                              "isVeg": 1,
                              "price": 8500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "49878149",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318793",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318794",
                                  "groupName": "Extras",
                                  "choices": [
                                    {
                                      "id": "28626625",
                                      "name": "Extra Sambar (250 Ml)",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "28626626",
                                      "name": "Extra Sambar (450 Ml)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "28626627",
                                      "name": "Extra Coconut Chutney (250 Ml)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "28626628",
                                      "name": "Extra Coconut Chutney (450 Ml)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 7 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "5858 ratings",
                                  "ratingCountV2": "5858"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "43305468",
                              "name": "Pongal",
                              "category": "Breakfast  ",
                              "description": "Served with chutney only.",
                              "imageId": "dnpugumscche9gdnbdhh",
                              "isVeg": 1,
                              "price": 6900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "41318811",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "36926124",
                                      "name": "Extra Tiffin Sambar[250ml]",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110360334",
                                      "name": "Extra Coconut Chutney [250ml]",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "49878152",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318813",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 7 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "1896 ratings",
                                  "ratingCountV2": "1896"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "50676841",
                              "name": "Chow Chow Bath",
                              "category": "Breakfast  ",
                              "description": "Served with chutney only.",
                              "imageId": "uwkfmryoucs4qzbec9hg",
                              "isVeg": 1,
                              "price": 6900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "41318817",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "36926124",
                                      "name": "Extra Tiffin Sambar[250ml]",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110360334",
                                      "name": "Extra Coconut Chutney [250ml]",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "49878153",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318820",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 7 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "1077 ratings",
                                  "ratingCountV2": "1077"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "51471962",
                              "name": "Mini Tiffin Combo",
                              "category": "Breakfast  ",
                              "description": "Single idly vada, masala dosa, chow chow bath served with chutney & sambar.",
                              "imageId": "ctcbreggcgzzn42hfk69",
                              "isVeg": 1,
                              "price": 18900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "49878143",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318762",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318764",
                                  "groupName": "Extras",
                                  "choices": [
                                    {
                                      "id": "28626625",
                                      "name": "Extra Sambar (250 Ml)",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "28626626",
                                      "name": "Extra Sambar (450 Ml)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "28626627",
                                      "name": "Extra Coconut Chutney (250 Ml)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "28626628",
                                      "name": "Extra Coconut Chutney (450 Ml)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 7 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "2974 ratings",
                                  "ratingCountV2": "2974"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Combos ",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "42978078",
                              "name": "Roti Curry",
                              "category": "Combos ",
                              "description": "Roti (2 pcs) + dal + curry + salad.",
                              "imageId": "jb2zc3lab0ziv9hb6svd",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "41318829",
                                  "groupName": "Extra Butter",
                                  "choices": [
                                    {
                                      "id": "28626629",
                                      "name": "Butter",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318830",
                                  "groupName": "Extra Roti",
                                  "choices": [
                                    {
                                      "id": "28626630",
                                      "name": "Extra Butter Roti",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "28626631",
                                      "name": "Extra Roti",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318832",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "2306 ratings",
                                  "ratingCountV2": "2306"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "42978080",
                              "name": "Kulcha Curry",
                              "category": "Combos ",
                              "description": "Kulcha + dal + curry + salad.",
                              "imageId": "qm9fprc0hyloqb8yzqk9",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "41318822",
                                  "groupName": "Extra Butter",
                                  "choices": [
                                    {
                                      "id": "28626629",
                                      "name": "Butter",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318823",
                                  "groupName": "Extra Roti",
                                  "choices": [
                                    {
                                      "id": "28626630",
                                      "name": "Extra Butter Roti",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "28626631",
                                      "name": "Extra Roti",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318825",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "1407 ratings",
                                  "ratingCountV2": "1407"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "42978079",
                              "name": "Naan Curry",
                              "category": "Combos ",
                              "description": "Naan + dal + curry + salad.",
                              "imageId": "iqjczuvbs9mxsbxdelws",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "41318837",
                                  "groupName": "Extra Butter",
                                  "choices": [
                                    {
                                      "id": "28626629",
                                      "name": "Butter",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318838",
                                  "groupName": "Extra Roti",
                                  "choices": [
                                    {
                                      "id": "28626630",
                                      "name": "Extra Butter Roti",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "28626631",
                                      "name": "Extra Roti",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318840",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "640 ratings",
                                  "ratingCountV2": "640"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Meals ",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "42978076",
                              "name": "South Indian Meal",
                              "category": "Meals ",
                              "description": "Steam rice+ Chapati(1pc)+ kurma+ palya+ rasam+ sambar or dal+ curd rice+ sweet+ papad",
                              "imageId": "uhommbdcbehesmzvghkg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "49878155",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318844",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "1584 ratings",
                                  "ratingCountV2": "1584"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "42978075",
                              "name": "North Indian Kulcha Meal",
                              "category": "Meals ",
                              "description": "Tomato soup + Kulcha + Dal + Curry + pulao + Curd rice + Sweet + Papad",
                              "imageId": "lsyl2rzxniq4emh6h2yk",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "41318846",
                                  "groupName": "Extra Butter",
                                  "choices": [
                                    {
                                      "id": "28626629",
                                      "name": "Butter",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "49881510",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318848",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "928 ratings",
                                  "ratingCountV2": "928"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "42978074",
                              "name": "North Indian Naan Meal",
                              "category": "Meals ",
                              "description": "Tomato soup + Naan + Dal + Curry + pulao + Curd rice + Sweet + Papad",
                              "imageId": "gtncz2l5at5svw2wvmu8",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "41318850",
                                  "groupName": "Extra Butter",
                                  "choices": [
                                    {
                                      "id": "28626629",
                                      "name": "Butter",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "49881512",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318851",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "372 ratings",
                                  "ratingCountV2": "372"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "42978073",
                              "name": "North Indian Roti Meal",
                              "category": "Meals ",
                              "description": "Tomato soup + Naan + Dal + Curry + pulao + Curd rice + Sweet + Papad",
                              "imageId": "nrcppaggbbdx4itsvxvj",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "41318853",
                                  "groupName": "Extra Butter",
                                  "choices": [
                                    {
                                      "id": "28626629",
                                      "name": "Butter",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "49881515",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318855",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "790 ratings",
                                  "ratingCountV2": "790"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Starters ",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "79020093",
                              "name": "Gobi Manchurian (dry)",
                              "category": "Starters ",
                              "description": "Served with tomato sauce(no artificial colours/ajinomoto/msg and its chemical free).",
                              "imageId": "cepid7iiux5mmvqa5lgm",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "41318876",
                                  "groupName": "Add On",
                                  "choices": [
                                    {
                                      "id": "28626634",
                                      "name": "Extra Tomato Ketchup",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "49878161",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318879",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "4565 ratings",
                                  "ratingCountV2": "4565"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "79020098",
                              "name": "Baby Corn Manchurian (dry)",
                              "category": "Starters ",
                              "description": "Served with tomato sauce(no artificial colours/ajinomoto/msg and its chemical free).",
                              "imageId": "nrvlfysm2ysnaxmwqrwt",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "41318881",
                                  "groupName": "Add On",
                                  "choices": [
                                    {
                                      "id": "28626634",
                                      "name": "Extra Tomato Ketchup",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "49878162",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318884",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "2048 ratings",
                                  "ratingCountV2": "2048"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "79020100",
                              "name": "Mushroom Manchurian (dry)",
                              "category": "Starters ",
                              "description": "Served with tomato sauce(no artificial colours/ajinomoto/msg and its chemical free).",
                              "imageId": "dfzkaxlydbd2zx3zwxa5",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "41318886",
                                  "groupName": "Add On",
                                  "choices": [
                                    {
                                      "id": "28626634",
                                      "name": "Extra Tomato Ketchup",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "49878163",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318888",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "1713 ratings",
                                  "ratingCountV2": "1713"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "79020104",
                              "name": "Paneer Manchurian (dry)",
                              "category": "Starters ",
                              "description": "Served with tomato sauce(no artificial colours/ajinomoto/msg and its chemical free).",
                              "imageId": "dyz1toyq79yjed3gxktr",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "41318891",
                                  "groupName": "Add On",
                                  "choices": [
                                    {
                                      "id": "28626634",
                                      "name": "Extra Tomato Ketchup",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "49878164",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318894",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "2536 ratings",
                                  "ratingCountV2": "2536"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Breads ",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "42978083",
                              "name": "Kulcha",
                              "category": "Breads ",
                              "imageId": "bqdrm3dt32fvqnp9o1a1",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "41318896",
                                  "groupName": "Extra Butter",
                                  "choices": [
                                    {
                                      "id": "28626629",
                                      "name": "Butter",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318897",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "345 ratings",
                                  "ratingCountV2": "345"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "50676854",
                              "name": "Roti (2 Pcs)",
                              "category": "Breads ",
                              "imageId": "glt9d62bq0qaplpwebaq",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "41318905",
                                  "groupName": "Extra Butter",
                                  "choices": [
                                    {
                                      "id": "28626629",
                                      "name": "Butter",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318906",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "464 ratings",
                                  "ratingCountV2": "464"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "42978082",
                              "name": "Naan",
                              "category": "Breads ",
                              "imageId": "njnsugcvjecwrthowqdl",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "41318901",
                                  "groupName": "Extra Butter",
                                  "choices": [
                                    {
                                      "id": "28626629",
                                      "name": "Butter",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318902",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "167 ratings",
                                  "ratingCountV2": "167"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Rice ",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "42978077",
                              "name": "Curd Rice",
                              "category": "Rice ",
                              "description": "Served with pickle only.",
                              "imageId": "seadeat5cs7wapexlydy",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "803 ratings",
                                  "ratingCountV2": "803"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Veg Biryani",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "84883717",
                              "name": "Asha Special Biryani",
                              "category": "Veg Biryani",
                              "imageId": "xvkxcvhma8y31kn8iir2",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "13350566",
                                    "name": "Portion",
                                    "variations": [
                                      {
                                        "name": "Mini",
                                        "price": 109,
                                        "default": 1,
                                        "id": "43384853",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 149,
                                        "id": "43384854",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "13350566",
                                        "variationId": "43384853"
                                      }
                                    ],
                                    "price": 10900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "13350566",
                                        "variationId": "43384854"
                                      }
                                    ],
                                    "price": 14900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 10900,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "1007 ratings",
                                  "ratingCountV2": "1007"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Fried Rice",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "42978068",
                              "name": "Veg Fried Rice",
                              "category": "Fried Rice",
                              "description": "Served with tomato sauce(no artificial colours/ajinomoto/msg and its chemical free).",
                              "imageId": "csmshhiajkyysvkyj9zd",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "41318910",
                                  "groupName": "Add On",
                                  "choices": [
                                    {
                                      "id": "28626634",
                                      "name": "Extra Tomato Ketchup",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "49878166",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318915",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "2873 ratings",
                                  "ratingCountV2": "2873"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "42978069",
                              "name": "Schezwan Fried Rice",
                              "category": "Fried Rice",
                              "description": "Served with tomato sauce(no artificial colours/ajinomoto/msg and its chemical free).",
                              "imageId": "ocbivocwjzbhzdcjvqst",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "41318920",
                                  "groupName": "Add On",
                                  "choices": [
                                    {
                                      "id": "28626634",
                                      "name": "Extra Tomato Ketchup",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "49878167",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318924",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "1583 ratings",
                                  "ratingCountV2": "1583"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "42978070",
                              "name": "Paneer Capsicum Fried Rice",
                              "category": "Fried Rice",
                              "description": "Served with tomato sauce(no artificial colours/ajinomoto/msg and its chemical free).",
                              "imageId": "r36ifgilmecbkxaogotj",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "41318931",
                                  "groupName": "Add On",
                                  "choices": [
                                    {
                                      "id": "28626634",
                                      "name": "Extra Tomato Ketchup",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "49878168",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318935",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "2161 ratings",
                                  "ratingCountV2": "2161"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Noodles ",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "50676857",
                              "name": "Chilli Garlic Noodles",
                              "category": "Noodles ",
                              "description": "Served with tomato sauce(no artificial colours/ajinomoto/msg and its chemical free).",
                              "imageId": "fzcj8s6extyuee6qkodx",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "41318940",
                                  "groupName": "Add On",
                                  "choices": [
                                    {
                                      "id": "28626634",
                                      "name": "Extra Tomato Ketchup",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "49878169",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318942",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "1729 ratings",
                                  "ratingCountV2": "1729"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58506816",
                              "name": "Paneer Capsicum Noodles",
                              "category": "Noodles ",
                              "description": "Served with tomato sauce (no artificial colours/ ajinomoto/ msg and its chemical free).",
                              "imageId": "cd526f94b6125241e24295dc252af804",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "41318946",
                                  "groupName": "Add On",
                                  "choices": [
                                    {
                                      "id": "28626634",
                                      "name": "Extra Tomato Ketchup",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "49878170",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318949",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "446 ratings",
                                  "ratingCountV2": "446"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "42978071",
                              "name": "Veg Noodles",
                              "category": "Noodles ",
                              "description": "Served with tomato sauce(no artificial colours/ajinomoto/msg and its chemical free).",
                              "imageId": "afnngzm0n673bm3dal4v",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "41318953",
                                  "groupName": "Add On",
                                  "choices": [
                                    {
                                      "id": "28626634",
                                      "name": "Extra Tomato Ketchup",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "49878171",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318956",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "1760 ratings",
                                  "ratingCountV2": "1760"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Dessert ",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "111781006",
                              "name": "Fruit Salad",
                              "category": "Dessert ",
                              "imageId": "96b3dd61f1f798a7b8c92471c7cbef47",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "506 ratings",
                                  "ratingCountV2": "506"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58056459",
                              "name": "Gulab Jamun (2 Pcs)",
                              "category": "Dessert ",
                              "imageId": "wyqtg4es6o921j2l5fbp",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "41319027",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "1844 ratings",
                                  "ratingCountV2": "1844"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Cold Beverages ",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "79020197",
                              "name": "Buttermilk (300ml)",
                              "category": "Cold Beverages ",
                              "imageId": "y0qdmmkm7luqdzdrpk77",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 3900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "49881559",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "961 ratings",
                                  "ratingCountV2": "961"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "79020198",
                              "name": "Pulpy Grape (300ml)",
                              "category": "Cold Beverages ",
                              "imageId": "hx5bfgu2l5f3u449ryx7",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "49881560",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "647 ratings",
                                  "ratingCountV2": "647"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "79020199",
                              "name": "Sweet Lassi (300ml)",
                              "category": "Cold Beverages ",
                              "imageId": "abpgrrkutrilyvd2hsow",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "49881561",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "291 ratings",
                                  "ratingCountV2": "291"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "79020200",
                              "name": "Cold Badam Milk (300ml)",
                              "category": "Cold Beverages ",
                              "imageId": "xgookbtqee1jqdbvdv1g",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "49881562",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "529 ratings",
                                  "ratingCountV2": "529"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Extras",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "79020204",
                              "name": "Extra Coconut Chutney",
                              "category": "Extras",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "12187692",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "250ml",
                                        "price": 59,
                                        "default": 1,
                                        "id": "39848861",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "450ml",
                                        "price": 99,
                                        "id": "39848862",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "12187692",
                                        "variationId": "39848861"
                                      }
                                    ],
                                    "price": 5900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "12187692",
                                        "variationId": "39848862"
                                      }
                                    ],
                                    "price": 9900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 5900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "151 ratings",
                                  "ratingCountV2": "151"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "79020205",
                              "name": "Extra Tiffin Sambar",
                              "category": "Extras",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "12187696",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "250ml",
                                        "price": 45,
                                        "default": 1,
                                        "id": "39848870",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "450ml",
                                        "price": 69,
                                        "id": "39848871",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "12187696",
                                        "variationId": "39848870"
                                      }
                                    ],
                                    "price": 4500
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "12187696",
                                        "variationId": "39848871"
                                      }
                                    ],
                                    "price": 6900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 4500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "225 ratings",
                                  "ratingCountV2": "225"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "South Indian",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "79020131",
                              "name": "Idli (2 Pcs) + Vada (1 Pc)",
                              "category": "South Indian",
                              "description": "Served with chutney and sambar.",
                              "imageId": "ejorze1mgstdusrnvczx",
                              "isVeg": 1,
                              "price": 8500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "49878172",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318962",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318964",
                                  "groupName": "Extras",
                                  "choices": [
                                    {
                                      "id": "28626625",
                                      "name": "Extra Sambar (250 Ml)",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "28626626",
                                      "name": "Extra Sambar (450 Ml)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "28626627",
                                      "name": "Extra Coconut Chutney (250 Ml)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "28626628",
                                      "name": "Extra Coconut Chutney (450 Ml)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 4 pm, today",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "5858 ratings",
                                  "ratingCountV2": "5858"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "79020137",
                              "name": "Idli (2 Pcs).",
                              "category": "South Indian",
                              "description": "Served with chutney and sambar.",
                              "imageId": "ho4aoyvabttu7jfes3r1",
                              "isVeg": 1,
                              "price": 5500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "49878173",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318968",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318971",
                                  "groupName": "Extras",
                                  "choices": [
                                    {
                                      "id": "28626625",
                                      "name": "Extra Sambar (250 Ml)",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "28626626",
                                      "name": "Extra Sambar (450 Ml)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "28626627",
                                      "name": "Extra Coconut Chutney (250 Ml)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "28626628",
                                      "name": "Extra Coconut Chutney (450 Ml)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 4 pm, today",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "6341 ratings",
                                  "ratingCountV2": "6341"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "79020139",
                              "name": "Vada (2 Pcs)",
                              "category": "South Indian",
                              "description": "Served with chutney and sambar.",
                              "imageId": "u963ojjhtvnpvlmkjnnd",
                              "isVeg": 1,
                              "price": 5900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "49878175",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318974",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318977",
                                  "groupName": "Extras",
                                  "choices": [
                                    {
                                      "id": "28626625",
                                      "name": "Extra Sambar (250 Ml)",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "28626626",
                                      "name": "Extra Sambar (450 Ml)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "28626627",
                                      "name": "Extra Coconut Chutney (250 Ml)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "28626628",
                                      "name": "Extra Coconut Chutney (450 Ml)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 4 pm, today",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "1023 ratings",
                                  "ratingCountV2": "1023"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "79020151",
                              "name": "Chow Chow Bath.",
                              "category": "South Indian",
                              "description": "Served with chutney only.",
                              "imageId": "gj5fs6wx9y5ulyvnlvxk",
                              "isVeg": 1,
                              "price": 6900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "41318980",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "36926124",
                                      "name": "Extra Tiffin Sambar[250ml]",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110360334",
                                      "name": "Extra Coconut Chutney [250ml]",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "49878176",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318984",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 4 pm, today",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "1077 ratings",
                                  "ratingCountV2": "1077"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "79020160",
                              "name": "Khara Bath.",
                              "category": "South Indian",
                              "description": "Served with chutney only.",
                              "imageId": "dxd9uqgmjqdyprdrpwcu",
                              "isVeg": 1,
                              "price": 3500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "41318992",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "36926124",
                                      "name": "Extra Tiffin Sambar[250ml]",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110360334",
                                      "name": "Extra Coconut Chutney [250ml]",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "49878178",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318995",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 4 pm, today",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "2225 ratings",
                                  "ratingCountV2": "2225"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "79020161",
                              "name": "Masala Dosa.",
                              "category": "South Indian",
                              "description": "Served with chutney and sambar.",
                              "imageId": "asxt2puvdey0rzjirhrt",
                              "isVeg": 1,
                              "price": 6500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "49878179",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41318999",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41319003",
                                  "groupName": "Extras",
                                  "choices": [
                                    {
                                      "id": "28626625",
                                      "name": "Extra Sambar (250 Ml)",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "28626626",
                                      "name": "Extra Sambar (450 Ml)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "28626627",
                                      "name": "Extra Coconut Chutney (250 Ml)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "28626628",
                                      "name": "Extra Coconut Chutney (450 Ml)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 4 pm, today",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "17717 ratings",
                                  "ratingCountV2": "17717"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "79020165",
                              "name": "Mini Tiffin Combo.",
                              "category": "South Indian",
                              "description": "Single idly vada, masala dosa, chow chow bath served with chutney & sambar.",
                              "imageId": "ou1qhagiwdfdhf80do40",
                              "isVeg": 1,
                              "price": 18900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "49878180",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41319006",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "44660261",
                                  "groupName": "Extras",
                                  "choices": [
                                    {
                                      "id": "28626625",
                                      "name": "Extra Sambar (250 Ml)",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "28626626",
                                      "name": "Extra Sambar (450 Ml)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "28626627",
                                      "name": "Extra Coconut Chutney (250 Ml)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "28626628",
                                      "name": "Extra Coconut Chutney (450 Ml)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 4 pm, today",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "2974 ratings",
                                  "ratingCountV2": "2974"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "79020170",
                              "name": "Plain Dosa",
                              "category": "South Indian",
                              "description": "Served with chutney and sambar.",
                              "imageId": "h1llqfq7tnfsq21eap6c",
                              "isVeg": 1,
                              "price": 6500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "49878181",
                                  "groupName": "Dessert",
                                  "choices": [
                                    {
                                      "id": "53771781",
                                      "name": "Gulab Juman (2pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41319009",
                                  "groupName": "Cold Beverages",
                                  "choices": [
                                    {
                                      "id": "68068822",
                                      "name": "Pulpy Grape",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497500",
                                      "name": "Sweet Lassi",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497502",
                                      "name": "Butter Milk",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "41497503",
                                      "name": "Cold Badam Milk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "41319012",
                                  "groupName": "Extras",
                                  "choices": [
                                    {
                                      "id": "28626625",
                                      "name": "Extra Sambar (250 Ml)",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "28626626",
                                      "name": "Extra Sambar (450 Ml)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "28626627",
                                      "name": "Extra Coconut Chutney (250 Ml)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "28626628",
                                      "name": "Extra Coconut Chutney (450 Ml)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 4 pm, today",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "5030 ratings",
                                  "ratingCountV2": "5030"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                      "type": "FSSAI",
                      "imageId": "fssai_final_edss9i",
                      "text": [
                        "License No. 11218334001444"
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                      "name": "Asha tiffins",
                      "area": "Hsr Layout",
                      "completeAddress": "Asha Tiffins, 5th Main Road, Sector 7, HSR Layout, Bengaluru, Karnataka, India"
                    }
                  }
                }
              ]
            }
          }
        }
      }
    ],
    "firstOffsetRequest": true,
    "isQCLink": false
  },
  "tid": "8091b6c9-34ec-4881-8b5e-d2b6a4328fa1",
  "sid": "c8b69dc8-6710-47a7-bc63-18091856e3fa",
  "deviceId": "c73fa13e-69cf-472b-8071-076091f9d98d",
  "csrfToken": "iJHxzc4JoLOq-uNv0RVbq4PcHHHO-8w7Il9sAYLo"
}

export const MUMBAI_TIFFIN=
{
  "statusCode": 0,
  "data": {
    "statusMessage": "done successfully",
    "cards": [
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
            "info": {
              "id": "171768",
              "name": "Mumbai Tiffin",
              "city": "Bangalore",
              "slugs": {
                "restaurant": "mumbai-tiffin-room-sector-5-hsr",
                "city": "bangalore"
              },
              "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
              "cloudinaryImageId": "h58dwaoafbqj0ax5h26b",
              "locality": "HSR Layout",
              "areaName": "HSR Layout",
              "costForTwo": "40000",
              "costForTwoMessage": "₹400 for two",
              "cuisines": [
                "Home Food",
                "Thalis"
              ],
              "avgRating": 4.6,
              "veg": true,
              "feeDetails": {
                "restaurantId": "171768",
                "fees": [
                  {
                    "name": "distance",
                    "fee": 3200
                  },
                  {
                    "name": "time"
                  },
                  {
                    "name": "special"
                  }
                ],
                "totalFee": 3200,
                "icon": "v1648635511/Delivery_fee_new_cjxumu",
                "message": "1.3 kms | ₹32 Delivery fee will apply"
              },
              "parentId": "13235",
              "avgRatingString": "4.6",
              "totalRatingsString": "10K+ ratings",
              "sla": {
                "restaurantId": "171768",
                "deliveryTime": 21,
                "minDeliveryTime": 20,
                "maxDeliveryTime": 25,
                "lastMileTravel": 1.4,
                "serviceability": "SERVICEABLE",
                "stressFactor": 1,
                "rainMode": "RAIN_MODE_NONE",
                "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
                "zoneId": 3,
                "slaString": "20-25 MINS",
                "lastMileTravelString": "1.3 km",
                "iconType": "ICON_TYPE_EMPTY"
              },
              "availability": {
                "nextCloseTime": "2024-02-18 16:00:00",
                "visibility": true,
                "opened": true,
                "restaurantClosedMeta": {
                  
                }
              },
              "aggregatedDiscountInfo": {
                "shortDescriptionList": [
                  {
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "Flat ₹100 off | Above ₹550",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "15% off upto ₹300 | Use CITIFOODIE Above ₹1200",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "visible": true
              },
              "badges": {
                
              },
              "slugString": "mumbai-tiffin-room-sector-5-hsr",
              "isOpen": true,
              "labels": [
                {
                  "title": "Timings",
                  "message": "null"
                },
                {
                  "title": "Address",
                  "message": "5, 6, 7, M. Krishnappa Layout, Mangammanapalya Main Road, Sector 7, HSR Layout, Bangalore"
                },
                {
                  "title": "Cuisines",
                  "message": "Home Food,Thalis"
                }
              ],
              "totalRatings": 10000,
              "aggregatedDiscountInfoV2": {
                "shortDescriptionList": [
                  {
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "Flat ₹100 off | Above ₹550",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "15% off upto ₹300 | Use CITIFOODIE Above ₹1200",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "couponDetailsCta": "View coupon details"
              },
              "type": "F",
              "headerBanner": {
                "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/171768"
              },
              "expectationNotifiers": [
                {
                  "text": "1.3 kms | ₹32 Delivery fee will apply",
                  "icon": {
                    "imageId": "v1648635511/Delivery_fee_new_cjxumu"
                  },
                  "popup": {
                    "cta": {
                      
                    }
                  },
                  "type": "DISTANCE_FEE_NON_FOOD_LM",
                  "enrichedText": "<b>1.3 kms</b> | ₹32 Delivery fee will apply",
                  "halfCardPopup": {
                    "halfCardPopupHeader": {
                      
                    }
                  }
                }
              ],
              "ratingSlab": "RATING_SLAB_5",
              "orderabilityCommunication": {
                "title": {
                  
                },
                "subTitle": {
                  
                },
                "message": {
                  
                },
                "customIcon": {
                  
                }
              },
              "hasBestsellerItems": true,
              "cartOrderabilityNudgeBanner": {
                "parameters": {
                  
                },
                "presentation": {
                  
                }
              },
              "latLong": "12.906453514419589,77.63731760936615",
              "backgroundImageOverlayInfo": {
                
              }
            },
            "analytics": {
              
            }
          },
          "relevance": {
            "type": "RELEVANCE_TYPE_CHECK_ORDERABILITY_ON_ITEM_ADD",
            "sectionId": "POP_UP_CROUTON_MENU"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "layout": {
              "rows": 1,
              "columns": 5,
              "horizontalScrollEnabled": true,
              "itemSpacing": 12,
              "lineSpacing": 10,
              "widgetPadding": {
                
              },
              "containerStyle": {
                "containerPadding": {
                  "left": 10,
                  "right": 10,
                  "bottom": 16
                }
              },
              "scrollBar": {
                
              }
            },
            "id": "offerCollectionWidget_UX4",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                "offers": [
                  {
                    "info": {
                      "header": "FLAT ₹100 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "MARKETING_BANNERS/IMAGES/OFFERS/2024/2/17/1ed4245d-31e3-4dc6-b949-524a33b9b8c9_ICICI.png",
                      "offerIds": [
                        "299f5c31-dd4a-47a4-8d93-4ccb6be1a8a8"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "NO CODE REQUIRED",
                      "description": "ABOVE ₹550",
                      "offerType": "offers",
                      "restId": "171768",
                      "offerLogo": "MARKETING_BANNERS/IMAGES/OFFERS/2024/2/17/1ed4245d-31e3-4dc6-b949-524a33b9b8c9_ICICI.png",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹50 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "MARKETING_BANNERS/IMAGES/OFFERS/2024/2/16/d2280c74-96d1-4a1d-afd6-4270a05b5488_ICICI.png",
                      "offerIds": [
                        "72b12a41-597c-4c87-a813-32c46574fde9"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "NO CODE REQUIRED",
                      "description": "ABOVE ₹500",
                      "offerType": "offers",
                      "restId": "171768",
                      "offerLogo": "MARKETING_BANNERS/IMAGES/OFFERS/2024/2/16/d2280c74-96d1-4a1d-afd6-4270a05b5488_ICICI.png",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "15% OFF UPTO ₹300",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/15fb1cfe885005447dc8375e7970600f",
                      "offerIds": [
                        "c313f07b-4a9c-451e-ab52-586759f42642"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE CITIFOODIE",
                      "description": "ABOVE ₹1200",
                      "offerType": "offers",
                      "restId": "171768",
                      "offerLogo": "rng/md/ads/production/15fb1cfe885005447dc8375e7970600f",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹30 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/7f31c9e47ddd7e6a3c16d21553c0ca60",
                      "offerIds": [
                        "269c382d-796f-45cd-bd15-0b8b891c5e0c"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE SIMPL30",
                      "description": "ABOVE ₹300",
                      "offerType": "offers",
                      "restId": "171768",
                      "offerLogo": "rng/md/ads/production/7f31c9e47ddd7e6a3c16d21553c0ca60",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹150 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/59ef5e58052532ad85a185bf516eccce",
                      "offerIds": [
                        "6265534b-c8b7-4494-a469-116273548dd2"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE AMEX150",
                      "description": "ABOVE ₹600",
                      "offerType": "offers",
                      "restId": "171768",
                      "offerLogo": "rng/md/ads/production/59ef5e58052532ad85a185bf516eccce",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  }
                ],
                "habitMilestoneInfo": {
                  "callout": {
                    
                  }
                },
                "loyaltyDiscoverPresentationInfo": {
                  "logoCtx": {
                    
                  }
                }
              }
            }
          }
        }
      },
      {
        "groupedCard": {
          "cardGroupMap": {
            "REGULAR": {
              "cards": [
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                      "isPureVeg": true,
                      "badges": {
                        
                      },
                      "vegOnlyDetails": {
                        "imageId": "AutoVegOnly_qkjowj",
                        "title": "Showing only vegetarian options.",
                        "description": "Tap on the VEG ONLY button to turn off the setting"
                      },
                      "topRatedFilter": {
                        
                      },
                      "kidsCategoryFilter": {
                        "attributes": {
                          "displayText": "Kids Favourites",
                          "tooltip": {
                            "enabled": true,
                            "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                          }
                        }
                      },
                      "vegFilter": {
                        "attributes": {
                          "displayText": "VEG"
                        }
                      },
                      "nonvegFilter": {
                        "attributes": {
                          "displayText": "NONVEG"
                        }
                      }
                    },
                    "relevance": {
                      "type": "RELEVANCE_TYPE_ON_MENU_FILTER_TOGGLED",
                      "sectionId": "MENU_FILTER_TOGGLE"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Recommended",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012274",
                              "name": "Puri Bhaji",
                              "category": "Breakfast",
                              "description": "Serves 1 | 4 puri with 1 bhaji gravy and salad. Daily changing bhaji like chana, rajma, lobia, dal-makhni, aloo-mutter etc. (as per availability and not as per choice). Prepared in bulk, can't be customized. Picture shown is for illustration purpose only. Jain food not available.",
                              "imageId": "uc6zqw75bwdtted4b9cc",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "19355148",
                                  "groupName": "Add-ons",
                                  "choices": [
                                    {
                                      "id": "11498885",
                                      "name": "Extra 1 Puri ",
                                      "price": 2800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110927833",
                                      "name": "Extra Bhaji Gravy",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ]
                                },
                                {
                                  "groupId": "103636190",
                                  "groupName": "Choice of Accompaniment",
                                  "choices": [
                                    {
                                      "id": "15770730",
                                      "name": "Green Chutney - Half            ",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770731",
                                      "name": "Pickle Chotu Pack",
                                      "price": 300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770732",
                                      "name": "Butter",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "12279544",
                                      "name": "Extra Curd",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770733",
                                      "name": "Tomato Sauce 2 Pouch",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "1403 ratings",
                                  "ratingCountV2": "1403"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "95711794",
                              "name": "Roti Curry",
                              "category": "Classic Meal Combos",
                              "description": "Serves 1 | 4 tava roti, 1 sabji, 1 dal, salad. Daily changing menu like mix veg, gobhi aloo, veg kofte, bhindi do pyaza, baingan masala, kadi pakoda, besan gatte, mashroom mutter, soya aloo, lauki chana, palak aloo, methi aloo, aloo tamatar etc.  (as per availability and not as per choice). Prepared in bulk, can't be customized. Jain food not available.",
                              "imageId": "j1te9bba8lljoxqr6hjq",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15200,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "54563498",
                                  "groupName": "Addons",
                                  "choices": [
                                    {
                                      "id": "22136999",
                                      "name": "Extra Rice",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "103643354",
                                  "groupName": "Choice of Bread",
                                  "choices": [
                                    {
                                      "id": "15770729",
                                      "name": "Ghee (on Phulka)",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "103643352",
                                  "groupName": "Choice of Accompaniment",
                                  "choices": [
                                    {
                                      "id": "15770730",
                                      "name": "Green Chutney - Half            ",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770731",
                                      "name": "Pickle Chotu Pack",
                                      "price": 300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770732",
                                      "name": "Butter",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "12279544",
                                      "name": "Extra Curd",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770733",
                                      "name": "Tomato Sauce 2 Pouch",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "302 ratings",
                                  "ratingCountV2": "302"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "95711793",
                              "name": "Dal Subji Rice Meal",
                              "category": "Classic Meal Combos",
                              "description": "Serves 1 | Rice, 1 sabji, 1 dal, salad. Daily changing menu like mix veg, gobhi aloo, veg kofte, bhindi do pyaza, baingan masala, kadi pakoda, besan gatte, mashroom mutter, soya aloo, lauki chana, palak aloo, methi aloo, aloo tamatar etc.  (as per availability and not as per choice). Prepared in bulk, can't be customized. Jain food not available.",
                              "imageId": "geebhtkd9knqz61ll3i1",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "103643346",
                                  "groupName": "Choice of Accompaniment",
                                  "choices": [
                                    {
                                      "id": "15770730",
                                      "name": "Green Chutney - Half            ",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770731",
                                      "name": "Pickle Chotu Pack",
                                      "price": 300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770732",
                                      "name": "Butter",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "12279544",
                                      "name": "Extra Curd",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770733",
                                      "name": "Tomato Sauce 2 Pouch",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "441 ratings",
                                  "ratingCountV2": "441"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012295",
                              "name": "Premium Tawa Paratha Thali with Rice ",
                              "category": "Classic Meal Combos",
                              "description": "2 plain paratha, 1 paneer veg, 1 veg, dal, rice, curd, salad. Daily changing menu like mix veg, gobhi aloo, veg kofte, bhindi do pyaza, baingan masala, kadi pakoda, mashroom mutter, soya aloo, lauki chana, palak aloo, methi aloo, aloo tamatar / butter paneer, shahi paneer, kadai paneer or palak paneer etc. (as per availability and not as per choice). Prepared in bulk, can't be customized.",
                              "imageId": "cqlkuwxliitarajyl9uz",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 27600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "19355143",
                                  "groupName": "Addons",
                                  "choices": [
                                    {
                                      "id": "11636088",
                                      "name": "Extra Plain Paratha",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "103643365",
                                  "groupName": "Choice of Accompaniment",
                                  "choices": [
                                    {
                                      "id": "15770730",
                                      "name": "Green Chutney - Half            ",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770731",
                                      "name": "Pickle Chotu Pack",
                                      "price": 300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770732",
                                      "name": "Butter",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "12279544",
                                      "name": "Extra Curd",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770733",
                                      "name": "Tomato Sauce 2 Pouch",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "347 ratings",
                                  "ratingCountV2": "347"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012297",
                              "name": "Premium Methi Paratha Thali with Rice ",
                              "category": "Classic Meal Combos",
                              "description": "2 methi paratha, 1 paneer veg, 1 veg, dal, rice, curd, salad. Daily changing menu like mix veg, gobhi aloo, veg kofte, bhindi do pyaza, baingan masala, kadi pakoda, mashroom mutter, soya aloo, lauki chana, palak aloo, methi aloo, aloo tamatar / butter paneer, shahi paneer, kadai paneer or palak paneer etc. (as per availability and not as per choice). Prepared in bulk, can't be customized.",
                              "imageId": "nqjg22ztiaxjdfhmrbtt",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 27600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "19355145",
                                  "groupName": "Addons",
                                  "choices": [
                                    {
                                      "id": "11636089",
                                      "name": "Extra Methi Paratha ",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "103643893",
                                  "groupName": "Choice of Accompaniment",
                                  "choices": [
                                    {
                                      "id": "15770730",
                                      "name": "Green Chutney - Half            ",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770731",
                                      "name": "Pickle Chotu Pack",
                                      "price": 300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770732",
                                      "name": "Butter",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770733",
                                      "name": "Tomato Sauce 2 Pouch",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "499 ratings",
                                  "ratingCountV2": "499"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012278",
                              "name": "Aloo Paratha",
                              "category": "Stuffed Paratha",
                              "description": "Serves 1 | 1 big size stuffed paratha with curd and bhaji. Prepared in bulk, can't be customized. Picture shown is for illustration purpose only",
                              "imageId": "u5w966bcnmm7ykddf5q5",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15700,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "103634987",
                                  "groupName": "Choice of Accompaniment",
                                  "choices": [
                                    {
                                      "id": "15770730",
                                      "name": "Green Chutney - Half            ",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770731",
                                      "name": "Pickle Chotu Pack",
                                      "price": 300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770732",
                                      "name": "Butter",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770733",
                                      "name": "Tomato Sauce 2 Pouch",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "3654 ratings",
                                  "ratingCountV2": "3654"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012285",
                              "name": "Aloo Onion Paratha",
                              "category": "Stuffed Paratha",
                              "description": "Serves 1 | 1 big size stuffed paratha with curd and bhaji. Prepared in bulk, can't be customized. Picture shown is for illustration purpose only",
                              "imageId": "paryce88sa26bsvqqgtj",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "103637733",
                                  "groupName": "Choice of Accompaniment",
                                  "choices": [
                                    {
                                      "id": "15770730",
                                      "name": "Green Chutney - Half            ",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770731",
                                      "name": "Pickle Chotu Pack",
                                      "price": 300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770732",
                                      "name": "Butter",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770733",
                                      "name": "Tomato Sauce 2 Pouch",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "2827 ratings",
                                  "ratingCountV2": "2827"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012281",
                              "name": "Paneer Paratha",
                              "category": "Stuffed Paratha",
                              "description": "Serves 1 | 1 big size stuffed paratha with curd and bhaji. Prepared in bulk, can't be customized. Picture shown is for illustration purpose only",
                              "imageId": "nezemesnk23n14v3dsc4",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "103637701",
                                  "groupName": "Choice of Accompaniment",
                                  "choices": [
                                    {
                                      "id": "15770730",
                                      "name": "Green Chutney - Half            ",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770731",
                                      "name": "Pickle Chotu Pack",
                                      "price": 300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770732",
                                      "name": "Butter",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770733",
                                      "name": "Tomato Sauce 2 Pouch",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "2571 ratings",
                                  "ratingCountV2": "2571"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012289",
                              "name": "Onion Paneer Paratha",
                              "category": "Stuffed Paratha",
                              "description": "1 big size stuffed paratha with curd and bhaji. Prepared in bulk, can't be customized. Picture shown is for illustration purpose only.(serves 1).",
                              "imageId": "z2nudtnwdgvfjo8jpfkd",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "103634955",
                                  "groupName": "Choice of Accompaniment",
                                  "choices": [
                                    {
                                      "id": "15770730",
                                      "name": "Green Chutney - Half            ",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770731",
                                      "name": "Pickle Chotu Pack",
                                      "price": 300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770732",
                                      "name": "Butter",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770733",
                                      "name": "Tomato Sauce 2 Pouch",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "792 ratings",
                                  "ratingCountV2": "792"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012279",
                              "name": "Gobi Paratha",
                              "category": "Stuffed Paratha",
                              "description": "1 big size stuffed paratha with curd and bhaji. Prepared in bulk, can't be customized. Picture shown is for illustration purpose only.(serves 1).",
                              "imageId": "e0fzae1tjlx7gxvxn5ij",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "103634980",
                                  "groupName": "Choice of Accompaniment",
                                  "choices": [
                                    {
                                      "id": "15770730",
                                      "name": "Green Chutney - Half            ",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770731",
                                      "name": "Pickle Chotu Pack",
                                      "price": 300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770732",
                                      "name": "Butter",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770733",
                                      "name": "Tomato Sauce 2 Pouch",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "1387 ratings",
                                  "ratingCountV2": "1387"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012290",
                              "name": "Gobi Paneer Paratha",
                              "category": "Stuffed Paratha",
                              "description": "1 big size stuffed paratha with curd and bhaji. Prepared in bulk, can't be customized. Picture shown is for illustration purpose only.(serves 1).",
                              "imageId": "s6kzgxtvph7b2pbcafum",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "103634946",
                                  "groupName": "Choice of Accompaniment",
                                  "choices": [
                                    {
                                      "id": "15770730",
                                      "name": "Green Chutney - Half            ",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770731",
                                      "name": "Pickle Chotu Pack",
                                      "price": 300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770732",
                                      "name": "Butter",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770733",
                                      "name": "Tomato Sauce 2 Pouch",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "175 ratings",
                                  "ratingCountV2": "175"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012286",
                              "name": "Aloo Gobi Paratha",
                              "category": "Stuffed Paratha",
                              "description": "1 big size stuffed paratha with curd and bhaji. Prepared in bulk, can't be customized. Picture shown is for illustration purpose only.(serves 1).",
                              "imageId": "cxc4am3ha9m9lyhd0coh",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "103637726",
                                  "groupName": "Choice of Accompaniment",
                                  "choices": [
                                    {
                                      "id": "15770730",
                                      "name": "Green Chutney - Half            ",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770731",
                                      "name": "Pickle Chotu Pack",
                                      "price": 300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770732",
                                      "name": "Butter",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770733",
                                      "name": "Tomato Sauce 2 Pouch",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "633 ratings",
                                  "ratingCountV2": "633"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012288",
                              "name": "Aloo Paneer Paratha",
                              "category": "Stuffed Paratha",
                              "description": "Serves 1 | 1 big size stuffed paratha with curd and bhaji. Prepared in bulk, can't be customized. Picture shown is for illustration purpose only",
                              "imageId": "sq7d8y8x55cdgfbfnfkr",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "103634971",
                                  "groupName": "Choice of Accompaniment",
                                  "choices": [
                                    {
                                      "id": "15770730",
                                      "name": "Green Chutney - Half            ",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770731",
                                      "name": "Pickle Chotu Pack",
                                      "price": 300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770732",
                                      "name": "Butter",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770733",
                                      "name": "Tomato Sauce 2 Pouch",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "383 ratings",
                                  "ratingCountV2": "383"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012283",
                              "name": "Methi Aloo Paratha",
                              "category": "Stuffed Paratha",
                              "description": "Serves 1 | 1 big size stuffed paratha with curd and bhaji. Prepared in bulk, can't be customized. Picture shown is for illustration purpose only",
                              "imageId": "z4laaccoovnkwjnhg4je",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "103637665",
                                  "groupName": "Choice of Accompaniment",
                                  "choices": [
                                    {
                                      "id": "15770730",
                                      "name": "Green Chutney - Half            ",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770731",
                                      "name": "Pickle Chotu Pack",
                                      "price": 300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770732",
                                      "name": "Butter",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770733",
                                      "name": "Tomato Sauce 2 Pouch",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "709 ratings",
                                  "ratingCountV2": "709"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012284",
                              "name": "Methi Paneer Paratha",
                              "category": "Stuffed Paratha",
                              "description": "1 big size stuffed paratha with curd and bhaji. Prepared in bulk, can't be customized. Picture shown is for illustration purpose only.(serves 1).",
                              "imageId": "sqauvh7h0wsd6b0b8dsa",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "103637738",
                                  "groupName": "Choice of Accompaniment",
                                  "choices": [
                                    {
                                      "id": "15770730",
                                      "name": "Green Chutney - Half            ",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770731",
                                      "name": "Pickle Chotu Pack",
                                      "price": 300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770732",
                                      "name": "Butter",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770733",
                                      "name": "Tomato Sauce 2 Pouch",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "462 ratings",
                                  "ratingCountV2": "462"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012312",
                              "name": "Butter",
                              "category": "Sides",
                              "description": "Cube blister",
                              "imageId": "nkuknwltggaokiylyky6",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "95 ratings",
                                  "ratingCountV2": "95"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012313",
                              "name": "Green Salad",
                              "category": "Sides",
                              "description": "Cucumber, carrot, radish, tomato, onion, lemon, green chilli.",
                              "imageId": "embqrks4wqhwmlkjuvzm",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "525 ratings",
                                  "ratingCountV2": "525"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012315",
                              "name": "Butter Milk",
                              "category": "Beverages",
                              "description": "Masala chhas. Prepared in bulk, can't be customized. Picture shown is for illustration purpose only",
                              "imageId": "y0qwazat8cr2tyksrbhq",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "1030 ratings",
                                  "ratingCountV2": "1030"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012316",
                              "name": "Sweet Lassi",
                              "category": "Beverages",
                              "description": "Cardamom flavored. Prepared in bulk, can't be customized. Picture shown is for illustration purpose only",
                              "imageId": "t0dzmmlmpmz0ciegbdti",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "1015 ratings",
                                  "ratingCountV2": "1015"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "type": "CATEGORY_TYPE_RECOMMENDED"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Breakfast",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012274",
                              "name": "Puri Bhaji",
                              "category": "Breakfast",
                              "description": "Serves 1 | 4 puri with 1 bhaji gravy and salad. Daily changing bhaji like chana, rajma, lobia, dal-makhni, aloo-mutter etc. (as per availability and not as per choice). Prepared in bulk, can't be customized. Picture shown is for illustration purpose only. Jain food not available.",
                              "imageId": "uc6zqw75bwdtted4b9cc",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "19355148",
                                  "groupName": "Add-ons",
                                  "choices": [
                                    {
                                      "id": "11498885",
                                      "name": "Extra 1 Puri ",
                                      "price": 2800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110927833",
                                      "name": "Extra Bhaji Gravy",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ]
                                },
                                {
                                  "groupId": "103636190",
                                  "groupName": "Choice of Accompaniment",
                                  "choices": [
                                    {
                                      "id": "15770730",
                                      "name": "Green Chutney - Half            ",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770731",
                                      "name": "Pickle Chotu Pack",
                                      "price": 300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770732",
                                      "name": "Butter",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "12279544",
                                      "name": "Extra Curd",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770733",
                                      "name": "Tomato Sauce 2 Pouch",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "1403 ratings",
                                  "ratingCountV2": "1403"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "69232561",
                              "name": "Poha ",
                              "category": "Breakfast",
                              "description": "Serves 1 | prepared in bulk, can't be customized. Picture shown is for illustration purpose only. Jain food not available.",
                              "imageId": "cyeqmss3javrxlkiczdl",
                              "isVeg": 1,
                              "price": 8600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "103643358",
                                  "groupName": "Choice of Accompaniment",
                                  "choices": [
                                    {
                                      "id": "15770730",
                                      "name": "Green Chutney - Half            ",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770731",
                                      "name": "Pickle Chotu Pack",
                                      "price": 300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770732",
                                      "name": "Butter",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "12279544",
                                      "name": "Extra Curd",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770733",
                                      "name": "Tomato Sauce 2 Pouch",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 8 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "893 ratings",
                                  "ratingCountV2": "893"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Tava And Methi Paratha",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012275",
                              "name": "Paratha Bhaji",
                              "category": "Tava And Methi Paratha",
                              "description": "Serves 1 | 2 plain paratha with 1 bhaji gravy and salad. Daily changing menu like chana, rajma, aloo-mutter etc",
                              "imageId": "byqczuetea0fcve7jd78",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15700,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "6911644",
                                  "groupName": "Addons",
                                  "choices": [
                                    {
                                      "id": "11636088",
                                      "name": "Extra Plain Paratha",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "103636161",
                                  "groupName": "Choice of Accompaniment",
                                  "choices": [
                                    {
                                      "id": "15770730",
                                      "name": "Green Chutney - Half            ",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770731",
                                      "name": "Pickle Chotu Pack",
                                      "price": 300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770732",
                                      "name": "Butter",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "12279544",
                                      "name": "Extra Curd",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770733",
                                      "name": "Tomato Sauce 2 Pouch",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "1520 ratings",
                                  "ratingCountV2": "1520"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012276",
                              "name": "Methi Paratha Bhaji",
                              "category": "Tava And Methi Paratha",
                              "description": "Serves 1 | 2 methi paratha with 1 bhaji gravy and salad. Daily changing menu like chana, rajma, aloo-mutter etc",
                              "imageId": "wfadf2i4gsaxu4qmizbs",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15700,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "6911645",
                                  "groupName": "Addons",
                                  "choices": [
                                    {
                                      "id": "11636089",
                                      "name": "Extra Methi Paratha ",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "103636286",
                                  "groupName": "Choice of Accompaniment",
                                  "choices": [
                                    {
                                      "id": "15770730",
                                      "name": "Green Chutney - Half            ",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770731",
                                      "name": "Pickle Chotu Pack",
                                      "price": 300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770732",
                                      "name": "Butter",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "12279544",
                                      "name": "Extra Curd",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770733",
                                      "name": "Tomato Sauce 2 Pouch",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "2482 ratings",
                                  "ratingCountV2": "2482"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Classic Meal Combos",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "95711794",
                              "name": "Roti Curry",
                              "category": "Classic Meal Combos",
                              "description": "Serves 1 | 4 tava roti, 1 sabji, 1 dal, salad. Daily changing menu like mix veg, gobhi aloo, veg kofte, bhindi do pyaza, baingan masala, kadi pakoda, besan gatte, mashroom mutter, soya aloo, lauki chana, palak aloo, methi aloo, aloo tamatar etc.  (as per availability and not as per choice). Prepared in bulk, can't be customized. Jain food not available.",
                              "imageId": "j1te9bba8lljoxqr6hjq",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15200,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "54563498",
                                  "groupName": "Addons",
                                  "choices": [
                                    {
                                      "id": "22136999",
                                      "name": "Extra Rice",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "103643354",
                                  "groupName": "Choice of Bread",
                                  "choices": [
                                    {
                                      "id": "15770729",
                                      "name": "Ghee (on Phulka)",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "103643352",
                                  "groupName": "Choice of Accompaniment",
                                  "choices": [
                                    {
                                      "id": "15770730",
                                      "name": "Green Chutney - Half            ",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770731",
                                      "name": "Pickle Chotu Pack",
                                      "price": 300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770732",
                                      "name": "Butter",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "12279544",
                                      "name": "Extra Curd",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770733",
                                      "name": "Tomato Sauce 2 Pouch",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "302 ratings",
                                  "ratingCountV2": "302"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "95711793",
                              "name": "Dal Subji Rice Meal",
                              "category": "Classic Meal Combos",
                              "description": "Serves 1 | Rice, 1 sabji, 1 dal, salad. Daily changing menu like mix veg, gobhi aloo, veg kofte, bhindi do pyaza, baingan masala, kadi pakoda, besan gatte, mashroom mutter, soya aloo, lauki chana, palak aloo, methi aloo, aloo tamatar etc.  (as per availability and not as per choice). Prepared in bulk, can't be customized. Jain food not available.",
                              "imageId": "geebhtkd9knqz61ll3i1",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "103643346",
                                  "groupName": "Choice of Accompaniment",
                                  "choices": [
                                    {
                                      "id": "15770730",
                                      "name": "Green Chutney - Half            ",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770731",
                                      "name": "Pickle Chotu Pack",
                                      "price": 300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770732",
                                      "name": "Butter",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "12279544",
                                      "name": "Extra Curd",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770733",
                                      "name": "Tomato Sauce 2 Pouch",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "441 ratings",
                                  "ratingCountV2": "441"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012292",
                              "name": "Premium Phulka Thali with Rice ",
                              "category": "Classic Meal Combos",
                              "description": "Serves 1 | 3 phulka, 1 paneer veg, 1 veg, dal, rice, curd, salad. Daily changing menu like mix veg, gobhi aloo, veg kofte, bhindi do pyaza, baingan masala, kadi pakoda, mashroom mutter, soya aloo, lauki chana, palak aloo, methi aloo, aloo tamatar / butter paneer, shahi paneer, kadai paneer or palak paneer etc",
                              "imageId": "bq9pctleehl1givfbc5o",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 22800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "103643883",
                                  "groupName": "Ad-ons",
                                  "choices": [
                                    {
                                      "id": "15770730",
                                      "name": "Green Chutney - Half            ",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770731",
                                      "name": "Pickle Chotu Pack",
                                      "price": 300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770729",
                                      "name": "Ghee (on Phulka)",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770732",
                                      "name": "Butter",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770733",
                                      "name": "Tomato Sauce 2 Pouch",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "3582 ratings",
                                  "ratingCountV2": "3582"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012293",
                              "name": "Premium Phulka Thali Without Rice",
                              "category": "Classic Meal Combos",
                              "description": "Serves 1 | 4 phulka, 1 paneer veg, 1 veg, dal, curd, salad. Daily changing menu like mix veg, gobhi aloo, veg kofte, bhindi do pyaza, baingan masala, kadi pakoda, mashroom mutter, soya aloo, lauki chana, palak aloo, methi aloo, aloo tamatar / butter paneer, shahi paneer, kadai paneer or palak paneer etc",
                              "imageId": "wrht3lg77vetnw3di0pp",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 21900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "103643868",
                                  "groupName": "Choice of Accompaniment",
                                  "choices": [
                                    {
                                      "id": "15770730",
                                      "name": "Green Chutney - Half            ",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770731",
                                      "name": "Pickle Chotu Pack",
                                      "price": 300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770732",
                                      "name": "Butter",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "12279544",
                                      "name": "Extra Curd",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770733",
                                      "name": "Tomato Sauce 2 Pouch",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "103643874",
                                  "groupName": "Choice of Bread",
                                  "choices": [
                                    {
                                      "id": "15770729",
                                      "name": "Ghee (on Phulka)",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "1719 ratings",
                                  "ratingCountV2": "1719"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012294",
                              "name": "Premium Rice Thali With 1 Phulka",
                              "category": "Classic Meal Combos",
                              "description": "Serves 1 | Rice, 1 tava roti, 1 paneer veg, 1 veg, dal, curd, salad. Daily changing menu like mix veg, gobhi aloo, veg kofte, bhindi do pyaza, baingan masala, kadi pakoda, mashroom mutter, soya aloo, lauki chana, palak aloo, methi aloo, aloo tamatar / butter paneer, shahi paneer, kadai paneer or palak paneer etc (as per availability and not as per choice). Prepared in bulk, can't be customized. Picture shown is for illustration purpose only. Jain food not available",
                              "imageId": "cfapoorbvgch00zpmksu",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 22800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "103643860",
                                  "groupName": "Choice of Accompaniment",
                                  "choices": [
                                    {
                                      "id": "15770730",
                                      "name": "Green Chutney - Half            ",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770731",
                                      "name": "Pickle Chotu Pack",
                                      "price": 300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770732",
                                      "name": "Butter",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "12279544",
                                      "name": "Extra Curd",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770733",
                                      "name": "Tomato Sauce 2 Pouch",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "222 ratings",
                                  "ratingCountV2": "222"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012295",
                              "name": "Premium Tawa Paratha Thali with Rice ",
                              "category": "Classic Meal Combos",
                              "description": "2 plain paratha, 1 paneer veg, 1 veg, dal, rice, curd, salad. Daily changing menu like mix veg, gobhi aloo, veg kofte, bhindi do pyaza, baingan masala, kadi pakoda, mashroom mutter, soya aloo, lauki chana, palak aloo, methi aloo, aloo tamatar / butter paneer, shahi paneer, kadai paneer or palak paneer etc. (as per availability and not as per choice). Prepared in bulk, can't be customized.",
                              "imageId": "cqlkuwxliitarajyl9uz",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 27600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "19355143",
                                  "groupName": "Addons",
                                  "choices": [
                                    {
                                      "id": "11636088",
                                      "name": "Extra Plain Paratha",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "103643365",
                                  "groupName": "Choice of Accompaniment",
                                  "choices": [
                                    {
                                      "id": "15770730",
                                      "name": "Green Chutney - Half            ",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770731",
                                      "name": "Pickle Chotu Pack",
                                      "price": 300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770732",
                                      "name": "Butter",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "12279544",
                                      "name": "Extra Curd",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770733",
                                      "name": "Tomato Sauce 2 Pouch",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "347 ratings",
                                  "ratingCountV2": "347"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012296",
                              "name": "Premium Tawa Paratha Thali Without Rice",
                              "category": "Classic Meal Combos",
                              "description": "Serves 1 | 3 plain paratha, 1 paneer veg, 1 veg, dal, curd, salad. Daily changing menu like mix veg, gobhi aloo, veg kofte, bhindi do pyaza, baingan masala, kadi pakoda, mashroom mutter, soya aloo, lauki chana, palak aloo, methi aloo, aloo tamatar / butter paneer, shahi paneer, kadai paneer or palak paneer etc (as per availability and not as per choice). Prepared in bulk, can't be customized. Picture shown is for illustration purpose only. Jain food not available",
                              "imageId": "eevq2mrjg1wf5i8rol3w",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 27600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "19355144",
                                  "groupName": "Addons",
                                  "choices": [
                                    {
                                      "id": "11636088",
                                      "name": "Extra Plain Paratha",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "103643902",
                                  "groupName": "Choice of Accompaniment",
                                  "choices": [
                                    {
                                      "id": "15770730",
                                      "name": "Green Chutney - Half            ",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770731",
                                      "name": "Pickle Chotu Pack",
                                      "price": 300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770732",
                                      "name": "Butter",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "12279544",
                                      "name": "Extra Curd",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770733",
                                      "name": "Tomato Sauce 2 Pouch",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "219 ratings",
                                  "ratingCountV2": "219"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012297",
                              "name": "Premium Methi Paratha Thali with Rice ",
                              "category": "Classic Meal Combos",
                              "description": "2 methi paratha, 1 paneer veg, 1 veg, dal, rice, curd, salad. Daily changing menu like mix veg, gobhi aloo, veg kofte, bhindi do pyaza, baingan masala, kadi pakoda, mashroom mutter, soya aloo, lauki chana, palak aloo, methi aloo, aloo tamatar / butter paneer, shahi paneer, kadai paneer or palak paneer etc. (as per availability and not as per choice). Prepared in bulk, can't be customized.",
                              "imageId": "nqjg22ztiaxjdfhmrbtt",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 27600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "19355145",
                                  "groupName": "Addons",
                                  "choices": [
                                    {
                                      "id": "11636089",
                                      "name": "Extra Methi Paratha ",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "103643893",
                                  "groupName": "Choice of Accompaniment",
                                  "choices": [
                                    {
                                      "id": "15770730",
                                      "name": "Green Chutney - Half            ",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770731",
                                      "name": "Pickle Chotu Pack",
                                      "price": 300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770732",
                                      "name": "Butter",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770733",
                                      "name": "Tomato Sauce 2 Pouch",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "499 ratings",
                                  "ratingCountV2": "499"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012298",
                              "name": "Premium Methi Paratha Thali Without Rice",
                              "category": "Classic Meal Combos",
                              "description": "Serves 1 | 3 methi paratha, 1 paneer veg, 1 veg, dal, curd, salad. Daily changing menu like mix veg, gobhi aloo, veg kofte, bhindi do pyaza, baingan masala, kadi pakoda, mashroom mutter, soya aloo, lauki chana, palak aloo, methi aloo, aloo tamatar / butter paneer, shahi paneer, kadai paneer or palak paneer etc",
                              "imageId": "xsyivuzcb3svnqosjzx0",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 27600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "19355146",
                                  "groupName": "Addons",
                                  "choices": [
                                    {
                                      "id": "11636089",
                                      "name": "Extra Methi Paratha ",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "103643888",
                                  "groupName": "Choice of Accompaniment",
                                  "choices": [
                                    {
                                      "id": "15770730",
                                      "name": "Green Chutney - Half            ",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770731",
                                      "name": "Pickle Chotu Pack",
                                      "price": 300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770732",
                                      "name": "Butter",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "12279544",
                                      "name": "Extra Curd",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770733",
                                      "name": "Tomato Sauce 2 Pouch",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "303 ratings",
                                  "ratingCountV2": "303"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Individual Items",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012304",
                              "name": "Phulka",
                              "category": "Individual Items",
                              "description": "1 piece",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2300,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "2561 ratings",
                                  "ratingCountV2": "2561"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012305",
                              "name": "Ghee Phulka",
                              "category": "Individual Items",
                              "description": "1 piece",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "652 ratings",
                                  "ratingCountV2": "652"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012306",
                              "name": "Tava Paratha",
                              "category": "Individual Items",
                              "description": "1 piece",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5700,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "691 ratings",
                                  "ratingCountV2": "691"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012307",
                              "name": "Methi Paratha",
                              "category": "Individual Items",
                              "description": "1 piece",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5700,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "1577 ratings",
                                  "ratingCountV2": "1577"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "70853984",
                              "name": "Rice [small]",
                              "category": "Individual Items",
                              "description": "About 225 ml of white rice.",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 3800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "305 ratings",
                                  "ratingCountV2": "305"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "70853985",
                              "name": "Rice [large]",
                              "category": "Individual Items",
                              "description": "About 450 ml of white rice.",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "241 ratings",
                                  "ratingCountV2": "241"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "70853355",
                              "name": "Dal [small]",
                              "category": "Individual Items",
                              "description": "About 225 ml. Daily changing menu (as per availability and not as per choice). Prepared in bulk, can't be customized.",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "557 ratings",
                                  "ratingCountV2": "557"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "70853356",
                              "name": "Dal [large]",
                              "category": "Individual Items",
                              "description": "About 450 ml. Daily changing menu (as per availability and not as per choice). Prepared in bulk, can't be customized.",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14200,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "440 ratings",
                                  "ratingCountV2": "440"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "70853979",
                              "name": "Veg Of The Day [small]",
                              "category": "Individual Items",
                              "description": "About 225 ml. Daily changing menu like mix veg, gobhi aloo, veg kofte, bhindi do pyaza, baingan masala, kadi pakoda, mashroom mutter, soya aloo, lauki chana, palak aloo, methi aloo, aloo tamatar etc.  (as per availability and not as per choice). Prepared in bulk, can't be customized.",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13300,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "453 ratings",
                                  "ratingCountV2": "453"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "70853980",
                              "name": "Veg Of The Day [large]",
                              "category": "Individual Items",
                              "description": "About 450 ml. Daily changing menu like mix veg, gobhi aloo, veg kofte, bhindi do pyaza, baingan masala, kadi pakoda, mashroom mutter, soya aloo, lauki chana, palak aloo, methi aloo, aloo tamatar etc.  (as per availability and not as per choice). Prepared in bulk, can't be customized.",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 20000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "216 ratings",
                                  "ratingCountV2": "216"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "70853981",
                              "name": "Paneer Veg [small]",
                              "category": "Individual Items",
                              "description": "225 ml | Serves 1 | Daily changing menu like butter paneer, shahi paneer, kadai paneer or palak paneer etc",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15200,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "225 ml"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "502 ratings",
                                  "ratingCountV2": "502"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "70853983",
                              "name": "Paneer Veg [large]",
                              "category": "Individual Items",
                              "description": "About 450 ml. Daily changing menu like butter paneer, shahi paneer, kadai paneer or palak paneer etc. (as per availability and not as per choice). Prepared in bulk, can't be customized.",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 22800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "354 ratings",
                                  "ratingCountV2": "354"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "70853976",
                              "name": "Gravy Of The Day [small]",
                              "category": "Individual Items",
                              "description": "About 225 ml. Daily changing menu like chana, rajma, aloo-mutter etc. (as per availability and not as per choice). Prepared in bulk, can't be customized.",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11400,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "376 ratings",
                                  "ratingCountV2": "376"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "70853978",
                              "name": "Gravy Of The Day [large]",
                              "category": "Individual Items",
                              "description": "About 450 ml. Daily changing menu like chana, rajma, aloo-mutter etc. (as per availability and not as per choice). Prepared in bulk, can't be customized.",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17100,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "408 ratings",
                                  "ratingCountV2": "408"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Stuffed Paratha",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012278",
                              "name": "Aloo Paratha",
                              "category": "Stuffed Paratha",
                              "description": "Serves 1 | 1 big size stuffed paratha with curd and bhaji. Prepared in bulk, can't be customized. Picture shown is for illustration purpose only",
                              "imageId": "u5w966bcnmm7ykddf5q5",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15700,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "103634987",
                                  "groupName": "Choice of Accompaniment",
                                  "choices": [
                                    {
                                      "id": "15770730",
                                      "name": "Green Chutney - Half            ",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770731",
                                      "name": "Pickle Chotu Pack",
                                      "price": 300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770732",
                                      "name": "Butter",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770733",
                                      "name": "Tomato Sauce 2 Pouch",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "3654 ratings",
                                  "ratingCountV2": "3654"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012285",
                              "name": "Aloo Onion Paratha",
                              "category": "Stuffed Paratha",
                              "description": "Serves 1 | 1 big size stuffed paratha with curd and bhaji. Prepared in bulk, can't be customized. Picture shown is for illustration purpose only",
                              "imageId": "paryce88sa26bsvqqgtj",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "103637733",
                                  "groupName": "Choice of Accompaniment",
                                  "choices": [
                                    {
                                      "id": "15770730",
                                      "name": "Green Chutney - Half            ",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770731",
                                      "name": "Pickle Chotu Pack",
                                      "price": 300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770732",
                                      "name": "Butter",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770733",
                                      "name": "Tomato Sauce 2 Pouch",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "2827 ratings",
                                  "ratingCountV2": "2827"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012281",
                              "name": "Paneer Paratha",
                              "category": "Stuffed Paratha",
                              "description": "Serves 1 | 1 big size stuffed paratha with curd and bhaji. Prepared in bulk, can't be customized. Picture shown is for illustration purpose only",
                              "imageId": "nezemesnk23n14v3dsc4",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "103637701",
                                  "groupName": "Choice of Accompaniment",
                                  "choices": [
                                    {
                                      "id": "15770730",
                                      "name": "Green Chutney - Half            ",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770731",
                                      "name": "Pickle Chotu Pack",
                                      "price": 300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770732",
                                      "name": "Butter",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770733",
                                      "name": "Tomato Sauce 2 Pouch",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "2571 ratings",
                                  "ratingCountV2": "2571"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012289",
                              "name": "Onion Paneer Paratha",
                              "category": "Stuffed Paratha",
                              "description": "1 big size stuffed paratha with curd and bhaji. Prepared in bulk, can't be customized. Picture shown is for illustration purpose only.(serves 1).",
                              "imageId": "z2nudtnwdgvfjo8jpfkd",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "103634955",
                                  "groupName": "Choice of Accompaniment",
                                  "choices": [
                                    {
                                      "id": "15770730",
                                      "name": "Green Chutney - Half            ",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770731",
                                      "name": "Pickle Chotu Pack",
                                      "price": 300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770732",
                                      "name": "Butter",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770733",
                                      "name": "Tomato Sauce 2 Pouch",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "792 ratings",
                                  "ratingCountV2": "792"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012279",
                              "name": "Gobi Paratha",
                              "category": "Stuffed Paratha",
                              "description": "1 big size stuffed paratha with curd and bhaji. Prepared in bulk, can't be customized. Picture shown is for illustration purpose only.(serves 1).",
                              "imageId": "e0fzae1tjlx7gxvxn5ij",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "103634980",
                                  "groupName": "Choice of Accompaniment",
                                  "choices": [
                                    {
                                      "id": "15770730",
                                      "name": "Green Chutney - Half            ",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770731",
                                      "name": "Pickle Chotu Pack",
                                      "price": 300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770732",
                                      "name": "Butter",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770733",
                                      "name": "Tomato Sauce 2 Pouch",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "1387 ratings",
                                  "ratingCountV2": "1387"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012290",
                              "name": "Gobi Paneer Paratha",
                              "category": "Stuffed Paratha",
                              "description": "1 big size stuffed paratha with curd and bhaji. Prepared in bulk, can't be customized. Picture shown is for illustration purpose only.(serves 1).",
                              "imageId": "s6kzgxtvph7b2pbcafum",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "103634946",
                                  "groupName": "Choice of Accompaniment",
                                  "choices": [
                                    {
                                      "id": "15770730",
                                      "name": "Green Chutney - Half            ",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770731",
                                      "name": "Pickle Chotu Pack",
                                      "price": 300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770732",
                                      "name": "Butter",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770733",
                                      "name": "Tomato Sauce 2 Pouch",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "175 ratings",
                                  "ratingCountV2": "175"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012286",
                              "name": "Aloo Gobi Paratha",
                              "category": "Stuffed Paratha",
                              "description": "1 big size stuffed paratha with curd and bhaji. Prepared in bulk, can't be customized. Picture shown is for illustration purpose only.(serves 1).",
                              "imageId": "cxc4am3ha9m9lyhd0coh",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "103637726",
                                  "groupName": "Choice of Accompaniment",
                                  "choices": [
                                    {
                                      "id": "15770730",
                                      "name": "Green Chutney - Half            ",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770731",
                                      "name": "Pickle Chotu Pack",
                                      "price": 300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770732",
                                      "name": "Butter",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770733",
                                      "name": "Tomato Sauce 2 Pouch",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "633 ratings",
                                  "ratingCountV2": "633"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012288",
                              "name": "Aloo Paneer Paratha",
                              "category": "Stuffed Paratha",
                              "description": "Serves 1 | 1 big size stuffed paratha with curd and bhaji. Prepared in bulk, can't be customized. Picture shown is for illustration purpose only",
                              "imageId": "sq7d8y8x55cdgfbfnfkr",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "103634971",
                                  "groupName": "Choice of Accompaniment",
                                  "choices": [
                                    {
                                      "id": "15770730",
                                      "name": "Green Chutney - Half            ",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770731",
                                      "name": "Pickle Chotu Pack",
                                      "price": 300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770732",
                                      "name": "Butter",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770733",
                                      "name": "Tomato Sauce 2 Pouch",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "383 ratings",
                                  "ratingCountV2": "383"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012283",
                              "name": "Methi Aloo Paratha",
                              "category": "Stuffed Paratha",
                              "description": "Serves 1 | 1 big size stuffed paratha with curd and bhaji. Prepared in bulk, can't be customized. Picture shown is for illustration purpose only",
                              "imageId": "z4laaccoovnkwjnhg4je",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "103637665",
                                  "groupName": "Choice of Accompaniment",
                                  "choices": [
                                    {
                                      "id": "15770730",
                                      "name": "Green Chutney - Half            ",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770731",
                                      "name": "Pickle Chotu Pack",
                                      "price": 300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770732",
                                      "name": "Butter",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770733",
                                      "name": "Tomato Sauce 2 Pouch",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "709 ratings",
                                  "ratingCountV2": "709"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012284",
                              "name": "Methi Paneer Paratha",
                              "category": "Stuffed Paratha",
                              "description": "1 big size stuffed paratha with curd and bhaji. Prepared in bulk, can't be customized. Picture shown is for illustration purpose only.(serves 1).",
                              "imageId": "sqauvh7h0wsd6b0b8dsa",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "103637738",
                                  "groupName": "Choice of Accompaniment",
                                  "choices": [
                                    {
                                      "id": "15770730",
                                      "name": "Green Chutney - Half            ",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770731",
                                      "name": "Pickle Chotu Pack",
                                      "price": 300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770732",
                                      "name": "Butter",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "15770733",
                                      "name": "Tomato Sauce 2 Pouch",
                                      "price": 200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "462 ratings",
                                  "ratingCountV2": "462"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Sides",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012312",
                              "name": "Butter",
                              "category": "Sides",
                              "description": "Cube blister",
                              "imageId": "nkuknwltggaokiylyky6",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "95 ratings",
                                  "ratingCountV2": "95"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012313",
                              "name": "Green Salad",
                              "category": "Sides",
                              "description": "Cucumber, carrot, radish, tomato, onion, lemon, green chilli.",
                              "imageId": "embqrks4wqhwmlkjuvzm",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "525 ratings",
                                  "ratingCountV2": "525"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012310",
                              "name": "Onion And Lemon Salad",
                              "category": "Sides",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "111 ratings",
                                  "ratingCountV2": "111"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012309",
                              "name": "Green Chutney",
                              "category": "Sides",
                              "description": "About 100 ml",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 4700,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "158 ratings",
                                  "ratingCountV2": "158"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012311",
                              "name": "Pickle",
                              "category": "Sides",
                              "description": "About 30 ml",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "107 ratings",
                                  "ratingCountV2": "107"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012308",
                              "name": "Curd",
                              "category": "Sides",
                              "description": "About 85 ml",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 1000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "312 ratings",
                                  "ratingCountV2": "312"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Beverages",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012315",
                              "name": "Butter Milk",
                              "category": "Beverages",
                              "description": "Masala chhas. Prepared in bulk, can't be customized. Picture shown is for illustration purpose only",
                              "imageId": "y0qwazat8cr2tyksrbhq",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "1030 ratings",
                                  "ratingCountV2": "1030"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "39012316",
                              "name": "Sweet Lassi",
                              "category": "Beverages",
                              "description": "Cardamom flavored. Prepared in bulk, can't be customized. Picture shown is for illustration purpose only",
                              "imageId": "t0dzmmlmpmz0ciegbdti",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "1015 ratings",
                                  "ratingCountV2": "1015"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                      "type": "FSSAI",
                      "imageId": "fssai_final_edss9i",
                      "text": [
                        "License No. 11223334000759"
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                      "name": "Mumbai Tiffin",
                      "area": "HSR Layout",
                      "completeAddress": "5, 6, 7, M. Krishnappa Layout, Mangammanapalya Main Road, Sector 7, HSR Layout, Bangalore"
                    }
                  }
                }
              ]
            }
          }
        }
      }
    ],
    "firstOffsetRequest": true,
    "isQCLink": false
  },
  "tid": "8091b6c9-34ec-4881-8b5e-d2b6a4328fa1",
  "sid": "c8b69dc8-6710-47a7-bc63-18091856e3fa",
  "deviceId": "c73fa13e-69cf-472b-8071-076091f9d98d",
  "csrfToken": "raL3sg1xVNSP-Wiz0CqxmzjiMznatjUoCMaWTB8w"
}

export const MANI_DUM_BIRYANI=
{
  "statusCode": 0,
  "data": {
    "statusMessage": "done successfully",
    "cards": [
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
            "info": {
              "id": "194610",
              "name": "Mani's Dum Biryani",
              "city": "Bangalore",
              "slugs": {
                "restaurant": "mani's-dum-biryani-hsr-hsr",
                "city": "bangalore"
              },
              "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
              "cloudinaryImageId": "j7cijvueivi8qhvnohvw",
              "locality": "HSR Layout\t",
              "areaName": "HSR Layout",
              "costForTwo": "30000",
              "costForTwoMessage": "₹300 for two",
              "cuisines": [
                "Andhra",
                "Biryani"
              ],
              "avgRating": 4.4,
              "feeDetails": {
                "restaurantId": "194610",
                "fees": [
                  {
                    "name": "distance",
                    "fee": 3200
                  },
                  {
                    "name": "time"
                  },
                  {
                    "name": "special"
                  }
                ],
                "totalFee": 3200,
                "icon": "v1648635511/Delivery_fee_new_cjxumu",
                "message": "1.7 kms | ₹32 Delivery fee will apply"
              },
              "parentId": "623",
              "avgRatingString": "4.4",
              "totalRatingsString": "10K+ ratings",
              "sla": {
                "restaurantId": "194610",
                "deliveryTime": 33,
                "minDeliveryTime": 30,
                "maxDeliveryTime": 35,
                "lastMileTravel": 1.7,
                "serviceability": "SERVICEABLE",
                "stressFactor": 1,
                "rainMode": "RAIN_MODE_NONE",
                "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
                "zoneId": 3,
                "slaString": "30-35 MINS",
                "lastMileTravelString": "1.7 km",
                "iconType": "ICON_TYPE_EMPTY"
              },
              "availability": {
                "nextCloseTime": "2024-02-18 23:45:00",
                "visibility": true,
                "opened": true,
                "restaurantClosedMeta": {
                  
                }
              },
              "aggregatedDiscountInfo": {
                "shortDescriptionList": [
                  {
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "Flat ₹100 off | Above ₹550",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "15% off upto ₹300 | Use CITIFOODIE Above ₹1200",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "visible": true
              },
              "badges": {
                
              },
              "slugString": "mani's-dum-biryani-hsr-hsr",
              "multiOutlet": true,
              "isOpen": true,
              "labels": [
                {
                  "title": "Timings",
                  "message": "null"
                },
                {
                  "title": "Address",
                  "message": "HSR Layout, Bengaluru, Karnataka, India"
                },
                {
                  "title": "Cuisines",
                  "message": "Andhra,Biryani"
                }
              ],
              "totalRatings": 10000,
              "aggregatedDiscountInfoV2": {
                "shortDescriptionList": [
                  {
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "Flat ₹100 off | Above ₹550",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "15% off upto ₹300 | Use CITIFOODIE Above ₹1200",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "couponDetailsCta": "View coupon details"
              },
              "type": "F",
              "headerBanner": {
                "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/194610"
              },
              "expectationNotifiers": [
                {
                  "text": "1.7 kms | ₹32 Delivery fee will apply",
                  "icon": {
                    "imageId": "v1648635511/Delivery_fee_new_cjxumu"
                  },
                  "popup": {
                    "cta": {
                      
                    }
                  },
                  "type": "DISTANCE_FEE_NON_FOOD_LM",
                  "enrichedText": "<b>1.7 kms</b> | ₹32 Delivery fee will apply",
                  "halfCardPopup": {
                    "halfCardPopupHeader": {
                      
                    }
                  }
                }
              ],
              "generalPurposeInfoListV2": [
                {
                  "cta": {
                    "info": {
                      "recordings": {
                        
                      }
                    },
                    "linkCta": {
                      
                    }
                  }
                }
              ],
              "ratingSlab": "RATING_SLAB_5",
              "orderabilityCommunication": {
                "title": {
                  
                },
                "subTitle": {
                  
                },
                "message": {
                  
                },
                "customIcon": {
                  
                }
              },
              "hasBestsellerItems": true,
              "cartOrderabilityNudgeBanner": {
                "parameters": {
                  
                },
                "presentation": {
                  
                }
              },
              "latLong": "12.914739,77.63833299999999",
              "backgroundImageOverlayInfo": {
                
              }
            },
            "analytics": {
              
            }
          },
          "relevance": {
            "type": "RELEVANCE_TYPE_CHECK_ORDERABILITY_ON_ITEM_ADD",
            "sectionId": "POP_UP_CROUTON_MENU"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "layout": {
              "rows": 1,
              "columns": 5,
              "horizontalScrollEnabled": true,
              "itemSpacing": 12,
              "lineSpacing": 10,
              "widgetPadding": {
                
              },
              "containerStyle": {
                "containerPadding": {
                  "left": 10,
                  "right": 10,
                  "bottom": 16
                }
              },
              "scrollBar": {
                
              }
            },
            "id": "offerCollectionWidget_UX4",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                "offers": [
                  {
                    "info": {
                      "header": "FLAT ₹100 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "MARKETING_BANNERS/IMAGES/OFFERS/2024/2/17/1ed4245d-31e3-4dc6-b949-524a33b9b8c9_ICICI.png",
                      "offerIds": [
                        "299f5c31-dd4a-47a4-8d93-4ccb6be1a8a8"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "NO CODE REQUIRED",
                      "description": "ABOVE ₹550",
                      "offerType": "offers",
                      "restId": "194610",
                      "offerLogo": "MARKETING_BANNERS/IMAGES/OFFERS/2024/2/17/1ed4245d-31e3-4dc6-b949-524a33b9b8c9_ICICI.png",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹50 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "MARKETING_BANNERS/IMAGES/OFFERS/2024/2/16/d2280c74-96d1-4a1d-afd6-4270a05b5488_ICICI.png",
                      "offerIds": [
                        "72b12a41-597c-4c87-a813-32c46574fde9"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "NO CODE REQUIRED",
                      "description": "ABOVE ₹500",
                      "offerType": "offers",
                      "restId": "194610",
                      "offerLogo": "MARKETING_BANNERS/IMAGES/OFFERS/2024/2/16/d2280c74-96d1-4a1d-afd6-4270a05b5488_ICICI.png",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "15% OFF UPTO ₹300",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/15fb1cfe885005447dc8375e7970600f",
                      "offerIds": [
                        "c313f07b-4a9c-451e-ab52-586759f42642"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE CITIFOODIE",
                      "description": "ABOVE ₹1200",
                      "offerType": "offers",
                      "restId": "194610",
                      "offerLogo": "rng/md/ads/production/15fb1cfe885005447dc8375e7970600f",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹30 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/7f31c9e47ddd7e6a3c16d21553c0ca60",
                      "offerIds": [
                        "269c382d-796f-45cd-bd15-0b8b891c5e0c"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE SIMPL30",
                      "description": "ABOVE ₹300",
                      "offerType": "offers",
                      "restId": "194610",
                      "offerLogo": "rng/md/ads/production/7f31c9e47ddd7e6a3c16d21553c0ca60",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹150 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/59ef5e58052532ad85a185bf516eccce",
                      "offerIds": [
                        "6265534b-c8b7-4494-a469-116273548dd2"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE AMEX150",
                      "description": "ABOVE ₹600",
                      "offerType": "offers",
                      "restId": "194610",
                      "offerLogo": "rng/md/ads/production/59ef5e58052532ad85a185bf516eccce",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  }
                ],
                "habitMilestoneInfo": {
                  "callout": {
                    
                  }
                },
                "loyaltyDiscoverPresentationInfo": {
                  "logoCtx": {
                    
                  }
                }
              }
            }
          }
        }
      },
      {
        "groupedCard": {
          "cardGroupMap": {
            "REGULAR": {
              "cards": [
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                      "badges": {
                        
                      },
                      "vegOnlyDetails": {
                        "imageId": "AutoVegOnly_qkjowj",
                        "title": "Showing only vegetarian options.",
                        "description": "Tap on the VEG ONLY button to turn off the setting"
                      },
                      "topRatedFilter": {
                        
                      },
                      "kidsCategoryFilter": {
                        "attributes": {
                          "displayText": "Kids Favourites",
                          "tooltip": {
                            "enabled": true,
                            "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                          }
                        }
                      },
                      "vegFilter": {
                        "attributes": {
                          "displayText": "VEG"
                        }
                      },
                      "nonvegFilter": {
                        "attributes": {
                          "displayText": "NONVEG"
                        }
                      }
                    },
                    "relevance": {
                      "type": "RELEVANCE_TYPE_ON_MENU_FILTER_TOGGLED",
                      "sectionId": "MENU_FILTER_TOGGLE"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Starters",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "126820613",
                              "name": "Chicken Kabab Fry",
                              "category": "Starters",
                              "description": "Our kabab made with marinated chicken withbone (12-14 pieces) nutritional information (per 100 gms) : energy - 175. 1 kcal, protein - 14. 5 g,  carbs -7 g , fats - 9. 9 g, allergens: egg. Serving size: 240 gms",
                              "imageId": "cdd124b08835bc30b160a1ecb58acdc8",
                              "inStock": 1,
                              "price": 26900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "9 ratings",
                                  "ratingCountV2": "9"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815069",
                              "name": "Boneless Chicken 65 (4 Pcs)",
                              "category": "Starters",
                              "description": "Our signature starter made with boneless marinated chicken (4 pieces) nutritional information (per 100 gms) : energy - 175. 1 kcal, protein - 14. 5 g,  carbs -7 g , fats - 9. 9 g, allergens: egg. Serving size: 120 gms",
                              "imageId": "7c1859cf0b217626bc804732a476908c",
                              "inStock": 1,
                              "price": 14900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "33 ratings",
                                  "ratingCountV2": "33"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815099",
                              "name": "Boneless Chicken 65 (8 Pcs)",
                              "category": "Starters",
                              "description": "Our signature starter made with boneless marinated chicken (8 pieces) nutritional information (per 100 gms) : energy - 175. 1 kcal, protein - 14. 5 g,  carbs -7 g , fats - 9. 9 g, allergens: egg. Serving size: 240 gms",
                              "imageId": "33e59d15b9d820975be544d9e95bd408",
                              "inStock": 1,
                              "price": 26900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "28 ratings",
                                  "ratingCountV2": "28"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815098",
                              "name": "Achari Chicken Kebab",
                              "category": "Starters",
                              "description": "24-26 small cubes of fried achari flavoured boneless chicken. Nutritional information (per 100 gms) : energy - 172 kcal, protein - 15 g,  carbs -6. 8 g , fats - 9. 5 g, allergens: egg. Serving size: 240 gms",
                              "imageId": "1fe6c4ca04e15add33d71e58ab58eb7b",
                              "inStock": 1,
                              "price": 26900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "22 ratings",
                                  "ratingCountV2": "22"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112922744",
                              "name": "Hot & Spice Chicken (30 Pcs)",
                              "category": "Starters",
                              "description": "30 small cubes of fried boneless chicken flavored with hot & spice mix. Nutritional information (per 100 gms) : energy - 172 kcal, protein - 15 g,  carbs -6. 8 g , fats - 9. 5 g, allergens: egg. Serving size: 240 gms",
                              "imageId": "a89c071ad1d3afa8f1248b1e36f4663d",
                              "inStock": 1,
                              "price": 26900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "33 ratings",
                                  "ratingCountV2": "33"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815110",
                              "name": "Fish Kabab (8 Pcs)",
                              "category": "Starters",
                              "description": "8 medium-sized pieces of fried marinated boneless fish. Nutritional information (per 100 gms) : energy - 206. 3 kcal, protein - 25. 4 g,  carbs -29 g , fats - 6. 6 g. Serving size: 240 gms",
                              "imageId": "ad0a7c5dfc44c26092d9881eea53e382",
                              "inStock": 1,
                              "price": 31900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.4",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112922749",
                              "name": "Thees Thukuda Maachi Fry (30 Pcs)",
                              "category": "Starters",
                              "description": "30 small cubes of fried boneless fish flavoured with hot & spice mix. Nutritional information (per 100 gms) : energy - 217. 1 kcal, protein - 5 g,  carbs -20 g , fats - 9. 9 g. Serving size: 240 gms",
                              "imageId": "28ea8c33e4496c9ac4a7638c213c357b",
                              "inStock": 1,
                              "price": 31900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.9",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112922750",
                              "name": "Paneer Thukuda Fry (15 Pcs)",
                              "category": "Starters",
                              "description": "15 -16 small cubes of paneer batter fried flavoured with hot & spice mix. Nutritional information (per 100 gms) : energy - 172 kcal, protein - 5 g,  carbs -20 g , fats - 8 g. Serving size: 240 gms",
                              "imageId": "1aa8b8c84a0ad901bb209cd4d82154ff",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 26900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "41 ratings",
                                  "ratingCountV2": "41"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "41784009",
                              "name": "Gobi Manchurian",
                              "category": "Starters",
                              "description": "Indo-chinese style starter made with batter fried cauliflower tossed in machurian sauce. Nutritional information (per 100 gms) : energy - 177. 35 kcal, protein - 2. 9 g,  carbs -21. 3 g , fats - 8. 95 g. Serving size: 240 gms",
                              "imageId": "d9661829f37cd1921d830826ae98adfd",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 24900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "16 ratings",
                                  "ratingCountV2": "16"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "118288175",
                              "name": "Chilli Chicken Boneless (15 Pcs)",
                              "category": "Starters",
                              "description": "Indo-chinese style starter made with 15 small cubes of boneless chicken tossed in spicy chili sauce. Nutritional information (per 100 gms) : energy - 181. 5 kcal, protein - 15. 2 g,  carbs -7. 9 g , fats - 9. 9 g, allergens: egg. Serving size: 240 gms",
                              "inStock": 1,
                              "price": 26900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Jeera Samba Biryani",
                      "categories": [
                        {
                          "title": "D'lite Series Biryanis (Serves 1)",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "120519256",
                                  "name": "Dlite Chicken Biryani (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "description": "Dum biryani with 2 pieces of chicken (with bone), 1 boiled egg, raita & salan. Nutritional information (per 100 gms) : energy - 191. 47 kcal, protein - 8. 9 g,  carbs - 27. 74 g , fats - 4. 99 g, allergens: milk, egg. Serving size: 510 gms",
                                  "imageId": "53c8fade0ff207e58469205d33198fca",
                                  "inStock": 1,
                                  "price": 19900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532233",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112045932",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532234",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112045972",
                                          "name": "Salan (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "7 ratings",
                                      "ratingCountV2": "7"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123479028",
                                  "name": "Chicken Biryani With Leg Piece, Half (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "description": "Dum biryani with 1 chicken drumstick & 1 chicken piece (with bone), 1 boiled egg, raita & salan. Nutritional information (per 100 gms) : energy - 191. 47 kcal, protein - 8. 9 g,  carbs - 27. 74 g , fats - 4. 99 g, allergens: milk, egg. Serving size: 540 gms",
                                  "imageId": "bfc500638995978210f0a40981a10779",
                                  "inStock": 1,
                                  "price": 23900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532237",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112045871",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532238",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112046049",
                                          "name": "Salan (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "5 ratings",
                                      "ratingCountV2": "5"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "115815075",
                                  "name": "Chicken Masalendar Biryani Dlite (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "description": "Boneless chicken curry with extra spices to make it masaledar served separately alongwith our jeeraga samba dum biryani rice, 1 boiled egg and raita",
                                  "imageId": "11b5168980535bb5e60625e98b870216",
                                  "inStock": 1,
                                  "price": 19900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.7",
                                      "ratingCount": "5 ratings",
                                      "ratingCountV2": "5"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "115815086",
                                  "name": "Dlite Chatpata Paneer Biryani (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "description": "Marinated milky paneer cubes sauteed in tangy and peppery south indian curry sauce served separately along with our vegetarian jeeraga samba biryani rice and raita",
                                  "imageId": "c63dd85e9a3cc24c7780f213c293ae9c",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 19900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532241",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112046069",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532242",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112046072",
                                          "name": "Salan (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "12 ratings",
                                      "ratingCountV2": "12"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "115815084",
                                  "name": "Dlite Chatpata Chicken Biryani (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "description": "Mildly marinated chicken boneless pieces sauteed in a tangy and peppery south indian curry sauce served separately alongwith our jeeraga samba dum biryani rice, 1 boiled egg and raita",
                                  "imageId": "ec3c3941816fec6d9e739d5d60231d5e",
                                  "inStock": 1,
                                  "price": 19900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "7 ratings",
                                      "ratingCountV2": "7"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "115815094",
                                  "name": "Dlite Masaledar Egg Biryani (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "description": "Egg curry (2 eggs) spiced with extra masala to make it masaledar and served separately along with our vegetarian jeeraga samba veg biryani rice and raita",
                                  "imageId": "51a4fe0f55b4094be52b058af708d211",
                                  "inStock": 1,
                                  "price": 19900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "2.2",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "115815082",
                                  "name": "Dlite Achari Chicken Biryani (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "description": "Our tangy and peppery jeeraga samba chicken dum biryani with 14 pieces of chicken boneless kabab served along with 1 boiled egg and raita",
                                  "imageId": "9b408e28490df1ff56249faeec3a99f2",
                                  "inStock": 1,
                                  "price": 19900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.5",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "119298420",
                                  "name": "Dlite Chicken Value Biryani (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "description": "Dum biryani with 1 piece of chicken (with bone), 1 boiled egg, raita. Nutritional information (per 100 gms) : energy - 191. 47 kcal, protein - 8. 9 g,  carbs - 27. 74 g , fats - 4. 99 g, allergens: milk, egg. Serving size: 510 gms",
                                  "inStock": 1,
                                  "price": 14900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "119298421",
                                  "name": "Dlite Veg Biryani Half (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "description": "Vegetarian dum biryani with fresh vegetables & paneer cubes, raita. Nutritional information (per 100 gms) : energy - 205. 15 kcal, protein - 8. 9 g,  carbs -29 g , fats - 5. 95 g, allergens: milk. Serving size: 510 gms",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 19900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Half Biryanis (Serves 1)",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123478964",
                                  "name": "Half Chicken Biryani Boneless (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "inStock": 1,
                                  "price": 23900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532257",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112045845",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532259",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112045912",
                                          "name": "Salan (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123478966",
                                  "name": "Half Chicken Kabab Biryani (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "inStock": 1,
                                  "price": 25900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532263",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112045971",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532265",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112045993",
                                          "name": "Salan (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123478965",
                                  "name": "Half Fish Biryani (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "inStock": 1,
                                  "price": 32900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532268",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112045850",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532270",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112046066",
                                          "name": "Salan (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123478962",
                                  "name": "Half Egg Biryani (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "inStock": 1,
                                  "price": 16900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532272",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112045968",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532274",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112046099",
                                          "name": "Salan (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123478963",
                                  "name": "Half Dum Biryani Without Pieces (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "inStock": 1,
                                  "price": 11900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532276",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112045847",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532277",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112046037",
                                          "name": "Salan (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123479001",
                                  "name": "Half Veg Biryani (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 19900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532280",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112045967",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532281",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112046062",
                                          "name": "Salan (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123479002",
                                  "name": "Half Andhra Paneer Biryani (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 24900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532289",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112046094",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532290",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112045876",
                                          "name": "Salan (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Full Biryanis (Serves 1 To 2)",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123479005",
                                  "name": "Full Chicken Biryani (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "imageId": "9a8d919d4e468db7819b48b9aa597e01",
                                  "inStock": 1,
                                  "price": 29900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532346",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112045969",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532349",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112045991",
                                          "name": "Salan (200 Ml)",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123479003",
                                  "name": "Full Chicken Biryani With Leg Piece (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "imageId": "92d14749daba49153ffd7abcdcdc557e",
                                  "inStock": 1,
                                  "price": 30900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532354",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112045848",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532357",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112046076",
                                          "name": "Salan (200 Ml)",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123479004",
                                  "name": "Full Chicken Biryani Boneless (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "imageId": "333f95b1f1eb946de8e085d126f806d6",
                                  "inStock": 1,
                                  "price": 32900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532368",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112045966",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532369",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112045930",
                                          "name": "Salan (200 Ml)",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123479007",
                                  "name": "Full Chicken Kabab Biryani (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "imageId": "f179b35940101b6390461115feaa0bf7",
                                  "inStock": 1,
                                  "price": 34900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532378",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112045846",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532383",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112045874",
                                          "name": "Salan (200 Ml)",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123479006",
                                  "name": "Full Fish Biryani (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "inStock": 1,
                                  "price": 42900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532392",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112045965",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532398",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112046078",
                                          "name": "Salan (200 Ml)",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123478986",
                                  "name": "Full Egg Biryani (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "imageId": "22f26ef7c20448eb01f6a5f3ca3f7fd9",
                                  "inStock": 1,
                                  "price": 22900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532408",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112045856",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532411",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112045875",
                                          "name": "Salan (200 Ml)",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123478984",
                                  "name": "Full Dum Biryani Without Pieces (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "imageId": "a0f0bb08be6b0e297ed551fb2c1b368d",
                                  "inStock": 1,
                                  "price": 16900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532422",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112045866",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532424",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112045862",
                                          "name": "Salan (200 Ml)",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123478985",
                                  "name": "Full Veg Biryani (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "imageId": "5e51974f7c385591499970ea6254cfd4",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 25900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532434",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112046020",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532436",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112046102",
                                          "name": "Salan (200 Ml)",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123478989",
                                  "name": "Full Andhra Paneer Biryani (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "imageId": "51612d69977167af717342a4f14ea43f",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 32900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532450",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112045867",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532452",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112045863",
                                          "name": "Salan (200 Ml)",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Large Biryanis (Serves 2 To 3)",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123478990",
                                  "name": "Large Chicken Biryani (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "inStock": 1,
                                  "price": 44900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532461",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112045954",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532464",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112046017",
                                          "name": "Salan (200 Ml)",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123478987",
                                  "name": "Large Chicken Biryani With Leg Piece (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "inStock": 1,
                                  "price": 48900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532480",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112045865",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532482",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112045859",
                                          "name": "Salan (200 Ml)",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123478988",
                                  "name": "Large Chicken Biryani Boneless (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "inStock": 1,
                                  "price": 48900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532491",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112046018",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532494",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112045948",
                                          "name": "Salan (200 Ml)",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.0",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123478991",
                                  "name": "Large Chicken Kabab Biryani (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "inStock": 1,
                                  "price": 49900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532503",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112045864",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532506",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112045857",
                                          "name": "Salan (200 Ml)",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123478994",
                                  "name": "Large Egg Biryani (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "inStock": 1,
                                  "price": 34900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532515",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112046025",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532517",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112046095",
                                          "name": "Salan (200 Ml)",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123478995",
                                  "name": "Large Dum Biryani Without Pieces (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "inStock": 1,
                                  "price": 24900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532526",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112046086",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532530",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112045973",
                                          "name": "Salan (200 Ml)",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123478992",
                                  "name": "Large Veg Biryani (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 37900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532537",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112045943",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532542",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112045853",
                                          "name": "Salan (200 Ml)",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123478993",
                                  "name": "Large Andhra Paneer Biryani (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 47900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532551",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112046003",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532554",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112045974",
                                          "name": "Salan (200 Ml)",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Family Biryanis (Serves 3 To 4)",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123478998",
                                  "name": "Chicken Family Biryani (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "inStock": 1,
                                  "price": 69900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532563",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112045882",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532568",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112046096",
                                          "name": "Salan (450 Ml)",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123478999",
                                  "name": "Family Chicken Biryani With Leg Piece (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "inStock": 1,
                                  "price": 79900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532579",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112045940",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532581",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112045983",
                                          "name": "Salan (450 Ml)",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123478996",
                                  "name": "Family Boneless Chicken Biryani (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "inStock": 1,
                                  "price": 84900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532594",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112046083",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532597",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112045889",
                                          "name": "Salan (450 Ml)",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123478997",
                                  "name": "Chicken Family Kabab Biryani (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "inStock": 1,
                                  "price": 84900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532613",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112046000",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532616",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112045984",
                                          "name": "Salan (450 Ml)",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123478967",
                                  "name": "Egg Family Biryani (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "inStock": 1,
                                  "price": 54900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532622",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112046080",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532624",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112045985",
                                          "name": "Salan (450 Ml)",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123478970",
                                  "name": "Dum Family Biryani Without Pieces (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "inStock": 1,
                                  "price": 39900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532633",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112045938",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532635",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112045890",
                                          "name": "Salan (450 Ml)",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123478971",
                                  "name": "Veg Family Biryani (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 59900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532640",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112045893",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532642",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112045926",
                                          "name": "Salan (450 Ml)",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123478968",
                                  "name": "Andhra Paneer Family Biryani (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 89900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532651",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112045988",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532652",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112046077",
                                          "name": "Salan (450 Ml)",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Family Combos (Serves 3 To 4)",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123478983",
                                  "name": "Chicken Biryani (Family Combos, Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "inStock": 1,
                                  "price": 99900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532657",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112046100",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532661",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112046015",
                                          "name": "Salan (450 Ml)",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123478980",
                                  "name": "Chicken Biryani Family Combo (Leg Piece, Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "inStock": 1,
                                  "price": 109900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532665",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112045914",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532667",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112046055",
                                          "name": "Salan (450 Ml)",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123478981",
                                  "name": "Chicken Biryani (Bnls, Family Combos, Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "inStock": 1,
                                  "price": 119900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532677",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112046014",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532680",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112045957",
                                          "name": "Salan (450 Ml)",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123478958",
                                  "name": "Chicken Kabab Biryani (Family Combos, Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "inStock": 1,
                                  "price": 119900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532684",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112046048",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532689",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112046059",
                                          "name": "Salan (450 Ml)",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123478960",
                                  "name": "Egg Biryani (Family Combos, Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "inStock": 1,
                                  "price": 89900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532696",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112046052",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532697",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112046041",
                                          "name": "Salan (450 Ml)",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123478961",
                                  "name": "Veg Biryani (Family Combos, Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 94900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532712",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112045953",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532715",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112045904",
                                          "name": "Salan (450 Ml)",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123478959",
                                  "name": "Andhra Paneer Biryani (Family Combos, Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 119900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532724",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112046050",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532730",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112045906",
                                          "name": "Salan (450 Ml)",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Bucket Biryanis (Serves 6 To 7)",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123478969",
                                  "name": "Chicken Bucket Biryani (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "inStock": 1,
                                  "price": 119900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532741",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112045927",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532744",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112045905",
                                          "name": "Salan (600 Ml)",
                                          "price": 12000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123478973",
                                  "name": "Chicken Bucket Biryani (Leg Piece, Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "inStock": 1,
                                  "price": 139900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532753",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112046073",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532757",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112046038",
                                          "name": "Salan (600 Ml)",
                                          "price": 12000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123478974",
                                  "name": "Chicken Bucket Biryani Boneless (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "inStock": 1,
                                  "price": 139900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532768",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112045873",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532770",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112045907",
                                          "name": "Salan (600 Ml)",
                                          "price": 12000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123478972",
                                  "name": "Egg Bucket Biryani (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "inStock": 1,
                                  "price": 89900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532782",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112046067",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532786",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112046042",
                                          "name": "Salan (600 Ml)",
                                          "price": 12000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123478975",
                                  "name": "Veg Bucket Biryani (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 99900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532795",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112045925",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532800",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112045903",
                                          "name": "Salan (600 Ml)",
                                          "price": 12000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Bucket Biryani Combos (Serves 6 To 7)",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123478976",
                                  "name": "Chicken Bucket Biryani Combo (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "inStock": 1,
                                  "price": 189900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532812",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112045870",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532815",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112046036",
                                          "name": "Salan (600 Ml)",
                                          "price": 12000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123478978",
                                  "name": "Chicken Bucket Biryani Combo (Leg Piece, Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "inStock": 1,
                                  "price": 209900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532825",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112045995",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532828",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112046039",
                                          "name": "Salan (600 Ml)",
                                          "price": 12000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123478979",
                                  "name": "Chicken Bucket Biryani Boneless Combo (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "inStock": 1,
                                  "price": 209900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532839",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112045936",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532841",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112045961",
                                          "name": "Salan (600 Ml)",
                                          "price": 12000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123478977",
                                  "name": "Egg Bucket Biryani Combo (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "inStock": 1,
                                  "price": 159900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532857",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112046016",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532861",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112045894",
                                          "name": "Salan (600 Ml)",
                                          "price": 12000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123478982",
                                  "name": "Veg Bucket Biryani Combo (Jeera Samba)",
                                  "category": "Jeera Samba Biryani",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 169900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "133532870",
                                      "groupName": "Raita 100ml",
                                      "choices": [
                                        {
                                          "id": "112045913",
                                          "name": "Raita (100 Ml)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "133532873",
                                      "groupName": "Salan",
                                      "choices": [
                                        {
                                          "id": "112045920",
                                          "name": "Salan (600 Ml)",
                                          "price": 12000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "D'lite Series Biryanis (Serves 1)",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815089",
                              "name": "Dlite Chicken Masaledar Biryani (Basmati)",
                              "category": "D'lite Series Biryanis (Serves 1)",
                              "description": "Dum biryani rice served with masaledar boneless chicken (10-12 pcs), 1 boiled egg, raita. Nutritional information (per 100 gms) : energy - 210. 95 kcal, protein - 8. 9 g,  carbs - 30. 45 g , fats - 5. 95 g, allergens: milk, egg. Serving size: 510 gms",
                              "imageId": "53c8fade0ff207e58469205d33198fca",
                              "inStock": 1,
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133532880",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112046097",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133532884",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112045981",
                                      "name": "Salan (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "112 ratings",
                                  "ratingCountV2": "112"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815087",
                              "name": "Dlite Chicken 65 Biryani (Basmati)",
                              "category": "D'lite Series Biryanis (Serves 1)",
                              "description": "Dum biryani rice topped with our signature chicken 65 (3 pcs), 1 boiled egg, raita. Nutritional information (per 100 gms) : energy - 196. 51 kcal, protein - 8. 9 g,  carbs - 29 g , fats - 4. 99 g, allergens: milk, egg. Serving size: 510 gms",
                              "imageId": "05610b649a22bb8461fc250ed1501210",
                              "inStock": 1,
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133532890",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112045877",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133532896",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112045883",
                                      "name": "Salan (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "55 ratings",
                                  "ratingCountV2": "55"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815076",
                              "name": "Dlite Chicken Biryani (Basmati)",
                              "category": "D'lite Series Biryanis (Serves 1)",
                              "description": "Dum biryani with 2 pieces of chicken (with bone), 1 boiled egg, raita. Nutritional information (per 100 gms) : energy - 191. 47 kcal, protein - 8. 9 g,  carbs - 27. 74 g , fats - 4. 99 g, allergens: milk, egg. Serving size: 510 gms",
                              "inStock": 1,
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.5",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "118288177",
                              "name": "Dlite Chicken Value Biryani (Basmati)",
                              "category": "D'lite Series Biryanis (Serves 1)",
                              "description": "Dum biryani with 1 piece of chicken (with bone), 1 boiled egg, raita. Nutritional information (per 100 gms) : energy - 191. 47 kcal, protein - 8. 9 g,  carbs - 27. 74 g , fats - 4. 99 g, allergens: milk, egg. Serving size: 510 gms",
                              "inStock": 1,
                              "price": 14900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "8 ratings",
                                  "ratingCountV2": "8"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "118288178",
                              "name": "Dlite Veg Biryani Half (Basmati)",
                              "category": "D'lite Series Biryanis (Serves 1)",
                              "description": "Vegetarian dum biryani with fresh vegetables & paneer cubes, raita. Nutritional information (per 100 gms) : energy - 205. 15 kcal, protein - 8. 9 g,  carbs -29 g , fats - 5. 95 g, allergens: milk. Serving size: 510 gms",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815067",
                              "name": "Dlite Chicken Kushka (Basmati)",
                              "category": "D'lite Series Biryanis (Serves 1)",
                              "description": "Dum biryani rice served with a mildly spiced flavoursome egg curry, raita. Nutritional information (per 100 gms) : energy - 107. 9 kcal, protein - 4. 9 g,  carbs -14. 2 g , fats - 3. 5 g, allergens: milk, egg. Serving size: 510 gms",
                              "inStock": 1,
                              "price": 15900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133532923",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112045937",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133532926",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112045891",
                                      "name": "Salan (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "32 ratings",
                                  "ratingCountV2": "32"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815081",
                              "name": "Dlite Achari Chicken Biryani (Basmati)",
                              "category": "D'lite Series Biryanis (Serves 1)",
                              "description": "Dum biryani rice topped with 10-12 small cubes of fried achari flavoured boneless chicken, 1 boiled egg, raita. Nutritional information (per 100 gms) : energy - 210. 95 kcal, protein - 8. 9 g,  carbs - 30. 45 g , fats - 5. 95 g, allergens: milk, egg. Serving size: 510 gms",
                              "imageId": "0f7bddc2bcf715474877688301cf95ca",
                              "inStock": 1,
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133532945",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112045918",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133532947",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112046051",
                                      "name": "Salan (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "35 ratings",
                                  "ratingCountV2": "35"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815093",
                              "name": "Dlite Masaledar Egg Biryani (Basmati)",
                              "category": "D'lite Series Biryanis (Serves 1)",
                              "description": "Dum biryani rice served with masaledar egg (2 no), raita. Nutritional information (per 100 gms) : energy - 163. 9 kcal, protein - 8. 9 g,  carbs - 24. 2 g , fats - 3. 5 g, allergens: milk, egg. Serving size: 510 gms",
                              "imageId": "ac5d3c984a2d9e4fee394f15d955f919",
                              "inStock": 1,
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133532959",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112046023",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133532960",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112046030",
                                      "name": "Salan (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815085",
                              "name": "Dlite Chatpata Paneer Biryani (Basmati)",
                              "category": "D'lite Series Biryanis (Serves 1)",
                              "description": "Plain vegetarian dum biryani rice topped with our chatapata mix of marinated paneer cubes, green peas & capsicum sauteed in a tangy & peppery sauce, raita. Nutritional information (per 100 gms) : energy - 176. 66  kcal, protein - 6. 3 g,  carbs - 27. 74 g , fats - 4. 5 g, allergens: milk. Serving size: 510 gms",
                              "imageId": "c63dd85e9a3cc24c7780f213c293ae9c",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133532970",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112046056",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133532972",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112045885",
                                      "name": "Salan (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "42 ratings",
                                  "ratingCountV2": "42"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815083",
                              "name": "Dlite Chatpata Chicken Biryani (Basmati)",
                              "category": "D'lite Series Biryanis (Serves 1)",
                              "description": "Dum biryani rice topped with marinated boneless chicken pieces sauteed in a tangy & peppery sauce, 1 boiled egg, raita. Nutritional information (per 100 gms) : energy - 210. 95 kcal, protein - 8. 9 g,  carbs - 30. 45 g , fats - 5. 95 g, allergens: milk, egg. Serving size: 510 gms",
                              "imageId": "f200557b05947cbff64289481a71f8d9",
                              "inStock": 1,
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133532980",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112046027",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133532981",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112045949",
                                      "name": "Salan (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "14 ratings",
                                  "ratingCountV2": "14"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815092",
                              "name": "Dlite Ipl Chicken Biryani (Basmati)",
                              "category": "D'lite Series Biryanis (Serves 1)",
                              "description": "Dum biryani rice topped with 12-14 cubes of fried chicken boneless kababs, 1 boiled egg, raita. Nutritional information (per 100 gms) : energy - 210. 95 kcal, protein - 8. 9 g,  carbs - 30. 45 g , fats - 5. 95 g, allergens: milk, egg. Serving size: 510 gms",
                              "imageId": "49525bb8fd8413546f67907e2174db0b",
                              "inStock": 1,
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133532989",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112046028",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133532990",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112046079",
                                      "name": "Salan (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "213 ratings",
                                  "ratingCountV2": "213"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Half Biryanis (Serves 1)",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815105",
                              "name": "Chicken Biryani With Leg Piece (Half)",
                              "category": "Half Biryanis (Serves 1)",
                              "description": "Dum biryani with 1 chicken drumstick & 1 chicken piece (with bone), 1 boiled egg, raita. Nutritional information (per 100 gms) : energy - 191. 47 kcal, protein - 8. 9 g,  carbs - 27. 74 g , fats - 4. 99 g, allergens: milk, egg. Serving size: 540 gms",
                              "imageId": "bfc500638995978210f0a40981a10779",
                              "inStock": 1,
                              "price": 23900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133532999",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112046074",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533001",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112045933",
                                      "name": "Salan (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.6",
                                  "ratingCount": "15 ratings",
                                  "ratingCountV2": "15"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815104",
                              "name": "Chicken Biryani Boneless (Half)",
                              "category": "Half Biryanis (Serves 1)",
                              "description": "Dum biryani with 10/12 cubes of boneless chicken, 1 boiled egg, raita. Nutritional information (per 100 gms) : energy - 191. 47 kcal, protein - 8. 9 g,  carbs - 27. 74 g , fats - 4. 99 g, allergens: milk, egg. Serving size: 540 gms",
                              "imageId": "398577477480764c66d01dc1cee88c26",
                              "inStock": 1,
                              "price": 23900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533009",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112045928",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533012",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112045958",
                                      "name": "Salan (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "20 ratings",
                                  "ratingCountV2": "20"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815115",
                              "name": "Chicken Kabab Biryani (Half)",
                              "category": "Half Biryanis (Serves 1)",
                              "description": "Dum biryani rice topped with chef's special boneless chicken, 1 boiled egg, raita. Nutritional information (per 100 gms) : energy - 210. 95 kcal, protein - 8. 9 g,  carbs - 30 g , fats - 5. 95 g, allergens: milk, egg. Serving size: 540 gms",
                              "imageId": "ff33d041d839877a7ada7fd26362e834",
                              "inStock": 1,
                              "price": 25900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533020",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112045990",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533022",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112045945",
                                      "name": "Salan (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "152 ratings",
                                  "ratingCountV2": "152"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "120557652",
                              "name": "Chicken Biryani (Half)",
                              "category": "Half Biryanis (Serves 1)",
                              "description": "Biryani with 3 pieces of chicken, 1 boiled egg, raita and salan",
                              "imageId": "2719e0bf37ad47d5ecb192d80dc3c7b9",
                              "inStock": 1,
                              "price": 22900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533032",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112045987",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533033",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112045924",
                                      "name": "Salan (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "128 ratings",
                                  "ratingCountV2": "128"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815119",
                              "name": "Fish Biryani (Half)",
                              "category": "Half Biryanis (Serves 1)",
                              "description": "Dum biryani rice with 10/12 small cubes of boneless fish, raita. Nutritional information (per 100 gms) : energy - 174. 47 kcal, protein - 7. 9 g,  carbs - 26. 74 g , fats - 3. 99 g, allergens: milk, egg. Serving size: 540 gms",
                              "imageId": "4aef53e1ecc51e1f028822d5061333c9",
                              "inStock": 1,
                              "price": 32900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533046",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112046108",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533047",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112046011",
                                      "name": "Salan (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "32 ratings",
                                  "ratingCountV2": "32"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815074",
                              "name": "Egg Biryani (Half)",
                              "category": "Half Biryanis (Serves 1)",
                              "description": "Dum biryani with 2 boiled eggs, raita. Nutritional information (per 100 gms) : energy - 163. 9 kcal, protein - 8. 9 g,  carbs - 24. 2 g , fats - 3. 5 g, allergens: milk, egg. Serving size: 540 gms",
                              "imageId": "7073e1421b5ffd33a71a0cba31a45c2d",
                              "inStock": 1,
                              "price": 16900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533054",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112045922",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533056",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112046061",
                                      "name": "Salan (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "234 ratings",
                                  "ratingCountV2": "234"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815070",
                              "name": "Dum Biryani Without Pieces (Half)",
                              "category": "Half Biryanis (Serves 1)",
                              "description": "Plain dum biryani rice, raita. Nutritional information (per 100 gms) : energy - 107. 9  kcal, protein - 4. 9 g,  carbs - 14. 2 g , fats - 3. 5 g, allergens: milk, egg. Serving size: 540 gms",
                              "imageId": "bda8daa2fb259ac99be9759d8c53054c",
                              "inStock": 1,
                              "price": 11900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533063",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112045892",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533065",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112046040",
                                      "name": "Salan (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "62 ratings",
                                  "ratingCountV2": "62"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815097",
                              "name": "Veg Biryani (Half)",
                              "category": "Half Biryanis (Serves 1)",
                              "description": "Vegetarian dum biryani with fresh vegetables & paneer cubes, raita. Nutritional information (per 100 gms) : energy - 176. 66  kcal, protein - 6. 3 g,  carbs - 27. 74 g , fats - 4. 5 g, allergens: milk. Serving size: 540 gms",
                              "imageId": "9b29adef928604a16d725e0d74a34490",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533070",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112046057",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533072",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112046101",
                                      "name": "Salan (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "263 ratings",
                                  "ratingCountV2": "263"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815108",
                              "name": "Andhra Paneer Biryani (Half)",
                              "category": "Half Biryanis (Serves 1)",
                              "description": "Plain vegetarian dum biryani topped with paneer cubes sauteed in spicy andhra masala, raita. Nutritional information (per 100 gms) : energy - 205. 15 kcal, protein - 8. 9 g,  carbs -29 g , fats - 5. 95 g, allergens: milk. Serving size: 540 gms",
                              "imageId": "3fb3ccfa14ec37c1dd0c1b1ecd008ab6",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 24900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533074",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112045959",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533076",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112046070",
                                      "name": "Salan (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "65 ratings",
                                  "ratingCountV2": "65"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Regular Biryanis (Serves 1)",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815113",
                              "name": "Chicken Biryani Leg Piece (Regular)",
                              "category": "Regular Biryanis (Serves 1)",
                              "description": "Dum biryani with 1 chicken drumstick & 1 chicken piece (with bone), 1 boiled egg, raita. Nutritional information (per 100 gms) : energy - 191. 47 kcal, protein - 8. 9 g,  carbs - 27. 74 g , fats - 4. 99 g, allergens: milk, egg. Serving size: 640 gms",
                              "imageId": "701f83eaf72497570176a9576422f4b0",
                              "inStock": 1,
                              "price": 25900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533082",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112045884",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533083",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112045997",
                                      "name": "Salan (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "68 ratings",
                                  "ratingCountV2": "68"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815112",
                              "name": "Chicken Biryani Boneless (Regular)",
                              "category": "Regular Biryanis (Serves 1)",
                              "description": "Dum biryani with 10/12 cubes of boneless chicken, 1 boiled egg, raita. Nutritional information (per 100 gms) : energy - 191. 47 kcal, protein - 8. 9 g,  carbs - 27. 74 g , fats - 4. 99 g, allergens: milk, egg. Serving size: 640 gms",
                              "imageId": "91ae6cee2a297d5bc389998b4d735dd5",
                              "inStock": 1,
                              "price": 25900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533088",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112046006",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533089",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112046060",
                                      "name": "Salan (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "134 ratings",
                                  "ratingCountV2": "134"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815116",
                              "name": "Chicken Kabab Biryani (Regular)",
                              "category": "Regular Biryanis (Serves 1)",
                              "description": "Dum biryani rice topped with chef's special boneless chicken, 1 boiled egg, raita. Nutritional information (per 100 gms) : energy - 210. 95 kcal, protein - 8. 9 g,  carbs - 30 g , fats - 5. 95 g, allergens: milk, egg. Serving size: 640 gms",
                              "imageId": "a144bf4c1ee3685d1247ff8e54696463",
                              "inStock": 1,
                              "price": 27900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533094",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112045942",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533095",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112046091",
                                      "name": "Salan (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "271 ratings",
                                  "ratingCountV2": "271"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815121",
                              "name": "Fish Biryani (Regular)",
                              "category": "Regular Biryanis (Serves 1)",
                              "description": "Dum biryani rice with 10/12 small cubes of boneless fish, raita. Nutritional information (per 100 gms) : energy - 174. 47 kcal, protein - 7. 9 g,  carbs - 26. 74 g , fats - 3. 99 g, allergens: milk, egg. Serving size: 640 gms",
                              "imageId": "c641b7642f466cae0df8d01f788f8313",
                              "inStock": 1,
                              "price": 34900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533100",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112046087",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533103",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112046105",
                                      "name": "Salan (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815096",
                              "name": "Egg Biryani (Regular)",
                              "category": "Regular Biryanis (Serves 1)",
                              "description": "Dum biryani with 2 boiled eggs, raita. Nutritional information (per 100 gms) : energy - 163. 9 kcal, protein - 8. 9 g,  carbs - 24. 2 g , fats - 3. 5 g, allergens: milk, egg. Serving size: 640 gms",
                              "imageId": "dc304f1d77527bf25603614a70b8e69e",
                              "inStock": 1,
                              "price": 18900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533108",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112045909",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533109",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112045852",
                                      "name": "Salan (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "242 ratings",
                                  "ratingCountV2": "242"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815073",
                              "name": "Dum Biryani Without Pieces (Regular)",
                              "category": "Regular Biryanis (Serves 1)",
                              "description": "Plain dum biryani rice, raita. Nutritional information (per 100 gms) : energy - 107. 9  kcal, protein - 4. 9 g,  carbs - 14. 2 g , fats - 3. 5 g, allergens: milk, egg. Serving size: 640 gms",
                              "imageId": "b62f572325c0638640bcdbc0e86b657e",
                              "inStock": 1,
                              "price": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533113",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112046009",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533114",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112045860",
                                      "name": "Salan (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "22 ratings",
                                  "ratingCountV2": "22"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "72452196",
                              "name": "Andhra Paneer Biryani (Regular)",
                              "category": "Regular Biryanis (Serves 1)",
                              "description": "Plain vegetarian dum biryani topped with paneer cubes sauteed in spicy andhra masala, raita. Nutritional information (per 100 gms) : energy - 205. 15 kcal, protein - 8. 9 g,  carbs -29 g , fats - 5. 95 g, allergens: milk. Serving size: 640 gms",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 26900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533118",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112046044",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533119",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112045895",
                                      "name": "Salan (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "154 ratings",
                                  "ratingCountV2": "154"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815107",
                              "name": "Chicken Biryani (Regular)",
                              "category": "Regular Biryanis (Serves 1)",
                              "description": "Dum biryani with 3 pieces of chicken (with bone), 1 boiled egg, raita. Nutritional information (per 100 gms) : energy - 191. 47 kcal, protein - 8. 9 g,  carbs - 27. 74 g , fats - 4. 99 g, allergens: milk, egg. Serving size: 640 gms",
                              "imageId": "f8024fe32da4ff084957c55a8184fa2f",
                              "inStock": 1,
                              "price": 24900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533122",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112046029",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533123",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112046053",
                                      "name": "Salan (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "19 ratings",
                                  "ratingCountV2": "19"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815101",
                              "name": "Veg Biryani (Regular)",
                              "category": "Regular Biryanis (Serves 1)",
                              "description": "Biryani wth fresh vegetables and paneer chunks with raita",
                              "imageId": "5e51974f7c385591499970ea6254cfd4",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 21900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533125",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112045898",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533126",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112045964",
                                      "name": "Salan (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "66 ratings",
                                  "ratingCountV2": "66"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Full Biryanis (Serves 1 To 2)",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815122",
                              "name": "Chicken Biryani (Full)",
                              "category": "Full Biryanis (Serves 1 To 2)",
                              "description": "Dum biryani with 4 pieces of chicken (with bone), 1 boiled egg, raita. Nutritional information (per 100 gms) : energy - 191. 47 kcal, protein - 8. 9 g,  carbs - 27. 74 g , fats - 4. 99 g, allergens: milk, egg. Serving size: 850 gms",
                              "imageId": "9957da77109c4b3c2b2af1323a8b90b3",
                              "inStock": 1,
                              "price": 29900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533128",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112045952",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533129",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112046004",
                                      "name": "Salan (200 Ml)",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "54 ratings",
                                  "ratingCountV2": "54"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815125",
                              "name": "Chicken Biryani With Leg Piece (Full)",
                              "category": "Full Biryanis (Serves 1 To 2)",
                              "description": "Dum biryani with 1 chicken drumstick & 2 chicken pieces (with bone), 1 boiled egg, raita. Nutritional information (per 100 gms) : energy - 191. 47 kcal, protein - 8. 9 g,  carbs - 27. 74 g , fats - 4. 99 g, allergens: milk, egg. Serving size: 850 gms",
                              "imageId": "01823ff3ab61853fe49ed06d4243d5fd",
                              "inStock": 1,
                              "price": 30900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533130",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112046043",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533131",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112046090",
                                      "name": "Salan (200 Ml)",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "13 ratings",
                                  "ratingCountV2": "13"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815124",
                              "name": "Chicken Biryani Boneless (Full)",
                              "category": "Full Biryanis (Serves 1 To 2)",
                              "description": "Dum biryani with 15/16 cubes of boneless chicken, 1 boiled egg, raita. Nutritional information (per 100 gms) : energy - 191. 47 kcal, protein - 8. 9 g,  carbs - 27. 74 g , fats - 4. 99 g, allergens: milk, egg. Serving size: 850 gms",
                              "imageId": "f6ceb951bae3658150c6bb50d089bc41",
                              "inStock": 1,
                              "price": 32900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533133",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112046008",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533134",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112045934",
                                      "name": "Salan (200 Ml)",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "118 ratings",
                                  "ratingCountV2": "118"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815131",
                              "name": "Chicken Kabab Biryani (Full)",
                              "category": "Full Biryanis (Serves 1 To 2)",
                              "description": "Dum biryani rice topped with chef's special boneless chicken, 1 boiled egg, raita. Nutritional information (per 100 gms) : energy - 210. 95 kcal, protein - 8. 9 g,  carbs - 30 g , fats - 5. 95 g, allergens: milk, egg. Serving size: 850 gms",
                              "imageId": "4ed6d7af198b9dac9d42780ac5d22a16",
                              "inStock": 1,
                              "price": 34900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533137",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112045955",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533139",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112045989",
                                      "name": "Salan (200 Ml)",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "99 ratings",
                                  "ratingCountV2": "99"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815134",
                              "name": "Fish Biryani (Full)",
                              "category": "Full Biryanis (Serves 1 To 2)",
                              "description": "Dum biryani rice with 15/16 small cubes of boneless fish, raita. Nutritional information (per 100 gms) : energy - 174. 47 kcal, protein - 7. 9 g,  carbs - 26. 74 g , fats - 3. 99 g, allergens: milk, egg. Serving size: 850 gms",
                              "imageId": "2acdd8a142355ee957aae9639b86fcb9",
                              "inStock": 1,
                              "price": 42900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533145",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112045917",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533146",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112046065",
                                      "name": "Salan (200 Ml)",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116717976",
                              "name": "Egg Biryani (Full)",
                              "category": "Full Biryanis (Serves 1 To 2)",
                              "description": "Dum biryani with 3 boiled eggs, raita. Nutritional information (per 100 gms) : energy - 163. 9 kcal, protein - 8. 9 g,  carbs - 24. 2 g , fats - 3. 5 g, allergens: milk, egg. Serving size: 850 gms",
                              "imageId": "a2e0ac4ca671444d11a3c36797f20bbd",
                              "inStock": 1,
                              "price": 22900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533147",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112046104",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533148",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112046024",
                                      "name": "Salan (200 Ml)",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "42 ratings",
                                  "ratingCountV2": "42"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815095",
                              "name": "Dum Biryani Without Pieces (Full)",
                              "category": "Full Biryanis (Serves 1 To 2)",
                              "description": "Plain dum biryani rice, raita. Nutritional information (per 100 gms) : energy - 107. 9  kcal, protein - 4. 9 g,  carbs - 14. 2 g , fats - 3. 5 g, allergens: milk, egg. Serving size: 850 gms",
                              "imageId": "bbf09fab48a20d4abce019dc2e200235",
                              "inStock": 1,
                              "price": 16900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533150",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112045900",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533151",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112045921",
                                      "name": "Salan (200 Ml)",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "53 ratings",
                                  "ratingCountV2": "53"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815111",
                              "name": "Veg Biryani (Full)",
                              "category": "Full Biryanis (Serves 1 To 2)",
                              "description": "Vegetarian dum biryani with fresh vegetables & paneer cubes, raita. Nutritional information (per 100 gms) : energy - 176. 66  kcal, protein - 6. 3 g,  carbs - 27. 74 g , fats - 4. 5 g, allergens: milk. Serving size: 850 gms",
                              "imageId": "590dc8acd73a87d016969e311a09b701",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 25900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533153",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112046032",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533155",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112046106",
                                      "name": "Salan (200 Ml)",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "31 ratings",
                                  "ratingCountV2": "31"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815126",
                              "name": "Andhra Paneer Biryani (Full)",
                              "category": "Full Biryanis (Serves 1 To 2)",
                              "description": "Plain vegetarian dum biryani topped with paneer cubes sauteed in spicy andhra masala, raita. Nutritional information (per 100 gms) : energy - 205. 15 kcal, protein - 8. 9 g,  carbs -29 g , fats - 5. 95 g, allergens: milk. Serving size: 850 gms",
                              "imageId": "08bcf9b9454cb468e5a640cd155481da",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 32900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533157",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112046031",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533158",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112045919",
                                      "name": "Salan (200 Ml)",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "49 ratings",
                                  "ratingCountV2": "49"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Large Biryanis (Serves 2 To 3)",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815135",
                              "name": "Chicken Biryani (Large)",
                              "category": "Large Biryanis (Serves 2 To 3)",
                              "description": "Dum biryani with 6 pieces of chicken (with bone), 2 boiled eggs, raita. Nutritional information (per 100 gms) : energy - 191. 47 kcal, protein - 8. 9 g,  carbs - 27. 74 g , fats - 4. 99 g, allergens: milk, egg. Serving size: 1280 gms",
                              "imageId": "9a8d919d4e468db7819b48b9aa597e01",
                              "inStock": 1,
                              "price": 44900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533160",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112045899",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533161",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112046022",
                                      "name": "Salan (200 Ml)",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "15 ratings",
                                  "ratingCountV2": "15"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815139",
                              "name": "Chicken Biryani With Leg Piece (Large)",
                              "category": "Large Biryanis (Serves 2 To 3)",
                              "description": "Dum biryani with 2 chicken drumsticks & 3 chicken pieces (with bone), 2 boiled eggs, raita. Nutritional information (per 100 gms) : energy - 191. 47 kcal, protein - 8. 9 g,  carbs - 27. 74 g , fats - 4. 99 g, allergens: milk, egg. Serving size: 1280 gms",
                              "imageId": "92d14749daba49153ffd7abcdcdc557e",
                              "inStock": 1,
                              "price": 48900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533162",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112046035",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533163",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112046058",
                                      "name": "Salan (200 Ml)",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "9 ratings",
                                  "ratingCountV2": "9"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815138",
                              "name": "Chicken Biryani Boneless (Large)",
                              "category": "Large Biryanis (Serves 2 To 3)",
                              "description": "Dum biryani with 22-24 cubes of boneless chicken, 2 boiled eggs, raita. Nutritional information (per 100 gms) : energy - 191. 47 kcal, protein - 8. 9 g,  carbs - 27. 74 g , fats - 4. 99 g, allergens: milk, egg. Serving size: 1280 gms",
                              "imageId": "333f95b1f1eb946de8e085d126f806d6",
                              "inStock": 1,
                              "price": 48900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533164",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112046033",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533165",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112045939",
                                      "name": "Salan (200 Ml)",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "26 ratings",
                                  "ratingCountV2": "26"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815141",
                              "name": "Chicken Kabab Biryani (Large)",
                              "category": "Large Biryanis (Serves 2 To 3)",
                              "description": "Dum biryani rice topped with chef's special boneless chicken, 2 boiled eggs, raita. Nutritional information (per 100 gms) : energy - 210. 95 kcal, protein - 8. 9 g,  carbs - 30 g , fats - 5. 95 g, allergens: milk, egg. Serving size: 1280 gms",
                              "imageId": "f179b35940101b6390461115feaa0bf7",
                              "inStock": 1,
                              "price": 49900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533166",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112045901",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533167",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112046001",
                                      "name": "Salan (200 Ml)",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "30 ratings",
                                  "ratingCountV2": "30"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815129",
                              "name": "Egg Biryani (Large)",
                              "category": "Large Biryanis (Serves 2 To 3)",
                              "description": "Dum biryani with 4 boiled eggs, raita. Nutritional information (per 100 gms) : energy - 163. 9 kcal, protein - 8. 9 g,  carbs - 24. 2 g , fats - 3. 5 g, allergens: milk, egg. Serving size: 1280 gms",
                              "imageId": "22f26ef7c20448eb01f6a5f3ca3f7fd9",
                              "inStock": 1,
                              "price": 34900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533168",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112045902",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533169",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112046098",
                                      "name": "Salan (200 Ml)",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815103",
                              "name": "Dum Biryani Without Pieces (Large)",
                              "category": "Large Biryanis (Serves 2 To 3)",
                              "description": "Plain dum biryani rice, raita. Nutritional information (per 100 gms) : energy - 107. 9  kcal, protein - 4. 9 g,  carbs - 14. 2 g , fats - 3. 5 g, allergens: milk, egg. Serving size: 1280 gms",
                              "imageId": "a0f0bb08be6b0e297ed551fb2c1b368d",
                              "inStock": 1,
                              "price": 24900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533170",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112046034",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533171",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112045910",
                                      "name": "Salan (200 Ml)",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "23 ratings",
                                  "ratingCountV2": "23"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815133",
                              "name": "Veg Biryani (Large)",
                              "category": "Large Biryanis (Serves 2 To 3)",
                              "description": "Vegetarian dum biryani with fresh vegetables & paneer cubes, raita. Nutritional information (per 100 gms) : energy - 176. 66  kcal, protein - 6. 3 g,  carbs - 27. 74 g , fats - 4. 5 g, allergens: milk. Serving size: 1280 gms",
                              "imageId": "5e51974f7c385591499970ea6254cfd4",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 37900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533172",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112045956",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533173",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112045888",
                                      "name": "Salan (200 Ml)",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "22 ratings",
                                  "ratingCountV2": "22"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815136",
                              "name": "Andhra Paneer Biryani (Large)",
                              "category": "Large Biryanis (Serves 2 To 3)",
                              "description": "Plain vegetarian dum biryani topped with paneer cubes sauteed in spicy andhra masala, raita. Nutritional information (per 100 gms) : energy - 205. 15 kcal, protein - 8. 9 g,  carbs -29 g , fats - 5. 95 g, allergens: milk. Serving size: 1280 gms",
                              "imageId": "51612d69977167af717342a4f14ea43f",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 47900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533174",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112046054",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533175",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112046046",
                                      "name": "Salan (200 Ml)",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "9 ratings",
                                  "ratingCountV2": "9"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Family Biryani (Serves 3-4)",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815144",
                              "name": "Chicken Biryani (Family)",
                              "category": "Family Biryani (Serves 3-4)",
                              "description": "Dum biryani with 8 pieces of chicken (with bone), 3 boiled eggs, raita. Nutritional information (per 100 gms) : energy - 191. 47 kcal, protein - 8. 9 g,  carbs - 27. 74 g , fats - 4. 99 g, allergens: milk, egg. Serving size: 2130 gms",
                              "imageId": "a82f998ab1cde79922b46040c87549d3",
                              "inStock": 1,
                              "price": 69900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533176",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112046019",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533177",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112046103",
                                      "name": "Salan (450 Ml)",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "9 ratings",
                                  "ratingCountV2": "9"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815145",
                              "name": "Chicken Biryani With Leg Piece (Family)",
                              "category": "Family Biryani (Serves 3-4)",
                              "description": "Dum biryani with 3 chicken drumsticks & 4 chicken pieces (with bone), 3 boiled eggs, raita. Nutritional information (per 100 gms) : energy - 191. 47 kcal, protein - 8. 9 g,  carbs - 27. 74 g , fats - 4. 99 g, allergens: milk, egg. Serving size: 2130 gms",
                              "imageId": "d7a963915cf834df813f28bfc9eb8477",
                              "inStock": 1,
                              "price": 79900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533178",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112045915",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533179",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112045916",
                                      "name": "Salan (450 Ml)",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815147",
                              "name": "Chicken Biryani Boneless (Family)",
                              "category": "Family Biryani (Serves 3-4)",
                              "description": "Dum biryani with 30-34 cubes of boneless chicken, 3 boiled eggs, raita. Nutritional information (per 100 gms) : energy - 191. 47 kcal, protein - 8. 9 g,  carbs - 27. 74 g , fats - 4. 99 g, allergens: milk, egg. Serving size: 2130 gms",
                              "imageId": "1b7846d5fa16e75db13fc1ec27007f36",
                              "inStock": 1,
                              "price": 84900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533180",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112046045",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533181",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112045908",
                                      "name": "Salan (450 Ml)",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "10 ratings",
                                  "ratingCountV2": "10"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815149",
                              "name": "Chicken Kabab Biryani (Family)",
                              "category": "Family Biryani (Serves 3-4)",
                              "description": "Dum biryani rice topped with chef's special boneless chicken, 3 boiled eggs, raita. Nutritional information (per 100 gms) : energy - 210. 95 kcal, protein - 8. 9 g,  carbs - 30 g , fats - 5. 95 g, allergens: milk, egg. Serving size: 2130 gms",
                              "imageId": "38d17e052ac843a2e62fc9f9f603e46d",
                              "inStock": 1,
                              "price": 84900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533182",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112046010",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533183",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112046092",
                                      "name": "Salan (450 Ml)",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815137",
                              "name": "Egg Biryani (Family)",
                              "category": "Family Biryani (Serves 3-4)",
                              "description": "Dum biryani with 6 boiled eggs, raita. Nutritional information (per 100 gms) : energy - 163. 9 kcal, protein - 8. 9 g,  carbs - 24. 2 g , fats - 3. 5 g, allergens: milk, egg. Serving size: 2130 gms",
                              "imageId": "3545617f6299847e66d24430a45b3083",
                              "inStock": 1,
                              "price": 54900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533184",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112045911",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533185",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112045880",
                                      "name": "Salan (450 Ml)",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815132",
                              "name": "Dum Biryani Without Pieces (Family)",
                              "category": "Family Biryani (Serves 3-4)",
                              "description": "Plain dum biryani rice, raita. Nutritional information (per 100 gms) : energy - 107. 9  kcal, protein - 4. 9 g,  carbs - 14. 2 g , fats - 3. 5 g, allergens: milk, egg. Serving size: 2130 gms",
                              "imageId": "07fe804660d85a3f067870fc96f35e68",
                              "inStock": 1,
                              "price": 39900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533186",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112046013",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533187",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112045946",
                                      "name": "Salan (450 Ml)",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.3",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815142",
                              "name": "Veg Biryani (Family)",
                              "category": "Family Biryani (Serves 3-4)",
                              "description": "Vegetarian dum biryani with fresh vegetables & paneer cubes, raita. Nutritional information (per 100 gms) : energy - 176. 66  kcal, protein - 6. 3 g,  carbs - 27. 74 g , fats - 4. 5 g, allergens: milk. Serving size: 2130 gms",
                              "imageId": "04276cbbf349f5642ed1e7ece6264334",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 59900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533188",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112046047",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533189",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112046088",
                                      "name": "Salan (450 Ml)",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "22 ratings",
                                  "ratingCountV2": "22"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815150",
                              "name": "Andhra Paneer Biryani (Family)",
                              "category": "Family Biryani (Serves 3-4)",
                              "description": "Plain vegetarian dum biryani topped with paneer cubes sauteed in spicy andhra masala, raita. Nutritional information (per 100 gms) : energy - 205. 15 kcal, protein - 8. 9 g,  carbs -29 g , fats - 5. 95 g, allergens: milk. Serving size: 2130 gms",
                              "imageId": "cb0999e183d08793f0ee1ca89cc3c00a",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 89900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533190",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112045941",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533191",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112045999",
                                      "name": "Salan (450 Ml)",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Family Combos (Serves 3 To 4)",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815154",
                              "name": "Chicken Biryani (Family Combo)",
                              "category": "Family Combos (Serves 3 To 4)",
                              "description": "Dum biryani with 8 pieces chicken (with bone), 3 boiled eggs, chicken 65 (8 pcs), 1 soft drink pet bottle (500 ml), 4 gulab jamuns, raita. Nutritional information (per 100 gms) : energy - 191. 47 kcal, protein - 8. 9 g,  carbs - 27. 74 g , fats - 4. 99 g, allergens: milk, egg. Serving size: 2130 gms",
                              "imageId": "27a481f9d249676d8ff54e657a8b0c9c",
                              "inStock": 1,
                              "price": 99900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533192",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112046085",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533193",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112045879",
                                      "name": "Salan (450 Ml)",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815155",
                              "name": "Chicken Biryani With Leg Piece (Family Combo)",
                              "category": "Family Combos (Serves 3 To 4)",
                              "description": "Dum biryani with 3 chicken drumsticks & 4 chicken pieces (with bone), 3 boiled eggs, chicken 65 (8 pcs), 1 soft drink pet bottle (500 ml), 4 gulab jamuns, raita. Nutritional information (per 100 gms) : energy - 191. 47 kcal, protein - 8. 9 g,  carbs - 27. 74 g , fats - 4. 99 g, allergens: milk, egg. Serving size: 2130 gms",
                              "inStock": 1,
                              "price": 109900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533194",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112045998",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533195",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112046084",
                                      "name": "Salan (450 Ml)",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815157",
                              "name": "Chicken Biryani Boneless (Family Combo)",
                              "category": "Family Combos (Serves 3 To 4)",
                              "description": "Dum biryani with 30-34 cubes of boneless chicken, 3 boiled eggs, chicken 65 (8 pcs), 1 soft drink pet bottle (500 ml), 4 gulab jamuns, raita. Nutritional information (per 100 gms) : energy - 191. 47 kcal, protein - 8. 9 g,  carbs - 27. 74 g , fats - 4. 99 g, allergens: milk, egg. Serving size: 230 gms",
                              "imageId": "073fe9ee6d65e9d0c1a44d2b6da96e2c",
                              "inStock": 1,
                              "price": 119900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533196",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112045929",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533197",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112045923",
                                      "name": "Salan (450 Ml)",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815159",
                              "name": "Chicken Kabab Biryani (Family Combo)",
                              "category": "Family Combos (Serves 3 To 4)",
                              "description": "Dum biryani rice topped with chef's special boneless chicken, 3 boiled eggs, chicken 65 (8 pcs), 1 soft drink pet bottle (500 ml), 4 gulab jamuns, raita. Nutritional information (per 100 gms) : energy - 210. 95 kcal, protein - 8. 9 g,  carbs - 30 g , fats - 5. 95 g, allergens: milk, egg. Serving size: 2130 gms",
                              "imageId": "a8902e5dcb1d69ea77537b8216a4d7ff",
                              "inStock": 1,
                              "price": 119900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533198",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112046075",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533199",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112045896",
                                      "name": "Salan (450 Ml)",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815160",
                              "name": "Andhra Paneer Biryani (Family Combos)",
                              "category": "Family Combos (Serves 3 To 4)",
                              "description": "Plain vegetarian dum biryani topped with paneer cubes sauteed in spicy andhra masala, gobi manchurian, 1 soft drink pet bottle (500 ml), 4 gulab jamuns, raita. Nutritional information (per 100 gms) : energy - 205. 15 kcal, protein - 8. 9 g,  carbs -29 g , fats - 5. 95 g, allergens: milk. Serving size: 2130 gms",
                              "imageId": "0799ed246c9db9d85f1ab135c42afdd3",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 119900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533200",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112046064",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533201",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112045992",
                                      "name": "Salan (450 Ml)",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815146",
                              "name": "Egg Biryani (Family Combos)",
                              "category": "Family Combos (Serves 3 To 4)",
                              "description": "Dum biryani with 6 boiled eggs, chicken 65 (8 pcs), 1 soft drink pet bottle (500 ml), 4 gulab jamuns, raita. Nutritional information (per 100 gms) : energy - 163. 9 kcal, protein - 8. 9 g,  carbs - 24. 2 g , fats - 3. 5 g, allergens: milk, egg. Serving size: 230 gms",
                              "imageId": "778d38a9e3d57a6eddbed9911f5b93b8",
                              "inStock": 1,
                              "price": 89900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533202",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112046063",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533203",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112046071",
                                      "name": "Salan (450 Ml)",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815152",
                              "name": "Veg Biryani (Family Combos)",
                              "category": "Family Combos (Serves 3 To 4)",
                              "description": "Vegetarian dum biryani with fresh vegetables & paneer cubes, paneer tukuda fry (16 pcs), 1 soft drink pet bottle (500 ml), 4 gulab jamuns, raita. Nutritional information (per 100 gms) : energy - 176. 66  kcal, protein - 6. 3 g,  carbs - 27. 74 g , fats - 4. 5 g, allergens: milk. Serving size: 230 gms",
                              "imageId": "d26439833114f03d3a3f1897c3be0a20",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 94900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533204",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112045960",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533205",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112045872",
                                      "name": "Salan (450 Ml)",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Bucket Biryanis (Serves 6 To 7)",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815161",
                              "name": "Chicken Biryani (Bucket)",
                              "category": "Bucket Biryanis (Serves 6 To 7)",
                              "description": "Dum biryani with 12 pieces of chicken (with bone), 6 boiled eggs, raita. Nutritional information (per 100 gms) : energy - 191. 47 kcal, protein - 8. 9 g,  carbs - 27. 74 g , fats - 4. 99 g, allergens: milk, egg. Serving size: 3740 gms",
                              "imageId": "88fec06dff6f1a45b6b76c7e469c08ca",
                              "inStock": 1,
                              "price": 119900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533206",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112045897",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533207",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112045854",
                                      "name": "Salan (600 Ml)",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.6",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815164",
                              "name": "Chicken Biryani With Leg Piece (Bucket)",
                              "category": "Bucket Biryanis (Serves 6 To 7)",
                              "description": "Dum biryani with 6 chicken drumsticks & 6 chicken pieces (with bone), 6 boiled eggs, raita. Nutritional information (per 100 gms) : energy - 191. 47 kcal, protein - 8. 9 g,  carbs - 27. 74 g , fats - 4. 99 g, allergens: milk, egg. Serving size: 3740 gms",
                              "imageId": "303a863de0a7ea085fe3f2d3665e28ac",
                              "inStock": 1,
                              "price": 139900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533208",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112045986",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533209",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112045975",
                                      "name": "Salan (600 Ml)",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815165",
                              "name": "Chicken Biryani Boneless (Bucket)",
                              "category": "Bucket Biryanis (Serves 6 To 7)",
                              "description": "Dum biryani with 55-60 cubes of boneless chicken, 6 boiled eggs, raita. Nutritional information (per 100 gms) : energy - 191. 47 kcal, protein - 8. 9 g,  carbs - 27. 74 g , fats - 4. 99 g, allergens: milk, egg. Serving size: 3740 gms",
                              "imageId": "7260ac257543c99a1d6f447c8bc1bc35",
                              "inStock": 1,
                              "price": 139900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533210",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112046068",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533211",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112045855",
                                      "name": "Salan (600 Ml)",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815151",
                              "name": "Egg Biryani (Bucket)",
                              "category": "Bucket Biryanis (Serves 6 To 7)",
                              "description": "Dum biryani with 12 boiled eggs, raita. Nutritional information (per 100 gms) : energy - 163. 9 kcal, protein - 8. 9 g,  carbs - 24. 2 g , fats - 3. 5 g, allergens: milk, egg. Serving size: 3740 gms",
                              "imageId": "e37cfbb22cd9a09d82f8723112212312",
                              "inStock": 1,
                              "price": 89900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533212",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112046005",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533213",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112046007",
                                      "name": "Salan (600 Ml)",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815156",
                              "name": "Veg Biryani (Bucket)",
                              "category": "Bucket Biryanis (Serves 6 To 7)",
                              "description": "Veg biryani cooked with fresh seasonal vegetables and paneer + raita",
                              "imageId": "af1792b95e422087d3e752b91e5947a3",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 99900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533214",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112046089",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533215",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112045858",
                                      "name": "Salan (600 Ml)",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Bucket Biryani Combos (Serves 6 To 7)",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815167",
                              "name": "Chicken Biryani (Bucket Combo)",
                              "category": "Bucket Biryani Combos (Serves 6 To 7)",
                              "description": "Dum biryani with 12 pieces of chicken (with bone), 6 boiled eggs, 2 starters (chicken 65 & achaari chicken), 2 soft drink pet bottles (500 ml each), 6 gulab jamuns, raita. Nutritional information (per 100 gms) : energy - 191. 47 kcal, protein - 8. 9 g,  carbs - 27. 74 g , fats - 4. 99 g, allergens: milk, egg. Serving size: 3740 gms",
                              "imageId": "a382cdd0605f1efe1bb20471e04ed6ad",
                              "inStock": 1,
                              "price": 189900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533216",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112045944",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533217",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112045951",
                                      "name": "Salan (600 Ml)",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815170",
                              "name": "Chicken Biryani With Leg Piece (Bucket Combo)",
                              "category": "Bucket Biryani Combos (Serves 6 To 7)",
                              "description": "Dum biryani with 6 chicken drumsticks & 6 chicken pieces (with bone), 6 boiled eggs, 2 starters (chicken 65 & achaari chicken), 2 soft drink pet bottles (500 ml each), 6 gulab jamuns, raita. Nutritional information (per 100 gms) : energy - 191. 47 kcal, protein - 8. 9 g,  carbs - 27. 74 g , fats - 4. 99 g, allergens: milk, egg. Serving size: 3740 gms",
                              "imageId": "fbaa084a8a9d6b9e39c5bd5eee181a1a",
                              "inStock": 1,
                              "price": 209900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533218",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112045881",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533219",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112045861",
                                      "name": "Salan (600 Ml)",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815169",
                              "name": "Chicken Biryani Boneless (Bucket Combo)",
                              "category": "Bucket Biryani Combos (Serves 6 To 7)",
                              "description": "Dum biryani with 55-60 cubes of boneless chicken, 6 boiled eggs, 2 starters (chicken 65 & achaari chicken), 2 soft drink pet bottles (500 ml each), 6 gulab jamuns, raita. Nutritional information (per 100 gms) : energy - 191. 47 kcal, protein - 8. 9 g,  carbs - 27. 74 g , fats - 4. 99 g, allergens: milk, egg. Serving size: 3740 gms",
                              "imageId": "f2620b0365f1451e8693f6ea8c39bc5c",
                              "inStock": 1,
                              "price": 209900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533220",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112046002",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533221",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112046012",
                                      "name": "Salan (600 Ml)",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815162",
                              "name": "Egg Biryani (Bucket Combo)",
                              "category": "Bucket Biryani Combos (Serves 6 To 7)",
                              "description": "Dum biryani with 12 boiled eggs, 2 starters (chicken 65 & achaari chicken), 2 soft drink pet bottles (500 ml each), 6 gulab jamuns, raita. Nutritional information (per 100 gms) : energy - 163. 9 kcal, protein - 8. 9 g,  carbs - 24. 2 g , fats - 3. 5 g, allergens: milk, egg. Serving size: 3740 gms",
                              "imageId": "dbe69e2bb96483a93a535ad1c3b2d6be",
                              "inStock": 1,
                              "price": 159900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533222",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112046082",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533223",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112046107",
                                      "name": "Salan (600 Ml)",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815166",
                              "name": "Veg Biryani (Bucket Combo)",
                              "category": "Bucket Biryani Combos (Serves 6 To 7)",
                              "description": "Vegetarian dum biryani with fresh vegetables & paneer cubes, 2 starters (paneer tukuda fry & gobi machurian), 2 soft drink pet bottles (500 ml each), 6 gulab jamuns, raita. Nutritional information (per 100 gms) : energy - 176. 66  kcal, protein - 6. 3 g,  carbs - 27. 74 g , fats - 4. 5 g, allergens: milk. Serving size: 3740 gms",
                              "imageId": "f1c657cff85655dfd18669d54e5c1646",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 169900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "133533224",
                                  "groupName": "Raita 100ml",
                                  "choices": [
                                    {
                                      "id": "112045878",
                                      "name": "Raita (100 Ml)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "133533225",
                                  "groupName": "Salan",
                                  "choices": [
                                    {
                                      "id": "112045869",
                                      "name": "Salan (600 Ml)",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Soft Drinks, Desserts And Extra",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "42335976",
                              "name": "Gulab Jamun (2 Pcs)",
                              "category": "Soft Drinks, Desserts And Extra",
                              "description": "Nutritional information (per 100 gms) : energy - 153. 3 kcal, protein - 1. 9 g,  carbs -20 g , fats - 7. 3 g, allergens: milk. Serving size: 140 gms",
                              "imageId": "ed75842c2f1eda868907463afd5d7a95",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6300,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "84 ratings",
                                  "ratingCountV2": "84"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112922751",
                              "name": "Salan (100 Ml)",
                              "category": "Soft Drinks, Desserts And Extra",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "334 ratings",
                                  "ratingCountV2": "334"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112922737",
                              "name": "Salan (200 Ml)",
                              "category": "Soft Drinks, Desserts And Extra",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 4500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112922739",
                              "name": "Salan (450 Ml)",
                              "category": "Soft Drinks, Desserts And Extra",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112922740",
                              "name": "Salan (600 Ml)",
                              "category": "Soft Drinks, Desserts And Extra",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "48728355",
                              "name": "Raita (100 Ml)",
                              "category": "Soft Drinks, Desserts And Extra",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "140 ratings",
                                  "ratingCountV2": "140"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "120375160",
                              "name": "Raita (200 Ml)",
                              "category": "Soft Drinks, Desserts And Extra",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 4000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "10 ratings",
                                  "ratingCountV2": "10"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115815061",
                              "name": "Manis Water Bottle (1 Ltr)",
                              "category": "Soft Drinks, Desserts And Extra",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "57595742",
                              "name": "Extra Egg",
                              "category": "Soft Drinks, Desserts And Extra",
                              "inStock": 1,
                              "price": 1000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "47 ratings",
                                  "ratingCountV2": "47"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                      "type": "FSSAI",
                      "imageId": "fssai_final_edss9i",
                      "text": [
                        "License No. 11219334001387"
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                      "name": "Mani's Dum Biryani",
                      "area": "HSR Layout",
                      "completeAddress": "HSR Layout, Bengaluru, Karnataka, India"
                    }
                  }
                }
              ]
            }
          }
        }
      }
    ],
    "firstOffsetRequest": true,
    "isQCLink": false
  },
  "tid": "8091b6c9-34ec-4881-8b5e-d2b6a4328fa1",
  "sid": "c8b69dc8-6710-47a7-bc63-18091856e3fa",
  "deviceId": "c73fa13e-69cf-472b-8071-076091f9d98d",
  "csrfToken": "QbwNqw5OSLed-gFLrNPn3gKw4DF4zGraFyioGrzk"
}

export const BIG_BOWL=
{
  "statusCode": 0,
  "data": {
    "statusMessage": "done successfully",
    "cards": [
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
            "info": {
              "id": "376713",
              "name": "Big Bowl",
              "city": "Bangalore",
              "slugs": {
                "restaurant": "big-bowl-company-hsr-hsr",
                "city": "bangalore"
              },
              "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
              "cloudinaryImageId": "c99751d54e4e1847186c62b3309c1327",
              "locality": "3rd Sector",
              "areaName": "HSR Layout",
              "costForTwo": "25000",
              "costForTwoMessage": "₹250 for two",
              "cuisines": [
                "North Indian",
                "Chinese"
              ],
              "avgRating": 4,
              "feeDetails": {
                "restaurantId": "376713",
                "fees": [
                  {
                    "name": "distance",
                    "fee": 3200
                  },
                  {
                    "name": "time"
                  },
                  {
                    "name": "special"
                  }
                ],
                "totalFee": 3200,
                "icon": "v1648635511/Delivery_fee_new_cjxumu",
                "message": "1 kms | ₹32 Delivery fee will apply"
              },
              "parentId": "434792",
              "avgRatingString": "4.0",
              "totalRatingsString": "1K+ ratings",
              "sla": {
                "restaurantId": "376713",
                "deliveryTime": 23,
                "minDeliveryTime": 20,
                "maxDeliveryTime": 25,
                "lastMileTravel": 1,
                "serviceability": "SERVICEABLE",
                "stressFactor": 1,
                "rainMode": "RAIN_MODE_NONE",
                "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
                "zoneId": 3,
                "slaString": "20-25 MINS",
                "lastMileTravelString": "1.0 km",
                "iconType": "ICON_TYPE_EMPTY"
              },
              "availability": {
                "nextCloseTime": "2024-02-19 02:00:00",
                "visibility": true,
                "opened": true,
                "restaurantClosedMeta": {
                  
                }
              },
              "aggregatedDiscountInfo": {
                "header": "Get items under 169",
                "shortDescriptionList": [
                  {
                    "meta": "Get items under 169",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "50% off | Use TRYNEW",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "Get items under 169",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "50% off up to ₹100 | Use code TRYNEW",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "visible": true
              },
              "badges": {
                
              },
              "slugString": "big-bowl-company-hsr-hsr",
              "multiOutlet": true,
              "isOpen": true,
              "labels": [
                {
                  "title": "Timings",
                  "message": "null"
                },
                {
                  "title": "Address",
                  "message": "NO.1212, KATHA NO.688/1212, GROUND  FLOOR, SECTOR-III, HOSUR SARJAPUR ROAD,  HSR LAYOUT, BANGALORE, BTM Layout ,  B.B.M.P South, Karnataka-560102"
                },
                {
                  "title": "Cuisines",
                  "message": "North Indian,Chinese"
                }
              ],
              "totalRatings": 1000,
              "aggregatedDiscountInfoV2": {
                "header": "Get items under 169",
                "shortDescriptionList": [
                  {
                    "meta": "Get items under 169",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "50% off | Use TRYNEW",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "Get items under 169",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "50% off up to ₹100 | Use code TRYNEW",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "couponDetailsCta": "View coupon details"
              },
              "type": "F",
              "nudgeBanners": [
                {
                  "priority": 1,
                  "discountInfo": {
                    "discountType": "FinalPrice",
                    "value": 169
                  },
                  "unlockedMessage": "Deal of the Day unlocked!",
                  "minItemCount": 1,
                  "maxItemCount": 1,
                  "type": "SILD",
                  "nudgeTagInfo": {
                    "title": "Deal of the Day",
                    "fontName": "FONT_NAME_CONDENSED_BOLD"
                  },
                  "logoCtx": {
                    
                  }
                }
              ],
              "headerBanner": {
                "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/376713"
              },
              "expectationNotifiers": [
                {
                  "text": "1 kms | ₹32 Delivery fee will apply",
                  "icon": {
                    "imageId": "v1648635511/Delivery_fee_new_cjxumu"
                  },
                  "popup": {
                    "cta": {
                      
                    }
                  },
                  "type": "DISTANCE_FEE_NON_FOOD_LM",
                  "enrichedText": "<b>1 kms</b> | ₹32 Delivery fee will apply",
                  "halfCardPopup": {
                    "halfCardPopupHeader": {
                      
                    }
                  }
                }
              ],
              "ratingSlab": "RATING_SLAB_4",
              "orderabilityCommunication": {
                "title": {
                  
                },
                "subTitle": {
                  
                },
                "message": {
                  
                },
                "customIcon": {
                  
                }
              },
              "hasBestsellerItems": true,
              "hasGuiltfreeItems": true,
              "cartOrderabilityNudgeBanner": {
                "parameters": {
                  
                },
                "presentation": {
                  
                }
              },
              "latLong": "12.9093,77.638701",
              "backgroundImageOverlayInfo": {
                
              }
            },
            "analytics": {
              
            }
          },
          "relevance": {
            "type": "RELEVANCE_TYPE_CHECK_ORDERABILITY_ON_ITEM_ADD",
            "sectionId": "POP_UP_CROUTON_MENU"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "layout": {
              "rows": 1,
              "columns": 5,
              "horizontalScrollEnabled": true,
              "itemSpacing": 12,
              "lineSpacing": 10,
              "widgetPadding": {
                
              },
              "containerStyle": {
                "containerPadding": {
                  "left": 10,
                  "right": 10,
                  "bottom": 16
                }
              },
              "scrollBar": {
                
              }
            },
            "id": "offerCollectionWidget_UX4",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                "offers": [
                  {
                    "info": {
                      "header": "ITEMS AT ₹169",
                      "offerTag": "DEAL OF DAY",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "cea4d22a-274f-43b4-b1f4-1419e4abf37a"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "description": "ON SELECT ITEMS |",
                      "offerType": "offers",
                      "restId": "376713",
                      "offerLogo": "offers/deal-of-day",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "50% OFF UPTO ₹100",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "1c657321-760e-4ae8-99ab-5eac2425bcd7"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE TRYNEW",
                      "description": "ABOVE ₹159",
                      "offerType": "offers",
                      "restId": "376713",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹125 OFF",
                      "offerTag": "FLAT DEAL",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "ecd336fe-c710-452b-a1dc-84658a4ec355"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE SWIGGYWEEKENDS",
                      "description": "ABOVE ₹399",
                      "offerType": "offers",
                      "restId": "376713",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT 20% OFF",
                      "offerTag": "FLAT DEAL",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "9e99cd55-ad62-4c9f-97b7-315638fad2ca"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE PARTY",
                      "description": "ABOVE ₹700",
                      "offerType": "offers",
                      "restId": "376713",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹100 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "MARKETING_BANNERS/IMAGES/OFFERS/2024/2/17/1ed4245d-31e3-4dc6-b949-524a33b9b8c9_ICICI.png",
                      "offerIds": [
                        "299f5c31-dd4a-47a4-8d93-4ccb6be1a8a8"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "NO CODE REQUIRED",
                      "description": "ABOVE ₹550",
                      "offerType": "offers",
                      "restId": "376713",
                      "offerLogo": "MARKETING_BANNERS/IMAGES/OFFERS/2024/2/17/1ed4245d-31e3-4dc6-b949-524a33b9b8c9_ICICI.png",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  }
                ],
                "habitMilestoneInfo": {
                  "callout": {
                    
                  }
                },
                "loyaltyDiscoverPresentationInfo": {
                  "logoCtx": {
                    
                  }
                }
              }
            }
          }
        }
      },
      {
        "groupedCard": {
          "cardGroupMap": {
            "REGULAR": {
              "cards": [
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                      "badges": {
                        
                      },
                      "vegOnlyDetails": {
                        "imageId": "AutoVegOnly_qkjowj",
                        "title": "Showing only vegetarian options.",
                        "description": "Tap on the VEG ONLY button to turn off the setting"
                      },
                      "topRatedFilter": {
                        
                      },
                      "kidsCategoryFilter": {
                        "attributes": {
                          "displayText": "Kids Favourites",
                          "tooltip": {
                            "enabled": true,
                            "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                          }
                        }
                      },
                      "vegFilter": {
                        "attributes": {
                          "displayText": "VEG"
                        }
                      },
                      "nonvegFilter": {
                        "attributes": {
                          "displayText": "NONVEG"
                        }
                      }
                    },
                    "relevance": {
                      "type": "RELEVANCE_TYPE_ON_MENU_FILTER_TOGGLED",
                      "sectionId": "MENU_FILTER_TOGGLE"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Recommended",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "69492488",
                              "name": "Dal Fry Rice Bowl",
                              "category": "Indian Bowls",
                              "description": "Serves 1 | Yellow dal tempered with garlic and jeera served with jeera rice.",
                              "imageId": "cc2710c8da2c6c9d4d55a0b593b3e582",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "finalPrice": 16900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "itemNudgeType": "FinalPrice",
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "82 ratings",
                                  "ratingCountV2": "82"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "72570454",
                              "name": "Dal Khichdi Bowl",
                              "category": "Indian Bowls",
                              "description": "Serves 1 | Comfort of dal and rice mixed together with a tempering of garlic and jeera.",
                              "imageId": "df21feb97fc789dce1c27c6d5d5683df",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 20900,
                              "finalPrice": 16900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "27 ratings",
                                  "ratingCountV2": "27"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "69492493",
                              "name": "Rajma Chawal Bowl",
                              "category": "Indian Bowls",
                              "description": "Serves 1 | Home style cooked rajma gravy served with jeera rice.",
                              "imageId": "cfbe130bc6159126e4ef547f2576b2a0",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 23900,
                              "finalPrice": 16900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "itemNudgeType": "FinalPrice",
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "99 ratings",
                                  "ratingCountV2": "99"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "69258850",
                              "name": "Pindi Chole Rice Bowl",
                              "category": "Indian Bowls",
                              "description": "Serves 1 | Chole simmered in rich brown masala gravy served with jeera rice.",
                              "imageId": "c5f7de7f4adbed6b6fb9929b7b18ed00",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 25900,
                              "finalPrice": 16900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "itemNudgeType": "FinalPrice",
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.5",
                                  "ratingCount": "42 ratings",
                                  "ratingCountV2": "42"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "69492496",
                              "name": "Dal Makhani Rice Bowl",
                              "category": "Indian Bowls",
                              "description": "Serves 1 | Classic rich dal makhani served with jeera rice.",
                              "imageId": "879b6f09d0570952a752cf636bbf058e",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 21900,
                              "finalPrice": 16900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.8",
                                  "ratingCount": "69 ratings",
                                  "ratingCountV2": "69"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "69258856",
                              "name": "Paneer Butter Masala Rice Bowl",
                              "category": "Indian Bowls",
                              "description": "Serves 1 | Tender paneer cubes tossed in a rich makhani gravy served with jeera rice.",
                              "imageId": "77741423613b097ddb40967897a39920",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 29900,
                              "finalPrice": 16900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "itemNudgeType": "FinalPrice",
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "29 ratings",
                                  "ratingCountV2": "29"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "72570461",
                              "name": "Chicken Kadai Rice Bowl",
                              "category": "Indian Bowls",
                              "description": "Serves 1 | Char-grilled chicken with capsicum and onion tossed in a medium spicy kadhai gravy served with jeera rice.",
                              "imageId": "au2r5e8sbuharevtskwl",
                              "inStock": 1,
                              "price": 30900,
                              "finalPrice": 16900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "itemNudgeType": "FinalPrice",
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "69492568",
                              "name": "Smoky Butter Chicken Rice Bowl",
                              "category": "Indian Bowls",
                              "description": "Serves 1 | Smoky char-grilled chicken tossed in a rich makhani gravy served with jeera rice.",
                              "imageId": "ftty7hlxav5xfw0dsk8p",
                              "inStock": 1,
                              "price": 30900,
                              "finalPrice": 16900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "itemNudgeType": "FinalPrice",
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "47 ratings",
                                  "ratingCountV2": "47"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "72570460",
                              "name": "Spicy Butter Chicken Rice Bowl",
                              "category": "Indian Bowls",
                              "description": "Serves 1 | Smoky char-grilled chicken tossed in a rich medium spicy makhani gravy served with jeera rice.",
                              "imageId": "iocbgqsyrcakibvks7py",
                              "inStock": 1,
                              "price": 30900,
                              "finalPrice": 16900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "1.8",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "69492328",
                              "name": "Veg Hakka Noodles Bowl",
                              "category": "Chinese Bowls",
                              "description": "Serves 1 | Noodles tossed with cabbage, onion, carrot with a touch of dark soya & garnished with spring onion.",
                              "imageId": "cmzfdgkptykmalumzirf",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "138177280",
                                  "groupName": "Add Extra Dip",
                                  "choices": [
                                    {
                                      "id": "113732099",
                                      "name": "Extra Momo Chutney",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732092",
                                      "name": "Extra Schezwan Dip",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732095",
                                      "name": "Extra Sweet Chilli Dip",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732103",
                                      "name": "Extra Mayo Dip",
                                      "price": 2000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732091",
                                      "name": "Extra Tandoori Mayo Dip",
                                      "price": 2000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732098",
                                      "name": "Extra Mint Mayo Dip",
                                      "price": 2000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "138177281",
                                  "groupName": "Add  Drinks",
                                  "choices": [
                                    {
                                      "id": "113732125",
                                      "name": "Classic Lemon",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732120",
                                      "name": "Tender Coconut",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732096",
                                      "name": "Aam Panna",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732130",
                                      "name": "Masala Shikanji",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732085",
                                      "name": "Peach Ice Tea",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732084",
                                      "name": "Lemon Ice Tea",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732127",
                                      "name": "Pepsi Pet Bottle",
                                      "price": 6000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732128",
                                      "name": "7 Up Pet Bottle",
                                      "price": 6000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732121",
                                      "name": "Alphonso Mango",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732129",
                                      "name": "Mixed Fruit",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 10,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "138177282",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "113732086",
                                      "name": "Chocolate Mousse - Small",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732087",
                                      "name": "Black Forest Mousse Cake",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732088",
                                      "name": "Salted Caramel Choco Mousse",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732089",
                                      "name": "Choco Lava",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732126",
                                      "name": "Chocolate Mousse (Save Rs. 20)",
                                      "price": 8000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "138177285",
                                  "groupName": "Add Veg Starters",
                                  "choices": [
                                    {
                                      "id": "113732090",
                                      "name": "Chilli Paneer",
                                      "price": 30900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732113",
                                      "name": "Veg Spring Rolls (4 pcs)",
                                      "price": 16900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732093",
                                      "name": "Veg Manchurian Dry",
                                      "price": 26900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isGuiltfree": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "29 ratings",
                                  "ratingCountV2": "29"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "69492333",
                              "name": "Veg Chilli Garlic Noodles Bowl",
                              "category": "Chinese Bowls",
                              "description": "Serves 1 | Noodles tossed with carrot, capsicum & onion flavored with chilli flakes, garlic & soy, garnished with spring onion.",
                              "imageId": "xfjyhe98gcsbiuezyekt",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 21500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "138177237",
                                  "groupName": "Add Extra Dip",
                                  "choices": [
                                    {
                                      "id": "113732099",
                                      "name": "Extra Momo Chutney",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732092",
                                      "name": "Extra Schezwan Dip",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732095",
                                      "name": "Extra Sweet Chilli Dip",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732103",
                                      "name": "Extra Mayo Dip",
                                      "price": 2000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732091",
                                      "name": "Extra Tandoori Mayo Dip",
                                      "price": 2000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732098",
                                      "name": "Extra Mint Mayo Dip",
                                      "price": 2000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "138177239",
                                  "groupName": "Add  Drinks",
                                  "choices": [
                                    {
                                      "id": "113732125",
                                      "name": "Classic Lemon",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732120",
                                      "name": "Tender Coconut",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732096",
                                      "name": "Aam Panna",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732130",
                                      "name": "Masala Shikanji",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732085",
                                      "name": "Peach Ice Tea",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732084",
                                      "name": "Lemon Ice Tea",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732127",
                                      "name": "Pepsi Pet Bottle",
                                      "price": 6000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732128",
                                      "name": "7 Up Pet Bottle",
                                      "price": 6000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732121",
                                      "name": "Alphonso Mango",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732129",
                                      "name": "Mixed Fruit",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 10,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "138177241",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "113732086",
                                      "name": "Chocolate Mousse - Small",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732087",
                                      "name": "Black Forest Mousse Cake",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732088",
                                      "name": "Salted Caramel Choco Mousse",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732089",
                                      "name": "Choco Lava",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732126",
                                      "name": "Chocolate Mousse (Save Rs. 20)",
                                      "price": 8000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "138177243",
                                  "groupName": "Add Veg Starters",
                                  "choices": [
                                    {
                                      "id": "113732090",
                                      "name": "Chilli Paneer",
                                      "price": 30900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732113",
                                      "name": "Veg Spring Rolls (4 pcs)",
                                      "price": 16900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732093",
                                      "name": "Veg Manchurian Dry",
                                      "price": 26900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isGuiltfree": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "98 ratings",
                                  "ratingCountV2": "98"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "69492338",
                              "name": "Chicken Fried Rice Bowl",
                              "category": "Chinese Bowls",
                              "description": "Serves 1 | Rice tossed with diced chicken, egg & carrot, french beans & baby corn, garnished with spring onion.",
                              "imageId": "wdn1lxgfdacda4arhrmp",
                              "inStock": 1,
                              "price": 21500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "138177245",
                                  "groupName": "Add Extra Dip",
                                  "choices": [
                                    {
                                      "id": "113732099",
                                      "name": "Extra Momo Chutney",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732092",
                                      "name": "Extra Schezwan Dip",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732095",
                                      "name": "Extra Sweet Chilli Dip",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732103",
                                      "name": "Extra Mayo Dip",
                                      "price": 2000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732091",
                                      "name": "Extra Tandoori Mayo Dip",
                                      "price": 2000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732098",
                                      "name": "Extra Mint Mayo Dip",
                                      "price": 2000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "138177246",
                                  "groupName": "Add  Drinks",
                                  "choices": [
                                    {
                                      "id": "113732125",
                                      "name": "Classic Lemon",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732120",
                                      "name": "Tender Coconut",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732096",
                                      "name": "Aam Panna",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732130",
                                      "name": "Masala Shikanji",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732085",
                                      "name": "Peach Ice Tea",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732084",
                                      "name": "Lemon Ice Tea",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732127",
                                      "name": "Pepsi Pet Bottle",
                                      "price": 6000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732128",
                                      "name": "7 Up Pet Bottle",
                                      "price": 6000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732121",
                                      "name": "Alphonso Mango",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732129",
                                      "name": "Mixed Fruit",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 10,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "138177247",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "113732086",
                                      "name": "Chocolate Mousse - Small",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732087",
                                      "name": "Black Forest Mousse Cake",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732088",
                                      "name": "Salted Caramel Choco Mousse",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732089",
                                      "name": "Choco Lava",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732126",
                                      "name": "Chocolate Mousse (Save Rs. 20)",
                                      "price": 8000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "138177249",
                                  "groupName": "Add Non Veg Starters",
                                  "choices": [
                                    {
                                      "id": "113732094",
                                      "name": "Chicken Spring Roll (4pcs)",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732097",
                                      "name": "Chilli Chicken",
                                      "price": 33900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732108",
                                      "name": "Chicken Manchurian",
                                      "price": 33900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.2",
                                  "ratingCount": "143 ratings",
                                  "ratingCountV2": "143"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "69492344",
                              "name": "Chicken Chilli Garlic Fried Rice Bowl",
                              "category": "Chinese Bowls",
                              "description": "Serves 1 | Rice tossed with carrot,french beans & babycorn,egg ,chicken flavoured with soy,garlic and chilli flakes garnished with spring onion.",
                              "imageId": "cpxp6evxmc970hbah8zd",
                              "inStock": 1,
                              "price": 25900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "138177528",
                                  "groupName": "Add Extra Dip",
                                  "choices": [
                                    {
                                      "id": "113732099",
                                      "name": "Extra Momo Chutney",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732092",
                                      "name": "Extra Schezwan Dip",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732095",
                                      "name": "Extra Sweet Chilli Dip",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732103",
                                      "name": "Extra Mayo Dip",
                                      "price": 2000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732091",
                                      "name": "Extra Tandoori Mayo Dip",
                                      "price": 2000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732098",
                                      "name": "Extra Mint Mayo Dip",
                                      "price": 2000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "138177530",
                                  "groupName": "Add  Drinks",
                                  "choices": [
                                    {
                                      "id": "113732125",
                                      "name": "Classic Lemon",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732120",
                                      "name": "Tender Coconut",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732096",
                                      "name": "Aam Panna",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732130",
                                      "name": "Masala Shikanji",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732085",
                                      "name": "Peach Ice Tea",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732084",
                                      "name": "Lemon Ice Tea",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732127",
                                      "name": "Pepsi Pet Bottle",
                                      "price": 6000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732128",
                                      "name": "7 Up Pet Bottle",
                                      "price": 6000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732121",
                                      "name": "Alphonso Mango",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732129",
                                      "name": "Mixed Fruit",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 10,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "138177531",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "113732086",
                                      "name": "Chocolate Mousse - Small",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732087",
                                      "name": "Black Forest Mousse Cake",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732088",
                                      "name": "Salted Caramel Choco Mousse",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732089",
                                      "name": "Choco Lava",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732126",
                                      "name": "Chocolate Mousse (Save Rs. 20)",
                                      "price": 8000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "138177532",
                                  "groupName": "Add Non Veg Starters",
                                  "choices": [
                                    {
                                      "id": "113732094",
                                      "name": "Chicken Spring Roll (4pcs)",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732097",
                                      "name": "Chilli Chicken",
                                      "price": 33900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732108",
                                      "name": "Chicken Manchurian",
                                      "price": 33900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.3",
                                  "ratingCount": "44 ratings",
                                  "ratingCountV2": "44"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "69492353",
                              "name": "Chicken Chilli Garlic Noodles Bowl",
                              "category": "Chinese Bowls",
                              "description": "Serves 1 | Noodles tossed with carrot, cabbage, onion, egg and chicken flavoured with chilli flakes,garlic and soy garnished with spring onion.",
                              "imageId": "vadj2jznbtsy1sfe9kne",
                              "inStock": 1,
                              "price": 25900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "138177289",
                                  "groupName": "Add Extra Dip",
                                  "choices": [
                                    {
                                      "id": "113732099",
                                      "name": "Extra Momo Chutney",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732092",
                                      "name": "Extra Schezwan Dip",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732095",
                                      "name": "Extra Sweet Chilli Dip",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732103",
                                      "name": "Extra Mayo Dip",
                                      "price": 2000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732091",
                                      "name": "Extra Tandoori Mayo Dip",
                                      "price": 2000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732098",
                                      "name": "Extra Mint Mayo Dip",
                                      "price": 2000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "138177292",
                                  "groupName": "Add  Drinks",
                                  "choices": [
                                    {
                                      "id": "113732125",
                                      "name": "Classic Lemon",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732120",
                                      "name": "Tender Coconut",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732096",
                                      "name": "Aam Panna",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732130",
                                      "name": "Masala Shikanji",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732085",
                                      "name": "Peach Ice Tea",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732084",
                                      "name": "Lemon Ice Tea",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732127",
                                      "name": "Pepsi Pet Bottle",
                                      "price": 6000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732128",
                                      "name": "7 Up Pet Bottle",
                                      "price": 6000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732121",
                                      "name": "Alphonso Mango",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732129",
                                      "name": "Mixed Fruit",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 10,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "138177295",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "113732086",
                                      "name": "Chocolate Mousse - Small",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732087",
                                      "name": "Black Forest Mousse Cake",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732088",
                                      "name": "Salted Caramel Choco Mousse",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732089",
                                      "name": "Choco Lava",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732126",
                                      "name": "Chocolate Mousse (Save Rs. 20)",
                                      "price": 8000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "138177297",
                                  "groupName": "Add Non Veg Starters",
                                  "choices": [
                                    {
                                      "id": "113732094",
                                      "name": "Chicken Spring Roll (4pcs)",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732097",
                                      "name": "Chilli Chicken",
                                      "price": 33900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732108",
                                      "name": "Chicken Manchurian",
                                      "price": 33900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "56 ratings",
                                  "ratingCountV2": "56"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "69492367",
                              "name": "Chilli Paneer Bowl",
                              "category": "Chinese Bowls",
                              "description": "Serves 1 | (Spicy) Paneer, onion and capsicum tossed in our signature desi chilli sauce, served with choice of rice.",
                              "imageId": "gour4gfnz1oh2tdk6usl",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "33801686",
                                    "name": "Rice / Noodle Options",
                                    "variations": [
                                      {
                                        "name": "Fried Rice",
                                        "price": 299,
                                        "default": 1,
                                        "id": "104518026",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Burnt Garlic Fried Rice",
                                        "price": 319,
                                        "id": "104518028",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chilli Garlic Fried Rice",
                                        "price": 319,
                                        "id": "104518030",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Schezwan Fried Rice",
                                        "price": 329,
                                        "id": "104518032",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Hakka Noodles",
                                        "price": 299,
                                        "id": "104518033",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Burnt Garlic Noodles",
                                        "price": 319,
                                        "id": "104518034",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chilli Garlic Noodles",
                                        "price": 319,
                                        "id": "104518035",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Schezwan Noodles",
                                        "price": 329,
                                        "id": "104518036",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801686",
                                        "variationId": "104518026"
                                      }
                                    ],
                                    "price": 29900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177584",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177584",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177584",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177584",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177584",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177585",
                                        "addonId": "113732113"
                                      },
                                      {
                                        "groupId": "138177585",
                                        "addonId": "113732093"
                                      },
                                      {
                                        "groupId": "138177585",
                                        "addonId": "113732090"
                                      },
                                      {
                                        "groupId": "138177582",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177582",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177582",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177582",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177582",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177582",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801686",
                                        "variationId": "104518028"
                                      }
                                    ],
                                    "price": 31900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177584",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177584",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177584",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177584",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177584",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177585",
                                        "addonId": "113732113"
                                      },
                                      {
                                        "groupId": "138177585",
                                        "addonId": "113732093"
                                      },
                                      {
                                        "groupId": "138177585",
                                        "addonId": "113732090"
                                      },
                                      {
                                        "groupId": "138177582",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177582",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177582",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177582",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177582",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177582",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801686",
                                        "variationId": "104518030"
                                      }
                                    ],
                                    "price": 31900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177584",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177584",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177584",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177584",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177584",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177585",
                                        "addonId": "113732113"
                                      },
                                      {
                                        "groupId": "138177585",
                                        "addonId": "113732093"
                                      },
                                      {
                                        "groupId": "138177585",
                                        "addonId": "113732090"
                                      },
                                      {
                                        "groupId": "138177582",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177582",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177582",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177582",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177582",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177582",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801686",
                                        "variationId": "104518032"
                                      }
                                    ],
                                    "price": 32900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177584",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177584",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177584",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177584",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177584",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177585",
                                        "addonId": "113732113"
                                      },
                                      {
                                        "groupId": "138177585",
                                        "addonId": "113732093"
                                      },
                                      {
                                        "groupId": "138177585",
                                        "addonId": "113732090"
                                      },
                                      {
                                        "groupId": "138177582",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177582",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177582",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177582",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177582",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177582",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801686",
                                        "variationId": "104518033"
                                      }
                                    ],
                                    "price": 29900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177584",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177584",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177584",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177584",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177584",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177585",
                                        "addonId": "113732113"
                                      },
                                      {
                                        "groupId": "138177585",
                                        "addonId": "113732093"
                                      },
                                      {
                                        "groupId": "138177585",
                                        "addonId": "113732090"
                                      },
                                      {
                                        "groupId": "138177582",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177582",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177582",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177582",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177582",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177582",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801686",
                                        "variationId": "104518034"
                                      }
                                    ],
                                    "price": 31900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177584",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177584",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177584",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177584",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177584",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177585",
                                        "addonId": "113732113"
                                      },
                                      {
                                        "groupId": "138177585",
                                        "addonId": "113732093"
                                      },
                                      {
                                        "groupId": "138177585",
                                        "addonId": "113732090"
                                      },
                                      {
                                        "groupId": "138177582",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177582",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177582",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177582",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177582",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177582",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801686",
                                        "variationId": "104518035"
                                      }
                                    ],
                                    "price": 31900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177584",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177584",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177584",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177584",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177584",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177585",
                                        "addonId": "113732113"
                                      },
                                      {
                                        "groupId": "138177585",
                                        "addonId": "113732093"
                                      },
                                      {
                                        "groupId": "138177585",
                                        "addonId": "113732090"
                                      },
                                      {
                                        "groupId": "138177582",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177582",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177582",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177582",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177582",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177582",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801686",
                                        "variationId": "104518036"
                                      }
                                    ],
                                    "price": 32900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177584",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177584",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177584",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177584",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177584",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177585",
                                        "addonId": "113732113"
                                      },
                                      {
                                        "groupId": "138177585",
                                        "addonId": "113732093"
                                      },
                                      {
                                        "groupId": "138177585",
                                        "addonId": "113732090"
                                      },
                                      {
                                        "groupId": "138177582",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177582",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177582",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177582",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177582",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177582",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177583",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "138177582",
                                  "groupName": "Add Extra Dip",
                                  "choices": [
                                    {
                                      "id": "113732099",
                                      "name": "Extra Momo Chutney",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732092",
                                      "name": "Extra Schezwan Dip",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732095",
                                      "name": "Extra Sweet Chilli Dip",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732103",
                                      "name": "Extra Mayo Dip",
                                      "price": 2000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732091",
                                      "name": "Extra Tandoori Mayo Dip",
                                      "price": 2000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732098",
                                      "name": "Extra Mint Mayo Dip",
                                      "price": 2000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "138177583",
                                  "groupName": "Add  Drinks",
                                  "choices": [
                                    {
                                      "id": "113732125",
                                      "name": "Classic Lemon",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732120",
                                      "name": "Tender Coconut",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732096",
                                      "name": "Aam Panna",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732130",
                                      "name": "Masala Shikanji",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732085",
                                      "name": "Peach Ice Tea",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732084",
                                      "name": "Lemon Ice Tea",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732127",
                                      "name": "Pepsi Pet Bottle",
                                      "price": 6000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732128",
                                      "name": "7 Up Pet Bottle",
                                      "price": 6000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732121",
                                      "name": "Alphonso Mango",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732129",
                                      "name": "Mixed Fruit",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 10,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "138177584",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "113732086",
                                      "name": "Chocolate Mousse - Small",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732087",
                                      "name": "Black Forest Mousse Cake",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732088",
                                      "name": "Salted Caramel Choco Mousse",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732089",
                                      "name": "Choco Lava",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732126",
                                      "name": "Chocolate Mousse (Save Rs. 20)",
                                      "price": 8000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "138177585",
                                  "groupName": "Add Veg Starters",
                                  "choices": [
                                    {
                                      "id": "113732090",
                                      "name": "Chilli Paneer",
                                      "price": 30900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732113",
                                      "name": "Veg Spring Rolls (4 pcs)",
                                      "price": 16900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732093",
                                      "name": "Veg Manchurian Dry",
                                      "price": 26900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 29900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.5",
                                  "ratingCount": "12 ratings",
                                  "ratingCountV2": "12"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "69492369",
                              "name": "Veg Manchurian Bowl",
                              "category": "Chinese Bowls",
                              "description": "Serves 1 | (Peppery & Non Spicy) Mix veg fried fritters, onion and capsicum tossed in classic manchurian sauce, served with choice of Rice / Noodles.",
                              "imageId": "giazrujwhwoiz3xjsayi",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "33801707",
                                    "name": "Rice / Noodle Options",
                                    "variations": [
                                      {
                                        "name": "Fried Rice",
                                        "price": 259,
                                        "default": 1,
                                        "id": "104518129",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Burnt Garlic Fried Rice",
                                        "price": 279,
                                        "id": "104518130",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chilli Garlic Fried Rice",
                                        "price": 279,
                                        "id": "104518131",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Schezwan Fried Rice",
                                        "price": 289,
                                        "id": "104518132",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Hakka Noodles",
                                        "price": 259,
                                        "id": "104518133",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Burnt Garlic Noodles",
                                        "price": 279,
                                        "id": "104518134",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chilli Garlic Noodles",
                                        "price": 279,
                                        "id": "104518135",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Schezwan Noodles",
                                        "price": 289,
                                        "id": "104518136",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801707",
                                        "variationId": "104518129"
                                      }
                                    ],
                                    "price": 25900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177184",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177184",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177184",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177184",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177184",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177186",
                                        "addonId": "113732113"
                                      },
                                      {
                                        "groupId": "138177186",
                                        "addonId": "113732093"
                                      },
                                      {
                                        "groupId": "138177186",
                                        "addonId": "113732090"
                                      },
                                      {
                                        "groupId": "138177181",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177181",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177181",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177181",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177181",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177181",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801707",
                                        "variationId": "104518130"
                                      }
                                    ],
                                    "price": 27900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177184",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177184",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177184",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177184",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177184",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177186",
                                        "addonId": "113732113"
                                      },
                                      {
                                        "groupId": "138177186",
                                        "addonId": "113732093"
                                      },
                                      {
                                        "groupId": "138177186",
                                        "addonId": "113732090"
                                      },
                                      {
                                        "groupId": "138177181",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177181",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177181",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177181",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177181",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177181",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801707",
                                        "variationId": "104518131"
                                      }
                                    ],
                                    "price": 27900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177184",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177184",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177184",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177184",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177184",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177186",
                                        "addonId": "113732113"
                                      },
                                      {
                                        "groupId": "138177186",
                                        "addonId": "113732093"
                                      },
                                      {
                                        "groupId": "138177186",
                                        "addonId": "113732090"
                                      },
                                      {
                                        "groupId": "138177181",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177181",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177181",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177181",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177181",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177181",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801707",
                                        "variationId": "104518132"
                                      }
                                    ],
                                    "price": 28900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177184",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177184",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177184",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177184",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177184",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177186",
                                        "addonId": "113732113"
                                      },
                                      {
                                        "groupId": "138177186",
                                        "addonId": "113732093"
                                      },
                                      {
                                        "groupId": "138177186",
                                        "addonId": "113732090"
                                      },
                                      {
                                        "groupId": "138177181",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177181",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177181",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177181",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177181",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177181",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801707",
                                        "variationId": "104518133"
                                      }
                                    ],
                                    "price": 25900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177184",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177184",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177184",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177184",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177184",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177186",
                                        "addonId": "113732113"
                                      },
                                      {
                                        "groupId": "138177186",
                                        "addonId": "113732093"
                                      },
                                      {
                                        "groupId": "138177186",
                                        "addonId": "113732090"
                                      },
                                      {
                                        "groupId": "138177181",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177181",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177181",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177181",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177181",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177181",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801707",
                                        "variationId": "104518134"
                                      }
                                    ],
                                    "price": 27900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177184",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177184",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177184",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177184",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177184",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177186",
                                        "addonId": "113732113"
                                      },
                                      {
                                        "groupId": "138177186",
                                        "addonId": "113732093"
                                      },
                                      {
                                        "groupId": "138177186",
                                        "addonId": "113732090"
                                      },
                                      {
                                        "groupId": "138177181",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177181",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177181",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177181",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177181",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177181",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801707",
                                        "variationId": "104518135"
                                      }
                                    ],
                                    "price": 27900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177184",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177184",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177184",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177184",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177184",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177186",
                                        "addonId": "113732113"
                                      },
                                      {
                                        "groupId": "138177186",
                                        "addonId": "113732093"
                                      },
                                      {
                                        "groupId": "138177186",
                                        "addonId": "113732090"
                                      },
                                      {
                                        "groupId": "138177181",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177181",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177181",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177181",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177181",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177181",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801707",
                                        "variationId": "104518136"
                                      }
                                    ],
                                    "price": 28900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177184",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177184",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177184",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177184",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177184",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177186",
                                        "addonId": "113732113"
                                      },
                                      {
                                        "groupId": "138177186",
                                        "addonId": "113732093"
                                      },
                                      {
                                        "groupId": "138177186",
                                        "addonId": "113732090"
                                      },
                                      {
                                        "groupId": "138177181",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177181",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177181",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177181",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177181",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177181",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177182",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "138177181",
                                  "groupName": "Add Extra Dip",
                                  "choices": [
                                    {
                                      "id": "113732099",
                                      "name": "Extra Momo Chutney",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732092",
                                      "name": "Extra Schezwan Dip",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732095",
                                      "name": "Extra Sweet Chilli Dip",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732103",
                                      "name": "Extra Mayo Dip",
                                      "price": 2000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732091",
                                      "name": "Extra Tandoori Mayo Dip",
                                      "price": 2000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732098",
                                      "name": "Extra Mint Mayo Dip",
                                      "price": 2000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "138177182",
                                  "groupName": "Add  Drinks",
                                  "choices": [
                                    {
                                      "id": "113732125",
                                      "name": "Classic Lemon",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732120",
                                      "name": "Tender Coconut",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732096",
                                      "name": "Aam Panna",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732130",
                                      "name": "Masala Shikanji",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732085",
                                      "name": "Peach Ice Tea",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732084",
                                      "name": "Lemon Ice Tea",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732127",
                                      "name": "Pepsi Pet Bottle",
                                      "price": 6000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732128",
                                      "name": "7 Up Pet Bottle",
                                      "price": 6000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732121",
                                      "name": "Alphonso Mango",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732129",
                                      "name": "Mixed Fruit",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 10,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "138177184",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "113732086",
                                      "name": "Chocolate Mousse - Small",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732087",
                                      "name": "Black Forest Mousse Cake",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732088",
                                      "name": "Salted Caramel Choco Mousse",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732089",
                                      "name": "Choco Lava",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732126",
                                      "name": "Chocolate Mousse (Save Rs. 20)",
                                      "price": 8000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "138177186",
                                  "groupName": "Add Veg Starters",
                                  "choices": [
                                    {
                                      "id": "113732090",
                                      "name": "Chilli Paneer",
                                      "price": 30900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732113",
                                      "name": "Veg Spring Rolls (4 pcs)",
                                      "price": 16900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732093",
                                      "name": "Veg Manchurian Dry",
                                      "price": 26900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 25900,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "83 ratings",
                                  "ratingCountV2": "83"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "95693884",
                              "name": "Black Pepper Chicken Bowl",
                              "category": "Chinese Bowls",
                              "description": "Serves 1 | (Peppery & Non Spicy) Chicken, Onion, Capsicum, Tossed In Our In-House Black Pepper Sauce, Served With Choice Of Rice/ Noodle.",
                              "imageId": "63215498e2e95192ee0adad8b7b3f414",
                              "inStock": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "36034934",
                                    "name": "Rice /Noodle Options",
                                    "variations": [
                                      {
                                        "name": "Fried Rice",
                                        "price": 319,
                                        "default": 1,
                                        "id": "111878043",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Burnt Garlic Fried Rice",
                                        "price": 339,
                                        "id": "111878044",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chilli Garlic Fried Rice",
                                        "price": 339,
                                        "id": "111878045",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Schezwan Fried Rice",
                                        "price": 349,
                                        "id": "111878046",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Hakka Noodles",
                                        "price": 319,
                                        "id": "111878047",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Burnt Garlic Noodles",
                                        "price": 339,
                                        "id": "111878048",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chilli Garlic Noodles",
                                        "price": 339,
                                        "id": "111878049",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Schezwan Noodles",
                                        "price": 349,
                                        "id": "111878050",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chicken Fried Rice",
                                        "price": 369,
                                        "id": "121812474",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chicken Burnt Garlic Rice",
                                        "price": 369,
                                        "id": "121812475",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chicken Chilli Garlic Rice",
                                        "price": 369,
                                        "id": "121812476",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chicken Schezwan Fried Rice",
                                        "price": 369,
                                        "id": "121812477",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Egg Hakka Noodles",
                                        "price": 344,
                                        "id": "121812478",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chicken Hakka Noodles",
                                        "price": 369,
                                        "id": "121812479",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chicken Burnt Garlic Noodles",
                                        "price": 369,
                                        "id": "121812480",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chicken Chilli Garlic Noodles",
                                        "price": 369,
                                        "id": "121812481",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chicken Schezwan Noodles",
                                        "price": 369,
                                        "id": "121812482",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Egg Fried Rice",
                                        "price": 339,
                                        "id": "111878051",
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36034934",
                                        "variationId": "111878043"
                                      }
                                    ],
                                    "price": 31900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36034934",
                                        "variationId": "111878044"
                                      }
                                    ],
                                    "price": 33900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36034934",
                                        "variationId": "111878045"
                                      }
                                    ],
                                    "price": 33900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36034934",
                                        "variationId": "111878046"
                                      }
                                    ],
                                    "price": 34900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36034934",
                                        "variationId": "111878047"
                                      }
                                    ],
                                    "price": 31900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36034934",
                                        "variationId": "111878048"
                                      }
                                    ],
                                    "price": 33900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36034934",
                                        "variationId": "111878049"
                                      }
                                    ],
                                    "price": 33900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36034934",
                                        "variationId": "111878050"
                                      }
                                    ],
                                    "price": 34900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36034934",
                                        "variationId": "111878051"
                                      }
                                    ],
                                    "price": 33900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36034934",
                                        "variationId": "121812474"
                                      }
                                    ],
                                    "price": 36900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36034934",
                                        "variationId": "121812475"
                                      }
                                    ],
                                    "price": 36900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36034934",
                                        "variationId": "121812476"
                                      }
                                    ],
                                    "price": 36900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36034934",
                                        "variationId": "121812477"
                                      }
                                    ],
                                    "price": 36900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36034934",
                                        "variationId": "121812478"
                                      }
                                    ],
                                    "price": 34400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36034934",
                                        "variationId": "121812479"
                                      }
                                    ],
                                    "price": 36900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36034934",
                                        "variationId": "121812480"
                                      }
                                    ],
                                    "price": 36900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36034934",
                                        "variationId": "121812481"
                                      }
                                    ],
                                    "price": 36900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36034934",
                                        "variationId": "121812482"
                                      }
                                    ],
                                    "price": 36900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177319",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177317",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177315",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177316",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "138177315",
                                  "groupName": "Add Extra Dip",
                                  "choices": [
                                    {
                                      "id": "113732099",
                                      "name": "Extra Momo Chutney",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732092",
                                      "name": "Extra Schezwan Dip",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732095",
                                      "name": "Extra Sweet Chilli Dip",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732103",
                                      "name": "Extra Mayo Dip",
                                      "price": 2000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732091",
                                      "name": "Extra Tandoori Mayo Dip",
                                      "price": 2000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732098",
                                      "name": "Extra Mint Mayo Dip",
                                      "price": 2000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "138177316",
                                  "groupName": "Add  Drinks",
                                  "choices": [
                                    {
                                      "id": "113732125",
                                      "name": "Classic Lemon",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732120",
                                      "name": "Tender Coconut",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732096",
                                      "name": "Aam Panna",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732130",
                                      "name": "Masala Shikanji",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732085",
                                      "name": "Peach Ice Tea",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732084",
                                      "name": "Lemon Ice Tea",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732127",
                                      "name": "Pepsi Pet Bottle",
                                      "price": 6000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732128",
                                      "name": "7 Up Pet Bottle",
                                      "price": 6000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732121",
                                      "name": "Alphonso Mango",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732129",
                                      "name": "Mixed Fruit",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 10,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "138177317",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "113732086",
                                      "name": "Chocolate Mousse - Small",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732087",
                                      "name": "Black Forest Mousse Cake",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732088",
                                      "name": "Salted Caramel Choco Mousse",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732089",
                                      "name": "Choco Lava",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732126",
                                      "name": "Chocolate Mousse (Save Rs. 20)",
                                      "price": 8000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "138177319",
                                  "groupName": "Add Non Veg Starters",
                                  "choices": [
                                    {
                                      "id": "113732094",
                                      "name": "Chicken Spring Roll (4pcs)",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732097",
                                      "name": "Chilli Chicken",
                                      "price": 33900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732108",
                                      "name": "Chicken Manchurian",
                                      "price": 33900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 31900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "69492381",
                              "name": "Chilli Chicken Bowl",
                              "category": "Chinese Bowls",
                              "description": "Serves 1 | (Spicy) Diced chicken, onion and capsicum tossed in our signature desi chilli sauce, served with choice of Rice/ Noodle.",
                              "imageId": "s8zzafralzp3620swozf",
                              "inStock": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "33801704",
                                    "name": "Rice /Noodle Options",
                                    "variations": [
                                      {
                                        "name": "Fried Rice",
                                        "price": 299,
                                        "default": 1,
                                        "id": "104518078",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Burnt Garlic Fried Rice",
                                        "price": 319,
                                        "id": "104518079",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chilli Garlic Fried Rice",
                                        "price": 319,
                                        "id": "104518080",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Schezwan Fried Rice",
                                        "price": 329,
                                        "id": "104518081",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Hakka Noodles",
                                        "price": 299,
                                        "id": "104518082",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Burnt Garlic Noodles",
                                        "price": 319,
                                        "id": "104518083",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chilli Garlic Noodles",
                                        "price": 319,
                                        "id": "104518084",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Schezwan Noodles",
                                        "price": 329,
                                        "id": "104518085",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chicken Fried Rice",
                                        "price": 349,
                                        "id": "121812593",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chicken Burnt Garlic Rice",
                                        "price": 349,
                                        "id": "121812594",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chicken Chilli Garlic Rice",
                                        "price": 349,
                                        "id": "121812595",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chicken Schezwan Fried Rice",
                                        "price": 349,
                                        "id": "121812596",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Egg Hakka Noodles",
                                        "price": 324,
                                        "id": "121812597",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chicken Hakka Noodles",
                                        "price": 349,
                                        "id": "121812598",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chicken Burnt Garlic Noodles",
                                        "price": 349,
                                        "id": "121812599",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chicken Chilli Garlic Noodles",
                                        "price": 349,
                                        "id": "121812600",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chicken Schezwan Noodles",
                                        "price": 349,
                                        "id": "121812601",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Egg Fried Rice",
                                        "price": 319,
                                        "id": "104518086",
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801704",
                                        "variationId": "104518078"
                                      }
                                    ],
                                    "price": 29900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801704",
                                        "variationId": "104518079"
                                      }
                                    ],
                                    "price": 31900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801704",
                                        "variationId": "104518080"
                                      }
                                    ],
                                    "price": 31900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801704",
                                        "variationId": "104518081"
                                      }
                                    ],
                                    "price": 32900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801704",
                                        "variationId": "104518082"
                                      }
                                    ],
                                    "price": 29900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801704",
                                        "variationId": "104518083"
                                      }
                                    ],
                                    "price": 31900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801704",
                                        "variationId": "104518084"
                                      }
                                    ],
                                    "price": 31900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801704",
                                        "variationId": "104518085"
                                      }
                                    ],
                                    "price": 32900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801704",
                                        "variationId": "104518086"
                                      }
                                    ],
                                    "price": 31900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801704",
                                        "variationId": "121812593"
                                      }
                                    ],
                                    "price": 34900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801704",
                                        "variationId": "121812594"
                                      }
                                    ],
                                    "price": 34900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801704",
                                        "variationId": "121812595"
                                      }
                                    ],
                                    "price": 34900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801704",
                                        "variationId": "121812596"
                                      }
                                    ],
                                    "price": 34900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801704",
                                        "variationId": "121812597"
                                      }
                                    ],
                                    "price": 32400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801704",
                                        "variationId": "121812598"
                                      }
                                    ],
                                    "price": 34900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801704",
                                        "variationId": "121812599"
                                      }
                                    ],
                                    "price": 34900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801704",
                                        "variationId": "121812600"
                                      }
                                    ],
                                    "price": 34900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801704",
                                        "variationId": "121812601"
                                      }
                                    ],
                                    "price": 34900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177575",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177574",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177572",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177573",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "138177572",
                                  "groupName": "Add Extra Dip",
                                  "choices": [
                                    {
                                      "id": "113732099",
                                      "name": "Extra Momo Chutney",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732092",
                                      "name": "Extra Schezwan Dip",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732095",
                                      "name": "Extra Sweet Chilli Dip",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732103",
                                      "name": "Extra Mayo Dip",
                                      "price": 2000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732091",
                                      "name": "Extra Tandoori Mayo Dip",
                                      "price": 2000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732098",
                                      "name": "Extra Mint Mayo Dip",
                                      "price": 2000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "138177573",
                                  "groupName": "Add  Drinks",
                                  "choices": [
                                    {
                                      "id": "113732125",
                                      "name": "Classic Lemon",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732120",
                                      "name": "Tender Coconut",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732096",
                                      "name": "Aam Panna",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732130",
                                      "name": "Masala Shikanji",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732085",
                                      "name": "Peach Ice Tea",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732084",
                                      "name": "Lemon Ice Tea",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732127",
                                      "name": "Pepsi Pet Bottle",
                                      "price": 6000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732128",
                                      "name": "7 Up Pet Bottle",
                                      "price": 6000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732121",
                                      "name": "Alphonso Mango",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732129",
                                      "name": "Mixed Fruit",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 10,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "138177574",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "113732086",
                                      "name": "Chocolate Mousse - Small",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732087",
                                      "name": "Black Forest Mousse Cake",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732088",
                                      "name": "Salted Caramel Choco Mousse",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732089",
                                      "name": "Choco Lava",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732126",
                                      "name": "Chocolate Mousse (Save Rs. 20)",
                                      "price": 8000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "138177575",
                                  "groupName": "Add Non Veg Starters",
                                  "choices": [
                                    {
                                      "id": "113732094",
                                      "name": "Chicken Spring Roll (4pcs)",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732097",
                                      "name": "Chilli Chicken",
                                      "price": 33900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732108",
                                      "name": "Chicken Manchurian",
                                      "price": 33900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 29900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "68 ratings",
                                  "ratingCountV2": "68"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "69492383",
                              "name": "Chicken Manchurian Bowl",
                              "category": "Chinese Bowls",
                              "description": "Serves 1 | (Peppery & Spicy) Diced chicken, onion and capsicum tossed in classic manchurian sauce, served with choice of Rice/ Noodle.",
                              "imageId": "giazrujwhwoiz3xjsayi",
                              "inStock": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "33801705",
                                    "name": "Rice /Noodle Options",
                                    "variations": [
                                      {
                                        "name": "Fried Rice",
                                        "price": 309,
                                        "default": 1,
                                        "id": "104518095",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Burnt Garlic Fried Rice",
                                        "price": 329,
                                        "id": "104518096",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chilli Garlic Fried Rice",
                                        "price": 329,
                                        "id": "104518097",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Schezwan Fried Rice",
                                        "price": 339,
                                        "id": "104518098",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Hakka Noodles",
                                        "price": 309,
                                        "id": "104518099",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Burnt Garlic Noodles",
                                        "price": 329,
                                        "id": "104518100",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chilli Garlic Noodles",
                                        "price": 329,
                                        "id": "104518101",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Schezwan Noodles",
                                        "price": 339,
                                        "id": "104518102",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chicken Fried Rice",
                                        "price": 359,
                                        "id": "121812430",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chicken Burnt Garlic Rice",
                                        "price": 359,
                                        "id": "121812432",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chicken Chilli Garlic Rice",
                                        "price": 359,
                                        "id": "121812433",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chicken Schezwan Fried Rice",
                                        "price": 359,
                                        "id": "121812434",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Egg Hakka Noodles",
                                        "price": 334,
                                        "id": "121812435",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chicken Hakka Noodles",
                                        "price": 359,
                                        "id": "121812436",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chicken Burnt Garlic Noodles",
                                        "price": 359,
                                        "id": "121812437",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chicken Chilli Garlic Noodles",
                                        "price": 359,
                                        "id": "121812438",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chicken Schezwan Noodles",
                                        "price": 359,
                                        "id": "121812439",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Egg Fried Rice",
                                        "price": 329,
                                        "id": "104518103",
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801705",
                                        "variationId": "104518095"
                                      }
                                    ],
                                    "price": 30900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801705",
                                        "variationId": "104518096"
                                      }
                                    ],
                                    "price": 32900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801705",
                                        "variationId": "104518097"
                                      }
                                    ],
                                    "price": 32900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801705",
                                        "variationId": "104518098"
                                      }
                                    ],
                                    "price": 33900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801705",
                                        "variationId": "104518099"
                                      }
                                    ],
                                    "price": 30900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801705",
                                        "variationId": "104518100"
                                      }
                                    ],
                                    "price": 32900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801705",
                                        "variationId": "104518101"
                                      }
                                    ],
                                    "price": 32900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801705",
                                        "variationId": "104518102"
                                      }
                                    ],
                                    "price": 33900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801705",
                                        "variationId": "104518103"
                                      }
                                    ],
                                    "price": 32900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801705",
                                        "variationId": "121812430"
                                      }
                                    ],
                                    "price": 35900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801705",
                                        "variationId": "121812432"
                                      }
                                    ],
                                    "price": 35900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801705",
                                        "variationId": "121812433"
                                      }
                                    ],
                                    "price": 35900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801705",
                                        "variationId": "121812434"
                                      }
                                    ],
                                    "price": 35900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801705",
                                        "variationId": "121812435"
                                      }
                                    ],
                                    "price": 33400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801705",
                                        "variationId": "121812436"
                                      }
                                    ],
                                    "price": 35900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801705",
                                        "variationId": "121812437"
                                      }
                                    ],
                                    "price": 35900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801705",
                                        "variationId": "121812438"
                                      }
                                    ],
                                    "price": 35900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801705",
                                        "variationId": "121812439"
                                      }
                                    ],
                                    "price": 35900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177132",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177131",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177127",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177129",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "138177127",
                                  "groupName": "Add Extra Dip",
                                  "choices": [
                                    {
                                      "id": "113732099",
                                      "name": "Extra Momo Chutney",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732092",
                                      "name": "Extra Schezwan Dip",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732095",
                                      "name": "Extra Sweet Chilli Dip",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732103",
                                      "name": "Extra Mayo Dip",
                                      "price": 2000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732091",
                                      "name": "Extra Tandoori Mayo Dip",
                                      "price": 2000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732098",
                                      "name": "Extra Mint Mayo Dip",
                                      "price": 2000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "138177129",
                                  "groupName": "Add  Drinks",
                                  "choices": [
                                    {
                                      "id": "113732125",
                                      "name": "Classic Lemon",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732120",
                                      "name": "Tender Coconut",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732096",
                                      "name": "Aam Panna",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732130",
                                      "name": "Masala Shikanji",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732085",
                                      "name": "Peach Ice Tea",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732084",
                                      "name": "Lemon Ice Tea",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732127",
                                      "name": "Pepsi Pet Bottle",
                                      "price": 6000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732128",
                                      "name": "7 Up Pet Bottle",
                                      "price": 6000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732121",
                                      "name": "Alphonso Mango",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732129",
                                      "name": "Mixed Fruit",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 10,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "138177131",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "113732086",
                                      "name": "Chocolate Mousse - Small",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732087",
                                      "name": "Black Forest Mousse Cake",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732088",
                                      "name": "Salted Caramel Choco Mousse",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732089",
                                      "name": "Choco Lava",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732126",
                                      "name": "Chocolate Mousse (Save Rs. 20)",
                                      "price": 8000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "138177132",
                                  "groupName": "Add Non Veg Starters",
                                  "choices": [
                                    {
                                      "id": "113732094",
                                      "name": "Chicken Spring Roll (4pcs)",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732097",
                                      "name": "Chilli Chicken",
                                      "price": 33900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732108",
                                      "name": "Chicken Manchurian",
                                      "price": 33900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 30900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.2",
                                  "ratingCount": "24 ratings",
                                  "ratingCountV2": "24"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "69492378",
                              "name": "Kung Pao Chicken Bowl",
                              "category": "Chinese Bowls",
                              "description": "Serves 1 | (Medium Spicy) Diced chicken & veggies tossed in kung pao sauce, served with choice of Rice/ Noodle.",
                              "imageId": "k2eufgoa7wn2xovopidp",
                              "inStock": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "33801706",
                                    "name": "Rice /Noodle Options",
                                    "variations": [
                                      {
                                        "name": "Fried Rice",
                                        "price": 309,
                                        "default": 1,
                                        "id": "104518112",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Burnt Garlic Fried Rice",
                                        "price": 329,
                                        "id": "104518113",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chilli Garlic Fried Rice",
                                        "price": 329,
                                        "id": "104518114",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Schezwan Fried Rice",
                                        "price": 339,
                                        "id": "104518115",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Hakka Noodles",
                                        "price": 309,
                                        "id": "104518116",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Burnt Garlic Noodles",
                                        "price": 329,
                                        "id": "104518117",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chilli Garlic Noodles",
                                        "price": 329,
                                        "id": "104518118",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Schezwan Noodles",
                                        "price": 339,
                                        "id": "104518119",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chicken Fried Rice",
                                        "price": 359,
                                        "id": "121812505",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chicken Burnt Garlic Rice",
                                        "price": 359,
                                        "id": "121812506",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chicken Chilli Garlic Rice",
                                        "price": 359,
                                        "id": "121812507",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chicken Schezwan Fried Rice",
                                        "price": 359,
                                        "id": "121812508",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Egg Hakka Noodles",
                                        "price": 334,
                                        "id": "121812509",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chicken Hakka Noodles",
                                        "price": 359,
                                        "id": "121812510",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chicken Burnt Garlic Noodles",
                                        "price": 359,
                                        "id": "121812511",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chicken Chilli Garlic Noodles",
                                        "price": 359,
                                        "id": "121812512",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chicken Schezwan Noodles",
                                        "price": 359,
                                        "id": "121812513",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Egg Fried Rice",
                                        "price": 329,
                                        "id": "104518120",
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801706",
                                        "variationId": "104518112"
                                      }
                                    ],
                                    "price": 30900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801706",
                                        "variationId": "104518113"
                                      }
                                    ],
                                    "price": 32900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801706",
                                        "variationId": "104518114"
                                      }
                                    ],
                                    "price": 32900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801706",
                                        "variationId": "104518115"
                                      }
                                    ],
                                    "price": 33900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801706",
                                        "variationId": "104518116"
                                      }
                                    ],
                                    "price": 30900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801706",
                                        "variationId": "104518117"
                                      }
                                    ],
                                    "price": 32900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801706",
                                        "variationId": "104518118"
                                      }
                                    ],
                                    "price": 32900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801706",
                                        "variationId": "104518119"
                                      }
                                    ],
                                    "price": 33900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801706",
                                        "variationId": "104518120"
                                      }
                                    ],
                                    "price": 32900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801706",
                                        "variationId": "121812505"
                                      }
                                    ],
                                    "price": 35900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801706",
                                        "variationId": "121812506"
                                      }
                                    ],
                                    "price": 35900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801706",
                                        "variationId": "121812507"
                                      }
                                    ],
                                    "price": 35900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801706",
                                        "variationId": "121812508"
                                      }
                                    ],
                                    "price": 35900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801706",
                                        "variationId": "121812509"
                                      }
                                    ],
                                    "price": 33400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801706",
                                        "variationId": "121812510"
                                      }
                                    ],
                                    "price": 35900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801706",
                                        "variationId": "121812511"
                                      }
                                    ],
                                    "price": 35900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801706",
                                        "variationId": "121812512"
                                      }
                                    ],
                                    "price": 35900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33801706",
                                        "variationId": "121812513"
                                      }
                                    ],
                                    "price": 35900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732094"
                                      },
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732097"
                                      },
                                      {
                                        "groupId": "138177420",
                                        "addonId": "113732108"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732086"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732087"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732088"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732089"
                                      },
                                      {
                                        "groupId": "138177418",
                                        "addonId": "113732126"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732099"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732092"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732103"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732091"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732098"
                                      },
                                      {
                                        "groupId": "138177415",
                                        "addonId": "113732095"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732127"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732128"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732125"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732120"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732121"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732129"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732096"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732130"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732085"
                                      },
                                      {
                                        "groupId": "138177416",
                                        "addonId": "113732084"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "138177415",
                                  "groupName": "Add Extra Dip",
                                  "choices": [
                                    {
                                      "id": "113732099",
                                      "name": "Extra Momo Chutney",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732092",
                                      "name": "Extra Schezwan Dip",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732095",
                                      "name": "Extra Sweet Chilli Dip",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732103",
                                      "name": "Extra Mayo Dip",
                                      "price": 2000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732091",
                                      "name": "Extra Tandoori Mayo Dip",
                                      "price": 2000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732098",
                                      "name": "Extra Mint Mayo Dip",
                                      "price": 2000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "138177416",
                                  "groupName": "Add  Drinks",
                                  "choices": [
                                    {
                                      "id": "113732125",
                                      "name": "Classic Lemon",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732120",
                                      "name": "Tender Coconut",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732096",
                                      "name": "Aam Panna",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732130",
                                      "name": "Masala Shikanji",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732085",
                                      "name": "Peach Ice Tea",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732084",
                                      "name": "Lemon Ice Tea",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732127",
                                      "name": "Pepsi Pet Bottle",
                                      "price": 6000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732128",
                                      "name": "7 Up Pet Bottle",
                                      "price": 6000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732121",
                                      "name": "Alphonso Mango",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732129",
                                      "name": "Mixed Fruit",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 10,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "138177418",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "113732086",
                                      "name": "Chocolate Mousse - Small",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732087",
                                      "name": "Black Forest Mousse Cake",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732088",
                                      "name": "Salted Caramel Choco Mousse",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732089",
                                      "name": "Choco Lava",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732126",
                                      "name": "Chocolate Mousse (Save Rs. 20)",
                                      "price": 8000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "138177420",
                                  "groupName": "Add Non Veg Starters",
                                  "choices": [
                                    {
                                      "id": "113732094",
                                      "name": "Chicken Spring Roll (4pcs)",
                                      "price": 20900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732097",
                                      "name": "Chilli Chicken",
                                      "price": 33900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "113732108",
                                      "name": "Chicken Manchurian",
                                      "price": 33900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 30900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.0",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "type": "CATEGORY_TYPE_RECOMMENDED"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Combo",
                      "categories": [
                        {
                          "title": "Combo - Veg",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "120359764",
                                  "name": "Veg Indian Bowls with Dessert & Drinks",
                                  "category": "Combo",
                                  "description": "Serves 1 | Delish  Veg Indian Bowl with Dessert and Drinks.",
                                  "imageId": "ac3qnjpamj3q8aasakku",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "38547686",
                                        "name": "Select  Veg Indian Bowl",
                                        "variations": [
                                          {
                                            "name": "Rajma Chawal Bowl",
                                            "price": 378,
                                            "id": "121812643",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547688",
                                              "variationId": "121812652"
                                            }
                                          },
                                          {
                                            "name": "Pindi Chole Rice Bowl",
                                            "price": 368,
                                            "default": 1,
                                            "id": "121812644",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547688",
                                              "variationId": "121812652"
                                            }
                                          },
                                          {
                                            "name": "Dal Makhani Rice Bowl",
                                            "price": 368,
                                            "id": "121812645",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547688",
                                              "variationId": "121812652"
                                            }
                                          },
                                          {
                                            "name": "Paneer Kadai Rice Bowl",
                                            "price": 408,
                                            "id": "121812646",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547688",
                                              "variationId": "121812652"
                                            }
                                          },
                                          {
                                            "name": "Paneer Butter Masala Rice Bowl",
                                            "price": 418,
                                            "id": "121812647",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547688",
                                              "variationId": "121812652"
                                            }
                                          },
                                          {
                                            "name": "Spicy Paneer Butter Masala Rice Bowl",
                                            "price": 418,
                                            "id": "121812649",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547688",
                                              "variationId": "121812652"
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "38547688",
                                        "name": "Choose Your Dessert",
                                        "variations": [
                                          {
                                            "name": "Chocolate Mousse",
                                            "default": 1,
                                            "id": "121812652",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547689",
                                              "variationId": "121812653"
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "38547689",
                                        "name": "Choose Your Drink",
                                        "variations": [
                                          {
                                            "name": "Pepsi Pet Bottle",
                                            "default": 1,
                                            "id": "121812653",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "7 Up Pet Bottle",
                                            "id": "121812654",
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547686",
                                            "variationId": "121812643"
                                          },
                                          {
                                            "groupId": "38547688",
                                            "variationId": "121812652"
                                          },
                                          {
                                            "groupId": "38547689",
                                            "variationId": "121812653"
                                          }
                                        ],
                                        "price": 37800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547686",
                                            "variationId": "121812643"
                                          },
                                          {
                                            "groupId": "38547688",
                                            "variationId": "121812652"
                                          },
                                          {
                                            "groupId": "38547689",
                                            "variationId": "121812654"
                                          }
                                        ],
                                        "price": 37800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547686",
                                            "variationId": "121812644"
                                          },
                                          {
                                            "groupId": "38547688",
                                            "variationId": "121812652"
                                          },
                                          {
                                            "groupId": "38547689",
                                            "variationId": "121812653"
                                          }
                                        ],
                                        "price": 36800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547686",
                                            "variationId": "121812644"
                                          },
                                          {
                                            "groupId": "38547688",
                                            "variationId": "121812652"
                                          },
                                          {
                                            "groupId": "38547689",
                                            "variationId": "121812654"
                                          }
                                        ],
                                        "price": 36800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547686",
                                            "variationId": "121812645"
                                          },
                                          {
                                            "groupId": "38547688",
                                            "variationId": "121812652"
                                          },
                                          {
                                            "groupId": "38547689",
                                            "variationId": "121812653"
                                          }
                                        ],
                                        "price": 36800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547686",
                                            "variationId": "121812645"
                                          },
                                          {
                                            "groupId": "38547688",
                                            "variationId": "121812652"
                                          },
                                          {
                                            "groupId": "38547689",
                                            "variationId": "121812654"
                                          }
                                        ],
                                        "price": 36800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547686",
                                            "variationId": "121812646"
                                          },
                                          {
                                            "groupId": "38547688",
                                            "variationId": "121812652"
                                          },
                                          {
                                            "groupId": "38547689",
                                            "variationId": "121812653"
                                          }
                                        ],
                                        "price": 40800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547686",
                                            "variationId": "121812646"
                                          },
                                          {
                                            "groupId": "38547688",
                                            "variationId": "121812652"
                                          },
                                          {
                                            "groupId": "38547689",
                                            "variationId": "121812654"
                                          }
                                        ],
                                        "price": 40800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547686",
                                            "variationId": "121812647"
                                          },
                                          {
                                            "groupId": "38547688",
                                            "variationId": "121812652"
                                          },
                                          {
                                            "groupId": "38547689",
                                            "variationId": "121812653"
                                          }
                                        ],
                                        "price": 41800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547686",
                                            "variationId": "121812647"
                                          },
                                          {
                                            "groupId": "38547688",
                                            "variationId": "121812652"
                                          },
                                          {
                                            "groupId": "38547689",
                                            "variationId": "121812654"
                                          }
                                        ],
                                        "price": 41800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547686",
                                            "variationId": "121812649"
                                          },
                                          {
                                            "groupId": "38547688",
                                            "variationId": "121812652"
                                          },
                                          {
                                            "groupId": "38547689",
                                            "variationId": "121812653"
                                          }
                                        ],
                                        "price": 41800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547686",
                                            "variationId": "121812649"
                                          },
                                          {
                                            "groupId": "38547688",
                                            "variationId": "121812652"
                                          },
                                          {
                                            "groupId": "38547689",
                                            "variationId": "121812654"
                                          }
                                        ],
                                        "price": 41800
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 36800,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "120359761",
                                  "name": "Veg Chinese Bowls with Dessert",
                                  "category": "Combo",
                                  "description": "Serves 1 | Delish  Veg Chinese Bowl with Dessert",
                                  "imageId": "46e1521fd160893e491fd83d2846a355",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "38547692",
                                        "name": "Choose Veg Gravy",
                                        "variations": [
                                          {
                                            "name": "Veg Manchurian Gravy",
                                            "price": 328,
                                            "default": 1,
                                            "id": "121812668",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547693",
                                              "variationId": "121812672"
                                            }
                                          },
                                          {
                                            "name": "Chilli Paneer Gravy",
                                            "price": 338,
                                            "id": "121812669",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547693",
                                              "variationId": "121812672"
                                            }
                                          },
                                          {
                                            "name": "Schezwan Paneer Gravy",
                                            "price": 348,
                                            "id": "121812670",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547693",
                                              "variationId": "121812672"
                                            }
                                          },
                                          {
                                            "name": "Kung Pao Paneer Gravy",
                                            "price": 358,
                                            "id": "121812671",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547693",
                                              "variationId": "121812672"
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "38547693",
                                        "name": "Choose Rice/Noodles",
                                        "variations": [
                                          {
                                            "name": "Fried Rice",
                                            "price": 1,
                                            "default": 1,
                                            "id": "121812672",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547694",
                                              "variationId": "121812680"
                                            }
                                          },
                                          {
                                            "name": "Hakka Noodles",
                                            "price": 10,
                                            "id": "121812673",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547694",
                                              "variationId": "121812680"
                                            }
                                          },
                                          {
                                            "name": "Burnt Garlic Fried Rice",
                                            "price": 20,
                                            "id": "121812674",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547694",
                                              "variationId": "121812680"
                                            }
                                          },
                                          {
                                            "name": "Burnt Garlic Noodles",
                                            "price": 20,
                                            "id": "121812675",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547694",
                                              "variationId": "121812680"
                                            }
                                          },
                                          {
                                            "name": "Chilli Garlic Fried Rice",
                                            "price": 20,
                                            "id": "121812676",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547694",
                                              "variationId": "121812680"
                                            }
                                          },
                                          {
                                            "name": "Chilli Garlic Noodles",
                                            "price": 20,
                                            "id": "121812677",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547694",
                                              "variationId": "121812680"
                                            }
                                          },
                                          {
                                            "name": "Schezwan Fried Rice",
                                            "price": 30,
                                            "id": "121812678",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547694",
                                              "variationId": "121812680"
                                            }
                                          },
                                          {
                                            "name": "Schezwan Noodles",
                                            "price": 30,
                                            "id": "121812679",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547694",
                                              "variationId": "121812680"
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "38547694",
                                        "name": "Choose Your Dessert",
                                        "variations": [
                                          {
                                            "name": "Chocolate Mousse",
                                            "default": 1,
                                            "id": "121812680",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547692",
                                            "variationId": "121812668"
                                          },
                                          {
                                            "groupId": "38547693",
                                            "variationId": "121812672"
                                          },
                                          {
                                            "groupId": "38547694",
                                            "variationId": "121812680"
                                          }
                                        ],
                                        "price": 32900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547692",
                                            "variationId": "121812668"
                                          },
                                          {
                                            "groupId": "38547693",
                                            "variationId": "121812673"
                                          },
                                          {
                                            "groupId": "38547694",
                                            "variationId": "121812680"
                                          }
                                        ],
                                        "price": 33800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547692",
                                            "variationId": "121812668"
                                          },
                                          {
                                            "groupId": "38547693",
                                            "variationId": "121812674"
                                          },
                                          {
                                            "groupId": "38547694",
                                            "variationId": "121812680"
                                          }
                                        ],
                                        "price": 34800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547692",
                                            "variationId": "121812668"
                                          },
                                          {
                                            "groupId": "38547693",
                                            "variationId": "121812675"
                                          },
                                          {
                                            "groupId": "38547694",
                                            "variationId": "121812680"
                                          }
                                        ],
                                        "price": 34800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547692",
                                            "variationId": "121812668"
                                          },
                                          {
                                            "groupId": "38547693",
                                            "variationId": "121812676"
                                          },
                                          {
                                            "groupId": "38547694",
                                            "variationId": "121812680"
                                          }
                                        ],
                                        "price": 34800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547692",
                                            "variationId": "121812668"
                                          },
                                          {
                                            "groupId": "38547693",
                                            "variationId": "121812677"
                                          },
                                          {
                                            "groupId": "38547694",
                                            "variationId": "121812680"
                                          }
                                        ],
                                        "price": 34800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547692",
                                            "variationId": "121812668"
                                          },
                                          {
                                            "groupId": "38547693",
                                            "variationId": "121812678"
                                          },
                                          {
                                            "groupId": "38547694",
                                            "variationId": "121812680"
                                          }
                                        ],
                                        "price": 35800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547692",
                                            "variationId": "121812668"
                                          },
                                          {
                                            "groupId": "38547693",
                                            "variationId": "121812679"
                                          },
                                          {
                                            "groupId": "38547694",
                                            "variationId": "121812680"
                                          }
                                        ],
                                        "price": 35800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547692",
                                            "variationId": "121812669"
                                          },
                                          {
                                            "groupId": "38547693",
                                            "variationId": "121812672"
                                          },
                                          {
                                            "groupId": "38547694",
                                            "variationId": "121812680"
                                          }
                                        ],
                                        "price": 33900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547692",
                                            "variationId": "121812669"
                                          },
                                          {
                                            "groupId": "38547693",
                                            "variationId": "121812673"
                                          },
                                          {
                                            "groupId": "38547694",
                                            "variationId": "121812680"
                                          }
                                        ],
                                        "price": 34800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547692",
                                            "variationId": "121812669"
                                          },
                                          {
                                            "groupId": "38547693",
                                            "variationId": "121812674"
                                          },
                                          {
                                            "groupId": "38547694",
                                            "variationId": "121812680"
                                          }
                                        ],
                                        "price": 35800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547692",
                                            "variationId": "121812669"
                                          },
                                          {
                                            "groupId": "38547693",
                                            "variationId": "121812675"
                                          },
                                          {
                                            "groupId": "38547694",
                                            "variationId": "121812680"
                                          }
                                        ],
                                        "price": 35800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547692",
                                            "variationId": "121812669"
                                          },
                                          {
                                            "groupId": "38547693",
                                            "variationId": "121812676"
                                          },
                                          {
                                            "groupId": "38547694",
                                            "variationId": "121812680"
                                          }
                                        ],
                                        "price": 35800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547692",
                                            "variationId": "121812669"
                                          },
                                          {
                                            "groupId": "38547693",
                                            "variationId": "121812677"
                                          },
                                          {
                                            "groupId": "38547694",
                                            "variationId": "121812680"
                                          }
                                        ],
                                        "price": 35800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547692",
                                            "variationId": "121812669"
                                          },
                                          {
                                            "groupId": "38547693",
                                            "variationId": "121812678"
                                          },
                                          {
                                            "groupId": "38547694",
                                            "variationId": "121812680"
                                          }
                                        ],
                                        "price": 36800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547692",
                                            "variationId": "121812669"
                                          },
                                          {
                                            "groupId": "38547693",
                                            "variationId": "121812679"
                                          },
                                          {
                                            "groupId": "38547694",
                                            "variationId": "121812680"
                                          }
                                        ],
                                        "price": 36800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547692",
                                            "variationId": "121812670"
                                          },
                                          {
                                            "groupId": "38547693",
                                            "variationId": "121812672"
                                          },
                                          {
                                            "groupId": "38547694",
                                            "variationId": "121812680"
                                          }
                                        ],
                                        "price": 34900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547692",
                                            "variationId": "121812670"
                                          },
                                          {
                                            "groupId": "38547693",
                                            "variationId": "121812673"
                                          },
                                          {
                                            "groupId": "38547694",
                                            "variationId": "121812680"
                                          }
                                        ],
                                        "price": 35800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547692",
                                            "variationId": "121812670"
                                          },
                                          {
                                            "groupId": "38547693",
                                            "variationId": "121812674"
                                          },
                                          {
                                            "groupId": "38547694",
                                            "variationId": "121812680"
                                          }
                                        ],
                                        "price": 36800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547692",
                                            "variationId": "121812670"
                                          },
                                          {
                                            "groupId": "38547693",
                                            "variationId": "121812675"
                                          },
                                          {
                                            "groupId": "38547694",
                                            "variationId": "121812680"
                                          }
                                        ],
                                        "price": 36800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547692",
                                            "variationId": "121812670"
                                          },
                                          {
                                            "groupId": "38547693",
                                            "variationId": "121812676"
                                          },
                                          {
                                            "groupId": "38547694",
                                            "variationId": "121812680"
                                          }
                                        ],
                                        "price": 36800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547692",
                                            "variationId": "121812670"
                                          },
                                          {
                                            "groupId": "38547693",
                                            "variationId": "121812677"
                                          },
                                          {
                                            "groupId": "38547694",
                                            "variationId": "121812680"
                                          }
                                        ],
                                        "price": 36800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547692",
                                            "variationId": "121812670"
                                          },
                                          {
                                            "groupId": "38547693",
                                            "variationId": "121812678"
                                          },
                                          {
                                            "groupId": "38547694",
                                            "variationId": "121812680"
                                          }
                                        ],
                                        "price": 37800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547692",
                                            "variationId": "121812670"
                                          },
                                          {
                                            "groupId": "38547693",
                                            "variationId": "121812679"
                                          },
                                          {
                                            "groupId": "38547694",
                                            "variationId": "121812680"
                                          }
                                        ],
                                        "price": 37800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547692",
                                            "variationId": "121812671"
                                          },
                                          {
                                            "groupId": "38547693",
                                            "variationId": "121812672"
                                          },
                                          {
                                            "groupId": "38547694",
                                            "variationId": "121812680"
                                          }
                                        ],
                                        "price": 35900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547692",
                                            "variationId": "121812671"
                                          },
                                          {
                                            "groupId": "38547693",
                                            "variationId": "121812673"
                                          },
                                          {
                                            "groupId": "38547694",
                                            "variationId": "121812680"
                                          }
                                        ],
                                        "price": 36800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547692",
                                            "variationId": "121812671"
                                          },
                                          {
                                            "groupId": "38547693",
                                            "variationId": "121812674"
                                          },
                                          {
                                            "groupId": "38547694",
                                            "variationId": "121812680"
                                          }
                                        ],
                                        "price": 37800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547692",
                                            "variationId": "121812671"
                                          },
                                          {
                                            "groupId": "38547693",
                                            "variationId": "121812675"
                                          },
                                          {
                                            "groupId": "38547694",
                                            "variationId": "121812680"
                                          }
                                        ],
                                        "price": 37800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547692",
                                            "variationId": "121812671"
                                          },
                                          {
                                            "groupId": "38547693",
                                            "variationId": "121812676"
                                          },
                                          {
                                            "groupId": "38547694",
                                            "variationId": "121812680"
                                          }
                                        ],
                                        "price": 37800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547692",
                                            "variationId": "121812671"
                                          },
                                          {
                                            "groupId": "38547693",
                                            "variationId": "121812677"
                                          },
                                          {
                                            "groupId": "38547694",
                                            "variationId": "121812680"
                                          }
                                        ],
                                        "price": 37800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547692",
                                            "variationId": "121812671"
                                          },
                                          {
                                            "groupId": "38547693",
                                            "variationId": "121812678"
                                          },
                                          {
                                            "groupId": "38547694",
                                            "variationId": "121812680"
                                          }
                                        ],
                                        "price": 38800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547692",
                                            "variationId": "121812671"
                                          },
                                          {
                                            "groupId": "38547693",
                                            "variationId": "121812679"
                                          },
                                          {
                                            "groupId": "38547694",
                                            "variationId": "121812680"
                                          }
                                        ],
                                        "price": 38800
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 32900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "120359767",
                                  "name": "Veg Chinese Bowls with Drinks",
                                  "category": "Combo",
                                  "description": "Serves 1 | Delish  Veg Chinese Bowl with Drinks",
                                  "imageId": "a53d5326880af5af02b6bf3328d90929",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "38547695",
                                        "name": "Choose Veg Gravy",
                                        "variations": [
                                          {
                                            "name": "Chilli Paneer Gravy",
                                            "price": 299,
                                            "id": "121812682",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547696",
                                              "variationId": "121812685"
                                            }
                                          },
                                          {
                                            "name": "Schezwan Paneer Gravy",
                                            "price": 309,
                                            "id": "121812683",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547696",
                                              "variationId": "121812685"
                                            }
                                          },
                                          {
                                            "name": "Kung Pao Paneer Gravy",
                                            "price": 319,
                                            "id": "121812684",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547696",
                                              "variationId": "121812685"
                                            }
                                          },
                                          {
                                            "name": "Veg Manchurian Gravy",
                                            "price": 289,
                                            "default": 1,
                                            "id": "121812681",
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547696",
                                              "variationId": "121812685"
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "38547696",
                                        "name": "Choose Rice/Noodels",
                                        "variations": [
                                          {
                                            "name": "Fried Rice",
                                            "price": 1,
                                            "default": 1,
                                            "id": "121812685",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547697",
                                              "variationId": "121812693"
                                            }
                                          },
                                          {
                                            "name": "Hakka Noodles",
                                            "price": 10,
                                            "id": "121812686",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547697",
                                              "variationId": "121812693"
                                            }
                                          },
                                          {
                                            "name": "Chilli Garlic Noodles",
                                            "price": 20,
                                            "id": "121812687",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547697",
                                              "variationId": "121812693"
                                            }
                                          },
                                          {
                                            "name": "Chilli Garlic Fried Rice",
                                            "price": 20,
                                            "id": "121812688",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547697",
                                              "variationId": "121812693"
                                            }
                                          },
                                          {
                                            "name": "Burnt Garlic Noodles",
                                            "price": 20,
                                            "id": "121812689",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547697",
                                              "variationId": "121812693"
                                            }
                                          },
                                          {
                                            "name": "Burnt Garlic Fried Rice",
                                            "price": 20,
                                            "id": "121812690",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547697",
                                              "variationId": "121812693"
                                            }
                                          },
                                          {
                                            "name": "Schezwan Fried Rice",
                                            "price": 30,
                                            "id": "121812691",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547697",
                                              "variationId": "121812693"
                                            }
                                          },
                                          {
                                            "name": "Schezwan Noodles",
                                            "price": 30,
                                            "id": "121812692",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547697",
                                              "variationId": "121812693"
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "38547697",
                                        "name": "Choose Your Drink",
                                        "variations": [
                                          {
                                            "name": "Pepsi Pet Bottle",
                                            "default": 1,
                                            "id": "121812693",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "7 Up Pet Bottle",
                                            "id": "121812694",
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812681"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812685"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812693"
                                          }
                                        ],
                                        "price": 29000
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812681"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812685"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812694"
                                          }
                                        ],
                                        "price": 29000
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812681"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812686"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812693"
                                          }
                                        ],
                                        "price": 29900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812681"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812686"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812694"
                                          }
                                        ],
                                        "price": 29900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812681"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812687"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812693"
                                          }
                                        ],
                                        "price": 30900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812681"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812687"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812694"
                                          }
                                        ],
                                        "price": 30900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812681"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812688"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812693"
                                          }
                                        ],
                                        "price": 30900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812681"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812688"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812694"
                                          }
                                        ],
                                        "price": 30900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812681"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812689"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812693"
                                          }
                                        ],
                                        "price": 30900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812681"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812689"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812694"
                                          }
                                        ],
                                        "price": 30900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812681"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812690"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812693"
                                          }
                                        ],
                                        "price": 30900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812681"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812690"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812694"
                                          }
                                        ],
                                        "price": 30900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812681"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812691"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812693"
                                          }
                                        ],
                                        "price": 31900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812681"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812691"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812694"
                                          }
                                        ],
                                        "price": 31900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812681"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812692"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812693"
                                          }
                                        ],
                                        "price": 31900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812681"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812692"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812694"
                                          }
                                        ],
                                        "price": 31900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812682"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812685"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812693"
                                          }
                                        ],
                                        "price": 30000
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812682"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812685"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812694"
                                          }
                                        ],
                                        "price": 30000
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812682"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812686"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812693"
                                          }
                                        ],
                                        "price": 30900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812682"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812686"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812694"
                                          }
                                        ],
                                        "price": 30900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812682"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812687"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812693"
                                          }
                                        ],
                                        "price": 31900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812682"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812687"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812694"
                                          }
                                        ],
                                        "price": 31900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812682"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812688"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812693"
                                          }
                                        ],
                                        "price": 31900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812682"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812688"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812694"
                                          }
                                        ],
                                        "price": 31900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812682"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812689"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812693"
                                          }
                                        ],
                                        "price": 31900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812682"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812689"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812694"
                                          }
                                        ],
                                        "price": 31900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812682"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812690"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812693"
                                          }
                                        ],
                                        "price": 31900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812682"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812690"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812694"
                                          }
                                        ],
                                        "price": 31900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812682"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812691"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812693"
                                          }
                                        ],
                                        "price": 32900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812682"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812691"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812694"
                                          }
                                        ],
                                        "price": 32900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812682"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812692"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812693"
                                          }
                                        ],
                                        "price": 32900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812682"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812692"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812694"
                                          }
                                        ],
                                        "price": 32900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812683"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812685"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812693"
                                          }
                                        ],
                                        "price": 31000
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812683"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812685"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812694"
                                          }
                                        ],
                                        "price": 31000
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812683"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812686"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812693"
                                          }
                                        ],
                                        "price": 31900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812683"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812686"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812694"
                                          }
                                        ],
                                        "price": 31900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812683"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812687"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812693"
                                          }
                                        ],
                                        "price": 32900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812683"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812687"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812694"
                                          }
                                        ],
                                        "price": 32900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812683"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812688"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812693"
                                          }
                                        ],
                                        "price": 32900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812683"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812688"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812694"
                                          }
                                        ],
                                        "price": 32900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812683"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812689"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812693"
                                          }
                                        ],
                                        "price": 32900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812683"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812689"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812694"
                                          }
                                        ],
                                        "price": 32900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812683"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812690"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812693"
                                          }
                                        ],
                                        "price": 32900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812683"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812690"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812694"
                                          }
                                        ],
                                        "price": 32900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812683"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812691"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812693"
                                          }
                                        ],
                                        "price": 33900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812683"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812691"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812694"
                                          }
                                        ],
                                        "price": 33900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812683"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812692"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812693"
                                          }
                                        ],
                                        "price": 33900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812683"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812692"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812694"
                                          }
                                        ],
                                        "price": 33900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812684"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812685"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812693"
                                          }
                                        ],
                                        "price": 32000
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812684"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812685"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812694"
                                          }
                                        ],
                                        "price": 32000
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812684"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812686"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812693"
                                          }
                                        ],
                                        "price": 32900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812684"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812686"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812694"
                                          }
                                        ],
                                        "price": 32900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812684"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812687"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812693"
                                          }
                                        ],
                                        "price": 33900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812684"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812687"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812694"
                                          }
                                        ],
                                        "price": 33900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812684"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812688"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812693"
                                          }
                                        ],
                                        "price": 33900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812684"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812688"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812694"
                                          }
                                        ],
                                        "price": 33900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812684"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812689"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812693"
                                          }
                                        ],
                                        "price": 33900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812684"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812689"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812694"
                                          }
                                        ],
                                        "price": 33900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812684"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812690"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812693"
                                          }
                                        ],
                                        "price": 33900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812684"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812690"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812694"
                                          }
                                        ],
                                        "price": 33900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812684"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812691"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812693"
                                          }
                                        ],
                                        "price": 34900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812684"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812691"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812694"
                                          }
                                        ],
                                        "price": 34900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812684"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812692"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812693"
                                          }
                                        ],
                                        "price": 34900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547695",
                                            "variationId": "121812684"
                                          },
                                          {
                                            "groupId": "38547696",
                                            "variationId": "121812692"
                                          },
                                          {
                                            "groupId": "38547697",
                                            "variationId": "121812694"
                                          }
                                        ],
                                        "price": 34900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 29000,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "120359759",
                                  "name": "Veg Chinese Bowls with Dessert & Drinks",
                                  "category": "Combo",
                                  "description": "Serves 1 | Delish  Veg Chinese Bowl with Dessert and Drinks.",
                                  "imageId": "8b14f6199f33d259c2f6d5a14c6ba33b",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "38547699",
                                        "name": "Choose Veg Gravy",
                                        "variations": [
                                          {
                                            "name": "Chilli Paneer Gravy",
                                            "price": 398,
                                            "id": "121812697",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547700",
                                              "variationId": "121812701"
                                            }
                                          },
                                          {
                                            "name": "Veg Manchurian Gravy",
                                            "price": 388,
                                            "default": 1,
                                            "id": "121812698",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547700",
                                              "variationId": "121812701"
                                            }
                                          },
                                          {
                                            "name": "Schezwan Paneer Gravy",
                                            "price": 408,
                                            "id": "121812699",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547700",
                                              "variationId": "121812701"
                                            }
                                          },
                                          {
                                            "name": "Kung Pao Paneer Gravy",
                                            "price": 418,
                                            "id": "121812700",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547700",
                                              "variationId": "121812701"
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "38547700",
                                        "name": "Choose Rice/Noodle",
                                        "variations": [
                                          {
                                            "name": "Fried Rice",
                                            "price": 1,
                                            "default": 1,
                                            "id": "121812701",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547701",
                                              "variationId": "121812709"
                                            }
                                          },
                                          {
                                            "name": "Hakka Noodles",
                                            "price": 10,
                                            "id": "121812702",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547701",
                                              "variationId": "121812709"
                                            }
                                          },
                                          {
                                            "name": "Burnt Garlic Fried Rice",
                                            "price": 20,
                                            "id": "121812703",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547701",
                                              "variationId": "121812709"
                                            }
                                          },
                                          {
                                            "name": "Burnt Garlic Noodles",
                                            "price": 20,
                                            "id": "121812704",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547701",
                                              "variationId": "121812709"
                                            }
                                          },
                                          {
                                            "name": "Chilli Garlic Fried Rice",
                                            "price": 20,
                                            "id": "121812705",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547701",
                                              "variationId": "121812709"
                                            }
                                          },
                                          {
                                            "name": "Chilli Garlic Noodles",
                                            "price": 20,
                                            "id": "121812706",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547701",
                                              "variationId": "121812709"
                                            }
                                          },
                                          {
                                            "name": "Schezwan Fried Rice",
                                            "price": 30,
                                            "id": "121812707",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547701",
                                              "variationId": "121812709"
                                            }
                                          },
                                          {
                                            "name": "Schezwan Noodles",
                                            "price": 30,
                                            "id": "121812708",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547701",
                                              "variationId": "121812709"
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "38547701",
                                        "name": "Choose Your Dessert",
                                        "variations": [
                                          {
                                            "name": "Chocolate Mousse",
                                            "default": 1,
                                            "id": "121812709",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547702",
                                              "variationId": "121812710"
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "38547702",
                                        "name": "Choose Your Drink",
                                        "variations": [
                                          {
                                            "name": "Pepsi Pet Bottle",
                                            "default": 1,
                                            "id": "121812710",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "7 Up Pet Bottle",
                                            "id": "121812711",
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812697"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812701"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812710"
                                          }
                                        ],
                                        "price": 39900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812697"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812701"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812711"
                                          }
                                        ],
                                        "price": 39900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812697"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812702"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812710"
                                          }
                                        ],
                                        "price": 40800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812697"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812702"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812711"
                                          }
                                        ],
                                        "price": 40800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812697"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812703"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812710"
                                          }
                                        ],
                                        "price": 41800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812697"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812703"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812711"
                                          }
                                        ],
                                        "price": 41800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812697"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812704"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812710"
                                          }
                                        ],
                                        "price": 41800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812697"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812704"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812711"
                                          }
                                        ],
                                        "price": 41800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812697"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812705"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812710"
                                          }
                                        ],
                                        "price": 41800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812697"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812705"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812711"
                                          }
                                        ],
                                        "price": 41800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812697"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812706"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812710"
                                          }
                                        ],
                                        "price": 41800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812697"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812706"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812711"
                                          }
                                        ],
                                        "price": 41800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812697"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812707"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812710"
                                          }
                                        ],
                                        "price": 42800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812697"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812707"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812711"
                                          }
                                        ],
                                        "price": 42800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812697"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812708"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812710"
                                          }
                                        ],
                                        "price": 42800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812697"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812708"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812711"
                                          }
                                        ],
                                        "price": 42800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812698"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812701"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812710"
                                          }
                                        ],
                                        "price": 38900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812698"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812701"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812711"
                                          }
                                        ],
                                        "price": 38900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812698"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812702"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812710"
                                          }
                                        ],
                                        "price": 39800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812698"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812702"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812711"
                                          }
                                        ],
                                        "price": 39800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812698"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812703"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812710"
                                          }
                                        ],
                                        "price": 40800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812698"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812703"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812711"
                                          }
                                        ],
                                        "price": 40800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812698"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812704"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812710"
                                          }
                                        ],
                                        "price": 40800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812698"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812704"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812711"
                                          }
                                        ],
                                        "price": 40800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812698"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812705"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812710"
                                          }
                                        ],
                                        "price": 40800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812698"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812705"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812711"
                                          }
                                        ],
                                        "price": 40800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812698"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812706"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812710"
                                          }
                                        ],
                                        "price": 40800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812698"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812706"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812711"
                                          }
                                        ],
                                        "price": 40800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812698"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812707"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812710"
                                          }
                                        ],
                                        "price": 41800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812698"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812707"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812711"
                                          }
                                        ],
                                        "price": 41800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812698"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812708"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812710"
                                          }
                                        ],
                                        "price": 41800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812698"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812708"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812711"
                                          }
                                        ],
                                        "price": 41800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812699"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812701"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812710"
                                          }
                                        ],
                                        "price": 40900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812699"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812701"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812711"
                                          }
                                        ],
                                        "price": 40900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812699"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812702"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812710"
                                          }
                                        ],
                                        "price": 41800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812699"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812702"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812711"
                                          }
                                        ],
                                        "price": 41800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812699"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812703"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812710"
                                          }
                                        ],
                                        "price": 42800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812699"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812703"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812711"
                                          }
                                        ],
                                        "price": 42800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812699"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812704"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812710"
                                          }
                                        ],
                                        "price": 42800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812699"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812704"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812711"
                                          }
                                        ],
                                        "price": 42800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812699"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812705"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812710"
                                          }
                                        ],
                                        "price": 42800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812699"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812705"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812711"
                                          }
                                        ],
                                        "price": 42800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812699"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812706"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812710"
                                          }
                                        ],
                                        "price": 42800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812699"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812706"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812711"
                                          }
                                        ],
                                        "price": 42800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812699"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812707"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812710"
                                          }
                                        ],
                                        "price": 43800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812699"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812707"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812711"
                                          }
                                        ],
                                        "price": 43800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812699"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812708"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812710"
                                          }
                                        ],
                                        "price": 43800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812699"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812708"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812711"
                                          }
                                        ],
                                        "price": 43800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812700"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812701"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812710"
                                          }
                                        ],
                                        "price": 41900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812700"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812701"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812711"
                                          }
                                        ],
                                        "price": 41900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812700"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812702"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812710"
                                          }
                                        ],
                                        "price": 42800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812700"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812702"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812711"
                                          }
                                        ],
                                        "price": 42800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812700"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812703"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812710"
                                          }
                                        ],
                                        "price": 43800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812700"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812703"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812711"
                                          }
                                        ],
                                        "price": 43800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812700"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812704"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812710"
                                          }
                                        ],
                                        "price": 43800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812700"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812704"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812711"
                                          }
                                        ],
                                        "price": 43800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812700"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812705"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812710"
                                          }
                                        ],
                                        "price": 43800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812700"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812705"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812711"
                                          }
                                        ],
                                        "price": 43800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812700"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812706"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812710"
                                          }
                                        ],
                                        "price": 43800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812700"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812706"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812711"
                                          }
                                        ],
                                        "price": 43800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812700"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812707"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812710"
                                          }
                                        ],
                                        "price": 44800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812700"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812707"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812711"
                                          }
                                        ],
                                        "price": 44800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812700"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812708"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812710"
                                          }
                                        ],
                                        "price": 44800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547699",
                                            "variationId": "121812700"
                                          },
                                          {
                                            "groupId": "38547700",
                                            "variationId": "121812708"
                                          },
                                          {
                                            "groupId": "38547701",
                                            "variationId": "121812709"
                                          },
                                          {
                                            "groupId": "38547702",
                                            "variationId": "121812711"
                                          }
                                        ],
                                        "price": 44800
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 38900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Combo - Non Veg",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "127262697",
                                  "name": "Non - Veg Indian Bowls with Dessert and Drinks",
                                  "category": "Combo",
                                  "description": "Serves 1 | Delish  Non-Veg Indian Bowls with Dessert & Drinks",
                                  "imageId": "25786d0b5fcadbfb0609ed5f8e6a41b3",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "38547731",
                                        "name": "Select Non - Veg Indian Bowl",
                                        "variations": [
                                          {
                                            "name": "Chicken Kadai Rice Bowl",
                                            "price": 428,
                                            "default": 1,
                                            "id": "121812799",
                                            "inStock": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547732",
                                              "variationId": "121812802"
                                            }
                                          },
                                          {
                                            "name": "Smoky Butter Chicken Rice Bowl",
                                            "price": 438,
                                            "id": "121812800",
                                            "inStock": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547732",
                                              "variationId": "121812802"
                                            }
                                          },
                                          {
                                            "name": "Spicy Butter Chicken Rice Bowl",
                                            "price": 438,
                                            "id": "121812801",
                                            "inStock": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547732",
                                              "variationId": "121812802"
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "38547732",
                                        "name": "Choose Your Dessert",
                                        "variations": [
                                          {
                                            "name": "Chocolate Mousse",
                                            "default": 1,
                                            "id": "121812802",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547733",
                                              "variationId": "121812803"
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "38547733",
                                        "name": "Choose Your Drink",
                                        "variations": [
                                          {
                                            "name": "Pepsi Pet Bottle",
                                            "default": 1,
                                            "id": "121812803",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "7 Up Pet Bottle",
                                            "id": "121812804",
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547731",
                                            "variationId": "121812799"
                                          },
                                          {
                                            "groupId": "38547732",
                                            "variationId": "121812802"
                                          },
                                          {
                                            "groupId": "38547733",
                                            "variationId": "121812803"
                                          }
                                        ],
                                        "price": 42800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547731",
                                            "variationId": "121812799"
                                          },
                                          {
                                            "groupId": "38547732",
                                            "variationId": "121812802"
                                          },
                                          {
                                            "groupId": "38547733",
                                            "variationId": "121812804"
                                          }
                                        ],
                                        "price": 42800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547731",
                                            "variationId": "121812800"
                                          },
                                          {
                                            "groupId": "38547732",
                                            "variationId": "121812802"
                                          },
                                          {
                                            "groupId": "38547733",
                                            "variationId": "121812803"
                                          }
                                        ],
                                        "price": 43800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547731",
                                            "variationId": "121812800"
                                          },
                                          {
                                            "groupId": "38547732",
                                            "variationId": "121812802"
                                          },
                                          {
                                            "groupId": "38547733",
                                            "variationId": "121812804"
                                          }
                                        ],
                                        "price": 43800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547731",
                                            "variationId": "121812801"
                                          },
                                          {
                                            "groupId": "38547732",
                                            "variationId": "121812802"
                                          },
                                          {
                                            "groupId": "38547733",
                                            "variationId": "121812803"
                                          }
                                        ],
                                        "price": 43800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547731",
                                            "variationId": "121812801"
                                          },
                                          {
                                            "groupId": "38547732",
                                            "variationId": "121812802"
                                          },
                                          {
                                            "groupId": "38547733",
                                            "variationId": "121812804"
                                          }
                                        ],
                                        "price": 43800
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 42800,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "120327942",
                                  "name": "Non - Veg Chinese Bowls with Dessert",
                                  "category": "Combo",
                                  "description": "Serves 1 | Delish Non - Veg Chinese Bowls with Dessert",
                                  "imageId": "fcdddfc468b410f1b5fb9acf6ad392f7",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "38547734",
                                        "name": "Choose Non - Veg Gravy",
                                        "variations": [
                                          {
                                            "name": "Chilli Chicken Gravy",
                                            "price": 348,
                                            "default": 1,
                                            "id": "121812805",
                                            "inStock": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547735",
                                              "variationId": "121812809"
                                            }
                                          },
                                          {
                                            "name": "Chicken Manchurian Gravy",
                                            "price": 358,
                                            "id": "121812806",
                                            "inStock": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547735",
                                              "variationId": "121812809"
                                            }
                                          },
                                          {
                                            "name": "Schezwan Chicken Gravy",
                                            "price": 358,
                                            "id": "121812807",
                                            "inStock": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547735",
                                              "variationId": "121812809"
                                            }
                                          },
                                          {
                                            "name": "Kung Pao Chicken Gravy",
                                            "price": 368,
                                            "id": "121812808",
                                            "inStock": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547735",
                                              "variationId": "121812809"
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "38547735",
                                        "name": "Choose Rice/Noodles",
                                        "variations": [
                                          {
                                            "name": "Fried Rice",
                                            "price": 1,
                                            "default": 1,
                                            "id": "121812809",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547736",
                                              "variationId": "121812817"
                                            }
                                          },
                                          {
                                            "name": "Hakka Noodles",
                                            "price": 10,
                                            "id": "121812810",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547736",
                                              "variationId": "121812817"
                                            }
                                          },
                                          {
                                            "name": "Burnt Garlic Fried Rice",
                                            "price": 20,
                                            "id": "121812811",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547736",
                                              "variationId": "121812817"
                                            }
                                          },
                                          {
                                            "name": "Burnt Garlic Noodles",
                                            "price": 20,
                                            "id": "121812812",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547736",
                                              "variationId": "121812817"
                                            }
                                          },
                                          {
                                            "name": "Chilli Garlic Fried Rice",
                                            "price": 20,
                                            "id": "121812813",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547736",
                                              "variationId": "121812817"
                                            }
                                          },
                                          {
                                            "name": "Chilli Garlic Noodles",
                                            "price": 20,
                                            "id": "121812814",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547736",
                                              "variationId": "121812817"
                                            }
                                          },
                                          {
                                            "name": "Schezwan Fried Rice",
                                            "price": 30,
                                            "id": "121812815",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547736",
                                              "variationId": "121812817"
                                            }
                                          },
                                          {
                                            "name": "Schezwan Noodles",
                                            "price": 30,
                                            "id": "121812816",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547736",
                                              "variationId": "121812817"
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "38547736",
                                        "name": "Choose Your Dessert",
                                        "variations": [
                                          {
                                            "name": "Chocolate Mousse",
                                            "default": 1,
                                            "id": "121812817",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547734",
                                            "variationId": "121812805"
                                          },
                                          {
                                            "groupId": "38547735",
                                            "variationId": "121812809"
                                          },
                                          {
                                            "groupId": "38547736",
                                            "variationId": "121812817"
                                          }
                                        ],
                                        "price": 34900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547734",
                                            "variationId": "121812805"
                                          },
                                          {
                                            "groupId": "38547735",
                                            "variationId": "121812810"
                                          },
                                          {
                                            "groupId": "38547736",
                                            "variationId": "121812817"
                                          }
                                        ],
                                        "price": 35800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547734",
                                            "variationId": "121812805"
                                          },
                                          {
                                            "groupId": "38547735",
                                            "variationId": "121812811"
                                          },
                                          {
                                            "groupId": "38547736",
                                            "variationId": "121812817"
                                          }
                                        ],
                                        "price": 36800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547734",
                                            "variationId": "121812805"
                                          },
                                          {
                                            "groupId": "38547735",
                                            "variationId": "121812812"
                                          },
                                          {
                                            "groupId": "38547736",
                                            "variationId": "121812817"
                                          }
                                        ],
                                        "price": 36800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547734",
                                            "variationId": "121812805"
                                          },
                                          {
                                            "groupId": "38547735",
                                            "variationId": "121812813"
                                          },
                                          {
                                            "groupId": "38547736",
                                            "variationId": "121812817"
                                          }
                                        ],
                                        "price": 36800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547734",
                                            "variationId": "121812805"
                                          },
                                          {
                                            "groupId": "38547735",
                                            "variationId": "121812814"
                                          },
                                          {
                                            "groupId": "38547736",
                                            "variationId": "121812817"
                                          }
                                        ],
                                        "price": 36800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547734",
                                            "variationId": "121812805"
                                          },
                                          {
                                            "groupId": "38547735",
                                            "variationId": "121812815"
                                          },
                                          {
                                            "groupId": "38547736",
                                            "variationId": "121812817"
                                          }
                                        ],
                                        "price": 37800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547734",
                                            "variationId": "121812805"
                                          },
                                          {
                                            "groupId": "38547735",
                                            "variationId": "121812816"
                                          },
                                          {
                                            "groupId": "38547736",
                                            "variationId": "121812817"
                                          }
                                        ],
                                        "price": 37800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547734",
                                            "variationId": "121812806"
                                          },
                                          {
                                            "groupId": "38547735",
                                            "variationId": "121812809"
                                          },
                                          {
                                            "groupId": "38547736",
                                            "variationId": "121812817"
                                          }
                                        ],
                                        "price": 35900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547734",
                                            "variationId": "121812806"
                                          },
                                          {
                                            "groupId": "38547735",
                                            "variationId": "121812810"
                                          },
                                          {
                                            "groupId": "38547736",
                                            "variationId": "121812817"
                                          }
                                        ],
                                        "price": 36800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547734",
                                            "variationId": "121812806"
                                          },
                                          {
                                            "groupId": "38547735",
                                            "variationId": "121812811"
                                          },
                                          {
                                            "groupId": "38547736",
                                            "variationId": "121812817"
                                          }
                                        ],
                                        "price": 37800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547734",
                                            "variationId": "121812806"
                                          },
                                          {
                                            "groupId": "38547735",
                                            "variationId": "121812812"
                                          },
                                          {
                                            "groupId": "38547736",
                                            "variationId": "121812817"
                                          }
                                        ],
                                        "price": 37800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547734",
                                            "variationId": "121812806"
                                          },
                                          {
                                            "groupId": "38547735",
                                            "variationId": "121812813"
                                          },
                                          {
                                            "groupId": "38547736",
                                            "variationId": "121812817"
                                          }
                                        ],
                                        "price": 37800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547734",
                                            "variationId": "121812806"
                                          },
                                          {
                                            "groupId": "38547735",
                                            "variationId": "121812814"
                                          },
                                          {
                                            "groupId": "38547736",
                                            "variationId": "121812817"
                                          }
                                        ],
                                        "price": 37800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547734",
                                            "variationId": "121812806"
                                          },
                                          {
                                            "groupId": "38547735",
                                            "variationId": "121812815"
                                          },
                                          {
                                            "groupId": "38547736",
                                            "variationId": "121812817"
                                          }
                                        ],
                                        "price": 38800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547734",
                                            "variationId": "121812806"
                                          },
                                          {
                                            "groupId": "38547735",
                                            "variationId": "121812816"
                                          },
                                          {
                                            "groupId": "38547736",
                                            "variationId": "121812817"
                                          }
                                        ],
                                        "price": 38800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547734",
                                            "variationId": "121812807"
                                          },
                                          {
                                            "groupId": "38547735",
                                            "variationId": "121812809"
                                          },
                                          {
                                            "groupId": "38547736",
                                            "variationId": "121812817"
                                          }
                                        ],
                                        "price": 35900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547734",
                                            "variationId": "121812807"
                                          },
                                          {
                                            "groupId": "38547735",
                                            "variationId": "121812810"
                                          },
                                          {
                                            "groupId": "38547736",
                                            "variationId": "121812817"
                                          }
                                        ],
                                        "price": 36800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547734",
                                            "variationId": "121812807"
                                          },
                                          {
                                            "groupId": "38547735",
                                            "variationId": "121812811"
                                          },
                                          {
                                            "groupId": "38547736",
                                            "variationId": "121812817"
                                          }
                                        ],
                                        "price": 37800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547734",
                                            "variationId": "121812807"
                                          },
                                          {
                                            "groupId": "38547735",
                                            "variationId": "121812812"
                                          },
                                          {
                                            "groupId": "38547736",
                                            "variationId": "121812817"
                                          }
                                        ],
                                        "price": 37800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547734",
                                            "variationId": "121812807"
                                          },
                                          {
                                            "groupId": "38547735",
                                            "variationId": "121812813"
                                          },
                                          {
                                            "groupId": "38547736",
                                            "variationId": "121812817"
                                          }
                                        ],
                                        "price": 37800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547734",
                                            "variationId": "121812807"
                                          },
                                          {
                                            "groupId": "38547735",
                                            "variationId": "121812814"
                                          },
                                          {
                                            "groupId": "38547736",
                                            "variationId": "121812817"
                                          }
                                        ],
                                        "price": 37800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547734",
                                            "variationId": "121812807"
                                          },
                                          {
                                            "groupId": "38547735",
                                            "variationId": "121812815"
                                          },
                                          {
                                            "groupId": "38547736",
                                            "variationId": "121812817"
                                          }
                                        ],
                                        "price": 38800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547734",
                                            "variationId": "121812807"
                                          },
                                          {
                                            "groupId": "38547735",
                                            "variationId": "121812816"
                                          },
                                          {
                                            "groupId": "38547736",
                                            "variationId": "121812817"
                                          }
                                        ],
                                        "price": 38800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547734",
                                            "variationId": "121812808"
                                          },
                                          {
                                            "groupId": "38547735",
                                            "variationId": "121812809"
                                          },
                                          {
                                            "groupId": "38547736",
                                            "variationId": "121812817"
                                          }
                                        ],
                                        "price": 36900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547734",
                                            "variationId": "121812808"
                                          },
                                          {
                                            "groupId": "38547735",
                                            "variationId": "121812810"
                                          },
                                          {
                                            "groupId": "38547736",
                                            "variationId": "121812817"
                                          }
                                        ],
                                        "price": 37800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547734",
                                            "variationId": "121812808"
                                          },
                                          {
                                            "groupId": "38547735",
                                            "variationId": "121812811"
                                          },
                                          {
                                            "groupId": "38547736",
                                            "variationId": "121812817"
                                          }
                                        ],
                                        "price": 38800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547734",
                                            "variationId": "121812808"
                                          },
                                          {
                                            "groupId": "38547735",
                                            "variationId": "121812812"
                                          },
                                          {
                                            "groupId": "38547736",
                                            "variationId": "121812817"
                                          }
                                        ],
                                        "price": 38800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547734",
                                            "variationId": "121812808"
                                          },
                                          {
                                            "groupId": "38547735",
                                            "variationId": "121812813"
                                          },
                                          {
                                            "groupId": "38547736",
                                            "variationId": "121812817"
                                          }
                                        ],
                                        "price": 38800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547734",
                                            "variationId": "121812808"
                                          },
                                          {
                                            "groupId": "38547735",
                                            "variationId": "121812814"
                                          },
                                          {
                                            "groupId": "38547736",
                                            "variationId": "121812817"
                                          }
                                        ],
                                        "price": 38800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547734",
                                            "variationId": "121812808"
                                          },
                                          {
                                            "groupId": "38547735",
                                            "variationId": "121812815"
                                          },
                                          {
                                            "groupId": "38547736",
                                            "variationId": "121812817"
                                          }
                                        ],
                                        "price": 39800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547734",
                                            "variationId": "121812808"
                                          },
                                          {
                                            "groupId": "38547735",
                                            "variationId": "121812816"
                                          },
                                          {
                                            "groupId": "38547736",
                                            "variationId": "121812817"
                                          }
                                        ],
                                        "price": 39800
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 34900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "120327943",
                                  "name": "Non - Veg Chinese Bowls with Drinks",
                                  "category": "Combo",
                                  "description": "Serves 1 | Delish  Non - Veg Chinese Bowls with Drinks",
                                  "imageId": "03651d8c0dd4133fa6a0d28357184e87",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "38547737",
                                        "name": "Choose Non - Veg Gravy",
                                        "variations": [
                                          {
                                            "name": "Chilli Chicken Gravy",
                                            "price": 309,
                                            "default": 1,
                                            "id": "121812818",
                                            "inStock": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547738",
                                              "variationId": "121812822"
                                            }
                                          },
                                          {
                                            "name": "Chicken Manchurian Gravy",
                                            "price": 319,
                                            "id": "121812819",
                                            "inStock": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547738",
                                              "variationId": "121812822"
                                            }
                                          },
                                          {
                                            "name": "Schezwan Chicken Gravy",
                                            "price": 319,
                                            "id": "121812820",
                                            "inStock": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547738",
                                              "variationId": "121812822"
                                            }
                                          },
                                          {
                                            "name": "Kung Pao Chicken Gravy",
                                            "price": 329,
                                            "id": "121812821",
                                            "inStock": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547738",
                                              "variationId": "121812822"
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "38547738",
                                        "name": "Choose Rice/Noodels",
                                        "variations": [
                                          {
                                            "name": "Fried Rice",
                                            "price": 1,
                                            "default": 1,
                                            "id": "121812822",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547739",
                                              "variationId": "121812830"
                                            }
                                          },
                                          {
                                            "name": "Hakka Noodles",
                                            "price": 10,
                                            "id": "121812823",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547739",
                                              "variationId": "121812830"
                                            }
                                          },
                                          {
                                            "name": "Chilli Garlic Noodles",
                                            "price": 20,
                                            "id": "121812824",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547739",
                                              "variationId": "121812830"
                                            }
                                          },
                                          {
                                            "name": "Chilli Garlic Fried Rice",
                                            "price": 20,
                                            "id": "121812825",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547739",
                                              "variationId": "121812830"
                                            }
                                          },
                                          {
                                            "name": "Burnt Garlic Noodles",
                                            "price": 20,
                                            "id": "121812826",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547739",
                                              "variationId": "121812830"
                                            }
                                          },
                                          {
                                            "name": "Burnt Garlic Fried Rice",
                                            "price": 20,
                                            "id": "121812827",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547739",
                                              "variationId": "121812830"
                                            }
                                          },
                                          {
                                            "name": "Schezwan Fried Rice",
                                            "price": 30,
                                            "id": "121812828",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547739",
                                              "variationId": "121812830"
                                            }
                                          },
                                          {
                                            "name": "Schezwan Noodles",
                                            "price": 30,
                                            "id": "121812829",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547739",
                                              "variationId": "121812830"
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "38547739",
                                        "name": "Choose Your Drink",
                                        "variations": [
                                          {
                                            "name": "Pepsi Pet Bottle",
                                            "default": 1,
                                            "id": "121812830",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "7 Up Pet Bottle",
                                            "id": "121812831",
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812818"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812822"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812830"
                                          }
                                        ],
                                        "price": 31000
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812818"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812822"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812831"
                                          }
                                        ],
                                        "price": 31000
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812818"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812823"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812830"
                                          }
                                        ],
                                        "price": 31900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812818"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812823"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812831"
                                          }
                                        ],
                                        "price": 31900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812818"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812824"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812830"
                                          }
                                        ],
                                        "price": 32900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812818"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812824"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812831"
                                          }
                                        ],
                                        "price": 32900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812818"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812825"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812830"
                                          }
                                        ],
                                        "price": 32900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812818"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812825"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812831"
                                          }
                                        ],
                                        "price": 32900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812818"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812826"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812830"
                                          }
                                        ],
                                        "price": 32900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812818"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812826"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812831"
                                          }
                                        ],
                                        "price": 32900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812818"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812827"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812830"
                                          }
                                        ],
                                        "price": 32900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812818"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812827"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812831"
                                          }
                                        ],
                                        "price": 32900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812818"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812828"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812830"
                                          }
                                        ],
                                        "price": 33900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812818"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812828"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812831"
                                          }
                                        ],
                                        "price": 33900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812818"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812829"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812830"
                                          }
                                        ],
                                        "price": 33900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812818"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812829"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812831"
                                          }
                                        ],
                                        "price": 33900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812819"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812822"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812830"
                                          }
                                        ],
                                        "price": 32000
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812819"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812822"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812831"
                                          }
                                        ],
                                        "price": 32000
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812819"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812823"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812830"
                                          }
                                        ],
                                        "price": 32900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812819"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812823"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812831"
                                          }
                                        ],
                                        "price": 32900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812819"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812824"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812830"
                                          }
                                        ],
                                        "price": 33900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812819"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812824"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812831"
                                          }
                                        ],
                                        "price": 33900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812819"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812825"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812830"
                                          }
                                        ],
                                        "price": 33900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812819"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812825"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812831"
                                          }
                                        ],
                                        "price": 33900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812819"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812826"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812830"
                                          }
                                        ],
                                        "price": 33900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812819"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812826"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812831"
                                          }
                                        ],
                                        "price": 33900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812819"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812827"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812830"
                                          }
                                        ],
                                        "price": 33900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812819"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812827"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812831"
                                          }
                                        ],
                                        "price": 33900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812819"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812828"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812830"
                                          }
                                        ],
                                        "price": 34900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812819"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812828"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812831"
                                          }
                                        ],
                                        "price": 34900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812819"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812829"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812830"
                                          }
                                        ],
                                        "price": 34900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812819"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812829"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812831"
                                          }
                                        ],
                                        "price": 34900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812820"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812822"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812830"
                                          }
                                        ],
                                        "price": 32000
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812820"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812822"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812831"
                                          }
                                        ],
                                        "price": 32000
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812820"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812823"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812830"
                                          }
                                        ],
                                        "price": 32900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812820"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812823"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812831"
                                          }
                                        ],
                                        "price": 32900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812820"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812824"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812830"
                                          }
                                        ],
                                        "price": 33900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812820"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812824"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812831"
                                          }
                                        ],
                                        "price": 33900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812820"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812825"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812830"
                                          }
                                        ],
                                        "price": 33900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812820"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812825"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812831"
                                          }
                                        ],
                                        "price": 33900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812820"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812826"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812830"
                                          }
                                        ],
                                        "price": 33900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812820"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812826"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812831"
                                          }
                                        ],
                                        "price": 33900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812820"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812827"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812830"
                                          }
                                        ],
                                        "price": 33900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812820"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812827"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812831"
                                          }
                                        ],
                                        "price": 33900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812820"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812828"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812830"
                                          }
                                        ],
                                        "price": 34900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812820"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812828"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812831"
                                          }
                                        ],
                                        "price": 34900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812820"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812829"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812830"
                                          }
                                        ],
                                        "price": 34900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812820"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812829"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812831"
                                          }
                                        ],
                                        "price": 34900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812821"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812822"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812830"
                                          }
                                        ],
                                        "price": 33000
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812821"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812822"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812831"
                                          }
                                        ],
                                        "price": 33000
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812821"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812823"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812830"
                                          }
                                        ],
                                        "price": 33900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812821"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812823"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812831"
                                          }
                                        ],
                                        "price": 33900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812821"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812824"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812830"
                                          }
                                        ],
                                        "price": 34900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812821"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812824"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812831"
                                          }
                                        ],
                                        "price": 34900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812821"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812825"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812830"
                                          }
                                        ],
                                        "price": 34900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812821"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812825"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812831"
                                          }
                                        ],
                                        "price": 34900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812821"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812826"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812830"
                                          }
                                        ],
                                        "price": 34900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812821"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812826"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812831"
                                          }
                                        ],
                                        "price": 34900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812821"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812827"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812830"
                                          }
                                        ],
                                        "price": 34900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812821"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812827"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812831"
                                          }
                                        ],
                                        "price": 34900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812821"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812828"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812830"
                                          }
                                        ],
                                        "price": 35900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812821"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812828"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812831"
                                          }
                                        ],
                                        "price": 35900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812821"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812829"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812830"
                                          }
                                        ],
                                        "price": 35900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547737",
                                            "variationId": "121812821"
                                          },
                                          {
                                            "groupId": "38547738",
                                            "variationId": "121812829"
                                          },
                                          {
                                            "groupId": "38547739",
                                            "variationId": "121812831"
                                          }
                                        ],
                                        "price": 35900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 31000,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "120327944",
                                  "name": "Non - Veg Chinese Bowls with Dessert & Drinks",
                                  "category": "Combo",
                                  "description": "Serves 1 | Delish  Non - Veg Chinese Bowls with Dessert and  Drinks",
                                  "imageId": "bf7ba2ea252f7121084f82612089885a",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "38547740",
                                        "name": "Choose Non - Veg Gravy",
                                        "variations": [
                                          {
                                            "name": "Chilli Chicken Gravy",
                                            "price": 408,
                                            "default": 1,
                                            "id": "121812834",
                                            "inStock": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547741",
                                              "variationId": "121812838"
                                            }
                                          },
                                          {
                                            "name": "Chicken Manchurian Gravy",
                                            "price": 418,
                                            "id": "121812835",
                                            "inStock": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547741",
                                              "variationId": "121812838"
                                            }
                                          },
                                          {
                                            "name": "Schezwan Chicken Gravy",
                                            "price": 418,
                                            "id": "121812836",
                                            "inStock": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547741",
                                              "variationId": "121812838"
                                            }
                                          },
                                          {
                                            "name": "Kung Pao Chicken Gravy",
                                            "price": 428,
                                            "id": "121812837",
                                            "inStock": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547741",
                                              "variationId": "121812838"
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "38547741",
                                        "name": "Choose Rice/Noodle",
                                        "variations": [
                                          {
                                            "name": "Fried Rice",
                                            "price": 1,
                                            "default": 1,
                                            "id": "121812838",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547742",
                                              "variationId": "121812846"
                                            }
                                          },
                                          {
                                            "name": "Hakka Noodles",
                                            "price": 10,
                                            "id": "121812839",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547742",
                                              "variationId": "121812846"
                                            }
                                          },
                                          {
                                            "name": "Burnt Garlic Fried Rice",
                                            "price": 20,
                                            "id": "121812840",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547742",
                                              "variationId": "121812846"
                                            }
                                          },
                                          {
                                            "name": "Burnt Garlic Noodles",
                                            "price": 20,
                                            "id": "121812841",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547742",
                                              "variationId": "121812846"
                                            }
                                          },
                                          {
                                            "name": "Chilli Garlic Fried Rice",
                                            "price": 20,
                                            "id": "121812842",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547742",
                                              "variationId": "121812846"
                                            }
                                          },
                                          {
                                            "name": "Chilli Garlic Noodles",
                                            "price": 20,
                                            "id": "121812843",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547742",
                                              "variationId": "121812846"
                                            }
                                          },
                                          {
                                            "name": "Schezwan Fried Rice",
                                            "price": 30,
                                            "id": "121812844",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547742",
                                              "variationId": "121812846"
                                            }
                                          },
                                          {
                                            "name": "Schezwan Noodles",
                                            "price": 30,
                                            "id": "121812845",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547742",
                                              "variationId": "121812846"
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "38547742",
                                        "name": "Choose Your Dessert",
                                        "variations": [
                                          {
                                            "name": "Chocolate Mousse",
                                            "default": 1,
                                            "id": "121812846",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "38547743",
                                              "variationId": "121812847"
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "38547743",
                                        "name": "Choose Your Drink",
                                        "variations": [
                                          {
                                            "name": "Pepsi Pet Bottle",
                                            "default": 1,
                                            "id": "121812847",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "7 Up Pet Bottle",
                                            "id": "121812848",
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812834"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812838"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812847"
                                          }
                                        ],
                                        "price": 40900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812834"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812838"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812848"
                                          }
                                        ],
                                        "price": 40900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812834"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812839"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812847"
                                          }
                                        ],
                                        "price": 41800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812834"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812839"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812848"
                                          }
                                        ],
                                        "price": 41800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812834"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812840"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812847"
                                          }
                                        ],
                                        "price": 42800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812834"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812840"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812848"
                                          }
                                        ],
                                        "price": 42800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812834"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812841"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812847"
                                          }
                                        ],
                                        "price": 42800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812834"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812841"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812848"
                                          }
                                        ],
                                        "price": 42800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812834"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812842"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812847"
                                          }
                                        ],
                                        "price": 42800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812834"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812842"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812848"
                                          }
                                        ],
                                        "price": 42800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812834"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812843"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812847"
                                          }
                                        ],
                                        "price": 42800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812834"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812843"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812848"
                                          }
                                        ],
                                        "price": 42800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812834"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812844"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812847"
                                          }
                                        ],
                                        "price": 43800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812834"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812844"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812848"
                                          }
                                        ],
                                        "price": 43800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812834"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812845"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812847"
                                          }
                                        ],
                                        "price": 43800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812834"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812845"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812848"
                                          }
                                        ],
                                        "price": 43800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812835"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812838"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812847"
                                          }
                                        ],
                                        "price": 41900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812835"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812838"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812848"
                                          }
                                        ],
                                        "price": 41900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812835"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812839"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812847"
                                          }
                                        ],
                                        "price": 42800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812835"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812839"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812848"
                                          }
                                        ],
                                        "price": 42800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812835"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812840"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812847"
                                          }
                                        ],
                                        "price": 43800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812835"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812840"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812848"
                                          }
                                        ],
                                        "price": 43800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812835"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812841"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812847"
                                          }
                                        ],
                                        "price": 43800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812835"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812841"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812848"
                                          }
                                        ],
                                        "price": 43800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812835"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812842"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812847"
                                          }
                                        ],
                                        "price": 43800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812835"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812842"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812848"
                                          }
                                        ],
                                        "price": 43800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812835"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812843"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812847"
                                          }
                                        ],
                                        "price": 43800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812835"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812843"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812848"
                                          }
                                        ],
                                        "price": 43800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812835"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812844"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812847"
                                          }
                                        ],
                                        "price": 44800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812835"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812844"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812848"
                                          }
                                        ],
                                        "price": 44800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812835"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812845"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812847"
                                          }
                                        ],
                                        "price": 44800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812835"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812845"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812848"
                                          }
                                        ],
                                        "price": 44800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812836"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812838"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812847"
                                          }
                                        ],
                                        "price": 41900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812836"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812838"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812848"
                                          }
                                        ],
                                        "price": 41900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812836"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812839"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812847"
                                          }
                                        ],
                                        "price": 42800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812836"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812839"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812848"
                                          }
                                        ],
                                        "price": 42800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812836"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812840"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812847"
                                          }
                                        ],
                                        "price": 43800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812836"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812840"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812848"
                                          }
                                        ],
                                        "price": 43800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812836"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812841"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812847"
                                          }
                                        ],
                                        "price": 43800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812836"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812841"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812848"
                                          }
                                        ],
                                        "price": 43800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812836"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812842"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812847"
                                          }
                                        ],
                                        "price": 43800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812836"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812842"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812848"
                                          }
                                        ],
                                        "price": 43800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812836"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812843"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812847"
                                          }
                                        ],
                                        "price": 43800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812836"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812843"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812848"
                                          }
                                        ],
                                        "price": 43800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812836"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812844"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812847"
                                          }
                                        ],
                                        "price": 44800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812836"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812844"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812848"
                                          }
                                        ],
                                        "price": 44800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812836"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812845"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812847"
                                          }
                                        ],
                                        "price": 44800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812836"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812845"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812848"
                                          }
                                        ],
                                        "price": 44800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812837"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812838"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812847"
                                          }
                                        ],
                                        "price": 42900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812837"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812838"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812848"
                                          }
                                        ],
                                        "price": 42900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812837"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812839"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812847"
                                          }
                                        ],
                                        "price": 43800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812837"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812839"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812848"
                                          }
                                        ],
                                        "price": 43800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812837"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812840"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812847"
                                          }
                                        ],
                                        "price": 44800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812837"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812840"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812848"
                                          }
                                        ],
                                        "price": 44800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812837"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812841"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812847"
                                          }
                                        ],
                                        "price": 44800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812837"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812841"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812848"
                                          }
                                        ],
                                        "price": 44800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812837"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812842"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812847"
                                          }
                                        ],
                                        "price": 44800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812837"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812842"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812848"
                                          }
                                        ],
                                        "price": 44800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812837"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812843"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812847"
                                          }
                                        ],
                                        "price": 44800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812837"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812843"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812848"
                                          }
                                        ],
                                        "price": 44800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812837"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812844"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812847"
                                          }
                                        ],
                                        "price": 45800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812837"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812844"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812848"
                                          }
                                        ],
                                        "price": 45800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812837"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812845"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812847"
                                          }
                                        ],
                                        "price": 45800
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547740",
                                            "variationId": "121812837"
                                          },
                                          {
                                            "groupId": "38547741",
                                            "variationId": "121812845"
                                          },
                                          {
                                            "groupId": "38547742",
                                            "variationId": "121812846"
                                          },
                                          {
                                            "groupId": "38547743",
                                            "variationId": "121812848"
                                          }
                                        ],
                                        "price": 45800
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 40900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Indian Bowls",
                      "categories": [
                        {
                          "title": "Indian Bowl - Veg",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93656474",
                                  "name": "Paneer Tawa Rice Bowl",
                                  "category": "Indian Bowls",
                                  "description": "Serves 1 | Paneer tossed In A Medium Spicy Onion & Tomato Gravy served with Jeera Rice",
                                  "imageId": "71b689a8f6d77cac283c1e2af8ea0a96",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 29900,
                                  "finalPrice": 16900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      
                                    }
                                  ],
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "6 ratings",
                                      "ratingCountV2": "6"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93656511",
                                  "name": "Paneer Bhuna Rice Bowl",
                                  "category": "Indian Bowls",
                                  "description": "Serves 1 | Paneer sauted In Brown Onion Gravy With Coarsely Grounded Spices served with Jeera Rice",
                                  "imageId": "f279532487eff3ac1cbb59e13dfa9d3d",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 29900,
                                  "finalPrice": 16900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      
                                    }
                                  ],
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "103484959",
                                  "name": "Potato In choice of Indian Gravy - Rice Bowl",
                                  "category": "Indian Bowls",
                                  "description": "Serves 1 | Potato in choice of Indian gravy",
                                  "imageId": "gzgvpnlje6wzg96kmrhu",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "38547705",
                                        "name": "Select Gravy",
                                        "variations": [
                                          {
                                            "name": "Makhani Gravy",
                                            "price": 229,
                                            "default": 1,
                                            "id": "121812719",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Spicy Makhani Gravy",
                                            "price": 229,
                                            "id": "121812720",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Kadhai Gravy",
                                            "price": 229,
                                            "id": "121812721",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547705",
                                            "variationId": "121812719"
                                          }
                                        ],
                                        "price": 22900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177672",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177672",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177672",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177672",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177672",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177670",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177670",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177670",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177670",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177670",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177670",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177670",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177670",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177670",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177670",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547705",
                                            "variationId": "121812720"
                                          }
                                        ],
                                        "price": 22900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177672",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177672",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177672",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177672",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177672",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177670",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177670",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177670",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177670",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177670",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177670",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177670",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177670",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177670",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177670",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547705",
                                            "variationId": "121812721"
                                          }
                                        ],
                                        "price": 22900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177672",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177672",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177672",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177672",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177672",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177670",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177670",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177670",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177670",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177670",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177670",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177670",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177670",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177670",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177670",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177670",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177672",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 22900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "8 ratings",
                                      "ratingCountV2": "8"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "69492488",
                                  "name": "Dal Fry Rice Bowl",
                                  "category": "Indian Bowls",
                                  "description": "Serves 1 | Yellow dal tempered with garlic and jeera served with jeera rice.",
                                  "imageId": "cc2710c8da2c6c9d4d55a0b593b3e582",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 19900,
                                  "finalPrice": 16900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      
                                    }
                                  ],
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "82 ratings",
                                      "ratingCountV2": "82"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "72570454",
                                  "name": "Dal Khichdi Bowl",
                                  "category": "Indian Bowls",
                                  "description": "Serves 1 | Comfort of dal and rice mixed together with a tempering of garlic and jeera.",
                                  "imageId": "df21feb97fc789dce1c27c6d5d5683df",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 20900,
                                  "finalPrice": 16900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      
                                    }
                                  ],
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.7",
                                      "ratingCount": "27 ratings",
                                      "ratingCountV2": "27"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "69492493",
                                  "name": "Rajma Chawal Bowl",
                                  "category": "Indian Bowls",
                                  "description": "Serves 1 | Home style cooked rajma gravy served with jeera rice.",
                                  "imageId": "cfbe130bc6159126e4ef547f2576b2a0",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 23900,
                                  "finalPrice": 16900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      
                                    }
                                  ],
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.8",
                                      "ratingCount": "99 ratings",
                                      "ratingCountV2": "99"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "69258850",
                                  "name": "Pindi Chole Rice Bowl",
                                  "category": "Indian Bowls",
                                  "description": "Serves 1 | Chole simmered in rich brown masala gravy served with jeera rice.",
                                  "imageId": "c5f7de7f4adbed6b6fb9929b7b18ed00",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 25900,
                                  "finalPrice": 16900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      
                                    }
                                  ],
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.5",
                                      "ratingCount": "42 ratings",
                                      "ratingCountV2": "42"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "69492496",
                                  "name": "Dal Makhani Rice Bowl",
                                  "category": "Indian Bowls",
                                  "description": "Serves 1 | Classic rich dal makhani served with jeera rice.",
                                  "imageId": "879b6f09d0570952a752cf636bbf058e",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 21900,
                                  "finalPrice": 16900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      
                                    }
                                  ],
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "2.8",
                                      "ratingCount": "69 ratings",
                                      "ratingCountV2": "69"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "69258854",
                                  "name": "Paneer Kadai Rice Bowl",
                                  "category": "Indian Bowls",
                                  "description": "Serves 1 | Paneer with capsicum and onion tossed in a medium spicy kadhai gravy served with jeera rice.",
                                  "imageId": "85fd6398efca7d92dbba2d48b2e0b0c5",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 25900,
                                  "finalPrice": 16900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      
                                    }
                                  ],
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "1.1",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "69258856",
                                  "name": "Paneer Butter Masala Rice Bowl",
                                  "category": "Indian Bowls",
                                  "description": "Serves 1 | Tender paneer cubes tossed in a rich makhani gravy served with jeera rice.",
                                  "imageId": "77741423613b097ddb40967897a39920",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 29900,
                                  "finalPrice": 16900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      
                                    }
                                  ],
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.7",
                                      "ratingCount": "29 ratings",
                                      "ratingCountV2": "29"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "72570459",
                                  "name": "Spicy Paneer Butter Masala Rice Bowl",
                                  "category": "Indian Bowls",
                                  "description": "Serves 1 | Tender paneer cubes tossed in a rich medium spicy makhani gravy served with jeera rice.",
                                  "imageId": "8189e4fbabc400d5fc4bdaea3a61cd03",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 29900,
                                  "finalPrice": 16900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      
                                    }
                                  ],
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.9",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Indian Bowl Non-Veg",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93656517",
                                  "name": "Chicken Tawa Rice Bowl",
                                  "category": "Indian Bowls",
                                  "description": "Serves 1 | Chicken tossed In A Medium Spicy Onion & Tomato Gravy served with Jeera Rice",
                                  "imageId": "b706010cfc0685d9193c372ddd2c2b03",
                                  "inStock": 1,
                                  "price": 30900,
                                  "finalPrice": 16900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      
                                    }
                                  ],
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.1",
                                      "ratingCount": "5 ratings",
                                      "ratingCountV2": "5"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93656537",
                                  "name": "Chicken Bhuna Rice Bowl",
                                  "category": "Indian Bowls",
                                  "description": "Serves 1 | Chicken sauted In Brown Onion Gravy With Coarsely Grounded Spices served with Jeera Rice",
                                  "imageId": "63f42c19b53b90c76fb74b4bc79db863",
                                  "inStock": 1,
                                  "price": 30900,
                                  "finalPrice": 16900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      
                                    }
                                  ],
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.4",
                                      "ratingCount": "7 ratings",
                                      "ratingCountV2": "7"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "72570461",
                                  "name": "Chicken Kadai Rice Bowl",
                                  "category": "Indian Bowls",
                                  "description": "Serves 1 | Char-grilled chicken with capsicum and onion tossed in a medium spicy kadhai gravy served with jeera rice.",
                                  "imageId": "au2r5e8sbuharevtskwl",
                                  "inStock": 1,
                                  "price": 30900,
                                  "finalPrice": 16900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      
                                    }
                                  ],
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "69492568",
                                  "name": "Smoky Butter Chicken Rice Bowl",
                                  "category": "Indian Bowls",
                                  "description": "Serves 1 | Smoky char-grilled chicken tossed in a rich makhani gravy served with jeera rice.",
                                  "imageId": "ftty7hlxav5xfw0dsk8p",
                                  "inStock": 1,
                                  "price": 30900,
                                  "finalPrice": 16900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      
                                    }
                                  ],
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "47 ratings",
                                      "ratingCountV2": "47"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "72570460",
                                  "name": "Spicy Butter Chicken Rice Bowl",
                                  "category": "Indian Bowls",
                                  "description": "Serves 1 | Smoky char-grilled chicken tossed in a rich medium spicy makhani gravy served with jeera rice.",
                                  "imageId": "iocbgqsyrcakibvks7py",
                                  "inStock": 1,
                                  "price": 30900,
                                  "finalPrice": 16900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      
                                    }
                                  ],
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "1.8",
                                      "ratingCount": "6 ratings",
                                      "ratingCountV2": "6"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Chinese Bowls",
                      "categories": [
                        {
                          "title": "Rice & Noodle Bowls",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "69492324",
                                  "name": "Veg Fried Rice Bowl",
                                  "category": "Chinese Bowls",
                                  "description": "Serves 1 | Rice tossed with carrot, french beans & baby corn, garnished with spring onion.",
                                  "imageId": "kwtabo4vx9u8jor9kntd",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 17900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177162",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177163",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177165",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177166",
                                      "groupName": "Add Veg Starters",
                                      "choices": [
                                        {
                                          "id": "113732090",
                                          "name": "Chilli Paneer",
                                          "price": 30900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732113",
                                          "name": "Veg Spring Rolls (4 pcs)",
                                          "price": 16900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732093",
                                          "name": "Veg Manchurian Dry",
                                          "price": 26900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "13 ratings",
                                      "ratingCountV2": "13"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "69492325",
                                  "name": "Veg Burnt Garlic Fried Rice Bowl",
                                  "category": "Chinese Bowls",
                                  "description": "Serves 1 | Rice carrot, french beans & baby corn tossed with burnt garlic & coriander.",
                                  "imageId": "y56gzpxonatrxfnoyozr",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 18900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177354",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177355",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177356",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177358",
                                      "groupName": "Add Veg Starters",
                                      "choices": [
                                        {
                                          "id": "113732090",
                                          "name": "Chilli Paneer",
                                          "price": 30900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732113",
                                          "name": "Veg Spring Rolls (4 pcs)",
                                          "price": 16900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732093",
                                          "name": "Veg Manchurian Dry",
                                          "price": 26900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.5",
                                      "ratingCount": "12 ratings",
                                      "ratingCountV2": "12"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "69492326",
                                  "name": "Veg Chilli Garlic Fried Rice Bowl",
                                  "category": "Chinese Bowls",
                                  "description": "Serves 1 | Rice tossed with carrot,french beans & babycorn flavoured with soy,garlic and chilli flakes garnished with spring onion.",
                                  "imageId": "o5p4qw5oq0bkhvjbpsfj",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 19900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177261",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177263",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177264",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177267",
                                      "groupName": "Add Veg Starters",
                                      "choices": [
                                        {
                                          "id": "113732090",
                                          "name": "Chilli Paneer",
                                          "price": 30900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732113",
                                          "name": "Veg Spring Rolls (4 pcs)",
                                          "price": 16900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732093",
                                          "name": "Veg Manchurian Dry",
                                          "price": 26900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "33 ratings",
                                      "ratingCountV2": "33"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "69492475",
                                  "name": "Veg Schezwan Fried Rice Bowl",
                                  "category": "Chinese Bowls",
                                  "description": "Serves 1 | Mixed veggies tossed in schezwan sauce with rice.",
                                  "imageId": "fwtn3bh6qanb7mr93hrf",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 23900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177576",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177577",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177578",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177579",
                                      "groupName": "Add Veg Starters",
                                      "choices": [
                                        {
                                          "id": "113732090",
                                          "name": "Chilli Paneer",
                                          "price": 30900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732113",
                                          "name": "Veg Spring Rolls (4 pcs)",
                                          "price": 16900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732093",
                                          "name": "Veg Manchurian Dry",
                                          "price": 26900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "1.7",
                                      "ratingCount": "6 ratings",
                                      "ratingCountV2": "6"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "69492328",
                                  "name": "Veg Hakka Noodles Bowl",
                                  "category": "Chinese Bowls",
                                  "description": "Serves 1 | Noodles tossed with cabbage, onion, carrot with a touch of dark soya & garnished with spring onion.",
                                  "imageId": "cmzfdgkptykmalumzirf",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 19900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177280",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177281",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177282",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177285",
                                      "groupName": "Add Veg Starters",
                                      "choices": [
                                        {
                                          "id": "113732090",
                                          "name": "Chilli Paneer",
                                          "price": 30900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732113",
                                          "name": "Veg Spring Rolls (4 pcs)",
                                          "price": 16900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732093",
                                          "name": "Veg Manchurian Dry",
                                          "price": 26900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isGuiltfree": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "29 ratings",
                                      "ratingCountV2": "29"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "69492330",
                                  "name": "Veg Burnt Garlic Noodles Bowl",
                                  "category": "Chinese Bowls",
                                  "description": "Serves 1 | Noodles tossed with cabbage, onion, carrot, burnt garlic & coriander.",
                                  "imageId": "wrvvgy86s0d0816siaaj",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 21900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177218",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177220",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177222",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177224",
                                      "groupName": "Add Veg Starters",
                                      "choices": [
                                        {
                                          "id": "113732090",
                                          "name": "Chilli Paneer",
                                          "price": 30900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732113",
                                          "name": "Veg Spring Rolls (4 pcs)",
                                          "price": 16900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732093",
                                          "name": "Veg Manchurian Dry",
                                          "price": 26900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.6",
                                      "ratingCount": "7 ratings",
                                      "ratingCountV2": "7"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "69492333",
                                  "name": "Veg Chilli Garlic Noodles Bowl",
                                  "category": "Chinese Bowls",
                                  "description": "Serves 1 | Noodles tossed with carrot, capsicum & onion flavored with chilli flakes, garlic & soy, garnished with spring onion.",
                                  "imageId": "xfjyhe98gcsbiuezyekt",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 21500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177237",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177239",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177241",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177243",
                                      "groupName": "Add Veg Starters",
                                      "choices": [
                                        {
                                          "id": "113732090",
                                          "name": "Chilli Paneer",
                                          "price": 30900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732113",
                                          "name": "Veg Spring Rolls (4 pcs)",
                                          "price": 16900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732093",
                                          "name": "Veg Manchurian Dry",
                                          "price": 26900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isGuiltfree": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "98 ratings",
                                      "ratingCountV2": "98"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "69492482",
                                  "name": "Veg Schezwan Noodles Bowl",
                                  "category": "Chinese Bowls",
                                  "description": "Serves 1 | Mixed veggies tossed in schezwan sauce with noodles.",
                                  "imageId": "epp5hlzbqrdmeml0idat",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 23900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177147",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177148",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177149",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177151",
                                      "groupName": "Add Veg Starters",
                                      "choices": [
                                        {
                                          "id": "113732090",
                                          "name": "Chilli Paneer",
                                          "price": 30900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732113",
                                          "name": "Veg Spring Rolls (4 pcs)",
                                          "price": 16900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732093",
                                          "name": "Veg Manchurian Dry",
                                          "price": 26900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.7",
                                      "ratingCount": "8 ratings",
                                      "ratingCountV2": "8"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "69492336",
                                  "name": "Egg Fried Rice Bowl",
                                  "category": "Chinese Bowls",
                                  "description": "Serves 1 | Rice tossed with egg & carrot, french beans & baby corn, garnished with spring onion .",
                                  "imageId": "u9tlae5i7ttn1bc8sjeu",
                                  "inStock": 1,
                                  "price": 20900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177176",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177177",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177178",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177179",
                                      "groupName": "Add Non Veg Starters",
                                      "choices": [
                                        {
                                          "id": "113732094",
                                          "name": "Chicken Spring Roll (4pcs)",
                                          "price": 20900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732097",
                                          "name": "Chilli Chicken",
                                          "price": 33900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732108",
                                          "name": "Chicken Manchurian",
                                          "price": 33900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "2.9",
                                      "ratingCount": "38 ratings",
                                      "ratingCountV2": "38"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "69492338",
                                  "name": "Chicken Fried Rice Bowl",
                                  "category": "Chinese Bowls",
                                  "description": "Serves 1 | Rice tossed with diced chicken, egg & carrot, french beans & baby corn, garnished with spring onion.",
                                  "imageId": "wdn1lxgfdacda4arhrmp",
                                  "inStock": 1,
                                  "price": 21500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177245",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177246",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177247",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177249",
                                      "groupName": "Add Non Veg Starters",
                                      "choices": [
                                        {
                                          "id": "113732094",
                                          "name": "Chicken Spring Roll (4pcs)",
                                          "price": 20900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732097",
                                          "name": "Chilli Chicken",
                                          "price": 33900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732108",
                                          "name": "Chicken Manchurian",
                                          "price": 33900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.2",
                                      "ratingCount": "143 ratings",
                                      "ratingCountV2": "143"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "86808197",
                                  "name": "Double Egg Fried Rice Bowl",
                                  "category": "Chinese Bowls",
                                  "description": "Serves 1 | Rice tossed with Double Egg & Carrot, French Beans & Baby Corn, garnished with Spring Onion .",
                                  "imageId": "zotp4g4jjhf7aolxr2fk",
                                  "inStock": 1,
                                  "price": 22900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177451",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177454",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177456",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177457",
                                      "groupName": "Add Non Veg Starters",
                                      "choices": [
                                        {
                                          "id": "113732094",
                                          "name": "Chicken Spring Roll (4pcs)",
                                          "price": 20900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732097",
                                          "name": "Chilli Chicken",
                                          "price": 33900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732108",
                                          "name": "Chicken Manchurian",
                                          "price": 33900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "19 ratings",
                                      "ratingCountV2": "19"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "69492341",
                                  "name": "Chicken Burnt Garlic Fried Rice Bowl",
                                  "category": "Chinese Bowls",
                                  "description": "Serves 1 | Rice, diced chicken carrot, french beans & baby corn tossed with burnt garlic & coriander.",
                                  "imageId": "sb3iiemcejpl38reyfuy",
                                  "inStock": 1,
                                  "price": 25900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177427",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177428",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177430",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177433",
                                      "groupName": "Add Non Veg Starters",
                                      "choices": [
                                        {
                                          "id": "113732094",
                                          "name": "Chicken Spring Roll (4pcs)",
                                          "price": 20900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732097",
                                          "name": "Chilli Chicken",
                                          "price": 33900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732108",
                                          "name": "Chicken Manchurian",
                                          "price": 33900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "12 ratings",
                                      "ratingCountV2": "12"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "69492344",
                                  "name": "Chicken Chilli Garlic Fried Rice Bowl",
                                  "category": "Chinese Bowls",
                                  "description": "Serves 1 | Rice tossed with carrot,french beans & babycorn,egg ,chicken flavoured with soy,garlic and chilli flakes garnished with spring onion.",
                                  "imageId": "cpxp6evxmc970hbah8zd",
                                  "inStock": 1,
                                  "price": 25900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177528",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177530",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177531",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177532",
                                      "groupName": "Add Non Veg Starters",
                                      "choices": [
                                        {
                                          "id": "113732094",
                                          "name": "Chicken Spring Roll (4pcs)",
                                          "price": 20900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732097",
                                          "name": "Chilli Chicken",
                                          "price": 33900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732108",
                                          "name": "Chicken Manchurian",
                                          "price": 33900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.3",
                                      "ratingCount": "44 ratings",
                                      "ratingCountV2": "44"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "69492479",
                                  "name": "Chicken Schezwan Fried Rice Bowl",
                                  "category": "Chinese Bowls",
                                  "description": "Serves 1 | Diced chicken and mixed veggies tossed in our schezwan sauce with rice.",
                                  "imageId": "uwsdyczsawqclvad8crv",
                                  "inStock": 1,
                                  "price": 25900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177388",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177390",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177393",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177394",
                                      "groupName": "Add Non Veg Starters",
                                      "choices": [
                                        {
                                          "id": "113732094",
                                          "name": "Chicken Spring Roll (4pcs)",
                                          "price": 20900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732097",
                                          "name": "Chilli Chicken",
                                          "price": 33900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732108",
                                          "name": "Chicken Manchurian",
                                          "price": 33900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "2.1",
                                      "ratingCount": "24 ratings",
                                      "ratingCountV2": "24"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "69492347",
                                  "name": "Chicken Hakka Noodles Bowl",
                                  "category": "Chinese Bowls",
                                  "description": "Serves 1 | Noodles tossed with capsicum, onion, carrot, with a touch of dark soya & garnished with spring onion.",
                                  "imageId": "itz8nbfcsq9jwidl7z58",
                                  "inStock": 1,
                                  "price": 22900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177189",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177190",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177191",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177192",
                                      "groupName": "Add Non Veg Starters",
                                      "choices": [
                                        {
                                          "id": "113732094",
                                          "name": "Chicken Spring Roll (4pcs)",
                                          "price": 20900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732097",
                                          "name": "Chilli Chicken",
                                          "price": 33900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732108",
                                          "name": "Chicken Manchurian",
                                          "price": 33900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "75 ratings",
                                      "ratingCountV2": "75"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "69492351",
                                  "name": "Chicken Burnt Garlic Noodles Bowl",
                                  "category": "Chinese Bowls",
                                  "description": "Serves 1 | Noodles egg, diced chicken carrot, french beans & baby corn tossed with burnt garlic & coriander.",
                                  "imageId": "lrpthkxjbnk0outway0b",
                                  "inStock": 1,
                                  "price": 25900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177271",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177273",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177274",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177275",
                                      "groupName": "Add Non Veg Starters",
                                      "choices": [
                                        {
                                          "id": "113732094",
                                          "name": "Chicken Spring Roll (4pcs)",
                                          "price": 20900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732097",
                                          "name": "Chilli Chicken",
                                          "price": 33900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732108",
                                          "name": "Chicken Manchurian",
                                          "price": 33900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "69492353",
                                  "name": "Chicken Chilli Garlic Noodles Bowl",
                                  "category": "Chinese Bowls",
                                  "description": "Serves 1 | Noodles tossed with carrot, cabbage, onion, egg and chicken flavoured with chilli flakes,garlic and soy garnished with spring onion.",
                                  "imageId": "vadj2jznbtsy1sfe9kne",
                                  "inStock": 1,
                                  "price": 25900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177289",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177292",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177295",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177297",
                                      "groupName": "Add Non Veg Starters",
                                      "choices": [
                                        {
                                          "id": "113732094",
                                          "name": "Chicken Spring Roll (4pcs)",
                                          "price": 20900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732097",
                                          "name": "Chilli Chicken",
                                          "price": 33900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732108",
                                          "name": "Chicken Manchurian",
                                          "price": 33900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "56 ratings",
                                      "ratingCountV2": "56"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "69492485",
                                  "name": "Chicken Schezwan Noodles Bowl",
                                  "category": "Chinese Bowls",
                                  "description": "Serves 1 | Diced chicken and mixed veggies tossed in our schezwan sauce with noodles.",
                                  "imageId": "ik3sf59deznaajxymlst",
                                  "inStock": 1,
                                  "price": 27900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177440",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177441",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177443",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177445",
                                      "groupName": "Add Non Veg Starters",
                                      "choices": [
                                        {
                                          "id": "113732094",
                                          "name": "Chicken Spring Roll (4pcs)",
                                          "price": 20900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732097",
                                          "name": "Chilli Chicken",
                                          "price": 33900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732108",
                                          "name": "Chicken Manchurian",
                                          "price": 33900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.0",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Veg Chinese Bowls",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "95693875",
                                  "name": "Black Pepper Paneer  Bowl",
                                  "category": "Chinese Bowls",
                                  "description": "Serves 1 | (Peppery & Non Spicy) Paneer, Onion, Capsicum, Tossed In Our In-House Black Pepper Sauce, Served With Choice Of Rice / Noodles.",
                                  "imageId": "a52ef11d863a4c758965cf57d48e537c",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "36034933",
                                        "name": "Rice / Noodle Options",
                                        "variations": [
                                          {
                                            "name": "Fried Rice",
                                            "price": 309,
                                            "default": 1,
                                            "id": "111878035",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Burnt Garlic Fried Rice",
                                            "price": 329,
                                            "id": "111878036",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chilli Garlic Fried Rice",
                                            "price": 329,
                                            "id": "111878037",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Schezwan Fried Rice",
                                            "price": 339,
                                            "id": "111878038",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Hakka Noodles",
                                            "price": 309,
                                            "id": "111878039",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Burnt Garlic Noodles",
                                            "price": 329,
                                            "id": "111878040",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chilli Garlic Noodles",
                                            "price": 329,
                                            "id": "111878041",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Schezwan Noodles",
                                            "price": 339,
                                            "id": "111878042",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36034933",
                                            "variationId": "111878035"
                                          }
                                        ],
                                        "price": 30900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177493",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177493",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177493",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177493",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177493",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177494",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177494",
                                            "addonId": "113732093"
                                          },
                                          {
                                            "groupId": "138177494",
                                            "addonId": "113732090"
                                          },
                                          {
                                            "groupId": "138177491",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177491",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177491",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177491",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177491",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177491",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36034933",
                                            "variationId": "111878036"
                                          }
                                        ],
                                        "price": 32900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177493",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177493",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177493",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177493",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177493",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177494",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177494",
                                            "addonId": "113732093"
                                          },
                                          {
                                            "groupId": "138177494",
                                            "addonId": "113732090"
                                          },
                                          {
                                            "groupId": "138177491",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177491",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177491",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177491",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177491",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177491",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36034933",
                                            "variationId": "111878037"
                                          }
                                        ],
                                        "price": 32900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177493",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177493",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177493",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177493",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177493",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177494",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177494",
                                            "addonId": "113732093"
                                          },
                                          {
                                            "groupId": "138177494",
                                            "addonId": "113732090"
                                          },
                                          {
                                            "groupId": "138177491",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177491",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177491",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177491",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177491",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177491",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36034933",
                                            "variationId": "111878038"
                                          }
                                        ],
                                        "price": 33900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177493",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177493",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177493",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177493",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177493",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177494",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177494",
                                            "addonId": "113732093"
                                          },
                                          {
                                            "groupId": "138177494",
                                            "addonId": "113732090"
                                          },
                                          {
                                            "groupId": "138177491",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177491",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177491",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177491",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177491",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177491",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36034933",
                                            "variationId": "111878039"
                                          }
                                        ],
                                        "price": 30900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177493",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177493",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177493",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177493",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177493",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177494",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177494",
                                            "addonId": "113732093"
                                          },
                                          {
                                            "groupId": "138177494",
                                            "addonId": "113732090"
                                          },
                                          {
                                            "groupId": "138177491",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177491",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177491",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177491",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177491",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177491",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36034933",
                                            "variationId": "111878040"
                                          }
                                        ],
                                        "price": 32900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177493",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177493",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177493",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177493",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177493",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177494",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177494",
                                            "addonId": "113732093"
                                          },
                                          {
                                            "groupId": "138177494",
                                            "addonId": "113732090"
                                          },
                                          {
                                            "groupId": "138177491",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177491",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177491",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177491",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177491",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177491",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36034933",
                                            "variationId": "111878041"
                                          }
                                        ],
                                        "price": 32900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177493",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177493",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177493",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177493",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177493",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177494",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177494",
                                            "addonId": "113732093"
                                          },
                                          {
                                            "groupId": "138177494",
                                            "addonId": "113732090"
                                          },
                                          {
                                            "groupId": "138177491",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177491",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177491",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177491",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177491",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177491",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36034933",
                                            "variationId": "111878042"
                                          }
                                        ],
                                        "price": 33900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177493",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177493",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177493",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177493",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177493",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177494",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177494",
                                            "addonId": "113732093"
                                          },
                                          {
                                            "groupId": "138177494",
                                            "addonId": "113732090"
                                          },
                                          {
                                            "groupId": "138177491",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177491",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177491",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177491",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177491",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177491",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177492",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177491",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177492",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177493",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177494",
                                      "groupName": "Add Veg Starters",
                                      "choices": [
                                        {
                                          "id": "113732090",
                                          "name": "Chilli Paneer",
                                          "price": 30900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732113",
                                          "name": "Veg Spring Rolls (4 pcs)",
                                          "price": 16900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732093",
                                          "name": "Veg Manchurian Dry",
                                          "price": 26900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 30900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "69492358",
                                  "name": "Schezwan Paneer Bowl",
                                  "category": "Chinese Bowls",
                                  "description": "Serves 1 | (Spicy) Paneer & veggies tossed in schezwan sauce, served with choice of Rice / Noodles.",
                                  "imageId": "gour4gfnz1oh2tdk6usl",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "33801685",
                                        "name": "Rice / Noodle Options",
                                        "variations": [
                                          {
                                            "name": "Fried Rice",
                                            "price": 299,
                                            "default": 1,
                                            "id": "104518018",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Burnt Garlic Fried Rice",
                                            "price": 319,
                                            "id": "104518019",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chilli Garlic Fried Rice",
                                            "price": 319,
                                            "id": "104518020",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Schezwan Fried Rice",
                                            "price": 329,
                                            "id": "104518021",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Hakka Noodles",
                                            "price": 299,
                                            "id": "104518022",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Burnt Garlic Noodles",
                                            "price": 319,
                                            "id": "104518023",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chilli Garlic Noodles",
                                            "price": 319,
                                            "id": "104518024",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Schezwan Noodles",
                                            "price": 329,
                                            "id": "104518025",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801685",
                                            "variationId": "104518018"
                                          }
                                        ],
                                        "price": 29900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177333",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177333",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177333",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177333",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177333",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177334",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177334",
                                            "addonId": "113732093"
                                          },
                                          {
                                            "groupId": "138177334",
                                            "addonId": "113732090"
                                          },
                                          {
                                            "groupId": "138177329",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177329",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177329",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177329",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177329",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177329",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801685",
                                            "variationId": "104518019"
                                          }
                                        ],
                                        "price": 31900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177333",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177333",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177333",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177333",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177333",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177334",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177334",
                                            "addonId": "113732093"
                                          },
                                          {
                                            "groupId": "138177334",
                                            "addonId": "113732090"
                                          },
                                          {
                                            "groupId": "138177329",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177329",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177329",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177329",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177329",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177329",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801685",
                                            "variationId": "104518020"
                                          }
                                        ],
                                        "price": 31900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177333",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177333",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177333",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177333",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177333",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177334",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177334",
                                            "addonId": "113732093"
                                          },
                                          {
                                            "groupId": "138177334",
                                            "addonId": "113732090"
                                          },
                                          {
                                            "groupId": "138177329",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177329",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177329",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177329",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177329",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177329",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801685",
                                            "variationId": "104518021"
                                          }
                                        ],
                                        "price": 32900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177333",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177333",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177333",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177333",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177333",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177334",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177334",
                                            "addonId": "113732093"
                                          },
                                          {
                                            "groupId": "138177334",
                                            "addonId": "113732090"
                                          },
                                          {
                                            "groupId": "138177329",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177329",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177329",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177329",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177329",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177329",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801685",
                                            "variationId": "104518022"
                                          }
                                        ],
                                        "price": 29900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177333",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177333",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177333",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177333",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177333",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177334",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177334",
                                            "addonId": "113732093"
                                          },
                                          {
                                            "groupId": "138177334",
                                            "addonId": "113732090"
                                          },
                                          {
                                            "groupId": "138177329",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177329",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177329",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177329",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177329",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177329",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801685",
                                            "variationId": "104518023"
                                          }
                                        ],
                                        "price": 31900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177333",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177333",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177333",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177333",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177333",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177334",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177334",
                                            "addonId": "113732093"
                                          },
                                          {
                                            "groupId": "138177334",
                                            "addonId": "113732090"
                                          },
                                          {
                                            "groupId": "138177329",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177329",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177329",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177329",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177329",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177329",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801685",
                                            "variationId": "104518024"
                                          }
                                        ],
                                        "price": 31900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177333",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177333",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177333",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177333",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177333",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177334",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177334",
                                            "addonId": "113732093"
                                          },
                                          {
                                            "groupId": "138177334",
                                            "addonId": "113732090"
                                          },
                                          {
                                            "groupId": "138177329",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177329",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177329",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177329",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177329",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177329",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801685",
                                            "variationId": "104518025"
                                          }
                                        ],
                                        "price": 32900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177333",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177333",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177333",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177333",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177333",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177334",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177334",
                                            "addonId": "113732093"
                                          },
                                          {
                                            "groupId": "138177334",
                                            "addonId": "113732090"
                                          },
                                          {
                                            "groupId": "138177329",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177329",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177329",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177329",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177329",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177329",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177331",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177329",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177331",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177333",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177334",
                                      "groupName": "Add Veg Starters",
                                      "choices": [
                                        {
                                          "id": "113732090",
                                          "name": "Chilli Paneer",
                                          "price": 30900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732113",
                                          "name": "Veg Spring Rolls (4 pcs)",
                                          "price": 16900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732093",
                                          "name": "Veg Manchurian Dry",
                                          "price": 26900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 29900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.8",
                                      "ratingCount": "48 ratings",
                                      "ratingCountV2": "48"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "69492367",
                                  "name": "Chilli Paneer Bowl",
                                  "category": "Chinese Bowls",
                                  "description": "Serves 1 | (Spicy) Paneer, onion and capsicum tossed in our signature desi chilli sauce, served with choice of rice.",
                                  "imageId": "gour4gfnz1oh2tdk6usl",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "33801686",
                                        "name": "Rice / Noodle Options",
                                        "variations": [
                                          {
                                            "name": "Fried Rice",
                                            "price": 299,
                                            "default": 1,
                                            "id": "104518026",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Burnt Garlic Fried Rice",
                                            "price": 319,
                                            "id": "104518028",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chilli Garlic Fried Rice",
                                            "price": 319,
                                            "id": "104518030",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Schezwan Fried Rice",
                                            "price": 329,
                                            "id": "104518032",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Hakka Noodles",
                                            "price": 299,
                                            "id": "104518033",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Burnt Garlic Noodles",
                                            "price": 319,
                                            "id": "104518034",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chilli Garlic Noodles",
                                            "price": 319,
                                            "id": "104518035",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Schezwan Noodles",
                                            "price": 329,
                                            "id": "104518036",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801686",
                                            "variationId": "104518026"
                                          }
                                        ],
                                        "price": 29900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177584",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177584",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177584",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177584",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177584",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177585",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177585",
                                            "addonId": "113732093"
                                          },
                                          {
                                            "groupId": "138177585",
                                            "addonId": "113732090"
                                          },
                                          {
                                            "groupId": "138177582",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177582",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177582",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177582",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177582",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177582",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801686",
                                            "variationId": "104518028"
                                          }
                                        ],
                                        "price": 31900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177584",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177584",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177584",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177584",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177584",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177585",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177585",
                                            "addonId": "113732093"
                                          },
                                          {
                                            "groupId": "138177585",
                                            "addonId": "113732090"
                                          },
                                          {
                                            "groupId": "138177582",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177582",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177582",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177582",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177582",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177582",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801686",
                                            "variationId": "104518030"
                                          }
                                        ],
                                        "price": 31900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177584",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177584",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177584",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177584",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177584",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177585",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177585",
                                            "addonId": "113732093"
                                          },
                                          {
                                            "groupId": "138177585",
                                            "addonId": "113732090"
                                          },
                                          {
                                            "groupId": "138177582",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177582",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177582",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177582",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177582",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177582",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801686",
                                            "variationId": "104518032"
                                          }
                                        ],
                                        "price": 32900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177584",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177584",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177584",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177584",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177584",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177585",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177585",
                                            "addonId": "113732093"
                                          },
                                          {
                                            "groupId": "138177585",
                                            "addonId": "113732090"
                                          },
                                          {
                                            "groupId": "138177582",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177582",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177582",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177582",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177582",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177582",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801686",
                                            "variationId": "104518033"
                                          }
                                        ],
                                        "price": 29900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177584",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177584",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177584",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177584",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177584",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177585",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177585",
                                            "addonId": "113732093"
                                          },
                                          {
                                            "groupId": "138177585",
                                            "addonId": "113732090"
                                          },
                                          {
                                            "groupId": "138177582",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177582",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177582",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177582",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177582",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177582",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801686",
                                            "variationId": "104518034"
                                          }
                                        ],
                                        "price": 31900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177584",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177584",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177584",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177584",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177584",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177585",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177585",
                                            "addonId": "113732093"
                                          },
                                          {
                                            "groupId": "138177585",
                                            "addonId": "113732090"
                                          },
                                          {
                                            "groupId": "138177582",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177582",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177582",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177582",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177582",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177582",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801686",
                                            "variationId": "104518035"
                                          }
                                        ],
                                        "price": 31900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177584",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177584",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177584",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177584",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177584",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177585",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177585",
                                            "addonId": "113732093"
                                          },
                                          {
                                            "groupId": "138177585",
                                            "addonId": "113732090"
                                          },
                                          {
                                            "groupId": "138177582",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177582",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177582",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177582",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177582",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177582",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801686",
                                            "variationId": "104518036"
                                          }
                                        ],
                                        "price": 32900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177584",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177584",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177584",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177584",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177584",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177585",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177585",
                                            "addonId": "113732093"
                                          },
                                          {
                                            "groupId": "138177585",
                                            "addonId": "113732090"
                                          },
                                          {
                                            "groupId": "138177582",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177582",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177582",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177582",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177582",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177582",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177583",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177582",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177583",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177584",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177585",
                                      "groupName": "Add Veg Starters",
                                      "choices": [
                                        {
                                          "id": "113732090",
                                          "name": "Chilli Paneer",
                                          "price": 30900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732113",
                                          "name": "Veg Spring Rolls (4 pcs)",
                                          "price": 16900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732093",
                                          "name": "Veg Manchurian Dry",
                                          "price": 26900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 29900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.5",
                                      "ratingCount": "12 ratings",
                                      "ratingCountV2": "12"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "69492369",
                                  "name": "Veg Manchurian Bowl",
                                  "category": "Chinese Bowls",
                                  "description": "Serves 1 | (Peppery & Non Spicy) Mix veg fried fritters, onion and capsicum tossed in classic manchurian sauce, served with choice of Rice / Noodles.",
                                  "imageId": "giazrujwhwoiz3xjsayi",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "33801707",
                                        "name": "Rice / Noodle Options",
                                        "variations": [
                                          {
                                            "name": "Fried Rice",
                                            "price": 259,
                                            "default": 1,
                                            "id": "104518129",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Burnt Garlic Fried Rice",
                                            "price": 279,
                                            "id": "104518130",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chilli Garlic Fried Rice",
                                            "price": 279,
                                            "id": "104518131",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Schezwan Fried Rice",
                                            "price": 289,
                                            "id": "104518132",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Hakka Noodles",
                                            "price": 259,
                                            "id": "104518133",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Burnt Garlic Noodles",
                                            "price": 279,
                                            "id": "104518134",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chilli Garlic Noodles",
                                            "price": 279,
                                            "id": "104518135",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Schezwan Noodles",
                                            "price": 289,
                                            "id": "104518136",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801707",
                                            "variationId": "104518129"
                                          }
                                        ],
                                        "price": 25900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177184",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177184",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177184",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177184",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177184",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177186",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177186",
                                            "addonId": "113732093"
                                          },
                                          {
                                            "groupId": "138177186",
                                            "addonId": "113732090"
                                          },
                                          {
                                            "groupId": "138177181",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177181",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177181",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177181",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177181",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177181",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801707",
                                            "variationId": "104518130"
                                          }
                                        ],
                                        "price": 27900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177184",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177184",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177184",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177184",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177184",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177186",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177186",
                                            "addonId": "113732093"
                                          },
                                          {
                                            "groupId": "138177186",
                                            "addonId": "113732090"
                                          },
                                          {
                                            "groupId": "138177181",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177181",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177181",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177181",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177181",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177181",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801707",
                                            "variationId": "104518131"
                                          }
                                        ],
                                        "price": 27900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177184",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177184",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177184",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177184",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177184",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177186",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177186",
                                            "addonId": "113732093"
                                          },
                                          {
                                            "groupId": "138177186",
                                            "addonId": "113732090"
                                          },
                                          {
                                            "groupId": "138177181",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177181",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177181",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177181",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177181",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177181",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801707",
                                            "variationId": "104518132"
                                          }
                                        ],
                                        "price": 28900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177184",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177184",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177184",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177184",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177184",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177186",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177186",
                                            "addonId": "113732093"
                                          },
                                          {
                                            "groupId": "138177186",
                                            "addonId": "113732090"
                                          },
                                          {
                                            "groupId": "138177181",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177181",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177181",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177181",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177181",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177181",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801707",
                                            "variationId": "104518133"
                                          }
                                        ],
                                        "price": 25900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177184",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177184",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177184",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177184",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177184",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177186",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177186",
                                            "addonId": "113732093"
                                          },
                                          {
                                            "groupId": "138177186",
                                            "addonId": "113732090"
                                          },
                                          {
                                            "groupId": "138177181",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177181",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177181",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177181",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177181",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177181",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801707",
                                            "variationId": "104518134"
                                          }
                                        ],
                                        "price": 27900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177184",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177184",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177184",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177184",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177184",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177186",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177186",
                                            "addonId": "113732093"
                                          },
                                          {
                                            "groupId": "138177186",
                                            "addonId": "113732090"
                                          },
                                          {
                                            "groupId": "138177181",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177181",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177181",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177181",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177181",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177181",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801707",
                                            "variationId": "104518135"
                                          }
                                        ],
                                        "price": 27900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177184",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177184",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177184",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177184",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177184",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177186",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177186",
                                            "addonId": "113732093"
                                          },
                                          {
                                            "groupId": "138177186",
                                            "addonId": "113732090"
                                          },
                                          {
                                            "groupId": "138177181",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177181",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177181",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177181",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177181",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177181",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801707",
                                            "variationId": "104518136"
                                          }
                                        ],
                                        "price": 28900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177184",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177184",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177184",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177184",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177184",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177186",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177186",
                                            "addonId": "113732093"
                                          },
                                          {
                                            "groupId": "138177186",
                                            "addonId": "113732090"
                                          },
                                          {
                                            "groupId": "138177181",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177181",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177181",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177181",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177181",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177181",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177182",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177181",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177182",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177184",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177186",
                                      "groupName": "Add Veg Starters",
                                      "choices": [
                                        {
                                          "id": "113732090",
                                          "name": "Chilli Paneer",
                                          "price": 30900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732113",
                                          "name": "Veg Spring Rolls (4 pcs)",
                                          "price": 16900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732093",
                                          "name": "Veg Manchurian Dry",
                                          "price": 26900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 25900,
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "83 ratings",
                                      "ratingCountV2": "83"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "69492364",
                                  "name": "Kung Pao Paneer Bowl",
                                  "category": "Chinese Bowls",
                                  "description": "Serves 1 | (Medium Spicy) Paneer & veggies tossed in kung pao sauce, served with choice of Rice / Noodles.",
                                  "imageId": "gour4gfnz1oh2tdk6usl",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "33801679",
                                        "name": "Rice / Noodle Options",
                                        "variations": [
                                          {
                                            "name": "Fried Rice",
                                            "price": 299,
                                            "default": 1,
                                            "id": "104518004",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Burnt Garlic Fried Rice",
                                            "price": 319,
                                            "id": "104518005",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chilli Garlic Fried Rice",
                                            "price": 319,
                                            "id": "104518006",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Schezwan Fried Rice",
                                            "price": 329,
                                            "id": "104518007",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Hakka Noodles",
                                            "price": 299,
                                            "id": "104518008",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Burnt Garlic Noodles",
                                            "price": 319,
                                            "id": "104518009",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chilli Garlic Noodles",
                                            "price": 319,
                                            "id": "104518010",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Schezwan Noodles",
                                            "price": 329,
                                            "id": "104518011",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801679",
                                            "variationId": "104518004"
                                          }
                                        ],
                                        "price": 29900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177143",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177143",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177143",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177143",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177143",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177145",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177145",
                                            "addonId": "113732093"
                                          },
                                          {
                                            "groupId": "138177145",
                                            "addonId": "113732090"
                                          },
                                          {
                                            "groupId": "138177139",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177139",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177139",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177139",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177139",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177139",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801679",
                                            "variationId": "104518005"
                                          }
                                        ],
                                        "price": 31900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177143",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177143",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177143",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177143",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177143",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177145",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177145",
                                            "addonId": "113732093"
                                          },
                                          {
                                            "groupId": "138177145",
                                            "addonId": "113732090"
                                          },
                                          {
                                            "groupId": "138177139",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177139",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177139",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177139",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177139",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177139",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801679",
                                            "variationId": "104518006"
                                          }
                                        ],
                                        "price": 31900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177143",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177143",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177143",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177143",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177143",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177145",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177145",
                                            "addonId": "113732093"
                                          },
                                          {
                                            "groupId": "138177145",
                                            "addonId": "113732090"
                                          },
                                          {
                                            "groupId": "138177139",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177139",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177139",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177139",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177139",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177139",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801679",
                                            "variationId": "104518007"
                                          }
                                        ],
                                        "price": 32900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177143",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177143",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177143",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177143",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177143",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177145",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177145",
                                            "addonId": "113732093"
                                          },
                                          {
                                            "groupId": "138177145",
                                            "addonId": "113732090"
                                          },
                                          {
                                            "groupId": "138177139",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177139",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177139",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177139",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177139",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177139",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801679",
                                            "variationId": "104518008"
                                          }
                                        ],
                                        "price": 29900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177143",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177143",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177143",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177143",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177143",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177145",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177145",
                                            "addonId": "113732093"
                                          },
                                          {
                                            "groupId": "138177145",
                                            "addonId": "113732090"
                                          },
                                          {
                                            "groupId": "138177139",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177139",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177139",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177139",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177139",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177139",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801679",
                                            "variationId": "104518009"
                                          }
                                        ],
                                        "price": 31900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177143",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177143",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177143",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177143",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177143",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177145",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177145",
                                            "addonId": "113732093"
                                          },
                                          {
                                            "groupId": "138177145",
                                            "addonId": "113732090"
                                          },
                                          {
                                            "groupId": "138177139",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177139",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177139",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177139",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177139",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177139",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801679",
                                            "variationId": "104518010"
                                          }
                                        ],
                                        "price": 31900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177143",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177143",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177143",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177143",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177143",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177145",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177145",
                                            "addonId": "113732093"
                                          },
                                          {
                                            "groupId": "138177145",
                                            "addonId": "113732090"
                                          },
                                          {
                                            "groupId": "138177139",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177139",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177139",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177139",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177139",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177139",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801679",
                                            "variationId": "104518011"
                                          }
                                        ],
                                        "price": 32900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177143",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177143",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177143",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177143",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177143",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177145",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177145",
                                            "addonId": "113732093"
                                          },
                                          {
                                            "groupId": "138177145",
                                            "addonId": "113732090"
                                          },
                                          {
                                            "groupId": "138177139",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177139",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177139",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177139",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177139",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177139",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177141",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177139",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177141",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177143",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177145",
                                      "groupName": "Add Veg Starters",
                                      "choices": [
                                        {
                                          "id": "113732090",
                                          "name": "Chilli Paneer",
                                          "price": 30900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732113",
                                          "name": "Veg Spring Rolls (4 pcs)",
                                          "price": 16900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732093",
                                          "name": "Veg Manchurian Dry",
                                          "price": 26900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 29900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.7",
                                      "ratingCount": "6 ratings",
                                      "ratingCountV2": "6"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Non-Veg Chinese Bowls",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "95693884",
                                  "name": "Black Pepper Chicken Bowl",
                                  "category": "Chinese Bowls",
                                  "description": "Serves 1 | (Peppery & Non Spicy) Chicken, Onion, Capsicum, Tossed In Our In-House Black Pepper Sauce, Served With Choice Of Rice/ Noodle.",
                                  "imageId": "63215498e2e95192ee0adad8b7b3f414",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "36034934",
                                        "name": "Rice /Noodle Options",
                                        "variations": [
                                          {
                                            "name": "Fried Rice",
                                            "price": 319,
                                            "default": 1,
                                            "id": "111878043",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Burnt Garlic Fried Rice",
                                            "price": 339,
                                            "id": "111878044",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chilli Garlic Fried Rice",
                                            "price": 339,
                                            "id": "111878045",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Schezwan Fried Rice",
                                            "price": 349,
                                            "id": "111878046",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Hakka Noodles",
                                            "price": 319,
                                            "id": "111878047",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Burnt Garlic Noodles",
                                            "price": 339,
                                            "id": "111878048",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chilli Garlic Noodles",
                                            "price": 339,
                                            "id": "111878049",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Schezwan Noodles",
                                            "price": 349,
                                            "id": "111878050",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken Fried Rice",
                                            "price": 369,
                                            "id": "121812474",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken Burnt Garlic Rice",
                                            "price": 369,
                                            "id": "121812475",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken Chilli Garlic Rice",
                                            "price": 369,
                                            "id": "121812476",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken Schezwan Fried Rice",
                                            "price": 369,
                                            "id": "121812477",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Egg Hakka Noodles",
                                            "price": 344,
                                            "id": "121812478",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken Hakka Noodles",
                                            "price": 369,
                                            "id": "121812479",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken Burnt Garlic Noodles",
                                            "price": 369,
                                            "id": "121812480",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken Chilli Garlic Noodles",
                                            "price": 369,
                                            "id": "121812481",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken Schezwan Noodles",
                                            "price": 369,
                                            "id": "121812482",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Egg Fried Rice",
                                            "price": 339,
                                            "id": "111878051",
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36034934",
                                            "variationId": "111878043"
                                          }
                                        ],
                                        "price": 31900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36034934",
                                            "variationId": "111878044"
                                          }
                                        ],
                                        "price": 33900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36034934",
                                            "variationId": "111878045"
                                          }
                                        ],
                                        "price": 33900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36034934",
                                            "variationId": "111878046"
                                          }
                                        ],
                                        "price": 34900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36034934",
                                            "variationId": "111878047"
                                          }
                                        ],
                                        "price": 31900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36034934",
                                            "variationId": "111878048"
                                          }
                                        ],
                                        "price": 33900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36034934",
                                            "variationId": "111878049"
                                          }
                                        ],
                                        "price": 33900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36034934",
                                            "variationId": "111878050"
                                          }
                                        ],
                                        "price": 34900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36034934",
                                            "variationId": "111878051"
                                          }
                                        ],
                                        "price": 33900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36034934",
                                            "variationId": "121812474"
                                          }
                                        ],
                                        "price": 36900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36034934",
                                            "variationId": "121812475"
                                          }
                                        ],
                                        "price": 36900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36034934",
                                            "variationId": "121812476"
                                          }
                                        ],
                                        "price": 36900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36034934",
                                            "variationId": "121812477"
                                          }
                                        ],
                                        "price": 36900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36034934",
                                            "variationId": "121812478"
                                          }
                                        ],
                                        "price": 34400,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36034934",
                                            "variationId": "121812479"
                                          }
                                        ],
                                        "price": 36900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36034934",
                                            "variationId": "121812480"
                                          }
                                        ],
                                        "price": 36900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36034934",
                                            "variationId": "121812481"
                                          }
                                        ],
                                        "price": 36900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36034934",
                                            "variationId": "121812482"
                                          }
                                        ],
                                        "price": 36900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177319",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177317",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177315",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177316",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177315",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177316",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177317",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177319",
                                      "groupName": "Add Non Veg Starters",
                                      "choices": [
                                        {
                                          "id": "113732094",
                                          "name": "Chicken Spring Roll (4pcs)",
                                          "price": 20900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732097",
                                          "name": "Chilli Chicken",
                                          "price": 33900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732108",
                                          "name": "Chicken Manchurian",
                                          "price": 33900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 31900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "69492375",
                                  "name": "Schezwan Chicken Bowl",
                                  "category": "Chinese Bowls",
                                  "description": "Serves 1 | (Spicy) Diced chicken & veggies tossed in schezwan sauce, served with choice of Rice/ Noodle.",
                                  "imageId": "p5ufriiadgziqmfvited",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "33801708",
                                        "name": "Rice /Noodle Options",
                                        "variations": [
                                          {
                                            "name": "Fried Rice",
                                            "price": 309,
                                            "default": 1,
                                            "id": "104518137",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Burnt Garlic Fried Rice",
                                            "price": 329,
                                            "id": "104518138",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chilli Garlic Fried Rice",
                                            "price": 329,
                                            "id": "104518139",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Schezwan Fried Rice",
                                            "price": 339,
                                            "id": "104518140",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Hakka Noodles",
                                            "price": 309,
                                            "id": "104518141",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Burnt Garlic Noodles",
                                            "price": 329,
                                            "id": "104518142",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chilli Garlic Noodles",
                                            "price": 329,
                                            "id": "104518143",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Schezwan Noodles",
                                            "price": 339,
                                            "id": "104518144",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken Fried Rice",
                                            "price": 359,
                                            "id": "121812484",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken Burnt Garlic Rice",
                                            "price": 359,
                                            "id": "121812485",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken Chilli Garlic Rice",
                                            "price": 359,
                                            "id": "121812486",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken Schezwan Fried Rice",
                                            "price": 359,
                                            "id": "121812487",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Egg Hakka Noodles",
                                            "price": 334,
                                            "id": "121812488",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken Hakka Noodles",
                                            "price": 359,
                                            "id": "121812489",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken Burnt Garlic Noodles",
                                            "price": 359,
                                            "id": "121812490",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken Chilli Garlic Noodles",
                                            "price": 359,
                                            "id": "121812491",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken Schezwan Noodles",
                                            "price": 359,
                                            "id": "121812492",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Egg Fried Rice",
                                            "price": 329,
                                            "id": "104518145",
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801708",
                                            "variationId": "104518137"
                                          }
                                        ],
                                        "price": 30900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801708",
                                            "variationId": "104518138"
                                          }
                                        ],
                                        "price": 32900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801708",
                                            "variationId": "104518139"
                                          }
                                        ],
                                        "price": 32900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801708",
                                            "variationId": "104518140"
                                          }
                                        ],
                                        "price": 33900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801708",
                                            "variationId": "104518141"
                                          }
                                        ],
                                        "price": 30900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801708",
                                            "variationId": "104518142"
                                          }
                                        ],
                                        "price": 32900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801708",
                                            "variationId": "104518143"
                                          }
                                        ],
                                        "price": 32900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801708",
                                            "variationId": "104518144"
                                          }
                                        ],
                                        "price": 33900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801708",
                                            "variationId": "104518145"
                                          }
                                        ],
                                        "price": 32900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801708",
                                            "variationId": "121812484"
                                          }
                                        ],
                                        "price": 35900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801708",
                                            "variationId": "121812485"
                                          }
                                        ],
                                        "price": 35900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801708",
                                            "variationId": "121812486"
                                          }
                                        ],
                                        "price": 35900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801708",
                                            "variationId": "121812487"
                                          }
                                        ],
                                        "price": 35900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801708",
                                            "variationId": "121812488"
                                          }
                                        ],
                                        "price": 33400,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801708",
                                            "variationId": "121812489"
                                          }
                                        ],
                                        "price": 35900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801708",
                                            "variationId": "121812490"
                                          }
                                        ],
                                        "price": 35900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801708",
                                            "variationId": "121812491"
                                          }
                                        ],
                                        "price": 35900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801708",
                                            "variationId": "121812492"
                                          }
                                        ],
                                        "price": 35900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177347",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177346",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177343",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177344",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177343",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177344",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177346",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177347",
                                      "groupName": "Add Non Veg Starters",
                                      "choices": [
                                        {
                                          "id": "113732094",
                                          "name": "Chicken Spring Roll (4pcs)",
                                          "price": 20900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732097",
                                          "name": "Chilli Chicken",
                                          "price": 33900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732108",
                                          "name": "Chicken Manchurian",
                                          "price": 33900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 30900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.1",
                                      "ratingCount": "19 ratings",
                                      "ratingCountV2": "19"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "69492381",
                                  "name": "Chilli Chicken Bowl",
                                  "category": "Chinese Bowls",
                                  "description": "Serves 1 | (Spicy) Diced chicken, onion and capsicum tossed in our signature desi chilli sauce, served with choice of Rice/ Noodle.",
                                  "imageId": "s8zzafralzp3620swozf",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "33801704",
                                        "name": "Rice /Noodle Options",
                                        "variations": [
                                          {
                                            "name": "Fried Rice",
                                            "price": 299,
                                            "default": 1,
                                            "id": "104518078",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Burnt Garlic Fried Rice",
                                            "price": 319,
                                            "id": "104518079",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chilli Garlic Fried Rice",
                                            "price": 319,
                                            "id": "104518080",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Schezwan Fried Rice",
                                            "price": 329,
                                            "id": "104518081",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Hakka Noodles",
                                            "price": 299,
                                            "id": "104518082",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Burnt Garlic Noodles",
                                            "price": 319,
                                            "id": "104518083",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chilli Garlic Noodles",
                                            "price": 319,
                                            "id": "104518084",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Schezwan Noodles",
                                            "price": 329,
                                            "id": "104518085",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken Fried Rice",
                                            "price": 349,
                                            "id": "121812593",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken Burnt Garlic Rice",
                                            "price": 349,
                                            "id": "121812594",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken Chilli Garlic Rice",
                                            "price": 349,
                                            "id": "121812595",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken Schezwan Fried Rice",
                                            "price": 349,
                                            "id": "121812596",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Egg Hakka Noodles",
                                            "price": 324,
                                            "id": "121812597",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken Hakka Noodles",
                                            "price": 349,
                                            "id": "121812598",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken Burnt Garlic Noodles",
                                            "price": 349,
                                            "id": "121812599",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken Chilli Garlic Noodles",
                                            "price": 349,
                                            "id": "121812600",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken Schezwan Noodles",
                                            "price": 349,
                                            "id": "121812601",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Egg Fried Rice",
                                            "price": 319,
                                            "id": "104518086",
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801704",
                                            "variationId": "104518078"
                                          }
                                        ],
                                        "price": 29900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801704",
                                            "variationId": "104518079"
                                          }
                                        ],
                                        "price": 31900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801704",
                                            "variationId": "104518080"
                                          }
                                        ],
                                        "price": 31900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801704",
                                            "variationId": "104518081"
                                          }
                                        ],
                                        "price": 32900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801704",
                                            "variationId": "104518082"
                                          }
                                        ],
                                        "price": 29900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801704",
                                            "variationId": "104518083"
                                          }
                                        ],
                                        "price": 31900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801704",
                                            "variationId": "104518084"
                                          }
                                        ],
                                        "price": 31900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801704",
                                            "variationId": "104518085"
                                          }
                                        ],
                                        "price": 32900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801704",
                                            "variationId": "104518086"
                                          }
                                        ],
                                        "price": 31900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801704",
                                            "variationId": "121812593"
                                          }
                                        ],
                                        "price": 34900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801704",
                                            "variationId": "121812594"
                                          }
                                        ],
                                        "price": 34900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801704",
                                            "variationId": "121812595"
                                          }
                                        ],
                                        "price": 34900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801704",
                                            "variationId": "121812596"
                                          }
                                        ],
                                        "price": 34900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801704",
                                            "variationId": "121812597"
                                          }
                                        ],
                                        "price": 32400,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801704",
                                            "variationId": "121812598"
                                          }
                                        ],
                                        "price": 34900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801704",
                                            "variationId": "121812599"
                                          }
                                        ],
                                        "price": 34900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801704",
                                            "variationId": "121812600"
                                          }
                                        ],
                                        "price": 34900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801704",
                                            "variationId": "121812601"
                                          }
                                        ],
                                        "price": 34900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177575",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177574",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177572",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177573",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177572",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177573",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177574",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177575",
                                      "groupName": "Add Non Veg Starters",
                                      "choices": [
                                        {
                                          "id": "113732094",
                                          "name": "Chicken Spring Roll (4pcs)",
                                          "price": 20900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732097",
                                          "name": "Chilli Chicken",
                                          "price": 33900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732108",
                                          "name": "Chicken Manchurian",
                                          "price": 33900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 29900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "68 ratings",
                                      "ratingCountV2": "68"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "69492383",
                                  "name": "Chicken Manchurian Bowl",
                                  "category": "Chinese Bowls",
                                  "description": "Serves 1 | (Peppery & Spicy) Diced chicken, onion and capsicum tossed in classic manchurian sauce, served with choice of Rice/ Noodle.",
                                  "imageId": "giazrujwhwoiz3xjsayi",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "33801705",
                                        "name": "Rice /Noodle Options",
                                        "variations": [
                                          {
                                            "name": "Fried Rice",
                                            "price": 309,
                                            "default": 1,
                                            "id": "104518095",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Burnt Garlic Fried Rice",
                                            "price": 329,
                                            "id": "104518096",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chilli Garlic Fried Rice",
                                            "price": 329,
                                            "id": "104518097",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Schezwan Fried Rice",
                                            "price": 339,
                                            "id": "104518098",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Hakka Noodles",
                                            "price": 309,
                                            "id": "104518099",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Burnt Garlic Noodles",
                                            "price": 329,
                                            "id": "104518100",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chilli Garlic Noodles",
                                            "price": 329,
                                            "id": "104518101",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Schezwan Noodles",
                                            "price": 339,
                                            "id": "104518102",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken Fried Rice",
                                            "price": 359,
                                            "id": "121812430",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken Burnt Garlic Rice",
                                            "price": 359,
                                            "id": "121812432",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken Chilli Garlic Rice",
                                            "price": 359,
                                            "id": "121812433",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken Schezwan Fried Rice",
                                            "price": 359,
                                            "id": "121812434",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Egg Hakka Noodles",
                                            "price": 334,
                                            "id": "121812435",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken Hakka Noodles",
                                            "price": 359,
                                            "id": "121812436",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken Burnt Garlic Noodles",
                                            "price": 359,
                                            "id": "121812437",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken Chilli Garlic Noodles",
                                            "price": 359,
                                            "id": "121812438",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken Schezwan Noodles",
                                            "price": 359,
                                            "id": "121812439",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Egg Fried Rice",
                                            "price": 329,
                                            "id": "104518103",
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801705",
                                            "variationId": "104518095"
                                          }
                                        ],
                                        "price": 30900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801705",
                                            "variationId": "104518096"
                                          }
                                        ],
                                        "price": 32900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801705",
                                            "variationId": "104518097"
                                          }
                                        ],
                                        "price": 32900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801705",
                                            "variationId": "104518098"
                                          }
                                        ],
                                        "price": 33900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801705",
                                            "variationId": "104518099"
                                          }
                                        ],
                                        "price": 30900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801705",
                                            "variationId": "104518100"
                                          }
                                        ],
                                        "price": 32900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801705",
                                            "variationId": "104518101"
                                          }
                                        ],
                                        "price": 32900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801705",
                                            "variationId": "104518102"
                                          }
                                        ],
                                        "price": 33900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801705",
                                            "variationId": "104518103"
                                          }
                                        ],
                                        "price": 32900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801705",
                                            "variationId": "121812430"
                                          }
                                        ],
                                        "price": 35900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801705",
                                            "variationId": "121812432"
                                          }
                                        ],
                                        "price": 35900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801705",
                                            "variationId": "121812433"
                                          }
                                        ],
                                        "price": 35900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801705",
                                            "variationId": "121812434"
                                          }
                                        ],
                                        "price": 35900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801705",
                                            "variationId": "121812435"
                                          }
                                        ],
                                        "price": 33400,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801705",
                                            "variationId": "121812436"
                                          }
                                        ],
                                        "price": 35900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801705",
                                            "variationId": "121812437"
                                          }
                                        ],
                                        "price": 35900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801705",
                                            "variationId": "121812438"
                                          }
                                        ],
                                        "price": 35900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801705",
                                            "variationId": "121812439"
                                          }
                                        ],
                                        "price": 35900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177132",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177131",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177127",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177129",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177127",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177129",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177131",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177132",
                                      "groupName": "Add Non Veg Starters",
                                      "choices": [
                                        {
                                          "id": "113732094",
                                          "name": "Chicken Spring Roll (4pcs)",
                                          "price": 20900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732097",
                                          "name": "Chilli Chicken",
                                          "price": 33900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732108",
                                          "name": "Chicken Manchurian",
                                          "price": 33900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 30900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.2",
                                      "ratingCount": "24 ratings",
                                      "ratingCountV2": "24"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "69492378",
                                  "name": "Kung Pao Chicken Bowl",
                                  "category": "Chinese Bowls",
                                  "description": "Serves 1 | (Medium Spicy) Diced chicken & veggies tossed in kung pao sauce, served with choice of Rice/ Noodle.",
                                  "imageId": "k2eufgoa7wn2xovopidp",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "33801706",
                                        "name": "Rice /Noodle Options",
                                        "variations": [
                                          {
                                            "name": "Fried Rice",
                                            "price": 309,
                                            "default": 1,
                                            "id": "104518112",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Burnt Garlic Fried Rice",
                                            "price": 329,
                                            "id": "104518113",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chilli Garlic Fried Rice",
                                            "price": 329,
                                            "id": "104518114",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Schezwan Fried Rice",
                                            "price": 339,
                                            "id": "104518115",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Hakka Noodles",
                                            "price": 309,
                                            "id": "104518116",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Burnt Garlic Noodles",
                                            "price": 329,
                                            "id": "104518117",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chilli Garlic Noodles",
                                            "price": 329,
                                            "id": "104518118",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Schezwan Noodles",
                                            "price": 339,
                                            "id": "104518119",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken Fried Rice",
                                            "price": 359,
                                            "id": "121812505",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken Burnt Garlic Rice",
                                            "price": 359,
                                            "id": "121812506",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken Chilli Garlic Rice",
                                            "price": 359,
                                            "id": "121812507",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken Schezwan Fried Rice",
                                            "price": 359,
                                            "id": "121812508",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Egg Hakka Noodles",
                                            "price": 334,
                                            "id": "121812509",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken Hakka Noodles",
                                            "price": 359,
                                            "id": "121812510",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken Burnt Garlic Noodles",
                                            "price": 359,
                                            "id": "121812511",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken Chilli Garlic Noodles",
                                            "price": 359,
                                            "id": "121812512",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken Schezwan Noodles",
                                            "price": 359,
                                            "id": "121812513",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Egg Fried Rice",
                                            "price": 329,
                                            "id": "104518120",
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801706",
                                            "variationId": "104518112"
                                          }
                                        ],
                                        "price": 30900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801706",
                                            "variationId": "104518113"
                                          }
                                        ],
                                        "price": 32900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801706",
                                            "variationId": "104518114"
                                          }
                                        ],
                                        "price": 32900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801706",
                                            "variationId": "104518115"
                                          }
                                        ],
                                        "price": 33900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801706",
                                            "variationId": "104518116"
                                          }
                                        ],
                                        "price": 30900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801706",
                                            "variationId": "104518117"
                                          }
                                        ],
                                        "price": 32900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801706",
                                            "variationId": "104518118"
                                          }
                                        ],
                                        "price": 32900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801706",
                                            "variationId": "104518119"
                                          }
                                        ],
                                        "price": 33900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801706",
                                            "variationId": "104518120"
                                          }
                                        ],
                                        "price": 32900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801706",
                                            "variationId": "121812505"
                                          }
                                        ],
                                        "price": 35900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801706",
                                            "variationId": "121812506"
                                          }
                                        ],
                                        "price": 35900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801706",
                                            "variationId": "121812507"
                                          }
                                        ],
                                        "price": 35900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801706",
                                            "variationId": "121812508"
                                          }
                                        ],
                                        "price": 35900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801706",
                                            "variationId": "121812509"
                                          }
                                        ],
                                        "price": 33400,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801706",
                                            "variationId": "121812510"
                                          }
                                        ],
                                        "price": 35900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801706",
                                            "variationId": "121812511"
                                          }
                                        ],
                                        "price": 35900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801706",
                                            "variationId": "121812512"
                                          }
                                        ],
                                        "price": 35900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801706",
                                            "variationId": "121812513"
                                          }
                                        ],
                                        "price": 35900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732097"
                                          },
                                          {
                                            "groupId": "138177420",
                                            "addonId": "113732108"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177418",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177415",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177416",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177415",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177416",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177418",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177420",
                                      "groupName": "Add Non Veg Starters",
                                      "choices": [
                                        {
                                          "id": "113732094",
                                          "name": "Chicken Spring Roll (4pcs)",
                                          "price": 20900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732097",
                                          "name": "Chilli Chicken",
                                          "price": 33900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732108",
                                          "name": "Chicken Manchurian",
                                          "price": 33900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 30900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "2.0",
                                      "ratingCount": "6 ratings",
                                      "ratingCountV2": "6"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Starters & Soup",
                      "categories": [
                        {
                          "title": "Chinese Starters ",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "120785104",
                                  "name": "Veg Spring Roll",
                                  "category": "Starters & Soup",
                                  "description": "Serves 1 | Mixed vegetables & noodles encased in crispy spring roll sheet served with sweet chilli sauce.",
                                  "imageId": "62731df20b595a1dca6f4f8ed45b7123",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "33801747",
                                        "name": "Add Veg Spring Roll",
                                        "variations": [
                                          {
                                            "name": "Veg Spring Rolls (4 pcs)",
                                            "price": 169,
                                            "default": 1,
                                            "id": "104518299",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Veg Spring Rolls (6 pcs)",
                                            "price": 219,
                                            "id": "121812450",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Veg Spring Rolls (12 pcs)",
                                            "price": 359,
                                            "id": "121812451",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801747",
                                            "variationId": "104518299"
                                          }
                                        ],
                                        "price": 16900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177204",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177204",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177202",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177202",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177202",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177202",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177202",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177203",
                                            "addonId": "113732102"
                                          },
                                          {
                                            "groupId": "138177203",
                                            "addonId": "113732123"
                                          },
                                          {
                                            "groupId": "138177203",
                                            "addonId": "113732105"
                                          },
                                          {
                                            "groupId": "138177203",
                                            "addonId": "113732116"
                                          },
                                          {
                                            "groupId": "138177203",
                                            "addonId": "113732104"
                                          },
                                          {
                                            "groupId": "138177203",
                                            "addonId": "113732107"
                                          },
                                          {
                                            "groupId": "138177203",
                                            "addonId": "113732106"
                                          },
                                          {
                                            "groupId": "138177203",
                                            "addonId": "113732118"
                                          },
                                          {
                                            "groupId": "138177200",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177200",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177200",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177200",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177200",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177200",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177201",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177201",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177201",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177201",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177201",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177201",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177201",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177201",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177201",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177201",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801747",
                                            "variationId": "121812450"
                                          }
                                        ],
                                        "price": 21900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177204",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177204",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177202",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177202",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177202",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177202",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177202",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177203",
                                            "addonId": "113732102"
                                          },
                                          {
                                            "groupId": "138177203",
                                            "addonId": "113732123"
                                          },
                                          {
                                            "groupId": "138177203",
                                            "addonId": "113732105"
                                          },
                                          {
                                            "groupId": "138177203",
                                            "addonId": "113732116"
                                          },
                                          {
                                            "groupId": "138177203",
                                            "addonId": "113732104"
                                          },
                                          {
                                            "groupId": "138177203",
                                            "addonId": "113732107"
                                          },
                                          {
                                            "groupId": "138177203",
                                            "addonId": "113732106"
                                          },
                                          {
                                            "groupId": "138177203",
                                            "addonId": "113732118"
                                          },
                                          {
                                            "groupId": "138177200",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177200",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177200",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177200",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177200",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177200",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177201",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177201",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177201",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177201",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177201",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177201",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177201",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177201",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177201",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177201",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801747",
                                            "variationId": "121812451"
                                          }
                                        ],
                                        "price": 35900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177204",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177204",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177202",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177202",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177202",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177202",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177202",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177203",
                                            "addonId": "113732102"
                                          },
                                          {
                                            "groupId": "138177203",
                                            "addonId": "113732123"
                                          },
                                          {
                                            "groupId": "138177203",
                                            "addonId": "113732105"
                                          },
                                          {
                                            "groupId": "138177203",
                                            "addonId": "113732116"
                                          },
                                          {
                                            "groupId": "138177203",
                                            "addonId": "113732104"
                                          },
                                          {
                                            "groupId": "138177203",
                                            "addonId": "113732107"
                                          },
                                          {
                                            "groupId": "138177203",
                                            "addonId": "113732106"
                                          },
                                          {
                                            "groupId": "138177203",
                                            "addonId": "113732118"
                                          },
                                          {
                                            "groupId": "138177200",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177200",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177200",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177200",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177200",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177200",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177201",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177201",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177201",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177201",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177201",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177201",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177201",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177201",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177201",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177201",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177200",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177201",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177202",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177203",
                                      "groupName": "Add Veg Rice/ Noodles",
                                      "choices": [
                                        {
                                          "id": "113732102",
                                          "name": "Veg Fried Rice Bowl",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732123",
                                          "name": "Veg Burnt Garlic Fried Rice Bowl",
                                          "price": 18900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732105",
                                          "name": "Veg Chilli Garlic Fried Rice Bowl",
                                          "price": 19900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732116",
                                          "name": "Veg Schezwan Fried Rice Bowl",
                                          "price": 23900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732104",
                                          "name": "Veg Hakka Noodles Bowl",
                                          "price": 19900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732107",
                                          "name": "Veg Burnt Garlic Noodles Bowl",
                                          "price": 21900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732106",
                                          "name": "Veg Chilli Garlic Noodles Bowl",
                                          "price": 21500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732118",
                                          "name": "Veg Schezwan Noodles Bowl",
                                          "price": 23900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177204",
                                      "groupName": "Add Soup",
                                      "choices": [
                                        {
                                          "id": "113732100",
                                          "name": "Veg Manchow Soup with Crispy Noodles",
                                          "price": 18900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732111",
                                          "name": "Chicken Manchow Soup with Crispy Noodles",
                                          "price": 19900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 16900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.1",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "102700863",
                                  "name": "Veg Manchurian Balls in Choice of Sauce",
                                  "category": "Starters & Soup",
                                  "description": "Serves 1 | Mix veg fried balls with choice of sauce tossed in onion & capsicum",
                                  "imageId": "rqppq1avq2i5cdt8pvfg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "38547703",
                                        "name": "Select Sauce",
                                        "variations": [
                                          {
                                            "name": "Schezwan Sauce",
                                            "price": 269,
                                            "default": 1,
                                            "id": "121812714",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Desi Chilli Sauce",
                                            "price": 269,
                                            "id": "121812715",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Kung Pao Sauce",
                                            "price": 269,
                                            "id": "121812716",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547703",
                                            "variationId": "121812714"
                                          }
                                        ],
                                        "price": 26900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177663",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177663",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177659",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177659",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177659",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177659",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177659",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177661",
                                            "addonId": "113732102"
                                          },
                                          {
                                            "groupId": "138177661",
                                            "addonId": "113732123"
                                          },
                                          {
                                            "groupId": "138177661",
                                            "addonId": "113732105"
                                          },
                                          {
                                            "groupId": "138177661",
                                            "addonId": "113732116"
                                          },
                                          {
                                            "groupId": "138177661",
                                            "addonId": "113732104"
                                          },
                                          {
                                            "groupId": "138177661",
                                            "addonId": "113732107"
                                          },
                                          {
                                            "groupId": "138177661",
                                            "addonId": "113732106"
                                          },
                                          {
                                            "groupId": "138177661",
                                            "addonId": "113732118"
                                          },
                                          {
                                            "groupId": "138177654",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177654",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177654",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177654",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177654",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177654",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177656",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177656",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177656",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177656",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177656",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177656",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177656",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177656",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177656",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177656",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547703",
                                            "variationId": "121812715"
                                          }
                                        ],
                                        "price": 26900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177663",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177663",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177659",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177659",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177659",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177659",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177659",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177661",
                                            "addonId": "113732102"
                                          },
                                          {
                                            "groupId": "138177661",
                                            "addonId": "113732123"
                                          },
                                          {
                                            "groupId": "138177661",
                                            "addonId": "113732105"
                                          },
                                          {
                                            "groupId": "138177661",
                                            "addonId": "113732116"
                                          },
                                          {
                                            "groupId": "138177661",
                                            "addonId": "113732104"
                                          },
                                          {
                                            "groupId": "138177661",
                                            "addonId": "113732107"
                                          },
                                          {
                                            "groupId": "138177661",
                                            "addonId": "113732106"
                                          },
                                          {
                                            "groupId": "138177661",
                                            "addonId": "113732118"
                                          },
                                          {
                                            "groupId": "138177654",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177654",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177654",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177654",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177654",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177654",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177656",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177656",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177656",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177656",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177656",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177656",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177656",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177656",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177656",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177656",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547703",
                                            "variationId": "121812716"
                                          }
                                        ],
                                        "price": 26900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177663",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177663",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177659",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177659",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177659",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177659",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177659",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177661",
                                            "addonId": "113732102"
                                          },
                                          {
                                            "groupId": "138177661",
                                            "addonId": "113732123"
                                          },
                                          {
                                            "groupId": "138177661",
                                            "addonId": "113732105"
                                          },
                                          {
                                            "groupId": "138177661",
                                            "addonId": "113732116"
                                          },
                                          {
                                            "groupId": "138177661",
                                            "addonId": "113732104"
                                          },
                                          {
                                            "groupId": "138177661",
                                            "addonId": "113732107"
                                          },
                                          {
                                            "groupId": "138177661",
                                            "addonId": "113732106"
                                          },
                                          {
                                            "groupId": "138177661",
                                            "addonId": "113732118"
                                          },
                                          {
                                            "groupId": "138177654",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177654",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177654",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177654",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177654",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177654",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177656",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177656",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177656",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177656",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177656",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177656",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177656",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177656",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177656",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177656",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177654",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177656",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177659",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177661",
                                      "groupName": "Add Veg Rice/ Noodles",
                                      "choices": [
                                        {
                                          "id": "113732102",
                                          "name": "Veg Fried Rice Bowl",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732123",
                                          "name": "Veg Burnt Garlic Fried Rice Bowl",
                                          "price": 18900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732105",
                                          "name": "Veg Chilli Garlic Fried Rice Bowl",
                                          "price": 19900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732116",
                                          "name": "Veg Schezwan Fried Rice Bowl",
                                          "price": 23900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732104",
                                          "name": "Veg Hakka Noodles Bowl",
                                          "price": 19900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732107",
                                          "name": "Veg Burnt Garlic Noodles Bowl",
                                          "price": 21900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732106",
                                          "name": "Veg Chilli Garlic Noodles Bowl",
                                          "price": 21500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732118",
                                          "name": "Veg Schezwan Noodles Bowl",
                                          "price": 23900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177663",
                                      "groupName": "Add Soup",
                                      "choices": [
                                        {
                                          "id": "113732100",
                                          "name": "Veg Manchow Soup with Crispy Noodles",
                                          "price": 18900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732111",
                                          "name": "Chicken Manchow Soup with Crispy Noodles",
                                          "price": 19900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 26900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "69258839",
                                  "name": "Veg Manchurian Dry",
                                  "category": "Starters & Soup",
                                  "description": "Serves 1 | (Peppery & Spicy) Mix veg fried balls, onion and capsicum tossed in classic manchurian sauce.",
                                  "imageId": "63252f17d5b30abfa52d853248a316b3",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 26900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177400",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177402",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177404",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177405",
                                      "groupName": "Add Veg Rice/ Noodles",
                                      "choices": [
                                        {
                                          "id": "113732102",
                                          "name": "Veg Fried Rice Bowl",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732123",
                                          "name": "Veg Burnt Garlic Fried Rice Bowl",
                                          "price": 18900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732105",
                                          "name": "Veg Chilli Garlic Fried Rice Bowl",
                                          "price": 19900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732116",
                                          "name": "Veg Schezwan Fried Rice Bowl",
                                          "price": 23900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732104",
                                          "name": "Veg Hakka Noodles Bowl",
                                          "price": 19900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732107",
                                          "name": "Veg Burnt Garlic Noodles Bowl",
                                          "price": 21900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732106",
                                          "name": "Veg Chilli Garlic Noodles Bowl",
                                          "price": 21500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732118",
                                          "name": "Veg Schezwan Noodles Bowl",
                                          "price": 23900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177406",
                                      "groupName": "Add Soup",
                                      "choices": [
                                        {
                                          "id": "113732100",
                                          "name": "Veg Manchow Soup with Crispy Noodles",
                                          "price": 18900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732111",
                                          "name": "Chicken Manchow Soup with Crispy Noodles",
                                          "price": 19900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "16 ratings",
                                      "ratingCountV2": "16"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "69258840",
                                  "name": "Paneer Chilli Dry",
                                  "category": "Starters & Soup",
                                  "description": "Serves 1 | (Spicy) Paneer cubes, green chilli, onion, capsicum tossed in desi chilli sauce finished with a punch of soya.",
                                  "imageId": "mwwp59gok3iwvz8aap7o",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 30900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177349",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177350",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177351",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177352",
                                      "groupName": "Add Veg Rice/ Noodles",
                                      "choices": [
                                        {
                                          "id": "113732102",
                                          "name": "Veg Fried Rice Bowl",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732123",
                                          "name": "Veg Burnt Garlic Fried Rice Bowl",
                                          "price": 18900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732105",
                                          "name": "Veg Chilli Garlic Fried Rice Bowl",
                                          "price": 19900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732116",
                                          "name": "Veg Schezwan Fried Rice Bowl",
                                          "price": 23900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732104",
                                          "name": "Veg Hakka Noodles Bowl",
                                          "price": 19900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732107",
                                          "name": "Veg Burnt Garlic Noodles Bowl",
                                          "price": 21900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732106",
                                          "name": "Veg Chilli Garlic Noodles Bowl",
                                          "price": 21500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732118",
                                          "name": "Veg Schezwan Noodles Bowl",
                                          "price": 23900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177353",
                                      "groupName": "Add Soup",
                                      "choices": [
                                        {
                                          "id": "113732100",
                                          "name": "Veg Manchow Soup with Crispy Noodles",
                                          "price": 18900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732111",
                                          "name": "Chicken Manchow Soup with Crispy Noodles",
                                          "price": 19900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "2.7",
                                      "ratingCount": "11 ratings",
                                      "ratingCountV2": "11"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "120785105",
                                  "name": "Chicken Spring Roll",
                                  "category": "Starters & Soup",
                                  "description": "Serves 1 | Minced chicken encased in crispy spring roll sheet served with sweet chilli sauce.",
                                  "imageId": "5435d37f1e0c7be8eface74fbe6182ea",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "33801748",
                                        "name": "Chicken Spring Roll",
                                        "variations": [
                                          {
                                            "name": "Chicken Spring Roll (4 pcs)",
                                            "price": 209,
                                            "default": 1,
                                            "id": "104518302",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken Spring Roll (6 pcs)",
                                            "price": 274,
                                            "id": "121812414",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken Spring Roll (12 pcs)",
                                            "price": 459,
                                            "id": "121812415",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801748",
                                            "variationId": "104518302"
                                          }
                                        ],
                                        "price": 20900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177090",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177090",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177089",
                                            "addonId": "113732112"
                                          },
                                          {
                                            "groupId": "138177089",
                                            "addonId": "113732110"
                                          },
                                          {
                                            "groupId": "138177089",
                                            "addonId": "113732114"
                                          },
                                          {
                                            "groupId": "138177089",
                                            "addonId": "113732122"
                                          },
                                          {
                                            "groupId": "138177089",
                                            "addonId": "113732117"
                                          },
                                          {
                                            "groupId": "138177089",
                                            "addonId": "113732109"
                                          },
                                          {
                                            "groupId": "138177089",
                                            "addonId": "113732115"
                                          },
                                          {
                                            "groupId": "138177089",
                                            "addonId": "113732124"
                                          },
                                          {
                                            "groupId": "138177089",
                                            "addonId": "113732119"
                                          },
                                          {
                                            "groupId": "138177089",
                                            "addonId": "113732101"
                                          },
                                          {
                                            "groupId": "138177088",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177088",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177088",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177088",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177088",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177083",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177083",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177083",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177083",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177083",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177083",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177085",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177085",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177085",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177085",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177085",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177085",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177085",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177085",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177085",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177085",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801748",
                                            "variationId": "121812414"
                                          }
                                        ],
                                        "price": 27400,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177090",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177090",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177089",
                                            "addonId": "113732112"
                                          },
                                          {
                                            "groupId": "138177089",
                                            "addonId": "113732110"
                                          },
                                          {
                                            "groupId": "138177089",
                                            "addonId": "113732114"
                                          },
                                          {
                                            "groupId": "138177089",
                                            "addonId": "113732122"
                                          },
                                          {
                                            "groupId": "138177089",
                                            "addonId": "113732117"
                                          },
                                          {
                                            "groupId": "138177089",
                                            "addonId": "113732109"
                                          },
                                          {
                                            "groupId": "138177089",
                                            "addonId": "113732115"
                                          },
                                          {
                                            "groupId": "138177089",
                                            "addonId": "113732124"
                                          },
                                          {
                                            "groupId": "138177089",
                                            "addonId": "113732119"
                                          },
                                          {
                                            "groupId": "138177089",
                                            "addonId": "113732101"
                                          },
                                          {
                                            "groupId": "138177088",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177088",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177088",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177088",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177088",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177083",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177083",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177083",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177083",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177083",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177083",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177085",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177085",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177085",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177085",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177085",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177085",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177085",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177085",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177085",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177085",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801748",
                                            "variationId": "121812415"
                                          }
                                        ],
                                        "price": 45900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177090",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177090",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177089",
                                            "addonId": "113732112"
                                          },
                                          {
                                            "groupId": "138177089",
                                            "addonId": "113732110"
                                          },
                                          {
                                            "groupId": "138177089",
                                            "addonId": "113732114"
                                          },
                                          {
                                            "groupId": "138177089",
                                            "addonId": "113732122"
                                          },
                                          {
                                            "groupId": "138177089",
                                            "addonId": "113732117"
                                          },
                                          {
                                            "groupId": "138177089",
                                            "addonId": "113732109"
                                          },
                                          {
                                            "groupId": "138177089",
                                            "addonId": "113732115"
                                          },
                                          {
                                            "groupId": "138177089",
                                            "addonId": "113732124"
                                          },
                                          {
                                            "groupId": "138177089",
                                            "addonId": "113732119"
                                          },
                                          {
                                            "groupId": "138177089",
                                            "addonId": "113732101"
                                          },
                                          {
                                            "groupId": "138177088",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177088",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177088",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177088",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177088",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177083",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177083",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177083",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177083",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177083",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177083",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177085",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177085",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177085",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177085",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177085",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177085",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177085",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177085",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177085",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177085",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177083",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177085",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177088",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177089",
                                      "groupName": "Add Non Veg Rice/ Noodles",
                                      "choices": [
                                        {
                                          "id": "113732112",
                                          "name": "Egg Fried Rice Bowl",
                                          "price": 20900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732110",
                                          "name": "Double Egg Fried Rice Bowl",
                                          "price": 22900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732114",
                                          "name": "Chicken Fried Rice Bowl",
                                          "price": 20900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732122",
                                          "name": "Chicken Burnt Garlic Fried Rice Bowl",
                                          "price": 25900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732117",
                                          "name": "Chicken Chilli Garlic Fried Rice Bowl",
                                          "price": 25900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732109",
                                          "name": "Chicken Schezwan Fried Rice Bowl",
                                          "price": 25900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732115",
                                          "name": "Chicken Hakka Noodles Bowl",
                                          "price": 22900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732124",
                                          "name": "Chicken Burnt Garlic Noodles Bowl",
                                          "price": 25900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732119",
                                          "name": "Chicken Chilli Garlic Noodles Bowl",
                                          "price": 25900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732101",
                                          "name": "Chicken Schezwan Noodles Bowl",
                                          "price": 27900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177090",
                                      "groupName": "Add Soup",
                                      "choices": [
                                        {
                                          "id": "113732100",
                                          "name": "Veg Manchow Soup with Crispy Noodles",
                                          "price": 18900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732111",
                                          "name": "Chicken Manchow Soup with Crispy Noodles",
                                          "price": 19900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 20900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "69258844",
                                  "name": "Chilli Chicken Dry",
                                  "category": "Starters & Soup",
                                  "description": "Serves 1 | (Spicy) Diced chicken, green chillies, onion, capsicum tossed in desi chilli sauce finished with a punch of soya.",
                                  "imageId": "glwqyzn7qubrg16vzkjj",
                                  "inStock": 1,
                                  "price": 33900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177626",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177627",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177628",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177629",
                                      "groupName": "Add Non Veg Rice/ Noodles",
                                      "choices": [
                                        {
                                          "id": "113732112",
                                          "name": "Egg Fried Rice Bowl",
                                          "price": 20900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732110",
                                          "name": "Double Egg Fried Rice Bowl",
                                          "price": 22900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732114",
                                          "name": "Chicken Fried Rice Bowl",
                                          "price": 20900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732122",
                                          "name": "Chicken Burnt Garlic Fried Rice Bowl",
                                          "price": 25900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732117",
                                          "name": "Chicken Chilli Garlic Fried Rice Bowl",
                                          "price": 25900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732109",
                                          "name": "Chicken Schezwan Fried Rice Bowl",
                                          "price": 25900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732115",
                                          "name": "Chicken Hakka Noodles Bowl",
                                          "price": 22900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732124",
                                          "name": "Chicken Burnt Garlic Noodles Bowl",
                                          "price": 25900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732119",
                                          "name": "Chicken Chilli Garlic Noodles Bowl",
                                          "price": 25900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732101",
                                          "name": "Chicken Schezwan Noodles Bowl",
                                          "price": 27900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177630",
                                      "groupName": "Add Soup",
                                      "choices": [
                                        {
                                          "id": "113732100",
                                          "name": "Veg Manchow Soup with Crispy Noodles",
                                          "price": 18900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732111",
                                          "name": "Chicken Manchow Soup with Crispy Noodles",
                                          "price": 19900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.5",
                                      "ratingCount": "22 ratings",
                                      "ratingCountV2": "22"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "69258845",
                                  "name": "Chicken Manchurian Dry",
                                  "category": "Starters & Soup",
                                  "description": "Serves 1 | (Peppery & Non Spicy) Diced chicken, onion and capsicum tossed in classic manchurian sauce.",
                                  "imageId": "dfscgchz5ks9gcwoirpz",
                                  "inStock": 1,
                                  "price": 33900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177502",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177504",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177506",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177509",
                                      "groupName": "Add Non Veg Rice/ Noodles",
                                      "choices": [
                                        {
                                          "id": "113732112",
                                          "name": "Egg Fried Rice Bowl",
                                          "price": 20900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732110",
                                          "name": "Double Egg Fried Rice Bowl",
                                          "price": 22900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732114",
                                          "name": "Chicken Fried Rice Bowl",
                                          "price": 20900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732122",
                                          "name": "Chicken Burnt Garlic Fried Rice Bowl",
                                          "price": 25900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732117",
                                          "name": "Chicken Chilli Garlic Fried Rice Bowl",
                                          "price": 25900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732109",
                                          "name": "Chicken Schezwan Fried Rice Bowl",
                                          "price": 25900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732115",
                                          "name": "Chicken Hakka Noodles Bowl",
                                          "price": 22900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732124",
                                          "name": "Chicken Burnt Garlic Noodles Bowl",
                                          "price": 25900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732119",
                                          "name": "Chicken Chilli Garlic Noodles Bowl",
                                          "price": 25900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732101",
                                          "name": "Chicken Schezwan Noodles Bowl",
                                          "price": 27900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177512",
                                      "groupName": "Add Soup",
                                      "choices": [
                                        {
                                          "id": "113732100",
                                          "name": "Veg Manchow Soup with Crispy Noodles",
                                          "price": 18900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732111",
                                          "name": "Chicken Manchow Soup with Crispy Noodles",
                                          "price": 19900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.5",
                                      "ratingCount": "11 ratings",
                                      "ratingCountV2": "11"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Soup",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "69258841",
                                  "name": "Veg Manchow Soup with Crispy Noodles",
                                  "category": "Starters & Soup",
                                  "description": "Serves 1 | A local favourite with veggies topped with crunchy fried noodles.",
                                  "imageId": "a5l3vk5gs0wanqhrceqq",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 18900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177594",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177597",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177599",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "1.9",
                                      "ratingCount": "10 ratings",
                                      "ratingCountV2": "10"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "69258846",
                                  "name": "Chicken Manchow Soup with Crispy Noodles",
                                  "category": "Starters & Soup",
                                  "description": "Serves 1 | A local favourite with chicken and egg topped with crunchy fried noodles.",
                                  "imageId": "myer5zjduzm6b4xcd5oz",
                                  "inStock": 1,
                                  "price": 19900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177612",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177614",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177615",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177616",
                                      "groupName": "Add Non Veg Spring Roll",
                                      "choices": [
                                        {
                                          "id": "113732094",
                                          "name": "Chicken Spring Roll (4pcs)",
                                          "price": 20900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "14 ratings",
                                      "ratingCountV2": "14"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Momos",
                      "categories": [
                        {
                          "title": "Steamed Momos",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "133697289",
                                  "name": "Veg Wheat Momos With Momo Chutney",
                                  "category": "Momos",
                                  "description": "Serves 1 | Aromatic mixture of minced vegetables encased in a wheat wrapper, served steaming hot with momo chutney.",
                                  "imageId": "ca13d4f9bc64d1cdfef4f9290e330065",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "37943654",
                                        "name": "Add Veg Wheat Momos",
                                        "variations": [
                                          {
                                            "name": "Steamed Veg Wheat Momo with Momo Chutney - 6 Pcs",
                                            "price": 229,
                                            "default": 1,
                                            "id": "119216744",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "37943655",
                                              "variationId": "119216748"
                                            }
                                          },
                                          {
                                            "name": "Fried Veg Wheat Momo with Momo Chutney - 6 Pcs",
                                            "price": 259,
                                            "id": "119216745",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "37943655",
                                              "variationId": "119216748"
                                            }
                                          },
                                          {
                                            "name": "Steamed Veg Wheat Momo with Momo Chutney -12 Pcs",
                                            "price": 339,
                                            "id": "121812542",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "37943655",
                                              "variationId": "119216748"
                                            }
                                          },
                                          {
                                            "name": "Fried Veg Wheat Momo with Momo Chutney - 12 Pcs",
                                            "price": 389,
                                            "id": "121812544",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "37943655",
                                              "variationId": "119216748"
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "37943655",
                                        "name": "Add Dip",
                                        "variations": [
                                          {
                                            "name": "Momo Chutney",
                                            "price": 1,
                                            "default": 1,
                                            "id": "119216748",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "37943654",
                                            "variationId": "119216744"
                                          },
                                          {
                                            "groupId": "37943655",
                                            "variationId": "119216748"
                                          }
                                        ],
                                        "price": 23000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177470",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177470",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177469",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177467",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177467",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177467",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177467",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177467",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177463",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177463",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177463",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177463",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177463",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177463",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177465",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177465",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177465",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177465",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177465",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177465",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177465",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177465",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177465",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177465",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "37943654",
                                            "variationId": "119216745"
                                          },
                                          {
                                            "groupId": "37943655",
                                            "variationId": "119216748"
                                          }
                                        ],
                                        "price": 26000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177470",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177470",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177469",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177467",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177467",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177467",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177467",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177467",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177463",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177463",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177463",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177463",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177463",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177463",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177465",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177465",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177465",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177465",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177465",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177465",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177465",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177465",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177465",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177465",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "37943654",
                                            "variationId": "121812542"
                                          },
                                          {
                                            "groupId": "37943655",
                                            "variationId": "119216748"
                                          }
                                        ],
                                        "price": 34000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177470",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177470",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177469",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177467",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177467",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177467",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177467",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177467",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177463",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177463",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177463",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177463",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177463",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177463",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177465",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177465",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177465",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177465",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177465",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177465",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177465",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177465",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177465",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177465",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "37943654",
                                            "variationId": "121812544"
                                          },
                                          {
                                            "groupId": "37943655",
                                            "variationId": "119216748"
                                          }
                                        ],
                                        "price": 39000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177470",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177470",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177469",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177467",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177467",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177467",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177467",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177467",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177463",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177463",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177463",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177463",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177463",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177463",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177465",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177465",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177465",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177465",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177465",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177465",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177465",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177465",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177465",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177465",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177463",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177465",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177467",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177470",
                                      "groupName": "Add Soup",
                                      "choices": [
                                        {
                                          "id": "113732100",
                                          "name": "Veg Manchow Soup with Crispy Noodles",
                                          "price": 18900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732111",
                                          "name": "Chicken Manchow Soup with Crispy Noodles",
                                          "price": 19900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 23000,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "120785094",
                                  "name": "Veg Momos with Momo Chutney",
                                  "category": "Momos",
                                  "description": "Serves 1 | Aromatic mixture of minced vegetables encased in a thin wrapper, served steaming hot with momo chutney.",
                                  "imageId": "2b06baf15913ed55d6805a1caafedb11",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "33801749",
                                        "name": "Add Veg Momos",
                                        "variations": [
                                          {
                                            "name": "Steamed Veg Momos with Momo Chutney - 6 Pcs",
                                            "price": 209,
                                            "default": 1,
                                            "id": "104518305",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "37286724",
                                              "variationId": "116461138"
                                            }
                                          },
                                          {
                                            "name": "Fried Veg Momos with Momo Chutney - 6 Pc",
                                            "price": 239,
                                            "id": "104518306",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "37286724",
                                              "variationId": "116461138"
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "37286724",
                                        "name": "Add Dip",
                                        "variations": [
                                          {
                                            "name": "Momo Chutney",
                                            "price": 1,
                                            "default": 1,
                                            "id": "116461138",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801749",
                                            "variationId": "104518305"
                                          },
                                          {
                                            "groupId": "37286724",
                                            "variationId": "116461138"
                                          }
                                        ],
                                        "price": 21000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177113",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177113",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177111",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177110",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177110",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177110",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177110",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177110",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177108",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177108",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177108",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177108",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177108",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177108",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177109",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177109",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177109",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177109",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177109",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177109",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177109",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177109",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177109",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177109",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801749",
                                            "variationId": "104518306"
                                          },
                                          {
                                            "groupId": "37286724",
                                            "variationId": "116461138"
                                          }
                                        ],
                                        "price": 24000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177113",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177113",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177111",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177110",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177110",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177110",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177110",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177110",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177108",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177108",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177108",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177108",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177108",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177108",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177109",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177109",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177109",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177109",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177109",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177109",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177109",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177109",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177109",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177109",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177108",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177109",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177110",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177113",
                                      "groupName": "Add Soup",
                                      "choices": [
                                        {
                                          "id": "113732100",
                                          "name": "Veg Manchow Soup with Crispy Noodles",
                                          "price": 18900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732111",
                                          "name": "Chicken Manchow Soup with Crispy Noodles",
                                          "price": 19900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 21000,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "120785095",
                                  "name": "Paneer Tikka Momos with Momo Chutney",
                                  "category": "Momos",
                                  "description": "Serves 1 | Mixture of paneer tikka masala encased in a thin wrapper, served steaming hot with momo chutney.",
                                  "imageId": "9f743e80bc01eb9dfecad8eca0b72114",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "33801751",
                                        "name": "Add Paneer Tikka Momos",
                                        "variations": [
                                          {
                                            "name": "Steamed Paneer Tikka Momos with Momo Chutney - 6 Pc",
                                            "price": 249,
                                            "default": 1,
                                            "id": "104518310",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "37286748",
                                              "variationId": "116461232"
                                            }
                                          },
                                          {
                                            "name": "Fried Paneer Tikka Momos with Momo Chutney - 6 Pc",
                                            "price": 279,
                                            "id": "104518311",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "37286748",
                                              "variationId": "116461232"
                                            }
                                          },
                                          {
                                            "name": "Steamed Paneer Tikka Momos with Momo Chutney - 12 Pcs",
                                            "price": 375,
                                            "id": "121812412",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "37286748",
                                              "variationId": "116461232"
                                            }
                                          },
                                          {
                                            "name": "Fried Paneer Tikka Momos with Momo Chutney - 12 Pcs",
                                            "price": 419,
                                            "id": "121812413",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "37286748",
                                              "variationId": "116461232"
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "37286748",
                                        "name": "Add Dip",
                                        "variations": [
                                          {
                                            "name": "Momo Chutney",
                                            "price": 1,
                                            "default": 1,
                                            "id": "116461232",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801751",
                                            "variationId": "104518310"
                                          },
                                          {
                                            "groupId": "37286748",
                                            "variationId": "116461232"
                                          }
                                        ],
                                        "price": 25000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177077",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177077",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177075",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177074",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177074",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177074",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177074",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177074",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177072",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177072",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177072",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177072",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177072",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177072",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177073",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177073",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177073",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177073",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177073",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177073",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177073",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177073",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177073",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177073",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801751",
                                            "variationId": "104518311"
                                          },
                                          {
                                            "groupId": "37286748",
                                            "variationId": "116461232"
                                          }
                                        ],
                                        "price": 28000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177077",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177077",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177075",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177074",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177074",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177074",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177074",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177074",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177072",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177072",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177072",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177072",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177072",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177072",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177073",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177073",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177073",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177073",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177073",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177073",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177073",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177073",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177073",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177073",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801751",
                                            "variationId": "121812412"
                                          },
                                          {
                                            "groupId": "37286748",
                                            "variationId": "116461232"
                                          }
                                        ],
                                        "price": 37600,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177077",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177077",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177075",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177074",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177074",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177074",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177074",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177074",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177072",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177072",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177072",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177072",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177072",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177072",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177073",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177073",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177073",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177073",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177073",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177073",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177073",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177073",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177073",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177073",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801751",
                                            "variationId": "121812413"
                                          },
                                          {
                                            "groupId": "37286748",
                                            "variationId": "116461232"
                                          }
                                        ],
                                        "price": 42000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177077",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177077",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177075",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177074",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177074",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177074",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177074",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177074",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177072",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177072",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177072",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177072",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177072",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177072",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177073",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177073",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177073",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177073",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177073",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177073",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177073",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177073",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177073",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177073",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177072",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177073",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177074",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177077",
                                      "groupName": "Add Soup",
                                      "choices": [
                                        {
                                          "id": "113732100",
                                          "name": "Veg Manchow Soup with Crispy Noodles",
                                          "price": 18900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732111",
                                          "name": "Chicken Manchow Soup with Crispy Noodles",
                                          "price": 19900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 25000,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "133697290",
                                  "name": "Chicken Wheat Momos With Momo Chutney",
                                  "category": "Momos",
                                  "description": "Serves 1 | Aromatic mix of juicy chicken mince filling encased in a wheat wrapper, served steaming hot with momo chutney.",
                                  "imageId": "d4717a043d1cb5b95cfceeef2f28f5d5",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "37943656",
                                        "name": "Add Chicken Wheat Momos",
                                        "variations": [
                                          {
                                            "name": "Steamed Chicken Wheat Momo with Momo Chutney - 6 Pc",
                                            "price": 239,
                                            "default": 1,
                                            "id": "119216749",
                                            "inStock": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "37943657",
                                              "variationId": "119216753"
                                            }
                                          },
                                          {
                                            "name": "Fried Chicken Wheat Momo with Momo Chutney - 6 Pcs",
                                            "price": 269,
                                            "id": "119216750",
                                            "inStock": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "37943657",
                                              "variationId": "119216753"
                                            }
                                          },
                                          {
                                            "name": "Steamed Chicken Wheat Momo with Momo Chutney - 12 Pcs",
                                            "price": 359,
                                            "id": "121812502",
                                            "inStock": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "37943657",
                                              "variationId": "119216753"
                                            }
                                          },
                                          {
                                            "name": "Fried Chicken Wheat Momo with Momo Chutney - 12 Pcs",
                                            "price": 409,
                                            "id": "121812503",
                                            "inStock": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "37943657",
                                              "variationId": "119216753"
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "37943657",
                                        "name": "Add Dip",
                                        "variations": [
                                          {
                                            "name": "Momo Chutney",
                                            "price": 1,
                                            "default": 1,
                                            "id": "119216753",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "37943656",
                                            "variationId": "119216749"
                                          },
                                          {
                                            "groupId": "37943657",
                                            "variationId": "119216753"
                                          }
                                        ],
                                        "price": 24000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177375",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177375",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177374",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177372",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177372",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177372",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177372",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177372",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177370",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177370",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177370",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177370",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177370",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177370",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177371",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177371",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177371",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177371",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177371",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177371",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177371",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177371",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177371",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177371",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "37943656",
                                            "variationId": "119216750"
                                          },
                                          {
                                            "groupId": "37943657",
                                            "variationId": "119216753"
                                          }
                                        ],
                                        "price": 27000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177375",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177375",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177374",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177372",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177372",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177372",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177372",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177372",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177370",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177370",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177370",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177370",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177370",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177370",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177371",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177371",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177371",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177371",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177371",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177371",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177371",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177371",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177371",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177371",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "37943656",
                                            "variationId": "121812502"
                                          },
                                          {
                                            "groupId": "37943657",
                                            "variationId": "119216753"
                                          }
                                        ],
                                        "price": 36000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177375",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177375",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177374",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177372",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177372",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177372",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177372",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177372",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177370",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177370",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177370",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177370",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177370",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177370",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177371",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177371",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177371",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177371",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177371",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177371",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177371",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177371",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177371",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177371",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "37943656",
                                            "variationId": "121812503"
                                          },
                                          {
                                            "groupId": "37943657",
                                            "variationId": "119216753"
                                          }
                                        ],
                                        "price": 41000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177375",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177375",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177374",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177372",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177372",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177372",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177372",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177372",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177370",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177370",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177370",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177370",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177370",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177370",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177371",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177371",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177371",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177371",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177371",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177371",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177371",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177371",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177371",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177371",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177370",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177371",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177372",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177374",
                                      "groupName": "Add Non Veg Spring Roll",
                                      "choices": [
                                        {
                                          "id": "113732094",
                                          "name": "Chicken Spring Roll (4pcs)",
                                          "price": 20900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177375",
                                      "groupName": "Add Soup",
                                      "choices": [
                                        {
                                          "id": "113732100",
                                          "name": "Veg Manchow Soup with Crispy Noodles",
                                          "price": 18900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732111",
                                          "name": "Chicken Manchow Soup with Crispy Noodles",
                                          "price": 19900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 24000,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "120785097",
                                  "name": "Chicken Momos with Momo Chutney",
                                  "category": "Momos",
                                  "description": "Serves 1 | Aromatic mix of juicy chicken mince filling encased in a thin wrapper, served steaming hot with momo chutney.",
                                  "imageId": "48262f81ca919bf443284f774c04dae0",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "33801755",
                                        "name": "Add Chicken Momos",
                                        "variations": [
                                          {
                                            "name": "Steamed Chicken Momos with Momo Chutney - 6 Pc",
                                            "price": 219,
                                            "default": 1,
                                            "id": "104518320",
                                            "inStock": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "37286728",
                                              "variationId": "116461159"
                                            }
                                          },
                                          {
                                            "name": "Fried Chicken Momos with Momo Chutney - 6 Pc",
                                            "price": 249,
                                            "id": "104518321",
                                            "inStock": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "37286728",
                                              "variationId": "116461159"
                                            }
                                          },
                                          {
                                            "name": "Steamed Chicken Momos with Momo Chutney - 12 Pcs",
                                            "price": 339,
                                            "id": "121812555",
                                            "inStock": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "37286728",
                                              "variationId": "116461159"
                                            }
                                          },
                                          {
                                            "name": "Fried Chicken Momos with Momo Chutney - 12 Pcs",
                                            "price": 389,
                                            "id": "121812556",
                                            "inStock": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "37286728",
                                              "variationId": "116461159"
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "37286728",
                                        "name": "Add Dip",
                                        "variations": [
                                          {
                                            "name": "Momo Chutney",
                                            "price": 1,
                                            "default": 1,
                                            "id": "116461159",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801755",
                                            "variationId": "104518320"
                                          },
                                          {
                                            "groupId": "37286728",
                                            "variationId": "116461159"
                                          }
                                        ],
                                        "price": 22000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177486",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177486",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177485",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177483",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177483",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177483",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177483",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177483",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177479",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177479",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177479",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177479",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177479",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177479",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177481",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177481",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177481",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177481",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177481",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177481",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177481",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177481",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177481",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177481",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801755",
                                            "variationId": "104518321"
                                          },
                                          {
                                            "groupId": "37286728",
                                            "variationId": "116461159"
                                          }
                                        ],
                                        "price": 25000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177486",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177486",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177485",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177483",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177483",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177483",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177483",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177483",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177479",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177479",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177479",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177479",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177479",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177479",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177481",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177481",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177481",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177481",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177481",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177481",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177481",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177481",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177481",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177481",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801755",
                                            "variationId": "121812555"
                                          },
                                          {
                                            "groupId": "37286728",
                                            "variationId": "116461159"
                                          }
                                        ],
                                        "price": 34000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177486",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177486",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177485",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177483",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177483",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177483",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177483",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177483",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177479",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177479",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177479",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177479",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177479",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177479",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177481",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177481",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177481",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177481",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177481",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177481",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177481",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177481",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177481",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177481",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801755",
                                            "variationId": "121812556"
                                          },
                                          {
                                            "groupId": "37286728",
                                            "variationId": "116461159"
                                          }
                                        ],
                                        "price": 39000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177486",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177486",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177485",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177483",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177483",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177483",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177483",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177483",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177479",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177479",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177479",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177479",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177479",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177479",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177481",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177481",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177481",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177481",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177481",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177481",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177481",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177481",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177481",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177481",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177479",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177481",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177483",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177485",
                                      "groupName": "Add Non Veg Spring Roll",
                                      "choices": [
                                        {
                                          "id": "113732094",
                                          "name": "Chicken Spring Roll (4pcs)",
                                          "price": 20900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177486",
                                      "groupName": "Add Soup",
                                      "choices": [
                                        {
                                          "id": "113732100",
                                          "name": "Veg Manchow Soup with Crispy Noodles",
                                          "price": 18900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732111",
                                          "name": "Chicken Manchow Soup with Crispy Noodles",
                                          "price": 19900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 22000,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "120785098",
                                  "name": "Chicken Tikka Momos with Momo Chutney",
                                  "category": "Momos",
                                  "description": "Serves 1 | Aromatic mixture of minced vegetables encased in a thin wrapper, served steaming hot with momo chutney.",
                                  "imageId": "c9c0623d299c16b9ff32db1522822620",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "33801767",
                                        "name": "Add Chicken Tikka Momos",
                                        "variations": [
                                          {
                                            "name": "Steamed Chicken Tikka Momos with Momo Chutney - 6 Pc",
                                            "price": 259,
                                            "default": 1,
                                            "id": "104518340",
                                            "inStock": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "37286706",
                                              "variationId": "116461046"
                                            }
                                          },
                                          {
                                            "name": "Fried Chicken Tikka Momos with Momo Chutney - 6 Pc",
                                            "price": 289,
                                            "id": "104518341",
                                            "inStock": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "37286706",
                                              "variationId": "116461046"
                                            }
                                          },
                                          {
                                            "name": "Steamed Chicken Tikka Momos with Momo Chutney - 12 Pcs",
                                            "price": 395,
                                            "id": "121812472",
                                            "inStock": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "37286706",
                                              "variationId": "116461046"
                                            }
                                          },
                                          {
                                            "name": "Fried Chicken Tikka Momos with Momo Chutney - 12 Pcs",
                                            "price": 445,
                                            "id": "121812473",
                                            "inStock": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "37286706",
                                              "variationId": "116461046"
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "37286706",
                                        "name": "Add Dip",
                                        "variations": [
                                          {
                                            "name": "Momo Chutney",
                                            "price": 1,
                                            "default": 1,
                                            "id": "116461046",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801767",
                                            "variationId": "104518340"
                                          },
                                          {
                                            "groupId": "37286706",
                                            "variationId": "116461046"
                                          }
                                        ],
                                        "price": 26000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177308",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177308",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177307",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177306",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177306",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177306",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177306",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177306",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177301",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177301",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177301",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177301",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177301",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177301",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177303",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177303",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177303",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177303",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177303",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177303",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177303",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177303",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177303",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177303",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801767",
                                            "variationId": "104518341"
                                          },
                                          {
                                            "groupId": "37286706",
                                            "variationId": "116461046"
                                          }
                                        ],
                                        "price": 29000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177308",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177308",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177307",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177306",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177306",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177306",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177306",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177306",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177301",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177301",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177301",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177301",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177301",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177301",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177303",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177303",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177303",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177303",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177303",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177303",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177303",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177303",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177303",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177303",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801767",
                                            "variationId": "121812472"
                                          },
                                          {
                                            "groupId": "37286706",
                                            "variationId": "116461046"
                                          }
                                        ],
                                        "price": 39600,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177308",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177308",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177307",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177306",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177306",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177306",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177306",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177306",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177301",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177301",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177301",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177301",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177301",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177301",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177303",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177303",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177303",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177303",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177303",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177303",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177303",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177303",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177303",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177303",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801767",
                                            "variationId": "121812473"
                                          },
                                          {
                                            "groupId": "37286706",
                                            "variationId": "116461046"
                                          }
                                        ],
                                        "price": 44600,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177308",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177308",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177307",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177306",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177306",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177306",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177306",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177306",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177301",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177301",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177301",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177301",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177301",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177301",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177303",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177303",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177303",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177303",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177303",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177303",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177303",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177303",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177303",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177303",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177301",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177303",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177306",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177307",
                                      "groupName": "Add Non Veg Spring Roll",
                                      "choices": [
                                        {
                                          "id": "113732094",
                                          "name": "Chicken Spring Roll (4pcs)",
                                          "price": 20900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177308",
                                      "groupName": "Add Soup",
                                      "choices": [
                                        {
                                          "id": "113732100",
                                          "name": "Veg Manchow Soup with Crispy Noodles",
                                          "price": 18900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732111",
                                          "name": "Chicken Manchow Soup with Crispy Noodles",
                                          "price": 19900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 26000,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Fried Momos",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "133697295",
                                  "name": "Fried Veg Wheat Momos With Momo Chutney",
                                  "category": "Momos",
                                  "description": "Serves 1 | Aromatic mixture of minced vegetables encased in wheat wrapper, served crispy fried with momo chutney.",
                                  "imageId": "3571ad5be7111708c7bc8d491cb3a990",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "37943662",
                                        "name": "Add Fried Veg  Wheat Momos",
                                        "variations": [
                                          {
                                            "name": "Fried Veg Wheat Momo with Momo Chutney - 6 Pcs",
                                            "price": 259,
                                            "default": 1,
                                            "id": "119216762",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "37943663",
                                              "variationId": "119216764"
                                            }
                                          },
                                          {
                                            "name": "Fried Veg Wheat Momo with Momo Chutney - 12 Pcs",
                                            "price": 389,
                                            "id": "121812448",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "37943663",
                                              "variationId": "119216764"
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "37943663",
                                        "name": "Add Dip",
                                        "variations": [
                                          {
                                            "name": "Momo Chutney",
                                            "price": 1,
                                            "default": 1,
                                            "id": "119216764",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "37943662",
                                            "variationId": "119216762"
                                          },
                                          {
                                            "groupId": "37943663",
                                            "variationId": "119216764"
                                          }
                                        ],
                                        "price": 26000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177173",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177173",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177172",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177171",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177171",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177171",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177171",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177171",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177169",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177169",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177169",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177169",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177169",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177169",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177170",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177170",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177170",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177170",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177170",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177170",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177170",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177170",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177170",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177170",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "37943662",
                                            "variationId": "121812448"
                                          },
                                          {
                                            "groupId": "37943663",
                                            "variationId": "119216764"
                                          }
                                        ],
                                        "price": 39000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177173",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177173",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177172",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177171",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177171",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177171",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177171",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177171",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177169",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177169",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177169",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177169",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177169",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177169",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177170",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177170",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177170",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177170",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177170",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177170",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177170",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177170",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177170",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177170",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177169",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177170",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177171",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177173",
                                      "groupName": "Add Soup",
                                      "choices": [
                                        {
                                          "id": "113732100",
                                          "name": "Veg Manchow Soup with Crispy Noodles",
                                          "price": 18900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732111",
                                          "name": "Chicken Manchow Soup with Crispy Noodles",
                                          "price": 19900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 26000,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "71677872",
                                  "name": "Fried Veg Momos with Momo Chutney",
                                  "category": "Momos",
                                  "description": "Serves 1 | Aromatic mixture of minced vegetables encased in a thin wrapper, served crispy fried with momo chutney.",
                                  "imageId": "b33940913acd6c38df77105592cd1949",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "33801763",
                                        "name": "Add Fried Veg Momos",
                                        "variations": [
                                          {
                                            "name": "Fried Veg Momos with Momo Chutney - 6 Pc",
                                            "price": 239,
                                            "default": 1,
                                            "id": "104518334",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "37286713",
                                              "variationId": "116461085"
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "37286713",
                                        "name": "Add Dip",
                                        "variations": [
                                          {
                                            "name": "Momo Chutney",
                                            "price": 1,
                                            "default": 1,
                                            "id": "116461085",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801763",
                                            "variationId": "104518334"
                                          },
                                          {
                                            "groupId": "37286713",
                                            "variationId": "116461085"
                                          }
                                        ],
                                        "price": 24000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177197",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177197",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177196",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177195",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177195",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177195",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177195",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177195",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177193",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177193",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177193",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177193",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177193",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177193",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177194",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177194",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177194",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177194",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177194",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177194",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177194",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177194",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177194",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177194",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177193",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177194",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177195",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177197",
                                      "groupName": "Add Soup",
                                      "choices": [
                                        {
                                          "id": "113732100",
                                          "name": "Veg Manchow Soup with Crispy Noodles",
                                          "price": 18900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732111",
                                          "name": "Chicken Manchow Soup with Crispy Noodles",
                                          "price": 19900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 24000,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.5",
                                      "ratingCount": "6 ratings",
                                      "ratingCountV2": "6"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "71677878",
                                  "name": "Fried Paneer Tikka Momos with Momo Chutney",
                                  "category": "Momos",
                                  "description": "Serves 1 | Mixture of paneer tikka masala encased in a thin wrapper, served crispy fried with momo chutney",
                                  "imageId": "a3524256c58deaa280e702602ed46f63",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "33801765",
                                        "name": "Fried Paneer Tikka Momos",
                                        "variations": [
                                          {
                                            "name": "Fried Paneer Tikka Momos with Momo Chutney - 6 Pc",
                                            "price": 279,
                                            "default": 1,
                                            "id": "104518337",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "37286719",
                                              "variationId": "116461114"
                                            }
                                          },
                                          {
                                            "name": "Fried Paneer Tikka Momos with Momo Chutney - 12 Pcs",
                                            "price": 419,
                                            "id": "121812568",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "37286719",
                                              "variationId": "116461114"
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "37286719",
                                        "name": "Add Dip",
                                        "variations": [
                                          {
                                            "name": "Momo Chutney",
                                            "price": 1,
                                            "default": 1,
                                            "id": "116461114",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801765",
                                            "variationId": "104518337"
                                          },
                                          {
                                            "groupId": "37286719",
                                            "variationId": "116461114"
                                          }
                                        ],
                                        "price": 28000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177555",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177555",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177553",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177551",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177551",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177551",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177551",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177551",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177549",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177549",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177549",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177549",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177549",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177549",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177550",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177550",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177550",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177550",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177550",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177550",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177550",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177550",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177550",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177550",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801765",
                                            "variationId": "121812568"
                                          },
                                          {
                                            "groupId": "37286719",
                                            "variationId": "116461114"
                                          }
                                        ],
                                        "price": 42000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177555",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177555",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177553",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177551",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177551",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177551",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177551",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177551",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177549",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177549",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177549",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177549",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177549",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177549",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177550",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177550",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177550",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177550",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177550",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177550",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177550",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177550",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177550",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177550",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177549",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177550",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177551",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177555",
                                      "groupName": "Add Soup",
                                      "choices": [
                                        {
                                          "id": "113732100",
                                          "name": "Veg Manchow Soup with Crispy Noodles",
                                          "price": 18900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732111",
                                          "name": "Chicken Manchow Soup with Crispy Noodles",
                                          "price": 19900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 28000,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "71677888",
                                  "name": "Fried Chicken Momos with Momo Chutney",
                                  "category": "Momos",
                                  "description": "Serves 1 | Aromatic mix of juicy chicken mince filling encased in a thin wrapper, served crispy fried with momo chutney.",
                                  "imageId": "f49e63b20bb8cd895159b58a98bcc0b5",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "33801759",
                                        "name": "Add Fried Chicken Momos",
                                        "variations": [
                                          {
                                            "name": "Fried Chicken Momos with Momo Chutney - 6 Pc",
                                            "price": 249,
                                            "default": 1,
                                            "id": "104518328",
                                            "inStock": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "37286745",
                                              "variationId": "116461220"
                                            }
                                          },
                                          {
                                            "name": "Fried Chicken Momos with Momo Chutney - 12 Pcs",
                                            "price": 389,
                                            "id": "121812416",
                                            "inStock": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "37286745",
                                              "variationId": "116461220"
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "37286745",
                                        "name": "Add Dip",
                                        "variations": [
                                          {
                                            "name": "Momo Chutney",
                                            "price": 1,
                                            "default": 1,
                                            "id": "116461220",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801759",
                                            "variationId": "104518328"
                                          },
                                          {
                                            "groupId": "37286745",
                                            "variationId": "116461220"
                                          }
                                        ],
                                        "price": 25000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177104",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177104",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177101",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177099",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177099",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177099",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177099",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177099",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177096",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177096",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177096",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177096",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177096",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177096",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177098",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177098",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177098",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177098",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177098",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177098",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177098",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177098",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177098",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177098",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801759",
                                            "variationId": "121812416"
                                          },
                                          {
                                            "groupId": "37286745",
                                            "variationId": "116461220"
                                          }
                                        ],
                                        "price": 39000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177104",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177104",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177101",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177099",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177099",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177099",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177099",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177099",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177096",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177096",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177096",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177096",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177096",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177096",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177098",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177098",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177098",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177098",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177098",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177098",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177098",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177098",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177098",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177098",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177096",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177098",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177099",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177101",
                                      "groupName": "Add Non Veg Spring Roll",
                                      "choices": [
                                        {
                                          "id": "113732094",
                                          "name": "Chicken Spring Roll (4pcs)",
                                          "price": 20900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177104",
                                      "groupName": "Add Soup",
                                      "choices": [
                                        {
                                          "id": "113732100",
                                          "name": "Veg Manchow Soup with Crispy Noodles",
                                          "price": 18900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732111",
                                          "name": "Chicken Manchow Soup with Crispy Noodles",
                                          "price": 19900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 25000,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "133697296",
                                  "name": "Fried Chicken Wheat Momos With Momo Chutney",
                                  "category": "Momos",
                                  "description": "Serves 1 | Aromatic mix of juicy chicken mince filling encased in a wheat wrapper, served crispy fried with momo chutney.",
                                  "imageId": "0eaeb499e57d0966307afa5a893b85ef",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "37943664",
                                        "name": "Add Fried Chicken Wheat Momos",
                                        "variations": [
                                          {
                                            "name": "Fried Chicken Wheat Momo with Momo Chutney - 6 Pcs",
                                            "price": 269,
                                            "default": 1,
                                            "id": "119216765",
                                            "inStock": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "37943665",
                                              "variationId": "119216767"
                                            }
                                          },
                                          {
                                            "name": "Fried Chicken Wheat Momo with Momo Chutney - 12 Pcs",
                                            "price": 409,
                                            "id": "121812454",
                                            "inStock": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "37943665",
                                              "variationId": "119216767"
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "37943665",
                                        "name": "Add Dip",
                                        "variations": [
                                          {
                                            "name": "Momo Chutney",
                                            "price": 1,
                                            "default": 1,
                                            "id": "119216767",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "37943664",
                                            "variationId": "119216765"
                                          },
                                          {
                                            "groupId": "37943665",
                                            "variationId": "119216767"
                                          }
                                        ],
                                        "price": 27000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177216",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177216",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177214",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177212",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177212",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177212",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177212",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177212",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177210",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177210",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177210",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177210",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177210",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177210",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177211",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177211",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177211",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177211",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177211",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177211",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177211",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177211",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177211",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177211",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "37943664",
                                            "variationId": "121812454"
                                          },
                                          {
                                            "groupId": "37943665",
                                            "variationId": "119216767"
                                          }
                                        ],
                                        "price": 41000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177216",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177216",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177214",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177212",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177212",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177212",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177212",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177212",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177210",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177210",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177210",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177210",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177210",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177210",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177211",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177211",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177211",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177211",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177211",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177211",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177211",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177211",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177211",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177211",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177210",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177211",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177212",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177214",
                                      "groupName": "Add Non Veg Spring Roll",
                                      "choices": [
                                        {
                                          "id": "113732094",
                                          "name": "Chicken Spring Roll (4pcs)",
                                          "price": 20900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177216",
                                      "groupName": "Add Soup",
                                      "choices": [
                                        {
                                          "id": "113732100",
                                          "name": "Veg Manchow Soup with Crispy Noodles",
                                          "price": 18900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732111",
                                          "name": "Chicken Manchow Soup with Crispy Noodles",
                                          "price": 19900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 27000,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "71677885",
                                  "name": "Fried Chicken Tikka Momos with Momo Chutney",
                                  "category": "Momos",
                                  "description": "Serves 1 | Mixture of chicken tikka masala encased in a thin wrapper, served crispy fried with momo chutney.",
                                  "imageId": "f665e8d2251c096eeca0b56fde26c3ee",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "33801757",
                                        "name": "Add Fried Chicken Tikka Momos",
                                        "variations": [
                                          {
                                            "name": "Fried Chicken Tikka Momos with Momo Chutney - 6 Pc",
                                            "price": 289,
                                            "default": 1,
                                            "id": "104518325",
                                            "inStock": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "37286736",
                                              "variationId": "116461196"
                                            }
                                          },
                                          {
                                            "name": "Fried Chicken Tikka Momos with Momo Chutney - 12 Pcs",
                                            "price": 445,
                                            "id": "121812447",
                                            "inStock": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "37286736",
                                              "variationId": "116461196"
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "37286736",
                                        "name": "Add Dip",
                                        "variations": [
                                          {
                                            "name": "Momo Chutney",
                                            "price": 1,
                                            "default": 1,
                                            "id": "116461196",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801757",
                                            "variationId": "104518325"
                                          },
                                          {
                                            "groupId": "37286736",
                                            "variationId": "116461196"
                                          }
                                        ],
                                        "price": 29000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177160",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177160",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177159",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177158",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177158",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177158",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177158",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177158",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177155",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177155",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177155",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177155",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177155",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177155",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177157",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177157",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177157",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177157",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177157",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177157",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177157",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177157",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177157",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177157",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33801757",
                                            "variationId": "121812447"
                                          },
                                          {
                                            "groupId": "37286736",
                                            "variationId": "116461196"
                                          }
                                        ],
                                        "price": 44600,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177160",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177160",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177159",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177158",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177158",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177158",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177158",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177158",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177155",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177155",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177155",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177155",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177155",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177155",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177157",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177157",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177157",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177157",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177157",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177157",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177157",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177157",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177157",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177157",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177155",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177157",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177158",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177159",
                                      "groupName": "Add Non Veg Spring Roll",
                                      "choices": [
                                        {
                                          "id": "113732094",
                                          "name": "Chicken Spring Roll (4pcs)",
                                          "price": 20900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177160",
                                      "groupName": "Add Soup",
                                      "choices": [
                                        {
                                          "id": "113732100",
                                          "name": "Veg Manchow Soup with Crispy Noodles",
                                          "price": 18900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732111",
                                          "name": "Chicken Manchow Soup with Crispy Noodles",
                                          "price": 19900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 29000,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Momos 12 - Pcs",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "133697291",
                                  "name": "Steamed Veg Wheat Momo with Momo Chutney - 12 Pcs",
                                  "category": "Momos",
                                  "description": "Serves 1 | Aromatic mixture of minced vegetables encased in wheat wrapper. served steaming hot with momo chutney.",
                                  "imageId": "3f77a86db1fdb01415e0cb4ee077d47a",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "38547744",
                                        "name": "Add Dip",
                                        "variations": [
                                          {
                                            "name": "Momo Chutney",
                                            "price": 340,
                                            "default": 1,
                                            "id": "121812849",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Extra Momo Chutney",
                                            "price": 359,
                                            "id": "121812850",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547744",
                                            "variationId": "121812849"
                                          }
                                        ],
                                        "price": 34000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177780",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177780",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177778",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177776",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177776",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177776",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177776",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177776",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177772",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177772",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177772",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177772",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177772",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177772",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177774",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177774",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177774",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177774",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177774",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177774",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177774",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177774",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177774",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177774",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547744",
                                            "variationId": "121812850"
                                          }
                                        ],
                                        "price": 35900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177780",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177780",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177778",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177776",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177776",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177776",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177776",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177776",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177772",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177772",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177772",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177772",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177772",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177772",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177774",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177774",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177774",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177774",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177774",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177774",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177774",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177774",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177774",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177774",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177772",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177774",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177776",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177780",
                                      "groupName": "Add Soup",
                                      "choices": [
                                        {
                                          "id": "113732100",
                                          "name": "Veg Manchow Soup with Crispy Noodles",
                                          "price": 18900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732111",
                                          "name": "Chicken Manchow Soup with Crispy Noodles",
                                          "price": 19900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 34000,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "133697292",
                                  "name": "Fried Veg Wheat Momos with Momo Chutney - 12 Pcs",
                                  "category": "Momos",
                                  "description": "Serves 1 | (12 pcs) aromatic mixture of minced vegetables encased in in wheat wrapper, served crispy fried with momo chutney.",
                                  "imageId": "e4d8d176c42941b4c7361b630102b233",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "38547745",
                                        "name": "Add Dip",
                                        "variations": [
                                          {
                                            "name": "Momo Chutney",
                                            "price": 390,
                                            "default": 1,
                                            "id": "121812851",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Extra Momo Chutney",
                                            "price": 409,
                                            "id": "121812852",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547745",
                                            "variationId": "121812851"
                                          }
                                        ],
                                        "price": 39000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177789",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177789",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177788",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177787",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177787",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177787",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177787",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177787",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177785",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177785",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177785",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177785",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177785",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177785",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177786",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177786",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177786",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177786",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177786",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177786",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177786",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177786",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177786",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177786",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547745",
                                            "variationId": "121812852"
                                          }
                                        ],
                                        "price": 40900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177789",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177789",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177788",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177787",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177787",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177787",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177787",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177787",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177785",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177785",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177785",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177785",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177785",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177785",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177786",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177786",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177786",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177786",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177786",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177786",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177786",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177786",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177786",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177786",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177785",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177786",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177787",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177789",
                                      "groupName": "Add Soup",
                                      "choices": [
                                        {
                                          "id": "113732100",
                                          "name": "Veg Manchow Soup with Crispy Noodles",
                                          "price": 18900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732111",
                                          "name": "Chicken Manchow Soup with Crispy Noodles",
                                          "price": 19900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 39000,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116910373",
                                  "name": "Steamed Veg Momos with Momo Chutney - 12 Pcs",
                                  "category": "Momos",
                                  "description": "Serves 1 | (12 pcs) aromatic mixture of minced vegetables encased in a thin wrapper, served steaming hot with momo chutney.",
                                  "imageId": "74cde67cae195315a04a333949ff8630",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "38547707",
                                        "name": "Add Dip",
                                        "variations": [
                                          {
                                            "name": "Momo Chutney",
                                            "price": 310,
                                            "default": 1,
                                            "id": "121812724",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Extra Momo Chutney",
                                            "price": 329,
                                            "id": "121812725",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547707",
                                            "variationId": "121812724"
                                          }
                                        ],
                                        "price": 31000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177686",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177686",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177684",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177683",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177683",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177683",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177683",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177683",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177680",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177680",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177680",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177680",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177680",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177680",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177682",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177682",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177682",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177682",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177682",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177682",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177682",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177682",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177682",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177682",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547707",
                                            "variationId": "121812725"
                                          }
                                        ],
                                        "price": 32900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177686",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177686",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177684",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177683",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177683",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177683",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177683",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177683",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177680",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177680",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177680",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177680",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177680",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177680",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177682",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177682",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177682",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177682",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177682",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177682",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177682",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177682",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177682",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177682",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177680",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177682",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177683",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177686",
                                      "groupName": "Add Soup",
                                      "choices": [
                                        {
                                          "id": "113732100",
                                          "name": "Veg Manchow Soup with Crispy Noodles",
                                          "price": 18900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732111",
                                          "name": "Chicken Manchow Soup with Crispy Noodles",
                                          "price": 19900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 31000,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116910419",
                                  "name": "Fried Paneer Tikka Momos with Momo Chutney - 12 Pcs",
                                  "category": "Momos",
                                  "description": "Serves 1 | (12 pcs) mixture of paneer tikka masala encased in a thin wrapper, served crispy fried with momo chutney",
                                  "imageId": "ee23306c4b0612f66c70ffdfbb3b5bf3",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "38547709",
                                        "name": "Add Dip",
                                        "variations": [
                                          {
                                            "name": "Momo Chutney",
                                            "price": 420,
                                            "default": 1,
                                            "id": "121812729",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Extra Momo Chutney",
                                            "price": 439,
                                            "id": "121812730",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547709",
                                            "variationId": "121812729"
                                          }
                                        ],
                                        "price": 42000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177703",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177703",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177701",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177699",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177699",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177699",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177699",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177699",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177696",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177696",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177696",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177696",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177696",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177696",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177697",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177697",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177697",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177697",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177697",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177697",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177697",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177697",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177697",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177697",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547709",
                                            "variationId": "121812730"
                                          }
                                        ],
                                        "price": 43900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177703",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177703",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177701",
                                            "addonId": "113732113"
                                          },
                                          {
                                            "groupId": "138177699",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177699",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177699",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177699",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177699",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177696",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177696",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177696",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177696",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177696",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177696",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177697",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177697",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177697",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177697",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177697",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177697",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177697",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177697",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177697",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177697",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177696",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177697",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177699",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177703",
                                      "groupName": "Add Soup",
                                      "choices": [
                                        {
                                          "id": "113732100",
                                          "name": "Veg Manchow Soup with Crispy Noodles",
                                          "price": 18900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732111",
                                          "name": "Chicken Manchow Soup with Crispy Noodles",
                                          "price": 19900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 42000,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "133697293",
                                  "name": "Steamed Chicken Wheat Momo with Momo Chutney - 12 Pcs",
                                  "category": "Momos",
                                  "description": "Serves 1 | (12 pcs) aromatic mix of juicy chicken mince filling encased in a wheat wrapper, served steaming hot with momo chutney.",
                                  "imageId": "8921435abec25d0592fa561b08a8e89a",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "38547746",
                                        "name": "Add Dip",
                                        "variations": [
                                          {
                                            "name": "Momo Chutney",
                                            "price": 360,
                                            "default": 1,
                                            "id": "121812853",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Extra Momo Chutney",
                                            "price": 379,
                                            "id": "121812854",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547746",
                                            "variationId": "121812853"
                                          }
                                        ],
                                        "price": 36000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177797",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177797",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177795",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177794",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177794",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177794",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177794",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177794",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177791",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177791",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177791",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177791",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177791",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177791",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177792",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177792",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177792",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177792",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177792",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177792",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177792",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177792",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177792",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177792",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547746",
                                            "variationId": "121812854"
                                          }
                                        ],
                                        "price": 37900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177797",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177797",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177795",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177794",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177794",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177794",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177794",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177794",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177791",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177791",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177791",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177791",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177791",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177791",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177792",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177792",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177792",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177792",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177792",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177792",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177792",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177792",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177792",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177792",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177791",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177792",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177794",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177795",
                                      "groupName": "Add Non Veg Spring Roll",
                                      "choices": [
                                        {
                                          "id": "113732094",
                                          "name": "Chicken Spring Roll (4pcs)",
                                          "price": 20900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177797",
                                      "groupName": "Add Soup",
                                      "choices": [
                                        {
                                          "id": "113732100",
                                          "name": "Veg Manchow Soup with Crispy Noodles",
                                          "price": 18900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732111",
                                          "name": "Chicken Manchow Soup with Crispy Noodles",
                                          "price": 19900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 36000,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "133697294",
                                  "name": "Fried Chicken Wheat Momos with Momo Chutney - 12 Pcs",
                                  "category": "Momos",
                                  "description": "Serves 1 | (12 pcs) aromatic mix of juicy chicken mince filling encased in a wheat wrapper, served crispy fried with momo chutney.",
                                  "imageId": "1a7be9b311cc2631b76b5f0b7d7a48e4",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "38547747",
                                        "name": "Add Dip",
                                        "variations": [
                                          {
                                            "name": "Momo Chutney",
                                            "price": 410,
                                            "default": 1,
                                            "id": "121812855",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Extra Momo Chutney",
                                            "price": 429,
                                            "id": "121812856",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547747",
                                            "variationId": "121812855"
                                          }
                                        ],
                                        "price": 41000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177804",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177804",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177802",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177801",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177801",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177801",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177801",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177801",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177799",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177799",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177799",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177799",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177799",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177799",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177800",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177800",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177800",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177800",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177800",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177800",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177800",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177800",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177800",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177800",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547747",
                                            "variationId": "121812856"
                                          }
                                        ],
                                        "price": 42900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177804",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177804",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177802",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177801",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177801",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177801",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177801",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177801",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177799",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177799",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177799",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177799",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177799",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177799",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177800",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177800",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177800",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177800",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177800",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177800",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177800",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177800",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177800",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177800",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177799",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177800",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177801",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177802",
                                      "groupName": "Add Non Veg Spring Roll",
                                      "choices": [
                                        {
                                          "id": "113732094",
                                          "name": "Chicken Spring Roll (4pcs)",
                                          "price": 20900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177804",
                                      "groupName": "Add Soup",
                                      "choices": [
                                        {
                                          "id": "113732100",
                                          "name": "Veg Manchow Soup with Crispy Noodles",
                                          "price": 18900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732111",
                                          "name": "Chicken Manchow Soup with Crispy Noodles",
                                          "price": 19900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 41000,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116910424",
                                  "name": "Steamed Chicken Momos with Momo Chutney - 12 Pcs",
                                  "category": "Momos",
                                  "description": "Serves 1 | (12 pcs) aromatic mix of juicy chicken mince filling encased in a thin wrapper, served steaming hot with momo chutney.",
                                  "imageId": "def5b139691ba3b68cdf8df13e9643b5",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "38547724",
                                        "name": "Add Dip",
                                        "variations": [
                                          {
                                            "name": "Momo Chutney",
                                            "price": 330,
                                            "default": 1,
                                            "id": "121812784",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Extra Momo Chutney",
                                            "price": 349,
                                            "id": "121812785",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547724",
                                            "variationId": "121812784"
                                          }
                                        ],
                                        "price": 33000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177724",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177724",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177721",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177717",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177717",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177717",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177717",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177717",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177714",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177714",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177714",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177714",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177714",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177714",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177716",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177716",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177716",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177716",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177716",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177716",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177716",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177716",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177716",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177716",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547724",
                                            "variationId": "121812785"
                                          }
                                        ],
                                        "price": 34900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177724",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177724",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177721",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177717",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177717",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177717",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177717",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177717",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177714",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177714",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177714",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177714",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177714",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177714",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177716",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177716",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177716",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177716",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177716",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177716",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177716",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177716",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177716",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177716",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177714",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177716",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177717",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177721",
                                      "groupName": "Add Non Veg Spring Roll",
                                      "choices": [
                                        {
                                          "id": "113732094",
                                          "name": "Chicken Spring Roll (4pcs)",
                                          "price": 20900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177724",
                                      "groupName": "Add Soup",
                                      "choices": [
                                        {
                                          "id": "113732100",
                                          "name": "Veg Manchow Soup with Crispy Noodles",
                                          "price": 18900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732111",
                                          "name": "Chicken Manchow Soup with Crispy Noodles",
                                          "price": 19900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 33000,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116910421",
                                  "name": "Fried Chicken Momos with Momo Chutney - 12 Pcs",
                                  "category": "Momos",
                                  "description": "Serves 1 | (12 pcs) aromatic mix of juicy chicken mince filling encased in a thin wrapper, served crispy fried with momo chutney.",
                                  "imageId": "e18ceae677593a24d569943a76371326",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "38547716",
                                        "name": "Add Dip",
                                        "variations": [
                                          {
                                            "name": "Momo Chutney",
                                            "price": 380,
                                            "default": 1,
                                            "id": "121812753",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Extra Momo Chutney",
                                            "price": 399,
                                            "id": "121812754",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547716",
                                            "variationId": "121812753"
                                          }
                                        ],
                                        "price": 38000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177711",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177711",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177709",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177708",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177708",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177708",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177708",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177708",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177706",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177706",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177706",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177706",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177706",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177706",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177707",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177707",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177707",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177707",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177707",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177707",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177707",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177707",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177707",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177707",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547716",
                                            "variationId": "121812754"
                                          }
                                        ],
                                        "price": 39900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177711",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177711",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177709",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177708",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177708",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177708",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177708",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177708",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177706",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177706",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177706",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177706",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177706",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177706",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177707",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177707",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177707",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177707",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177707",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177707",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177707",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177707",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177707",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177707",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177706",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177707",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177708",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177709",
                                      "groupName": "Add Non Veg Spring Roll",
                                      "choices": [
                                        {
                                          "id": "113732094",
                                          "name": "Chicken Spring Roll (4pcs)",
                                          "price": 20900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177711",
                                      "groupName": "Add Soup",
                                      "choices": [
                                        {
                                          "id": "113732100",
                                          "name": "Veg Manchow Soup with Crispy Noodles",
                                          "price": 18900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732111",
                                          "name": "Chicken Manchow Soup with Crispy Noodles",
                                          "price": 19900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 38000,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116910431",
                                  "name": "Steamed Chicken Tikka Momos with Momo Chutney - 12 Pcs",
                                  "category": "Momos",
                                  "description": "Serves 1 | (12 pcs) mixture of chicken tikka masala encased in a thin wrapper, served steaming hot with momo chutney.",
                                  "imageId": "61656b925e6639c56bcb96979da2f461",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "38547728",
                                        "name": "Add Dip",
                                        "variations": [
                                          {
                                            "name": "Momo Chutney",
                                            "price": 390,
                                            "default": 1,
                                            "id": "121812793",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Extra Momo Chutney",
                                            "price": 409,
                                            "id": "121812794",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547728",
                                            "variationId": "121812793"
                                          }
                                        ],
                                        "price": 39000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177753",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177753",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177750",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177747",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177747",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177747",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177747",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177747",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177743",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177743",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177743",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177743",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177743",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177743",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177744",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177744",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177744",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177744",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177744",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177744",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177744",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177744",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177744",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177744",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547728",
                                            "variationId": "121812794"
                                          }
                                        ],
                                        "price": 40900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177753",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177753",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177750",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177747",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177747",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177747",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177747",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177747",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177743",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177743",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177743",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177743",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177743",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177743",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177744",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177744",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177744",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177744",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177744",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177744",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177744",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177744",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177744",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177744",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177743",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177744",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177747",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177750",
                                      "groupName": "Add Non Veg Spring Roll",
                                      "choices": [
                                        {
                                          "id": "113732094",
                                          "name": "Chicken Spring Roll (4pcs)",
                                          "price": 20900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177753",
                                      "groupName": "Add Soup",
                                      "choices": [
                                        {
                                          "id": "113732100",
                                          "name": "Veg Manchow Soup with Crispy Noodles",
                                          "price": 18900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732111",
                                          "name": "Chicken Manchow Soup with Crispy Noodles",
                                          "price": 19900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 39000,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116910427",
                                  "name": "Fried Chicken Tikka Momos with Momo Chutney - 12 Pcs",
                                  "category": "Momos",
                                  "description": "Serves 1 | (12 pcs) mixture of chicken tikka masala encased in a thin wrapper, served crispy fried with momo chutney.",
                                  "imageId": "568ff781a6eceef12932d118b1046d6c",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "38547726",
                                        "name": "Add Dip",
                                        "variations": [
                                          {
                                            "name": "Momo Chutney",
                                            "price": 440,
                                            "default": 1,
                                            "id": "121812789",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Extra Momo Chutney",
                                            "price": 459,
                                            "id": "121812790",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547726",
                                            "variationId": "121812789"
                                          }
                                        ],
                                        "price": 44000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177736",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177736",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177734",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177732",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177732",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177732",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177732",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177732",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177728",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177728",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177728",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177728",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177728",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177728",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177731",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177731",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177731",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177731",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177731",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177731",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177731",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177731",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177731",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177731",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "38547726",
                                            "variationId": "121812790"
                                          }
                                        ],
                                        "price": 45900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "138177736",
                                            "addonId": "113732100"
                                          },
                                          {
                                            "groupId": "138177736",
                                            "addonId": "113732111"
                                          },
                                          {
                                            "groupId": "138177734",
                                            "addonId": "113732094"
                                          },
                                          {
                                            "groupId": "138177732",
                                            "addonId": "113732086"
                                          },
                                          {
                                            "groupId": "138177732",
                                            "addonId": "113732087"
                                          },
                                          {
                                            "groupId": "138177732",
                                            "addonId": "113732088"
                                          },
                                          {
                                            "groupId": "138177732",
                                            "addonId": "113732089"
                                          },
                                          {
                                            "groupId": "138177732",
                                            "addonId": "113732126"
                                          },
                                          {
                                            "groupId": "138177728",
                                            "addonId": "113732099"
                                          },
                                          {
                                            "groupId": "138177728",
                                            "addonId": "113732092"
                                          },
                                          {
                                            "groupId": "138177728",
                                            "addonId": "113732103"
                                          },
                                          {
                                            "groupId": "138177728",
                                            "addonId": "113732091"
                                          },
                                          {
                                            "groupId": "138177728",
                                            "addonId": "113732098"
                                          },
                                          {
                                            "groupId": "138177728",
                                            "addonId": "113732095"
                                          },
                                          {
                                            "groupId": "138177731",
                                            "addonId": "113732127"
                                          },
                                          {
                                            "groupId": "138177731",
                                            "addonId": "113732128"
                                          },
                                          {
                                            "groupId": "138177731",
                                            "addonId": "113732125"
                                          },
                                          {
                                            "groupId": "138177731",
                                            "addonId": "113732120"
                                          },
                                          {
                                            "groupId": "138177731",
                                            "addonId": "113732121"
                                          },
                                          {
                                            "groupId": "138177731",
                                            "addonId": "113732129"
                                          },
                                          {
                                            "groupId": "138177731",
                                            "addonId": "113732096"
                                          },
                                          {
                                            "groupId": "138177731",
                                            "addonId": "113732130"
                                          },
                                          {
                                            "groupId": "138177731",
                                            "addonId": "113732085"
                                          },
                                          {
                                            "groupId": "138177731",
                                            "addonId": "113732084"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "138177728",
                                      "groupName": "Add Extra Dip",
                                      "choices": [
                                        {
                                          "id": "113732099",
                                          "name": "Extra Momo Chutney",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732092",
                                          "name": "Extra Schezwan Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732095",
                                          "name": "Extra Sweet Chilli Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732103",
                                          "name": "Extra Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732091",
                                          "name": "Extra Tandoori Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732098",
                                          "name": "Extra Mint Mayo Dip",
                                          "price": 2000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177731",
                                      "groupName": "Add  Drinks",
                                      "choices": [
                                        {
                                          "id": "113732125",
                                          "name": "Classic Lemon",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732120",
                                          "name": "Tender Coconut",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732096",
                                          "name": "Aam Panna",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732130",
                                          "name": "Masala Shikanji",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732085",
                                          "name": "Peach Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732084",
                                          "name": "Lemon Ice Tea",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732127",
                                          "name": "Pepsi Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732128",
                                          "name": "7 Up Pet Bottle",
                                          "price": 6000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732121",
                                          "name": "Alphonso Mango",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732129",
                                          "name": "Mixed Fruit",
                                          "price": 9000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177732",
                                      "groupName": "Add Dessert",
                                      "choices": [
                                        {
                                          "id": "113732086",
                                          "name": "Chocolate Mousse - Small",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732087",
                                          "name": "Black Forest Mousse Cake",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732088",
                                          "name": "Salted Caramel Choco Mousse",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732089",
                                          "name": "Choco Lava",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732126",
                                          "name": "Chocolate Mousse (Save Rs. 20)",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177734",
                                      "groupName": "Add Non Veg Spring Roll",
                                      "choices": [
                                        {
                                          "id": "113732094",
                                          "name": "Chicken Spring Roll (4pcs)",
                                          "price": 20900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "138177736",
                                      "groupName": "Add Soup",
                                      "choices": [
                                        {
                                          "id": "113732100",
                                          "name": "Veg Manchow Soup with Crispy Noodles",
                                          "price": 18900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "113732111",
                                          "name": "Chicken Manchow Soup with Crispy Noodles",
                                          "price": 19900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 44000,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Desserts",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "133609029",
                              "name": "Chocolate Mousse - Small",
                              "category": "Desserts",
                              "description": "Serves 1 | Creamy chocolate mousse layered with moist chocolate cake.",
                              "imageId": "6090d8356fa5f65a89bdeb09d32a296c",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "133609031",
                              "name": "Black Forest Mousse Cake",
                              "category": "Desserts",
                              "description": "Serves 1 | Evergreen cake recipe, served in a mousse style dessert",
                              "imageId": "255a409e1e0175da4c9039fff030db10",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "133609033",
                              "name": "Salted Caramel Choco Mousse",
                              "category": "Desserts",
                              "description": "Serves 1 | Layers of Salted Caramel mousse and Choco mousse served chilled",
                              "imageId": "703c64e08c0fe2dfc7a6c195bca97787",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "69258828",
                              "name": "Chocolate Mousse",
                              "category": "Desserts",
                              "description": "Serves 1 | Creamy chocolate mousse layered with moist chocolate cake.",
                              "imageId": "va0oeeadiigrat1tvxox",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "11 ratings",
                                  "ratingCountV2": "11"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "69258829",
                              "name": "Choco Lava",
                              "category": "Desserts",
                              "description": "Serves 1 | Rich chocolate cake with molten chocolate center, served warm.",
                              "imageId": "ccemgz9q1tcd5peyhulf",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.0",
                                  "ratingCount": "12 ratings",
                                  "ratingCountV2": "12"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Drinks",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106019906",
                              "name": "Classic Lemon 200 ml",
                              "category": "Drinks",
                              "description": "Serves 1",
                              "imageId": "eb58db2cab1e2a0ad18b7deab8f6aebd",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106019907",
                              "name": "Tender Coconut",
                              "category": "Drinks",
                              "description": "Serves 1",
                              "imageId": "bd1bbe41f00ad365f0b6a092a193c7f9",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106019908",
                              "name": "Alphonso Mango",
                              "category": "Drinks",
                              "description": "Serves 1",
                              "imageId": "ddba490d85eb69f607595daccf43d920",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106019909",
                              "name": "Mixed Fruit",
                              "category": "Drinks",
                              "description": "Serves 1",
                              "imageId": "23dbf9a94e2e6e816e6b65afee87aab0",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "127262694",
                              "name": "Pepsi Pet Bottle",
                              "category": "Drinks",
                              "description": "Serves 1",
                              "imageId": "v73dbzh71l7haeywdrxl",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "10 ratings",
                                  "ratingCountV2": "10"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "127262692",
                              "name": "7 Up",
                              "category": "Drinks",
                              "description": "Serves 1",
                              "imageId": "lpdhsbtoluz7uvflydbr",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115289084",
                              "name": "Coolberg Peach",
                              "category": "Drinks",
                              "description": "Serves 1",
                              "imageId": "5334c710771efbcd2f639dbfaf701d14",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115289085",
                              "name": "Coolberg Cranberry",
                              "category": "Drinks",
                              "description": "Serves 1",
                              "imageId": "bd7ca83e624566fa6cfa59e1f9ee1e5c",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "122939150",
                              "name": "Peach Ice Tea",
                              "category": "Drinks",
                              "description": "Serves 1",
                              "imageId": "49e7fb782d5d019fd7366f21e7cf35f9",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "122939151",
                              "name": "Aam Panna",
                              "category": "Drinks",
                              "description": "Serves 1",
                              "imageId": "230eb1c7fa33b8001096964726f08672",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "122939152",
                              "name": "Masala Shikanji",
                              "category": "Drinks",
                              "description": "Serves 1",
                              "imageId": "92c4543d3526e04be5c1e8f314a15690",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "122939153",
                              "name": "Lemon Ice Tea",
                              "category": "Drinks",
                              "description": "Serves 1",
                              "imageId": "8aac4f00e3a244019a24b48bece68c07",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97971864",
                              "name": "Aquafina",
                              "category": "Drinks",
                              "description": "Serves 1",
                              "imageId": "13d447605819f7ce3e2c48c38f752292",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 1000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Extras",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "118873778",
                              "name": "Extra Crispy Noodles",
                              "category": "Extras",
                              "description": "Serves 1",
                              "imageId": "c9ca85ad57d4de0e501fead44053e009",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "99292286",
                              "name": "Extra Momo Chutney",
                              "category": "Extras",
                              "description": "Serves 1",
                              "imageId": "7be5a5bde35cdf9f2bf3ecff1095f8e7",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "99292281",
                              "name": "Extra Schezwan Dip",
                              "category": "Extras",
                              "description": "Serves 1",
                              "imageId": "93ef381eb1cfeb601a97a8b6f02b43d9",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "99292282",
                              "name": "Extra Mayo Dip",
                              "category": "Extras",
                              "description": "Serves 1",
                              "imageId": "297547830a7081f3337b663412ffe765",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "99292283",
                              "name": "Extra Tandoori Mayo Dip",
                              "category": "Extras",
                              "description": "Serves 1",
                              "imageId": "413cb01e0cf4970fe16961e4a830f267",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "99292284",
                              "name": "Extra Mint Mayo Dip",
                              "category": "Extras",
                              "description": "Serves 1",
                              "imageId": "4938747706de809850e3ecdd89b71681",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "99292285",
                              "name": "Extra Sweet Chilli Dip",
                              "category": "Extras",
                              "description": "Serves 1",
                              "imageId": "4733d341c5080c31ab4d4581a3b3fb37",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                      "type": "FSSAI",
                      "imageId": "fssai_final_edss9i",
                      "text": [
                        "License No. 11222334001547"
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                      "name": "Big Bowl",
                      "area": "HSR Layout",
                      "completeAddress": "NO.1212, KATHA NO.688/1212, GROUND  FLOOR, SECTOR-III, HOSUR SARJAPUR ROAD,  HSR LAYOUT, BANGALORE, BTM Layout ,  B.B.M.P South, Karnataka-560102"
                    }
                  }
                }
              ]
            }
          }
        }
      }
    ],
    "firstOffsetRequest": true,
    "isQCLink": false
  },
  "tid": "8091b6c9-34ec-4881-8b5e-d2b6a4328fa1",
  "sid": "c8b69dc8-6710-47a7-bc63-18091856e3fa",
  "deviceId": "c73fa13e-69cf-472b-8071-076091f9d98d",
  "csrfToken": "k4sX1u08RQ1R-uyXxiSIQVRi4G41vBl37ULY4EVI"
}